// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vkui--vkBase--light,
:root {
  --vkui--theme_name: "vkBase"
}

.vkui--vkBase--dark,
.vkui--vkBase--light,
:root {
  --vkui--theme_name_base: "vkBase";
  --vkui--size_base_padding_horizontal--regular: 16px;
  --vkui--size_switch_height--regular: 14px;
  --vkui--size_switch_height--compact: 12px;
  --vkui--size_switch_width--regular: 34px;
  --vkui--size_switch_width--compact: 32px;
  --vkui--size_switch_pin--regular: 20px;
  --vkui--size_switch_pin--compact: 18px;
  --vkui--size_panel_header_height--regular: 56px
}

.vkui--vkBase--dark,
.vkui--vkBase--light,
.vkui--vkCom--dark,
.vkui--vkCom--light,
.vkui--vkIOS--dark,
.vkui--vkIOS--light,
:root {
  --vkui--gradient_black: transparent 0%, rgba(0, 0, 0, .014) 13%, rgba(0, 0, 0, .06) 27%, rgba(0, 0, 0, .316) 68%, rgba(0, 0, 0, .38) 84%, rgba(0, 0, 0, .4) 100%;
  --vkui--gradient_white: hsla(0, 0%, 100%, 0) 0%, hsla(0, 0%, 100%, .036) 13%, hsla(0, 0%, 100%, .15) 27%, hsla(0, 0%, 100%, .79) 68%, hsla(0, 0%, 100%, .95) 84%, #fff 100%;
  --vkui--elevation1: 0px 0px 2px rgba(0, 0, 0, .03), 0px 2px 2px rgba(0, 0, 0, .06);
  --vkui--elevation1_invert_y: 0px 0px 2px rgba(0, 0, 0, .03), 0px -2px 2px rgba(0, 0, 0, .06);
  --vkui--elevation2: 0px 4px 8px rgba(0, 0, 0, .04), 0px 0px 4px rgba(0, 0, 0, .06);
  --vkui--elevation3: 0px 0px 2px rgba(0, 0, 0, .08), 0px 4px 16px rgba(0, 0, 0, .08);
  --vkui--elevation4: 0px 0px 8px rgba(0, 0, 0, .12), 0px 16px 16px rgba(0, 0, 0, .16);
  --vkui--font_family_fallbacks: -apple-system, system-ui, "Helvetica Neue", Roboto, sans-serif;
  --vkui--font_family_accent: -apple-system, system-ui, "Helvetica Neue", Roboto, sans-serif;
  --vkui--font_family_base: -apple-system, system-ui, "Helvetica Neue", Roboto, sans-serif;
  --vkui--font_weight_accent1: 600;
  --vkui--font_weight_accent2: 500;
  --vkui--font_weight_accent3: 400;
  --vkui--font_weight_base1: 600;
  --vkui--font_weight_base2: 500;
  --vkui--font_weight_base3: 400;
  --vkui--font_title1--font_size--regular: 24px;
  --vkui--font_title1--line_height--regular: 28px;
  --vkui--font_title1--font_family--regular: -apple-system, system-ui, "Helvetica Neue", Roboto, sans-serif;
  --vkui--font_title1--font_weight--regular: 600;
  --vkui--font_title2--font_size--regular: 20px;
  --vkui--font_title2--line_height--regular: 24px;
  --vkui--font_title2--font_family--regular: -apple-system, system-ui, "Helvetica Neue", Roboto, sans-serif;
  --vkui--font_title2--font_weight--regular: 600;
  --vkui--font_title3--font_size--regular: 17px;
  --vkui--font_title3--line_height--regular: 22px;
  --vkui--font_title3--font_family--regular: -apple-system, system-ui, "Helvetica Neue", Roboto, sans-serif;
  --vkui--font_title3--font_weight--regular: 600;
  --vkui--font_headline1--font_size--regular: 16px;
  --vkui--font_headline1--line_height--regular: 20px;
  --vkui--font_headline1--font_family--regular: -apple-system, system-ui, "Helvetica Neue", Roboto, sans-serif;
  --vkui--font_headline1--font_weight--regular: 500;
  --vkui--font_headline2--font_size--regular: 15px;
  --vkui--font_headline2--line_height--regular: 20px;
  --vkui--font_headline2--font_family--regular: -apple-system, system-ui, "Helvetica Neue", Roboto, sans-serif;
  --vkui--font_headline2--font_weight--regular: 500;
  --vkui--font_headline2--font_size--compact: 14px;
  --vkui--font_headline2--line_height--compact: 20px;
  --vkui--font_text--font_size--regular: 16px;
  --vkui--font_text--line_height--regular: 20px;
  --vkui--font_text--font_family--regular: -apple-system, system-ui, "Helvetica Neue", Roboto, sans-serif;
  --vkui--font_text--font_weight--regular: 400;
  --vkui--font_paragraph--font_size--regular: 15px;
  --vkui--font_paragraph--line_height--regular: 20px;
  --vkui--font_paragraph--font_family--regular: -apple-system, system-ui, "Helvetica Neue", Roboto, sans-serif;
  --vkui--font_paragraph--font_weight--regular: 400;
  --vkui--font_subhead--font_size--regular: 14px;
  --vkui--font_subhead--line_height--regular: 18px;
  --vkui--font_subhead--font_family--regular: -apple-system, system-ui, "Helvetica Neue", Roboto, sans-serif;
  --vkui--font_subhead--font_weight--regular: 400;
  --vkui--font_footnote--font_size--regular: 13px;
  --vkui--font_footnote--line_height--regular: 16px;
  --vkui--font_footnote--font_family--regular: -apple-system, system-ui, "Helvetica Neue", Roboto, sans-serif;
  --vkui--font_footnote--font_weight--regular: 400;
  --vkui--font_footnote_caps--font_size--regular: 13px;
  --vkui--font_footnote_caps--line_height--regular: 16px;
  --vkui--font_footnote_caps--font_family--regular: -apple-system, system-ui, "Helvetica Neue", Roboto, sans-serif;
  --vkui--font_footnote_caps--font_weight--regular: 400;
  --vkui--font_footnote_caps--text_transform--regular: uppercase;
  --vkui--font_caption1--font_size--regular: 12px;
  --vkui--font_caption1--line_height--regular: 14px;
  --vkui--font_caption1--font_family--regular: -apple-system, system-ui, "Helvetica Neue", Roboto, sans-serif;
  --vkui--font_caption1--font_weight--regular: 400;
  --vkui--font_caption1_caps--font_size--regular: 12px;
  --vkui--font_caption1_caps--line_height--regular: 14px;
  --vkui--font_caption1_caps--font_family--regular: -apple-system, system-ui, "Helvetica Neue", Roboto, sans-serif;
  --vkui--font_caption1_caps--font_weight--regular: 600;
  --vkui--font_caption1_caps--text_transform--regular: uppercase;
  --vkui--font_caption2--font_size--regular: 11px;
  --vkui--font_caption2--line_height--regular: 14px;
  --vkui--font_caption2--font_family--regular: -apple-system, system-ui, "Helvetica Neue", Roboto, sans-serif;
  --vkui--font_caption2--font_weight--regular: 400;
  --vkui--font_caption2_caps--font_size--regular: 11px;
  --vkui--font_caption2_caps--line_height--regular: 14px;
  --vkui--font_caption2_caps--font_family--regular: -apple-system, system-ui, "Helvetica Neue", Roboto, sans-serif;
  --vkui--font_caption2_caps--font_weight--regular: 600;
  --vkui--font_caption2_caps--text_transform--regular: uppercase;
  --vkui--font_caption3--font_size--regular: 9px;
  --vkui--font_caption3--line_height--regular: 12px;
  --vkui--font_caption3--font_family--regular: -apple-system, system-ui, "Helvetica Neue", Roboto, sans-serif;
  --vkui--font_caption3--font_weight--regular: 400;
  --vkui--font_caption3_caps--font_size--regular: 9px;
  --vkui--font_caption3_caps--line_height--regular: 12px;
  --vkui--font_caption3_caps--font_family--regular: -apple-system, system-ui, "Helvetica Neue", Roboto, sans-serif;
  --vkui--font_caption3_caps--font_weight--regular: 600;
  --vkui--font_caption3_caps--text_transform--regular: uppercase;
  --vkui--size_select_icon_padding--regular: 6px;
  --vkui--size_select_icon_padding--compact: 7px;
  --vkui--size_popup_base_padding--regular: 32px;
  --vkui--size_popup_base_padding--compact: 20px;
  --vkui--size_popup_header_padding--regular: 24px;
  --vkui--size_popup_header_padding--compact: 16px;
  --vkui--size_label_horizontal_margin--regular: 16px;
  --vkui--size_border_radius_rounded--regular: 48px;
  --vkui--size_check_border_radius--regular: 4px;
  --vkui--size_border_radius_paper--regular: 12px;
  --vkui--size_border_radius_promo--regular: 20px;
  --vkui--size_field_height--regular: 44px;
  --vkui--size_field_height--compact: 36px;
  --vkui--size_search_height--regular: 36px;
  --vkui--size_search_height--compact: 32px;
  --vkui--size_button_large_height--regular: 44px;
  --vkui--size_button_large_height--compact: 36px;
  --vkui--size_button_medium_height--regular: 36px;
  --vkui--size_button_medium_height--compact: 32px;
  --vkui--size_button_small_height--regular: 30px;
  --vkui--size_button_small_height--compact: 28px;
  --vkui--size_checkbox--regular: 16px;
  --vkui--size_arrow--regular: 8px;
  --vkui--size_arrow_promo--regular: 40px;
  --vkui--size_popup_medium--regular: 680px;
  --vkui--size_popup_large--regular: 880px;
  --vkui--size_field_horizontal_padding--regular: 12px;
  --vkui--size_button_padding_horizontal--regular: 12px;
  --vkui--size_arrow_padding--regular: 12px;
  --vkui--size_tooltip_margin--regular: 8px;
  --vkui--size_icon_u_i--regular: 16px;
  --vkui--size_avatar_x_s--regular: 24px;
  --vkui--size_avatar_s--regular: 32px;
  --vkui--size_avatar_m--regular: 48px;
  --vkui--size_avatar_l--regular: 96px;
  --vkui--size_avatar_x_l--regular: 128px;
  --vkui--size_badge_x_s--regular: 12px;
  --vkui--size_badge_s--regular: 16px;
  --vkui--size_badge_m--regular: 24px;
  --vkui--size_badge_l--regular: 44px;
  --vkui--size_badge_x_l--regular: 56px;
  --vkui--size_cardgrid_padding--regular: 8px;
  --vkui--size_cardgrid_padding_vertical--regular: 8px;
  --vkui--size_base_padding_vertical--regular: 12px;
  --vkui--size_button_group_gap_space--regular: 1px;
  --vkui--size_button_group_gap_small--regular: 8px;
  --vkui--size_button_group_gap_medium--regular: 12px;
  --vkui--size_option_hierarchy--regular: 32px;
  --vkui--size_button_base_small_padding_horizontal--regular: 16px;
  --vkui--size_button_base_medium_padding_horizontal--regular: 16px;
  --vkui--size_button_base_large_padding_horizontal--regular: 20px;
  --vkui--size_button_base_small_padding_horizontal_icon--regular: 12px;
  --vkui--size_button_base_medium_padding_horizontal_icon--regular: 12px;
  --vkui--size_button_base_large_padding_horizontal_icon--regular: 16px;
  --vkui--size_button_tertiary_small_padding_horizontal--regular: 12px;
  --vkui--size_button_tertiary_medium_padding_horizontal--regular: 12px;
  --vkui--size_button_tertiary_large_padding_horizontal--regular: 16px;
  --vkui--size_button_tertiary_small_padding_horizontal_icon--regular: 8px;
  --vkui--size_button_tertiary_medium_padding_horizontal_icon--regular: 8px;
  --vkui--size_button_tertiary_large_padding_horizontal_icon--regular: 12px;
  --vkui--size_button_minimum_width--regular: 80px;
  --vkui--size_split_col_padding_horizontal--regular: 16px;
  --vkui--size_subnavigation_bar_gap--regular: 8px;
  --vkui--size_subnavigation_bar_padding_vertical--regular: 12px;
  --vkui--size_border1x--regular: 1px;
  --vkui--spacing_size_xs: 4px;
  --vkui--spacing_size_s: 6px;
  --vkui--spacing_size_m: 8px;
  --vkui--spacing_size_l: 10px;
  --vkui--spacing_size_xl: 12px;
  --vkui--animation_duration_l: 0.4s;
  --vkui--animation_duration_m: 0.2s;
  --vkui--animation_duration_s: 0.1s;
  --vkui--animation_easing_default: cubic-bezier(0.3, 0.3, 0.5, 1);
  --vkui--opacity_disable: 0.4;
  --vkui--opacity_disable_accessibility: 0.64;
  --vkui--z_index_modal: 99;
  --vkui--z_index_popout: 100;
  --vkui--font_headline--font_size--regular: 16px;
  --vkui--font_headline--line_height--regular: 20px;
  --vkui--font_headline--font_family--regular: -apple-system, system-ui, "Helvetica Neue", Roboto, sans-serif;
  --vkui--font_headline--font_weight--regular: 500;
  --vkui--color_background_accent_tint: #5a9eff;
  --vkui--color_background_contrast_secondary_alpha--hover: hsla(0, 0%, 100%, .24);
  --vkui--color_background_contrast_secondary_alpha--active: hsla(0, 0%, 100%, .28);
  --vkui--color_text_link_tint: #71aaeb;
  --vkui--color_text_link_visited: #4986cc;
  --vkui--color_icon_contrast_secondary: #f2f3f5;
  --vkui--color_accent_orange_fire: #f05c44;
  --vkui--color_accent_secondary: #3f8ae0;
  --vkui--color_overlay_primary: rgba(0, 0, 0, .4);
  --vkui--color_overlay_primary--hover: rgba(0, 0, 0, .44);
  --vkui--color_overlay_primary--active: rgba(0, 0, 0, .48);
  --vkui--color_avatar_overlay: rgba(0, 0, 0, .6);
  --vkui--color_avatar_overlay--hover: rgba(0, 0, 0, .64);
  --vkui--color_avatar_overlay--active: rgba(0, 0, 0, .68);
  --vkui--color_avatar_overlay_inverse_alpha: hsla(0, 0%, 100%, .85);
  --vkui--color_avatar_overlay_inverse_alpha--hover: hsla(0, 0%, 100%, .89);
  --vkui--color_avatar_overlay_inverse_alpha--active: hsla(0, 0%, 100%, .93);
  --vkui--color_transparent: transparent
}

.vkui--vkBase--light,
.vkui--vkCom--light,
.vkui--vkIOS--light,
:root {
  --vkui--gradient_tint: hsla(0, 0%, 98%, 0) 0%, hsla(0, 0%, 98%, .036) 13%, hsla(0, 0%, 98%, .15) 27%, hsla(0, 0%, 98%, .79) 68%, hsla(0, 0%, 98%, .95) 84%, #f9f9f9 100%;
  --vkui--gradient: hsla(0, 0%, 100%, 0) 0%, hsla(0, 0%, 100%, .036) 13%, hsla(0, 0%, 100%, .15) 27%, hsla(0, 0%, 100%, .79) 68%, hsla(0, 0%, 100%, .95) 84%, #fff 100%;
  --vkui--colors_scheme: light;
  --vkui--color_background_accent_tint--hover: #5698f7;
  --vkui--color_background_accent_tint--active: #5393ef;
  --vkui--color_background_content--hover: #f5f5f7;
  --vkui--color_background_content--active: #ebecef;
  --vkui--color_background_tertiary_alpha: rgba(0, 0, 0, .03);
  --vkui--color_background_tertiary_alpha--hover: rgba(0, 0, 0, .07);
  --vkui--color_background_tertiary_alpha--active: rgba(0, 0, 0, .11);
  --vkui--color_background_contrast--hover: #f5f5f7;
  --vkui--color_background_contrast--active: #ebecef;
  --vkui--color_background_contrast_secondary_alpha: hsla(0, 0%, 100%, .2);
  --vkui--color_background_contrast_themed: #fff;
  --vkui--color_background_contrast_themed--hover: #f5f5f7;
  --vkui--color_background_contrast_themed--active: #ebecef;
  --vkui--color_background_modal--hover: #f5f5f7;
  --vkui--color_background_modal--active: #ebecef;
  --vkui--color_background_modal_inverse--hover: #2b2c2f;
  --vkui--color_background_modal_inverse--active: #292b2f;
  --vkui--color_background_warning: #fff2d6;
  --vkui--color_background_warning--hover: #f5e9d0;
  --vkui--color_background_warning--active: #ebe0ca;
  --vkui--color_background_positive--hover: #48ac4a;
  --vkui--color_background_positive--active: #45a64a;
  --vkui--color_background_negative--hover: #dd4446;
  --vkui--color_background_negative--active: #d44245;
  --vkui--color_background_negative_tint: #faebeb;
  --vkui--color_background_negative_tint--hover: #f0e2e4;
  --vkui--color_background_negative_tint--active: #e6d9dd;
  --vkui--color_background_positive_tint: #e8f9e8;
  --vkui--color_background_positive_tint--hover: #dff0e1;
  --vkui--color_background_positive_tint--active: #d5e6da;
  --vkui--color_header_background--hover: #f5f5f7;
  --vkui--color_header_background--active: #ebecef;
  --vkui--color_text_primary: #000;
  --vkui--color_text_primary--hover: #000102;
  --vkui--color_text_primary--active: #000105;
  --vkui--color_text_secondary--hover: #7c8795;
  --vkui--color_text_secondary--active: #778292;
  --vkui--color_text_tertiary--hover: #939ca9;
  --vkui--color_text_tertiary--active: #8d96a4;
  --vkui--color_text_contrast--hover: #f5f5f7;
  --vkui--color_text_contrast--active: #ebecef;
  --vkui--color_text_contrast_themed--hover: #f5f5f7;
  --vkui--color_text_contrast_themed--active: #ebecef;
  --vkui--color_text_positive--hover: #48ac4a;
  --vkui--color_text_positive--active: #45a64a;
  --vkui--color_text_negative--hover: #dd4446;
  --vkui--color_text_negative--active: #d44245;
  --vkui--color_text_link_tint--hover: #6ca4e4;
  --vkui--color_text_link_tint--active: #689edd;
  --vkui--color_text_link_visited--hover: #4681c6;
  --vkui--color_text_link_visited--active: #437dc1;
  --vkui--color_link_contrast--hover: #f5f5f7;
  --vkui--color_link_contrast--active: #ebecef;
  --vkui--color_icon_primary: #2c2d2e;
  --vkui--color_icon_primary--hover: #2a2c2f;
  --vkui--color_icon_primary--active: #282b2f;
  --vkui--color_icon_medium_alpha: rgba(0, 0, 0, .48);
  --vkui--color_icon_medium_alpha--hover: rgba(0, 0, 0, .52);
  --vkui--color_icon_medium_alpha--active: rgba(0, 0, 0, .56);
  --vkui--color_icon_secondary--hover: #939ca9;
  --vkui--color_icon_secondary--active: #8d96a4;
  --vkui--color_icon_secondary_alpha: rgba(0, 0, 0, .36);
  --vkui--color_icon_secondary_alpha--hover: rgba(0, 0, 0, .4);
  --vkui--color_icon_secondary_alpha--active: rgba(0, 0, 0, .44);
  --vkui--color_icon_tertiary_alpha: rgba(0, 0, 0, .24);
  --vkui--color_icon_tertiary_alpha--hover: rgba(0, 0, 0, .28);
  --vkui--color_icon_tertiary_alpha--active: rgba(0, 0, 0, .32);
  --vkui--color_icon_contrast--hover: #f5f5f7;
  --vkui--color_icon_contrast--active: #ebecef;
  --vkui--color_icon_contrast_themed--hover: #f5f5f7;
  --vkui--color_icon_contrast_themed--active: #ebecef;
  --vkui--color_icon_contrast_secondary--hover: #e8eaee;
  --vkui--color_icon_contrast_secondary--active: #dfe1e6;
  --vkui--color_icon_positive--hover: #48ac4a;
  --vkui--color_icon_positive--active: #45a64a;
  --vkui--color_icon_negative--hover: #dd4446;
  --vkui--color_icon_negative--active: #d44245;
  --vkui--color_separator_primary2x--hover: #c3c4c7;
  --vkui--color_separator_primary2x--active: #bbbdc1;
  --vkui--color_separator_primary3x--hover: #b6b8bc;
  --vkui--color_separator_primary3x--active: #afb1b6;
  --vkui--color_separator_primary_alpha: rgba(0, 0, 0, .12);
  --vkui--color_separator_primary_alpha--hover: rgba(0, 0, 0, .16);
  --vkui--color_separator_primary_alpha--active: rgba(0, 0, 0, .2);
  --vkui--color_stroke_positive--hover: #48ac4a;
  --vkui--color_stroke_positive--active: #45a64a;
  --vkui--color_stroke_negative--hover: #dd4446;
  --vkui--color_stroke_negative--active: #d44245;
  --vkui--color_stroke_contrast: #fff;
  --vkui--color_stroke_contrast--hover: #f5f5f7;
  --vkui--color_stroke_contrast--active: #ebecef;
  --vkui--color_image_border_alpha: rgba(0, 0, 0, .08);
  --vkui--color_image_border_alpha--hover: rgba(0, 0, 0, .12);
  --vkui--color_image_border_alpha--active: rgba(0, 0, 0, .16);
  --vkui--color_field_border_alpha: rgba(0, 0, 0, .12);
  --vkui--color_field_border_alpha--hover: rgba(0, 0, 0, .24);
  --vkui--color_field_border_alpha--active: rgba(0, 0, 0, .36);
  --vkui--color_accent_red--hover: #f53247;
  --vkui--color_accent_red--active: #eb3046;
  --vkui--color_accent_green--hover: #48ac4a;
  --vkui--color_accent_green--active: #45a64a;
  --vkui--color_accent_orange--hover: #f59a02;
  --vkui--color_accent_orange--active: #eb9405;
  --vkui--color_accent_orange_peach: #f9b54f;
  --vkui--color_accent_orange_peach--hover: #efae4e;
  --vkui--color_accent_orange_peach--active: #e5a84e;
  --vkui--color_accent_orange_fire--hover: #e65944;
  --vkui--color_accent_orange_fire--active: #dd5643;
  --vkui--color_accent_purple--hover: #6e59df;
  --vkui--color_accent_purple--active: #6a56d8;
  --vkui--color_accent_violet--hover: #742dbb;
  --vkui--color_accent_violet--active: #6f2cb6;
  --vkui--color_accent_raspberry_pink: #e03fab;
  --vkui--color_accent_raspberry_pink--hover: #d73da7;
  --vkui--color_accent_raspberry_pink--active: #ce3ba2;
  --vkui--color_accent_secondary--hover: #3c85d9;
  --vkui--color_accent_secondary--active: #3a80d3;
  --vkui--color_overlay_secondary: rgba(44, 45, 46, .5);
  --vkui--color_overlay_secondary--hover: rgba(44, 45, 46, .54);
  --vkui--color_overlay_secondary--active: rgba(44, 45, 46, .58);
  --vkui--color_action_sheet_text: #3f8ae0;
  --vkui--color_action_sheet_text--hover: #3c85d9;
  --vkui--color_action_sheet_text--active: #3a80d3;
  --vkui--color_image_placeholder: #f2f3f5;
  --vkui--color_image_placeholder--hover: #e8eaee;
  --vkui--color_image_placeholder--active: #dfe1e6;
  --vkui--color_image_placeholder_alpha: rgba(0, 28, 61, .08);
  --vkui--color_image_placeholder_alpha--hover: rgba(0, 28, 61, .12);
  --vkui--color_image_placeholder_alpha--active: rgba(0, 28, 61, .16);
  --vkui--color_write_bar_input_border_alpha: rgba(0, 0, 0, .08);
  --vkui--color_write_bar_input_border_alpha--hover: rgba(0, 0, 0, .12);
  --vkui--color_write_bar_input_border_alpha--active: rgba(0, 0, 0, .16);
  --vkui--color_segmented_control: #fff;
  --vkui--color_segmented_control--hover: #f5f5f7;
  --vkui--color_segmented_control--active: #ebecef;
  --vkui--color_tabbar_text_inactive: #99a2ad;
  --vkui--color_tabbar_text_inactive--hover: #939ca9;
  --vkui--color_tabbar_text_inactive--active: #8d96a4;
  --vkui--color_transparent--hover: rgba(0, 16, 61, .04);
  --vkui--color_transparent--active: rgba(0, 16, 61, .08)
}

.vkui--vkBase--dark,
.vkui--vkBase--light,
.vkui--vkIOS--dark,
.vkui--vkIOS--light,
:root {
  --vkui--font_headline1--font_size--compact: 15px;
  --vkui--font_headline1--line_height--compact: 20px;
  --vkui--font_text--font_size--compact: 15px;
  --vkui--font_text--line_height--compact: 20px;
  --vkui--font_subhead--font_size--compact: 13px;
  --vkui--font_subhead--line_height--compact: 16px;
  --vkui--size_popup_small--regular: 430px;
  --vkui--size_form_item_padding_vertical--regular: 12px;
  --vkui--size_border2x--regular: 0.5px;
  --vkui--size_border3x--regular: 0.33px;
  --vkui--font_headline--font_size--compact: 15px;
  --vkui--font_headline--line_height--compact: 20px;
  --vkui--color_background_contrast_inverse: #2c2d2e;
  --vkui--color_background_positive: #4bb34b;
  --vkui--color_text_primary_invariably: #000;
  --vkui--color_text_positive: #4bb34b;
  --vkui--color_icon_primary_invariably: #2c2d2e;
  --vkui--color_icon_positive: #4bb34b;
  --vkui--color_stroke_positive: #4bb34b;
  --vkui--color_accent_gray: #a3adb8;
  --vkui--color_accent_red: #ff3347;
  --vkui--color_accent_green: #4bb34b;
  --vkui--color_accent_orange: #ffa000
}

.vkui--vkBase--dark,
.vkui--vkBase--light,
.vkui--vkCom--dark,
.vkui--vkCom--light,
:root {
  --vkui--size_border_radius--regular: 8px;
  --vkui--size_card_border_radius--regular: 8px;
  --vkui--animation_easing_platform: cubic-bezier(0.4, 0, 0.2, 1)
}

.vkui--vkBase--light,
.vkui--vkIOS--light,
:root {
  --vkui--color_background_accent: #2688eb;
  --vkui--color_background_accent--hover: #2483e4;
  --vkui--color_background_accent--active: #237edd;
  --vkui--color_background_accent_themed: #2688eb;
  --vkui--color_background_accent_themed--hover: #2483e4;
  --vkui--color_background_accent_themed--active: #237edd;
  --vkui--color_background_accent_alternative: #2688eb;
  --vkui--color_background_accent_alternative--hover: #2483e4;
  --vkui--color_background_accent_alternative--active: #237edd;
  --vkui--color_background: #ebedf0;
  --vkui--color_background--hover: #e2e4e9;
  --vkui--color_background--active: #d8dbe2;
  --vkui--color_background_content: #fff;
  --vkui--color_background_secondary: #f5f5f5;
  --vkui--color_background_secondary--hover: #ebecee;
  --vkui--color_background_secondary--active: #e1e3e6;
  --vkui--color_background_secondary_alpha: rgba(0, 0, 0, .04);
  --vkui--color_background_secondary_alpha--hover: rgba(0, 0, 0, .08);
  --vkui--color_background_secondary_alpha--active: rgba(0, 0, 0, .12);
  --vkui--color_background_tertiary: #f9f9f9;
  --vkui--color_background_tertiary--hover: #eff0f1;
  --vkui--color_background_tertiary--active: #e5e6ea;
  --vkui--color_background_contrast: #fff;
  --vkui--color_background_contrast_inverse--hover: #2a2c2f;
  --vkui--color_background_contrast_inverse--active: #282b2f;
  --vkui--color_background_modal: #fff;
  --vkui--color_background_modal_inverse: #2d2d2e;
  --vkui--color_background_negative: #e64646;
  --vkui--color_field_background: #f2f3f5;
  --vkui--color_field_background--hover: #e8eaee;
  --vkui--color_field_background--active: #dfe1e6;
  --vkui--color_header_background: #fff;
  --vkui--color_text_accent: #2688eb;
  --vkui--color_text_accent--hover: #2483e4;
  --vkui--color_text_accent--active: #237edd;
  --vkui--color_text_accent_themed: #2688eb;
  --vkui--color_text_accent_themed--hover: #2483e4;
  --vkui--color_text_accent_themed--active: #237edd;
  --vkui--color_text_primary_invariably--hover: #000102;
  --vkui--color_text_primary_invariably--active: #000105;
  --vkui--color_text_secondary: #818c99;
  --vkui--color_text_subhead: #6d7885;
  --vkui--color_text_subhead--hover: #697482;
  --vkui--color_text_subhead--active: #64707f;
  --vkui--color_text_tertiary: #99a2ad;
  --vkui--color_text_contrast: #fff;
  --vkui--color_text_contrast_themed: #fff;
  --vkui--color_text_negative: #e64646;
  --vkui--color_text_link: #2d81e0;
  --vkui--color_text_link--hover: #2b7cd9;
  --vkui--color_text_link--active: #2978d3;
  --vkui--color_text_link_themed: #2d81e0;
  --vkui--color_text_link_themed--hover: #2b7cd9;
  --vkui--color_text_link_themed--active: #2978d3;
  --vkui--color_text_muted: #2c2d2e;
  --vkui--color_text_muted--hover: #2a2c2f;
  --vkui--color_text_muted--active: #282b2f;
  --vkui--color_link_contrast: #fff;
  --vkui--color_icon_accent: #2688eb;
  --vkui--color_icon_accent--hover: #2483e4;
  --vkui--color_icon_accent--active: #237edd;
  --vkui--color_icon_accent_themed: #2688eb;
  --vkui--color_icon_accent_themed--hover: #2483e4;
  --vkui--color_icon_accent_themed--active: #237edd;
  --vkui--color_icon_primary_invariably--hover: #2a2c2f;
  --vkui--color_icon_primary_invariably--active: #282b2f;
  --vkui--color_icon_medium: #818c99;
  --vkui--color_icon_medium--hover: #7c8795;
  --vkui--color_icon_medium--active: #778292;
  --vkui--color_icon_secondary: #99a2ad;
  --vkui--color_icon_tertiary: #b8c1cc;
  --vkui--color_icon_tertiary--hover: #b1bac6;
  --vkui--color_icon_tertiary--active: #a9b3c1;
  --vkui--color_icon_contrast: #fff;
  --vkui--color_icon_contrast_themed: #fff;
  --vkui--color_icon_negative: #e64646;
  --vkui--color_stroke_accent: #2688eb;
  --vkui--color_stroke_accent--hover: #2483e4;
  --vkui--color_stroke_accent--active: #237edd;
  --vkui--color_stroke_accent_themed: #2688eb;
  --vkui--color_stroke_accent_themed--hover: #2483e4;
  --vkui--color_stroke_accent_themed--active: #237edd;
  --vkui--color_separator_primary: #d7d8d9;
  --vkui--color_separator_primary--hover: #ced0d3;
  --vkui--color_separator_primary--active: #c6c8cd;
  --vkui--color_separator_primary2x: #cbcccd;
  --vkui--color_separator_primary3x: #bebfc1;
  --vkui--color_separator_secondary: #e1e3e6;
  --vkui--color_separator_secondary--hover: #d8dbdf;
  --vkui--color_separator_secondary--active: #cfd2d8;
  --vkui--color_stroke_negative: #e64646;
  --vkui--color_accent_blue: #2688eb;
  --vkui--color_accent_blue--hover: #2483e4;
  --vkui--color_accent_blue--active: #237edd;
  --vkui--color_accent_gray--hover: #9ca7b3;
  --vkui--color_accent_gray--active: #96a0ae;
  --vkui--color_accent_purple: #735ce6;
  --vkui--color_accent_violet: #792ec0;
  --vkui--color_skeleton_from: #f5f5f5;
  --vkui--color_skeleton_from--hover: #ebecee;
  --vkui--color_skeleton_from--active: #e1e3e6;
  --vkui--color_skeleton_to: #e1e3e6;
  --vkui--color_skeleton_to--hover: #d8dbdf;
  --vkui--color_skeleton_to--active: #cfd2d8;
  --vkui--color_button_text: #2688eb;
  --vkui--color_button_text--hover: #2483e4;
  --vkui--color_button_text--active: #237edd;
  --vkui--color_button_icon: #2688eb;
  --vkui--color_button_icon--hover: #2483e4;
  --vkui--color_button_icon--active: #237edd;
  --vkui--color_button_stroke: #2688eb;
  --vkui--color_button_stroke--hover: #2483e4;
  --vkui--color_button_stroke--active: #237edd;
  --vkui--color_write_bar_icon: #3f8ae0;
  --vkui--color_write_bar_icon--hover: #3c85d9;
  --vkui--color_write_bar_icon--active: #3a80d3;
  --vkui--color_write_bar_input_background: #f2f3f5;
  --vkui--color_write_bar_input_background--hover: #e8eaee;
  --vkui--color_write_bar_input_background--active: #dfe1e6;
  --vkui--color_write_bar_input_border: #e1e3e6;
  --vkui--color_write_bar_input_border--hover: #d8dbdf;
  --vkui--color_write_bar_input_border--active: #cfd2d8;
  --vkui--color_track_background: #e1e3e6;
  --vkui--color_track_background--hover: #d8dbdf;
  --vkui--color_track_background--active: #cfd2d8;
  --vkui--color_track_buffer: #a0bfe4;
  --vkui--color_track_buffer--hover: #9ab8dd;
  --vkui--color_track_buffer--active: #93b1d7;
  --vkui--color_search_field_background: #ebedf0;
  --vkui--color_search_field_background--hover: #e2e4e9;
  --vkui--color_search_field_background--active: #d8dbe2;
  --vkui--color_panel_header_icon: #2688eb;
  --vkui--color_panel_header_icon--hover: #2483e4;
  --vkui--color_panel_header_icon--active: #237edd
}

.vkui--vkBase--dark {
  --vkui--theme_name: "vkBaseDark"
}

.vkui--vkBase--dark,
.vkui--vkCom--dark,
.vkui--vkIOS--dark {
  --vkui--gradient_tint: rgba(32, 32, 33, 0) 0%, rgba(32, 32, 33, .036) 13%, rgba(32, 32, 33, .15) 27%, rgba(32, 32, 33, .79) 68%, rgba(32, 32, 33, .95) 84%, #202021 100%;
  --vkui--gradient: rgba(25, 25, 26, 0) 0%, rgba(25, 25, 26, .014) 13%, rgba(25, 25, 26, .06) 27%, rgba(25, 25, 26, .316) 68%, rgba(25, 25, 26, .38) 84%, rgba(25, 25, 26, .4) 100%;
  --vkui--colors_scheme: dark;
  --vkui--color_background_accent_tint--hover: #61a2ff;
  --vkui--color_background_accent_tint--active: #67a6ff;
  --vkui--color_background_secondary_alpha: hsla(0, 0%, 100%, .1);
  --vkui--color_background_secondary_alpha--hover: hsla(0, 0%, 100%, .12);
  --vkui--color_background_secondary_alpha--active: hsla(0, 0%, 100%, .14);
  --vkui--color_background_tertiary_alpha: hsla(0, 0%, 100%, .03);
  --vkui--color_background_tertiary_alpha--hover: hsla(0, 0%, 100%, .07);
  --vkui--color_background_tertiary_alpha--active: hsla(0, 0%, 100%, .11);
  --vkui--color_background_contrast--hover: #ebedf0;
  --vkui--color_background_contrast--active: #d7d8db;
  --vkui--color_background_contrast_secondary_alpha: hsla(0, 0%, 100%, .2);
  --vkui--color_background_contrast_themed: #323232;
  --vkui--color_background_contrast_themed--hover: #3a3a3a;
  --vkui--color_background_contrast_themed--active: #424242;
  --vkui--color_background_modal_inverse: #fff;
  --vkui--color_background_modal_inverse--hover: #ebedf0;
  --vkui--color_background_modal_inverse--active: #d7d8db;
  --vkui--color_background_warning: #857250;
  --vkui--color_background_warning--hover: #8a7857;
  --vkui--color_background_warning--active: #8f7d5e;
  --vkui--color_background_positive--hover: #52b652;
  --vkui--color_background_positive--active: #59b959;
  --vkui--color_background_negative--hover: #ff6363;
  --vkui--color_background_negative--active: #ff6969;
  --vkui--color_background_negative_tint: #522e2e;
  --vkui--color_background_negative_tint--hover: #593636;
  --vkui--color_background_negative_tint--active: #603f3f;
  --vkui--color_background_positive_tint: #b1d6b1;
  --vkui--color_background_positive_tint--hover: #b4d8b4;
  --vkui--color_background_positive_tint--active: #b7d9b7;
  --vkui--color_text_primary--hover: #e2e4e7;
  --vkui--color_text_primary--active: #e3e5e8;
  --vkui--color_text_contrast--hover: #ebedf0;
  --vkui--color_text_contrast--active: #d7d8db;
  --vkui--color_text_positive--hover: #52b652;
  --vkui--color_text_positive--active: #59b959;
  --vkui--color_text_negative--hover: #ff6363;
  --vkui--color_text_negative--active: #ff6969;
  --vkui--color_text_link_tint--hover: #77adec;
  --vkui--color_text_link_tint--active: #7cb1ed;
  --vkui--color_text_link_visited--hover: #508bce;
  --vkui--color_text_link_visited--active: #5890d0;
  --vkui--color_link_contrast--hover: #ebedf0;
  --vkui--color_link_contrast--active: #d7d8db;
  --vkui--color_icon_primary: #e1e3e6;
  --vkui--color_icon_primary--hover: #e2e4e7;
  --vkui--color_icon_primary--active: #e3e5e8;
  --vkui--color_icon_contrast_secondary--hover: #f3f3f5;
  --vkui--color_icon_contrast_secondary--active: #f3f4f6;
  --vkui--color_icon_positive--hover: #52b652;
  --vkui--color_icon_positive--active: #59b959;
  --vkui--color_icon_negative--hover: #ff6363;
  --vkui--color_icon_negative--active: #ff6969;
  --vkui--color_separator_primary: #363738;
  --vkui--color_separator_primary--hover: #3e3f40;
  --vkui--color_separator_primary--active: #464748;
  --vkui--color_separator_primary2x: #444546;
  --vkui--color_separator_primary2x--hover: #4b4c4d;
  --vkui--color_separator_primary2x--active: #535455;
  --vkui--color_separator_primary3x: #505253;
  --vkui--color_separator_primary3x--hover: #57595a;
  --vkui--color_separator_primary3x--active: #5e6061;
  --vkui--color_separator_primary_alpha: hsla(0, 0%, 100%, .12);
  --vkui--color_separator_primary_alpha--hover: hsla(0, 0%, 100%, .16);
  --vkui--color_separator_primary_alpha--active: hsla(0, 0%, 100%, .2);
  --vkui--color_stroke_positive--hover: #52b652;
  --vkui--color_stroke_positive--active: #59b959;
  --vkui--color_stroke_negative--hover: #ff6363;
  --vkui--color_stroke_negative--active: #ff6969;
  --vkui--color_stroke_contrast: #fff;
  --vkui--color_stroke_contrast--hover: #ebedf0;
  --vkui--color_stroke_contrast--active: #d7d8db;
  --vkui--color_image_border_alpha: hsla(0, 0%, 100%, .08);
  --vkui--color_image_border_alpha--hover: hsla(0, 0%, 100%, .12);
  --vkui--color_image_border_alpha--active: hsla(0, 0%, 100%, .16);
  --vkui--color_field_border_alpha: hsla(0, 0%, 100%, .12);
  --vkui--color_field_border_alpha--hover: hsla(0, 0%, 100%, .16);
  --vkui--color_field_border_alpha--active: hsla(0, 0%, 100%, .2);
  --vkui--color_accent_red--hover: #ff3b4e;
  --vkui--color_accent_red--active: #ff4356;
  --vkui--color_accent_green--hover: #52b652;
  --vkui--color_accent_green--active: #59b959;
  --vkui--color_accent_orange--hover: #ffa40a;
  --vkui--color_accent_orange--active: #ffa814;
  --vkui--color_accent_orange_peach: #ffc062;
  --vkui--color_accent_orange_peach--hover: #ffc368;
  --vkui--color_accent_orange_peach--active: #ffc56f;
  --vkui--color_accent_orange_fire--hover: #f1634b;
  --vkui--color_accent_orange_fire--active: #f16953;
  --vkui--color_accent_raspberry_pink: #f060c0;
  --vkui--color_accent_raspberry_pink--hover: #f166c3;
  --vkui--color_accent_raspberry_pink--active: #f16dc5;
  --vkui--color_accent_secondary--hover: #478fe1;
  --vkui--color_accent_secondary--active: #4e93e2;
  --vkui--color_overlay_secondary: rgba(55, 56, 57, .5);
  --vkui--color_overlay_secondary--hover: rgba(55, 56, 57, .54);
  --vkui--color_overlay_secondary--active: rgba(55, 56, 57, .58);
  --vkui--color_action_sheet_text: #71aaeb;
  --vkui--color_action_sheet_text--hover: #77adec;
  --vkui--color_action_sheet_text--active: #7cb1ed;
  --vkui--color_image_placeholder: #2a2b2c;
  --vkui--color_image_placeholder--hover: #333334;
  --vkui--color_image_placeholder--active: #3b3c3d;
  --vkui--color_image_placeholder_alpha: rgba(241, 247, 255, .08);
  --vkui--color_image_placeholder_alpha--hover: rgba(241, 247, 255, .12);
  --vkui--color_image_placeholder_alpha--active: rgba(241, 247, 255, .16);
  --vkui--color_write_bar_input_border_alpha: hsla(0, 0%, 100%, .8);
  --vkui--color_write_bar_input_border_alpha--hover: hsla(0, 0%, 100%, .84);
  --vkui--color_write_bar_input_border_alpha--active: hsla(0, 0%, 100%, .88);
  --vkui--color_panel_header_icon--hover: #77adec;
  --vkui--color_panel_header_icon--active: #7cb1ed;
  --vkui--color_segmented_control: #626364;
  --vkui--color_segmented_control--hover: #68696a;
  --vkui--color_segmented_control--active: #6f6f70;
  --vkui--color_tabbar_text_inactive: #76787a;
  --vkui--color_tabbar_text_inactive--hover: #7b7d7f;
  --vkui--color_tabbar_text_inactive--active: #818385;
  --vkui--color_transparent--hover: hsla(0, 0%, 100%, .04);
  --vkui--color_transparent--active: hsla(0, 0%, 100%, .08)
}

.vkui--vkBase--dark,
.vkui--vkCom--light,
.vkui--vkIOS--light {
  --vkui--theme_inherits_from: "vkBase"
}

.vkui--vkBase--dark,
.vkui--vkIOS--dark {
  --vkui--color_background_accent: #529ef4;
  --vkui--color_background_accent--hover: #59a2f4;
  --vkui--color_background_accent--active: #60a6f5;
  --vkui--color_background_accent_themed: #fff;
  --vkui--color_background_accent_themed--hover: #ebedf0;
  --vkui--color_background_accent_themed--active: #d7d8db;
  --vkui--color_background_accent_alternative: #529ef4;
  --vkui--color_background_accent_alternative--hover: #59a2f4;
  --vkui--color_background_accent_alternative--active: #60a6f5;
  --vkui--color_background: #0a0a0a;
  --vkui--color_background--hover: #141414;
  --vkui--color_background--active: #1e1e1e;
  --vkui--color_background_content: #0f0f0f;
  --vkui--color_background_content--hover: #222223;
  --vkui--color_background_content--active: #2b2b2c;
  --vkui--color_background_secondary: #212022;
  --vkui--color_background_secondary--hover: #2c2c2d;
  --vkui--color_background_secondary--active: #353536;
  --vkui--color_background_tertiary: #202021;
  --vkui--color_background_tertiary--hover: #29292a;
  --vkui--color_background_tertiary--active: #323233;
  --vkui--color_background_contrast_inverse--hover: #343536;
  --vkui--color_background_contrast_inverse--active: #3d3e3f;
  --vkui--color_background_modal: #2c2d2e;
  --vkui--color_background_modal--hover: #343536;
  --vkui--color_background_modal--active: #3d3e3f;
  --vkui--color_background_negative: #ff5c5c;
  --vkui--color_field_background: #232324;
  --vkui--color_field_background--hover: #2c2c2d;
  --vkui--color_field_background--active: #353536;
  --vkui--color_header_background: #19191a;
  --vkui--color_header_background--hover: #222223;
  --vkui--color_header_background--active: #2b2b2c;
  --vkui--color_text_accent: #529ef4;
  --vkui--color_text_accent--hover: #59a2f4;
  --vkui--color_text_accent--active: #60a6f5;
  --vkui--color_text_accent_themed: #fff;
  --vkui--color_text_accent_themed--hover: #ebedf0;
  --vkui--color_text_accent_themed--active: #d7d8db;
  --vkui--color_text_primary: #e1e3e6;
  --vkui--color_text_primary_invariably--hover: #0a0a0a;
  --vkui--color_text_primary_invariably--active: #141414;
  --vkui--color_text_secondary: #76787a;
  --vkui--color_text_secondary--hover: #7b7d7f;
  --vkui--color_text_secondary--active: #818385;
  --vkui--color_text_subhead: #969a9f;
  --vkui--color_text_subhead--hover: #9a9ea3;
  --vkui--color_text_subhead--active: #9ea2a7;
  --vkui--color_text_tertiary: #5d5f61;
  --vkui--color_text_tertiary--hover: #636567;
  --vkui--color_text_tertiary--active: #6a6c6e;
  --vkui--color_text_contrast_themed: #000;
  --vkui--color_text_contrast_themed--hover: #0a0a0a;
  --vkui--color_text_contrast_themed--active: #141414;
  --vkui--color_text_negative: #ff5c5c;
  --vkui--color_text_link: #529ef4;
  --vkui--color_text_link--hover: #59a2f4;
  --vkui--color_text_link--active: #60a6f5;
  --vkui--color_text_link_themed: #fff;
  --vkui--color_text_link_themed--hover: #ebedf0;
  --vkui--color_text_link_themed--active: #d7d8db;
  --vkui--color_text_muted: #e1e3e6;
  --vkui--color_text_muted--hover: #e2e4e7;
  --vkui--color_text_muted--active: #e3e5e8;
  --vkui--color_icon_accent: #529ef4;
  --vkui--color_icon_accent--hover: #59a2f4;
  --vkui--color_icon_accent--active: #60a6f5;
  --vkui--color_icon_accent_themed: #fff;
  --vkui--color_icon_accent_themed--hover: #ebedf0;
  --vkui--color_icon_accent_themed--active: #d7d8db;
  --vkui--color_icon_primary_invariably--hover: #343536;
  --vkui--color_icon_primary_invariably--active: #3d3e3f;
  --vkui--color_icon_medium: #b0b1b6;
  --vkui--color_icon_medium--hover: #b3b4b9;
  --vkui--color_icon_medium--active: #b6b7bc;
  --vkui--color_icon_medium_alpha: rgba(241, 247, 255, .66);
  --vkui--color_icon_medium_alpha--hover: rgba(241, 247, 255, .7);
  --vkui--color_icon_medium_alpha--active: rgba(241, 247, 255, .74);
  --vkui--color_icon_secondary: #76787a;
  --vkui--color_icon_secondary--hover: #7b7d7f;
  --vkui--color_icon_secondary--active: #818385;
  --vkui--color_icon_secondary_alpha: rgba(0, 0, 0, .43);
  --vkui--color_icon_secondary_alpha--hover: rgba(0, 0, 0, .47);
  --vkui--color_icon_secondary_alpha--active: rgba(0, 0, 0, .51);
  --vkui--color_icon_tertiary: #5d5f61;
  --vkui--color_icon_tertiary--hover: #636567;
  --vkui--color_icon_tertiary--active: #6a6c6e;
  --vkui--color_icon_tertiary_alpha: hsla(0, 0%, 100%, .3);
  --vkui--color_icon_tertiary_alpha--hover: hsla(0, 0%, 100%, .34);
  --vkui--color_icon_tertiary_alpha--active: hsla(0, 0%, 100%, .38);
  --vkui--color_icon_contrast--hover: #ebedf0;
  --vkui--color_icon_contrast--active: #d7d8db;
  --vkui--color_icon_contrast_themed: #000;
  --vkui--color_icon_contrast_themed--hover: #0a0a0a;
  --vkui--color_icon_contrast_themed--active: #141414;
  --vkui--color_icon_negative: #ff5c5c;
  --vkui--color_stroke_accent: #529ef4;
  --vkui--color_stroke_accent--hover: #59a2f4;
  --vkui--color_stroke_accent--active: #60a6f5;
  --vkui--color_stroke_accent_themed: #fff;
  --vkui--color_stroke_accent_themed--hover: #ebedf0;
  --vkui--color_stroke_accent_themed--active: #d7d8db;
  --vkui--color_separator_secondary: #141415;
  --vkui--color_separator_secondary--hover: #1d1d1e;
  --vkui--color_separator_secondary--active: #272728;
  --vkui--color_stroke_negative: #ff5c5c;
  --vkui--color_accent_blue: #71aaeb;
  --vkui--color_accent_blue--hover: #77adec;
  --vkui--color_accent_blue--active: #7cb1ed;
  --vkui--color_accent_gray--hover: #a7b0bb;
  --vkui--color_accent_gray--active: #aab4be;
  --vkui--color_accent_purple: #9985ff;
  --vkui--color_accent_purple--hover: #9d8aff;
  --vkui--color_accent_purple--active: #a18fff;
  --vkui--color_accent_violet: #a94fff;
  --vkui--color_accent_violet--hover: #ac56ff;
  --vkui--color_accent_violet--active: #b05dff;
  --vkui--color_skeleton_from: #232324;
  --vkui--color_skeleton_from--hover: #2c2c2d;
  --vkui--color_skeleton_from--active: #353536;
  --vkui--color_skeleton_to: #2c2d2e;
  --vkui--color_skeleton_to--hover: #343536;
  --vkui--color_skeleton_to--active: #3d3e3f;
  --vkui--color_button_text: #fff;
  --vkui--color_button_text--hover: #ebedf0;
  --vkui--color_button_text--active: #d7d8db;
  --vkui--color_button_icon: #fff;
  --vkui--color_button_icon--hover: #ebedf0;
  --vkui--color_button_icon--active: #d7d8db;
  --vkui--color_button_stroke: #fff;
  --vkui--color_button_stroke--hover: #ebedf0;
  --vkui--color_button_stroke--active: #d7d8db;
  --vkui--color_write_bar_icon: #76787a;
  --vkui--color_write_bar_icon--hover: #7b7d7f;
  --vkui--color_write_bar_icon--active: #818385;
  --vkui--color_write_bar_input_background: #2c2d2e;
  --vkui--color_write_bar_input_background--hover: #343536;
  --vkui--color_write_bar_input_background--active: #3d3e3f;
  --vkui--color_write_bar_input_border: #2c2d2e;
  --vkui--color_write_bar_input_border--hover: #343536;
  --vkui--color_write_bar_input_border--active: #3d3e3f;
  --vkui--color_track_background: #454647;
  --vkui--color_track_background--hover: #4c4d4e;
  --vkui--color_track_background--active: #545556;
  --vkui--color_track_buffer: #405772;
  --vkui--color_track_buffer--hover: #485e78;
  --vkui--color_track_buffer--active: #4f647d;
  --vkui--color_search_field_background: #363738;
  --vkui--color_search_field_background--hover: #3e3f40;
  --vkui--color_search_field_background--active: #464748;
  --vkui--color_panel_header_icon: #71aaeb
}

.vkui--vkBase--dark,
.vkui--vkCom--dark,
.vkui--vkCom--light,
.vkui--vkIOS--dark {
  --vkui--color_background_contrast: #fff;
  --vkui--color_text_contrast: #fff;
  --vkui--color_link_contrast: #fff
}

.vkui--vkBase--dark,
.vkui--vkCom--light,
.vkui--vkIOS--dark {
  --vkui--color_icon_contrast: #fff
}

.vkui--vkIOS--light {
  --vkui--theme_name: "vkIOS"
}

.vkui--vkIOS--dark,
.vkui--vkIOS--light {
  --vkui--theme_name_base: "vkIOS";
  --vkui--size_border_radius--regular: 10px;
  --vkui--size_card_border_radius--regular: 10px;
  --vkui--size_switch_height--regular: 31px;
  --vkui--size_switch_height--compact: 27px;
  --vkui--size_switch_width--regular: 51px;
  --vkui--size_switch_width--compact: 47px;
  --vkui--size_switch_pin--regular: 27px;
  --vkui--size_switch_pin--compact: 23px;
  --vkui--size_panel_header_height--regular: 52px;
  --vkui--animation_easing_platform: cubic-bezier(0.36, 0.66, 0.04, 1)
}

.vkui--vkCom--dark,
.vkui--vkCom--light,
.vkui--vkIOS--dark,
.vkui--vkIOS--light {
  --vkui--size_base_padding_horizontal--regular: 12px
}

.vkui--vkIOS--dark {
  --vkui--theme_name: "vkIOSDark"
}

.vkui--vkCom--dark,
.vkui--vkIOS--dark {
  --vkui--theme_inherits_from: "vkBaseDark"
}

.vkui--vkCom--light {
  --vkui--theme_name: "vkCom";
  --vkui--color_background_accent: #447bba;
  --vkui--color_background_accent--hover: #4177b5;
  --vkui--color_background_accent--active: #3f72b0;
  --vkui--color_background_accent_themed: #447bba;
  --vkui--color_background_accent_themed--hover: #4177b5;
  --vkui--color_background_accent_themed--active: #3f72b0;
  --vkui--color_background_accent_alternative: #447bba;
  --vkui--color_background_accent_alternative--hover: #4177b5;
  --vkui--color_background_accent_alternative--active: #3f72b0;
  --vkui--color_background: #edeef0;
  --vkui--color_background--hover: #e4e5e9;
  --vkui--color_background--active: #dadce2;
  --vkui--color_background_content: #fff;
  --vkui--color_background_secondary: #f0f2f5;
  --vkui--color_background_secondary--hover: #e6e9ee;
  --vkui--color_background_secondary--active: #dde0e6;
  --vkui--color_background_secondary_alpha: rgba(235, 242, 250, .99);
  --vkui--color_background_secondary_alpha--hover: rgba(223, 234, 246, .99);
  --vkui--color_background_secondary_alpha--active: rgba(213, 226, 241, .99);
  --vkui--color_background_tertiary: #fafbfc;
  --vkui--color_background_tertiary--hover: #f0f2f4;
  --vkui--color_background_tertiary--active: #e6e8ed;
  --vkui--color_background_contrast_inverse--hover: #313233;
  --vkui--color_background_contrast_inverse--active: #2f3034;
  --vkui--color_background_modal: #fff;
  --vkui--color_background_modal_inverse: #2d2d2e;
  --vkui--color_background_negative: #e64646;
  --vkui--color_field_background: #f7f8fa;
  --vkui--color_field_background--hover: #edeff2;
  --vkui--color_field_background--active: #e3e5eb;
  --vkui--color_header_background: #fff;
  --vkui--color_text_accent: #447bba;
  --vkui--color_text_accent--hover: #4177b5;
  --vkui--color_text_accent--active: #3f72b0;
  --vkui--color_text_accent_themed: #3770b1;
  --vkui--color_text_accent_themed--hover: #356cac;
  --vkui--color_text_accent_themed--active: #3368a8;
  --vkui--color_text_primary_invariably--hover: #313233;
  --vkui--color_text_primary_invariably--active: #2f3034;
  --vkui--color_text_secondary: #818c99;
  --vkui--color_text_subhead: #626d7a;
  --vkui--color_text_subhead--hover: #5e6978;
  --vkui--color_text_subhead--active: #5a6675;
  --vkui--color_text_tertiary: #99a2ad;
  --vkui--color_text_contrast_themed: #fff;
  --vkui--color_text_negative: #e64646;
  --vkui--color_text_link: #2a5885;
  --vkui--color_text_link--hover: #285582;
  --vkui--color_text_link--active: #27527f;
  --vkui--color_text_link_themed: #2a5885;
  --vkui--color_text_link_themed--hover: #285582;
  --vkui--color_text_link_themed--active: #27527f;
  --vkui--color_text_muted: #333;
  --vkui--color_text_muted--hover: #313233;
  --vkui--color_text_muted--active: #2f3034;
  --vkui--color_icon_accent: #447bba;
  --vkui--color_icon_accent--hover: #4177b5;
  --vkui--color_icon_accent--active: #3f72b0;
  --vkui--color_icon_accent_themed: #3770b1;
  --vkui--color_icon_accent_themed--hover: #356cac;
  --vkui--color_icon_accent_themed--active: #3368a8;
  --vkui--color_icon_primary_invariably--hover: #313233;
  --vkui--color_icon_primary_invariably--active: #2f3034;
  --vkui--color_icon_medium: #6f7985;
  --vkui--color_icon_medium--hover: #6b7582;
  --vkui--color_icon_medium--active: #66717f;
  --vkui--color_icon_secondary: #99a2ad;
  --vkui--color_icon_tertiary: #aeb7c2;
  --vkui--color_icon_tertiary--hover: #a7b0bd;
  --vkui--color_icon_tertiary--active: #a0aab7;
  --vkui--color_icon_contrast_themed: #fff;
  --vkui--color_icon_negative: #e64646;
  --vkui--color_stroke_accent: #447bba;
  --vkui--color_stroke_accent--hover: #4177b5;
  --vkui--color_stroke_accent--active: #3f72b0;
  --vkui--color_stroke_accent_themed: #3770b1;
  --vkui--color_stroke_accent_themed--hover: #356cac;
  --vkui--color_stroke_accent_themed--active: #3368a8;
  --vkui--color_separator_primary: #dce1e6;
  --vkui--color_separator_primary--hover: #d3d9df;
  --vkui--color_separator_primary--active: #cad0d8;
  --vkui--color_separator_primary2x: #cbcccd;
  --vkui--color_separator_primary3x: #bebfc1;
  --vkui--color_separator_secondary: #e7e8ec;
  --vkui--color_separator_secondary--hover: #dedfe5;
  --vkui--color_separator_secondary--active: #d5d7de;
  --vkui--color_stroke_negative: #e64646;
  --vkui--color_accent_blue: #5181b8;
  --vkui--color_accent_blue--hover: #4e7cb3;
  --vkui--color_accent_blue--active: #4b78ae;
  --vkui--color_accent_gray--hover: #a7b0bd;
  --vkui--color_accent_gray--active: #a0aab7;
  --vkui--color_accent_purple: #735ce6;
  --vkui--color_accent_violet: #792ec0;
  --vkui--color_skeleton_from: #f0f2f5;
  --vkui--color_skeleton_from--hover: #e6e9ee;
  --vkui--color_skeleton_from--active: #dde0e6;
  --vkui--color_skeleton_to: #e7e8ec;
  --vkui--color_skeleton_to--hover: #dedfe5;
  --vkui--color_skeleton_to--active: #d5d7de;
  --vkui--color_button_text: #346297;
  --vkui--color_button_text--hover: #325f93;
  --vkui--color_button_text--active: #305b90;
  --vkui--color_button_icon: #346297;
  --vkui--color_button_icon--hover: #325f93;
  --vkui--color_button_icon--active: #305b90;
  --vkui--color_button_stroke: #346297;
  --vkui--color_button_stroke--hover: #325f93;
  --vkui--color_button_stroke--active: #305b90;
  --vkui--color_write_bar_icon: #818c99;
  --vkui--color_write_bar_icon--hover: #7c8795;
  --vkui--color_write_bar_icon--active: #778292;
  --vkui--color_write_bar_input_background: #fff;
  --vkui--color_write_bar_input_background--hover: #f5f5f7;
  --vkui--color_write_bar_input_background--active: #ebecef;
  --vkui--color_write_bar_input_border: #d3d9de;
  --vkui--color_write_bar_input_border--hover: #cbd1d8;
  --vkui--color_write_bar_input_border--active: #c2c9d1;
  --vkui--color_track_background: #d3d9de;
  --vkui--color_track_background--hover: #cbd1d8;
  --vkui--color_track_background--active: #c2c9d1;
  --vkui--color_track_buffer: #447bba;
  --vkui--color_track_buffer--hover: #4177b5;
  --vkui--color_track_buffer--active: #3f72b0;
  --vkui--color_search_field_background: #edeef0;
  --vkui--color_search_field_background--hover: #e4e5e9;
  --vkui--color_search_field_background--active: #dadce2;
  --vkui--color_panel_header_icon: #447bba;
  --vkui--color_panel_header_icon--hover: #4177b5;
  --vkui--color_panel_header_icon--active: #3f72b0
}

.vkui--vkCom--dark,
.vkui--vkCom--light {
  --vkui--theme_name_base: "vkCom";
  --vkui--font_headline1--font_size--compact: 14px;
  --vkui--font_headline1--line_height--compact: 18px;
  --vkui--font_text--font_size--compact: 13px;
  --vkui--font_text--line_height--compact: 16px;
  --vkui--font_subhead--font_size--compact: 14px;
  --vkui--font_subhead--line_height--compact: 18px;
  --vkui--size_popup_small--regular: 448px;
  --vkui--size_switch_height--regular: 10px;
  --vkui--size_switch_height--compact: 10px;
  --vkui--size_switch_width--regular: 27px;
  --vkui--size_switch_width--compact: 27px;
  --vkui--size_switch_pin--regular: 16px;
  --vkui--size_switch_pin--compact: 16px;
  --vkui--size_panel_header_height--regular: 48px;
  --vkui--size_form_item_padding_vertical--regular: 8px;
  --vkui--size_border2x--regular: 1px;
  --vkui--size_border3x--regular: 1px;
  --vkui--font_headline--font_size--compact: 14px;
  --vkui--font_headline--line_height--compact: 18px;
  --vkui--color_background_contrast_inverse: #333;
  --vkui--color_background_positive: #4bb34b;
  --vkui--color_text_primary_invariably: #333;
  --vkui--color_text_positive: #4bb34b;
  --vkui--color_icon_primary_invariably: #333;
  --vkui--color_icon_positive: #4bb34b;
  --vkui--color_stroke_positive: #4bb34b;
  --vkui--color_accent_gray: #aeb7c2;
  --vkui--color_accent_red: #ff3347;
  --vkui--color_accent_green: #4bb34b;
  --vkui--color_accent_orange: #ffa000
}

.vkui--vkCom--dark {
  --vkui--theme_name: "vkComDark";
  --vkui--color_background_accent: #71aaeb;
  --vkui--color_background_accent--hover: #77adec;
  --vkui--color_background_accent--active: #7cb1ed;
  --vkui--color_background_accent_themed: #e1e3e6;
  --vkui--color_background_accent_themed--hover: #d8dbdf;
  --vkui--color_background_accent_themed--active: #cfd2d8;
  --vkui--color_background_accent_alternative: #71aaeb;
  --vkui--color_background_accent_alternative--hover: #77adec;
  --vkui--color_background_accent_alternative--active: #7cb1ed;
  --vkui--color_background: #141414;
  --vkui--color_background--hover: #1d1d1d;
  --vkui--color_background--active: #272727;
  --vkui--color_background_content: #222;
  --vkui--color_background_content--hover: #2b2b2b;
  --vkui--color_background_content--active: #343434;
  --vkui--color_background_secondary: #333;
  --vkui--color_background_secondary--hover: #3b3b3b;
  --vkui--color_background_secondary--active: #434343;
  --vkui--color_background_tertiary: #292929;
  --vkui--color_background_tertiary--hover: #323232;
  --vkui--color_background_tertiary--active: #3a3a3a;
  --vkui--color_background_contrast_inverse--hover: #3b3b3b;
  --vkui--color_background_contrast_inverse--active: #434343;
  --vkui--color_background_modal: #292929;
  --vkui--color_background_modal--hover: #323232;
  --vkui--color_background_modal--active: #3a3a3a;
  --vkui--color_background_negative: #ff5c5c;
  --vkui--color_field_background: #292929;
  --vkui--color_field_background--hover: #323232;
  --vkui--color_field_background--active: #3a3a3a;
  --vkui--color_header_background: #222;
  --vkui--color_header_background--hover: #2b2b2b;
  --vkui--color_header_background--active: #343434;
  --vkui--color_text_accent: #71aaeb;
  --vkui--color_text_accent--hover: #77adec;
  --vkui--color_text_accent--active: #7cb1ed;
  --vkui--color_text_accent_themed: #e1e3e6;
  --vkui--color_text_accent_themed--hover: #e2e4e7;
  --vkui--color_text_accent_themed--active: #e3e5e8;
  --vkui--color_text_primary: #e1e3e6;
  --vkui--color_text_primary_invariably--hover: #3b3b3b;
  --vkui--color_text_primary_invariably--active: #434343;
  --vkui--color_text_secondary: #828282;
  --vkui--color_text_secondary--hover: #878787;
  --vkui--color_text_secondary--active: #8c8c8c;
  --vkui--color_text_subhead: #939393;
  --vkui--color_text_subhead--hover: #979797;
  --vkui--color_text_subhead--active: #9c9c9c;
  --vkui--color_text_tertiary: #656565;
  --vkui--color_text_tertiary--hover: #6b6b6b;
  --vkui--color_text_tertiary--active: #717171;
  --vkui--color_text_contrast_themed: #222;
  --vkui--color_text_contrast_themed--hover: #2b2b2b;
  --vkui--color_text_contrast_themed--active: #343434;
  --vkui--color_text_negative: #ff5c5c;
  --vkui--color_text_link: #71aaeb;
  --vkui--color_text_link--hover: #77adec;
  --vkui--color_text_link--active: #7cb1ed;
  --vkui--color_text_link_themed: #939393;
  --vkui--color_text_link_themed--hover: #979797;
  --vkui--color_text_link_themed--active: #9c9c9c;
  --vkui--color_text_muted: #ccc;
  --vkui--color_text_muted--hover: #cecece;
  --vkui--color_text_muted--active: #d0d0d0;
  --vkui--color_icon_accent: #71aaeb;
  --vkui--color_icon_accent--hover: #77adec;
  --vkui--color_icon_accent--active: #7cb1ed;
  --vkui--color_icon_accent_themed: #e1e3e6;
  --vkui--color_icon_accent_themed--hover: #e2e4e7;
  --vkui--color_icon_accent_themed--active: #e3e5e8;
  --vkui--color_icon_primary_invariably--hover: #3b3b3b;
  --vkui--color_icon_primary_invariably--active: #434343;
  --vkui--color_icon_medium: #939393;
  --vkui--color_icon_medium--hover: #979797;
  --vkui--color_icon_medium--active: #9c9c9c;
  --vkui--color_icon_medium_alpha: hsla(0, 0%, 100%, .48);
  --vkui--color_icon_medium_alpha--hover: hsla(0, 0%, 100%, .52);
  --vkui--color_icon_medium_alpha--active: hsla(0, 0%, 100%, .56);
  --vkui--color_icon_secondary: #828282;
  --vkui--color_icon_secondary--hover: #878787;
  --vkui--color_icon_secondary--active: #8c8c8c;
  --vkui--color_icon_secondary_alpha: hsla(0, 0%, 100%, .4);
  --vkui--color_icon_secondary_alpha--hover: hsla(0, 0%, 100%, .44);
  --vkui--color_icon_secondary_alpha--active: hsla(0, 0%, 100%, .48);
  --vkui--color_icon_tertiary: #656565;
  --vkui--color_icon_tertiary--hover: #6b6b6b;
  --vkui--color_icon_tertiary--active: #717171;
  --vkui--color_icon_tertiary_alpha: hsla(0, 0%, 100%, .24);
  --vkui--color_icon_tertiary_alpha--hover: hsla(0, 0%, 100%, .28);
  --vkui--color_icon_tertiary_alpha--active: hsla(0, 0%, 100%, .32);
  --vkui--color_icon_contrast: #e1e3e6;
  --vkui--color_icon_contrast--hover: #e2e4e7;
  --vkui--color_icon_contrast--active: #e3e5e8;
  --vkui--color_icon_contrast_themed: #222;
  --vkui--color_icon_contrast_themed--hover: #2b2b2b;
  --vkui--color_icon_contrast_themed--active: #343434;
  --vkui--color_icon_negative: #ff5c5c;
  --vkui--color_stroke_accent: #71aaeb;
  --vkui--color_stroke_accent--hover: #77adec;
  --vkui--color_stroke_accent--active: #7cb1ed;
  --vkui--color_stroke_accent_themed: #e1e3e6;
  --vkui--color_stroke_accent_themed--hover: #e2e4e7;
  --vkui--color_stroke_accent_themed--active: #e3e5e8;
  --vkui--color_separator_secondary: #292929;
  --vkui--color_separator_secondary--hover: #323232;
  --vkui--color_separator_secondary--active: #3a3a3a;
  --vkui--color_stroke_negative: #ff5c5c;
  --vkui--color_accent_blue: #397dcc;
  --vkui--color_accent_blue--hover: #4182ce;
  --vkui--color_accent_blue--active: #4987d0;
  --vkui--color_accent_gray--hover: #b1bac4;
  --vkui--color_accent_gray--active: #b4bdc7;
  --vkui--color_accent_purple: #937ff5;
  --vkui--color_accent_purple--hover: #9784f5;
  --vkui--color_accent_purple--active: #9c89f6;
  --vkui--color_accent_violet: #a393f5;
  --vkui--color_accent_violet--hover: #a797f5;
  --vkui--color_accent_violet--active: #aa9cf6;
  --vkui--color_skeleton_from: #292929;
  --vkui--color_skeleton_from--hover: #323232;
  --vkui--color_skeleton_from--active: #3a3a3a;
  --vkui--color_skeleton_to: #333;
  --vkui--color_skeleton_to--hover: #3b3b3b;
  --vkui--color_skeleton_to--active: #434343;
  --vkui--color_button_text: #e1e3e6;
  --vkui--color_button_text--hover: #e2e4e7;
  --vkui--color_button_text--active: #e3e5e8;
  --vkui--color_button_icon: #e1e3e6;
  --vkui--color_button_icon--hover: #e2e4e7;
  --vkui--color_button_icon--active: #e3e5e8;
  --vkui--color_button_stroke: #e1e3e6;
  --vkui--color_button_stroke--hover: #e2e4e7;
  --vkui--color_button_stroke--active: #e3e5e8;
  --vkui--color_write_bar_icon: #e1e3e6;
  --vkui--color_write_bar_icon--hover: #e2e4e7;
  --vkui--color_write_bar_icon--active: #e3e5e8;
  --vkui--color_write_bar_input_background: #424242;
  --vkui--color_write_bar_input_background--hover: #4a4a4a;
  --vkui--color_write_bar_input_background--active: #515151;
  --vkui--color_write_bar_input_border: #555;
  --vkui--color_write_bar_input_border--hover: #5c5c5c;
  --vkui--color_write_bar_input_border--active: #636363;
  --vkui--color_track_background: #828282;
  --vkui--color_track_background--hover: #878787;
  --vkui--color_track_background--active: #8c8c8c;
  --vkui--color_track_buffer: #fff;
  --vkui--color_track_buffer--hover: #ebedf0;
  --vkui--color_track_buffer--active: #d7d8db;
  --vkui--color_search_field_background: #424242;
  --vkui--color_search_field_background--hover: #4a4a4a;
  --vkui--color_search_field_background--active: #515151;
  --vkui--color_panel_header_icon: #71aaeb
}

:root {
  --vkui_internal--tabbar_height: 48px;
  --vkui_internal--grid_avatar_image_offset: 2px;
  --vkui_internal--slider_thumb_size: 28px;
  --vkui_internal--side_cell_gap: calc(var(--vkui--size_base_padding_horizontal--regular) - var(--vkui--spacing_size_s));
  --vkui_internal--popover_safe_zone_padding: 8px;
  --vkui_internal--white: #fff;
  --vkui_internal--safe_area_inset_top: 0px;
  --vkui_internal--safe_area_inset_right: 0px;
  --vkui_internal--safe_area_inset_bottom: 0px;
  --vkui_internal--safe_area_inset_left: 0px;
  --vkui_internal--duration: 0.7s;
  --vkui_internal--z_index_cell_dragging: 1;
  --vkui_internal--z_index_tabs: 2;
  --vkui_internal--z_index_fixed_layout: 3;
  --vkui_internal--z_index_panel_header_context: 4;
  --vkui_internal--z_index_panel_header_fade: 5;
  --vkui_internal--z_index_pull_to_refresh: 9;
  --vkui_internal--z_index_panel_header: 10;
  --vkui_internal--z_index_split_layout_panel_header: 11;
  --vkui_internal--z_index_tappable_state: 0;
  --vkui_internal--z_index_tappable_element: 1;
  --vkui_internal--z_index_banner_background: 0;
  --vkui_internal--z_index_banner_content: 1;
  --vkui_internal--z_index_banner_hover: 2;
  --vkui_internal--z_index_form_field_element: 1;
  --vkui_internal--z_index_form_field_border: 2;
  --vkui_internal--z_index_form_field_status: 3;
  --vkui_internal--z_index_form_field_border_hover: 4;
  --vkui_internal--z_index_form_field_focus: 5;
  --vkui_internal--z_index_form_field_side: 6;
  --vkui_internal--z_index_image_base_overlay: 0;
  --vkui_internal--z_index_image_base_border: 1;
  --vkui_internal--z_index_image_base_badge: 2;
  --vkui_internal--z_index_horizontal_scroll_arrow: 1
}

@supports (padding-top:constant(safe-area-inset-top)) {
  :root {
    --vkui_internal--safe_area_inset_top: constant(safe-area-inset-top);
    --vkui_internal--safe_area_inset_right: constant(safe-area-inset-right);
    --vkui_internal--safe_area_inset_bottom: constant(safe-area-inset-bottom);
    --vkui_internal--safe_area_inset_left: constant(safe-area-inset-left)
  }
}

@supports (padding-top:env(safe-area-inset-top)) {
  :root {
    --vkui_internal--safe_area_inset_top: env(safe-area-inset-top);
    --vkui_internal--safe_area_inset_right: env(safe-area-inset-right);
    --vkui_internal--safe_area_inset_bottom: env(safe-area-inset-bottom);
    --vkui_internal--safe_area_inset_left: env(safe-area-inset-left)
  }
}

@media (min-width:768px) {
  .vkui-sizeX--compact-mq {
    display: none !important
  }
}

@media (max-width:767.9px) {
  .vkui-sizeX--regular-mq {
    display: none !important
  }
}

@media (max-width:767.9px) and (min-height:415px),
(pointer:coarse) and (min-height:415px),
(pointer:none) and (min-height:415px) {
  .vkui-sizeY--compact-mq {
    display: none !important
  }
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkui-sizeY--regular-mq {
    display: none !important
  }
}

@media (min-width:1024px) {
  .vkui-viewWidth--tabletMinus-mq {
    display: none !important
  }
}

@media (max-width:1023.9px) {
  .vkui-viewWidth--tabletPlus-mq {
    display: none !important
  }
}

.vkui-deviceType--desktop-forced,
.vkui-deviceType--mobile-forced {
  display: none !important
}

@media (min-width:768px) and (min-height:720px),
(min-width:768px) and (pointer:fine) {
  .vkui-deviceType--mobile-mq {
    display: none !important
  }
}

@media (max-width:767.9px),
(pointer:coarse) and (max-height:719.9px),
(pointer:none) and (max-height:719.9px) {
  .vkui-deviceType--desktop-mq {
    display: none !important
  }
}

* {
  --vkui--size_border--regular: var(--vkui--size_border1x--regular)
}

@media (min-resolution:2dppx) {
  * {
    --vkui--size_border--regular: var(--vkui--size_border2x--regular);
    --vkui--color_separator_primary: var(--vkui--color_separator_primary2x)
  }
}

@media (min-resolution:3dppx) {
  * {
    --vkui--size_border--regular: var(--vkui--size_border3x--regular);
    --vkui--color_separator_primary: var(--vkui--color_separator_primary3x)
  }
}

.vkuiAppRoot {
  height: 100%
}

.vkuiAppRoot--pointer-has-not {
  -webkit-user-select: none;
  user-select: none
}

.vkuiAppRoot--pointer-has-not [contenteditable] {
  -webkit-user-select: text;
  user-select: text
}

@media (pointer:coarse),
(pointer:none) {
  .vkuiAppRoot--pointer-none {
    -webkit-user-select: none;
    user-select: none
  }

  .vkuiAppRoot--pointer-none [contenteditable] {
    -webkit-user-select: text;
    user-select: text
  }
}

.vkui__root--embedded .vkuiAppRoot {
  overflow: auto
}

.vkuiTitle--level-1 {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_title1--font_family--regular);
  font-size: 24px;
  font-size: var(--vkui--font_title1--font_size--regular);
  font-weight: 600;
  font-weight: var(--vkui--font_title1--font_weight--regular);
  line-height: 28px;
  line-height: var(--vkui--font_title1--line_height--regular)
}

.vkuiTitle--level-2 {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_title2--font_family--regular);
  font-size: 20px;
  font-size: var(--vkui--font_title2--font_size--regular);
  font-weight: 600;
  font-weight: var(--vkui--font_title2--font_weight--regular);
  line-height: 24px;
  line-height: var(--vkui--font_title2--line_height--regular)
}

.vkuiTitle--level-3 {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_title3--font_family--regular);
  font-size: 17px;
  font-size: var(--vkui--font_title3--font_size--regular);
  font-weight: 600;
  font-weight: var(--vkui--font_title3--font_weight--regular);
  line-height: 22px;
  line-height: var(--vkui--font_title3--line_height--regular)
}

.vkuiTypography--normalize {
  display: block;
  margin: 0;
  padding: 0
}

.vkuiTypography--weight-1.vkuiTypography--weight-1.vkuiTypography--weight-1 {
  font-weight: 600;
  font-weight: var(--vkui--font_weight_accent1)
}

.vkuiTypography--weight-2.vkuiTypography--weight-2.vkuiTypography--weight-2 {
  font-weight: 500;
  font-weight: var(--vkui--font_weight_accent2)
}

.vkuiTypography--weight-3.vkuiTypography--weight-3.vkuiTypography--weight-3 {
  font-weight: 400;
  font-weight: var(--vkui--font_weight_accent3)
}

.vkuiTypography b {
  font-weight: 600;
  font-weight: var(--vkui--font_weight_accent1)
}

.vkuiHeadline--level-1 {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_headline1--font_family--regular);
  font-size: 16px;
  font-size: var(--vkui--font_headline1--font_size--regular);
  font-weight: 500;
  font-weight: var(--vkui--font_headline1--font_weight--regular);
  line-height: 20px;
  line-height: var(--vkui--font_headline1--line_height--regular)
}

.vkuiHeadline--sizeY-compact.vkuiHeadline--level-1 {
  font-size: 15px;
  font-size: var(--vkui--font_headline1--font_size--compact);
  line-height: 20px;
  line-height: var(--vkui--font_headline1--line_height--compact)
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiHeadline--sizeY-none.vkuiHeadline--level-1 {
    font-size: 15px;
    font-size: var(--vkui--font_headline1--font_size--compact);
    line-height: 20px;
    line-height: var(--vkui--font_headline1--line_height--compact)
  }
}

.vkuiHeadline--level-2 {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_headline2--font_family--regular);
  font-size: 15px;
  font-size: var(--vkui--font_headline2--font_size--regular);
  font-weight: 500;
  font-weight: var(--vkui--font_headline2--font_weight--regular);
  line-height: 20px;
  line-height: var(--vkui--font_headline2--line_height--regular)
}

.vkuiHeadline--sizeY-compact.vkuiHeadline--level-2 {
  font-size: 14px;
  font-size: var(--vkui--font_headline2--font_size--compact);
  line-height: 20px;
  line-height: var(--vkui--font_headline2--line_height--compact)
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiHeadline--sizeY-none.vkuiHeadline--level-2 {
    font-size: 14px;
    font-size: var(--vkui--font_headline2--font_size--compact);
    line-height: 20px;
    line-height: var(--vkui--font_headline2--line_height--compact)
  }
}

.vkuiText {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_text--font_family--regular);
  font-size: 16px;
  font-size: var(--vkui--font_text--font_size--regular);
  font-weight: 400;
  font-weight: var(--vkui--font_text--font_weight--regular);
  line-height: 20px;
  line-height: var(--vkui--font_text--line_height--regular)
}

.vkuiText--sizeY-compact {
  font-size: 15px;
  font-size: var(--vkui--font_text--font_size--compact);
  line-height: 20px;
  line-height: var(--vkui--font_text--line_height--compact)
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiText--sizeY-none {
    font-size: 15px;
    font-size: var(--vkui--font_text--font_size--compact);
    line-height: 20px;
    line-height: var(--vkui--font_text--line_height--compact)
  }
}

.vkuiParagraph {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_paragraph--font_family--regular);
  font-size: 15px;
  font-size: var(--vkui--font_paragraph--font_size--regular);
  font-weight: 400;
  font-weight: var(--vkui--font_paragraph--font_weight--regular);
  line-height: 20px;
  line-height: var(--vkui--font_paragraph--line_height--regular)
}

.vkuiSubhead {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_subhead--font_family--regular);
  font-size: 14px;
  font-size: var(--vkui--font_subhead--font_size--regular);
  font-weight: 400;
  font-weight: var(--vkui--font_subhead--font_weight--regular);
  line-height: 18px;
  line-height: var(--vkui--font_subhead--line_height--regular)
}

.vkuiSubhead--sizeY-compact {
  font-size: 13px;
  font-size: var(--vkui--font_subhead--font_size--compact);
  line-height: 16px;
  line-height: var(--vkui--font_subhead--line_height--compact)
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiSubhead--sizeY-none {
    font-size: 13px;
    font-size: var(--vkui--font_subhead--font_size--compact);
    line-height: 16px;
    line-height: var(--vkui--font_subhead--line_height--compact)
  }
}

.vkuiFootnote {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_footnote--font_family--regular);
  font-size: 13px;
  font-size: var(--vkui--font_footnote--font_size--regular);
  font-weight: 400;
  font-weight: var(--vkui--font_footnote--font_weight--regular);
  line-height: 16px;
  line-height: var(--vkui--font_footnote--line_height--regular)
}

.vkuiFootnote--caps {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_footnote_caps--font_family--regular);
  font-size: 13px;
  font-size: var(--vkui--font_footnote_caps--font_size--regular);
  font-weight: 400;
  font-weight: var(--vkui--font_footnote_caps--font_weight--regular);
  line-height: 16px;
  line-height: var(--vkui--font_footnote_caps--line_height--regular);
  text-transform: uppercase
}

.vkuiCaption--caps {
  text-transform: uppercase
}

.vkuiCaption--level-1 {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_caption1--font_family--regular);
  font-size: 12px;
  font-size: var(--vkui--font_caption1--font_size--regular);
  font-weight: 400;
  font-weight: var(--vkui--font_caption1--font_weight--regular);
  line-height: 14px;
  line-height: var(--vkui--font_caption1--line_height--regular)
}

.vkuiCaption--level-1.vkuiCaption--caps {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_caption1_caps--font_family--regular);
  font-size: 12px;
  font-size: var(--vkui--font_caption1_caps--font_size--regular);
  font-weight: 600;
  font-weight: var(--vkui--font_caption1_caps--font_weight--regular);
  line-height: 14px;
  line-height: var(--vkui--font_caption1_caps--line_height--regular)
}

.vkuiCaption--level-2 {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_caption2--font_family--regular);
  font-size: 11px;
  font-size: var(--vkui--font_caption2--font_size--regular);
  font-weight: 400;
  font-weight: var(--vkui--font_caption2--font_weight--regular);
  line-height: 14px;
  line-height: var(--vkui--font_caption2--line_height--regular)
}

.vkuiCaption--level-2.vkuiCaption--caps {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_caption2_caps--font_family--regular);
  font-size: 11px;
  font-size: var(--vkui--font_caption2_caps--font_size--regular);
  font-weight: 600;
  font-weight: var(--vkui--font_caption2_caps--font_weight--regular);
  line-height: 14px;
  line-height: var(--vkui--font_caption2_caps--line_height--regular)
}

.vkuiCaption--level-3 {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_caption3--font_family--regular);
  font-size: 9px;
  font-size: var(--vkui--font_caption3--font_size--regular);
  font-weight: 400;
  font-weight: var(--vkui--font_caption3--font_weight--regular);
  line-height: 12px;
  line-height: var(--vkui--font_caption3--line_height--regular)
}

.vkuiCaption--level-3.vkuiCaption--caps {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_caption3_caps--font_family--regular);
  font-size: 9px;
  font-size: var(--vkui--font_caption3_caps--font_size--regular);
  font-weight: 600;
  font-weight: var(--vkui--font_caption3_caps--font_weight--regular);
  line-height: 12px;
  line-height: var(--vkui--font_caption3_caps--line_height--regular)
}

.vkuiTappable {
  -webkit-tap-highlight-color: transparent;
  border-radius: 8px;
  border-radius: var(--vkui--size_border_radius--regular);
  cursor: default;
  isolation: isolate;
  position: relative;
  transition: background-color .15s ease-out, opacity .15s ease-out
}

.vkuiTappable>* {
  position: relative;
  z-index: 1;
  z-index: var(--vkui_internal--z_index_tappable_element)
}

.vkuiTappable--hasActive,
.vkuiTappable--hasHover {
  cursor: pointer
}

.vkuiTappable[aria-disabled=true],
.vkuiTappable[disabled] {
  cursor: default
}

.vkuiTappable--focus-visible,
.vkuiTappable:focus,
.vkuiTappable:focus-visible {
  outline: none
}

.vkuiTappable__stateLayer {
  border-radius: inherit;
  bottom: 0;
  left: 0;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  transition: background-color .15s ease-out;
  z-index: 0;
  z-index: var(--vkui_internal--z_index_tappable_state)
}

.vkuiTappable--hover-background>.vkuiTappable__stateLayer {
  background-color: rgba(0, 16, 61, .04);
  background-color: var(--vkui--color_transparent--hover)
}

.vkuiTappable--hover-opacity {
  opacity: .8
}

.vkuiTappable--active-background>.vkuiTappable__stateLayer {
  background-color: rgba(0, 16, 61, .08);
  background-color: var(--vkui--color_transparent--active)
}

.vkuiTappable--active-opacity {
  opacity: .7
}

.vkuiTappable--ios.vkuiTappable--active-background {
  transition: none
}

.vkuiTappable .vkuiTappable__waves {
  border-radius: inherit;
  bottom: 0;
  left: 0;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  will-change: transform;
  z-index: 0;
  z-index: var(--vkui_internal--z_index_tappable_state)
}

.vkuiTappable .vkuiTappable__wave {
  animation: vkuianimation-wave .3s cubic-bezier(.4, 0, .2, 1);
  animation: vkuianimation-wave .3s var(--vkui--animation_easing_platform);
  background: rgba(0, 16, 61, .08);
  background: var(--vkui--color_transparent--active);
  border-radius: 50%;
  content: "";
  height: 24px;
  left: 0;
  margin: -12px 0 0 -12px;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 24px
}

.vkuiTappable--sizeX-compact {
  border-radius: 0
}

@media (max-width:767.9px) {
  .vkuiTappable--sizeX-none {
    border-radius: 0
  }
}

.vkuiTappable.vkuiTappable--borderRadiusInherit {
  border-radius: inherit
}

@keyframes vkuianimation-wave {
  0% {
    opacity: 1;
    transform: scale(1)
  }

  30% {
    opacity: 1
  }

  to {
    opacity: 0;
    transform: scale(8)
  }
}

.vkuiFocusVisible {
  border-radius: inherit;
  bottom: 0;
  bottom: var(--vkui_internal--focus_visible_distance, 0);
  left: 0;
  left: var(--vkui_internal--focus_visible_distance, 0);
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  right: 0;
  right: var(--vkui_internal--focus_visible_distance, 0);
  top: 0;
  top: var(--vkui_internal--focus_visible_distance, 0);
  -webkit-user-select: none;
  user-select: none;
  visibility: hidden
}

.vkuiFocusVisible--visible {
  visibility: visible
}

.vkuiFocusVisible.vkuiFocusVisible {
  position: absolute
}

.vkuiFocusVisible {
  --vkui_internal--focus_visible_thin: 2px
}

.vkuiFocusVisible--thin {
  --vkui_internal--focus_visible_thin: var(--vkui--size_border--regular)
}

.vkuiFocusVisible--mode-inside,
.vkuiFocusVisible--mode-outline {
  border-color: #2688eb;
  border-color: var(--vkui--color_stroke_accent);
  border-style: solid;
  border-width: var(--vkui_internal--focus_visible_thin);
  box-sizing: border-box
}

.vkuiFocusVisible--mode-outline {
  --vkui_internal--focus_visible_distance: 0
}

.vkuiFocusVisible--mode-inside {
  --vkui_internal--focus_visible_distance: 2px
}

.vkuiFocusVisible--mode-outside {
  --vkui_internal--focus_visible_distance: -2px;
  box-shadow: 0 0 0 var(--vkui_internal--focus_visible_thin) #2688eb;
  box-shadow: 0 0 0 var(--vkui_internal--focus_visible_thin) var(--vkui--color_stroke_accent)
}

@media (prefers-reduced-motion:no-preference) {
  .vkuiFocusVisible--visible.vkuiFocusVisible--mode-inside {
    --vkui_internal--focus_visible_distance: 4px;
    animation: vkuianimation-focus-visible .15s ease-in-out forwards;
    animation-delay: .01ms;
    will-change: top, left, bottom, right
  }

  .vkuiFocusVisible--visible.vkuiFocusVisible--mode-outside {
    --vkui_internal--focus_visible_distance: 0;
    animation-name: vkuianimation-focus-visible-outside
  }
}

@keyframes vkuianimation-focus-visible {
  to {
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    will-change: auto
  }
}

@keyframes vkuianimation-focus-visible-outside {
  to {
    bottom: -2px;
    left: -2px;
    right: -2px;
    top: -2px;
    will-change: auto
  }
}

.vkuiFixedLayout {
  box-sizing: border-box;
  left: auto;
  padding-left: 0;
  padding-left: var(--vkui_internal--safe_area_inset_left);
  padding-right: 0;
  padding-right: var(--vkui_internal--safe_area_inset_right);
  position: fixed;
  z-index: 3;
  z-index: var(--vkui_internal--z_index_fixed_layout)
}

.vkuiFixedLayout--filled {
  background: #fff;
  background: var(--vkui--color_background_content)
}

.vkuiFixedLayout--vertical-top {
  top: 0;
  width: 100%
}

.vkuiFixedLayout--vertical-bottom {
  bottom: 0;
  padding-bottom: 0;
  padding-bottom: var(--vkui_internal--safe_area_inset_bottom);
  width: 100%
}

.vkuiInternalEpic--hasTabbar .vkuiFixedLayout--vertical-bottom {
  padding-bottom: calc(48px + 0px);
  padding-bottom: calc(var(--vkui_internal--tabbar_height) + var(--vkui_internal--safe_area_inset_bottom))
}

.vkuiInternalPanelHeader~* .vkuiFixedLayout--vertical-top:not(.vkuiInternalPanelHeader__fixed),
.vkuiInternalPanelHeader~.vkuiFixedLayout--vertical-top {
  top: calc(56px + 0px);
  top: calc(var(--vkui--size_panel_header_height--regular) + var(--vkui_internal--safe_area_inset_top))
}

.vkuiImageBase {
  align-items: center;
  background-color: #f5f5f5;
  background-color: var(--vkui--color_background_secondary);
  background-size: cover;
  box-sizing: border-box;
  color: #99a2ad;
  color: var(--vkui_internal--icon_color, var(--vkui--color_icon_secondary));
  display: flex;
  flex-shrink: 0;
  isolation: isolate;
  justify-content: center;
  position: relative
}

.vkuiImageBase__border {
  border: var(--vkui--size_border--regular) solid var(--vkui--color_image_border_alpha);
  border-radius: inherit;
  box-sizing: border-box;
  pointer-events: none;
  transform-origin: left top;
  z-index: 1;
  z-index: var(--vkui_internal--z_index_image_base_border)
}

.vkuiImageBase__border,
.vkuiImageBase__img {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%
}

.vkuiImageBase__img {
  border: 0;
  border-radius: inherit;
  display: block;
  object-fit: cover;
  visibility: hidden
}

.vkuiImageBase--loaded .vkuiImageBase__img {
  visibility: visible
}

.vkuiImageBase__fallback {
  left: auto;
  position: absolute;
  top: auto
}

.vkuiInternalPanelHeader__before .vkuiImageBase {
  margin-left: 8px
}

.vkuiInternalPanelHeader__after .vkuiImageBase {
  margin-right: 8px
}

.vkuiClickable__host {
  cursor: pointer
}

.vkuiClickable__host:focus,
.vkuiClickable__host:focus-visible {
  outline: none
}

.vkuiImageBaseBadge {
  border-radius: 50%;
  bottom: 0;
  padding: 2px;
  position: absolute;
  right: 0;
  transform: translate(2px, 2px);
  z-index: 2;
  z-index: var(--vkui_internal--z_index_image_base_badge)
}

.vkuiImageBaseBadge--background-stroke {
  background-color: #fff;
  background-color: var(--vkui_internal--background, var(--vkui--color_background_content))
}

.vkuiImageBaseBadge--background-shadow:before {
  border-radius: inherit;
  bottom: 2px;
  box-shadow: 0 0 2px rgba(0, 0, 0, .03), 0 2px 2px rgba(0, 0, 0, .06);
  box-shadow: var(--vkui--elevation1);
  content: "";
  left: 2px;
  margin: auto;
  position: absolute;
  right: 2px;
  top: 2px
}

.vkuiImageBaseOverlay {
  align-items: center;
  border: 0;
  border-radius: inherit;
  box-shadow: inherit;
  box-sizing: border-box;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  transition: opacity .3s ease-in-out;
  width: 100%;
  z-index: 0;
  z-index: var(--vkui_internal--z_index_image_base_overlay)
}

.vkuiImageBaseOverlay--visible {
  opacity: 1
}

.vkuiImageBaseOverlay--focus-visible {
  box-shadow: inset 0 0 0 2px #2688eb;
  box-shadow: inset 0 0 0 2px var(--vkui--color_stroke_accent);
  opacity: 1
}

.vkuiImageBaseOverlay--theme-light {
  background-color: hsla(0, 0%, 100%, .85);
  background-color: var(--vkui--color_avatar_overlay_inverse_alpha);
  color: #2688eb;
  color: var(--vkui--color_icon_accent)
}

.vkuiImageBaseOverlay--theme-dark {
  background-color: rgba(0, 0, 0, .6);
  background-color: var(--vkui--color_avatar_overlay);
  color: #fff;
  color: var(--vkui--color_icon_contrast)
}

.vkuiSpinner {
  align-items: center;
  color: #818c99;
  color: var(--vkui--color_icon_medium);
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%
}

.vkuiInternalPanelHeader .vkuiSpinner {
  color: currentColor
}

.vkuiButton {
  border: 0;
  border-radius: 8px;
  border-radius: var(--vkui--size_border_radius--regular);
  box-sizing: border-box;
  display: inline-block;
  margin: 0;
  max-width: 100%;
  min-height: 28px;
  min-height: var(--vkui--size_button_small_height--compact);
  min-width: 80px;
  min-width: var(--vkui--size_button_minimum_width--regular);
  padding: 0;
  position: relative;
  text-decoration: none;
  -webkit-user-select: none;
  user-select: none
}

.vkuiButton--rounded {
  border-radius: 48px;
  border-radius: var(--vkui--size_border_radius_rounded--regular)
}

.vkuiButton--loading {
  cursor: progress
}

.vkuiButton--singleIcon {
  min-width: auto;
  width: 28px;
  width: var(--vkui--size_button_small_height--compact)
}

.vkuiButton--sizeY-regular.vkuiButton--singleIcon {
  width: 30px;
  width: var(--vkui--size_button_small_height--regular)
}

@media (max-width:767.9px) and (min-height:415px),
(pointer:coarse) and (min-height:415px),
(pointer:none) and (min-height:415px) {
  .vkuiButton--sizeY-none.vkuiButton--singleIcon {
    width: 30px;
    width: var(--vkui--size_button_small_height--regular)
  }
}

.vkuiButton--stretched {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  width: 100%
}

.vkuiButton__in {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  min-height: inherit;
  text-align: center;
  width: 100%
}

.vkuiButton--align-left .vkuiButton__in {
  justify-content: flex-start;
  text-align: left
}

.vkuiButton--align-right .vkuiButton__in {
  justify-content: flex-end;
  text-align: right
}

.vkuiButton[disabled] {
  opacity: .4;
  opacity: var(--vkui--opacity_disable)
}

.vkuiButton--mode-outline[disabled]:not(.vkuiButton--appearance-overlay),
.vkuiButton--mode-primary[disabled]:not(.vkuiButton--appearance-overlay):not(.vkuiButton--appearance-negative):not(.vkuiButton--appearance-positive),
.vkuiButton--mode-secondary[disabled]:not(.vkuiButton--appearance-overlay),
.vkuiButton--mode-tertiary[disabled]:not(.vkuiButton--appearance-overlay) {
  opacity: .64
}

.vkuiButton__content {
  font-weight: 500;
  font-weight: var(--vkui--font_weight_accent2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

.vkuiButton--size-s .vkuiButton__content:first-child {
  padding-left: 16px;
  padding-left: var(--vkui--size_button_base_small_padding_horizontal--regular)
}

.vkuiButton--size-s .vkuiButton__after,
.vkuiButton--size-s .vkuiButton__content:last-child {
  padding-right: 16px;
  padding-right: var(--vkui--size_button_base_small_padding_horizontal--regular)
}

.vkuiButton--size-m .vkuiButton__content:first-child {
  padding-left: 16px;
  padding-left: var(--vkui--size_button_base_medium_padding_horizontal--regular)
}

.vkuiButton--size-m .vkuiButton__after,
.vkuiButton--size-m .vkuiButton__content:last-child {
  padding-right: 16px;
  padding-right: var(--vkui--size_button_base_medium_padding_horizontal--regular)
}

.vkuiButton--size-l .vkuiButton__content:first-child {
  padding-left: 20px;
  padding-left: var(--vkui--size_button_base_large_padding_horizontal--regular)
}

.vkuiButton--size-l .vkuiButton__after,
.vkuiButton--size-l .vkuiButton__content:last-child {
  padding-right: 20px;
  padding-right: var(--vkui--size_button_base_large_padding_horizontal--regular)
}

.vkuiButton--size-s .vkuiButton__before {
  padding-left: 12px;
  padding-left: var(--vkui--size_button_base_small_padding_horizontal_icon--regular)
}

.vkuiButton--size-m .vkuiButton__before {
  padding-left: 12px;
  padding-left: var(--vkui--size_button_base_medium_padding_horizontal_icon--regular)
}

.vkuiButton--size-l .vkuiButton__before {
  padding-left: 16px;
  padding-left: var(--vkui--size_button_base_large_padding_horizontal_icon--regular)
}

.vkuiButton--mode-tertiary.vkuiButton--size-s .vkuiButton__content:first-child {
  padding-left: 12px;
  padding-left: var(--vkui--size_button_tertiary_small_padding_horizontal--regular)
}

.vkuiButton--mode-tertiary.vkuiButton--size-s .vkuiButton__after,
.vkuiButton--mode-tertiary.vkuiButton--size-s .vkuiButton__content:last-child {
  padding-right: 12px;
  padding-right: var(--vkui--size_button_tertiary_small_padding_horizontal--regular)
}

.vkuiButton--mode-tertiary.vkuiButton--size-m .vkuiButton__content:first-child {
  padding-left: 12px;
  padding-left: var(--vkui--size_button_tertiary_medium_padding_horizontal--regular)
}

.vkuiButton--mode-tertiary.vkuiButton--size-m .vkuiButton__after,
.vkuiButton--mode-tertiary.vkuiButton--size-m .vkuiButton__content:last-child {
  padding-right: 12px;
  padding-right: var(--vkui--size_button_tertiary_medium_padding_horizontal--regular)
}

.vkuiButton--mode-tertiary.vkuiButton--size-l .vkuiButton__content:first-child {
  padding-left: 16px;
  padding-left: var(--vkui--size_button_tertiary_large_padding_horizontal--regular)
}

.vkuiButton--mode-tertiary.vkuiButton--size-l .vkuiButton__after,
.vkuiButton--mode-tertiary.vkuiButton--size-l .vkuiButton__content:last-child {
  padding-right: 16px;
  padding-right: var(--vkui--size_button_tertiary_large_padding_horizontal--regular)
}

.vkuiButton--mode-tertiary.vkuiButton--size-s .vkuiButton__before {
  padding-left: 8px;
  padding-left: var(--vkui--size_button_tertiary_small_padding_horizontal_icon--regular)
}

.vkuiButton--mode-tertiary.vkuiButton--size-m .vkuiButton__before {
  padding-left: 8px;
  padding-left: var(--vkui--size_button_tertiary_medium_padding_horizontal_icon--regular)
}

.vkuiButton--mode-tertiary.vkuiButton--size-l .vkuiButton__before {
  padding-left: 12px;
  padding-left: var(--vkui--size_button_tertiary_large_padding_horizontal_icon--regular)
}

.vkuiButton--mode-tertiary.vkuiButton--singleIcon .vkuiButton__after,
.vkuiButton--mode-tertiary.vkuiButton--singleIcon .vkuiButton__before,
.vkuiButton--singleIcon .vkuiButton__after,
.vkuiButton--singleIcon .vkuiButton__before {
  margin-left: auto;
  margin-right: auto;
  padding-left: 0;
  padding-right: 0
}

.vkuiButton--mode-link {
  background: none;
  min-width: auto
}

.vkuiButton--mode-link .vkuiButton__after,
.vkuiButton--mode-link .vkuiButton__before,
.vkuiButton--mode-link .vkuiButton__content:first-child,
.vkuiButton--mode-link .vkuiButton__content:last-child,
.vkuiButton--stretched .vkuiButton__after:only-child,
.vkuiButton--stretched .vkuiButton__before:only-child {
  padding-left: 0;
  padding-right: 0
}

.vkuiButton__spinner {
  bottom: 0;
  color: currentColor;
  left: 0;
  position: absolute;
  right: 0;
  top: 0
}

.vkuiButton__spinner+.vkuiButton__in {
  visibility: hidden
}

.vkuiButton--mode-primary.vkuiButton--appearance-accent {
  background-color: #2688eb;
  background-color: var(--vkui--color_background_accent_themed)
}

.vkuiButton--mode-primary.vkuiButton--appearance-accent.vkuiButton--hover {
  background-color: #2483e4;
  background-color: var(--vkui--color_background_accent_themed--hover)
}

.vkuiButton--mode-primary.vkuiButton--appearance-accent.vkuiButton--active {
  background-color: #237edd;
  background-color: var(--vkui--color_background_accent_themed--active)
}

.vkuiButton--mode-primary.vkuiButton--appearance-positive {
  background-color: #4bb34b;
  background-color: var(--vkui--color_background_positive)
}

.vkuiButton--mode-primary.vkuiButton--appearance-positive.vkuiButton--hover {
  background-color: #48ac4a;
  background-color: var(--vkui--color_background_positive--hover)
}

.vkuiButton--mode-primary.vkuiButton--appearance-positive.vkuiButton--active {
  background-color: #45a64a;
  background-color: var(--vkui--color_background_positive--active)
}

.vkuiButton--mode-primary.vkuiButton--appearance-negative {
  background-color: #e64646;
  background-color: var(--vkui--color_background_negative)
}

.vkuiButton--mode-primary.vkuiButton--appearance-negative.vkuiButton--hover {
  background-color: #dd4446;
  background-color: var(--vkui--color_background_negative--hover)
}

.vkuiButton--mode-primary.vkuiButton--appearance-negative.vkuiButton--active {
  background-color: #d44245;
  background-color: var(--vkui--color_background_negative--active)
}

.vkuiButton--mode-primary.vkuiButton--appearance-neutral {
  background-color: #f5f5f5;
  background-color: var(--vkui--color_background_secondary)
}

.vkuiButton--mode-primary.vkuiButton--appearance-neutral.vkuiButton--hover {
  background-color: #ebecee;
  background-color: var(--vkui--color_background_secondary--hover)
}

.vkuiButton--mode-primary.vkuiButton--appearance-neutral.vkuiButton--active {
  background-color: #e1e3e6;
  background-color: var(--vkui--color_background_secondary--active)
}

.vkuiButton--mode-primary.vkuiButton--appearance-accent-invariable {
  background-color: #2688eb;
  background-color: var(--vkui--color_background_accent)
}

.vkuiButton--mode-primary.vkuiButton--appearance-accent-invariable.vkuiButton--hover {
  background-color: #2483e4;
  background-color: var(--vkui--color_background_accent--hover)
}

.vkuiButton--mode-primary.vkuiButton--appearance-accent-invariable.vkuiButton--active {
  background-color: #237edd;
  background-color: var(--vkui--color_background_accent--active)
}

.vkuiButton--mode-secondary {
  background-color: rgba(0, 0, 0, .04);
  background-color: var(--vkui--color_background_secondary_alpha)
}

.vkuiButton--mode-secondary.vkuiButton--hover {
  background-color: rgba(0, 0, 0, .08);
  background-color: var(--vkui--color_background_secondary_alpha--hover)
}

.vkuiButton--mode-secondary.vkuiButton--active {
  background-color: rgba(0, 0, 0, .12);
  background-color: var(--vkui--color_background_secondary_alpha--active)
}

.vkuiButton--mode-outline,
.vkuiButton--mode-tertiary {
  background-color: initial;
  background-color: var(--vkui--color_transparent)
}

.vkuiButton--mode-outline.vkuiButton--hover,
.vkuiButton--mode-tertiary.vkuiButton--hover {
  background-color: rgba(0, 16, 61, .04);
  background-color: var(--vkui--color_transparent--hover)
}

.vkuiButton--mode-outline.vkuiButton--active,
.vkuiButton--mode-tertiary.vkuiButton--active {
  background-color: rgba(0, 16, 61, .08);
  background-color: var(--vkui--color_transparent--active)
}

.vkuiButton.vkuiButton--appearance-accent {
  color: #2688eb;
  color: var(--vkui--color_text_accent_themed)
}

.vkuiButton.vkuiButton--appearance-positive {
  color: #4bb34b;
  color: var(--vkui--color_text_positive)
}

.vkuiButton.vkuiButton--appearance-negative {
  color: #e64646;
  color: var(--vkui--color_text_negative)
}

.vkuiButton.vkuiButton--appearance-neutral {
  color: #000;
  color: var(--vkui--color_text_primary)
}

.vkuiButton.vkuiButton--appearance-accent-invariable {
  color: #2688eb;
  color: var(--vkui--color_text_accent)
}

.vkuiButton--mode-primary.vkuiButton--appearance-accent {
  color: #fff;
  color: var(--vkui--color_text_contrast_themed)
}

.vkuiButton--mode-primary.vkuiButton--appearance-accent-invariable,
.vkuiButton--mode-primary.vkuiButton--appearance-negative,
.vkuiButton--mode-primary.vkuiButton--appearance-positive {
  color: #fff;
  color: var(--vkui--color_text_contrast)
}

.vkuiButton--mode-link.vkuiButton--hover {
  opacity: .8
}

.vkuiButton--mode-link.vkuiButton--active {
  opacity: .7
}

.vkuiButton--mode-outline.vkuiButton--appearance-accent,
.vkuiButton--mode-outline.vkuiButton--appearance-accent.vkuiButton--active,
.vkuiButton--mode-outline.vkuiButton--appearance-accent.vkuiButton--hover {
  box-shadow: inset 0 0 0 1px #2688eb;
  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_accent_themed)
}

.vkuiButton--mode-outline.vkuiButton--appearance-positive {
  box-shadow: inset 0 0 0 1px #4bb34b;
  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_positive)
}

.vkuiButton--mode-outline.vkuiButton--appearance-positive.vkuiButton--hover {
  box-shadow: inset 0 0 0 1px #48ac4a;
  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_positive--hover)
}

.vkuiButton--mode-outline.vkuiButton--appearance-positive.vkuiButton--active {
  box-shadow: inset 0 0 0 1px #45a64a;
  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_positive--active)
}

.vkuiButton--mode-outline.vkuiButton--appearance-negative {
  box-shadow: inset 0 0 0 1px #e64646;
  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_negative)
}

.vkuiButton--mode-outline.vkuiButton--appearance-negative.vkuiButton--hover {
  box-shadow: inset 0 0 0 1px #dd4446;
  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_negative--hover)
}

.vkuiButton--mode-outline.vkuiButton--appearance-negative.vkuiButton--active {
  box-shadow: inset 0 0 0 1px #d44245;
  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_negative--active)
}

.vkuiButton--mode-outline.vkuiButton--appearance-neutral {
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .12);
  box-shadow: inset 0 0 0 1px var(--vkui--color_field_border_alpha)
}

.vkuiButton--mode-outline.vkuiButton--appearance-neutral.vkuiButton--hover {
  background-color: #ebecee;
  background-color: var(--vkui--color_background_secondary--hover);
  box-shadow: unset
}

.vkuiButton--mode-outline.vkuiButton--appearance-neutral.vkuiButton--active {
  background-color: #e1e3e6;
  background-color: var(--vkui--color_background_secondary--active);
  box-shadow: unset
}

.vkuiButton--mode-outline.vkuiButton--appearance-accent-invariable {
  box-shadow: inset 0 0 0 1px #2688eb;
  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_accent)
}

.vkuiButton--mode-primary.vkuiButton--appearance-overlay {
  background-color: #fff;
  background-color: var(--vkui--color_background_contrast)
}

.vkuiButton--mode-primary.vkuiButton--appearance-overlay.vkuiButton--hover {
  background-color: #f5f5f7;
  background-color: var(--vkui--color_background_contrast--hover)
}

.vkuiButton--mode-primary.vkuiButton--appearance-overlay.vkuiButton--active {
  background-color: #ebecef;
  background-color: var(--vkui--color_background_contrast--active)
}

.vkuiButton--mode-secondary.vkuiButton--appearance-overlay {
  background-color: hsla(0, 0%, 100%, .2);
  background-color: var(--vkui--color_background_contrast_secondary_alpha)
}

.vkuiButton--mode-outline.vkuiButton--appearance-overlay.vkuiButton--hover,
.vkuiButton--mode-secondary.vkuiButton--appearance-overlay.vkuiButton--hover,
.vkuiButton--mode-tertiary.vkuiButton--appearance-overlay.vkuiButton--hover {
  background-color: hsla(0, 0%, 100%, .24);
  background-color: var(--vkui--color_background_contrast_secondary_alpha--hover)
}

.vkuiButton--mode-outline.vkuiButton--appearance-overlay.vkuiButton--active,
.vkuiButton--mode-secondary.vkuiButton--appearance-overlay.vkuiButton--active,
.vkuiButton--mode-tertiary.vkuiButton--appearance-overlay.vkuiButton--active {
  background-color: hsla(0, 0%, 100%, .28);
  background-color: var(--vkui--color_background_contrast_secondary_alpha--active)
}

.vkuiButton--mode-primary.vkuiButton--appearance-overlay {
  color: #000;
  color: var(--vkui--color_text_primary_invariably)
}

.vkuiButton--mode-primary.vkuiButton--appearance-overlay.vkuiButton--hover {
  color: #000102;
  color: var(--vkui--color_text_primary_invariably--hover)
}

.vkuiButton--mode-primary.vkuiButton--appearance-overlay.vkuiButton--active {
  color: #000105;
  color: var(--vkui--color_text_primary_invariably--active)
}

.vkuiButton--mode-link.vkuiButton--appearance-overlay,
.vkuiButton--mode-outline.vkuiButton--appearance-overlay,
.vkuiButton--mode-secondary.vkuiButton--appearance-overlay,
.vkuiButton--mode-tertiary.vkuiButton--appearance-overlay {
  color: #fff;
  color: var(--vkui--color_text_contrast)
}

.vkuiButton--mode-outline.vkuiButton--appearance-overlay {
  box-shadow: inset 0 0 0 1px #fff;
  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_contrast)
}

.vkuiButton--mode-outline.vkuiButton--appearance-overlay.vkuiButton--hover {
  box-shadow: inset 0 0 0 1px #f5f5f7;
  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_contrast--hover)
}

.vkuiButton--mode-outline.vkuiButton--appearance-overlay.vkuiButton--active {
  box-shadow: inset 0 0 0 1px #ebecef;
  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_contrast--active)
}

.vkuiButton__after:not(:first-child),
.vkuiButton__before:not(:last-child)+.vkuiButton__content {
  margin-left: 6px
}

.vkuiButton--size-l .vkuiButton__after:not(:first-child),
.vkuiButton--size-l .vkuiButton__before:not(:last-child)+.vkuiButton__content {
  margin-left: 8px
}

.vkuiButton--size-s .vkuiButton__content {
  font-size: 13px;
  font-size: var(--vkui--font_subhead--font_size--compact);
  line-height: 16px;
  line-height: var(--vkui--font_subhead--line_height--compact)
}

.vkuiButton--size-s .vkuiButton__content,
.vkuiButton--sizeY-regular.vkuiButton--size-s .vkuiButton__content {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_subhead--font_family--regular)
}

.vkuiButton--sizeY-regular.vkuiButton--size-s .vkuiButton__content {
  font-size: 14px;
  font-size: var(--vkui--font_subhead--font_size--regular);
  line-height: 18px;
  line-height: var(--vkui--font_subhead--line_height--regular)
}

@media (max-width:767.9px) and (min-height:415px),
(pointer:coarse) and (min-height:415px),
(pointer:none) and (min-height:415px) {
  .vkuiButton--sizeY-none.vkuiButton--size-s .vkuiButton__content {
    font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
    font-family: var(--vkui--font_subhead--font_family--regular);
    font-size: 14px;
    font-size: var(--vkui--font_subhead--font_size--regular);
    line-height: 18px;
    line-height: var(--vkui--font_subhead--line_height--regular)
  }
}

.vkuiButton--size-m .vkuiButton__content {
  font-size: 14px;
  font-size: var(--vkui--font_headline2--font_size--compact);
  line-height: 20px;
  line-height: var(--vkui--font_headline2--line_height--compact)
}

.vkuiButton--size-m .vkuiButton__content,
.vkuiButton--sizeY-regular.vkuiButton--size-m .vkuiButton__content {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_headline2--font_family--regular)
}

.vkuiButton--sizeY-regular.vkuiButton--size-m .vkuiButton__content {
  font-size: 15px;
  font-size: var(--vkui--font_headline2--font_size--regular);
  line-height: 20px;
  line-height: var(--vkui--font_headline2--line_height--regular)
}

@media (max-width:767.9px) and (min-height:415px),
(pointer:coarse) and (min-height:415px),
(pointer:none) and (min-height:415px) {
  .vkuiButton--sizeY-none.vkuiButton--size-m .vkuiButton__content {
    font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
    font-family: var(--vkui--font_headline2--font_family--regular);
    font-size: 15px;
    font-size: var(--vkui--font_headline2--font_size--regular);
    line-height: 20px;
    line-height: var(--vkui--font_headline2--line_height--regular)
  }
}

.vkuiButton--size-l .vkuiButton__content {
  font-size: 15px;
  font-size: var(--vkui--font_headline1--font_size--compact);
  line-height: 20px;
  line-height: var(--vkui--font_headline1--line_height--compact)
}

.vkuiButton--size-l .vkuiButton__content,
.vkuiButton--sizeY-regular.vkuiButton--size-l .vkuiButton__content {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_headline1--font_family--regular)
}

.vkuiButton--sizeY-regular.vkuiButton--size-l .vkuiButton__content {
  font-size: 16px;
  font-size: var(--vkui--font_headline1--font_size--regular);
  line-height: 20px;
  line-height: var(--vkui--font_headline1--line_height--regular)
}

@media (max-width:767.9px) and (min-height:415px),
(pointer:coarse) and (min-height:415px),
(pointer:none) and (min-height:415px) {
  .vkuiButton--sizeY-none.vkuiButton--size-l .vkuiButton__content {
    font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
    font-family: var(--vkui--font_headline1--font_family--regular);
    font-size: 16px;
    font-size: var(--vkui--font_headline1--font_size--regular);
    line-height: 20px;
    line-height: var(--vkui--font_headline1--line_height--regular)
  }
}

.vkuiButton--sizeY-regular.vkuiButton--size-l.vkuiButton--ios .vkuiButton__content {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_title3--font_family--regular);
  font-size: 17px;
  font-size: var(--vkui--font_title3--font_size--regular);
  line-height: 22px;
  line-height: var(--vkui--font_title3--line_height--regular)
}

@media (max-width:767.9px) and (min-height:415px),
(pointer:coarse) and (min-height:415px),
(pointer:none) and (min-height:415px) {
  .vkuiButton--sizeY-none.vkuiButton--size-l.vkuiButton--ios .vkuiButton__content {
    font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
    font-family: var(--vkui--font_title3--font_family--regular);
    font-size: 17px;
    font-size: var(--vkui--font_title3--font_size--regular);
    line-height: 22px;
    line-height: var(--vkui--font_title3--line_height--regular)
  }
}

.vkuiButton--size-m {
  min-height: 32px;
  min-height: var(--vkui--size_button_medium_height--compact)
}

.vkuiButton--sizeY-regular.vkuiButton--size-m {
  min-height: 36px;
  min-height: var(--vkui--size_button_medium_height--regular)
}

@media (max-width:767.9px) and (min-height:415px),
(pointer:coarse) and (min-height:415px),
(pointer:none) and (min-height:415px) {
  .vkuiButton--sizeY-none.vkuiButton--size-m {
    min-height: 36px;
    min-height: var(--vkui--size_button_medium_height--regular)
  }
}

.vkuiButton--size-m.vkuiButton--singleIcon {
  width: 32px;
  width: var(--vkui--size_button_medium_height--compact)
}

.vkuiButton--sizeY-regular.vkuiButton--size-m.vkuiButton--singleIcon {
  width: 36px;
  width: var(--vkui--size_button_medium_height--regular)
}

@media (max-width:767.9px) and (min-height:415px),
(pointer:coarse) and (min-height:415px),
(pointer:none) and (min-height:415px) {
  .vkuiButton--sizeY-none.vkuiButton--size-m.vkuiButton--singleIcon {
    width: 36px;
    width: var(--vkui--size_button_medium_height--regular)
  }
}

.vkuiButton--size-l {
  min-height: 36px;
  min-height: var(--vkui--size_button_large_height--compact)
}

.vkuiButton--sizeY-regular.vkuiButton--size-l {
  min-height: 44px;
  min-height: var(--vkui--size_button_large_height--regular)
}

@media (max-width:767.9px) and (min-height:415px),
(pointer:coarse) and (min-height:415px),
(pointer:none) and (min-height:415px) {
  .vkuiButton--sizeY-none.vkuiButton--size-l {
    min-height: 44px;
    min-height: var(--vkui--size_button_large_height--regular)
  }
}

.vkuiButton--size-l.vkuiButton--singleIcon {
  width: 36px;
  width: var(--vkui--size_button_large_height--compact)
}

.vkuiButton--sizeY-regular.vkuiButton--size-l.vkuiButton--singleIcon {
  width: 44px;
  width: var(--vkui--size_button_large_height--regular)
}

@media (max-width:767.9px) and (min-height:415px),
(pointer:coarse) and (min-height:415px),
(pointer:none) and (min-height:415px) {
  .vkuiButton--sizeY-none.vkuiButton--size-l.vkuiButton--singleIcon {
    width: 44px;
    width: var(--vkui--size_button_large_height--regular)
  }
}

.vkuiButton--sizeY-regular {
  min-height: 30px;
  min-height: var(--vkui--size_button_small_height--regular)
}

@media (max-width:767.9px) and (min-height:415px),
(pointer:coarse) and (min-height:415px),
(pointer:none) and (min-height:415px) {
  .vkuiButton--sizeY-none {
    min-height: 30px;
    min-height: var(--vkui--size_button_small_height--regular)
  }
}

.vkuiButton--mode-primary.vkuiButton--appearance-accent {
  --vkui_internal--counter_inherit_background: var(--vkui--color_background_content);
  --vkui_internal--counter_inherit_color: var(--vkui--color_text_accent_themed)
}

.vkuiButton--mode-outline.vkuiButton--appearance-accent,
.vkuiButton--mode-secondary.vkuiButton--appearance-accent,
.vkuiButton--mode-tertiary.vkuiButton--appearance-accent {
  --vkui_internal--counter_inherit_background: var(--vkui--color_background_accent_themed);
  --vkui_internal--counter_inherit_color: var(--vkui--color_text_contrast_themed)
}

.vkuiButton--mode-primary.vkuiButton--appearance-positive {
  --vkui_internal--counter_inherit_background: var(--vkui--color_background_contrast);
  --vkui_internal--counter_inherit_color: var(--vkui--color_text_positive)
}

.vkuiButton--mode-outline.vkuiButton--appearance-positive,
.vkuiButton--mode-secondary.vkuiButton--appearance-positive,
.vkuiButton--mode-tertiary.vkuiButton--appearance-positive {
  --vkui_internal--counter_inherit_background: var(--vkui--color_background_positive);
  --vkui_internal--counter_inherit_color: var(--vkui--color_text_contrast)
}

.vkuiButton--mode-primary.vkuiButton--appearance-negative {
  --vkui_internal--counter_inherit_background: var(--vkui--color_background_contrast);
  --vkui_internal--counter_inherit_color: var(--vkui--color_text_negative)
}

.vkuiButton--mode-outline.vkuiButton--appearance-negative,
.vkuiButton--mode-secondary.vkuiButton--appearance-negative,
.vkuiButton--mode-tertiary.vkuiButton--appearance-negative {
  --vkui_internal--counter_inherit_background: var(--vkui--color_background_negative);
  --vkui_internal--counter_inherit_color: var(--vkui--color_text_contrast)
}

.vkuiButton--mode-primary.vkuiButton--appearance-neutral {
  --vkui_internal--counter_inherit_background: var(--vkui--color_background_contrast);
  --vkui_internal--counter_inherit_color: var(--vkui--color_text_primary_invariably)
}

.vkuiButton--mode-outline.vkuiButton--appearance-neutral,
.vkuiButton--mode-secondary.vkuiButton--appearance-neutral,
.vkuiButton--mode-tertiary.vkuiButton--appearance-neutral {
  --vkui_internal--counter_inherit_background: var(--vkui--color_background_accent);
  --vkui_internal--counter_inherit_color: var(--vkui--color_text_contrast)
}

.vkuiButton--mode-primary.vkuiButton--appearance-overlay {
  --vkui_internal--counter_inherit_background: var(--vkui--color_icon_primary_invariably);
  --vkui_internal--counter_inherit_color: var(--vkui--color_text_contrast)
}

.vkuiButton--mode-outline.vkuiButton--appearance-overlay,
.vkuiButton--mode-secondary.vkuiButton--appearance-overlay,
.vkuiButton--mode-tertiary.vkuiButton--appearance-overlay {
  --vkui_internal--counter_inherit_background: var(--vkui--color_background_contrast);
  --vkui_internal--counter_inherit_color: var(--vkui--color_text_primary_invariably)
}

.vkuiVisuallyHidden {
  clip: rect(0, 0, 0, 0) !important;
  border: 0 !important;
  clip-path: inset(50%);
  height: 1px !important;
  margin: -1px !important;
  opacity: 0;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  white-space: nowrap !important;
  width: 1px !important
}

.vkuiIconButton {
  appearance: none;
  background: none;
  border: 0;
  border-radius: 9999px;
  box-shadow: none;
  color: currentColor;
  display: block;
  height: 48px;
  margin: 0;
  padding: 0;
  position: relative
}

.vkuiIconButton--sizeY-compact {
  height: 44px
}

.vkuiIconButton[disabled] {
  opacity: .64;
  opacity: var(--vkui--opacity_disable_accessibility)
}

.vkuiIconButton--ios {
  border-radius: 8px;
  border-radius: var(--vkui--size_border_radius--regular)
}

.vkuiIconButton .vkuiIcon--16 {
  padding: 16px
}

.vkuiIconButton .vkuiIcon--16.vkuiIcon--w-8 {
  padding: 16px 14px
}

.vkuiIconButton--sizeY-compact .vkuiIcon--16,
.vkuiIconButton--sizeY-compact .vkuiIcon--16.vkuiIcon--w-8 {
  padding: 14px
}

.vkuiIconButton .vkuiIcon--24 {
  padding: 12px
}

.vkuiIconButton .vkuiIcon--28,
.vkuiIconButton--sizeY-compact .vkuiIcon--24 {
  padding: 10px
}

.vkuiIconButton--sizeY-compact .vkuiIcon--28 {
  padding: 8px
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiIconButton--sizeY-none {
    height: 44px
  }

  .vkuiIconButton--sizeY-none .vkuiIcon--16,
  .vkuiIconButton--sizeY-none .vkuiIcon--16.vkuiIcon--w-8 {
    padding: 14px
  }

  .vkuiIconButton--sizeY-none .vkuiIcon--24 {
    padding: 10px
  }

  .vkuiIconButton--sizeY-none .vkuiIcon--28 {
    padding: 8px
  }
}

.vkuiInternalFormField__after .vkuiIconButton,
.vkuiInternalFormItem--removable .vkuiInternalRemovable__content>.vkuiIconButton,
.vkuiInternalFormLayoutGroup--removable .vkuiInternalRemovable__content>.vkuiIconButton {
  align-content: center;
  align-items: center;
  border-radius: 8px;
  border-radius: var(--vkui--size_border_radius--regular);
  display: flex;
  height: 44px;
  height: var(--vkui--size_field_height--regular);
  justify-content: center;
  width: 44px;
  width: var(--vkui--size_field_height--regular)
}

.vkuiInternalFormField__after .vkuiIconButton .vkuiIcon.vkuiIcon.vkuiIcon {
  padding: 0
}

.vkuiInternalFormField__after .vkuiIconButton--sizeY-compact {
  height: 36px;
  height: var(--vkui--size_field_height--compact);
  width: 36px;
  width: var(--vkui--size_field_height--compact)
}

.vkuiInternalFormItem--removable .vkuiInternalRemovable__content>.vkuiIconButton--sizeY-compact,
.vkuiInternalFormLayoutGroup--removable .vkuiInternalRemovable__content>.vkuiIconButton--sizeY-compact {
  height: 36px;
  height: var(--vkui--size_field_height--compact)
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiInternalFormField__after .vkuiIconButton--sizeY-none {
    width: 36px;
    width: var(--vkui--size_field_height--compact)
  }

  .vkuiInternalFormField__after .vkuiIconButton--sizeY-none,
  .vkuiInternalFormItem--removable .vkuiInternalRemovable__content>.vkuiIconButton--sizeY-none,
  .vkuiInternalFormLayoutGroup--removable .vkuiInternalRemovable__content>.vkuiIconButton--sizeY-none {
    height: 36px;
    height: var(--vkui--size_field_height--compact)
  }
}

.vkuiInternalSimpleCell__after .vkuiIconButton:last-child {
  margin-right: -12px
}

.vkuiInternalSimpleCell__after .vkuiIconButton--ios:last-child {
  margin-right: -9px
}

.vkuiInternalAlert__dismiss.vkuiIconButton {
  height: 36px;
  padding: 8px
}

.vkuiRoot {
  height: 100%;
  position: relative;
  width: 100%
}

.vkuiRoot--transition {
  pointer-events: auto
}

.vkuiRoot__view {
  height: 100%;
  position: relative;
  width: 100%
}

.vkuiRoot--transition .vkuiRoot__view {
  left: 0;
  position: fixed;
  top: 0
}

.vkuiRoot__scrollCompensation {
  height: 100%;
  width: 100%
}

.vkuiRoot__view--show-forward {
  animation: vkuiroot-android-animation-show-forward .6s cubic-bezier(.4, 0, .2, 1);
  animation: vkuiroot-android-animation-show-forward .6s var(--vkui--animation_easing_platform)
}

.vkuiRoot__view--hide-back {
  animation: vkuiroot-android-animation-hide-back .6s cubic-bezier(.4, 0, .2, 1) forwards;
  animation: vkuiroot-android-animation-hide-back .6s var(--vkui--animation_easing_platform) forwards
}

.vkuiRoot--ios .vkuiRoot__view--hide-forward:after,
.vkuiRoot--ios .vkuiRoot__view--show-back:after {
  background-color: #000;
  content: "";
  display: block;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%
}

.vkuiRoot--ios .vkuiRoot__view--show-back:after {
  animation: vkuiroot-ios-animation-show-back .5s cubic-bezier(.32, .72, 0, 1) forwards;
  animation: vkuiroot-ios-animation-show-back .5s var(--vkui--animation_easing_platform) forwards
}

.vkuiRoot--ios .vkuiRoot__view--hide-forward:after {
  animation: vkuiroot-ios-animation-hide-forward .5s cubic-bezier(.32, .72, 0, 1);
  animation: vkuiroot-ios-animation-hide-forward .5s var(--vkui--animation_easing_platform);
}

.vkuiRoot--ios .vkuiRoot__view--show-forward {
  animation: vkuianimation-ios-next-forward .5s cubic-bezier(.32, .72, 0, 1);
  animation: vkuianimation-ios-next-forward .5s var(--vkui--animation_easing_platform)
}

.vkuiRoot--ios .vkuiRoot__view--hide-back {
  animation: vkuianimation-ios-prev-back .5s cubic-bezier(.32, .72, 0, 1) forwards;
  animation: vkuianimation-ios-prev-back .5s var(--vkui--animation_easing_platform) forwards
}

@keyframes vkuiroot-ios-animation-show-back {
  0% {
    opacity: .9
  }

  to {
    opacity: 0
  }
}

@keyframes vkuiroot-ios-animation-hide-forward {
  0% {
    opacity: 0
  }

  to {
    opacity: .9
  }
}

@keyframes vkuiroot-ios-animation-hide-back {
  0% {
    transform: translateZ(0)
  }

  to {
    transform: translate3d(0, 100%, 0)
  }
}

@keyframes vkuiroot-ios-animation-show-forward {
  0% {
    transform: translate3d(0, 100%, 0)
  }

  to {
    transform: translateZ(0)
  }
}

@keyframes vkuiroot-android-animation-hide-back {
  0% {
    opacity: 1;
    transform: scale(1)
  }

  to {
    opacity: 0;
    transform: scale(1.05)
  }
}

@keyframes vkuiroot-android-animation-show-forward {
  0% {
    opacity: 0;
    transform: scale(1.05)
  }

  to {
    opacity: 1;
    transform: scale(1)
  }
}

.vkuiView {
  word-wrap: break-word;
  height: 100%;
  position: relative;
  width: 100%
}

.vkuiView--animated,
.vkuiView--swiping-back {
  overflow: hidden
}

.vkuiView--animated .vkuiView__header,
.vkuiView--animated .vkuiView__panel,
.vkuiView--swiping-back .vkuiView__header,
.vkuiView--swiping-back .vkuiView__panel {
  pointer-events: auto
}

.vkuiView__panel,
.vkuiView__panels {
  height: 100%;
  width: 100%
}

.vkuiView__panel {
  box-sizing: border-box;
  isolation: isolate;
  position: relative
}

.vkuiView__panel-in {
  height: 100%
}

.vkuiView--animated .vkuiView__panel,
.vkuiView--swiping-back .vkuiView__panel {
  left: 0;
  overflow: hidden;
  position: fixed;
  top: 0
}

.vkuiView__panel-overlay {
  background-color: #000;
  display: none;
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 5;
  z-index: var(--vkui_internal--z_index_panel_header_fade)
}

.vkuiView--ios .vkuiView__panel--swipe-back-prev.vkuiView__panel--swipe-back-success {
  transform: translate3d(100%, 0, 0);
  transition: transform .3s cubic-bezier(.4, 0, .2, 1);
  transition: transform .3s var(--vkui--animation_easing_platform)
}

.vkuiView--ios .vkuiView__panel--swipe-back-next.vkuiView__panel--swipe-back-success,
.vkuiView--ios .vkuiView__panel--swipe-back-prev.vkuiView__panel--swipe-back-failed {
  transform: translateZ(0);
  transition: transform .3s cubic-bezier(.4, 0, .2, 1);
  transition: transform .3s var(--vkui--animation_easing_platform)
}

.vkuiView--ios .vkuiView__panel--swipe-back-next.vkuiView__panel--swipe-back-failed {
  transform: translate3d(-50%, 0, 0);
  transition: transform .3s cubic-bezier(.4, 0, .2, 1);
  transition: transform .3s var(--vkui--animation_easing_platform)
}

.vkuiView--ios .vkuiView__panel--swipe-back-next .vkuiView__panel-overlay {
  background-color: rgba(0, 0, 0, .1)
}

.vkuiView--ios .vkuiView__panel--swipe-back-next.vkuiView__panel--swipe-back-failed .vkuiView__panel-overlay,
.vkuiView--ios .vkuiView__panel--swipe-back-next.vkuiView__panel--swipe-back-success .vkuiView__panel-overlay {
  transition: opacity .3s cubic-bezier(.4, 0, .2, 1);
  transition: opacity .3s var(--vkui--animation_easing_platform)
}

.vkuiView__panel--next~.vkuiView__panel--prev {
  animation: vkuianimation-view-prev-back .3s cubic-bezier(.4, 0, .2, 1) forwards;
  animation: vkuianimation-view-prev-back .3s var(--vkui--animation_easing_platform) forwards
}

.vkuiView__panel--prev~.vkuiView__panel--next {
  animation: vkuianimation-view-next-forward .3s cubic-bezier(.4, 0, .2, 1);
  animation: vkuianimation-view-next-forward .3s var(--vkui--animation_easing_platform)
}

.vkuiView--no-motion .vkuiView__panel {
  animation: none
}

@keyframes vkuianimation-view-prev-back {
  0% {
    opacity: 1;
    transform: translateY(0)
  }

  to {
    opacity: 0;
    transform: translateY(80px)
  }
}

@keyframes vkuianimation-view-next-forward {
  0% {
    opacity: 0;
    transform: translateY(80px)
  }

  to {
    opacity: 1;
    transform: translateY(0)
  }
}

.vkuiView--ios .vkuiView__panel--prev {
  animation: vkuianimation-ios-prev-forward .6s cubic-bezier(.4, 0, .2, 1);
  animation: vkuianimation-ios-prev-forward .6s var(--vkui--animation_easing_platform)
}

.vkuiView--ios .vkuiView__panel--next {
  animation: vkuianimation-ios-next-back .6s cubic-bezier(.4, 0, .2, 1);
  animation: vkuianimation-ios-next-back .6s var(--vkui--animation_easing_platform)
}

.vkuiView--ios .vkuiView__panel--prev~.vkuiView__panel--next {
  animation: vkuianimation-ios-next-forward .6s cubic-bezier(.4, 0, .2, 1);
  animation: vkuianimation-ios-next-forward .6s var(--vkui--animation_easing_platform)
}

.vkuiView--ios .vkuiView__panel--next~.vkuiView__panel--prev {
  animation: vkuianimation-ios-prev-back .6s cubic-bezier(.4, 0, .2, 1) forwards;
  animation: vkuianimation-ios-prev-back .6s var(--vkui--animation_easing_platform) forwards
}

.vkuiView--ios .vkuiView__panel--next .vkuiView__panel-overlay,
.vkuiView--ios .vkuiView__panel--prev .vkuiView__panel-overlay {
  display: block
}

.vkuiView--ios .vkuiView__panel--prev .vkuiView__panel-overlay {
  animation: vkuianimation-ios-fade-in .6s cubic-bezier(.4, 0, .2, 1);
  animation: vkuianimation-ios-fade-in .6s var(--vkui--animation_easing_platform)
}

.vkuiView--ios .vkuiView__panel--next .vkuiView__panel-overlay {
  animation: vkuianimation-ios-fade-out .6s cubic-bezier(.4, 0, .2, 1) forwards;
  animation: vkuianimation-ios-fade-out .6s var(--vkui--animation_easing_platform) forwards
}

.vkuiView--ios .vkuiView__panel--next~.vkuiView__panel--prev .vkuiView__panel-overlay,
.vkuiView--ios .vkuiView__panel--prev~.vkuiView__panel--next .vkuiView__panel-overlay {
  display: none
}

.vkuiView--ios.vkuiView--no-motion .vkuiView__panel,
.vkuiView--ios.vkuiView--no-motion .vkuiView__panel .vkuiInternalPanel__in {
  animation: none
}

.vkuiView--ios .vkuiView__panel--active .vkuiView__panel-overlay {
  display: none
}

@keyframes vkuianimation-ios-next-forward {
  0% {
    transform: translate3d(100%, 0, 0)
  }

  to {
    transform: translateZ(0)
  }
}

@keyframes vkuianimation-ios-next-back {
  0% {
    transform: translate3d(-50%, 0, 0)
  }

  to {
    transform: translateZ(0)
  }
}

@keyframes vkuianimation-ios-prev-forward {
  0% {
    transform: translateZ(0)
  }

  to {
    transform: translate3d(-50%, 0, 0)
  }
}

@keyframes vkuianimation-ios-prev-back {
  0% {
    transform: translateZ(0)
  }

  to {
    transform: translate3d(100%, 0, 0)
  }
}

@keyframes vkuianimation-ios-fade-in {
  0% {
    opacity: 0
  }

  to {
    opacity: .3
  }
}

@keyframes vkuianimation-ios-fade-out {
  0% {
    opacity: .3
  }

  to {
    opacity: 0
  }
}

.vkuiPanel {
  height: 100%;
  position: relative;
  width: 100%
}

.vkuiPanel:before {
  content: "";
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%
}

.vkuiPanel__in {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  position: relative;
  width: 100%
}

.vkuiPanel__centered {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex: 1 0;
  flex-direction: column;
  justify-content: center
}

.vkuiPanel__centered .vkuiInternalPanelHeader--ios.vkuiInternalPanelHeader--vis+*,
.vkuiPanel__centered .vkuiInternalPanelHeader--vis+* {
  margin-top: 56px;
  margin-top: var(--vkui--size_panel_header_height--regular)
}

.vkuiPanel--sizeX-compact .vkuiPanel__centered .vkuiInternalPanelHeader--sep+* {
  margin-top: calc(56px + 5px);
  margin-top: calc(var(--vkui--size_panel_header_height--regular) + 5px)
}

@media (max-width:767.9px) {
  .vkuiPanel--sizeX-none .vkuiPanel__centered .vkuiInternalPanelHeader--sep+* {
    margin-top: calc(56px + 5px);
    margin-top: calc(var(--vkui--size_panel_header_height--regular) + 5px)
  }
}

.vkuiPanel--sizeX-compact .vkuiPanel__centered .vkuiInternalPanelHeader--ios.vkuiInternalPanelHeader--sep+* {
  margin-top: calc(56px + 5px);
  margin-top: calc(var(--vkui--size_panel_header_height--regular) + 5px)
}

@media (max-width:767.9px) {
  .vkuiPanel--sizeX-none .vkuiPanel__centered .vkuiInternalPanelHeader--ios.vkuiInternalPanelHeader--sep+* {
    margin-top: calc(56px + 5px);
    margin-top: calc(var(--vkui--size_panel_header_height--regular) + 5px)
  }
}

.vkuiPanel--sizeX-compact .vkuiPanel__centered .vkuiInternalPanelHeader--vkcom.vkuiInternalPanelHeader--sep+* {
  margin-top: calc(56px + 5px);
  margin-top: calc(var(--vkui--size_panel_header_height--regular) + 5px)
}

@media (max-width:767.9px) {
  .vkuiPanel--sizeX-none .vkuiPanel__centered .vkuiInternalPanelHeader--vkcom.vkuiInternalPanelHeader--sep+* {
    margin-top: calc(56px + 5px);
    margin-top: calc(var(--vkui--size_panel_header_height--regular) + 5px)
  }
}

.vkuiPanel--sizeX-regular .vkuiPanel__centered .vkuiInternalPanelHeader--sep+* {
  margin-top: calc(56px + 16px);
  margin-top: calc(var(--vkui--size_panel_header_height--regular) + 16px)
}

@media (min-width:768px) {
  .vkuiPanel--sizeX-none .vkuiPanel__centered .vkuiInternalPanelHeader--sep+* {
    margin-top: calc(56px + 16px);
    margin-top: calc(var(--vkui--size_panel_header_height--regular) + 16px)
  }
}

.vkuiPanel--sizeX-regular .vkuiPanel__centered .vkuiInternalPanelHeader--ios.vkuiInternalPanelHeader--sep+* {
  margin-top: calc(56px + 16px);
  margin-top: calc(var(--vkui--size_panel_header_height--regular) + 16px)
}

@media (min-width:768px) {
  .vkuiPanel--sizeX-none .vkuiPanel__centered .vkuiInternalPanelHeader--ios.vkuiInternalPanelHeader--sep+* {
    margin-top: calc(56px + 16px);
    margin-top: calc(var(--vkui--size_panel_header_height--regular) + 16px)
  }
}

.vkuiPanel--sizeX-regular .vkuiPanel__centered .vkuiInternalPanelHeader--vkcom.vkuiInternalPanelHeader--sep+* {
  margin-top: calc(56px + 16px);
  margin-top: calc(var(--vkui--size_panel_header_height--regular) + 16px)
}

@media (min-width:768px) {
  .vkuiPanel--sizeX-none .vkuiPanel__centered .vkuiInternalPanelHeader--vkcom.vkuiInternalPanelHeader--sep+* {
    margin-top: calc(56px + 16px);
    margin-top: calc(var(--vkui--size_panel_header_height--regular) + 16px)
  }
}

.vkuiInternalView--ios .vkuiPanel__in {
  padding-bottom: 0;
  padding-bottom: var(--vkui_internal--safe_area_inset_bottom);
  padding: 0;
  padding: 0 var(--vkui_internal--safe_area_inset_right) var(--vkui_internal--safe_area_inset_bottom) var(--vkui_internal--safe_area_inset_left)
}

.vkuiInternalEpic--hasTabbar .vkuiPanel__in {
  padding-bottom: calc(0px + 48px);
  padding-bottom: calc(var(--vkui_internal--safe_area_inset_bottom) + var(--vkui_internal--tabbar_height))
}

.vkuiPanel__in-before {
  height: 1px;
  margin-bottom: -1px
}

.vkuiPanel__in-after {
  height: 1px;
  margin-top: -1px
}

.vkuiPanel .vkuiPanel__in,
.vkuiPanel:before {
  background-color: #fff;
  background-color: var(--vkui--color_background_content)
}

.vkuiPanel--layout-card .vkuiPanel__in,
.vkuiPanel--layout-card:before {
  background-color: #ebedf0;
  background-color: var(--vkui--color_background)
}

.vkuiPanel--sizeX-regular .vkuiPanel__in,
.vkuiPanel--sizeX-regular:before {
  background-color: initial
}

@media (min-width:768px) {

  .vkuiPanel--sizeX-none .vkuiPanel__in,
  .vkuiPanel--sizeX-none:before {
    background-color: initial
  }
}

.vkuiPanelHeaderButton {
  appearance: none;
  background: none;
  border: 0;
  box-shadow: none;
  color: currentColor;
  display: block;
  margin: 0;
  padding: 0;
  position: relative
}

.vkuiPanelHeaderButton[disabled] {
  opacity: .6
}

.vkuiPanelHeaderButton--primitive {
  height: 48px;
  line-height: 48px;
  padding: 0 10px
}

.vkuiPanelHeaderButton--ios {
  align-items: center;
  display: flex;
  font-size: 17px;
  position: relative
}

.vkuiPanelHeaderButton--ios.vkuiPanelHeaderButton--primitive {
  height: 44px;
  line-height: 44px
}

.vkuiPanelHeaderButton--ios .vkuiIcon--24 {
  padding: 10px
}

.vkuiPanelHeaderButton--ios .vkuiIcon--28 {
  padding: 8px
}

.vkuiPanelHeaderBack--ios .vkuiIcon--w-20 {
  padding-left: 4px
}

.vkuiPanelHeaderButton--android.vkuiPanelHeaderButton--notPrimitive {
  border-radius: 50%
}

.vkuiPanelHeaderButton--android .vkuiIcon--24 {
  padding: 12px
}

.vkuiPanelHeaderButton--android .vkuiIcon--28 {
  padding: 10px
}

.vkuiPanelHeaderButton--vkcom {
  color: #818c99;
  color: var(--vkui--color_text_secondary)
}

.vkuiPanelHeaderButton--vkcom>:not(.vkuiInternalCounter) {
  opacity: .7;
  transition: opacity .3s
}

.vkuiPanelHeaderButton--vkcom.vkuiPanelHeaderButton--active>:not(.vkuiInternalCounter),
.vkuiPanelHeaderButton--vkcom.vkuiPanelHeaderButton--hover>:not(.vkuiInternalCounter) {
  opacity: 1
}

.vkuiPanelHeaderButton--vkcom {
  align-items: center;
  display: flex;
  padding: 10px
}

.vkuiPanelHeaderButton--vkcom.vkuiPanelHeaderButton--notPrimitive {
  border-radius: 50%
}

.vkuiPanelHeaderBack--vkcom.vkuiPanelHeaderBack--has-label {
  padding-right: 11px
}

@media (min-width:768px) {
  .vkuiPanelHeaderBack--ios.vkuiPanelHeaderBack--has-label:not(.vkuiPanelHeaderBack--sizeX-compact) {
    padding-right: 8px
  }
}

.vkuiPanelHeaderBack--sizeX-compact.vkuiPanelHeaderBack--ios .vkuiPanelHeaderButton__label {
  display: none
}

@media (max-width:767.9px) {
  .vkuiPanelHeaderBack--sizeX-none.vkuiPanelHeaderBack--ios .vkuiPanelHeaderButton__label {
    display: none
  }
}

.vkuiPanelHeader {
  position: relative
}

.vkuiPanelHeader--vis.vkuiPanelHeader--fixed:before {
  content: "";
  display: block
}

.vkuiPanelHeader:not(.vkuiPanelHeader--vis):not(.vkuiPanelHeader--fixed) {
  height: 0;
  z-index: 10;
  z-index: var(--vkui_internal--z_index_panel_header)
}

.vkuiPanelHeader__fixed {
  z-index: 10;
  z-index: var(--vkui_internal--z_index_panel_header)
}

.vkuiPanelHeader__in {
  align-items: center;
  background: #fff;
  background: var(--vkui--color_background_content);
  display: flex;
  justify-content: space-between;
  position: relative;
  white-space: nowrap
}

.vkuiPanelHeader--trnsp .vkuiPanelHeader__in {
  background: transparent
}

.vkuiPanelHeader--sizeX-regular .vkuiPanelHeader--shadow .vkuiPanelHeader__in {
  box-shadow: 0 0 4px rgba(0, 0, 0, .08)
}

@media (min-width:768px) {
  .vkuiPanelHeader--sizeX-none .vkuiPanelHeader--shadow .vkuiPanelHeader__in {
    box-shadow: 0 0 4px rgba(0, 0, 0, .08)
  }
}

.vkuiPanelHeader__before {
  box-sizing: border-box;
  color: #2688eb;
  color: var(--vkui--color_icon_accent_themed);
  display: flex;
  flex-shrink: 0
}

.vkuiPanelHeader__content {
  overflow: hidden
}

.vkuiPanelHeader__content>* {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis
}

.vkuiPanelHeader__content-in {
  color: #000;
  color: var(--vkui--color_text_primary);
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_family_accent);
  font-weight: 500
}

.vkuiPanelHeader:before,
.vkuiPanelHeader__in {
  height: 56px;
  height: var(--vkui--size_panel_header_height--regular);
  padding-top: 0;
  padding-top: var(--vkui_internal--safe_area_inset_top)
}

.vkuiPanelHeader__after {
  align-items: center;
  box-sizing: border-box;
  color: #2688eb;
  color: var(--vkui--color_icon_accent_themed);
  display: flex;
  justify-content: flex-end
}

.vkuiPanelHeader__after>:not(:last-child) {
  margin-right: 4px
}

.vkuiPanelHeader--ios .vkuiPanelHeader__before {
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 0;
  opacity: 1;
  padding: 4px 0 4px 4px;
  transition: opacity .3s cubic-bezier(.4, 0, .2, 1);
  transition: opacity .3s var(--vkui--animation_easing_platform)
}

.vkuiPanelHeader--ios .vkuiPanelHeader__before .vkuiPanelHeaderButton+.vkuiPanelHeaderButton--primitive {
  margin-left: -6px;
  padding-left: 0
}

.vkuiPanelHeader--ios .vkuiPanelHeader__content {
  opacity: 1;
  text-align: center;
  transition: opacity .3s cubic-bezier(.4, 0, .2, 1);
  transition: opacity .3s var(--vkui--animation_easing_platform)
}

.vkuiPanelHeader--ios .vkuiPanelHeader__content-in {
  font-size: 21px
}

.vkuiPanelHeader--ios .vkuiPanelHeader__content>* {
  padding: 0 4px
}

.vkuiPanelHeader--ios.vkuiPanelHeader--no-before .vkuiPanelHeader__content {
  padding-left: 8px
}

.vkuiPanelHeader--ios.vkuiPanelHeader--no-after .vkuiPanelHeader__content>* {
  padding-right: 0
}

.vkuiPanelHeader--ios.vkuiPanelHeader--no-after .vkuiPanelHeader__content {
  padding-right: 8px
}

.vkuiPanelHeader--ios .vkuiPanelHeader__after {
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 0;
  opacity: 1;
  padding: 4px 4px 4px 0;
  transition: opacity .3s cubic-bezier(.4, 0, .2, 1);
  transition: opacity .3s var(--vkui--animation_easing_platform)
}

.vkuiView--ios .vkuiView__panel--prev .vkuiPanelHeader__after,
.vkuiView--ios .vkuiView__panel--prev .vkuiPanelHeader__before,
.vkuiView--ios .vkuiView__panel--prev .vkuiPanelHeader__content {
  opacity: 0
}

.vkuiPanelHeader--android .vkuiPanelHeader__before:not(:empty) {
  padding: 4px 0 4px 4px
}

.vkuiPanelHeader--android .vkuiPanelHeader__content {
  align-items: center;
  flex-grow: 1;
  max-width: 100%
}

.vkuiPanelHeader--android .vkuiPanelHeader__content-in {
  font-size: 23px
}

.vkuiPanelHeader--android .vkuiPanelHeader__content>* {
  padding: 0 12px
}

.vkuiInternalSplitCol--spaced .vkuiPanelHeader--android.vkuiPanelHeader--no-before:not(.vkuiInternalModalPageHeader__in) .vkuiPanelHeader__content,
.vkuiInternalSplitCol--viewWidth-tabletPlus.vkuiInternalSplitCol--spaced-none.vkuiInternalSplitCol--spaced-auto .vkuiPanelHeader--android.vkuiPanelHeader--no-before:not(.vkuiInternalModalPageHeader__in) .vkuiPanelHeader__content {
  padding-left: 0
}

@media (min-width:768px) {
  .vkuiInternalSplitCol--viewWidth-none.vkuiInternalSplitCol--spaced-none.vkuiInternalSplitCol--spaced-auto .vkuiPanelHeader--android.vkuiPanelHeader--no-before:not(.vkuiInternalModalPageHeader__in) .vkuiPanelHeader__content {
    padding-left: 0
  }
}

.vkuiPanelHeader--android.vkuiPanelHeader--no-after .vkuiPanelHeader__content>*,
.vkuiPanelHeader--vkcom.vkuiPanelHeader--no-after .vkuiPanelHeader__content>* {
  padding-right: 0
}

.vkuiPanelHeader--android.vkuiPanelHeader--no-after .vkuiPanelHeader__content {
  padding-right: 16px
}

.vkuiPanelHeader--android.vkuiPanelHeader--no-before .vkuiPanelHeader__content {
  padding-left: 16px
}

.vkuiInternalSplitCol--spaced .vkuiPanelHeader--android.vkuiPanelHeader--no-after:not(.vkuiInternalModalPageHeader__in) .vkuiPanelHeader__content,
.vkuiInternalSplitCol--viewWidth-tabletPlus.vkuiInternalSplitCol--spaced-none.vkuiInternalSplitCol--spaced-auto .vkuiPanelHeader--android.vkuiPanelHeader--no-after:not(.vkuiInternalModalPageHeader__in) .vkuiPanelHeader__content {
  padding-right: 0
}

@media (min-width:768px) {
  .vkuiInternalSplitCol--viewWidth-none.vkuiInternalSplitCol--spaced-none.vkuiInternalSplitCol--spaced-auto .vkuiPanelHeader--android.vkuiPanelHeader--no-after:not(.vkuiInternalModalPageHeader__in) .vkuiPanelHeader__content {
    padding-right: 0
  }
}

.vkuiPanelHeader--android .vkuiPanelHeader__after:not(:empty),
.vkuiPanelHeader--vkcom .vkuiPanelHeader__after:not(:empty) {
  padding: 4px 4px 4px 0
}

.vkuiPanelHeader--vkcom {
  position: relative;
  z-index: 10;
  z-index: var(--vkui_internal--z_index_panel_header)
}

.vkuiPanelHeader--vkcom.vkuiPanelHeader--sizeX-regular:not(.vkuiInternalModalPageHeader__in):not(.vkuiPanelHeader--sep) .vkuiPanelHeader__in:after {
  background-color: #fff;
  background-color: var(--vkui--color_background_content);
  bottom: 0;
  content: "";
  height: var(--vkui--size_border--regular);
  left: var(--vkui--size_border--regular);
  position: absolute;
  right: var(--vkui--size_border--regular)
}

@media (min-width:768px) {
  .vkuiPanelHeader--vkcom.vkuiPanelHeader--sizeX-none:not(.vkuiInternalModalPageHeader__in):not(.vkuiPanelHeader--sep) .vkuiPanelHeader__in:after {
    background-color: #fff;
    background-color: var(--vkui--color_background_content);
    bottom: 0;
    content: "";
    height: var(--vkui--size_border--regular);
    left: var(--vkui--size_border--regular);
    position: absolute;
    right: var(--vkui--size_border--regular)
  }
}

.vkuiPanelHeader--vkcom.vkuiPanelHeader--sizeX-regular:not(.vkuiInternalModalPageHeader__in) .vkuiPanelHeader__in {
  border-bottom: 0;
  border-top-left-radius: 12px;
  border-top-left-radius: var(--vkui--size_border_radius_paper--regular);
  border-top-right-radius: 12px;
  border-top-right-radius: var(--vkui--size_border_radius_paper--regular);
  box-shadow: 0 0 0 var(--vkui--size_border--regular) rgba(0, 0, 0, .12) inset;
  box-shadow: 0 0 0 var(--vkui--size_border--regular) var(--vkui--color_field_border_alpha) inset
}

@media (min-width:768px) {
  .vkuiPanelHeader--vkcom.vkuiPanelHeader--sizeX-none:not(.vkuiInternalModalPageHeader__in) .vkuiPanelHeader__in {
    border-bottom: 0;
    border-top-left-radius: 12px;
    border-top-left-radius: var(--vkui--size_border_radius_paper--regular);
    border-top-right-radius: 12px;
    border-top-right-radius: var(--vkui--size_border_radius_paper--regular);
    box-shadow: 0 0 0 var(--vkui--size_border--regular) rgba(0, 0, 0, .12) inset;
    box-shadow: 0 0 0 var(--vkui--size_border--regular) var(--vkui--color_field_border_alpha) inset
  }
}

.vkuiPanelHeader--vkcom .vkuiPanelHeader__content {
  text-align: center
}

.vkuiPanelHeader--vkcom .vkuiPanelHeader__before:not(:empty) {
  padding: 0 0 0 4px
}

.vkuiPanelHeader--vkcom .vkuiPanelHeader__after,
.vkuiPanelHeader--vkcom .vkuiPanelHeader__before {
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 0
}

.vkuiPanelHeader__separator {
  margin-top: calc(-1 * var(--vkui--size_border--regular))
}

.vkuiPanelHeader--no-before .vkuiPanelHeader__content>* {
  padding-left: 0
}

.vkuiInternalPanel--centered .vkuiPanelHeader {
  left: 0;
  position: absolute;
  top: 0;
  width: 100%
}

.vkuiSeparator {
  color: #d7d8d9;
  color: var(--vkui--color_separator_primary)
}

.vkuiSeparator__in {
  background: currentColor;
  border: 0;
  color: inherit;
  height: var(--vkui--size_border--regular);
  margin: 0;
  transform-origin: center top
}

/* .vkuiSeparator--padded .vkuiSeparator__in {
  margin-left: 16px;
  margin-left: var(--vkui--size_base_padding_horizontal--regular);
  margin-right: 16px;
  margin-right: var(--vkui--size_base_padding_horizontal--regular)
} */

.vkuiInternalModalPage--sizeX-regular .vkuiSeparator--padded {
  padding-left: 8px;
  padding-right: 8px
}

@media (min-width:768px) {
  .vkuiInternalModalPage--sizeX-none .vkuiSeparator--padded {
    padding-left: 8px;
    padding-right: 8px
  }
}

.vkuiSpacing {
  box-sizing: border-box;
  position: relative
}

.vkuiPanelHeaderContent {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_family_base);
  height: 100%;
  justify-content: flex-start;
  line-height: normal;
  max-width: 100%
}

.vkuiPanelHeaderContent__before {
  flex-shrink: 0;
  margin-right: 12px
}

.vkuiPanelHeaderContent__in {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  justify-content: center;
  min-width: 0
}

.vkuiPanelHeaderContent__children-in,
.vkuiPanelHeaderContent__childrenText,
.vkuiPanelHeaderContent__status {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

.vkuiPanelHeaderContent__status {
  color: #818c99;
  color: var(--vkui--color_text_secondary);
  margin-top: 1px;
  max-width: 100%;
  order: 1
}

.vkuiPanelHeaderContent__children {
  align-items: center;
  display: flex;
  max-width: 100%
}

.vkuiPanelHeaderContent__children-in {
  flex-grow: 0;
  min-width: 0
}

.vkuiPanelHeaderContent__aside {
  align-items: center;
  color: #2688eb;
  color: var(--vkui--color_icon_accent);
  display: flex;
  justify-content: flex-start;
  margin-left: 2px
}

.vkuiPanelHeaderContent__width {
  width: 1000px
}

.vkuiPanelHeaderContent__in--centered {
  align-items: center
}

.vkuiPanelHeaderContent--ios .vkuiPanelHeaderContent__children-in {
  font-size: 21px
}

.vkuiPanelHeaderContent--android .vkuiPanelHeaderContent__children-in,
.vkuiPanelHeaderContent--ios .vkuiPanelHeaderContent__children-in {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_family_accent);
  font-weight: 500;
  line-height: 56px;
  line-height: var(--vkui--size_panel_header_height--regular)
}

.vkuiPanelHeaderContent--android .vkuiPanelHeaderContent__children-in {
  font-size: 23px
}

.vkuiInternalPanelHeader--no-before .vkuiPanelHeaderContent--vkcom {
  padding-left: 16px
}

.vkuiPanelHeaderContext {
  z-index: 4;
  z-index: var(--vkui_internal--z_index_panel_header_context)
}

.vkuiPanelHeaderContext--closing,
.vkuiPanelHeaderContext--opened {
  height: 100%;
  width: 100%
}

.vkuiPanelHeaderContext--sizeX-regular.vkuiPanelHeaderContext--closing,
.vkuiPanelHeaderContext--sizeX-regular.vkuiPanelHeaderContext--opened {
  height: auto
}

@media (min-width:768px) {

  .vkuiPanelHeaderContext--sizeX-none.vkuiPanelHeaderContext--closing,
  .vkuiPanelHeaderContext--sizeX-none.vkuiPanelHeaderContext--opened {
    height: auto
  }
}

.vkuiPanelHeaderContext__in {
  box-sizing: border-box;
  left: 0;
  padding: 8px;
  pointer-events: none;
  position: absolute;
  width: 100%
}

.vkuiPanelHeaderContext__fade {
  background: rgba(0, 0, 0, .4);
  display: none;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%
}

.vkuiPanelHeaderContext--sizeX-compact .vkuiPanelHeaderContext__fade {
  display: block
}

@media (max-width:767.9px) {
  .vkuiPanelHeaderContext--sizeX-none .vkuiPanelHeaderContext__fade {
    display: block
  }
}

.vkuiPanelHeaderContext--opened .vkuiPanelHeaderContext__fade {
  animation: vkuianimation-panelheadercontext-fade-in .2s ease
}

.vkuiPanelHeaderContext--closing .vkuiPanelHeaderContext__fade {
  animation: vkuianimation-panelheadercontext-fade-out .2s ease
}

.vkuiPanelHeaderContext--opened .vkuiPanelHeaderContext__in {
  animation: vkuianimation-panelheadercontext-translate-in .2s ease;
  pointer-events: auto
}

.vkuiPanelHeaderContext--closing .vkuiPanelHeaderContext__in {
  animation: vkuianimation-panelheadercontext-translate-out .2s ease
}

.vkuiPanelHeaderContext__content {
  background: #fff;
  background: var(--vkui--color_background_content);
  overflow: hidden
}

.vkuiPanelHeaderContext--ios .vkuiPanelHeaderContext__in {
  padding: 0
}

.vkuiPanelHeaderContext--sizeX-regular.vkuiPanelHeaderContext--ios .vkuiPanelHeaderContext__content,
.vkuiPanelHeaderContext:not(.vkuiPanelHeaderContext--ios) .vkuiPanelHeaderContext__content {
  border-radius: 12px;
  padding: 8px 0
}

@media (min-width:768px) {
  .vkuiPanelHeaderContext--sizeX-none.vkuiPanelHeaderContext--ios .vkuiPanelHeaderContext__content {
    border-radius: 12px;
    padding: 8px 0
  }
}

.vkuiPanelHeaderContext--sizeX-regular .vkuiPanelHeaderContext__in {
  padding: 12px 8px
}

.vkuiPanelHeaderContext--sizeX-regular .vkuiPanelHeaderContext__content {
  border-radius: 12px;
  box-shadow: 0 0 4px rgba(0, 0, 0, .08), 0 8px 8px rgba(0, 0, 0, .16)
}

@media (min-width:768px) {
  .vkuiPanelHeaderContext--sizeX-none .vkuiPanelHeaderContext__in {
    padding: 12px 8px
  }

  .vkuiPanelHeaderContext--sizeX-none .vkuiPanelHeaderContext__content {
    border-radius: 12px;
    box-shadow: 0 0 4px rgba(0, 0, 0, .08), 0 8px 8px rgba(0, 0, 0, .16)
  }
}

@keyframes vkuianimation-panelheadercontext-translate-in {
  0% {
    transform: translateY(-100%)
  }

  to {
    transform: translateY(0)
  }
}

@keyframes vkuianimation-panelheadercontext-translate-out {
  0% {
    transform: translateY(0)
  }

  to {
    transform: translateY(-100%)
  }
}

@keyframes vkuianimation-panelheadercontext-fade-in {
  0% {
    opacity: 0
  }

  to {
    opacity: 1
  }
}

@keyframes vkuianimation-panelheadercontext-fade-out {
  0% {
    opacity: 1
  }

  to {
    opacity: 0
  }
}

.vkuiSplitLayout {
  height: 100%;
  position: relative;
  width: 100%
}

.vkuiSplitLayout__inner {
  display: flex;
  height: 100%;
  width: 100%
}

.vkuiSplitLayout__inner--header {
  position: relative;
  z-index: 11;
  z-index: var(--vkui_internal--z_index_split_layout_panel_header)
}

.vkuiSplitLayout--ios .vkuiSplitLayout__inner--header,
.vkuiSplitLayout__inner--header {
  margin-top: calc(-1 * (56px + 0px));
  margin-top: calc(-1 * (var(--vkui--size_panel_header_height--regular) + var(--vkui_internal--safe_area_inset_top)))
}

.vkuiPopoutRoot {
  height: 100%;
  position: relative;
  width: 100%
}

.vkuiPopoutRoot__popout {
  z-index: 100;
  z-index: var(--vkui--z_index_popout)
}

.vkuiPopoutRoot__modal,
.vkuiPopoutRoot__popout {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%
}

.vkuiPopoutRoot__modal {
  z-index: 99;
  z-index: var(--vkui--z_index_modal)
}

.vkuiPopoutRoot__modal:empty,
.vkuiPopoutRoot__popout:empty {
  display: none
}

.vkuiSplitCol {
  flex-grow: 1;
  flex-shrink: 1;
  height: 100%;
  position: relative;
  width: 1px
}

.vkuiSplitCol--spaced,
.vkuiSplitCol--viewWidth-smallTabletPlus.vkuiSplitCol--spaced-none.vkuiSplitCol--spaced-auto {
  margin: 0 16px;
  margin: 0 var(--vkui--size_split_col_padding_horizontal--regular)
}

@media (min-width:768px) {
  .vkuiSplitCol--viewWidth-none.vkuiSplitCol--spaced-none.vkuiSplitCol--spaced-auto {
    margin: 0 16px;
    margin: 0 var(--vkui--size_split_col_padding_horizontal--regular)
  }
}

.vkuiSplitCol--viewWidth-tabletMinus.vkuiSplitCol--stretched-on-mobile {
  max-width: 100% !important;
  width: 100% !important
}

@media (max-width:1023.9px) {
  .vkuiSplitCol--viewWidth-none.vkuiSplitCol--stretched-on-mobile {
    max-width: 100% !important;
    width: 100% !important
  }
}

.vkuiSplitCol--fixed {
  flex-grow: 1;
  flex-shrink: 1;
  height: 100%;
  width: 1px
}

.vkuiSplitCol__fixedInner {
  height: inherit;
  max-width: inherit;
  min-width: inherit;
  overflow: hidden;
  position: fixed;
  top: 0;
  transform: translateZ(0);
  width: inherit
}

.vkuiEpic {
  height: 100%;
  width: 100%
}

.vkuiTabbar {
  background: #f9f9f9;
  background: var(--vkui--color_background_tertiary);
  bottom: 0;
  box-sizing: initial;
  display: flex;
  height: 48px;
  height: var(--vkui_internal--tabbar_height);
  left: 0;
  overflow: hidden;
  padding-bottom: 0;
  padding-bottom: var(--vkui_internal--safe_area_inset_bottom);
  position: fixed;
  width: 100%;
  z-index: 2;
  z-index: var(--vkui_internal--z_index_tabs)
}

.vkuiTabbar--shadow {
  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);
  box-shadow: var(--vkui--elevation3)
}

.vkuiTabbar--ios.vkuiTabbar--shadow {
  box-shadow: none
}

.vkuiTabbar--ios.vkuiTabbar--shadow:before {
  background: rgba(0, 0, 0, .12);
  background: var(--vkui--color_separator_primary_alpha);
  content: "";
  height: var(--vkui--size_border--regular);
  left: 0;
  position: absolute;
  width: 100%
}

.vkuiTabbarItem {
  align-items: center;
  background: transparent;
  border: 0;
  color: #99a2ad;
  color: var(--vkui--color_tabbar_text_inactive);
  display: flex;
  height: 48px;
  height: var(--vkui_internal--tabbar_height);
  justify-content: center;
  outline: none;
  padding: 0;
  position: relative;
  text-decoration: none
}

.vkuiInternalTabbar .vkuiTabbarItem {
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 0;
  max-width: 100%;
  min-width: 0
}

.vkuiTabbarItem--selected {
  color: #2688eb;
  color: var(--vkui--color_text_accent_themed)
}

.vkuiTabbarItem__tappable {
  position: absolute
}

.vkuiTabbarItem__in {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  height: 100%;
  justify-content: center;
  overflow: hidden;
  padding: 4px 2px 2px;
  pointer-events: none;
  width: 100%
}

.vkuiInternalTabbar--layout-vertical .vkuiTabbarItem__in {
  flex-direction: column
}

.vkuiInternalTabbar--layout-horizontal .vkuiTabbarItem__in {
  flex-direction: row
}

.vkuiTabbarItem__icon {
  color: #99a2ad;
  color: var(--vkui--color_icon_secondary);
  position: relative
}

.vkuiTabbarItem--selected .vkuiTabbarItem__icon {
  color: #2688eb;
  color: var(--vkui--color_icon_accent_themed)
}

.vkuiTabbarItem__text {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

.vkuiInternalTabbar--layout-vertical .vkuiTabbarItem__text {
  --vkui--font_footnote--font_size--regular: 10px;
  --vkui--font_footnote--line_height--regular: 12px;
  margin-top: 2px
}

.vkuiInternalTabbar--layout-horizontal .vkuiTabbarItem__text {
  margin-left: 8px
}

.vkuiTabbarItem--android .vkuiTabbarItem__tappable {
  border-radius: 50%;
  padding-bottom: calc(100% + 16px);
  width: calc(100% + 16px)
}

.vkuiTabbarItem--android:first-child {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0
}

.vkuiTabbarItem--android:last-child {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0
}

.vkuiTabbarItem--ios .vkuiTabbarItem__tappable {
  height: 100%;
  left: 0;
  top: 0;
  width: 100%
}

.vkuiTabbarItem--ios .vkuiTabbarItem__in {
  transition: transform .07s cubic-bezier(.4, 0, .2, 1);
  transition: transform .07s var(--vkui--animation_easing_platform)
}

.vkuiTabbarItem--ios .vkuiTabbarItem__tappable--active+.vkuiTabbarItem__in {
  transform: scale(.96)
}

.vkuiScrollArrow {
  background-color: initial;
  border: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 0;
  transition: opacity .15s;
  transition-timing-function: cubic-bezier(.4, 0, .2, 1);
  transition-timing-function: var(--vkui--animation_easing_platform);
  -webkit-user-select: auto;
  user-select: auto
}

.vkuiScrollArrow--direction-left,
.vkuiScrollArrow--direction-right {
  flex-direction: column;
  height: 100%
}

.vkuiScrollArrow--direction-down,
.vkuiScrollArrow--direction-up {
  flex-direction: row;
  width: 100%
}

.vkuiScrollArrow__icon {
  align-items: center;
  background-color: #fff;
  background-color: var(--vkui--color_background_modal);
  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);
  box-shadow: var(--vkui--elevation3);
  color: #99a2ad;
  color: var(--vkui--color_icon_secondary);
  display: flex;
  justify-content: center;
  position: relative
}

.vkuiScrollArrow--size-m .vkuiScrollArrow__icon {
  border-radius: 14px;
  height: 28px;
  width: 28px
}

.vkuiScrollArrow--size-l .vkuiScrollArrow__icon {
  border-radius: 24px;
  height: 40px;
  width: 40px
}

.vkuiScrollArrow--direction-left {
  left: 0;
  padding-left: 16px;
  padding-left: var(--vkui--size_base_padding_horizontal--regular, 16px)
}

.vkuiScrollArrow--direction-right {
  padding-right: 16px;
  padding-right: var(--vkui--size_base_padding_horizontal--regular, 16px);
  right: 0
}

.vkuiScrollArrow--direction-up {
  padding-top: 16px;
  padding-top: var(--vkui--size_base_padding_horizontal--regular, 16px);
  top: 0
}

.vkuiScrollArrow--direction-down {
  bottom: 0;
  padding-bottom: 16px;
  padding-bottom: var(--vkui--size_base_padding_horizontal--regular, 16px)
}

.vkuiScrollArrow--direction-left .vkuiScrollArrow__defaultIcon {
  transform: rotate(180deg)
}

.vkuiScrollArrow--direction-up .vkuiScrollArrow__defaultIcon {
  transform: rotate(-90deg)
}

.vkuiScrollArrow--direction-down .vkuiScrollArrow__defaultIcon {
  transform: rotate(90deg)
}

.vkuiHorizontalScroll {
  isolation: isolate;
  overflow-x: hidden;
  position: relative
}

.vkuiHorizontalScroll__in {
  -webkit-overflow-scrolling: touch;
  overflow-x: auto;
  scrollbar-width: none
}

.vkuiHorizontalScroll__in::-webkit-scrollbar {
  display: none
}

.vkuiHorizontalScroll__in-wrapper {
  transition: transform .2s
}

.vkuiHorizontalScroll__arrow {
  opacity: 0;
  position: absolute;
  top: 0;
  z-index: 1;
  z-index: var(--vkui_internal--z_index_horizontal_scroll_arrow)
}

.vkuiHorizontalScroll:hover .vkuiHorizontalScroll__arrow {
  opacity: .64;
  opacity: var(--vkui--opacity_disable_accessibility)
}

.vkuiHorizontalScroll .vkuiHorizontalScroll__arrow:hover,
.vkuiHorizontalScroll--withConstArrows .vkuiHorizontalScroll__arrow,
.vkuiHorizontalScroll--withConstArrows:hover .vkuiHorizontalScroll__arrow {
  opacity: 1
}

.vkuiHorizontalScroll__arrowLeft:hover~.vkuiHorizontalScroll__in .vkuiHorizontalScroll__in-wrapper {
  transform: translateX(8px)
}

.vkuiHorizontalScroll__arrowRight:hover~.vkuiHorizontalScroll__in .vkuiHorizontalScroll__in-wrapper {
  transform: translateX(-8px)
}

.vkuiInternalTabs .vkuiHorizontalScroll {
  min-width: 100%
}

.vkuiInternalTabs .vkuiHorizontalScroll__in-wrapper {
  align-items: stretch;
  display: flex
}

.vkuiInternalTabs--withGaps .vkuiHorizontalScroll__in-wrapper:after,
.vkuiInternalTabs--withGaps .vkuiHorizontalScroll__in-wrapper:before {
  content: "";
  display: block;
  flex-shrink: 0;
  height: 1px;
  width: 16px;
  width: var(--vkui--size_base_padding_horizontal--regular)
}

.vkuiAspectRatio {
  --vkui_internal--aspect_ratio: 1;
  max-width: 100%;
  position: relative
}

.vkuiAspectRatio:before {
  content: "";
  display: block;
  height: 0;
  padding-bottom: calc((1 / 1) * 100%);
  padding-bottom: calc((1 / var(--vkui_internal--aspect_ratio, 1)) * 100%)
}

.vkuiAspectRatio>* {
  left: 0;
  position: absolute;
  top: 0
}

.vkuiAspectRatio--mode-stretch>* {
  height: 100%;
  width: 100%
}

.vkuiAspectRatio--mode-stretch>img,
.vkuiAspectRatio--mode-stretch>video {
  object-fit: cover
}

.vkuiPopoutWrapper {
  box-sizing: border-box;
  height: 100%;
  left: 0;
  pointer-events: none;
  top: 0;
  width: 100%
}

.vkuiPopoutWrapper--opened {
  pointer-events: auto
}

.vkuiPopoutWrapper--closing {
  pointer-events: none
}

.vkuiPopoutWrapper--fixed {
  position: fixed
}

.vkuiPopoutWrapper__overlay {
  animation: vkuianimation-full-fade-in .2s ease;
  animation: vkuianimation-full-fade-in var(--vkui--animation_duration_m) ease;
  height: 100%;
  left: 0;
  opacity: 1;
  position: fixed;
  top: 0;
  width: 100%
}

.vkuiPopoutWrapper--closing .vkuiPopoutWrapper__overlay {
  opacity: 0;
  transition: opacity .2s cubic-bezier(.3, .3, .5, 1);
  transition: opacity var(--vkui--animation_duration_m) var(--vkui--animation_easing_default)
}

.vkuiPopoutWrapper--masked .vkuiPopoutWrapper__overlay {
  background: rgba(0, 0, 0, .4);
  background: var(--vkui--color_overlay_primary)
}

.vkuiPopoutWrapper--fixed .vkuiPopoutWrapper__overlay {
  position: absolute
}

.vkuiPopoutWrapper__container {
  box-sizing: border-box;
  display: flex;
  height: 100%;
  position: relative;
  width: 100%
}

.vkuiPopoutWrapper__content {
  display: flex;
  justify-content: center;
  pointer-events: none;
  position: relative;
  width: 100%
}

.vkuiPopoutWrapper__content>* {
  pointer-events: auto
}

.vkuiPopoutWrapper--alignY-center .vkuiPopoutWrapper__container {
  align-items: center
}

.vkuiPopoutWrapper--alignY-bottom .vkuiPopoutWrapper__container {
  align-items: flex-end
}

.vkuiPopoutWrapper--alignY-top .vkuiPopoutWrapper__container {
  align-items: flex-start
}

.vkuiPopoutWrapper--alignX-center .vkuiPopoutWrapper__container {
  justify-content: center
}

.vkuiPopoutWrapper--alignX-left .vkuiPopoutWrapper__container {
  justify-content: flex-start
}

.vkuiPopoutWrapper--alignX-right .vkuiPopoutWrapper__container {
  justify-content: flex-end
}

@keyframes vkuianimation-full-fade-in {
  0% {
    opacity: 0
  }

  to {
    opacity: 1
  }
}

.vkuiAlert {
  animation: vkuianimation-android-alert-intro .2s cubic-bezier(.4, 0, .2, 1);
  animation: vkuianimation-android-alert-intro .2s var(--vkui--animation_easing_platform);
  border-radius: 12px;
  border-radius: var(--vkui--size_border_radius_paper--regular);
  box-shadow: 0 0 8px rgba(0, 0, 0, .12), 0 16px 16px rgba(0, 0, 0, .16);
  box-shadow: var(--vkui--elevation4);
  color: #000;
  color: var(--vkui--color_text_primary);
  margin: auto 24px;
  max-width: 416px;
  min-width: 280px;
  position: relative;
  -webkit-user-select: none;
  user-select: none
}

.vkuiAlert--desktop {
  width: 100%
}

.vkuiAlert--closing {
  opacity: 0;
  transform: scale(.95);
  transition: transform .2s cubic-bezier(.4, 0, .2, 1), opacity .2s cubic-bezier(.4, 0, .2, 1);
  transition: transform .2s var(--vkui--animation_easing_platform), opacity .2s var(--vkui--animation_easing_platform)
}

.vkuiAlert:before {
  background-color: #fff;
  background-color: var(--vkui--color_background_modal);
  border-radius: inherit;
  content: "";
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%
}

.vkuiAlert__content {
  padding: 24px 24px 16px;
  position: relative
}

.vkuiAlert__content--withButton {
  padding-right: 52px
}

.vkuiAlert__action {
  background: transparent;
  white-space: nowrap
}

.vkuiAlert__actions {
  display: flex;
  max-width: 100%;
  padding: 0 12px 12px;
  position: relative
}

.vkuiAlert__header {
  margin-bottom: 8px
}

.vkuiAlert__text {
  color: #818c99;
  color: var(--vkui--color_text_secondary)
}

.vkuiAlert__header,
.vkuiAlert__text {
  word-break: break-word
}

.vkuiAlert__actions--direction-horizontal {
  justify-content: flex-end
}

.vkuiAlert__actions--direction-vertical {
  align-items: flex-end;
  flex-direction: column
}

.vkuiAlert__actions>* {
  margin: 4px
}

.vkuiAlert__actions--align-left {
  align-items: flex-start;
  justify-content: flex-start
}

.vkuiAlert__actions--align-center {
  align-items: center;
  justify-content: center
}

.vkuiAlert__actions--align-right {
  align-items: flex-end;
  justify-content: flex-end
}

.vkuiAlert--ios {
  animation: vkuianimation-ios-alert-intro .3s cubic-bezier(.4, 0, .2, 1);
  animation: vkuianimation-ios-alert-intro .3s var(--vkui--animation_easing_platform);
  box-shadow: none;
  min-width: 270px;
  overflow: hidden;
  width: 270px
}

.vkuiAlert--ios.vkuiAlert--closing {
  opacity: 0;
  transform: none;
  transition: opacity .3s cubic-bezier(.4, 0, .2, 1);
  transition: opacity .3s var(--vkui--animation_easing_platform)
}

.vkuiAlert--ios .vkuiAlert__content {
  padding: 20px 16px;
  text-align: center
}

.vkuiAlert--ios .vkuiAlert__header:not(:last-child) {
  margin-bottom: 7px
}

.vkuiAlert--ios .vkuiAlert__text {
  color: inherit
}

.vkuiAlert--ios .vkuiAlert__content:after {
  background: rgba(0, 0, 0, .12);
  background: var(--vkui--color_separator_primary_alpha);
  bottom: 0;
  content: "";
  height: 1px;
  left: 0;
  position: absolute;
  right: 0;
  transform-origin: center bottom
}

.vkuiAlert--ios .vkuiAlert__actions {
  padding: initial
}

.vkuiAlert--ios .vkuiAlert__actions--direction-vertical {
  align-items: normal;
  flex-direction: column
}

.vkuiAlert--ios .vkuiAlert__action {
  border: 0;
  border-radius: 0;
  color: #2688eb;
  color: var(--vkui--color_text_accent);
  display: block;
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_family_base);
  font-size: 17px;
  height: 44px;
  line-height: 44px;
  margin: 0;
  overflow: hidden;
  padding: 0 6px;
  position: relative;
  text-align: center;
  text-decoration: none;
  text-overflow: ellipsis
}

.vkuiAlert--ios .vkuiAlert__action:after {
  background: rgba(0, 0, 0, .12);
  background: var(--vkui--color_separator_primary_alpha);
  content: "";
  position: absolute
}

.vkuiAlert--ios .vkuiAlert__actions--direction-horizontal .vkuiAlert__action:after {
  height: 100%;
  right: 0;
  top: 0;
  transform-origin: right center;
  width: 1px
}

.vkuiAlert--ios .vkuiAlert__actions--direction-horizontal .vkuiAlert__action:last-child:after {
  content: none
}

.vkuiAlert--ios .vkuiAlert__actions--direction-horizontal .vkuiAlert__action {
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1
}

.vkuiAlert--ios .vkuiAlert__actions--direction-horizontal .vkuiAlert__action:first-child {
  border-bottom-left-radius: 12px;
  border-bottom-left-radius: var(--vkui--size_border_radius_paper--regular)
}

.vkuiAlert--ios .vkuiAlert__actions--direction-horizontal .vkuiAlert__action:last-child {
  border-bottom-right-radius: 12px;
  border-bottom-right-radius: var(--vkui--size_border_radius_paper--regular)
}

.vkuiAlert--ios .vkuiAlert__actions--direction-vertical .vkuiAlert__action:after {
  bottom: 0;
  height: 1px;
  left: 0;
  transform-origin: center bottom;
  width: 100%
}

.vkuiAlert--ios .vkuiAlert__actions--direction-vertical .vkuiAlert__action:last-child:after {
  content: none
}

.vkuiAlert--ios .vkuiAlert__actions--direction-vertical .vkuiAlert__action:last-child {
  border-radius: 0 0 12px 12px
}

@media (min-resolution:2dppx) {

  .vkuiAlert--ios .vkuiAlert__actions--direction-vertical .vkuiAlert__action:after,
  .vkuiAlert--ios .vkuiAlert__content:after {
    transform: scaleY(.5)
  }

  .vkuiAlert--ios .vkuiAlert__actions--direction-horizontal .vkuiAlert__action:after {
    transform: scaleX(.5)
  }
}

@media (min-resolution:3dppx) {

  .vkuiAlert--ios .vkuiAlert__actions--direction-vertical .vkuiAlert__action:after,
  .vkuiAlert--ios .vkuiAlert__content:after {
    transform: scaleY(.33)
  }

  .vkuiAlert--ios .vkuiAlert__actions--direction-horizontal .vkuiAlert__action:after {
    transform: scaleX(.33)
  }
}

.vkuiAlert--ios .vkuiAlert__action--mode-cancel {
  font-weight: 600
}

.vkuiAlert--ios .vkuiAlert__action--mode-destructive {
  color: #e64646;
  color: var(--vkui--color_text_negative)
}

.vkuiAlert--vkcom {
  box-shadow: 0 0 2px rgba(0, 0, 0, .12), 0 0 96px rgba(0, 0, 0, .16);
  width: 400px
}

.vkuiAlert--vkcom .vkuiAlert__content {
  padding-bottom: 20px
}

.vkuiAlert--vkcom .vkuiAlert__actions {
  padding: 0 20px 12px
}

.vkuiAlert--vkcom .vkuiAlert__button {
  order: 2
}

.vkuiAlert--vkcom .vkuiAlert__button--mode-cancel {
  order: 1
}

.vkuiAlert__dismiss {
  color: #99a2ad;
  color: var(--vkui--color_icon_secondary);
  position: absolute;
  right: 8px;
  top: 8px
}

@keyframes vkuianimation-ios-alert-intro {
  0% {
    opacity: 0;
    transform: scale(1.05)
  }

  to {
    opacity: 1;
    transform: scale(1)
  }
}

@keyframes vkuianimation-android-alert-intro {
  0% {
    opacity: 0;
    transform: scale(.95)
  }

  to {
    opacity: 1;
    transform: scale(1)
  }
}

.vkuiModalDismissButton {
  box-sizing: border-box;
  color: #fff;
  color: var(--vkui--color_icon_contrast);
  height: 56px;
  justify-content: center;
  padding: 18px;
  position: absolute;
  right: -56px;
  top: 0;
  transition: opacity .15s ease-out;
  width: 56px
}

.vkuiModalDismissButton:before {
  background: rgba(0, 0, 0, .4);
  background: var(--vkui--color_overlay_primary);
  border-radius: 50%;
  bottom: 14px;
  content: "";
  display: block;
  left: 14px;
  position: absolute;
  right: 14px;
  top: 14px
}

.vkuiModalDismissButton .vkuiIcon {
  transform: translateX(0)
}

.vkuiModalDismissButton--hover.vkuiModalDismissButton:before {
  background: rgba(0, 0, 0, .44);
  background: var(--vkui--color_overlay_primary--hover)
}

.vkuiModalDismissButton--active.vkuiModalDismissButton:before {
  background: rgba(0, 0, 0, .48);
  background: var(--vkui--color_overlay_primary--active)
}

.vkuiActionSheet {
  animation: vkuianimation-actionsheet-intro .2s cubic-bezier(.4, 0, .2, 1);
  animation: vkuianimation-actionsheet-intro .2s var(--vkui--animation_easing_platform);
  box-sizing: border-box;
  max-width: 430px;
  max-width: var(--vkui--size_popup_small--regular);
  padding: 10px;
  width: 100%
}

.vkuiActionSheet__content-wrapper {
  background: #fff;
  background: var(--vkui--color_background_modal);
  border-radius: 12px;
  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);
  box-shadow: var(--vkui--elevation3);
  overflow: hidden;
  padding: 8px 0
}

.vkuiActionSheet__header {
  color: #6d7885;
  color: var(--vkui--color_text_subhead);
  padding: 16px 20px
}

.vkuiActionSheet--closing {
  transform: translateY(calc(100% + 20px));
  transition: transform .2s cubic-bezier(.4, 0, .2, 1);
  transition: transform .2s var(--vkui--animation_easing_platform)
}

.vkuiActionSheet__title+.vkuiActionSheet__text {
  margin-top: 8px
}

.vkuiActionSheet--ios {
  animation: vkuianimation-actionsheet-intro .3s cubic-bezier(.4, 0, .2, 1);
  animation: vkuianimation-actionsheet-intro .3s var(--vkui--animation_easing_platform);
  background: transparent;
  padding: 8px
}

.vkuiActionSheet--ios .vkuiActionSheet__content-wrapper {
  border-radius: 14px;
  padding: 0
}

.vkuiActionSheet__close-item-wrapper--ios {
  background: #fff;
  background: var(--vkui--color_background_modal);
  border-radius: 14px;
  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);
  box-shadow: var(--vkui--elevation3);
  margin-bottom: 0;
  margin-bottom: var(--vkui_internal--safe_area_inset_bottom);
  margin-top: 8px;
  overflow: hidden
}

.vkuiActionSheet--ios.vkuiActionSheet--closing {
  transform: translateY(100%);
  transition: transform .3s cubic-bezier(.4, 0, .2, 1);
  transition: transform .3s var(--vkui--animation_easing_platform)
}

.vkuiActionSheet--ios .vkuiActionSheet__header {
  position: relative;
  text-align: center
}

.vkuiActionSheet--ios .vkuiActionSheet__text,
.vkuiActionSheet--ios .vkuiActionSheet__title {
  position: relative
}

.vkuiActionSheet--ios .vkuiActionSheet__header:before {
  background-color: #fff;
  background-color: var(--vkui--color_background_modal);
  content: "";
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%
}

.vkuiActionSheet--sizeY-compact .vkuiActionSheet__header {
  padding: 12px 20px
}

.vkuiActionSheet--menu {
  animation: none;
  height: auto;
  max-width: 100%;
  padding: 0;
  width: auto
}

.vkuiActionSheet--menu.vkuiActionSheet--ios .vkuiActionSheet__content-wrapper {
  border-radius: 14px;
  padding: 0
}

@keyframes vkuianimation-actionsheet-intro {
  0% {
    transform: translateY(100%)
  }

  to {
    transform: translateY(0)
  }
}

.vkuiPopper {
  z-index: 100;
  z-index: var(--vkui--z_index_popout)
}

.vkuiPopperArrow {
  position: absolute
}

.vkuiPopperArrow__in {
  content: "";
  display: block;
  transform: translateY(1px)
}

.vkuiPopperArrow--placement-right {
  transform: rotate(90deg) translate(50%, -50%);
  transform-origin: right
}

.vkuiPopperArrow--placement-bottom {
  transform: rotate(180deg)
}

.vkuiPopperArrow--placement-left {
  transform: rotate(-90deg) translate(-50%, -50%);
  transform-origin: left
}

.vkuiActionSheetItem {
  align-items: center;
  box-sizing: border-box;
  color: #000;
  color: var(--vkui--color_text_primary);
  display: flex;
  min-height: 48px;
  overflow: hidden;
  padding: 0 20px;
  position: relative;
  text-decoration: none
}

.vkuiActionSheetItem__after,
.vkuiActionSheetItem__before,
.vkuiActionSheetItem__container {
  position: relative
}

.vkuiActionSheetItem__after,
.vkuiActionSheetItem__before {
  flex-shrink: 0
}

.vkuiActionSheetItem__container {
  flex-grow: 1;
  max-width: 100%;
  padding: 10px 0
}

.vkuiActionSheetItem--ellipsis {
  overflow: hidden;
  white-space: nowrap
}

.vkuiActionSheetItem__content {
  align-items: baseline;
  display: flex;
  justify-content: space-between;
  overflow: hidden
}

.vkuiActionSheetItem--ellipsis .vkuiActionSheetItem__content {
  justify-content: flex-start
}

.vkuiActionSheetItem__children {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis
}

.vkuiActionSheetItem__subtitle {
  color: #818c99;
  color: var(--vkui--color_text_secondary);
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis
}

.vkuiActionSheetItem__meta {
  color: #818c99;
  color: var(--vkui--color_text_secondary);
  flex-shrink: 0;
  margin-left: 6px
}

.vkuiActionSheetItem__before {
  color: #2688eb;
  color: var(--vkui--color_icon_accent);
  margin-right: 16px
}

.vkuiActionSheetItem--menu .vkuiActionSheetItem__before {
  margin-right: 12px
}

.vkuiActionSheetItem--ios .vkuiActionSheetItem__before {
  color: #2688eb;
  color: var(--vkui--color_icon_accent_themed);
  margin-right: 18px
}

.vkuiActionSheetItem--mode-destructive .vkuiActionSheetItem__container:first-child {
  color: #e64646;
  color: var(--vkui--color_text_negative)
}

.vkuiActionSheetItem--mode-destructive .vkuiActionSheetItem__before {
  color: #e64646;
  color: var(--vkui--color_icon_negative)
}

.vkuiActionSheetItem__after {
  color: #2688eb;
  color: var(--vkui--color_icon_accent);
  display: flex;
  flex-direction: row;
  margin-left: 16px
}

.vkuiActionSheetItem__after>:not(:last-child) {
  margin-right: 12px
}

.vkuiActionSheetItem--ios {
  background: #fff;
  background: var(--vkui--color_background_modal);
  color: #2688eb;
  color: var(--vkui--color_text_accent_themed);
  min-height: 56px;
  padding: 14px 18px
}

.vkuiActionSheetItem--rich {
  color: #000;
  color: var(--vkui--color_text_primary)
}

.vkuiActionSheet--ios.vkuiActionSheetItem--selectable {
  padding: 14px 16px
}

.vkuiActionSheetItem--ios.vkuiActionSheetItem--mode-destructive {
  color: #e64646;
  color: var(--vkui--color_text_negative)
}

.vkuiActionSheetItem--ios:before {
  background-color: #fff;
  background-color: var(--vkui--color_background_modal);
  content: "";
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  transition: opacity .15s ease-out, background-color .15s ease-out;
  width: 100%
}

.vkuiActionSheetItem--ios:after {
  background: rgba(0, 0, 0, .12);
  background: var(--vkui--color_separator_primary_alpha);
  content: "";
  height: 1px;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transform-origin: center bottom
}

@media (min-resolution:2dppx) {
  .vkuiActionSheetItem--ios:after {
    transform: scaleY(.5)
  }
}

@media (min-resolution:3dppx) {
  .vkuiActionSheetItem--ios:after {
    transform: scaleY(.33)
  }
}

.vkuiActionSheet--ios .vkuiActionSheetItem--last:after,
.vkuiActionSheet--ios .vkuiActionSheet__header:empty,
.vkuiActionSheetItem--ios:first-child:after,
.vkuiActionSheetItem--mode-cancel:after {
  content: none
}

.vkuiActionSheetItem--ios.vkuiActionSheetItem--active:before {
  background-color: rgba(0, 16, 61, .08);
  background-color: var(--vkui--color_transparent--active);
  opacity: 1;
  transition: none
}

.vkuiActionSheetItem--ios .vkuiActionSheetItem__container {
  padding: 0
}

.vkuiActionSheetItem--ios .vkuiActionSheetItem--centered {
  justify-content: center
}

.vkuiActionSheetItem--mode-cancel {
  min-height: 52px
}

.vkuiActionSheetItem--menu {
  cursor: pointer;
  width: auto
}

.vkuiActionSheetItem[disabled] .vkuiActionSheetItem__children,
.vkuiActionSheetItem[disabled] .vkuiActionSheetItem__meta,
.vkuiActionSheetItem[disabled] .vkuiActionSheetItem__subtitle {
  color: #818c99;
  color: var(--vkui--color_text_secondary)
}

.vkuiActionSheetItem[disabled] .vkuiActionSheetItem__before,
.vkuiActionSheetItem[disabled] .vkuiActionSheetItem__marker {
  color: #99a2ad;
  color: var(--vkui--color_icon_secondary)
}

.vkuiActionSheetItem--sizeY-compact {
  min-height: 32px
}

.vkuiActionSheetItem--sizeY-compact.vkuiActionSheetItem--ios {
  min-height: 36px;
  padding: 4px 20px 4px 18px
}

.vkuiActionSheetItem--sizeY-compact:not(.vkuiActionSheetItem--ios)+.vkuiActionSheetItem--sizeY-compact:not(.vkuiActionSheetItem--ios) {
  margin-top: 2px
}

.vkuiActionSheetItem--sizeY-compact .vkuiActionSheetItem__container {
  padding: 5px 0
}

.vkuiActionSheetItemRadio__input~* {
  display: none
}

.vkuiActionSheetItemRadio__input:checked~* {
  display: block
}

.vkuiScreenSpinner {
  animation: vkuiscreen-spinner-intro .3s ease
}

.vkuiScreenSpinner--clickable {
  cursor: pointer
}

.vkuiScreenSpinner__spinner {
  opacity: 1;
  transition: opacity .1s ease
}

.vkuiScreenSpinner__spinner--hidden {
  opacity: 0
}

.vkuiScreenSpinner__container {
  background: #fff;
  background: var(--vkui--color_background_modal);
  border-radius: 8px;
  border-radius: var(--vkui--size_border_radius--regular);
  box-shadow: 0 0 8px rgba(0, 0, 0, .12), 0 16px 16px rgba(0, 0, 0, .16);
  box-shadow: var(--vkui--elevation4);
  color: #818c99;
  color: var(--vkui--color_icon_medium);
  height: 88px;
  position: relative;
  width: 88px
}

.vkuiScreenSpinner__icon {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  position: absolute;
  top: 0;
  width: 100%
}

.vkuiScreenSpinner__icon .vkuiIcon {
  animation: vkuiscreen-spinner-intro .2s ease
}

.vkuiScreenSpinner__icon--state-done .vkuiIcon path {
  stroke-dasharray: 50;
  stroke-dashoffset: 50;
  animation: vkuiscreen-spinner-icon-done .6s cubic-bezier(.4, 0, .2, 1) .3s forwards;
  animation: vkuiscreen-spinner-icon-done .6s .3s var(--vkui--animation_easing_platform) forwards
}

@keyframes vkuiscreen-spinner-icon-done {
  0% {
    stroke-dashoffset: 50
  }

  to {
    stroke-dashoffset: 0
  }
}

@keyframes vkuiscreen-spinner-intro {
  0% {
    opacity: 0
  }

  to {
    opacity: 1
  }
}

.vkuiSnackbar {
  bottom: 0;
  left: auto;
  padding-bottom: 0;
  padding-bottom: var(--vkui_internal--safe_area_inset_bottom);
  padding-left: 0;
  padding-left: var(--vkui_internal--safe_area_inset_left);
  padding-right: 0;
  padding-right: var(--vkui_internal--safe_area_inset_right);
  position: fixed;
  -webkit-user-select: none;
  user-select: none;
  width: 100%;
  z-index: 100;
  z-index: var(--vkui--z_index_popout)
}

.vkuiInternalEpic--hasTabbar .vkuiSnackbar {
  padding-bottom: calc(48px + 0px);
  padding-bottom: calc(var(--vkui_internal--tabbar_height) + var(--vkui_internal--safe_area_inset_bottom))
}

.vkuiSnackbar__body,
.vkuiSnackbar__in {
  transition: transform .32s cubic-bezier(.4, 0, .2, 1);
  transition: transform .32s var(--vkui--animation_easing_platform)
}

.vkuiSnackbar__in {
  animation: vkuianimation-snackbar-intro-vertical .34s cubic-bezier(.4, 0, .2, 1);
  animation: vkuianimation-snackbar-intro-vertical .34s var(--vkui--animation_easing_platform);
  padding: 8px
}

.vkuiSnackbar--closing .vkuiSnackbar__in {
  transform: translate3d(0, 140%, 0)
}

.vkuiSnackbar__body {
  align-items: center;
  background: #fff;
  background: var(--vkui--color_background_modal);
  border-radius: 8px;
  border-radius: var(--vkui--size_card_border_radius--regular);
  box-shadow: 0 0 8px rgba(0, 0, 0, .12), 0 16px 16px rgba(0, 0, 0, .16);
  box-shadow: var(--vkui--elevation4);
  box-sizing: border-box;
  display: flex;
  min-height: 56px;
  padding: 12px
}

.vkuiSnackbar--mode-dark .vkuiSnackbar__body {
  background: #2c2d2e;
  background: var(--vkui--color_background_contrast_inverse)
}

.vkuiSnackbar__before {
  margin-right: 12px
}

.vkuiSnackbar__after {
  margin-left: 12px
}

.vkuiSnackbar__content {
  align-items: center;
  display: flex;
  flex: 1 1;
  overflow: hidden
}

.vkuiSnackbar--layout-vertical .vkuiSnackbar__content {
  align-items: flex-start;
  flex-direction: column
}

.vkuiSnackbar__content-text {
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  color: #000;
  color: var(--vkui--color_text_primary);
  display: -webkit-box;
  flex: 1 1;
  overflow: hidden;
  width: 100%
}

.vkuiSnackbar__content-subtitle {
  color: #6d7885;
  color: var(--vkui--color_text_subhead);
  margin-top: 2px
}

.vkuiSnackbar--mode-dark .vkuiSnackbar__content-text {
  color: #fff;
  color: var(--vkui--color_text_contrast)
}

.vkuiSnackbar--layout-horizontal .vkuiSnackbar__action {
  margin-left: 12px;
  position: relative
}

.vkuiSnackbar--layout-vertical .vkuiSnackbar__action {
  margin-top: 2px;
  min-height: auto
}

.vkuiModalRoot .vkuiSnackbar {
  padding-bottom: 0;
  padding-bottom: var(--vkui_internal--safe_area_inset_bottom)
}

.vkuiSnackbar--ios .vkuiSnackbar__body,
.vkuiSnackbar--ios .vkuiSnackbar__in {
  transition: transform .4s cubic-bezier(.4, 0, .2, 1);
  transition: transform .4s var(--vkui--animation_easing_platform)
}

.vkuiSnackbar--desktop {
  bottom: 0;
  left: 0;
  max-width: 351px
}

.vkuiSnackbar--desktop .vkuiSnackbar__in {
  animation-name: vkuianimation-snackbar-intro-horizontal;
  padding: 12px
}

.vkuiSnackbar--desktop.vkuiSnackbar--closing .vkuiSnackbar__in {
  transform: translate3d(-140%, 0, 0)
}

.vkuiSnackbar--touched .vkuiSnackbar__body {
  transition: none
}

@keyframes vkuianimation-snackbar-intro-vertical {
  0% {
    transform: translate3d(0, 140%, 0)
  }

  to {
    transform: translateZ(0)
  }
}

@keyframes vkuianimation-snackbar-intro-horizontal {
  0% {
    transform: translate3d(-140%, 0, 0)
  }

  to {
    transform: translateZ(0)
  }
}

.vkuiModalRoot,
.vkuiModalRoot__mask {
  height: 100%;
  width: 100%
}

.vkuiModalRoot__mask {
  animation: vkuianimation-fade-in .32s ease;
  background: rgba(0, 0, 0, .4);
  left: 0;
  opacity: 1;
  position: absolute;
  top: 0;
  transition: opacity 167ms ease-out;
  -webkit-user-select: none;
  user-select: none
}

.vkuiModalRoot--touched .vkuiModalRoot__mask {
  transition: none
}

.vkuiModalRoot--switching .vkuiModalRoot__mask {
  pointer-events: none
}

.vkuiModalRoot__viewport {
  bottom: 0;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0
}

:not(.vkuiModalRoot--desktop).vkuiModalRoot .vkuiModalRoot__viewport {
  top: 0;
  top: var(--vkui_internal--safe_area_inset_top)
}

:not(.vkuiModalRoot--desktop).vkuiModalRoot--hasCustomPanelHeaderAfterSlot .vkuiModalRoot__viewport {
  top: calc(0px + 56px);
  top: calc(var(--vkui_internal--safe_area_inset_top) + var(--vkui--size_panel_header_height--regular))
}

.vkuiModalRoot__modal {
  box-sizing: border-box;
  height: 100%;
  position: absolute;
  width: 100%
}

@keyframes vkuianimation-fade-in {
  0% {
    opacity: 0
  }

  to {
    opacity: 1
  }
}

.vkuiModalPage {
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  width: 100%
}

.vkuiModalPage--desktop {
  align-items: center;
  display: flex;
  justify-content: center
}

.vkuiModalPage__in-wrap {
  align-items: flex-end;
  bottom: 0;
  display: flex;
  height: 100%;
  left: 0;
  margin-left: auto;
  margin-right: auto;
  pointer-events: auto;
  position: absolute;
  right: 0;
  transform: translateY(100%);
  transition: transform .32s cubic-bezier(.4, 0, .2, 1);
  transition: transform .32s var(--vkui--animation_easing_platform);
  width: 100%
}

.vkuiModalPage--ios .vkuiModalPage__in-wrap {
  transition: transform .4s cubic-bezier(.4, 0, .2, 1);
  transition: transform .4s var(--vkui--animation_easing_platform)
}

.vkuiModalPage--desktop .vkuiModalPage__in-wrap {
  align-items: normal;
  height: auto;
  margin: 32px 56px;
  max-height: 640px;
  opacity: 0;
  position: relative;
  transform: none;
  transition: opacity .34s cubic-bezier(.4, 0, .2, 1);
  transition: opacity .34s var(--vkui--animation_easing_platform)
}

@media (max-height:672px) {
  .vkuiModalPage--desktop .vkuiModalPage__in-wrap {
    max-height: calc(100% - 32px * 2)
  }
}

.vkuiModalPage--size-s .vkuiModalPage__in-wrap {
  max-width: 430px;
  max-width: var(--vkui--size_popup_small--regular)
}

.vkuiModalPage--size-m .vkuiModalPage__in-wrap {
  max-width: 680px;
  max-width: var(--vkui--size_popup_medium--regular)
}

.vkuiModalPage--size-l .vkuiModalPage__in-wrap {
  max-width: 880px;
  max-width: var(--vkui--size_popup_large--regular)
}

.vkuiModalPage__in {
  --vkui_internal--background: var(--vkui--color_background_modal);
  background-color: #fff;
  background-color: var(--vkui--color_background_modal);
  border-top-left-radius: 12px;
  border-top-left-radius: var(--vkui--size_border_radius_paper--regular);
  border-top-right-radius: 12px;
  border-top-right-radius: var(--vkui--size_border_radius_paper--regular);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: visible;
  position: relative;
  width: 100%
}

.vkuiModalPage--desktop .vkuiModalPage__in {
  border-bottom-left-radius: 12px;
  border-bottom-left-radius: var(--vkui--size_border_radius_paper--regular);
  border-bottom-right-radius: 12px;
  border-bottom-right-radius: var(--vkui--size_border_radius_paper--regular);
  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);
  box-shadow: var(--vkui--elevation3);
  height: auto
}

.vkuiModalPage__header {
  width: 100%
}

.vkuiModalPage__content-wrap {
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  position: relative
}

.vkuiModalPage__header:empty+.vkuiModalPage__content-wrap {
  border-radius: inherit
}

.vkuiModalPage__content {
  box-sizing: border-box;
  height: 100%;
  overflow-x: hidden;
  overflow-y: hidden
}

.vkuiInternalModalRoot__modal--expandable .vkuiModalPage__content,
.vkuiModalPage--desktop .vkuiModalPage__content {
  -webkit-overflow-scrolling: touch;
  overflow-y: auto
}

.vkuiInternalModalRoot__modal--expandable .vkuiModalPage__content-in,
.vkuiModalPage--desktop .vkuiModalPage__content-in {
  height: 100%
}

.vkuiModalPage__bottom-inset {
  flex-shrink: 0;
  height: 0;
  height: var(--vkui_internal--safe_area_inset_bottom)
}

.vkuiInternalModalRoot--touched .vkuiModalPage__in-wrap {
  transition: none
}

.vkuiInternalModalRoot--switching .vkuiModalPage__in-wrap {
  pointer-events: none
}

.vkuiInternalModalRoot__modal--collapsed .vkuiModalPage__content,
.vkuiInternalModalRoot__modal--dragging .vkuiModalPage__content {
  overflow: hidden;
  touch-action: pan-y
}

.vkuiModalPageHeader {
  --vkui_internal--safe_area_inset_top: 0
}

.vkuiModalPageHeader--withGaps {
  padding-left: 4px;
  padding-right: 4px
}

.vkuiModalPageHeader--desktop.vkuiModalPageHeader--withGaps {
  padding-left: 8px;
  padding-right: 8px
}

.vkuiModalPageHeader .vkuiIcon--cancel_24,
.vkuiModalPageHeader .vkuiIcon--dismiss_24 {
  color: #99a2ad;
  color: var(--vkui--color_icon_secondary)
}

.vkuiModalCard {
  align-items: flex-end;
  box-sizing: border-box;
  display: flex;
  height: 100%;
  left: 0;
  padding: 8px;
  position: absolute;
  top: 0;
  width: 100%
}

.vkuiModalCard__in {
  margin-left: auto;
  margin-right: auto;
  transform: translateY(calc(100% + 16px));
  transition: transform .34s cubic-bezier(.4, 0, .2, 1);
  transition: transform .34s var(--vkui--animation_easing_platform);
  width: 100%
}

.vkuiModalCard--ios .vkuiModalCard__in {
  max-width: 414px
}

.vkuiModalCard--android .vkuiModalCard__in {
  max-width: 440px
}

.vkuiModalCard--vkcom .vkuiModalCard__in {
  max-width: 400px
}

.vkuiModalCard--desktop {
  align-items: center
}

.vkuiModalCard--desktop .vkuiModalCard__in {
  opacity: 0;
  transform: unset;
  transition: opacity .34s cubic-bezier(.4, 0, .2, 1);
  transition: opacity .34s var(--vkui--animation_easing_platform)
}

.vkuiInternalModalRoot--touched .vkuiModalCard__in {
  transition: none
}

.vkuiModalCardBase__container {
  --vkui_internal--background: var(--vkui--color_background_modal);
  background: #fff;
  background: var(--vkui--color_background_modal);
  border-radius: 12px;
  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);
  box-shadow: var(--vkui--elevation3);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 0;
  margin-bottom: var(--vkui_internal--safe_area_inset_bottom);
  padding: 16px;
  pointer-events: auto;
  position: relative
}

.vkuiModalCardBase__container--softwareKeyboardOpened {
  margin-bottom: 0
}

.vkuiModalCardBase__header,
.vkuiModalCardBase__subheader {
  margin: 0;
  padding: 0 8px;
  text-align: center;
  word-break: break-word
}

.vkuiModalCardBase__header {
  color: #000;
  color: var(--vkui--color_text_primary)
}

.vkuiModalCardBase__subheader {
  color: #6d7885;
  color: var(--vkui--color_text_subhead)
}

.vkuiModalCardBase__header+.vkuiModalCardBase__subheader {
  margin-top: 8px
}

.vkuiModalCardBase__icon {
  color: #2688eb;
  color: var(--vkui--color_icon_accent);
  margin: 8px auto 16px
}

.vkuiModalCardBase__actions {
  display: flex;
  margin-top: 16px
}

.vkuiInternalUsersStack+.vkuiModalCardBase__actions {
  margin-top: 24px
}

.vkuiModalCardBase__header+.vkuiModalCardBase__actions,
.vkuiModalCardBase__subheader+.vkuiModalCardBase__actions {
  margin-top: 32px
}

.vkuiModalCardBase__dismiss {
  color: #99a2ad;
  color: var(--vkui--color_icon_secondary);
  height: 48px;
  justify-content: center;
  position: absolute;
  right: 4px;
  top: 4px;
  width: 48px
}

.vkuiModalCardBase--ios .vkuiModalCardBase__header:first-child {
  padding-left: 36px;
  padding-right: 36px
}

.vkuiModalCardBase--ios .vkuiModalCardBase__container {
  border-radius: 14px
}

.vkuiModalCardBase--desktop .vkuiModalCardBase__container {
  padding: 24px
}

.vkuiBadge {
  border-radius: 50%;
  display: block;
  flex-grow: 0;
  flex-shrink: 0;
  height: 6px;
  width: 6px
}

.vkuiBadge--mode-new {
  background-color: #2688eb;
  background-color: var(--vkui--color_icon_accent)
}

.vkuiBadge--mode-prominent {
  background-color: #ff3347;
  background-color: var(--vkui--color_accent_red)
}

.vkuiInternalTabbarItem__label .vkuiBadge {
  position: absolute;
  right: -2px;
  top: -2px
}

.vkuiButtonGroup {
  display: inline-flex;
  max-width: 100%
}

.vkuiButtonGroup--stretched {
  display: flex;
  width: 100%
}

.vkuiButtonGroup--mode-vertical {
  flex-direction: column
}

.vkuiButtonGroup--mode-horizontal {
  align-items: flex-start;
  flex-direction: row
}

.vkuiButtonGroup--mode-vertical.vkuiButtonGroup--gap-space>:not(:first-child) {
  margin-top: 1px;
  margin-top: var(--vkui--size_button_group_gap_space--regular)
}

.vkuiButtonGroup--mode-vertical.vkuiButtonGroup--gap-s>:not(:first-child) {
  margin-top: 8px;
  margin-top: var(--vkui--size_button_group_gap_small--regular)
}

.vkuiButtonGroup--mode-vertical.vkuiButtonGroup--gap-m>:not(:first-child) {
  margin-top: 12px;
  margin-top: var(--vkui--size_button_group_gap_medium--regular)
}

.vkuiButtonGroup--mode-horizontal>:not(.vkuiButtonGroup) {
  min-width: 0
}

.vkuiButtonGroup--mode-horizontal.vkuiButtonGroup--gap-space>:not(:last-child) {
  margin-right: 1px;
  margin-right: var(--vkui--size_button_group_gap_space--regular)
}

.vkuiButtonGroup--mode-horizontal.vkuiButtonGroup--gap-s>:not(:last-child) {
  margin-right: 8px;
  margin-right: var(--vkui--size_button_group_gap_small--regular)
}

.vkuiButtonGroup--mode-horizontal.vkuiButtonGroup--gap-m>:not(:last-child) {
  margin-right: 12px;
  margin-right: var(--vkui--size_button_group_gap_medium--regular)
}

.vkuiButtonGroup--mode-vertical.vkuiButtonGroup--align-left {
  align-items: flex-start
}

.vkuiButtonGroup--mode-vertical.vkuiButtonGroup--align-center {
  align-items: center
}

.vkuiButtonGroup--mode-vertical.vkuiButtonGroup--align-right {
  align-items: flex-end
}

.vkuiButtonGroup--mode-horizontal.vkuiButtonGroup--align-left {
  justify-content: flex-start
}

.vkuiButtonGroup--mode-horizontal.vkuiButtonGroup--align-center {
  justify-content: center
}

.vkuiButtonGroup--mode-horizontal.vkuiButtonGroup--align-right {
  justify-content: flex-end
}

.vkuiCard {
  background: #f5f5f5;
  background: var(--vkui--color_background_secondary);
  border-radius: 8px;
  border-radius: var(--vkui--size_card_border_radius--regular);
  position: relative
}

.vkuiCard--mode-shadow {
  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);
  box-shadow: var(--vkui--elevation3, 0 2px 24px 0 rgba(0, 0, 0, .08), 0 0 2px 0 rgba(0, 0, 0, .08))
}

.vkuiCard--mode-outline,
.vkuiCard--mode-shadow {
  background: #fff;
  background: var(--vkui--color_background_modal)
}

.vkuiCard--withBorder:after {
  border: var(--vkui--size_border--regular) solid var(--vkui--color_image_border_alpha);
  border-radius: inherit;
  box-sizing: border-box;
  content: "";
  display: block;
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%
}

.vkuiInternalCardScroll .vkuiCard {
  flex-shrink: 0;
  margin-right: 8px;
  margin-right: var(--vkui--size_cardgrid_padding--regular)
}

.vkuiInternalCardScroll .vkuiCard:last-of-type {
  margin-right: 0
}

.vkuiInternalCardScroll--size-s .vkuiCard {
  width: 40%
}

.vkuiInternalCardScroll--size-m .vkuiCard {
  width: 62%
}

.vkuiInternalCardScroll--size-l .vkuiCard {
  margin-right: 16px;
  margin-right: var(--vkui--size_base_padding_horizontal--regular);
  width: calc(100% - 16px * 2);
  width: calc(100% - var(--vkui--size_base_padding_horizontal--regular) * 2)
}

.vkuiInternalGroup--mode-card .vkuiInternalCardScroll--size-l .vkuiCard,
.vkuiInternalSplitCol--spaced .vkuiInternalCardScroll--size-l .vkuiCard {
  margin-right: 16px;
  width: calc(100% - 32px)
}

.vkuiInternalGroup--mode-card .vkuiInternalCardScroll--size-l .vkuiCard:last-of-type,
.vkuiInternalSplitCol--spaced .vkuiInternalCardScroll--size-l .vkuiCard:last-of-type {
  margin-right: 0
}

@media (min-width:768px) {
  .vkuiInternalGroup--mode-none .vkuiInternalCardScroll--size-l .vkuiCard:last-of-type {
    margin-right: 0
  }

  .vkuiInternalGroup--mode-none .vkuiInternalCardScroll--size-l .vkuiCard {
    margin-right: 16px;
    width: calc(100% - 32px)
  }
}

.vkuiInternalCardGrid .vkuiCard {
  margin-right: 8px;
  margin-right: var(--vkui--size_cardgrid_padding--regular)
}

.vkuiInternalCardGrid--size-l .vkuiCard {
  margin-right: 0;
  width: 100%
}

.vkuiInternalCardGrid--size-l .vkuiCard:not(:first-child) {
  margin-top: 8px;
  margin-top: var(--vkui--size_cardgrid_padding--regular)
}

.vkuiInternalCardGrid--size-m .vkuiCard {
  width: calc(50% - (8px / 2));
  width: calc(50% - (var(--vkui--size_cardgrid_padding--regular) / 2))
}

.vkuiInternalCardGrid--size-m .vkuiCard:nth-child(n+3) {
  margin-top: 8px;
  margin-top: var(--vkui--size_cardgrid_padding--regular)
}

.vkuiInternalCardGrid--size-m .vkuiCard:nth-child(2n) {
  margin-right: 0
}

.vkuiInternalCardGrid--size-s .vkuiCard {
  width: calc((100% - 2 * 8px) / 3);
  width: calc((100% - 2 * var(--vkui--size_cardgrid_padding--regular)) / 3)
}

.vkuiInternalCardGrid--size-s .vkuiCard:nth-child(n+4) {
  margin-top: 8px;
  margin-top: var(--vkui--size_cardgrid_padding--regular)
}

.vkuiInternalCardGrid--size-s .vkuiCard:nth-child(3n) {
  margin-right: 0
}

.vkuiCardGrid {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start
}

.vkuiCardGrid--spaced {
  padding: 12px 16px;
  padding: var(--vkui--size_base_padding_vertical--regular) var(--vkui--size_base_padding_horizontal--regular)
}

.vkuiCardGrid--sizeX-compact {
  padding-left: 16px;
  padding-left: var(--vkui--size_base_padding_horizontal--regular);
  padding-right: 16px;
  padding-right: var(--vkui--size_base_padding_horizontal--regular)
}

@media (max-width:767.9px) {
  .vkuiCardGrid--sizeX-none {
    padding-left: 16px;
    padding-left: var(--vkui--size_base_padding_horizontal--regular);
    padding-right: 16px;
    padding-right: var(--vkui--size_base_padding_horizontal--regular)
  }
}

.vkuiCardGrid+.vkuiCardGrid {
  margin-top: calc(8px * 2);
  margin-top: calc(var(--vkui--size_cardgrid_padding_vertical--regular) * 2)
}

.vkuiInternalGroup--mode-card .vkuiCardGrid {
  padding-left: 16px;
  padding-left: var(--vkui--size_base_padding_horizontal--regular);
  padding-right: 16px;
  padding-right: var(--vkui--size_base_padding_horizontal--regular)
}

@media (min-width:768px) {
  .vkuiInternalGroup--mode-none .vkuiCardGrid {
    padding-left: 8px;
    padding-right: 8px
  }
}

.vkuiInternalGroup .vkuiCardGrid:first-child {
  margin-top: 8px;
  margin-top: var(--vkui--size_cardgrid_padding_vertical--regular)
}

.vkuiInternalGroup .vkuiCardGrid:last-child {
  margin-bottom: 8px;
  margin-bottom: var(--vkui--size_cardgrid_padding_vertical--regular)
}

.vkuiCardScroll__in {
  align-items: stretch;
  display: flex
}

.vkuiCardScroll__gap {
  display: block;
  flex-shrink: 0
}

.vkuiCardScroll+.vkuiCardScroll {
  margin-top: 16px
}

.vkuiCardScroll--withSpaces .vkuiCardScroll__gap {
  width: 16px;
  width: var(--vkui--size_base_padding_horizontal--regular)
}

.vkuiInternalSplitCol--spaced .vkuiCardScroll--withSpaces .vkuiCardScroll {
  margin-left: -16px;
  margin-right: -16px
}

.vkuiInternalSplitCol--spaced .vkuiCardScroll--withSpaces .vkuiCardScroll__gap {
  width: 16px
}

.vkuiInternalGroup--mode-card .vkuiCardScroll--withSpaces {
  margin-left: -8px;
  margin-right: -8px
}

.vkuiInternalGroup--mode-card .vkuiCardScroll--withSpaces:first-child {
  padding-top: 8px;
  padding-top: var(--vkui--size_cardgrid_padding_vertical--regular)
}

.vkuiInternalGroup--mode-card .vkuiCardScroll--withSpaces:last-child {
  padding-bottom: 8px;
  padding-bottom: var(--vkui--size_cardgrid_padding_vertical--regular)
}

@media (min-width:768px) {
  .vkuiInternalGroup--mode-none .vkuiCardScroll--withSpaces {
    margin-left: -8px;
    margin-right: -8px
  }

  .vkuiInternalGroup--mode-none .vkuiCardScroll--withSpaces:first-child {
    padding-top: 8px;
    padding-top: var(--vkui--size_cardgrid_padding_vertical--regular)
  }

  .vkuiInternalGroup--mode-none .vkuiCardScroll--withSpaces:last-child {
    padding-bottom: 8px;
    padding-bottom: var(--vkui--size_cardgrid_padding_vertical--regular)
  }
}

.vkuiContentCard--disabled {
  opacity: .64;
  opacity: var(--vkui--opacity_disable_accessibility)
}

.vkuiContentCard__body {
  padding: 12px 16px;
  padding: var(--vkui--size_base_padding_vertical--regular) var(--vkui--size_base_padding_horizontal--regular)
}

.vkuiContentCard__tappable {
  border-radius: 8px;
  border-radius: var(--vkui--size_card_border_radius--regular);
  color: #000;
  color: var(--vkui--color_text_primary);
  display: block;
  text-decoration: none
}

.vkuiContentCard__img {
  border-radius: 8px 8px 0 0;
  border-radius: var(--vkui--size_card_border_radius--regular) var(--vkui--size_card_border_radius--regular) 0 0;
  display: block;
  object-fit: cover
}

.vkuiContentCard__text:not(:last-child) {
  margin-bottom: 4px
}

.vkuiContentCard__caption,
.vkuiContentCard__subtitle {
  color: #818c99;
  color: var(--vkui--color_text_secondary)
}

.vkuiHeader {
  align-items: flex-start;
  display: flex;
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_family_base);
  padding: 0 0 0 16px;
  padding-left: var(--vkui--size_base_padding_horizontal--regular);
  padding-right: 16px;
  padding-right: var(--vkui--size_base_padding_horizontal--regular);
  -webkit-user-select: text;
  user-select: text
}

.vkuiHeader__main {
  color: #000;
  color: var(--vkui--color_text_primary);
  flex: 1 0;
  min-width: 0
}

.vkuiHeader__content {
  align-items: center;
  display: flex
}

.vkuiHeader__content-in,
.vkuiHeader__subtitle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

.vkuiHeader__content--multiline {
  white-space: normal;
  word-break: break-word
}

.vkuiHeader__subtitle {
  display: block
}

.vkuiHeader--mode-secondary:not(.vkuiHeader--pi):not(.vkuiHeader--with-subtitle) .vkuiHeader__main,
.vkuiHeader--mode-tertiary .vkuiHeader__main,
.vkuiHeader__indicator,
.vkuiHeader__subtitle {
  color: #818c99;
  color: var(--vkui--color_text_secondary)
}

.vkuiHeader__indicator {
  flex-shrink: 0;
  margin-left: 6px
}

.vkuiHeader--mode-primary .vkuiHeader__indicator {
  color: #6d7885;
  color: var(--vkui--color_text_subhead)
}

.vkuiHeader:not(.vkuiHeader--pi) .vkuiHeader__indicator {
  align-self: center
}

.vkuiHeader--mode-secondary .vkuiHeader__indicator {
  margin-left: 8px
}

.vkuiHeader__aside {
  display: flex;
  white-space: nowrap
}

.vkuiHeader__aside.vkuiHeader__aside>* {
  margin-bottom: 7px;
  margin-left: 12px;
  margin-top: 13px
}

.vkuiHeader__aside>.vkuiIcon {
  color: #99a2ad;
  color: var(--vkui--color_icon_secondary);
  position: relative
}

.vkuiHeader__aside>.vkuiIcon--24 {
  margin-bottom: 5px;
  margin-top: 11px
}

.vkuiHeader__aside>.vkuiIcon--16 {
  margin-bottom: 9px;
  margin-top: 15px
}

.vkuiHeader--mode-primary {
  padding-bottom: 1px;
  padding-top: 3px
}

.vkuiHeader__content {
  margin-top: 12px
}

.vkuiHeader__content:last-child {
  margin-bottom: 8px
}

.vkuiHeader--mode-tertiary .vkuiHeader__content {
  margin-top: 15px
}

.vkuiHeader--mode-tertiary .vkuiHeader__content:last-child {
  margin-bottom: 9px
}

.vkuiHeader__subtitle {
  margin-bottom: 7px
}

.vkuiHeader--mode-primary .vkuiHeader__subtitle {
  margin-bottom: 6px
}

.vkuiHeader--large .vkuiHeader__content {
  margin-bottom: 6px;
  margin-top: 10px
}

.vkuiInternalGroup--mode-plain:not(:first-of-type)>.vkuiHeader:first-child,
.vkuiInternalGroup--mode-plain:not(:first-of-type)>.vkuiInternalTappable:first-child>.vkuiHeader {
  margin-top: -16px
}

@media (max-width:767.9px) {

  .vkuiInternalGroup--sizeX-none.vkuiInternalGroup--mode-none:not(:first-of-type)>.vkuiHeader:first-child,
  .vkuiInternalGroup--sizeX-none.vkuiInternalGroup--mode-none:not(:first-of-type)>.vkuiInternalTappable:first-child>.vkuiHeader {
    margin-top: -16px
  }
}

.vkuiInternalGroup--mode-card>.vkuiHeader:not(.vkuiHeader--mode-tertiary):first-child,
.vkuiInternalGroup--mode-card>.vkuiInternalTappable:first-child>.vkuiHeader:not(.vkuiHeader--mode-tertiary) {
  margin-top: -4px
}

@media (min-width:768px) {

  .vkuiInternalGroup--sizeX-none.vkuiInternalGroup--mode-none>.vkuiHeader:not(.vkuiHeader--mode-tertiary):first-child,
  .vkuiInternalGroup--sizeX-none.vkuiInternalGroup--mode-none>.vkuiInternalTappable:first-child>.vkuiHeader:not(.vkuiHeader--mode-tertiary) {
    margin-top: -4px
  }
}

.vkuiHeader__aside {
  --vkui_internal--link-color: var(--vkui--color_text_accent)
}

.vkuiGroup {
  color: #000;
  color: var(--vkui--color_text_primary);
  /* padding-bottom: 8px;
  padding-top: 8px */
}

.vkuiGroup__header:empty {
  display: none
}

.vkuiGroup--mode-plain:not(:first-of-type)>.vkuiGroup__header {
  margin-top: -8px
}

@media (max-width:767.9px) {
  .vkuiGroup--sizeX-none.vkuiGroup--mode-none:not(:first-of-type)>.vkuiGroup__header {
    margin-top: -8px
  }
}

.vkuiGroup--mode-card>.vkuiGroup__header {
  margin-top: -4px
}

@media (min-width:768px) {
  .vkuiGroup--sizeX-none.vkuiGroup--mode-none>.vkuiGroup__header {
    margin-top: -4px
  }
}

.vkuiGroup__separator--separator,
.vkuiGroup__separator--spacing {
  display: none
}

.vkuiGroup--mode-plain+*+.vkuiGroup__separator--separator {
  display: block
}

@media (max-width:767.9px) {
  .vkuiGroup--sizeX-none.vkuiGroup--mode-none+*+.vkuiGroup__separator--separator {
    display: block
  }
}

.vkuiGroup--mode-card+.vkuiGroup__separator--spacing {
  display: block
}

@media (min-width:768px) {
  .vkuiGroup--sizeX-none.vkuiGroup--mode-none+.vkuiGroup__separator--spacing {
    display: block
  }
}

.vkuiGroup:last-of-type~.vkuiGroup__separator {
  display: none
}

.vkuiGroup--mode-card:last-of-type+.vkuiGroup__separator--spacing,
.vkuiGroup:last-of-type~.vkuiGroup__separator--force {
  display: block
}

@media (min-width:768px) {
  .vkuiGroup--sizeX-none.vkuiGroup--mode-none:last-of-type+.vkuiGroup__separator--spacing {
    display: block
  }
}

.vkuiGroup--mode-card.vkuiGroup--padding-s {
  padding: 4px
}

.vkuiGroup--mode-card.vkuiGroup--padding-m {
  padding: 8px
}

@media (min-width:768px) {

  .vkuiGroup--sizeX-none.vkuiGroup--inside-modal.vkuiGroup--padding-s,
  .vkuiGroup--sizeX-none.vkuiGroup--mode-none.vkuiGroup--padding-s {
    padding: 4px
  }

  .vkuiGroup--sizeX-none.vkuiGroup--inside-modal.vkuiGroup--padding-m,
  .vkuiGroup--sizeX-none.vkuiGroup--mode-none.vkuiGroup--padding-m {
    padding: 8px
  }
}

.vkuiGroup--sizeX-compact,
.vkuiGroup--sizeX-compact.vkuiGroup--mode-card {
  padding-left: 0;
  padding-right: 0
}

@media (max-width:767.9px) {

  .vkuiGroup--sizeX-none,
  .vkuiGroup--sizeX-none.vkuiGroup--mode-card {
    padding-left: 0;
    padding-right: 0
  }
}

.vkuiGroup--mode-card {
  background: #fff;
  background: var(--vkui--color_background_content);
  border-radius: 12px;
  border-radius: var(--vkui--size_border_radius_paper--regular);
  position: relative
}

@media (min-width:768px) {
  .vkuiGroup--sizeX-none.vkuiGroup--mode-none {
    background: #fff;
    background: var(--vkui--color_background_content);
    border-radius: 12px;
    border-radius: var(--vkui--size_border_radius_paper--regular);
    position: relative
  }
}

.vkuiGroup--sizeX-compact.vkuiGroup--mode-card:first-of-type {
  border-radius: 0 0 12px 12px;
  border-radius: 0 0 var(--vkui--size_border_radius_paper--regular) var(--vkui--size_border_radius_paper--regular)
}

@media (max-width:767.9px) {
  .vkuiGroup--sizeX-none.vkuiGroup--mode-card:first-of-type {
    border-radius: 0 0 12px 12px;
    border-radius: 0 0 var(--vkui--size_border_radius_paper--regular) var(--vkui--size_border_radius_paper--regular)
  }
}

.vkuiGroup--mode-card:before {
  border-radius: inherit;
  box-shadow: inset 0 0 0 var(--vkui--size_border--regular) #d7d8d9;
  box-shadow: inset 0 0 0 var(--vkui--size_border--regular) var(--vkui--color_separator_primary);
  content: "";
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%
}

@media (min-width:768px) {
  .vkuiGroup--sizeX-none.vkuiGroup--mode-none:before {
    border-radius: inherit;
    box-shadow: inset 0 0 0 var(--vkui--size_border--regular) rgba(0, 0, 0, .12);
    box-shadow: inset 0 0 0 var(--vkui--size_border--regular) var(--vkui--color_field_border_alpha);
    content: "";
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%
  }
}

.vkuiGroup--sizeX-compact.vkuiGroup--mode-card:before {
  box-shadow: none
}

@media (max-width:767.9px) {
  .vkuiGroup--sizeX-none.vkuiGroup--mode-card:before {
    box-shadow: none
  }
}

.vkuiGroup--mode-plain+.vkuiGroup__separator,
.vkuiGroup--mode-plain+.vkuiGroup__separator+.vkuiGroup__separator {
  padding-bottom: 8px;
  padding-top: 8px
}

@media (max-width:767.9px) {

  .vkuiGroup--sizeX-none.vkuiGroup--mode-none+.vkuiGroup__separator,
  .vkuiGroup--sizeX-none.vkuiGroup--mode-none+.vkuiGroup__separator+.vkuiGroup__separator {
    padding-bottom: 8px;
    padding-top: 8px
  }
}

.vkuiGroup__description {
  color: #818c99;
  color: var(--vkui--color_text_secondary);
  display: block;
  padding: 4px 16px 16px
}

.vkuiGroup .vkuiGroup,
.vkuiGroup .vkuiGroup+.vkuiGroup__separator {
  padding-left: 0;
  padding-right: 0
}

.vkuiGroup .vkuiGroup:first-of-type {
  padding-top: 0
}

.vkuiGroup .vkuiGroup:last-of-type {
  padding-bottom: 0
}

.vkuiGroup--ios .vkuiGroup__description {
  padding: 4px 12px 16px
}

.vkuiInternalPanelHeader--vkcom+* .vkuiGroup:first-of-type,
.vkuiInternalPanelHeader--vkcom~.vkuiGroup:first-of-type {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  position: relative;
  top: -1px
}

.vkuiGradient--mode-tint.vkuiGradient--to-top {
  background: linear-gradient(180deg, hsla(0, 0%, 98%, 0) 0, hsla(0, 0%, 98%, .036) 13%, hsla(0, 0%, 98%, .15) 27%, hsla(0, 0%, 98%, .79) 68%, hsla(0, 0%, 98%, .95) 84%, #f9f9f9);
  background: linear-gradient(to bottom, var(--vkui--gradient_tint))
}

.vkuiGradient--mode-tint.vkuiGradient--to-bottom {
  background: linear-gradient(0deg, hsla(0, 0%, 98%, 0) 0, hsla(0, 0%, 98%, .036) 13%, hsla(0, 0%, 98%, .15) 27%, hsla(0, 0%, 98%, .79) 68%, hsla(0, 0%, 98%, .95) 84%, #f9f9f9);
  background: linear-gradient(to top, var(--vkui--gradient_tint))
}

.vkuiGradient--mode-white.vkuiGradient--to-top {
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0) 0, hsla(0, 0%, 100%, .036) 13%, hsla(0, 0%, 100%, .15) 27%, hsla(0, 0%, 100%, .79) 68%, hsla(0, 0%, 100%, .95) 84%, #fff);
  background: linear-gradient(to bottom, var(--vkui--gradient_white))
}

.vkuiGradient--mode-white.vkuiGradient--to-bottom {
  background: linear-gradient(0deg, hsla(0, 0%, 100%, 0) 0, hsla(0, 0%, 100%, .036) 13%, hsla(0, 0%, 100%, .15) 27%, hsla(0, 0%, 100%, .79) 68%, hsla(0, 0%, 100%, .95) 84%, #fff);
  background: linear-gradient(to top, var(--vkui--gradient_white))
}

.vkuiGradient--mode-black.vkuiGradient--to-top {
  background: linear-gradient(180deg, transparent 0, rgba(0, 0, 0, .014) 13%, rgba(0, 0, 0, .06) 27%, rgba(0, 0, 0, .316) 68%, rgba(0, 0, 0, .38) 84%, rgba(0, 0, 0, .4));
  background: linear-gradient(to bottom, var(--vkui--gradient_black))
}

.vkuiGradient--mode-black.vkuiGradient--to-bottom {
  background: linear-gradient(0deg, transparent 0, rgba(0, 0, 0, .014) 13%, rgba(0, 0, 0, .06) 27%, rgba(0, 0, 0, .316) 68%, rgba(0, 0, 0, .38) 84%, rgba(0, 0, 0, .4));
  background: linear-gradient(to top, var(--vkui--gradient_black))
}

.vkuiList {
  isolation: isolate
}

.vkuiCell {
  position: relative
}

.vkuiInternalList--dragging .vkuiCell:not(.vkuiCell--dragging) {
  pointer-events: none;
  transition: transform .3s ease
}

.vkuiCell--dragging {
  background-color: #f5f5f5;
  background-color: var(--vkui--color_background_secondary);
  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);
  box-shadow: var(--vkui--elevation3);
  z-index: 1;
  z-index: var(--vkui_internal--z_index_cell_dragging)
}

.vkuiCell--selectable.vkuiCell--disabled {
  opacity: .64;
  opacity: var(--vkui--opacity_disable_accessibility)
}

.vkuiCell__checkbox,
.vkuiCell__dragger {
  flex-shrink: 0;
  margin-right: 16px;
  position: relative
}

.vkuiCell__content {
  max-width: 100%;
  min-width: 0
}

.vkuiCell--removable .vkuiCell__content {
  flex-grow: 1;
  padding-right: 44px
}

.vkuiCell--removable .vkuiInternalRemovable__content {
  padding-left: 0
}

.vkuiCell--removable .vkuiInternalRemovable__action {
  padding-left: 0;
  position: absolute;
  right: 0
}

.vkuiCell--ios .vkuiCell__dragger {
  margin-left: 12px;
  margin-right: 0
}

.vkuiCell--ios .vkuiCell__checkbox {
  margin-right: 12px
}

.vkuiCell--ios.vkuiCell--removable .vkuiCell__content {
  padding-left: 48px;
  padding-right: 16px;
  padding-right: var(--vkui--size_base_padding_horizontal--regular)
}

.vkuiCell--ios.vkuiCell--removable .vkuiInternalRemovable__action {
  left: 0;
  right: auto;
  z-index: 1
}

.vkuiCell--ios.vkuiCell--removable .vkuiInternalRemovable__content {
  padding-right: 0
}

.vkuiInternalFormItem>.vkuiCell {
  margin: 0 calc(-1 * 16px);
  margin: 0 calc(-1 * var(--vkui--size_base_padding_horizontal--regular))
}

.vkuiCellDragger {
  color: #99a2ad;
  color: var(--vkui--color_icon_secondary);
  cursor: ns-resize
}

.vkuiCellCheckbox {
  display: flex;
  justify-content: center;
  width: 24px
}

.vkuiCellCheckbox__icon {
  color: #b8c1cc;
  color: var(--vkui--color_icon_tertiary);
  display: none
}

.vkuiCellCheckbox__icon--on {
  color: #2688eb;
  color: var(--vkui--color_icon_accent)
}

.vkuiCellCheckbox__input:checked~.vkuiCellCheckbox__icon--on,
.vkuiCellCheckbox__input:not(:checked)~.vkuiCellCheckbox__icon--off {
  display: block
}

.vkuiRemovable__content {
  align-items: center;
  display: flex;
  padding-left: 16px;
  padding-left: var(--vkui--size_base_padding_horizontal--regular);
  position: relative
}

.vkuiRemovable__action {
  border: 0;
  color: #99a2ad;
  color: var(--vkui--color_icon_secondary);
  flex-grow: 0;
  flex-shrink: 0;
  position: relative
}

.vkuiRemovable--align-start .vkuiRemovable__action {
  align-self: flex-start
}

.vkuiRemovable--ios {
  overflow: hidden
}

.vkuiRemovable__remove {
  background-color: #e64646;
  background-color: var(--vkui--color_background_negative);
  border: 0;
  border-radius: 0;
  color: #fff;
  color: var(--vkui_internal--white);
  font-size: 15px;
  height: 100%;
  left: 100%;
  line-height: 45px;
  padding: 0 10px;
  position: absolute;
  top: 0
}

.vkuiRemovable__remove-in {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%
}

@media (prefers-reduced-motion:no-preference) {
  .vkuiRemovable--ios .vkuiRemovable__content {
    transition: transform .6s cubic-bezier(.4, 0, .2, 1);
    transition: transform .6s var(--vkui--animation_easing_platform)
  }
}

.vkuiRemovable__toggle {
  background: none;
  display: block;
  height: 44px;
  margin: 0 2px;
  width: 44px
}

.vkuiRemovable__toggle-in {
  align-content: center;
  align-items: center;
  border: 0;
  display: flex;
  height: 100%;
  justify-content: center;
  position: relative;
  width: 100%
}

.vkuiRemovable__toggle-in:after {
  background-color: #e64646;
  background-color: var(--vkui--color_background_negative);
  border-radius: 50%;
  content: "";
  height: 22px;
  width: 22px
}

.vkuiRemovable__toggle-in:before {
  background-color: #fff;
  background-color: var(--vkui_internal--white);
  content: "";
  display: block;
  height: 2px;
  position: absolute;
  width: 12px
}

.vkuiRemovable--ios .vkuiRemovable__content {
  padding-left: 0;
  padding-right: 16px;
  padding-right: var(--vkui--size_base_padding_horizontal--regular)
}

.vkuiRemovable--indent .vkuiRemovable__action {
  pointer-events: none;
  visibility: hidden
}

.vkuiInternalFormItem--removable .vkuiRemovable__content,
.vkuiInternalFormLayoutGroup--removable .vkuiRemovable__content {
  align-items: flex-start;
  flex-wrap: wrap
}

.vkuiRemovable__offset {
  display: none
}

.vkuiInternalFormItem--withTop .vkuiInternalFormItem__removable~.vkuiRemovable__offset,
.vkuiInternalFormLayoutGroup--removable .vkuiInternalFormItem--withTop~.vkuiRemovable__offset {
  display: block;
  height: calc(2px + 18px + 8px);
  height: calc(2px + var(--vkui--font_subhead--line_height--regular) + 8px);
  order: -1;
  width: 100%
}

.vkuiInternalFormItem--sizeY-compact.vkuiInternalFormItem--withTop .vkuiInternalFormItem__removable~.vkuiRemovable__offset,
.vkuiInternalFormLayoutGroup--sizeY-compact.vkuiInternalFormLayoutGroup--removable .vkuiInternalFormItem--withTop~.vkuiRemovable__offset {
  height: calc(2px + 16px + 6px);
  height: calc(2px + var(--vkui--font_subhead--line_height--compact) + 6px)
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {

  .vkuiInternalFormItem--sizeY-none.vkuiInternalFormItem--withTop .vkuiInternalFormItem__removable~.vkuiRemovable__offset,
  .vkuiInternalFormLayoutGroup--sizeY-none.vkuiInternalFormLayoutGroup--removable .vkuiInternalFormItem--withTop~.vkuiRemovable__offset {
    height: calc(2px + 16px + 6px);
    height: calc(2px + var(--vkui--font_subhead--line_height--compact) + 6px)
  }
}

.vkuiSimpleCell {
  align-items: center;
  color: #000;
  color: var(--vkui--color_text_primary);
  display: flex;
  min-height: 48px;
  padding-left: 16px;
  padding-left: var(--vkui--size_base_padding_horizontal--regular);
  padding-right: 16px;
  padding-right: var(--vkui--size_base_padding_horizontal--regular);
  text-decoration: none;
  white-space: nowrap
}

.vkuiSimpleCell--mult {
  white-space: normal
}

.vkuiSimpleCell--mult .vkuiSimpleCell__children {
  text-overflow: clip
}

.vkuiSimpleCell__before {
  align-items: center;
  color: #2688eb;
  color: var(--vkui_internal--icon_color, var(--vkui--color_icon_accent));
  display: flex;
  padding-bottom: 6px;
  padding-right: 12px;
  padding-top: 6px
}

.vkuiSimpleCell__before>.vkuiIcon {
  padding-right: 4px
}

.vkuiSimpleCell__before:empty {
  display: none
}

.vkuiSimpleCell__middle {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  padding-bottom: 10px;
  padding-top: 10px
}

.vkuiSimpleCell__middle>:not(:first-child) {
  margin-top: 2px
}

.vkuiSimpleCell__subhead {
  color: #6d7885;
  color: var(--vkui--color_text_subhead)
}

.vkuiSimpleCell__text {
  overflow: hidden;
  text-overflow: ellipsis
}

.vkuiSimpleCell__extraSubtitle,
.vkuiSimpleCell__subtitle {
  color: #818c99;
  color: var(--vkui--color_text_secondary)
}

.vkuiSimpleCell .vkuiSimpleCell__content {
  align-content: flex-start;
  align-items: center;
  display: flex;
  justify-content: space-between;
  max-width: 100%
}

.vkuiSimpleCell:not(.vkuiSimpleCell--mult) .vkuiSimpleCell__content {
  justify-content: flex-start
}

.vkuiSimpleCell__children {
  color: inherit;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis
}

.vkuiSimpleCell--mult .vkuiSimpleCell__children,
.vkuiSimpleCell--mult .vkuiSimpleCell__subtitle {
  flex: 1 1 auto
}

.vkuiSimpleCell__badge {
  color: #2688eb;
  color: var(--vkui--color_icon_accent);
  display: inline-block;
  flex-grow: 0;
  flex-shrink: 0
}

.vkuiSimpleCell__content>:not(:last-child) {
  margin-right: 4px
}

.vkuiSimpleCell__indicator {
  color: #818c99;
  color: var(--vkui--color_text_secondary);
  min-width: 0;
  overflow: hidden;
  padding-left: 12px;
  text-overflow: ellipsis;
  white-space: nowrap
}

.vkuiSimpleCell__after {
  align-items: center;
  color: #2688eb;
  color: var(--vkui_internal--icon_color, var(--vkui--color_icon_accent));
  display: flex;
  flex-shrink: 0
}

.vkuiSimpleCell__after>.vkuiIcon {
  padding-left: 8px
}

.vkuiSimpleCell__after>.vkuiIcon:last-child {
  padding-right: 2px
}

.vkuiSimpleCell__chevronIcon {
  color: #b8c1cc;
  color: var(--vkui--color_icon_tertiary);
  padding-left: 12px
}

.vkuiSimpleCell--sizeY-compact {
  min-height: 44px
}

.vkuiSimpleCell--sizeY-compact .vkuiSimpleCell__before {
  padding-bottom: 4px;
  padding-top: 4px
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiSimpleCell--sizeY-none {
    min-height: 44px
  }

  .vkuiSimpleCell--sizeY-none .vkuiSimpleCell__before {
    padding-bottom: 4px;
    padding-top: 4px
  }
}

.vkuiInternalFormItem>.vkuiSimpleCell {
  margin: 0 calc(-1 * 16px);
  margin: 0 calc(-1 * var(--vkui--size_base_padding_horizontal--regular))
}

.vkuiRichCell {
  box-sizing: border-box;
  color: #000;
  color: var(--vkui--color_text_primary);
  display: flex;
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_family_base);
  min-height: 64px;
  padding: 8px 16px;
  padding: 8px var(--vkui--size_base_padding_horizontal--regular);
  text-decoration: none
}

.vkuiRichCell--sizeY-compact {
  min-height: 60px
}

.vkuiRichCell__before {
  margin-right: 12px
}

.vkuiRichCell__in {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  max-width: 100%;
  min-width: 0
}

.vkuiRichCell__content {
  display: flex;
  word-break: break-word
}

.vkuiRichCell__content-before {
  flex-grow: 1;
  min-width: 0
}

.vkuiRichCell__content-after {
  align-items: flex-end;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  padding-left: 12px
}

.vkuiRichCell__after-children {
  font-weight: 500;
  font-weight: var(--vkui--font_weight_accent2)
}

.vkuiRichCell__after-caption {
  color: #818c99;
  color: var(--vkui--color_text_secondary);
  font-size: 13px;
  font-size: var(--vkui--font_footnote--font_size--regular);
  line-height: 16px;
  line-height: var(--vkui--font_footnote--line_height--regular);
  margin-top: 2px
}

.vkuiRichCell--sizeY-compact .vkuiRichCell__after-caption {
  font-size: 12px;
  font-size: var(--vkui--font_caption1--font_size--regular);
  line-height: 14px;
  line-height: var(--vkui--font_caption1--line_height--regular)
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiRichCell--sizeY-none .vkuiRichCell__after-caption {
    font-size: 12px;
    font-size: var(--vkui--font_caption1--font_size--regular);
    line-height: 14px;
    line-height: var(--vkui--font_caption1--line_height--regular)
  }
}

.vkuiRichCell__caption,
.vkuiRichCell__subhead {
  color: #818c99;
  color: var(--vkui--color_text_secondary)
}

.vkuiRichCell__caption {
  margin-top: 1px
}

.vkuiRichCell__children {
  font-weight: 500;
  font-weight: var(--vkui--font_weight_accent2)
}

.vkuiRichCell--text-ellipsis .vkuiRichCell__caption,
.vkuiRichCell--text-ellipsis .vkuiRichCell__children,
.vkuiRichCell--text-ellipsis .vkuiRichCell__subhead,
.vkuiRichCell--text-ellipsis .vkuiRichCell__text {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

.vkuiRichCell__bottom {
  margin-top: 5px
}

.vkuiRichCell__actions {
  margin-top: 8px
}

.vkuiRichCell__after-children,
.vkuiRichCell__children,
.vkuiRichCell__text {
  font-size: 15px;
  font-size: var(--vkui--font_paragraph--font_size--regular);
  line-height: 20px;
  line-height: var(--vkui--font_paragraph--line_height--regular)
}

.vkuiRichCell--sizeY-compact .vkuiRichCell__after-children,
.vkuiRichCell--sizeY-compact .vkuiRichCell__children,
.vkuiRichCell--sizeY-compact .vkuiRichCell__text {
  font-size: 14px;
  font-size: var(--vkui--font_subhead--font_size--regular);
  line-height: 18px;
  line-height: var(--vkui--font_subhead--line_height--regular)
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {

  .vkuiRichCell--sizeY-none .vkuiRichCell__after-children,
  .vkuiRichCell--sizeY-none .vkuiRichCell__children,
  .vkuiRichCell--sizeY-none .vkuiRichCell__text {
    font-size: 14px;
    font-size: var(--vkui--font_subhead--font_size--regular);
    line-height: 18px;
    line-height: var(--vkui--font_subhead--line_height--regular)
  }
}

.vkuiInternalFormItem .vkuiRichCell {
  margin-left: calc(-1 * 16px);
  margin-left: calc(-1 * var(--vkui--size_base_padding_horizontal--regular));
  margin-right: calc(-1 * 16px);
  margin-right: calc(-1 * var(--vkui--size_base_padding_horizontal--regular))
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiRichCell--sizeY-none {
    min-height: 60px
  }
}

.vkuiRichCellIcon {
  align-items: center;
  box-sizing: border-box;
  color: #2688eb;
  color: var(--vkui--color_icon_accent_themed);
  display: flex;
  flex-direction: row;
  height: 40px;
  justify-content: flex-end;
  padding: 6px 0 6px 12px;
  width: 48px
}

.vkuiCellButton {
  background: transparent;
  border: 0;
  box-sizing: border-box;
  cursor: pointer;
  margin: 0;
  padding-bottom: 0;
  padding-top: 0;
  text-align: left;
  text-decoration: none;
  width: 100%
}

.vkuiInternalFormItem .vkuiCellButton {
  box-sizing: initial;
  margin: 0 calc(-1 * 16px);
  margin: 0 calc(-1 * var(--vkui--size_base_padding_horizontal--regular));
  width: 100%
}

.vkuiCellButton[disabled] {
  opacity: .4
}

.vkuiCellButton--centered {
  justify-content: center;
  text-align: center
}

.vkuiCellButton--centered>* {
  flex-grow: 0;
  max-width: none
}

.vkuiCellButton--centered .vkuiIcon {
  padding-right: 8px
}

.vkuiCellButton {
  --vkui_internal--icon_color: var(--vkui--color_icon_accent);
  color: #2688eb;
  color: var(--vkui--color_text_accent)
}

.vkuiCellButton--mode-danger {
  --vkui_internal--icon_color: var(--vkui--color_text_negative);
  color: #e64646;
  color: var(--vkui--color_text_negative)
}

.vkuiHorizontalCell {
  display: flex
}

.vkuiHorizontalCell__image {
  display: flex;
  justify-content: center
}

.vkuiHorizontalCell__body {
  font-family: inherit;
  text-decoration: none
}

.vkuiHorizontalCell .vkuiHorizontalCell__body {
  border-radius: 8px;
  border-radius: var(--vkui--size_border_radius--regular)
}

.vkuiHorizontalCell__content {
  color: #000;
  color: var(--vkui--color_text_primary);
  text-overflow: ellipsis;
  word-break: break-all
}

.vkuiHorizontalCell__subtitle {
  color: #818c99;
  color: var(--vkui--color_text_secondary)
}

.vkuiHorizontalCell__content .vkuiHorizontalCell__subtitle {
  margin-top: 2px
}

.vkuiHorizontalCell--size-s {
  --vkui_internal--side_cell_gap: calc(var(--vkui--size_base_padding_horizontal--regular) - var(--vkui--spacing_size_m));
  --vkui_internal--side_cell_width: calc(72px + var(--vkui_internal--side_cell_gap));
  max-width: 72px
}

.vkuiHorizontalCell__image {
  padding: 4px 6px;
  padding: 4px var(--vkui--spacing_size_s)
}

.vkuiHorizontalCell__content {
  padding: 2px 6px 8px;
  text-align: left
}

.vkuiHorizontalCell--size-s .vkuiHorizontalCell__image {
  padding: 4px 8px;
  padding: 4px var(--vkui--spacing_size_m)
}

.vkuiHorizontalCell--size-s .vkuiHorizontalCell__content {
  padding: 2px 4px 8px;
  text-align: center
}

.vkuiHorizontalCell--size-m {
  --vkui_internal--side_cell_width: calc(100px + var(--vkui_internal--side_cell_gap));
  width: 100px
}

.vkuiHorizontalCell--size-l {
  width: auto
}

.vkuiHorizontalCell:first-child:before,
.vkuiHorizontalCell:last-child:after {
  content: "";
  min-width: calc(16px - 6px);
  min-width: var(--vkui_internal--side_cell_gap)
}

.vkuiHorizontalCell--size-s:first-child,
.vkuiHorizontalCell--size-s:last-child {
  max-width: var(--vkui_internal--side_cell_width)
}

.vkuiHorizontalCell--size-m:first-child,
.vkuiHorizontalCell--size-m:last-child {
  width: var(--vkui_internal--side_cell_width)
}

.vkuiAvatar {
  border-radius: 50%
}

.vkuiAvatar--has-gradient {
  color: #fff;
  color: var(--vkui--color_text_contrast)
}

.vkuiAvatar--gradient-red {
  background-color: #e52e40;
  background-image: linear-gradient(135deg, #ff7583, #e52e40)
}

.vkuiAvatar--gradient-pink {
  background-color: #e62e6b;
  background-image: linear-gradient(135deg, #ff8880, #e62e6b)
}

.vkuiAvatar--gradient-orange {
  background-color: #e66b2e;
  background-image: linear-gradient(135deg, #ffbf80, #e66b2e)
}

.vkuiAvatar--gradient-yellow {
  background-color: #e7a902;
  background-image: linear-gradient(135deg, #ffd54f, #e7a902)
}

.vkuiAvatar--gradient-green {
  background-color: #6cd97e;
  background-image: linear-gradient(135deg, #6cd97e, #12b212)
}

.vkuiAvatar--gradient-l-blue {
  background-color: #2bb4d6;
  background-image: linear-gradient(135deg, #7df1fa, #2bb4d6)
}

.vkuiAvatar--gradient-blue {
  background-color: #3f8ae0;
  background-image: linear-gradient(135deg, #6cf, #3f8ae0)
}

.vkuiAvatar--gradient-violet {
  background-color: #8f3fe0;
  background-image: linear-gradient(135deg, #d3a6ff, #8f3fe0)
}

.vkuiAvatar__initials {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_family_accent);
  font-weight: 600;
  line-height: 1;
  text-align: center;
  text-transform: uppercase
}

.vkuiAvatarBadge {
  bottom: 0;
  right: 0
}

.vkuiAvatarBadge--shifted {
  bottom: -2px;
  right: -2px
}

.vkuiAvatarBadge--preset-online,
.vkuiAvatarBadge--preset-onlineMobile {
  bottom: 14%;
  color: #4bb34b;
  color: var(--vkui--color_accent_green);
  right: 14%;
  transform: translate(50%, 50%)
}

.vkuiAvatarBadge--preset-online {
  padding: 0
}

.vkuiAvatarBadge--preset-onlineMobile {
  border-radius: 3px
}

.vkuiFooter {
  color: #818c99;
  color: var(--vkui--color_text_secondary);
  display: block;
  margin: 24px 16px;
  margin: 24px var(--vkui--size_base_padding_horizontal--regular);
  padding-bottom: 0;
  padding-top: 0;
  text-align: center
}

.vkuiInfoRow {
  -webkit-user-select: text;
  user-select: text
}

.vkuiInfoRow,
.vkuiInfoRow__header {
  overflow: hidden;
  text-overflow: ellipsis
}

.vkuiInfoRow__header {
  color: #6d7885;
  color: var(--vkui--color_text_subhead);
  display: block;
  margin-bottom: 2px;
  white-space: nowrap
}

.vkuiBaseGallery {
  overflow: hidden;
  position: relative;
  -webkit-user-select: none;
  user-select: none
}

.vkuiBaseGallery__viewport {
  height: 100%;
  margin: 0;
  position: relative
}

.vkuiBaseGallery--align-center .vkuiBaseGallery__viewport {
  margin: 0 auto
}

.vkuiBaseGallery__layer {
  align-items: stretch;
  display: flex;
  height: 100%;
  min-height: 100px;
  width: 100%
}

.vkuiBaseGallery--draggable .vkuiBaseGallery__layer {
  cursor: grab
}

.vkuiBaseGallery__layer:empty {
  min-height: 0
}

.vkuiBaseGallery__slide {
  flex: 0 0 auto;
  max-width: 100%;
  overflow: hidden;
  width: 100%
}

.vkuiBaseGallery--custom-width .vkuiBaseGallery__slide {
  width: auto
}

.vkuiBaseGallery__slide>* {
  min-height: 100%;
  width: 100%
}

.vkuiBaseGallery__bullets {
  align-items: center;
  bottom: 10px;
  display: flex;
  height: 6px;
  justify-content: center;
  left: 0;
  position: absolute;
  width: 100%
}

.vkuiBaseGallery__bullets--dark .vkuiBaseGallery__bullet {
  background-color: #2c2d2e;
  background-color: var(--vkui--color_icon_primary_invariably)
}

.vkuiBaseGallery__bullets--light .vkuiBaseGallery__bullet {
  background-color: #fff;
  background-color: var(--vkui--color_icon_contrast)
}

.vkuiBaseGallery__bullet {
  border-radius: 10px;
  height: 6px;
  margin: 0 3px;
  opacity: .64;
  opacity: var(--vkui--opacity_disable_accessibility);
  width: 18px
}

.vkuiBaseGallery__bullet--active {
  opacity: 1
}

.vkuiBaseGallery__arrow {
  opacity: 0;
  position: absolute;
  top: 0
}

.vkuiBaseGallery:hover .vkuiBaseGallery__arrow {
  opacity: .64;
  opacity: var(--vkui--opacity_disable_accessibility)
}

.vkuiBaseGallery .vkuiBaseGallery__arrow:hover {
  opacity: 1
}

.vkuiGridAvatar {
  border-radius: 50%
}

.vkuiGridAvatar__in {
  border-radius: inherit;
  display: flex;
  flex-flow: column wrap;
  height: 100%;
  overflow: hidden;
  width: 100%
}

.vkuiGridAvatar__item {
  background-position: 50%;
  background-size: cover;
  height: calc(50% - 2px / 2);
  height: calc(50% - var(--vkui_internal--grid_avatar_image_offset) / 2);
  margin-right: 2px;
  margin-right: var(--vkui_internal--grid_avatar_image_offset);
  width: calc(50% - 2px / 2);
  width: calc(50% - var(--vkui_internal--grid_avatar_image_offset) / 2)
}

.vkuiGridAvatar__item:only-child {
  width: 100%
}

.vkuiGridAvatar__item:first-child:not(:nth-last-child(4)),
.vkuiGridAvatar__item:nth-child(2):last-child {
  height: 100%
}

.vkuiGridAvatar__item:nth-last-child(4),
.vkuiGridAvatar__item:nth-last-child(n+3)~.vkuiGridAvatar__item:nth-last-child(2) {
  margin-bottom: 2px;
  margin-bottom: var(--vkui_internal--grid_avatar_image_offset)
}

.vkuiGridAvatarBadge {
  bottom: 0;
  right: 0
}

.vkuiGridAvatarBadge--shifted {
  bottom: -2px;
  right: -2px
}

.vkuiImageBadge {
  bottom: -4px;
  position: absolute;
  right: -4px
}

.vkuiImageBadge--shifted {
  bottom: -3px;
  right: -3px
}

.vkuiProgress {
  background: #e1e3e6;
  background: var(--vkui--color_track_background);
  border-radius: 1px;
  height: 2px
}

.vkuiProgress__in {
  border-radius: inherit;
  height: 100%;
  transition: width .2s ease
}

.vkuiProgress--appearance-accent .vkuiProgress__in {
  background: #2688eb;
  background: var(--vkui--color_stroke_accent)
}

.vkuiProgress--appearance-positive .vkuiProgress__in {
  background: #4bb34b;
  background: var(--vkui--color_stroke_positive)
}

.vkuiProgress--appearance-negative .vkuiProgress__in {
  background: #e64646;
  background: var(--vkui--color_stroke_negative)
}

.vkuiSearch {
  -webkit-tap-highlight-color: transparent;
  --vkui_internal--search_height: var(--vkui--size_search_height--regular);
  display: flex;
  overflow: hidden
}

.vkuiSearch--withPadding {
  padding: 8px 16px;
  padding: 8px var(--vkui--size_base_padding_horizontal--regular)
}

.vkuiSearch--sizeY-compact {
  --vkui_internal--search_height: var(--vkui--size_search_height--compact)
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiSearch--sizeY-none {
    --vkui_internal--search_height: var(--vkui--size_search_height--compact)
  }
}

.vkuiSearch__field {
  background-color: #ebedf0;
  background-color: var(--vkui--color_search_field_background);
  border-radius: 8px;
  border-radius: var(--vkui--size_border_radius--regular);
  display: flex;
  flex: 2 1;
  height: var(--vkui_internal--search_height);
  position: relative;
  width: 10000px
}

.vkuiSearch__field:hover {
  background-color: #e2e4e9;
  background-color: var(--vkui--color_search_field_background--hover)
}

.vkuiSearch__field:active {
  background-color: #d8dbe2;
  background-color: var(--vkui--color_search_field_background--active)
}

.vkuiSearch__control {
  align-items: center;
  border-radius: inherit;
  color: #818c99;
  color: var(--vkui--color_icon_medium);
  display: flex;
  height: 100%;
  justify-content: flex-start;
  padding-left: 12px;
  width: calc(100% - 1px)
}

.vkuiSearch__input {
  -webkit-appearance: none;
  background-color: initial;
  border: 0;
  border-radius: inherit;
  bottom: 0;
  box-sizing: border-box;
  color: #000;
  color: var(--vkui--color_text_primary);
  flex-grow: 1;
  height: 100%;
  left: 0;
  margin: 0;
  max-width: 100%;
  min-width: 0;
  padding: 0 0 0 36px;
  position: absolute;
  right: 0;
  top: 0;
  width: -webkit-fill-available;
  width: -moz-available;
  width: stretch
}

.vkuiSearch__input::-webkit-search-cancel-button,
.vkuiSearch__input::-webkit-search-decoration,
.vkuiSearch__input::-webkit-search-results-button,
.vkuiSearch__input::-webkit-search-results-decoration {
  display: none
}

.vkuiSearch__input:focus {
  outline: none
}

.vkuiSearch--has-after .vkuiSearch__input {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0
}

.vkuiSearch--has-icon .vkuiSearch__input,
.vkuiSearch--has-value .vkuiSearch__input {
  margin-right: calc(var(--vkui_internal--search_height) + 4px)
}

.vkuiSearch--has-icon.vkuiSearch--has-value .vkuiSearch__input {
  margin-right: calc((var(--vkui_internal--search_height) + 4px) * 2)
}

.vkuiSearch--disabled {
  cursor: default;
  pointer-events: none
}

.vkuiSearch--disabled,
.vkuiSearch__input:disabled {
  opacity: .64;
  opacity: var(--vkui--opacity_disable_accessibility)
}

.vkuiSearch__input::placeholder {
  color: #818c99;
  color: var(--vkui--color_text_secondary);
  opacity: 1
}

.vkuiSearch__input:disabled::placeholder {
  color: #818c99;
  color: var(--vkui--color_text_secondary)
}

.vkuiSearch__icons {
  color: #99a2ad;
  color: var(--vkui--color_icon_secondary)
}

.vkuiSearch__icon,
.vkuiSearch__icons {
  align-items: center;
  display: flex;
  justify-content: center
}

.vkuiSearch__icon {
  border-radius: 8px;
  border-radius: var(--vkui--size_border_radius--regular);
  height: 100%;
  width: calc(var(--vkui_internal--search_height) + 4px)
}

.vkuiSearch__icon .vkuiIcon {
  padding: 0
}

.vkuiSearch__after {
  flex: 0 1;
  margin-left: 4px;
  margin-right: calc(4px - 16px);
  margin-right: calc(4px - var(--vkui--size_base_padding_horizontal--regular));
  max-width: min-content;
  min-width: auto;
  overflow: hidden;
  pointer-events: none;
  transform: translate(50%);
  transform-origin: left;
  transition: flex .3s cubic-bezier(.4, 0, .2, 1), transform .3s cubic-bezier(.4, 0, .2, 1);
  transition: flex .3s var(--vkui--animation_easing_platform), transform .3s var(--vkui--animation_easing_platform)
}

.vkuiSearch--focused .vkuiSearch__after,
.vkuiSearch--has-value .vkuiSearch__after {
  flex: 1 1;
  pointer-events: auto;
  transform: translate(0)
}

.vkuiSearch__afterText {
  display: block;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap
}

.vkuiGroup--mode-plain .vkuiSearch {
  padding-top: 4px
}

.vkuiTabs__in {
  align-items: stretch;
  display: flex
}

.vkuiTabs--withGaps {
  justify-content: flex-start
}

.vkuiInternalPanelHeader .vkuiTabs {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_family_base);
  overflow: hidden
}

.vkuiInternalPanelHeader .vkuiTabs:after {
  content: "";
  display: block;
  width: 1000px
}

.vkuiInternalGroup--mode-plain>.vkuiTabs--mode-default:first-child {
  margin-top: -8px
}

.vkuiInternalGroup--mode-card>.vkuiTabs--mode-default:first-child {
  margin-top: -4px
}

.vkuiInternalFixedLayout--ios.vkuiInternalFixedLayout--vertical-bottom .vkuiTabs:after {
  background: #fff;
  background: var(--vkui--color_background_content);
  content: "";
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%
}

.vkuiInternalFixedLayout--ios.vkuiInternalFixedLayout--vertical-bottom .vkuiSeparator,
.vkuiInternalFixedLayout--ios.vkuiInternalFixedLayout--vertical-bottom .vkuiTabs__in {
  position: relative;
  z-index: 2;
  z-index: var(--vkui_internal--z_index_tabs)
}

.vkuiTabsItem {
  align-items: center;
  border-radius: 8px;
  border-radius: var(--vkui--size_border_radius--regular);
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  max-width: 100%;
  min-height: 32px;
  min-width: 0;
  padding: 4px 8px;
  transition: background-color .15s ease-out
}

.vkuiTabsItem--withGaps {
  margin-bottom: 8px;
  margin-top: 8px
}

.vkuiTabsItem--withGaps:not(:first-of-type) {
  margin-left: 6px
}

.vkuiTabsItem--sizeY-compact {
  min-height: 28px;
  padding-bottom: 2px;
  padding-top: 2px
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiTabsItem--sizeY-none {
    min-height: 28px;
    padding-bottom: 2px;
    padding-top: 2px
  }
}

.vkuiTabsItem[disabled] {
  opacity: .64;
  opacity: var(--vkui--opacity_disable_accessibility)
}

.vkuiTabsItem--mode-default {
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 0;
  min-height: 48px;
  padding: 12px 16px;
  position: relative
}

.vkuiTabsItem--sizeY-compact.vkuiTabsItem--mode-default {
  min-height: 44px;
  padding-bottom: 10px;
  padding-top: 10px
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiTabsItem--sizeY-none.vkuiTabsItem--mode-default {
    min-height: 44px;
    padding-bottom: 10px;
    padding-top: 10px
  }
}

.vkuiTabsItem--hover.vkuiTabsItem--mode-default {
  background-color: rgba(0, 16, 61, .04);
  background-color: var(--vkui--color_transparent--hover)
}

.vkuiTabsItem--mode-accent {
  transition: background-color .15s ease-out, box-shadow .15s ease-out
}

.vkuiTabsItem--selected.vkuiTabsItem--mode-accent {
  background-color: #fff;
  background-color: var(--vkui--color_background_modal);
  box-shadow: 0 4px 8px rgba(0, 0, 0, .04), 0 0 4px rgba(0, 0, 0, .06);
  box-shadow: var(--vkui--elevation2)
}

.vkuiTabsItem--hover.vkuiTabsItem--mode-accent {
  background-color: #f5f5f5;
  background-color: var(--vkui--color_background_secondary)
}

.vkuiTabsItem--mode-accent:before {
  border: var(--vkui--size_border--regular) solid transparent;
  border-radius: inherit;
  bottom: 0;
  content: "";
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0
}

.vkuiTabsItem--selected.vkuiTabsItem--mode-accent:before {
  border-color: #d7d8d9;
  border-color: var(--vkui--color_separator_primary)
}

.vkuiTabsItem--selected.vkuiTabsItem--mode-secondary {
  background-color: rgba(0, 0, 0, .04);
  background-color: var(--vkui--color_background_secondary_alpha)
}

.vkuiTabsItem--hover.vkuiTabsItem--mode-secondary {
  background-color: rgba(0, 0, 0, .08);
  background-color: var(--vkui--color_background_secondary_alpha--hover)
}

.vkuiTabsItem__before {
  color: #818c99;
  color: var(--vkui--color_icon_medium);
  margin-right: 6px;
  transition: color .15s ease-out
}

.vkuiTabsItem--selected .vkuiTabsItem__before {
  color: #2c2d2e;
  color: var(--vkui--color_icon_primary)
}

.vkuiTabsItem--selected.vkuiTabsItem--mode-accent .vkuiTabsItem__before {
  color: #2688eb;
  color: var(--vkui--color_icon_accent_themed)
}

.vkuiTabsItem--selected.vkuiTabsItem--mode-secondary .vkuiTabsItem__before {
  opacity: .72
}

.vkuiTabsItem__label {
  color: #818c99;
  color: var(--vkui--color_text_secondary);
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color .15s ease-out;
  white-space: nowrap
}

.vkuiTabsItem--selected .vkuiTabsItem__label {
  color: #000;
  color: var(--vkui--color_text_primary)
}

.vkuiTabsItem--selected.vkuiTabsItem--mode-accent .vkuiTabsItem__label {
  color: #2688eb;
  color: var(--vkui--color_text_accent_themed)
}

.vkuiTabsItem--selected.vkuiTabsItem--mode-secondary .vkuiTabsItem__label {
  opacity: .72
}

.vkuiTabsItem__status {
  margin-left: 6px
}

.vkuiTabsItem__status--count {
  color: #99a2ad;
  color: var(--vkui--color_text_tertiary)
}

.vkuiTabsItem__after {
  color: #2688eb;
  color: var(--vkui--color_icon_accent_themed);
  margin-left: 6px
}

.vkuiTabsItem__underline {
  background-color: #2688eb;
  background-color: var(--vkui--color_background_accent);
  border-radius: 2px;
  bottom: 5px;
  height: 2px;
  left: 16px;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  right: 16px;
  transition: opacity .15s ease-out
}

.vkuiTabsItem--sizeY-compact .vkuiTabsItem__underline {
  bottom: 3px
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiTabsItem--sizeY-none .vkuiTabsItem__underline {
    bottom: 3px
  }
}

.vkuiTabsItem__underline[data-selected=true] {
  opacity: 1
}

.vkuiInternalTabs--vkcom .vkuiTabsItem {
  flex-grow: 0;
  min-width: auto;
  padding-left: 10px;
  padding-right: 10px
}

.vkuiInternalTabs--vkcom .vkuiTabsItem__underline {
  bottom: 0;
  left: 2px;
  right: 2px
}

.vkuiInternalHorizontalScroll .vkuiTabsItem {
  flex-basis: auto;
  flex-grow: 1;
  flex-shrink: 0;
  min-width: 64px
}

.vkuiPullToRefresh {
  flex-grow: 1
}

.vkuiPullToRefresh--refreshing {
  pointer-events: none;
  touch-action: none
}

.vkuiPullToRefresh__controls {
  pointer-events: none;
  width: 100%
}

.vkuiPullToRefresh:not(.vkuiPullToRefresh--ios) .vkuiPullToRefresh__controls {
  z-index: 9;
  z-index: var(--vkui_internal--z_index_pull_to_refresh)
}

.vkuiPullToRefresh__spinner {
  align-items: center;
  background: #fff;
  background: var(--vkui--color_background_modal);
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, .2);
  box-sizing: border-box;
  color: #2688eb;
  color: var(--vkui--color_icon_accent);
  display: flex;
  height: 40px;
  justify-content: center;
  margin: auto;
  opacity: 0;
  transition: transform .3s cubic-bezier(.1, 0, .25, 1), opacity .22s ease-out;
  width: 40px
}

.vkuiPullToRefresh--ios .vkuiPullToRefresh__spinner {
  background: none;
  border-radius: 0;
  box-shadow: none;
  color: #818c99;
  color: var(--vkui--color_icon_medium)
}

.vkuiPullToRefresh--watching .vkuiPullToRefresh__spinner {
  transition: opacity .22s ease-out
}

.vkuiPullToRefresh__spinner-self {
  stroke: currentColor
}

.vkuiPullToRefresh--ios.vkuiPullToRefresh--refreshing .vkuiPullToRefresh__spinner-self {
  animation: vkuipull-to-refresh-to-refreshing .38s ease-out
}

.vkuiPullToRefresh__spinner-path {
  transform: rotate(-90deg);
  transform-origin: center center;
  transition: stroke-dashoffset 167ms ease-out
}

.vkuiPullToRefresh--refreshing .vkuiPullToRefresh__spinner-path,
.vkuiPullToRefresh--watching .vkuiPullToRefresh__spinner-path {
  transition: none
}

.vkuiPullToRefresh__spinner--on .vkuiPullToRefresh__spinner-path {
  animation: vkuiptr-rotator .7s linear infinite;
  animation: vkuiptr-rotator var(--vkui_internal--duration) linear infinite
}

.vkuiPullToRefresh__content {
  overflow: hidden;
  transition: transform .4s cubic-bezier(.4, 0, .2, 1);
  transition: transform .4s var(--vkui--animation_easing_platform)
}

.vkuiPullToRefresh--watching .vkuiPullToRefresh__content {
  transition: none
}

@keyframes vkuipull-to-refresh-to-refreshing {
  0% {
    transform: scale(1)
  }

  30% {
    transform: scale(.6)
  }

  90% {
    transform: scale(1.1)
  }

  to {
    transform: scale(1)
  }
}

@keyframes vkuiptr-rotator {
  0% {
    transform: rotate(0deg)
  }

  to {
    transform: rotate(1turn)
  }
}

.vkuiLink {
  background: none;
  border: 0;
  border-radius: 0;
  color: #2d81e0;
  color: var(--vkui_internal--link-color, var(--vkui--color_text_link));
  cursor: pointer;
  display: inline;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  margin: 0;
  padding: 0;
  text-decoration: none
}

@media (hover:hover) and (pointer:fine) {
  .vkuiLink:hover {
    text-decoration: underline
  }
}

.vkuiLink--focus-visible {
  outline: 2px solid #2688eb !important;
  outline: 2px solid var(--vkui--color_stroke_accent) !important
}

.vkuiLink--has-visited:visited {
  color: #4986cc;
  color: var(--vkui--color_text_link_visited)
}

.vkuiLink .vkuiIcon {
  display: inline-block;
  margin-left: 4px;
  vertical-align: middle
}

.vkuiTooltip__overlay {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%
}

.vkuiTooltipBase {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  white-space: normal;
  width: 100%
}

.vkuiTooltipBase__content {
  background-color: #fff;
  background-color: var(--vkui--color_background_modal);
  border-radius: 8px;
  border-radius: var(--vkui--size_border_radius--regular);
  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);
  box-shadow: var(--vkui--elevation3);
  color: #000;
  color: var(--vkui--color_text_primary);
  padding: 9px 12px 10px
}

.vkuiTooltipBase__arrow {
  color: #fff;
  color: var(--vkui--color_background_modal)
}

.vkuiTooltipBase--appearance-accent .vkuiTooltipBase__content {
  background-color: #5a9eff;
  background-color: var(--vkui--color_background_accent_tint);
  color: #fff;
  color: var(--vkui--color_text_contrast)
}

.vkuiTooltipBase--appearance-accent .vkuiTooltipBase__arrow {
  color: #5a9eff;
  color: var(--vkui--color_background_accent_tint)
}

.vkuiTooltipBase--appearance-white .vkuiTooltipBase__content {
  background-color: #fff;
  background-color: var(--vkui--color_background_contrast);
  color: #000;
  color: var(--vkui--color_text_primary_invariably)
}

.vkuiTooltipBase--appearance-white .vkuiTooltipBase__arrow {
  color: #fff;
  color: var(--vkui--color_background_contrast)
}

.vkuiTooltipBase--appearance-black .vkuiTooltipBase__content {
  background-color: #2c2d2e;
  background-color: var(--vkui--color_background_contrast_inverse);
  color: #fff;
  color: var(--vkui--color_text_contrast)
}

.vkuiTooltipBase--appearance-black .vkuiTooltipBase__arrow {
  color: #2c2d2e;
  color: var(--vkui--color_background_contrast_inverse)
}

.vkuiTooltipBase--appearance-inversion .vkuiTooltipBase__content {
  background-color: #2d2d2e;
  background-color: var(--vkui--color_background_modal_inverse);
  color: #fff;
  color: var(--vkui--color_text_contrast_themed)
}

.vkuiTooltipBase--appearance-inversion .vkuiTooltipBase__arrow {
  color: #2d2d2e;
  color: var(--vkui--color_background_modal_inverse)
}

.vkuiCounter {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center
}

.vkuiCounter--mode-primary {
  background: #2688eb;
  background: var(--vkui--color_background_accent);
  color: #fff;
  color: var(--vkui--color_text_contrast)
}

.vkuiCounter--mode-secondary {
  background: #99a2ad;
  background: var(--vkui--color_icon_secondary);
  color: #fff;
  color: var(--vkui--color_text_contrast_themed)
}

.vkuiCounter--mode-prominent {
  background: #ff3347;
  background: var(--vkui--color_accent_red);
  color: #fff;
  color: var(--vkui--color_text_contrast)
}

.vkuiCounter--mode-contrast {
  background: #fff;
  background: var(--vkui--color_background_content);
  color: #2688eb;
  color: var(--vkui--color_text_accent_themed)
}

.vkuiCounter--size-m {
  border-radius: 12px;
  height: 24px;
  min-width: 24px
}

.vkuiCounter--size-s {
  border-radius: 9px;
  height: 18px;
  min-width: 18px
}

.vkuiCounter--mode-inherit {
  background-color: #99a2ad;
  background-color: var(--vkui_internal--counter_inherit_background, var(--vkui--color_icon_secondary));
  color: #fff;
  color: var(--vkui_internal--counter_inherit_color, var(--vkui--color_text_contrast_themed))
}

.vkuiInternalPanelHeaderButton .vkuiCounter {
  padding: 0;
  position: absolute;
  right: 2px;
  top: 8px
}

.vkuiInternalTabbarItem__label .vkuiCounter {
  position: absolute;
  right: -9px;
  top: -2px
}

.vkuiUsersStack {
  align-items: center;
  color: #818c99;
  color: var(--vkui--color_text_secondary);
  display: flex
}

.vkuiUsersStack--direction-row-reverse {
  flex-direction: row-reverse
}

.vkuiUsersStack--direction-column {
  flex-direction: column;
  justify-content: center
}

.vkuiUsersStack__photos {
  display: flex
}

.vkuiUsersStack__fill {
  fill: rgba(0, 28, 61, .08);
  fill: var(--vkui--color_image_placeholder_alpha)
}

.vkuiUsersStack__photo--others {
  align-items: center;
  background: #99a2ad;
  background: var(--vkui--color_icon_secondary);
  border-radius: 50%;
  color: #fff;
  color: var(--vkui--color_text_contrast_themed);
  display: flex;
  justify-content: center
}

.vkuiUsersStack--size-s .vkuiUsersStack__photo {
  height: 16px;
  width: 16px
}

.vkuiUsersStack--size-m .vkuiUsersStack__photo {
  height: 24px;
  width: 24px
}

.vkuiUsersStack--size-l .vkuiUsersStack__photo {
  height: 32px;
  width: 32px
}

.vkuiUsersStack__photo+.vkuiUsersStack__photo {
  margin-left: -2px
}

.vkuiUsersStack__text {
  flex: 1 1;
  min-width: 0
}

.vkuiUsersStack--direction-column .vkuiUsersStack__text {
  margin-top: 8px;
  text-align: center
}

.vkuiUsersStack--direction-row .vkuiUsersStack__text {
  margin-left: 8px
}

.vkuiUsersStack--direction-row-reverse .vkuiUsersStack__text {
  margin-right: 8px
}

.vkuiInternalModalCardBase .vkuiUsersStack {
  margin-top: 20px
}

.vkuiPlaceholder {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center
}

.vkuiPlaceholder--withPadding {
  padding: 48px 32px
}

.vkuiPlaceholder--stretched {
  flex: 1 0;
  height: 100%;
  padding-bottom: inherit;
  padding-top: inherit
}

.vkuiPlaceholder__icon {
  color: #99a2ad;
  color: var(--vkui--color_icon_secondary);
  display: inline-block;
  margin-bottom: 12px;
  vertical-align: top
}

.vkuiPlaceholder__header {
  color: #000;
  color: var(--vkui--color_text_primary)
}

.vkuiPlaceholder__text {
  color: #818c99;
  color: var(--vkui--color_text_secondary)
}

.vkuiPlaceholder__header+.vkuiPlaceholder__text {
  margin-top: 8px
}

.vkuiPlaceholder__action:not(:first-child) {
  margin-top: 16px
}

.vkuiBanner {
  color: #000;
  color: var(--vkui--color_text_primary);
  isolation: isolate
}

.vkuiBanner--withPadding {
  margin: 12px 0;
  padding: 0 16px;
  padding: 0 var(--vkui--size_base_padding_horizontal--regular)
}

.vkuiBanner__in {
  align-items: stretch;
  background-color: #f5f5f5;
  background-color: var(--vkui--color_background_secondary);
  border-radius: 8px;
  border-radius: var(--vkui--size_border_radius--regular);
  display: flex;
  flex-flow: row nowrap;
  overflow: hidden;
  padding: 12px;
  position: relative
}

.vkuiBanner__in:before {
  border: var(--vkui--size_border--regular) solid var(--vkui--color_image_border_alpha);
  border-radius: inherit;
  box-sizing: border-box;
  content: "";
  display: block;
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
  z-index: var(--vkui_internal--z_index_banner_content)
}

.vkuiBanner__before {
  margin-right: 12px
}

.vkuiBanner__before,
.vkuiBanner__content {
  position: relative;
  z-index: 1;
  z-index: var(--vkui_internal--z_index_banner_content)
}

.vkuiBanner__content {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  justify-content: center;
  min-width: 0
}

.vkuiBanner__subheader,
.vkuiBanner__text {
  color: #6d7885;
  color: var(--vkui--color_text_subhead)
}

.vkuiBanner__bg {
  left: 0;
  position: absolute;
  top: 0;
  z-index: 0;
  z-index: var(--vkui_internal--z_index_banner_background)
}

.vkuiBanner__bg,
.vkuiBanner__bg>* {
  height: 100%;
  width: 100%
}

.vkuiBanner__aside {
  justify-content: flex-end;
  width: 28px
}

.vkuiBanner__aside,
.vkuiBanner__dismiss {
  align-content: center;
  align-items: center;
  color: #99a2ad;
  color: var(--vkui--color_icon_secondary);
  display: flex;
  flex-flow: row nowrap
}

.vkuiBanner__dismiss {
  justify-content: center;
  position: absolute;
  right: 2px;
  top: 2px;
  z-index: 2;
  z-index: var(--vkui_internal--z_index_banner_hover)
}

.vkuiBanner__actions {
  margin-top: 12px
}

.vkuiBanner__subheader:not(:first-child),
.vkuiBanner__text:not(:first-child) {
  margin-top: 2px
}

.vkuiBanner--mode-image .vkuiBanner__in {
  background-color: #f5f5f5;
  background-color: var(--vkui--color_background_secondary)
}

.vkuiBanner--inverted,
.vkuiBanner--inverted .vkuiBanner__dismiss,
.vkuiBanner--inverted .vkuiBanner__expand,
.vkuiBanner--inverted .vkuiBanner__subheader {
  color: #fff;
  color: var(--vkui--color_text_contrast)
}

.vkuiBanner--inverted .vkuiBanner__subheader {
  opacity: .72
}

.vkuiBanner--size-m .vkuiBanner__in {
  padding: 16px
}

.vkuiBanner--size-m .vkuiBanner__subheader:not(:first-child),
.vkuiBanner--size-m .vkuiBanner__text:not(:first-child) {
  margin-top: 4px
}

.vkuiBanner--ios .vkuiBanner__dismiss,
.vkuiBanner--ios.vkuiBanner--mode-image .vkuiBanner__dismiss {
  color: #99a2ad;
  color: var(--vkui--color_icon_secondary)
}

.vkuiInternalFormStatus .vkuiBanner__in:before {
  border: 0
}

.vkuiInternalFormStatus--mode-error .vkuiBanner__in {
  background-color: #faebeb;
  background-color: var(--vkui--color_background_negative_tint)
}

.vkuiInternalFormStatus--mode-error .vkuiBanner__subheader {
  color: #e64646;
  color: var(--vkui--color_background_negative)
}

.vkuiMiniInfoCell {
  color: #6d7885;
  color: var(--vkui--color_text_subhead);
  display: flex;
  padding: 6px 16px;
  padding: 6px var(--vkui--size_base_padding_horizontal--regular)
}

.vkuiMiniInfoCell--mode-accent {
  color: #000;
  color: var(--vkui--color_text_primary)
}

.vkuiMiniInfoCell__before {
  color: #99a2ad;
  color: var(--vkui--color_icon_secondary);
  margin-right: 12px
}

.vkuiMiniInfoCell__middle {
  align-items: center;
  display: flex;
  flex: 1 1;
  min-width: 0;
  overflow: hidden
}

.vkuiMiniInfoCell__content {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-word
}

.vkuiMiniInfoCell--textWrap-short .vkuiMiniInfoCell__content {
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  max-height: 60px;
  white-space: normal
}

.vkuiMiniInfoCell--textWrap-full .vkuiMiniInfoCell__content {
  overflow: inherit;
  white-space: normal
}

.vkuiMiniInfoCell--textWrap-nowrap .vkuiMiniInfoCell__content {
  flex: 0 1 auto
}

.vkuiMiniInfoCell__after {
  margin-bottom: -2px;
  margin-left: 12px;
  margin-top: -2px
}

.vkuiMiniInfoCell--mode-add,
.vkuiMiniInfoCell--mode-more {
  color: #2d81e0;
  color: var(--vkui--color_text_link_themed)
}

.vkuiMiniInfoCell--mode-add .vkuiMiniInfoCell__before,
.vkuiMiniInfoCell--mode-more .vkuiMiniInfoCell__before {
  color: #2688eb;
  color: var(--vkui--color_icon_accent_themed)
}

.vkuiMiniInfoCell--mode-more {
  padding-bottom: 10px;
  padding-top: 10px
}

.vkuiMiniInfoCell__middle .vkuiIcon {
  color: #2688eb;
  color: var(--vkui--color_text_accent);
  margin-left: 4px
}

.vkuiMiniInfoCell--mode-add .vkuiMiniInfoCell__middle .vkuiIcon,
.vkuiMiniInfoCell--mode-more .vkuiMiniInfoCell__middle .vkuiIcon {
  color: #2688eb;
  color: var(--vkui--color_icon_accent_themed)
}

.vkuiWriteBar {
  background: #fff;
  background: var(--vkui--color_background_modal)
}

.vkuiWriteBar--shadow {
  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);
  box-shadow: var(--vkui--elevation3)
}

.vkuiWriteBar__after,
.vkuiWriteBar__before,
.vkuiWriteBar__form {
  align-items: flex-end;
  display: flex
}

.vkuiWriteBar__form {
  min-height: 52px
}

.vkuiWriteBar__formIn {
  display: flex;
  flex: 1 1;
  min-width: 0;
  position: relative
}

.vkuiWriteBar__textarea {
  -webkit-appearance: none;
  background: transparent;
  border: 0;
  box-sizing: border-box;
  color: #000;
  color: var(--vkui--color_text_primary);
  flex: 1 1;
  margin: 0;
  max-height: 120px;
  min-width: 0;
  resize: none;
  width: 100%
}

.vkuiWriteBar__textarea::placeholder {
  color: #6d7885;
  color: var(--vkui--color_text_subhead);
  opacity: 1
}

.vkuiWriteBar__textarea:focus {
  outline: none
}

.vkuiWriteBar__inlineAfter {
  align-items: flex-end;
  display: flex
}

.vkuiWriteBar__before {
  padding-left: 4px
}

.vkuiWriteBar__after {
  padding-right: 4px
}

.vkuiWriteBar__textarea {
  height: 52px;
  padding: 16px 12px
}

.vkuiWriteBar--ios {
  background: #fff;
  background: var(--vkui--color_background_content)
}

.vkuiWriteBar--ios .vkuiWriteBar__after,
.vkuiWriteBar--ios .vkuiWriteBar__before {
  padding: 0 4px
}

.vkuiWriteBar--ios .vkuiWriteBar__formIn {
  background-color: #f2f3f5;
  background-color: var(--vkui--color_write_bar_input_background);
  border: var(--vkui--size_border--regular) solid var(--vkui--color_write_bar_input_border);
  border-radius: 18px;
  box-sizing: border-box;
  margin: 8px 0
}

.vkuiWriteBar--ios .vkuiWriteBar__formIn:first-child {
  margin-left: 12px
}

.vkuiWriteBar--ios .vkuiWriteBar__inlineAfter {
  --vkui_internal--writebar-right-gap: calc(-1 * var(--vkui--size_border--regular));
  --vkui_internal--writebar-vertical-gap: calc(var(--vkui_internal--writebar-right-gap) - 8px);
  margin-bottom: var(--vkui_internal--writebar-vertical-gap);
  margin-right: var(--vkui_internal--writebar-right-gap);
  margin-top: var(--vkui_internal--writebar-vertical-gap)
}

.vkuiWriteBar--ios .vkuiWriteBar__textarea {
  height: 36px;
  padding: 6px 0 6px 12px
}

.vkuiWriteBarIcon {
  background: none;
  border: 0;
  border-radius: 8px;
  border-radius: var(--vkui--size_border_radius--regular);
  color: #99a2ad;
  color: var(--vkui--color_icon_secondary);
  cursor: pointer;
  height: 52px;
  margin: 0;
  padding: 0;
  position: relative;
  width: 44px
}

.vkuiWriteBarIcon__in {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%
}

.vkuiWriteBarIcon:disabled {
  opacity: .4;
  pointer-events: none
}

.vkuiWriteBarIcon__active {
  opacity: .6
}

.vkuiWriteBarIcon__counter {
  box-shadow: 0 0 0 2px #fff;
  box-shadow: 0 0 0 2px var(--vkui--color_background_modal);
  position: absolute;
  right: 2px;
  top: 6px
}

.vkuiWriteBarIcon--ios .vkuiWriteBarIcon__counter {
  box-shadow: 0 0 0 2px #fff;
  box-shadow: 0 0 0 2px var(--vkui--color_background_content)
}

.vkuiWriteBarIcon.vkuiWriteBarIcon--mode-done,
.vkuiWriteBarIcon.vkuiWriteBarIcon--mode-send {
  color: #2688eb;
  color: var(--vkui--color_icon_accent)
}

.vkuiWriteBarIcon--ios {
  color: #2688eb;
  color: var(--vkui--color_icon_accent_themed)
}

.vkuiWriteBarIcon--ios.vkuiWriteBarIcon--mode-done,
.vkuiWriteBarIcon--ios.vkuiWriteBarIcon--mode-send {
  color: #2688eb;
  color: var(--vkui--color_icon_accent_themed);
  margin-right: -4px;
  padding-left: 0;
  padding-right: 0;
  width: 48px
}

.vkuiWriteBarIcon--ios.vkuiWriteBarIcon--mode-done:only-child,
.vkuiWriteBarIcon--ios.vkuiWriteBarIcon--mode-send:only-child {
  margin-left: -4px
}

.vkuiWriteBarIcon {
  --vkui_internal--counter_inherit_color: var(--vkui--color_text_contrast_themed);
  --vkui_internal--counter_inherit_background: var(--vkui--color_background_positive)
}

.vkuiSubnavigationBar__in {
  margin: -8px 0
}

.vkuiSubnavigationBar__scrollIn {
  display: flex;
  margin: 0;
  padding: calc(12px + 8px) 0;
  padding: calc(var(--vkui--size_subnavigation_bar_padding_vertical--regular) + 8px) 0
}

.vkuiSubnavigationBar__scrollIn:after,
.vkuiSubnavigationBar__scrollIn:before {
  content: "";
  min-width: 16px;
  min-width: var(--vkui--size_base_padding_horizontal--regular)
}

.vkuiSubnavigationBar__item {
  display: flex;
  list-style-type: none
}

.vkuiSubnavigationBar__item+.vkuiSubnavigationBar__item {
  margin-left: 8px;
  margin-left: var(--vkui--size_subnavigation_bar_gap--regular)
}

.vkuiInternalSubnavigationBar--mode-fixed .vkuiSubnavigationBar__item {
  flex: 1 1;
  min-width: 0
}

.vkuiSubnavigationButton {
  border-radius: 8px;
  border-radius: var(--vkui--size_border_radius--regular);
  display: inline-block;
  -webkit-user-select: none;
  user-select: none
}

.vkuiSubnavigationButton__in {
  align-items: center;
  display: flex;
  justify-content: center
}

.vkuiSubnavigationButton--size-s .vkuiSubnavigationButton__in {
  height: 30px;
  height: var(--vkui--size_button_small_height--regular)
}

.vkuiSubnavigationButton--size-m .vkuiSubnavigationButton__in {
  height: 36px;
  height: var(--vkui--size_button_medium_height--regular)
}

.vkuiSubnavigationButton--size-l .vkuiSubnavigationButton__in {
  height: 44px;
  height: var(--vkui--size_button_large_height--regular)
}

.vkuiSubnavigationButton--sizeY-compact.vkuiSubnavigationButton--size-s .vkuiSubnavigationButton__in {
  height: 28px;
  height: var(--vkui--size_button_small_height--compact)
}

.vkuiSubnavigationButton--sizeY-compact.vkuiSubnavigationButton--size-m .vkuiSubnavigationButton__in {
  height: 32px;
  height: var(--vkui--size_button_medium_height--compact)
}

.vkuiSubnavigationButton--sizeY-compact.vkuiSubnavigationButton--size-l .vkuiSubnavigationButton__in {
  height: 36px;
  height: var(--vkui--size_button_large_height--compact)
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiSubnavigationButton--sizeY-none.vkuiSubnavigationButton--size-s .vkuiSubnavigationButton__in {
    height: 28px;
    height: var(--vkui--size_button_small_height--compact)
  }

  .vkuiSubnavigationButton--sizeY-none.vkuiSubnavigationButton--size-m .vkuiSubnavigationButton__in {
    height: 32px;
    height: var(--vkui--size_button_medium_height--compact)
  }

  .vkuiSubnavigationButton--sizeY-none.vkuiSubnavigationButton--size-l .vkuiSubnavigationButton__in {
    height: 36px;
    height: var(--vkui--size_button_large_height--compact)
  }
}

.vkuiSubnavigationButton__before {
  color: #2688eb;
  color: var(--vkui--color_icon_accent);
  margin-right: 8px
}

.vkuiSubnavigationButton__label {
  flex-grow: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

.vkuiSubnavigationButton__after {
  margin-left: 8px
}

.vkuiSubnavigationButton__expandableIcon {
  color: #99a2ad;
  color: var(--vkui--color_icon_secondary);
  margin-left: 8px;
  margin-top: 1px
}

.vkuiSubnavigationButton__before:first-child,
.vkuiSubnavigationButton__label:first-child {
  padding-left: 12px;
  padding-left: var(--vkui--size_button_base_small_padding_horizontal_icon--regular)
}

.vkuiSubnavigationButton__after:last-child,
.vkuiSubnavigationButton__expandableIcon,
.vkuiSubnavigationButton__label:last-child {
  padding-right: 12px;
  padding-right: var(--vkui--size_button_base_small_padding_horizontal_icon--regular)
}

.vkuiSubnavigationButton--mode-primary {
  background-color: #fff;
  background-color: var(--vkui--color_background_modal);
  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);
  box-shadow: var(--vkui--elevation3)
}

.vkuiSubnavigationButton--mode-outline {
  box-shadow: inset 0 0 0 var(--vkui--size_border--regular) rgba(0, 0, 0, .12);
  box-shadow: inset 0 0 0 var(--vkui--size_border--regular) var(--vkui--color_field_border_alpha)
}

.vkuiSubnavigationButton--appearance-neutral .vkuiSubnavigationButton__before,
.vkuiSubnavigationButton--appearance-neutral .vkuiSubnavigationButton__expandableIcon {
  color: #2c2d2e;
  color: var(--vkui--color_icon_primary)
}

.vkuiSubnavigationButton--selected {
  background-color: #2688eb;
  background-color: var(--vkui--color_background_accent_themed);
  border: 0;
  box-shadow: none;
  color: #fff;
  color: var(--vkui--color_text_contrast_themed)
}

.vkuiSubnavigationButton--selected.vkuiSubnavigationButton--appearance-neutral,
.vkuiSubnavigationButton--selected.vkuiSubnavigationButton--mode-tertiary {
  background-color: rgba(0, 16, 61, .08);
  background-color: var(--vkui--color_transparent--active);
  color: #000;
  color: var(--vkui--color_text_primary)
}

.vkuiSubnavigationButton--selected.vkuiSubnavigationButton--appearance-accent:not(.vkuiSubnavigationButton--mode-tertiary) .vkuiSubnavigationButton__before,
.vkuiSubnavigationButton--selected.vkuiSubnavigationButton--appearance-accent:not(.vkuiSubnavigationButton--mode-tertiary) .vkuiSubnavigationButton__expandableIcon {
  color: #fff;
  color: var(--vkui--color_icon_contrast_themed)
}

.vkuiSubnavigationButton {
  --vkui_internal--counter_inherit_background: var(--vkui--color_background_accent_themed);
  --vkui_internal--counter_inherit_color: var(--vkui--color_text_contrast_themed)
}

.vkuiSubnavigationButton--selected.vkuiSubnavigationButton--appearance-accent:not(.vkuiSubnavigationButton--mode-tertiary) {
  --vkui_internal--counter_inherit_background: var(--vkui--color_background_content);
  --vkui_internal--counter_inherit_color: var(--vkui--color_text_accent_themed)
}

.vkuiSubnavigationButton--selected.vkuiSubnavigationButton--appearance-neutral {
  --vkui_internal--counter_inherit_background: var(--vkui--color_background_content);
  --vkui_internal--counter_inherit_color: var(--vkui--color_text_primary)
}

.vkuiInternalSubnavigationBar--mode-fixed .vkuiSubnavigationButton {
  flex: 1 1;
  min-width: 0
}

.vkuiPagination__list {
  display: flex;
  list-style-type: none;
  margin: 0;
  padding: 0
}

.vkuiPagination__prevButtonContainer {
  margin-right: 8px
}

.vkuiPagination__nextButtonContainer {
  margin-left: 8px
}

.vkuiPaginationPage {
  border-radius: 8px;
  border-radius: var(--vkui--size_border_radius--regular);
  box-sizing: border-box;
  color: #818c99;
  color: var(--vkui--color_text_secondary);
  height: 44px;
  height: var(--vkui--size_button_large_height--regular);
  line-height: 44px;
  line-height: var(--vkui--size_button_large_height--regular);
  min-width: 40px;
  padding-left: 8px;
  padding-right: 8px;
  text-align: center;
  -webkit-user-select: none;
  user-select: none;
  width: 100%
}

.vkuiPaginationPage--state-hover {
  background-color: rgba(0, 16, 61, .04);
  background-color: var(--vkui--color_transparent--hover)
}

.vkuiPaginationPage--current,
.vkuiPaginationPage--state-active {
  background-color: rgba(0, 16, 61, .08);
  background-color: var(--vkui--color_transparent--active);
  color: #000;
  color: var(--vkui--color_text_primary)
}

.vkuiPaginationPage--disabled {
  opacity: .4;
  opacity: var(--vkui--opacity_disable)
}

.vkuiPaginationPage--sizeY-compact {
  height: 36px;
  height: var(--vkui--size_button_large_height--compact);
  line-height: 36px;
  line-height: var(--vkui--size_button_large_height--compact)
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiPaginationPage--sizeY-none {
    height: 36px;
    height: var(--vkui--size_button_large_height--compact);
    line-height: 36px;
    line-height: var(--vkui--size_button_large_height--compact)
  }
}

.vkuiPaginationPage--type-ellipsis {
  min-width: 16px;
  padding-left: 0;
  padding-right: 0
}

.vkuiAccordionSummary::-webkit-details-marker {
  display: none
}

.vkuiAccordionSummary__icon {
  color: #99a2ad;
  color: var(--vkui--color_icon_secondary)
}

.vkuiAccordion:not([open])>summary .vkuiAccordionSummary__icon--collapse,
.vkuiAccordion[open]>summary .vkuiAccordionSummary__icon--expand {
  display: none
}

.vkuiFormLayout {
  position: relative
}

.vkuiFormLayout__submit {
  appearance: none;
  border: 0;
  height: 0;
  left: 0;
  padding: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  visibility: hidden;
  width: 0
}

.vkuiFormItem {
  display: block
}

.vkuiFormItem--withPadding {
  padding: 12px 16px;
  padding: var(--vkui--size_form_item_padding_vertical--regular) var(--vkui--size_base_padding_horizontal--regular)
}

.vkuiFormItem--removable {
  padding-left: 0;
  padding-right: 0
}

.vkuiFormItem__removable {
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 0;
  max-width: 100%;
  min-width: 1px;
  overflow: hidden;
  padding: 0
}

.vkuiFormItem__top {
  color: #6d7885;
  color: var(--vkui--color_text_subhead);
  overflow: hidden;
  padding-bottom: 8px;
  padding-top: 2px;
  text-overflow: ellipsis;
  white-space: nowrap
}

.vkuiFormItem__bottom {
  color: #818c99;
  color: var(--vkui--color_text_secondary);
  padding-top: 8px
}

.vkuiFormItem--status-error .vkuiFormItem__bottom {
  color: #e64646;
  color: var(--vkui--color_text_negative)
}

.vkuiFormItem--status-valid .vkuiFormItem__bottom,
.vkuiFormItem--verified .vkuiFormItem__bottom {
  color: #4bb34b;
  color: var(--vkui--color_text_positive)
}

.vkuiFormItem--sizeY-compact .vkuiFormItem__top {
  padding-bottom: 6px
}

.vkuiFormItem--sizeY-compact .vkuiFormItem__bottom {
  padding-top: 6px
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiFormItem--sizeY-none .vkuiFormItem__top {
    padding-bottom: 6px
  }

  .vkuiFormItem--sizeY-none .vkuiFormItem__bottom {
    padding-top: 6px
  }
}

.vkuiInternalFormLayoutGroup--mode-horizontal .vkuiFormItem {
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 0;
  max-width: 100%;
  min-width: 1px;
  padding: 0
}

.vkuiInternalFormLayoutGroup--mode-horizontal:not(.vkuiInternalFormLayoutGroup--segmented) .vkuiFormItem+.vkuiFormItem {
  margin-left: 24px
}

.vkuiInternalFormLayoutGroup--mode-horizontal.vkuiInternalFormLayoutGroup--segmented .vkuiFormItem+.vkuiFormItem {
  margin-left: calc(-1 * var(--vkui--size_border--regular))
}

.vkuiInternalFormLayoutGroup--mode-vertical.vkuiInternalFormLayoutGroup--segmented .vkuiFormItem+.vkuiFormItem {
  margin-top: calc(-1 * var(--vkui--size_border--regular));
  padding-top: 0
}

.vkuiInternalFormLayoutGroup--mode-vertical.vkuiInternalFormLayoutGroup--segmented .vkuiFormItem:not(:last-of-type) {
  padding-bottom: 0
}

.vkuiFormItem--withTop .vkuiFormItem__removable,
.vkuiInternalFormLayoutGroup--mode-horizontal .vkuiFormItem--withTop {
  margin-top: calc(-2px - 18px - 8px);
  margin-top: calc(-2px - var(--vkui--font_subhead--line_height--regular) - 8px)
}

.vkuiFormItem--sizeY-compact.vkuiFormItem--withTop .vkuiFormItem__removable,
.vkuiInternalFormLayoutGroup--mode-horizontal .vkuiFormItem--sizeY-compact.vkuiFormItem--withTop {
  margin-top: calc(-2px - 16px - 6px);
  margin-top: calc(-2px - var(--vkui--font_subhead--line_height--compact) - 6px)
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {

  .vkuiFormItem--sizeY-none.vkuiFormItem--withTop .vkuiFormItem__removable,
  .vkuiInternalFormLayoutGroup--mode-horizontal .vkuiFormItem--sizeY-none.vkuiFormItem--withTop {
    margin-top: calc(-2px - 16px - 6px);
    margin-top: calc(-2px - var(--vkui--font_subhead--line_height--compact) - 6px)
  }
}

.vkuiFormField {
  -webkit-tap-highlight-color: transparent;
  align-items: center;
  border-radius: 8px;
  border-radius: var(--vkui--size_border_radius--regular);
  box-sizing: border-box;
  display: flex;
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_family_base);
  isolation: isolate;
  min-height: 44px;
  min-height: var(--vkui--size_field_height--regular);
  outline: none;
  position: relative
}

.vkuiFormField--sizeY-compact {
  min-height: 36px;
  min-height: var(--vkui--size_field_height--compact)
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiFormField--sizeY-none {
    min-height: 36px;
    min-height: var(--vkui--size_field_height--compact)
  }
}

.vkuiFormField>* {
  border-radius: inherit;
  z-index: 1;
  z-index: var(--vkui_internal--z_index_form_field_element)
}

.vkuiFormField__after,
.vkuiFormField__before {
  align-content: center;
  align-items: center;
  color: #99a2ad;
  color: var(--vkui--color_icon_secondary);
  display: flex;
  flex-shrink: 0;
  height: 100%;
  justify-content: center;
  min-width: 44px;
  min-width: var(--vkui--size_field_height--regular);
  position: relative;
  z-index: 6;
  z-index: var(--vkui_internal--z_index_form_field_side)
}

.vkuiFormField--sizeY-compact .vkuiFormField__after,
.vkuiFormField--sizeY-compact .vkuiFormField__before {
  height: 36px;
  height: var(--vkui--size_field_height--compact);
  min-width: 36px;
  min-width: var(--vkui--size_field_height--compact)
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {

  .vkuiFormField--sizeY-none .vkuiFormField__after,
  .vkuiFormField--sizeY-none .vkuiFormField__before {
    height: 36px;
    height: var(--vkui--size_field_height--compact);
    min-width: 36px;
    min-width: var(--vkui--size_field_height--compact)
  }
}

.vkuiFormField__before {
  color: #2688eb;
  color: var(--vkui--color_icon_accent)
}

.vkuiFormField__after {
  color: #99a2ad;
  color: var(--vkui--color_icon_secondary)
}

.vkuiFormField__border {
  border: var(--vkui--size_border--regular) solid transparent;
  border-radius: inherit;
  box-sizing: border-box;
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  transform-origin: left top;
  width: 100%;
  z-index: 2;
  z-index: var(--vkui_internal--z_index_form_field_border)
}

.vkuiFormField--mode-default .vkuiFormField__border {
  border-color: rgba(0, 0, 0, .12);
  border-color: var(--vkui--color_field_border_alpha)
}

.vkuiFormField--mode-default {
  background-color: #f2f3f5;
  background-color: var(--vkui--color_field_background)
}

.vkuiFormField--status-error .vkuiFormField__border,
.vkuiInternalFormItem--status-error .vkuiFormField__border {
  border-color: #e64646;
  border-color: var(--vkui--color_stroke_negative);
  z-index: 3;
  z-index: var(--vkui_internal--z_index_form_field_status)
}

.vkuiFormField--status-error,
.vkuiInternalFormItem--status-error .vkuiFormField {
  background-color: #faebeb;
  background-color: var(--vkui--color_background_negative_tint)
}

.vkuiFormField--status-valid .vkuiFormField__border,
.vkuiInternalFormItem--status-valid .vkuiFormField__border {
  border-color: #4bb34b;
  border-color: var(--vkui--color_stroke_positive);
  z-index: 3;
  z-index: var(--vkui_internal--z_index_form_field_status)
}

.vkuiFormField--disabled {
  cursor: default;
  opacity: .64;
  opacity: var(--vkui--opacity_disable_accessibility);
  pointer-events: none
}

.vkuiFormField--hover {
  background-color: #f2f3f5;
  background-color: var(--vkui--color_field_background)
}

.vkuiFormField--mode-default.vkuiFormField--hover .vkuiFormField__border {
  border-color: rgba(0, 0, 0, .24);
  border-color: var(--vkui--color_field_border_alpha--hover);
  z-index: 4;
  z-index: var(--vkui_internal--z_index_form_field_border_hover)
}

.vkuiFormField :focus {
  outline: none
}

.vkuiInternalModalCardBase__header+.vkuiFormField,
.vkuiInternalModalCardBase__subheader+.vkuiFormField {
  margin-top: 16px
}

.vkuiInternalNativeSelect .vkuiFormField__after {
  pointer-events: none
}

.vkuiInternalCalendarHeader__picker .vkuiFormField__after {
  min-width: 12px;
  padding-right: 8px
}

.vkuiInternalChipsInput .vkuiFormField__after {
  z-index: 6;
  z-index: var(--vkui_internal--z_index_form_field_side)
}

.vkuiInternalFormLayoutGroup--segmented .vkuiFormField {
  border-radius: 0;
  isolation: auto;
  z-index: auto
}

.vkuiInternalFormLayoutGroup--segmented.vkuiInternalFormLayoutGroup--mode-horizontal .vkuiInternalFormItem:first-of-type .vkuiFormField {
  border-bottom-left-radius: 8px;
  border-bottom-left-radius: var(--vkui--size_border_radius--regular);
  border-top-left-radius: 8px;
  border-top-left-radius: var(--vkui--size_border_radius--regular)
}

.vkuiInternalFormLayoutGroup--segmented.vkuiInternalFormLayoutGroup--mode-horizontal .vkuiInternalFormItem:last-of-type .vkuiFormField {
  border-bottom-right-radius: 8px;
  border-bottom-right-radius: var(--vkui--size_border_radius--regular);
  border-top-right-radius: 8px;
  border-top-right-radius: var(--vkui--size_border_radius--regular)
}

.vkuiInternalFormLayoutGroup--segmented.vkuiInternalFormLayoutGroup--mode-vertical .vkuiInternalFormItem:first-of-type .vkuiFormField {
  border-top-left-radius: 8px;
  border-top-left-radius: var(--vkui--size_border_radius--regular);
  border-top-right-radius: 8px;
  border-top-right-radius: var(--vkui--size_border_radius--regular)
}

.vkuiInternalFormLayoutGroup--segmented.vkuiInternalFormLayoutGroup--mode-vertical .vkuiInternalFormItem:last-of-type .vkuiFormField {
  border-bottom-left-radius: 8px;
  border-bottom-left-radius: var(--vkui--size_border_radius--regular);
  border-bottom-right-radius: 8px;
  border-bottom-right-radius: var(--vkui--size_border_radius--regular)
}

.vkuiFormLayoutGroup--mode-horizontal {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  padding: 12px 16px;
  padding: var(--vkui--size_form_item_padding_vertical--regular) var(--vkui--size_base_padding_horizontal--regular)
}

.vkuiFormLayoutGroup__removable {
  flex-grow: 1;
  max-width: 100%;
  min-width: 0
}

.vkuiFormLayoutGroup__offset {
  display: none
}

.vkuiFormLayoutGroup--mode-horizontal .vkuiInternalFormItem--withTop~.vkuiFormLayoutGroup__offset {
  display: block;
  height: calc(2px + 18px + 8px);
  height: calc(2px + var(--vkui--font_subhead--line_height--regular) + 8px);
  min-width: 100%;
  order: -1
}

.vkuiFormLayoutGroup--sizeY-compact.vkuiFormLayoutGroup--mode-horizontal .vkuiInternalFormItem--withTop~.vkuiFormLayoutGroup__offset {
  height: calc(2px + 16px + 6px);
  height: calc(2px + var(--vkui--font_subhead--line_height--compact) + 6px)
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiFormLayoutGroup--sizeY-none.vkuiFormLayoutGroup--mode-horizontal .vkuiInternalFormItem--withTop~.vkuiFormLayoutGroup__offset {
    height: calc(2px + 16px + 6px);
    height: calc(2px + var(--vkui--font_subhead--line_height--compact) + 6px)
  }
}

.vkuiFormLayoutGroup--removable {
  padding-left: 0;
  padding-right: 0
}

.vkuiFormLayoutGroup--segmented {
  position: relative
}

.vkuiFormStatus--mode-error {
  color: #e64646;
  color: var(--vkui--color_background_negative)
}

.vkuiSwitch {
  cursor: pointer;
  display: block;
  padding: calc((20px - 14px) / 2);
  padding: calc((var(--vkui--size_switch_pin--regular) - var(--vkui--size_switch_height--regular)) / 2);
  position: relative;
  -webkit-user-select: none;
  user-select: none
}

.vkuiSwitch--sizeY-compact {
  padding: calc((18px - 12px) / 2);
  padding: calc((var(--vkui--size_switch_pin--compact) - var(--vkui--size_switch_height--compact)) / 2)
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiSwitch--sizeY-none {
    padding: calc((18px - 12px) / 2);
    padding: calc((var(--vkui--size_switch_pin--compact) - var(--vkui--size_switch_height--compact)) / 2)
  }
}

.vkuiSwitch--disabled {
  cursor: default
}

.vkuiSwitch__pseudo {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
  display: block;
  position: relative
}

.vkuiSwitch__pseudo:before {
  background: #f2f3f5;
  background: var(--vkui--color_icon_contrast_secondary);
  border-radius: 50%;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, .12), 0 2px 2px 0 rgba(0, 0, 0, .24);
  box-sizing: border-box;
  content: "";
  height: 20px;
  height: var(--vkui--size_switch_pin--regular);
  left: calc((14px - 20px) / 2);
  left: calc((var(--vkui--size_switch_height--regular) - var(--vkui--size_switch_pin--regular)) / 2);
  position: absolute;
  top: calc((14px - 20px) / 2);
  top: calc((var(--vkui--size_switch_height--regular) - var(--vkui--size_switch_pin--regular)) / 2);
  width: 20px;
  width: var(--vkui--size_switch_pin--regular)
}

.vkuiSwitch--sizeY-compact .vkuiSwitch__pseudo:before {
  height: 18px;
  height: var(--vkui--size_switch_pin--compact);
  left: calc((12px - 18px) / 2);
  left: calc((var(--vkui--size_switch_height--compact) - var(--vkui--size_switch_pin--compact)) / 2);
  top: calc((12px - 18px) / 2);
  top: calc((var(--vkui--size_switch_height--compact) - var(--vkui--size_switch_pin--compact)) / 2);
  width: 18px;
  width: var(--vkui--size_switch_pin--compact)
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiSwitch--sizeY-none .vkuiSwitch__pseudo:before {
    height: 18px;
    height: var(--vkui--size_switch_pin--compact);
    left: calc((12px - 18px) / 2);
    left: calc((var(--vkui--size_switch_height--compact) - var(--vkui--size_switch_pin--compact)) / 2);
    top: calc((12px - 18px) / 2);
    top: calc((var(--vkui--size_switch_height--compact) - var(--vkui--size_switch_pin--compact)) / 2);
    width: 18px;
    width: var(--vkui--size_switch_pin--compact)
  }
}

.vkuiSwitch__self:checked+.vkuiSwitch__pseudo:before {
  background: #2688eb;
  background: var(--vkui--color_icon_accent);
  transform: translateX(calc(34px - 14px));
  transform: translateX(calc(var(--vkui--size_switch_width--regular) - var(--vkui--size_switch_height--regular)))
}

.vkuiSwitch__pseudo:after {
  background: rgba(0, 0, 0, .24);
  background: var(--vkui--color_icon_tertiary_alpha);
  border-radius: calc(34px / 2);
  border-radius: calc(var(--vkui--size_switch_width--regular) / 2);
  content: "";
  display: block;
  height: 14px;
  height: var(--vkui--size_switch_height--regular);
  width: 34px;
  width: var(--vkui--size_switch_width--regular)
}

.vkuiSwitch--sizeY-compact .vkuiSwitch__pseudo:after {
  border-radius: calc(32px / 2);
  border-radius: calc(var(--vkui--size_switch_width--compact) / 2);
  height: 12px;
  height: var(--vkui--size_switch_height--compact);
  width: 32px;
  width: var(--vkui--size_switch_width--compact)
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiSwitch--sizeY-none .vkuiSwitch__pseudo:after {
    border-radius: calc(32px / 2);
    border-radius: calc(var(--vkui--size_switch_width--compact) / 2);
    height: 12px;
    height: var(--vkui--size_switch_height--compact);
    width: 32px;
    width: var(--vkui--size_switch_width--compact)
  }
}

.vkuiSwitch__self:checked+.vkuiSwitch__pseudo:after {
  background: #2688eb;
  background: var(--vkui--color_icon_accent);
  opacity: .48
}

.vkuiSwitch--sizeY-compact .vkuiSwitch__self:checked+.vkuiSwitch__pseudo:before {
  transform: translateX(calc(32px - 12px));
  transform: translateX(calc(var(--vkui--size_switch_width--compact) - var(--vkui--size_switch_height--compact)))
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiSwitch--sizeY-none .vkuiSwitch__self:checked+.vkuiSwitch__pseudo:before {
    transform: translateX(calc(32px - 12px));
    transform: translateX(calc(var(--vkui--size_switch_width--compact) - var(--vkui--size_switch_height--compact)))
  }
}

.vkuiSwitch__self[disabled]+.vkuiSwitch__pseudo {
  opacity: .4;
  opacity: var(--vkui--opacity_disable)
}

.vkuiSwitch--ios .vkuiSwitch__pseudo:before {
  box-shadow: 0 3px 8px rgba(0, 0, 0, .15), 0 3px 1px rgba(0, 0, 0, .06), inset 0 0 0 .5px rgba(0, 0, 0, .04)
}

.vkuiSwitch--ios .vkuiSwitch__pseudo:before,
.vkuiSwitch--ios .vkuiSwitch__self:checked+.vkuiSwitch__pseudo:before {
  background: #fff;
  background: var(--vkui_internal--white)
}

.vkuiSwitch--ios .vkuiSwitch__pseudo:after {
  background: #e1e3e6;
  background: var(--vkui--color_track_background)
}

.vkuiSwitch--ios .vkuiSwitch__self:checked+.vkuiSwitch__pseudo:after {
  opacity: 1
}

@media (prefers-reduced-motion:no-preference) {
  .vkuiSwitch__pseudo:after {
    transition: background-color .1s ease
  }

  .vkuiSwitch__pseudo:before {
    transition: transform .1s ease
  }

  .vkuiSwitch--ios .vkuiSwitch__pseudo:after {
    transition: background-color .2s ease
  }

  .vkuiSwitch--ios .vkuiSwitch__pseudo:before {
    transition: transform .2s cubic-bezier(.36, -.24, .26, 1.32)
  }
}

.vkuiInternalSimpleCell__after>.vkuiSwitch {
  margin-left: 12px
}

.vkuiInput {
  font-size: 16px;
  line-height: 20px;
  position: relative
}

.vkuiInput--align-center .vkuiInput__el {
  text-align: center
}

.vkuiInput--align-right .vkuiInput__el {
  text-align: right
}

.vkuiInput__el {
  appearance: none;
  background: transparent;
  border: 0;
  border-radius: inherit;
  box-shadow: none;
  box-sizing: border-box;
  color: #000;
  color: var(--vkui--color_text_primary);
  height: 44px;
  height: var(--vkui--size_field_height--regular);
  margin: 0;
  padding: 0 12px;
  position: relative;
  width: 100%;
  z-index: 1;
  z-index: var(--vkui_internal--z_index_form_field_element)
}

.vkuiInput__el::-webkit-inner-spin-button,
.vkuiInput__el::-webkit-outer-spin-button {
  -webkit-appearance: none
}

.vkuiInput__el[type=number] {
  -moz-appearance: textfield
}

.vkuiInput--sizeY-compact .vkuiInput__el {
  height: 36px;
  height: var(--vkui--size_field_height--compact)
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiInput--sizeY-none .vkuiInput__el {
    height: 36px;
    height: var(--vkui--size_field_height--compact)
  }
}

.vkuiInput--hasBefore .vkuiInput__el {
  padding-left: 0
}

.vkuiInput--hasAfter .vkuiInput__el {
  padding-right: 0
}

.vkuiInput__el:disabled {
  opacity: .64;
  opacity: var(--vkui--opacity_disable_accessibility)
}

.vkuiInput__el::placeholder {
  color: #818c99;
  color: var(--vkui--color_text_secondary);
  opacity: 1
}

.vkuiInput__el:disabled::placeholder {
  color: #818c99;
  color: var(--vkui--color_text_secondary)
}

.vkuiChip {
  background: #fff;
  background: var(--vkui--color_background_content);
  border: var(--vkui--size_border--regular) solid var(--vkui--color_image_border_alpha);
  border-radius: 6px;
  box-sizing: border-box;
  display: inline-block;
  height: 32px
}

.vkuiChip__in {
  align-items: center;
  display: flex;
  height: 100%;
  padding: 0 8px;
  position: relative
}

.vkuiChip--removable .vkuiChip__in {
  padding-right: 0
}

.vkuiChip__content {
  color: #000;
  color: var(--vkui--color_text_primary);
  display: inline-block;
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_paragraph--font_family--regular);
  font-size: 15px;
  font-size: var(--vkui--font_paragraph--font_size--regular);
  font-weight: 400;
  font-weight: var(--vkui--font_paragraph--font_weight--regular);
  line-height: 20px;
  line-height: var(--vkui--font_paragraph--line_height--regular);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

.vkuiChip--sizeY-compact .vkuiChip__content {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_footnote--font_family--regular);
  font-size: 13px;
  font-size: var(--vkui--font_footnote--font_size--regular);
  font-weight: 400;
  font-weight: var(--vkui--font_footnote--font_weight--regular);
  line-height: 16px;
  line-height: var(--vkui--font_footnote--line_height--regular)
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiChip--sizeY-none .vkuiChip__content {
    font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
    font-family: var(--vkui--font_footnote--font_family--regular);
    font-size: 13px;
    font-size: var(--vkui--font_footnote--font_size--regular);
    font-weight: 400;
    font-weight: var(--vkui--font_footnote--font_weight--regular);
    line-height: 16px;
    line-height: var(--vkui--font_footnote--line_height--regular)
  }
}

.vkuiChip__remove {
  align-content: center;
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 2px;
  box-sizing: border-box;
  color: #99a2ad;
  color: var(--vkui--color_icon_secondary);
  cursor: pointer;
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  height: 28px;
  justify-content: center;
  margin: -1px;
  padding: 6px;
  position: relative;
  transform: translateX(-1px);
  width: 28px
}

.vkuiChip__before {
  margin-right: 6px
}

.vkuiChip__after {
  margin-left: 6px
}

.vkuiChip--sizeY-compact {
  height: 28px
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiChip--sizeY-none {
    height: 28px
  }
}

.vkuiChipsInput {
  max-width: 100%
}

.vkuiChipsInputBase {
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  flex-wrap: wrap;
  max-width: 100%;
  overflow: hidden;
  padding: 3px;
  position: relative;
  z-index: 1;
  z-index: var(--vkui_internal--z_index_form_field_element)
}

.vkuiChipsInputBase__chip {
  margin: 2px;
  max-width: calc(100% - 4px)
}

.vkuiChipsInputBase__label {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  justify-content: center;
  margin: 2px 2px 2px 10px
}

.vkuiChipsInputBase__el {
  appearance: none;
  background: transparent;
  border: 0;
  box-shadow: none;
  color: #000;
  color: var(--vkui--color_text_primary);
  margin-bottom: 2px;
  padding: 0;
  position: relative;
  width: 100%
}

.vkuiChipsInputBase__el:focus {
  min-width: 64px
}

.vkuiChipsInputBase__el::-ms-clear {
  display: none
}

.vkuiChipsInputBase__el:disabled {
  opacity: .64;
  opacity: var(--vkui--opacity_disable_accessibility)
}

.vkuiChipsInputBase__el::placeholder {
  color: #818c99;
  color: var(--vkui--color_text_secondary);
  opacity: 1
}

.vkuiChipsInputBase__el:disabled::placeholder {
  color: #818c99;
  color: var(--vkui--color_text_secondary)
}

.vkuiChipsInputBase__el[readonly] {
  cursor: default
}

.vkuiChipsInputBase--hasPlaceholder .vkuiChipsInputBase__label {
  margin-left: 9px;
  margin-right: 0
}

.vkuiChipsInputBase--hasPlaceholder .vkuiChipsInputBase__el {
  text-overflow: ellipsis;
  white-space: nowrap
}

.vkuiChipsInputBase--sizeY-compact {
  padding: 1px
}

.vkuiSlider {
  cursor: pointer;
  height: 28px;
  height: var(--vkui_internal--slider_thumb_size);
  position: relative
}

.vkuiSlider--disabled {
  cursor: not-allowed;
  opacity: .64;
  opacity: var(--vkui--opacity_disable_accessibility)
}

.vkuiSlider__track,
.vkuiSlider__track-fill {
  border-radius: 1px;
  height: 2px;
  left: 0;
  position: absolute;
  top: 50%
}

.vkuiSlider__track {
  background-color: #e1e3e6;
  background-color: var(--vkui--color_track_background);
  width: 100%
}

.vkuiSlider__track-fill {
  background: #2688eb;
  background: var(--vkui--color_background_accent);
  width: auto
}

.vkuiSlider__thumbs {
  height: 100%;
  isolation: isolate;
  margin-left: calc(28px / 2);
  margin-left: calc(var(--vkui_internal--slider_thumb_size) / 2);
  margin-right: calc(28px / 2);
  margin-right: calc(var(--vkui_internal--slider_thumb_size) / 2);
  position: relative
}

.vkuiSlider__thumb {
  top: 50%;
  transform: translate(-50%, -50%)
}

.vkuiSlider--sizeY-compact {
  --vkui_internal--slider_thumb_size: 24px
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiSlider--sizeY-none {
    --vkui_internal--slider_thumb_size: 24px
  }
}

.vkuiSliderThumb {
  background: #fff;
  background: var(--vkui--color_background_contrast);
  border: .5px solid rgba(0, 0, 0, .12);
  border: .5px solid var(--vkui--color_separator_primary_alpha);
  border-radius: 50%;
  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);
  box-shadow: var(--vkui--elevation3);
  height: 28px;
  height: var(--vkui_internal--slider_thumb_size);
  position: absolute;
  -webkit-user-select: none;
  user-select: none;
  width: 28px;
  width: var(--vkui_internal--slider_thumb_size);
  z-index: 1
}

.vkuiSliderThumb--focused {
  z-index: 2
}

.vkuiSliderThumb__nativeInput {
  clip: rect(0, 0, 0, 0);
  border: 0;
  direction: ltr;
  height: 100%;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 100%
}

.vkuiTextarea {
  position: relative
}

.vkuiTextarea__el {
  appearance: none;
  background: transparent;
  border: 0;
  box-sizing: border-box;
  color: #000;
  color: var(--vkui--color_text_primary);
  display: block;
  margin: 0;
  max-height: 204px;
  padding: 12px;
  position: relative;
  resize: none;
  width: 100%;
  z-index: 1;
  z-index: var(--vkui_internal--z_index_form_field_element)
}

.vkuiTextarea__el[cols] {
  width: auto
}

.vkuiTextarea--sizeY-compact .vkuiTextarea__el {
  max-height: 196px
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiTextarea--sizeY-none .vkuiTextarea__el {
    max-height: 196px
  }
}

.vkuiTextarea__el::placeholder {
  color: #818c99;
  color: var(--vkui--color_text_secondary);
  opacity: 1
}

.vkuiTextarea__el:disabled {
  opacity: .64;
  opacity: var(--vkui--opacity_disable_accessibility)
}

.vkuiTextarea__el:disabled::placeholder {
  color: #818c99;
  color: var(--vkui--color_text_secondary)
}

.vkuiRadio {
  display: block;
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_family_base);
  padding: 0 16px;
  padding: 0 var(--vkui--size_base_padding_horizontal--regular)
}

.vkuiInternalFormItem .vkuiRadio {
  box-sizing: initial;
  margin: 0 calc(-1 * 16px);
  margin: 0 calc(-1 * var(--vkui--size_base_padding_horizontal--regular));
  width: 100%
}

.vkuiRadio__container {
  align-items: center;
  display: flex;
  justify-content: flex-start
}

.vkuiRadio__input:disabled~.vkuiRadio__container {
  opacity: .64;
  opacity: var(--vkui--opacity_disable_accessibility)
}

.vkuiRadio__icon {
  color: #b8c1cc;
  color: var(--vkui--color_icon_tertiary);
  flex-shrink: 0;
  height: 22px;
  margin-right: 14px;
  transition: color .15s cubic-bezier(.4, 0, .2, 1);
  transition: color .15s var(--vkui--animation_easing_platform);
  width: 22px
}

.vkuiRadio__input:checked~.vkuiRadio__container .vkuiRadio__icon {
  color: #2688eb;
  color: var(--vkui--color_icon_accent)
}

.vkuiRadio__icon .vkuiRadio__pin {
  transform: scale(0);
  transform-origin: 12px 12px;
  transition: transform .15s cubic-bezier(.4, 0, .2, 1);
  transition: transform .15s var(--vkui--animation_easing_platform)
}

.vkuiRadio__input:checked~.vkuiRadio__container .vkuiRadio__icon .vkuiRadio__pin {
  transform: none
}

.vkuiRadio__content {
  color: #000;
  color: var(--vkui--color_text_primary);
  display: block;
  flex-grow: 1;
  max-width: 100%
}

.vkuiRadio__description {
  color: #818c99;
  color: var(--vkui--color_text_secondary);
  display: block;
  margin-bottom: 12px;
  margin-top: 2px
}

.vkuiRadio__title {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 12px
}

.vkuiRadio__title:last-child {
  margin-bottom: 12px
}

.vkuiRadio__titleAfter {
  color: #b8c1cc;
  color: var(--vkui--color_icon_tertiary);
  margin-left: 4px
}

.vkuiRadio--sizeY-compact .vkuiRadio__title {
  margin-top: 8px
}

.vkuiRadio--sizeY-compact .vkuiRadio__title:last-child {
  margin-bottom: 8px
}

.vkuiRadio--sizeY-compact .vkuiRadio__description {
  margin-bottom: 7px
}

.vkuiRadio--sizeY-compact .vkuiRadio__icon {
  height: 18px;
  width: 18px
}

.vkuiRadio--sizeY-compact .vkuiRadio__icon:after {
  height: 12px;
  width: 12px
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiRadio--sizeY-none .vkuiRadio__title {
    margin-top: 8px
  }

  .vkuiRadio--sizeY-none .vkuiRadio__title:last-child {
    margin-bottom: 8px
  }

  .vkuiRadio--sizeY-none .vkuiRadio__description {
    margin-bottom: 7px
  }

  .vkuiRadio--sizeY-none .vkuiRadio__icon {
    height: 18px;
    width: 18px
  }

  .vkuiRadio--sizeY-none .vkuiRadio__icon:after {
    height: 12px;
    width: 12px
  }
}

.vkuiInternalRadioGroup .vkuiRadio {
  box-sizing: border-box;
  flex: 1 1;
  margin: 0
}

.vkuiRadioGroup--mode-horizontal {
  display: flex
}

.vkuiInternalFormItem .vkuiRadioGroup {
  box-sizing: initial;
  margin: 0 calc(-1 * 16px);
  margin: 0 calc(-1 * var(--vkui--size_base_padding_horizontal--regular))
}

.vkuiCheckbox {
  align-items: center;
  display: flex;
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_family_base);
  justify-content: flex-start;
  min-height: 44px;
  min-height: var(--vkui--size_field_height--regular);
  min-width: 44px;
  min-width: var(--vkui--size_field_height--regular);
  padding: 0 16px;
  padding: 0 var(--vkui--size_base_padding_horizontal--regular)
}

.vkuiInternalFormItem .vkuiCheckbox {
  box-sizing: initial;
  margin: 0 calc(-1 * 16px);
  margin: 0 calc(-1 * var(--vkui--size_base_padding_horizontal--regular));
  width: 100%
}

.vkuiCheckbox__icon {
  flex-shrink: 0;
  margin-right: 12px
}

.vkuiCheckbox__icon--indeterminate,
.vkuiCheckbox__icon--on {
  color: #2688eb;
  color: var(--vkui--color_icon_accent);
  display: none
}

.vkuiCheckbox__icon--off {
  color: #b8c1cc;
  color: var(--vkui--color_icon_tertiary)
}

.vkuiCheckbox__content {
  color: #000;
  color: var(--vkui--color_text_primary);
  flex-grow: 1;
  min-width: 0;
  word-break: break-word
}

.vkuiCheckbox__description {
  color: #818c99;
  color: var(--vkui--color_text_secondary);
  display: block;
  margin-bottom: 12px;
  margin-top: 2px
}

.vkuiCheckbox__title {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 12px
}

.vkuiCheckbox__title:last-child {
  margin-bottom: 12px
}

.vkuiCheckbox__titleBefore {
  min-width: 0
}

.vkuiCheckbox__titleAfter {
  color: #b8c1cc;
  color: var(--vkui--color_icon_tertiary);
  flex-shrink: 0;
  margin-left: 4px
}

.vkuiCheckbox__input:checked~.vkuiCheckbox__icon--on {
  display: flex
}

.vkuiCheckbox__input:checked~.vkuiCheckbox__icon--off,
.vkuiCheckbox__input:indeterminate~.vkuiCheckbox__icon--indeterminate {
  display: none
}

.vkuiCheckbox__input:indeterminate~.vkuiCheckbox__icon--indeterminate {
  display: flex
}

.vkuiCheckbox__input:indeterminate~.vkuiCheckbox__icon--off,
.vkuiCheckbox__input:indeterminate~.vkuiCheckbox__icon--on {
  display: none
}

.vkuiCheckbox__input[disabled]~* {
  opacity: .64;
  opacity: var(--vkui--opacity_disable_accessibility)
}

.vkuiCheckbox--simple {
  align-items: center;
  border-radius: 50%;
  display: flex;
  height: 44px;
  height: var(--vkui--size_field_height--regular);
  justify-content: center;
  padding: 0;
  width: 44px;
  width: var(--vkui--size_field_height--regular)
}

.vkuiCheckbox--simple .vkuiCheckbox__content {
  display: none
}

.vkuiCheckbox--simple .vkuiCheckbox__icon {
  margin: 0
}

.vkuiCheckbox--sizeY-compact {
  min-height: 36px;
  min-height: var(--vkui--size_field_height--compact);
  min-width: 36px;
  min-width: var(--vkui--size_field_height--compact)
}

.vkuiCheckbox--sizeY-compact.vkuiCheckbox--simple {
  height: 36px;
  height: var(--vkui--size_field_height--compact);
  width: 36px;
  width: var(--vkui--size_field_height--compact)
}

.vkuiCheckbox--sizeY-compact .vkuiCheckbox__title {
  margin-top: 8px
}

.vkuiCheckbox--sizeY-compact .vkuiCheckbox__description,
.vkuiCheckbox--sizeY-compact .vkuiCheckbox__title:last-child {
  margin-bottom: 8px
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiCheckbox--sizeY-none {
    min-height: 36px;
    min-height: var(--vkui--size_field_height--compact);
    min-width: 36px;
    min-width: var(--vkui--size_field_height--compact)
  }

  .vkuiCheckbox--sizeY-none.vkuiCheckbox--simple {
    height: 36px;
    height: var(--vkui--size_field_height--compact);
    width: 36px;
    width: var(--vkui--size_field_height--compact)
  }

  .vkuiCheckbox--sizeY-none .vkuiCheckbox__title {
    margin-top: 8px
  }

  .vkuiCheckbox--sizeY-none .vkuiCheckbox__description,
  .vkuiCheckbox--sizeY-none .vkuiCheckbox__title:last-child {
    margin-bottom: 8px
  }
}

.vkuiCustomSelect {
  cursor: pointer;
  display: block;
  position: relative;
  width: 100%
}

.vkuiCustomSelect--pop-down {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0
}

.vkuiCustomSelect--pop-up {
  border-top-left-radius: 0;
  border-top-right-radius: 0
}

.vkuiCustomSelect__control {
  display: none
}

.vkuiCustomSelect__empty {
  color: #818c99;
  color: var(--vkui--color_text_secondary);
  padding: 12px 0;
  text-align: center
}

.vkuiCustomSelect__fetching {
  align-items: center;
  display: flex;
  justify-content: center
}

.vkuiCustomSelect__dropdown-icon {
  margin-right: 10px
}

.vkuiCustomSelect--clear-icon {
  margin-right: -6px
}

.vkuiCustomSelect--sizeY-compact .vkuiCustomSelect__dropdown-icon {
  margin-right: 8px
}

.vkuiCustomSelect--sizeY-compact .vkuiCustomSelect--clear-icon {
  margin-right: -2px
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiCustomSelect--sizeY-none .vkuiCustomSelect__dropdown-icon {
    margin-right: 8px
  }

  .vkuiCustomSelect--sizeY-none .vkuiCustomSelect--clear-icon {
    margin-right: -2px
  }
}

.vkuiCustomSelectOption {
  align-items: center;
  box-sizing: border-box;
  color: #000;
  color: var(--vkui--color_text_primary);
  cursor: pointer;
  display: flex;
  padding: 8px 12px;
  position: relative;
  -webkit-user-select: none;
  user-select: none;
  width: 100%
}

.vkuiCustomSelectOption--hierarchy {
  --vkui_internal--custom_select_option_hierarchy_level: 0;
  padding-left: calc(0 * 32px);
  padding-left: calc(var(--vkui_internal--custom_select_option_hierarchy_level) * var(--vkui--size_option_hierarchy--regular))
}

.vkuiCustomSelectOption--sizeY-regular {
  min-height: 44px
}

@media (max-width:767.9px) and (min-height:415px),
(pointer:coarse) and (min-height:415px),
(pointer:none) and (min-height:415px) {
  .vkuiCustomSelectOption--sizeY-none {
    min-height: 44px
  }
}

.vkuiCustomSelectOption--disabled {
  cursor: default;
  opacity: .64;
  opacity: var(--vkui--opacity_disable_accessibility)
}

.vkuiCustomSelectOption--hover {
  background-color: rgba(0, 16, 61, .04);
  background-color: var(--vkui--color_transparent--hover)
}

.vkuiCustomSelectOption__before {
  flex-shrink: 0;
  margin-right: 7px
}

.vkuiCustomSelectOption__main {
  flex-grow: 1;
  max-width: 100%;
  min-width: 0
}

.vkuiCustomSelectOption__children {
  min-width: 0
}

.vkuiCustomSelectOption__after {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  margin-left: 8px
}

.vkuiCustomSelectOption__description {
  color: #818c99;
  color: var(--vkui--color_text_secondary)
}

.vkuiCustomSelectOption__selectedIcon {
  color: #2688eb;
  color: var(--vkui--color_icon_accent)
}

.vkuiCustomSelectOption__selectedIcon:not(:first-child) {
  margin-left: 8px
}

.vkuiSelect {
  box-sizing: border-box;
  cursor: pointer;
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_family_base);
  position: relative
}

.vkuiSelect__el {
  appearance: none;
  border: 0;
  display: block;
  font-family: inherit;
  font-size: 15px;
  font-size: var(--vkui--font_paragraph--font_size--regular);
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 6;
  z-index: var(--vkui_internal--z_index_form_field_side)
}

.vkuiSelect__container {
  box-sizing: border-box;
  color: #000;
  color: var(--vkui--color_text_primary);
  flex-grow: 1;
  flex-shrink: 1;
  overflow: hidden;
  padding-left: 12px;
  padding-right: 0;
  position: relative;
  z-index: 1;
  z-index: var(--vkui_internal--z_index_form_field_element)
}

.vkuiSelect--hasBefore .vkuiSelect__container {
  padding-left: 0
}

.vkuiSelect--multiline .vkuiSelect__container {
  padding-bottom: 12px;
  padding-top: 12px
}

.vkuiSelect--sizeY-compact.vkuiSelect--multiline .vkuiSelect__container {
  padding-bottom: 8px;
  padding-top: 8px
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiSelect--sizeY-none.vkuiSelect--multiline .vkuiSelect__container {
    padding-bottom: 8px;
    padding-top: 8px
  }
}

.vkuiSelect__title {
  display: block
}

.vkuiSelect:not(.vkuiSelect--multiline) .vkuiSelect__title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

.vkuiSelect--empty .vkuiSelect__title {
  color: #818c99;
  color: var(--vkui--color_text_secondary)
}

.vkuiSelect--align-right .vkuiSelect__title {
  text-align: right
}

.vkuiSelect--align-center .vkuiSelect__title {
  text-align: center
}

.vkuiInternalCalendarHeader__picker .vkuiSelect__container {
  padding-right: 4px
}

.vkuiCustomSelectDropdown {
  background-color: #fff;
  background-color: var(--vkui--color_background_modal);
  border: var(--vkui--size_border--regular) solid var(--vkui--color_field_border_alpha);
  border-radius: 8px;
  box-shadow: 0 0 2px rgba(0, 0, 0, .03), 0 2px 2px rgba(0, 0, 0, .06);
  box-shadow: var(--vkui--elevation1);
  box-sizing: border-box;
  overflow: hidden
}

.vkuiCustomSelectDropdown--wide {
  width: 100%
}

.vkuiCustomSelectDropdown--bottom {
  border-top: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0
}

.vkuiCustomSelectDropdown--top {
  border-bottom: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  bottom: 100%;
  box-shadow: 0 0 2px rgba(0, 0, 0, .03), 0 -2px 2px rgba(0, 0, 0, .06);
  box-shadow: var(--vkui--elevation1_invert_y)
}

.vkuiCustomSelectDropdown__fetching {
  padding: 12px 0
}

.vkuiCustomSelectDropdown__in {
  max-height: 160px
}

.vkuiInternalCalendarHeader__pickers .vkuiCustomSelectDropdown__in {
  max-height: 184px
}

.vkuiCustomScrollView {
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%
}

.vkuiCustomScrollView__box {
  height: 100%;
  max-height: inherit;
  overflow-x: hidden;
  overflow-y: scroll;
  padding-right: 100px;
  position: relative;
  scrollbar-width: none;
  width: 100%
}

.vkuiCustomScrollView__box::-webkit-scrollbar {
  display: none
}

.vkuiCustomScrollView__barY:active+.vkuiCustomScrollView__box {
  pointer-events: none
}

.vkuiCustomScrollView__barY {
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  width: 10px
}

.vkuiCustomScrollView__trackerY {
  box-sizing: border-box;
  left: 0;
  padding: 4px 4px 4px 0;
  position: absolute;
  top: 0;
  -webkit-user-select: none;
  user-select: none;
  width: 10px
}

.vkuiCustomScrollView__trackerY--hidden {
  opacity: 0;
  transition: opacity .2s
}

.vkuiCustomScrollView__trackerY:before {
  background-color: #818c99;
  background-color: var(--vkui--color_icon_medium);
  border-radius: 12px;
  content: "";
  display: block;
  height: 100%;
  opacity: .48;
  transition: transform .2s, opacity .2s;
  width: 100%
}

.vkuiCustomScrollView__trackerY:active:before,
.vkuiCustomScrollView__trackerY:hover:before {
  opacity: .8;
  transform: scaleX(1.3333)
}

.vkuiInternalCustomSelectDropdown .vkuiCustomScrollView__box {
  padding-right: 8px
}

.vkuiInternalCustomSelectDropdown--wide .vkuiCustomScrollView__box {
  padding-right: 0
}

.vkuiDatePicker {
  border: 0;
  margin: 0;
  padding: 0
}

.vkuiDatePicker__container {
  display: flex;
  flex-direction: row;
  width: 100%
}

.vkuiDatePicker__day {
  min-width: 72px
}

.vkuiDatePicker__month {
  display: flex;
  flex: 1 0;
  min-width: 0;
  padding: 0 8px
}

.vkuiDatePicker__year {
  min-width: 92px
}

.vkuiDatePicker__monthSelect {
  width: 100%
}

.vkuiSegmentedControl {
  background-color: #f5f5f5;
  background-color: var(--vkui--color_background_secondary);
  border-radius: 8px;
  border-radius: var(--vkui--size_border_radius--regular);
  box-sizing: border-box;
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_family_base);
  height: 30px;
  padding: 2px
}

.vkuiSegmentedControl--size-l {
  height: 36px
}

.vkuiSegmentedControl__in {
  border-radius: inherit;
  display: flex;
  height: 100%;
  position: relative;
  transition: all .1s ease-out;
  width: 100%
}

.vkuiSegmentedControl__slider {
  background-color: #fff;
  background-color: var(--vkui--color_segmented_control);
  border-radius: inherit;
  bottom: 0;
  box-shadow: inset 0 0 0 .5px rgba(0, 0, 0, .08), 0 3px 8px rgba(0, 0, 0, .12), 0 3px 1px rgba(0, 0, 0, .04);
  box-shadow: inset 0 0 0 .5px var(--vkui--color_image_border_alpha), 0 3px 8px rgba(0, 0, 0, .12), 0 3px 1px rgba(0, 0, 0, .04);
  left: 0;
  position: absolute;
  top: 0;
  transform-origin: 0 0;
  transition: transform .15s
}

.vkuiSegmentedControl__option {
  display: block;
  flex: 1 1;
  margin: 0;
  padding: 0;
  position: relative
}

.vkuiSegmentedControl--sizeY-regular {
  height: 36px
}

.vkuiSegmentedControl--sizeY-regular.vkuiSegmentedControl--size-l {
  height: 44px
}

@media (max-width:767.9px) and (min-height:415px),
(pointer:coarse) and (min-height:415px),
(pointer:none) and (min-height:415px) {
  .vkuiSegmentedControl--sizeY-none {
    height: 36px
  }

  .vkuiSegmentedControl--sizeY-none.vkuiSegmentedControl--size-l {
    height: 44px
  }
}

.vkuiSegmentedControlOption {
  appearance: none;
  background: transparent;
  border: 0;
  border-radius: inherit;
  box-sizing: border-box;
  color: #000;
  color: var(--vkui--color_text_primary);
  cursor: pointer;
  height: 100%;
  transition: color .1s ease-out;
  -webkit-user-select: none;
  user-select: none
}

.vkuiSegmentedControlOption .vkuiIcon {
  color: #2c2d2e;
  color: var(--vkui--color_icon_primary)
}

.vkuiSegmentedControlOption:not(.vkuiSegmentedControlOption--checked):hover {
  opacity: .5
}

.vkuiSegmentedControlOption__content {
  align-content: center;
  align-items: center;
  border-radius: inherit;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%
}

.vkuiCalendar {
  background: #fff;
  background: var(--vkui--color_background_modal);
  border: .5px solid #d7d8d9;
  border: .5px solid var(--vkui--color_separator_primary);
  border-radius: 8px;
  box-shadow: 0 0 2px rgba(0, 0, 0, .03), 0 2px 2px rgba(0, 0, 0, .06);
  box-shadow: var(--vkui--elevation1);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 12px;
  width: 305px
}

.vkuiCalendar__time {
  border-top: 1px solid #d7d8d9;
  border-top: 1px solid var(--vkui--color_separator_primary);
  margin: 12px -12px 0;
  padding: 12px 12px 0
}

.vkuiCalendar__header {
  margin-bottom: 4px
}

.vkuiCalendar--size-s {
  padding: 8px;
  width: 220px
}

.vkuiCalendar--size-s .vkuiCalendar__header {
  margin-bottom: 0
}

.vkuiCalendarHeader {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 36px;
  position: relative
}

.vkuiCalendarHeader__pickers {
  color: #000;
  color: var(--vkui--color_text_primary);
  display: flex;
  position: absolute
}

.vkuiCalendarHeader__picker+.vkuiCalendarHeader__picker {
  margin-left: 4px
}

.vkuiCalendarHeader__nav-icon {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 3px;
  position: absolute
}

.vkuiCalendarHeader__nav-icon--accent {
  color: #2688eb;
  color: var(--vkui--color_icon_accent)
}

.vkuiCalendarHeader__nav-icon-next {
  right: 0
}

.vkuiCalendarHeader__nav-icon-prev {
  left: 0
}

.vkuiCalendarHeader__month {
  text-transform: capitalize
}

.vkuiCalendarDays {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-around
}

.vkuiCalendarDays__row {
  display: flex;
  flex-grow: 1;
  justify-content: center
}

.vkuiCalendarDays__row:not(:last-child) {
  margin-bottom: 4px
}

.vkuiCalendarDays__row--size-s:not(:last-child) {
  margin-bottom: 0
}

.vkuiCalendarDays__weekday {
  align-items: center;
  color: #6d7885;
  color: var(--vkui--color_text_subhead);
  display: flex;
  flex-basis: calc(100% / 7);
  flex-grow: 0;
  height: 32px;
  justify-content: center;
  text-transform: capitalize
}

.vkuiCalendarDay {
  border-radius: 0;
  color: #000;
  color: var(--vkui--color_text_primary);
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_family_base);
  font-size: 14px
}

.vkuiCalendarDay,
.vkuiCalendarDay__hidden {
  flex-basis: calc(100% / 7);
  flex-grow: 0;
  height: 36px
}

.vkuiCalendarDay--size-s,
.vkuiCalendarDay__hidden--size-s {
  height: 34px
}

.vkuiCalendarDay--disabled,
.vkuiCalendarDay--not-same-month {
  color: #99a2ad;
  color: var(--vkui--color_text_tertiary)
}

.vkuiCalendarDay--selected {
  background-color: #f5f5f5;
  background-color: var(--vkui--color_background_secondary)
}

.vkuiCalendarDay--selection-start.vkuiCalendarDay--selected,
.vkuiCalendarDay__hinted--selection-start {
  border-bottom-left-radius: 8px;
  border-top-left-radius: 8px
}

.vkuiCalendarDay--selection-end.vkuiCalendarDay--selected,
.vkuiCalendarDay__hinted--selection-end {
  border-bottom-right-radius: 8px;
  border-top-right-radius: 8px
}

.vkuiCalendarDay__day-number {
  text-align: center
}

.vkuiCalendarDay--today {
  font-weight: 600
}

.vkuiCalendarDay--today .vkuiCalendarDay__day-number:after {
  border-bottom: 2px solid #2688eb;
  border-bottom: 2px solid var(--vkui--color_stroke_accent);
  content: "";
  display: block;
  left: 50%;
  position: relative;
  transform: translateX(-50%);
  width: 16px
}

.vkuiCalendarDay--today .vkuiCalendarDay__inner--active .vkuiCalendarDay__day-number:after {
  border-bottom-color: #fff;
  border-bottom-color: var(--vkui--color_stroke_contrast)
}

.vkuiCalendarDay__hinted,
.vkuiCalendarDay__inner {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%
}

.vkuiCalendarDay__inner {
  border-radius: 8px
}

.vkuiCalendarDay--hover :not(.vkuiCalendarDay__hinted--active) .vkuiCalendarDay__inner,
.vkuiCalendarDay__hinted--active {
  background-color: rgba(0, 0, 0, .08);
  background-color: var(--vkui--color_background_secondary_alpha--hover)
}

.vkuiCalendarDay__inner--active {
  background-color: #2688eb;
  background-color: var(--vkui--color_background_accent);
  color: #fff;
  color: var(--vkui--color_text_contrast)
}

.vkuiCalendarTime {
  align-items: center;
  display: flex
}

.vkuiCalendarTime__picker {
  width: 77px
}

.vkuiCalendarTime__divider {
  color: #000;
  color: var(--vkui--color_text_primary);
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_family_base);
  margin-left: 6px;
  margin-right: 6px
}

.vkuiCalendarTime__button {
  margin-left: auto
}

.vkuiCalendarRange {
  background: #fff;
  background: var(--vkui--color_background_modal);
  border: .5px solid #d7d8d9;
  border: .5px solid var(--vkui--color_separator_primary);
  border-radius: 8px;
  box-shadow: 0 0 2px rgba(0, 0, 0, .03), 0 2px 2px rgba(0, 0, 0, .06);
  box-shadow: var(--vkui--elevation1);
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 12px;
  width: 610px
}

.vkuiCalendarRange__inner {
  display: flex;
  flex-direction: column;
  flex-grow: 1
}

.vkuiCalendarRange__inner:not(:last-child) {
  margin-right: 24px
}

.vkuiCalendarRange__header {
  margin-bottom: 4px
}

.vkuiInputLike__mask {
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_family_base);
  position: relative
}

.vkuiInputLike__mask:after {
  border-bottom: 1px solid #818c99;
  border-bottom: 1px solid var(--vkui--color_text_secondary);
  bottom: 0;
  content: "";
  height: 1px;
  left: 0;
  position: absolute;
  width: calc(100% - .1em)
}

.vkuiInputLike__mask:last-child {
  margin-right: 1px
}

.vkuiInputLike__divider,
.vkuiInputLike__last_character {
  letter-spacing: 1px !important
}

.vkuiInputLike__divider {
  color: #818c99;
  color: var(--vkui--color_text_secondary)
}

.vkuiInputLike--full+.vkuiInputLike__divider {
  color: #000;
  color: var(--vkui--color_text_primary)
}

.vkuiDateInput__input {
  cursor: text;
  flex-grow: 1;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  margin-left: 10px;
  margin-right: 14px;
  -webkit-user-select: text;
  user-select: text;
  white-space: nowrap;
  z-index: 1;
  z-index: var(--vkui_internal--z_index_form_field_element)
}

.vkuiDateInput__input--time-divider {
  letter-spacing: 6px !important
}

.vkuiDateInput--sizeY-compact .vkuiDateInput__input {
  margin-right: 22px
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiDateInput--sizeY-none .vkuiDateInput__input {
    margin-right: 22px
  }
}

.vkuiDateRangeInput__input {
  cursor: text;
  flex-grow: 1;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  margin-left: 10px;
  margin-right: 14px;
  -webkit-user-select: text;
  user-select: text;
  white-space: nowrap;
  z-index: 1;
  z-index: var(--vkui_internal--z_index_form_field_element)
}

.vkuiDateRangeInput--sizeY-compact .vkuiDateRangeInput__input {
  margin-right: 22px
}

@media (max-height:414.9px),
(pointer:fine) and (min-width:768px) {
  .vkuiDateRangeInput--sizeY-none .vkuiDateRangeInput__input {
    margin-right: 22px
  }
}

.vkuiDiv {
  padding: 12px 16px;
  padding: var(--vkui--size_base_padding_vertical--regular) var(--vkui--size_base_padding_horizontal--regular)
}

.vkuiVisuallyHiddenInput {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  white-space: nowrap
}

.vkuiPromoBanner {
  background: #fff;
  background: var(--vkui--color_background_content);
  box-sizing: border-box;
  color: #000;
  color: var(--vkui--color_text_primary);
  outline: var(--vkui--size_border--regular) solid rgba(0, 0, 0, .12);
  outline: var(--vkui--size_border--regular) solid var(--vkui--color_separator_primary_alpha);
  padding-bottom: 10px;
  position: relative;
  width: 100%
}

.vkuiPromoBanner__head {
  color: #818c99;
  color: var(--vkui--color_text_secondary);
  display: flex;
  padding: 14px 16px 10px;
  padding: 14px var(--vkui--size_base_padding_horizontal--regular) 10px
}

.vkuiPromoBanner__age {
  margin-left: 6px
}

.vkuiPromoBanner__close {
  align-items: center;
  color: #99a2ad;
  color: var(--vkui--color_icon_secondary);
  display: flex;
  height: 48px;
  justify-content: center;
  position: absolute;
  right: 0;
  top: 0;
  width: 48px
}

.vkuiPromoBanner__close:active {
  opacity: .7
}

.vkuiPromoBanner__pixels {
  display: none
}

.vkuiChipsSelect {
  position: relative
}

.vkuiChipsSelect__dropdown {
  cursor: pointer
}

.vkuiChipsSelect__icon {
  pointer-events: none
}

.vkuiChipsSelect__empty {
  color: #818c99;
  color: var(--vkui--color_text_secondary);
  padding: 12px 0;
  text-align: center
}

.vkuiChipsSelect--pop-down {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0
}

.vkuiChipsSelect--pop-up {
  border-top-left-radius: 0;
  border-top-right-radius: 0
}

.vkuiPopover {
  animation: vkuipopover-fade-in .2s ease;
  background: #fff;
  background: var(--vkui--color_background_modal);
  border-radius: 8px;
  border-radius: var(--vkui--size_border_radius--regular);
  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);
  box-shadow: var(--vkui--elevation3);
  position: relative
}

.vkuiPopover:before {
  bottom: calc(-1 * 8px);
  bottom: calc(-1 * var(--vkui_internal--popover_safe_zone_padding));
  content: "";
  left: calc(-1 * 8px);
  left: calc(-1 * var(--vkui_internal--popover_safe_zone_padding));
  position: absolute;
  right: calc(-1 * 8px);
  right: calc(-1 * var(--vkui_internal--popover_safe_zone_padding));
  top: calc(-1 * 8px);
  top: calc(-1 * var(--vkui_internal--popover_safe_zone_padding))
}

.vkuiPopover__in {
  position: relative
}

@keyframes vkuipopover-fade-in {
  0% {
    opacity: 0
  }

  to {
    opacity: 1
  }
}

.vkuiTextTooltip {
  animation: vkuitexttooltip-fade-in .2s ease;
  background-color: #fff;
  background-color: var(--vkui--color_background_modal);
  border-radius: 8px;
  border-radius: var(--vkui--size_border_radius--regular);
  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);
  box-shadow: var(--vkui--elevation3);
  color: #000;
  color: var(--vkui--color_text_primary);
  padding: 8px 12px 9px
}

.vkuiTextTooltip__arrow {
  color: #fff;
  color: var(--vkui--color_background_modal)
}

.vkuiTextTooltip--appearance-accent {
  background-color: #5a9eff;
  background-color: var(--vkui--color_background_accent_tint);
  color: #fff;
  color: var(--vkui--color_text_contrast)
}

.vkuiTextTooltip--appearance-accent .vkuiTextTooltip__arrow {
  color: #5a9eff;
  color: var(--vkui--color_background_accent_tint)
}

.vkuiTextTooltip--appearance-white {
  background-color: #fff;
  background-color: var(--vkui--color_background_contrast);
  color: #000;
  color: var(--vkui--color_text_primary_invariably)
}

.vkuiTextTooltip--appearance-white .vkuiTextTooltip__arrow {
  color: #fff;
  color: var(--vkui--color_background_contrast)
}

.vkuiTextTooltip--appearance-black {
  background-color: #2c2d2e;
  background-color: var(--vkui--color_background_contrast_inverse);
  color: #fff;
  color: var(--vkui--color_text_contrast)
}

.vkuiTextTooltip--appearance-black .vkuiTextTooltip__arrow {
  color: #2c2d2e;
  color: var(--vkui--color_background_contrast_inverse)
}

.vkuiTextTooltip--appearance-inversion {
  background-color: #2d2d2e;
  background-color: var(--vkui--color_background_modal_inverse);
  color: #fff;
  color: var(--vkui--color_text_contrast_themed)
}

.vkuiTextTooltip--appearance-inversion .vkuiTextTooltip__arrow {
  color: #2d2d2e;
  color: var(--vkui--color_background_modal_inverse)
}

@keyframes vkuitexttooltip-fade-in {
  0% {
    opacity: 0
  }

  to {
    opacity: 1
  }
}

.vkuiRichTooltip {
  animation: vkuirichtooltip-fade-in .2s ease;
  background-color: #fff;
  background-color: var(--vkui--color_background_modal);
  border-radius: 8px;
  border-radius: var(--vkui--size_border_radius--regular);
  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);
  box-shadow: var(--vkui--elevation3);
  color: #000;
  color: var(--vkui--color_text_primary)
}

.vkuiRichTooltip__arrow {
  color: #fff;
  color: var(--vkui--color_background_modal)
}

.vkuiRichTooltip--appearance-accent {
  background-color: #5a9eff;
  background-color: var(--vkui--color_background_accent_tint);
  color: #fff;
  color: var(--vkui--color_text_contrast)
}

.vkuiRichTooltip--appearance-accent .vkuiRichTooltip__arrow {
  color: #5a9eff;
  color: var(--vkui--color_background_accent_tint)
}

.vkuiRichTooltip--appearance-white {
  background-color: #fff;
  background-color: var(--vkui--color_background_contrast);
  color: #000;
  color: var(--vkui--color_text_primary_invariably)
}

.vkuiRichTooltip--appearance-white .vkuiRichTooltip__arrow {
  color: #fff;
  color: var(--vkui--color_background_contrast)
}

.vkuiRichTooltip--appearance-black {
  background-color: #2c2d2e;
  background-color: var(--vkui--color_background_contrast_inverse);
  color: #fff;
  color: var(--vkui--color_text_contrast)
}

.vkuiRichTooltip--appearance-black .vkuiRichTooltip__arrow {
  color: #2c2d2e;
  color: var(--vkui--color_background_contrast_inverse)
}

.vkuiRichTooltip--appearance-inversion {
  background-color: #2d2d2e;
  background-color: var(--vkui--color_background_modal_inverse);
  color: #fff;
  color: var(--vkui--color_text_contrast_themed)
}

.vkuiRichTooltip--appearance-inversion .vkuiRichTooltip__arrow {
  color: #2d2d2e;
  color: var(--vkui--color_background_modal_inverse)
}

@keyframes vkuirichtooltip-fade-in {
  0% {
    opacity: 0
  }

  to {
    opacity: 1
  }
}

.vkuiHorizontalCellShowMore {
  display: flex
}

.vkuiHorizontalCellShowMore--compensate-last-cell-indent {
  margin-left: calc(-1 * calc(16px - 6px));
  margin-left: calc(-1 * var(--vkui_internal--side_cell_gap))
}

.vkuiHorizontalCellShowMore:last-child:after {
  content: "";
  min-width: calc(16px - 6px);
  min-width: var(--vkui_internal--side_cell_gap)
}

.vkuiHorizontalCellShowMore__body {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4px 6px;
  padding: 4px var(--vkui--spacing_size_s)
}

.vkuiHorizontalCellShowMore--size-s .vkuiHorizontalCellShowMore__body {
  min-width: 64px;
  padding: 4px;
  padding: var(--vkui--spacing_size_xs)
}

.vkuiHorizontalCellShowMore--size-l .vkuiHorizontalCellShowMore__body,
.vkuiHorizontalCellShowMore--size-m .vkuiHorizontalCellShowMore__body {
  margin-bottom: auto;
  width: 128px
}

.vkuiHorizontalCellShowMore .vkuiHorizontalCellShowMore__body {
  border-radius: 8px;
  border-radius: var(--vkui--size_border_radius--regular)
}

.vkuiHorizontalCellShowMore__icon {
  color: #2688eb;
  color: var(--vkui--color_icon_accent)
}

.vkuiHorizontalCellShowMore__text {
  color: #2688eb;
  color: var(--vkui--color_text_accent);
  padding-top: 8px
}

.vkui,
.vkui>body,
.vkui__root {
  height: 100%;
  margin: 0;
  padding: 0
}

.vkui,
.vkui>body {
  -webkit-tap-highlight-color: transparent;
  -webkit-text-size-adjust: 100%;
  color: #000;
  color: var(--vkui--color_text_primary);
  color-scheme: light;
  color-scheme: var(--vkui--colors_scheme);
  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;
  font-family: var(--vkui--font_family_base)
}

.vkui__root--embedded {
  overflow-x: hidden
}

.vkui--sizeX-regular {
  background: #ebedf0;
  background: var(--vkui--color_background)
}

@media (min-width:768px) {
  .vkui--sizeX-none {
    background: #ebedf0;
    background: var(--vkui--color_background)
  }
}

.vkui--layout-card {
  background: #ebedf0;
  background: var(--vkui--color_background)
}

.vkui--layout-plain {
  background: #fff;
  background: var(--vkui--color_background_content)
}

.vkui--disable-overscroll-behavior {
  overscroll-behavior-y: none
}`, "",{"version":3,"sources":["webpack://./src/style/gmpui.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;;AAEA;;;EAGE,iCAAiC;EACjC,mDAAmD;EACnD,yCAAyC;EACzC,yCAAyC;EACzC,wCAAwC;EACxC,wCAAwC;EACxC,sCAAsC;EACtC,sCAAsC;EACtC;AACF;;AAEA;;;;;;;EAOE,gKAAgK;EAChK,2KAA2K;EAC3K,kFAAkF;EAClF,4FAA4F;EAC5F,kFAAkF;EAClF,mFAAmF;EACnF,oFAAoF;EACpF,6FAA6F;EAC7F,0FAA0F;EAC1F,wFAAwF;EACxF,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,6CAA6C;EAC7C,+CAA+C;EAC/C,yGAAyG;EACzG,8CAA8C;EAC9C,6CAA6C;EAC7C,+CAA+C;EAC/C,yGAAyG;EACzG,8CAA8C;EAC9C,6CAA6C;EAC7C,+CAA+C;EAC/C,yGAAyG;EACzG,8CAA8C;EAC9C,gDAAgD;EAChD,kDAAkD;EAClD,4GAA4G;EAC5G,iDAAiD;EACjD,gDAAgD;EAChD,kDAAkD;EAClD,4GAA4G;EAC5G,iDAAiD;EACjD,gDAAgD;EAChD,kDAAkD;EAClD,2CAA2C;EAC3C,6CAA6C;EAC7C,uGAAuG;EACvG,4CAA4C;EAC5C,gDAAgD;EAChD,kDAAkD;EAClD,4GAA4G;EAC5G,iDAAiD;EACjD,8CAA8C;EAC9C,gDAAgD;EAChD,0GAA0G;EAC1G,+CAA+C;EAC/C,+CAA+C;EAC/C,iDAAiD;EACjD,2GAA2G;EAC3G,gDAAgD;EAChD,oDAAoD;EACpD,sDAAsD;EACtD,gHAAgH;EAChH,qDAAqD;EACrD,8DAA8D;EAC9D,+CAA+C;EAC/C,iDAAiD;EACjD,2GAA2G;EAC3G,gDAAgD;EAChD,oDAAoD;EACpD,sDAAsD;EACtD,gHAAgH;EAChH,qDAAqD;EACrD,8DAA8D;EAC9D,+CAA+C;EAC/C,iDAAiD;EACjD,2GAA2G;EAC3G,gDAAgD;EAChD,oDAAoD;EACpD,sDAAsD;EACtD,gHAAgH;EAChH,qDAAqD;EACrD,8DAA8D;EAC9D,8CAA8C;EAC9C,iDAAiD;EACjD,2GAA2G;EAC3G,gDAAgD;EAChD,mDAAmD;EACnD,sDAAsD;EACtD,gHAAgH;EAChH,qDAAqD;EACrD,8DAA8D;EAC9D,8CAA8C;EAC9C,8CAA8C;EAC9C,8CAA8C;EAC9C,8CAA8C;EAC9C,gDAAgD;EAChD,gDAAgD;EAChD,mDAAmD;EACnD,iDAAiD;EACjD,8CAA8C;EAC9C,+CAA+C;EAC/C,+CAA+C;EAC/C,wCAAwC;EACxC,wCAAwC;EACxC,yCAAyC;EACzC,yCAAyC;EACzC,+CAA+C;EAC/C,+CAA+C;EAC/C,gDAAgD;EAChD,gDAAgD;EAChD,+CAA+C;EAC/C,+CAA+C;EAC/C,oCAAoC;EACpC,gCAAgC;EAChC,uCAAuC;EACvC,yCAAyC;EACzC,wCAAwC;EACxC,oDAAoD;EACpD,qDAAqD;EACrD,yCAAyC;EACzC,yCAAyC;EACzC,oCAAoC;EACpC,sCAAsC;EACtC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,uCAAuC;EACvC,qCAAqC;EACrC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,qCAAqC;EACrC,2CAA2C;EAC3C,oDAAoD;EACpD,iDAAiD;EACjD,iDAAiD;EACjD,iDAAiD;EACjD,mDAAmD;EACnD,4CAA4C;EAC5C,gEAAgE;EAChE,iEAAiE;EACjE,gEAAgE;EAChE,qEAAqE;EACrE,sEAAsE;EACtE,qEAAqE;EACrE,oEAAoE;EACpE,qEAAqE;EACrE,oEAAoE;EACpE,wEAAwE;EACxE,yEAAyE;EACzE,yEAAyE;EACzE,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,8DAA8D;EAC9D,mCAAmC;EACnC,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,gEAAgE;EAChE,4BAA4B;EAC5B,2CAA2C;EAC3C,yBAAyB;EACzB,2BAA2B;EAC3B,+CAA+C;EAC/C,iDAAiD;EACjD,2GAA2G;EAC3G,gDAAgD;EAChD,6CAA6C;EAC7C,gFAAgF;EAChF,iFAAiF;EACjF,qCAAqC;EACrC,wCAAwC;EACxC,8CAA8C;EAC9C,yCAAyC;EACzC,uCAAuC;EACvC,gDAAgD;EAChD,wDAAwD;EACxD,yDAAyD;EACzD,+CAA+C;EAC/C,uDAAuD;EACvD,wDAAwD;EACxD,kEAAkE;EAClE,yEAAyE;EACzE,0EAA0E;EAC1E;AACF;;AAEA;;;;EAIE,wKAAwK;EACxK,qKAAqK;EACrK,4BAA4B;EAC5B,oDAAoD;EACpD,qDAAqD;EACrD,gDAAgD;EAChD,iDAAiD;EACjD,2DAA2D;EAC3D,kEAAkE;EAClE,mEAAmE;EACnE,iDAAiD;EACjD,kDAAkD;EAClD,wEAAwE;EACxE,8CAA8C;EAC9C,wDAAwD;EACxD,yDAAyD;EACzD,8CAA8C;EAC9C,+CAA+C;EAC/C,sDAAsD;EACtD,uDAAuD;EACvD,yCAAyC;EACzC,gDAAgD;EAChD,iDAAiD;EACjD,iDAAiD;EACjD,kDAAkD;EAClD,iDAAiD;EACjD,kDAAkD;EAClD,+CAA+C;EAC/C,sDAAsD;EACtD,uDAAuD;EACvD,+CAA+C;EAC/C,sDAAsD;EACtD,uDAAuD;EACvD,+CAA+C;EAC/C,gDAAgD;EAChD,gCAAgC;EAChC,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;EAC5C,6CAA6C;EAC7C,2CAA2C;EAC3C,4CAA4C;EAC5C,2CAA2C;EAC3C,4CAA4C;EAC5C,kDAAkD;EAClD,mDAAmD;EACnD,2CAA2C;EAC3C,4CAA4C;EAC5C,2CAA2C;EAC3C,4CAA4C;EAC5C,4CAA4C;EAC5C,6CAA6C;EAC7C,+CAA+C;EAC/C,gDAAgD;EAChD,2CAA2C;EAC3C,4CAA4C;EAC5C,mCAAmC;EACnC,0CAA0C;EAC1C,2CAA2C;EAC3C,mDAAmD;EACnD,0DAA0D;EAC1D,2DAA2D;EAC3D,4CAA4C;EAC5C,6CAA6C;EAC7C,sDAAsD;EACtD,4DAA4D;EAC5D,8DAA8D;EAC9D,qDAAqD;EACrD,4DAA4D;EAC5D,6DAA6D;EAC7D,2CAA2C;EAC3C,4CAA4C;EAC5C,kDAAkD;EAClD,mDAAmD;EACnD,qDAAqD;EACrD,sDAAsD;EACtD,2CAA2C;EAC3C,4CAA4C;EAC5C,2CAA2C;EAC3C,4CAA4C;EAC5C,iDAAiD;EACjD,kDAAkD;EAClD,iDAAiD;EACjD,kDAAkD;EAClD,yDAAyD;EACzD,gEAAgE;EAChE,gEAAgE;EAChE,6CAA6C;EAC7C,8CAA8C;EAC9C,6CAA6C;EAC7C,8CAA8C;EAC9C,mCAAmC;EACnC,6CAA6C;EAC7C,8CAA8C;EAC9C,oDAAoD;EACpD,2DAA2D;EAC3D,4DAA4D;EAC5D,oDAAoD;EACpD,2DAA2D;EAC3D,4DAA4D;EAC5D,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,2CAA2C;EAC3C,4CAA4C;EAC5C,0CAA0C;EAC1C,iDAAiD;EACjD,kDAAkD;EAClD,gDAAgD;EAChD,iDAAiD;EACjD,2CAA2C;EAC3C,4CAA4C;EAC5C,2CAA2C;EAC3C,4CAA4C;EAC5C,4CAA4C;EAC5C,mDAAmD;EACnD,oDAAoD;EACpD,8CAA8C;EAC9C,+CAA+C;EAC/C,qDAAqD;EACrD,6DAA6D;EAC7D,8DAA8D;EAC9D,wCAAwC;EACxC,+CAA+C;EAC/C,gDAAgD;EAChD,wCAAwC;EACxC,+CAA+C;EAC/C,gDAAgD;EAChD,2DAA2D;EAC3D,kEAAkE;EAClE,mEAAmE;EACnE,8DAA8D;EAC9D,qEAAqE;EACrE,sEAAsE;EACtE,qCAAqC;EACrC,+CAA+C;EAC/C,gDAAgD;EAChD,2CAA2C;EAC3C,kDAAkD;EAClD,mDAAmD;EACnD,sDAAsD;EACtD;AACF;;AAEA;;;;;EAKE,gDAAgD;EAChD,kDAAkD;EAClD,2CAA2C;EAC3C,6CAA6C;EAC7C,8CAA8C;EAC9C,gDAAgD;EAChD,wCAAwC;EACxC,sDAAsD;EACtD,qCAAqC;EACrC,sCAAsC;EACtC,+CAA+C;EAC/C,iDAAiD;EACjD,kDAAkD;EAClD,0CAA0C;EAC1C,2CAA2C;EAC3C,oCAAoC;EACpC,8CAA8C;EAC9C,oCAAoC;EACpC,sCAAsC;EACtC,kCAAkC;EAClC,iCAAiC;EACjC,mCAAmC;EACnC;AACF;;AAEA;;;;;EAKE,wCAAwC;EACxC,6CAA6C;EAC7C;AACF;;AAEA;;;EAGE,wCAAwC;EACxC,+CAA+C;EAC/C,gDAAgD;EAChD,+CAA+C;EAC/C,sDAAsD;EACtD,uDAAuD;EACvD,oDAAoD;EACpD,2DAA2D;EAC3D,4DAA4D;EAC5D,iCAAiC;EACjC,wCAAwC;EACxC,yCAAyC;EACzC,sCAAsC;EACtC,2CAA2C;EAC3C,kDAAkD;EAClD,mDAAmD;EACnD,4DAA4D;EAC5D,mEAAmE;EACnE,oEAAoE;EACpE,0CAA0C;EAC1C,iDAAiD;EACjD,kDAAkD;EAClD,uCAAuC;EACvC,yDAAyD;EACzD,0DAA0D;EAC1D,oCAAoC;EACpC,+CAA+C;EAC/C,0CAA0C;EAC1C,uCAAuC;EACvC,8CAA8C;EAC9C,+CAA+C;EAC/C,qCAAqC;EACrC,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,yCAAyC;EACzC,gDAAgD;EAChD,iDAAiD;EACjD,qDAAqD;EACrD,sDAAsD;EACtD,qCAAqC;EACrC,mCAAmC;EACnC,0CAA0C;EAC1C,2CAA2C;EAC3C,oCAAoC;EACpC,iCAAiC;EACjC,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;EAChC,uCAAuC;EACvC,wCAAwC;EACxC,uCAAuC;EACvC,8CAA8C;EAC9C,+CAA+C;EAC/C,iCAAiC;EACjC,wCAAwC;EACxC,yCAAyC;EACzC,iCAAiC;EACjC,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,yCAAyC;EACzC,gDAAgD;EAChD,iDAAiD;EACjD,qDAAqD;EACrD,sDAAsD;EACtD,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,qCAAqC;EACrC,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,iCAAiC;EACjC,wCAAwC;EACxC,oCAAoC;EACpC,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,2CAA2C;EAC3C,kDAAkD;EAClD,mDAAmD;EACnD,wCAAwC;EACxC,+CAA+C;EAC/C,gDAAgD;EAChD,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,iDAAiD;EACjD,kDAAkD;EAClD,sCAAsC;EACtC,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,yCAAyC;EACzC,0CAA0C;EAC1C,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,qCAAqC;EACrC,4CAA4C;EAC5C,6CAA6C;EAC7C,iDAAiD;EACjD,wDAAwD;EACxD,yDAAyD;EACzD,6CAA6C;EAC7C,oDAAoD;EACpD,qDAAqD;EACrD,uCAAuC;EACvC,8CAA8C;EAC9C,+CAA+C;EAC/C,mCAAmC;EACnC,0CAA0C;EAC1C,2CAA2C;EAC3C,8CAA8C;EAC9C,qDAAqD;EACrD,sDAAsD;EACtD,wCAAwC;EACxC,+CAA+C;EAC/C;AACF;;AAEA;EACE;AACF;;AAEA;;;EAGE,wKAAwK;EACxK,iLAAiL;EACjL,2BAA2B;EAC3B,oDAAoD;EACpD,qDAAqD;EACrD,+DAA+D;EAC/D,uEAAuE;EACvE,wEAAwE;EACxE,+DAA+D;EAC/D,sEAAsE;EACtE,uEAAuE;EACvE,iDAAiD;EACjD,kDAAkD;EAClD,wEAAwE;EACxE,iDAAiD;EACjD,wDAAwD;EACxD,yDAAyD;EACzD,4CAA4C;EAC5C,sDAAsD;EACtD,uDAAuD;EACvD,yCAAyC;EACzC,gDAAgD;EAChD,iDAAiD;EACjD,iDAAiD;EACjD,kDAAkD;EAClD,iDAAiD;EACjD,kDAAkD;EAClD,+CAA+C;EAC/C,sDAAsD;EACtD,uDAAuD;EACvD,+CAA+C;EAC/C,sDAAsD;EACtD,uDAAuD;EACvD,0CAA0C;EAC1C,2CAA2C;EAC3C,2CAA2C;EAC3C,4CAA4C;EAC5C,2CAA2C;EAC3C,4CAA4C;EAC5C,2CAA2C;EAC3C,4CAA4C;EAC5C,4CAA4C;EAC5C,6CAA6C;EAC7C,+CAA+C;EAC/C,gDAAgD;EAChD,2CAA2C;EAC3C,4CAA4C;EAC5C,mCAAmC;EACnC,0CAA0C;EAC1C,2CAA2C;EAC3C,qDAAqD;EACrD,sDAAsD;EACtD,2CAA2C;EAC3C,4CAA4C;EAC5C,2CAA2C;EAC3C,4CAA4C;EAC5C,wCAAwC;EACxC,+CAA+C;EAC/C,gDAAgD;EAChD,0CAA0C;EAC1C,iDAAiD;EACjD,kDAAkD;EAClD,0CAA0C;EAC1C,iDAAiD;EACjD,kDAAkD;EAClD,6DAA6D;EAC7D,oEAAoE;EACpE,oEAAoE;EACpE,6CAA6C;EAC7C,8CAA8C;EAC9C,6CAA6C;EAC7C,8CAA8C;EAC9C,mCAAmC;EACnC,6CAA6C;EAC7C,8CAA8C;EAC9C,wDAAwD;EACxD,+DAA+D;EAC/D,gEAAgE;EAChE,wDAAwD;EACxD,+DAA+D;EAC/D,+DAA+D;EAC/D,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,2CAA2C;EAC3C,4CAA4C;EAC5C,0CAA0C;EAC1C,iDAAiD;EACjD,kDAAkD;EAClD,gDAAgD;EAChD,iDAAiD;EACjD,4CAA4C;EAC5C,mDAAmD;EACnD,oDAAoD;EACpD,8CAA8C;EAC9C,+CAA+C;EAC/C,qDAAqD;EACrD,6DAA6D;EAC7D,8DAA8D;EAC9D,wCAAwC;EACxC,+CAA+C;EAC/C,gDAAgD;EAChD,wCAAwC;EACxC,+CAA+C;EAC/C,gDAAgD;EAChD,+DAA+D;EAC/D,sEAAsE;EACtE,uEAAuE;EACvE,iEAAiE;EACjE,yEAAyE;EACzE,0EAA0E;EAC1E,+CAA+C;EAC/C,gDAAgD;EAChD,wCAAwC;EACxC,+CAA+C;EAC/C,gDAAgD;EAChD,2CAA2C;EAC3C,kDAAkD;EAClD,mDAAmD;EACnD,wDAAwD;EACxD;AACF;;AAEA;;;EAGE;AACF;;AAEA;;EAEE,wCAAwC;EACxC,+CAA+C;EAC/C,gDAAgD;EAChD,4CAA4C;EAC5C,sDAAsD;EACtD,uDAAuD;EACvD,oDAAoD;EACpD,2DAA2D;EAC3D,4DAA4D;EAC5D,iCAAiC;EACjC,wCAAwC;EACxC,yCAAyC;EACzC,yCAAyC;EACzC,gDAAgD;EAChD,iDAAiD;EACjD,2CAA2C;EAC3C,kDAAkD;EAClD,mDAAmD;EACnD,0CAA0C;EAC1C,iDAAiD;EACjD,kDAAkD;EAClD,yDAAyD;EACzD,0DAA0D;EAC1D,uCAAuC;EACvC,8CAA8C;EAC9C,+CAA+C;EAC/C,0CAA0C;EAC1C,uCAAuC;EACvC,8CAA8C;EAC9C,+CAA+C;EAC/C,wCAAwC;EACxC,+CAA+C;EAC/C,gDAAgD;EAChD,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,sCAAsC;EACtC,gDAAgD;EAChD,iDAAiD;EACjD,mCAAmC;EACnC,qDAAqD;EACrD,sDAAsD;EACtD,qCAAqC;EACrC,4CAA4C;EAC5C,6CAA6C;EAC7C,mCAAmC;EACnC,0CAA0C;EAC1C,2CAA2C;EAC3C,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,wCAAwC;EACxC,kDAAkD;EAClD,mDAAmD;EACnD,oCAAoC;EACpC,gCAAgC;EAChC,uCAAuC;EACvC,wCAAwC;EACxC,oCAAoC;EACpC,8CAA8C;EAC9C,+CAA+C;EAC/C,iCAAiC;EACjC,wCAAwC;EACxC,yCAAyC;EACzC,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,sCAAsC;EACtC,gDAAgD;EAChD,iDAAiD;EACjD,qDAAqD;EACrD,sDAAsD;EACtD,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,yDAAyD;EACzD,+DAA+D;EAC/D,iEAAiE;EACjE,qCAAqC;EACrC,4CAA4C;EAC5C,6CAA6C;EAC7C,sDAAsD;EACtD,6DAA6D;EAC7D,8DAA8D;EAC9D,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,wDAAwD;EACxD,gEAAgE;EAChE,iEAAiE;EACjE,2CAA2C;EAC3C,4CAA4C;EAC5C,wCAAwC;EACxC,kDAAkD;EAClD,mDAAmD;EACnD,oCAAoC;EACpC,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,wCAAwC;EACxC,kDAAkD;EAClD,mDAAmD;EACnD,0CAA0C;EAC1C,iDAAiD;EACjD,kDAAkD;EAClD,sCAAsC;EACtC,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,yCAAyC;EACzC,0CAA0C;EAC1C,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,+BAA+B;EAC/B,yCAAyC;EACzC,0CAA0C;EAC1C,+BAA+B;EAC/B,yCAAyC;EACzC,0CAA0C;EAC1C,iCAAiC;EACjC,2CAA2C;EAC3C,4CAA4C;EAC5C,qCAAqC;EACrC,4CAA4C;EAC5C,6CAA6C;EAC7C,iDAAiD;EACjD,wDAAwD;EACxD,yDAAyD;EACzD,6CAA6C;EAC7C,oDAAoD;EACpD,qDAAqD;EACrD,uCAAuC;EACvC,8CAA8C;EAC9C,+CAA+C;EAC/C,mCAAmC;EACnC,0CAA0C;EAC1C,2CAA2C;EAC3C,8CAA8C;EAC9C,qDAAqD;EACrD,sDAAsD;EACtD;AACF;;AAEA;;;;EAIE,uCAAuC;EACvC,iCAAiC;EACjC;AACF;;AAEA;;;EAGE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,gCAAgC;EAChC,yCAAyC;EACzC,8CAA8C;EAC9C,yCAAyC;EACzC,yCAAyC;EACzC,wCAAwC;EACxC,wCAAwC;EACxC,sCAAsC;EACtC,sCAAsC;EACtC,+CAA+C;EAC/C;AACF;;AAEA;;;;EAIE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,+CAA+C;EAC/C,gDAAgD;EAChD,+CAA+C;EAC/C,sDAAsD;EACtD,uDAAuD;EACvD,oDAAoD;EACpD,2DAA2D;EAC3D,4DAA4D;EAC5D,iCAAiC;EACjC,wCAAwC;EACxC,yCAAyC;EACzC,sCAAsC;EACtC,2CAA2C;EAC3C,kDAAkD;EAClD,mDAAmD;EACnD,kEAAkE;EAClE,yEAAyE;EACzE,0EAA0E;EAC1E,0CAA0C;EAC1C,iDAAiD;EACjD,kDAAkD;EAClD,yDAAyD;EACzD,0DAA0D;EAC1D,oCAAoC;EACpC,+CAA+C;EAC/C,0CAA0C;EAC1C,uCAAuC;EACvC,8CAA8C;EAC9C,+CAA+C;EAC/C,qCAAqC;EACrC,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,yCAAyC;EACzC,gDAAgD;EAChD,iDAAiD;EACjD,qDAAqD;EACrD,sDAAsD;EACtD,qCAAqC;EACrC,mCAAmC;EACnC,0CAA0C;EAC1C,2CAA2C;EAC3C,oCAAoC;EACpC,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;EAChC,uCAAuC;EACvC,wCAAwC;EACxC,uCAAuC;EACvC,8CAA8C;EAC9C,+CAA+C;EAC/C,8BAA8B;EAC9B,wCAAwC;EACxC,yCAAyC;EACzC,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,yCAAyC;EACzC,gDAAgD;EAChD,iDAAiD;EACjD,qDAAqD;EACrD,sDAAsD;EACtD,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,qCAAqC;EACrC,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,wCAAwC;EACxC,oCAAoC;EACpC,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,2CAA2C;EAC3C,kDAAkD;EAClD,mDAAmD;EACnD,wCAAwC;EACxC,+CAA+C;EAC/C,gDAAgD;EAChD,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,iDAAiD;EACjD,kDAAkD;EAClD,sCAAsC;EACtC,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,yCAAyC;EACzC,0CAA0C;EAC1C,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,qCAAqC;EACrC,4CAA4C;EAC5C,6CAA6C;EAC7C,8CAA8C;EAC9C,wDAAwD;EACxD,yDAAyD;EACzD,6CAA6C;EAC7C,oDAAoD;EACpD,qDAAqD;EACrD,uCAAuC;EACvC,8CAA8C;EAC9C,+CAA+C;EAC/C,mCAAmC;EACnC,0CAA0C;EAC1C,2CAA2C;EAC3C,8CAA8C;EAC9C,qDAAqD;EACrD,sDAAsD;EACtD,wCAAwC;EACxC,+CAA+C;EAC/C;AACF;;AAEA;;EAEE,gCAAgC;EAChC,gDAAgD;EAChD,kDAAkD;EAClD,2CAA2C;EAC3C,6CAA6C;EAC7C,8CAA8C;EAC9C,gDAAgD;EAChD,wCAAwC;EACxC,yCAAyC;EACzC,yCAAyC;EACzC,wCAAwC;EACxC,wCAAwC;EACxC,sCAAsC;EACtC,sCAAsC;EACtC,+CAA+C;EAC/C,qDAAqD;EACrD,mCAAmC;EACnC,mCAAmC;EACnC,+CAA+C;EAC/C,iDAAiD;EACjD,+CAA+C;EAC/C,0CAA0C;EAC1C,2CAA2C;EAC3C,oCAAoC;EACpC,2CAA2C;EAC3C,oCAAoC;EACpC,sCAAsC;EACtC,kCAAkC;EAClC,iCAAiC;EACjC,mCAAmC;EACnC;AACF;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;EACxC,+CAA+C;EAC/C,gDAAgD;EAChD,+CAA+C;EAC/C,sDAAsD;EACtD,uDAAuD;EACvD,oDAAoD;EACpD,2DAA2D;EAC3D,4DAA4D;EAC5D,iCAAiC;EACjC,wCAAwC;EACxC,yCAAyC;EACzC,sCAAsC;EACtC,gDAAgD;EAChD,iDAAiD;EACjD,wCAAwC;EACxC,kDAAkD;EAClD,mDAAmD;EACnD,0CAA0C;EAC1C,iDAAiD;EACjD,kDAAkD;EAClD,yDAAyD;EACzD,0DAA0D;EAC1D,uCAAuC;EACvC,8CAA8C;EAC9C,+CAA+C;EAC/C,0CAA0C;EAC1C,uCAAuC;EACvC,8CAA8C;EAC9C,+CAA+C;EAC/C,qCAAqC;EACrC,+CAA+C;EAC/C,gDAAgD;EAChD,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,yCAAyC;EACzC,gDAAgD;EAChD,iDAAiD;EACjD,mCAAmC;EACnC,qDAAqD;EACrD,sDAAsD;EACtD,qCAAqC;EACrC,4CAA4C;EAC5C,6CAA6C;EAC7C,mCAAmC;EACnC,0CAA0C;EAC1C,2CAA2C;EAC3C,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,wCAAwC;EACxC,kDAAkD;EAClD,mDAAmD;EACnD,oCAAoC;EACpC,gCAAgC;EAChC,uCAAuC;EACvC,wCAAwC;EACxC,uCAAuC;EACvC,8CAA8C;EAC9C,+CAA+C;EAC/C,8BAA8B;EAC9B,wCAAwC;EACxC,yCAAyC;EACzC,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,yCAAyC;EACzC,gDAAgD;EAChD,iDAAiD;EACjD,qDAAqD;EACrD,sDAAsD;EACtD,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,uDAAuD;EACvD,8DAA8D;EAC9D,+DAA+D;EAC/D,qCAAqC;EACrC,4CAA4C;EAC5C,6CAA6C;EAC7C,yDAAyD;EACzD,iEAAiE;EACjE,kEAAkE;EAClE,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,yDAAyD;EACzD,gEAAgE;EAChE,iEAAiE;EACjE,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,wCAAwC;EACxC,kDAAkD;EAClD,mDAAmD;EACnD,oCAAoC;EACpC,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,2CAA2C;EAC3C,kDAAkD;EAClD,mDAAmD;EACnD,0CAA0C;EAC1C,iDAAiD;EACjD,kDAAkD;EAClD,sCAAsC;EACtC,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,yCAAyC;EACzC,0CAA0C;EAC1C,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,+BAA+B;EAC/B,yCAAyC;EACzC,0CAA0C;EAC1C,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,qCAAqC;EACrC,4CAA4C;EAC5C,6CAA6C;EAC7C,iDAAiD;EACjD,wDAAwD;EACxD,yDAAyD;EACzD,0CAA0C;EAC1C,oDAAoD;EACpD,qDAAqD;EACrD,uCAAuC;EACvC,8CAA8C;EAC9C,+CAA+C;EAC/C,gCAAgC;EAChC,0CAA0C;EAC1C,2CAA2C;EAC3C,8CAA8C;EAC9C,qDAAqD;EACrD,sDAAsD;EACtD;AACF;;AAEA;EACE,oCAAoC;EACpC,8CAA8C;EAC9C,wCAAwC;EACxC,sHAAsH;EACtH,+CAA+C;EAC/C,4BAA4B;EAC5B,yCAAyC;EACzC,2CAA2C;EAC3C,4CAA4C;EAC5C,0CAA0C;EAC1C,+BAA+B;EAC/B,yCAAyC;EACzC,gCAAgC;EAChC,wCAAwC;EACxC,gDAAgD;EAChD,6CAA6C;EAC7C,2CAA2C;EAC3C,yCAAyC;EACzC,sDAAsD;EACtD,0CAA0C;EAC1C,4CAA4C;EAC5C,6CAA6C;EAC7C,0CAA0C;EAC1C,wCAAwC;EACxC,8CAA8C;EAC9C,6CAA6C;EAC7C,6CAA6C;EAC7C,mDAAmD;EACnD,4CAA4C;EAC5C,2CAA2C;EAC3C,8CAA8C;EAC9C,6CAA6C;EAC7C,4CAA4C;EAC5C;AACF;;AAEA;EACE;IACE,mEAAmE;IACnE,uEAAuE;IACvE,yEAAyE;IACzE;EACF;AACF;;AAEA;EACE;IACE,8DAA8D;IAC9D,kEAAkE;IAClE,oEAAoE;IACpE;EACF;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;;;EAGE;IACE;EACF;AACF;;AAEA;;EAEE;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE;IACE;EACF;AACF;;AAEA;;;EAGE;IACE;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EAEE;IACE,iEAAiE;IACjE;EACF;AACF;;AAEA;EAEE;IACE,iEAAiE;IACjE;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EAGzB;AACF;;AAEA;EACE,yBAAyB;EAGzB;AACF;;AAEA;;EAEE;IACE,yBAAyB;IAGzB;EACF;;EAEA;IACE,yBAAyB;IAGzB;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yEAAyE;EACzE,2DAA2D;EAC3D,eAAe;EACf,uDAAuD;EACvD,gBAAgB;EAChB,2DAA2D;EAC3D,iBAAiB;EACjB;AACF;;AAEA;EACE,yEAAyE;EACzE,2DAA2D;EAC3D,eAAe;EACf,uDAAuD;EACvD,gBAAgB;EAChB,2DAA2D;EAC3D,iBAAiB;EACjB;AACF;;AAEA;EACE,yEAAyE;EACzE,2DAA2D;EAC3D,eAAe;EACf,uDAAuD;EACvD,gBAAgB;EAChB,2DAA2D;EAC3D,iBAAiB;EACjB;AACF;;AAEA;EACE,cAAc;EACd,SAAS;EACT;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,yEAAyE;EACzE,8DAA8D;EAC9D,eAAe;EACf,0DAA0D;EAC1D,gBAAgB;EAChB,8DAA8D;EAC9D,iBAAiB;EACjB;AACF;;AAEA;EACE,eAAe;EACf,0DAA0D;EAC1D,iBAAiB;EACjB;AACF;;AAEA;;EAEE;IACE,eAAe;IACf,0DAA0D;IAC1D,iBAAiB;IACjB;EACF;AACF;;AAEA;EACE,yEAAyE;EACzE,8DAA8D;EAC9D,eAAe;EACf,0DAA0D;EAC1D,gBAAgB;EAChB,8DAA8D;EAC9D,iBAAiB;EACjB;AACF;;AAEA;EACE,eAAe;EACf,0DAA0D;EAC1D,iBAAiB;EACjB;AACF;;AAEA;;EAEE;IACE,eAAe;IACf,0DAA0D;IAC1D,iBAAiB;IACjB;EACF;AACF;;AAEA;EACE,yEAAyE;EACzE,yDAAyD;EACzD,eAAe;EACf,qDAAqD;EACrD,gBAAgB;EAChB,yDAAyD;EACzD,iBAAiB;EACjB;AACF;;AAEA;EACE,eAAe;EACf,qDAAqD;EACrD,iBAAiB;EACjB;AACF;;AAEA;;EAEE;IACE,eAAe;IACf,qDAAqD;IACrD,iBAAiB;IACjB;EACF;AACF;;AAEA;EACE,yEAAyE;EACzE,8DAA8D;EAC9D,eAAe;EACf,0DAA0D;EAC1D,gBAAgB;EAChB,8DAA8D;EAC9D,iBAAiB;EACjB;AACF;;AAEA;EACE,yEAAyE;EACzE,4DAA4D;EAC5D,eAAe;EACf,wDAAwD;EACxD,gBAAgB;EAChB,4DAA4D;EAC5D,iBAAiB;EACjB;AACF;;AAEA;EACE,eAAe;EACf,wDAAwD;EACxD,iBAAiB;EACjB;AACF;;AAEA;;EAEE;IACE,eAAe;IACf,wDAAwD;IACxD,iBAAiB;IACjB;EACF;AACF;;AAEA;EACE,yEAAyE;EACzE,6DAA6D;EAC7D,eAAe;EACf,yDAAyD;EACzD,gBAAgB;EAChB,6DAA6D;EAC7D,iBAAiB;EACjB;AACF;;AAEA;EACE,yEAAyE;EACzE,kEAAkE;EAClE,eAAe;EACf,8DAA8D;EAC9D,gBAAgB;EAChB,kEAAkE;EAClE,iBAAiB;EACjB,kEAAkE;EAClE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yEAAyE;EACzE,6DAA6D;EAC7D,eAAe;EACf,yDAAyD;EACzD,gBAAgB;EAChB,6DAA6D;EAC7D,iBAAiB;EACjB;AACF;;AAEA;EACE,yEAAyE;EACzE,kEAAkE;EAClE,eAAe;EACf,8DAA8D;EAC9D,gBAAgB;EAChB,kEAAkE;EAClE,iBAAiB;EACjB;AACF;;AAEA;EACE,yEAAyE;EACzE,6DAA6D;EAC7D,eAAe;EACf,yDAAyD;EACzD,gBAAgB;EAChB,6DAA6D;EAC7D,iBAAiB;EACjB;AACF;;AAEA;EACE,yEAAyE;EACzE,kEAAkE;EAClE,eAAe;EACf,8DAA8D;EAC9D,gBAAgB;EAChB,kEAAkE;EAClE,iBAAiB;EACjB;AACF;;AAEA;EACE,yEAAyE;EACzE,6DAA6D;EAC7D,cAAc;EACd,yDAAyD;EACzD,gBAAgB;EAChB,6DAA6D;EAC7D,iBAAiB;EACjB;AACF;;AAEA;EACE,yEAAyE;EACzE,kEAAkE;EAClE,cAAc;EACd,8DAA8D;EAC9D,gBAAgB;EAChB,kEAAkE;EAClE,iBAAiB;EACjB;AACF;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,uDAAuD;EACvD,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE;AACF;;AAEA;;;EAGE;AACF;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,0CAA0C;EAC1C,UAAU;EACV;AACF;;AAEA;EACE,sCAAsC;EACtC;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sCAAsC;EACtC;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,sBAAsB;EACtB,UAAU;EACV;AACF;;AAEA;EACE,4DAA4D;EAC5D,wEAAwE;EACxE,gCAAgC;EAChC,kDAAkD;EAClD,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE,UAAU;IACV;EACF;;EAEA;IACE;EACF;;EAEA;IACE,UAAU;IACV;EACF;AACF;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,uDAAuD;EACvD,OAAO;EACP,qDAAqD;EACrD,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,sDAAsD;EACtD,MAAM;EACN,oDAAoD;EACpD,yBAAyB;EAGzB,iBAAiB;EACjB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;EAC9C,mBAAmB;EACnB,sDAAsD;EACtD;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,6CAA6C;EAC7C,kEAAkE;EAClE;AACF;;AAEA;EACE;IACE,4CAA4C;IAC5C,gEAAgE;IAChE,sBAAsB;IACtB;EACF;;EAEA;IACE,0CAA0C;IAC1C;EACF;AACF;;AAEA;EACE;IACE,SAAS;IACT,OAAO;IACP,QAAQ;IACR,MAAM;IACN;EACF;AACF;;AAEA;EACE;IACE,YAAY;IACZ,UAAU;IACV,WAAW;IACX,SAAS;IACT;EACF;AACF;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,eAAe;EACf,wDAAwD;EACxD,gBAAgB;EAChB,0DAA0D;EAC1D,eAAe;EACf,UAAU;EACV;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,MAAM;EACN;AACF;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,4DAA4D;EAC5D;AACF;;AAEA;EACE,gCAAgC;EAChC;AACF;;AAEA;;EAEE,qBAAqB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yDAAyD;EACzD,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;EACd,0EAA0E;EAC1E,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB;AACF;;AAEA;EACE,qFAAqF;EACrF,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;EAC1B,UAAU;EACV;AACF;;AAEA;;EAEE,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN;AACF;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;EAC9B,UAAU;EACV;AACF;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,oEAAoE;EACpE,mCAAmC;EACnC,WAAW;EACX,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV;AACF;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,OAAO;EACP,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,mCAAmC;EACnC,WAAW;EACX,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mCAAmC;EACnC,4DAA4D;EAC5D;AACF;;AAEA;EACE,wCAAwC;EACxC,iEAAiE;EACjE,cAAc;EACd;AACF;;AAEA;EACE,mCAAmC;EACnC,mDAAmD;EACnD,WAAW;EACX;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qCAAqC;EACrC,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uDAAuD;EACvD,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0DAA0D;EAC1D,eAAe;EACf,0DAA0D;EAC1D,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EAGzB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;;;EAGE;IACE,WAAW;IACX;EACF;AACF;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB;AACF;;AAEA;EACE,2BAA2B;EAC3B;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;;;;EAIE;AACF;;AAEA;EACE,gBAAgB;EAChB,6CAA6C;EAC7C,gBAAgB;EAChB,uBAAuB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;;EAEE,mBAAmB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;;EAEE,mBAAmB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;;EAEE,mBAAmB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;;EAEE,mBAAmB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;;EAEE,mBAAmB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;;EAEE,mBAAmB;EACnB;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;;;;EAIE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;;;;;;EAME,eAAe;EACf;AACF;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,oCAAoC;EACpC;AACF;;AAEA;EACE,oCAAoC;EACpC;AACF;;AAEA;EACE,oCAAoC;EACpC;AACF;;AAEA;;EAEE,yBAAyB;EACzB;AACF;;AAEA;;EAEE,sCAAsC;EACtC;AACF;;AAEA;;EAEE,sCAAsC;EACtC;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;;;EAGE,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;;EAGE,mCAAmC;EACnC;AACF;;AAEA;EACE,mCAAmC;EACnC;AACF;;AAEA;EACE,mCAAmC;EACnC;AACF;;AAEA;EACE,mCAAmC;EACnC;AACF;;AAEA;EACE,mCAAmC;EACnC;AACF;;AAEA;EACE,mCAAmC;EACnC;AACF;;AAEA;EACE,mCAAmC;EACnC;AACF;;AAEA;EACE,8CAA8C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,gEAAgE;EAChE;AACF;;AAEA;EACE,yBAAyB;EACzB,iEAAiE;EACjE;AACF;;AAEA;EACE,mCAAmC;EACnC;AACF;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,uCAAuC;EACvC;AACF;;AAEA;;;EAGE,wCAAwC;EACxC;AACF;;AAEA;;;EAGE,wCAAwC;EACxC;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;;;;EAIE,WAAW;EACX;AACF;;AAEA;EACE,gCAAgC;EAChC;AACF;;AAEA;EACE,mCAAmC;EACnC;AACF;;AAEA;EACE,mCAAmC;EACnC;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,eAAe;EACf,wDAAwD;EACxD,iBAAiB;EACjB;AACF;;AAEA;;EAEE,yEAAyE;EACzE;AACF;;AAEA;EACE,eAAe;EACf,wDAAwD;EACxD,iBAAiB;EACjB;AACF;;AAEA;;;EAGE;IACE,yEAAyE;IACzE,4DAA4D;IAC5D,eAAe;IACf,wDAAwD;IACxD,iBAAiB;IACjB;EACF;AACF;;AAEA;EACE,eAAe;EACf,0DAA0D;EAC1D,iBAAiB;EACjB;AACF;;AAEA;;EAEE,yEAAyE;EACzE;AACF;;AAEA;EACE,eAAe;EACf,0DAA0D;EAC1D,iBAAiB;EACjB;AACF;;AAEA;;;EAGE;IACE,yEAAyE;IACzE,8DAA8D;IAC9D,eAAe;IACf,0DAA0D;IAC1D,iBAAiB;IACjB;EACF;AACF;;AAEA;EACE,eAAe;EACf,0DAA0D;EAC1D,iBAAiB;EACjB;AACF;;AAEA;;EAEE,yEAAyE;EACzE;AACF;;AAEA;EACE,eAAe;EACf,0DAA0D;EAC1D,iBAAiB;EACjB;AACF;;AAEA;;;EAGE;IACE,yEAAyE;IACzE,8DAA8D;IAC9D,eAAe;IACf,0DAA0D;IAC1D,iBAAiB;IACjB;EACF;AACF;;AAEA;EACE,yEAAyE;EACzE,2DAA2D;EAC3D,eAAe;EACf,uDAAuD;EACvD,iBAAiB;EACjB;AACF;;AAEA;;;EAGE;IACE,yEAAyE;IACzE,2DAA2D;IAC3D,eAAe;IACf,uDAAuD;IACvD,iBAAiB;IACjB;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;;;EAGE;IACE,gBAAgB;IAChB;EACF;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;;;EAGE;IACE,WAAW;IACX;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;;;EAGE;IACE,gBAAgB;IAChB;EACF;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;;;EAGE;IACE,WAAW;IACX;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;;;EAGE;IACE,gBAAgB;IAChB;EACF;AACF;;AAEA;EACE,kFAAkF;EAClF;AACF;;AAEA;;;EAGE,wFAAwF;EACxF;AACF;;AAEA;EACE,mFAAmF;EACnF;AACF;;AAEA;;;EAGE,mFAAmF;EACnF;AACF;;AAEA;EACE,mFAAmF;EACnF;AACF;;AAEA;;;EAGE,mFAAmF;EACnF;AACF;;AAEA;EACE,mFAAmF;EACnF;AACF;;AAEA;;;EAGE,iFAAiF;EACjF;AACF;;AAEA;EACE,uFAAuF;EACvF;AACF;;AAEA;;;EAGE,mFAAmF;EACnF;AACF;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;EAEpB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;EAC7B,8BAA8B;EAC9B;AACF;;AAEA;EAGE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,SAAS;EACT,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;IACE;EACF;;EAEA;;IAEE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;;;EAGE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,uDAAuD;EACvD,aAAa;EACb,YAAY;EACZ,+CAA+C;EAC/C,uBAAuB;EACvB,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,+CAA+C;EAC/C,WAAW;EACX;AACF;;AAEA;;EAEE,YAAY;EACZ;AACF;;AAEA;;EAEE;IACE,WAAW;IACX;EACF;;EAEA;;;IAGE,YAAY;IACZ;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB;AACF;;AAEA;EACE,OAAO;EACP,eAAe;EACf;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,iFAAiF;EACjF;AACF;;AAEA;EACE,uFAAuF;EACvF;AACF;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN;AACF;;AAEA;EACE,qFAAqF;EACrF;AACF;;AAEA;EACE,+EAA+E;EAC/E,yFAAyF;AAC3F;;AAEA;EACE,0EAA0E;EAC1E;AACF;;AAEA;EACE,gFAAgF;EAChF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE,UAAU;IACV;EACF;;EAEA;IACE,UAAU;IACV;EACF;AACF;;AAEA;EACE;IACE,UAAU;IACV;EACF;;EAEA;IACE,UAAU;IACV;EACF;AACF;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB;AACF;;AAEA;;EAEE;AACF;;AAEA;;;;EAIE;AACF;;AAEA;;EAEE,YAAY;EACZ;AACF;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,OAAO;EACP,gBAAgB;EAChB,eAAe;EACf;AACF;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,OAAO;EACP,oBAAoB;EACpB,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV;AACF;;AAEA;EACE,kCAAkC;EAClC,oDAAoD;EACpD;AACF;;AAEA;;EAEE,wBAAwB;EACxB,oDAAoD;EACpD;AACF;;AAEA;EACE,kCAAkC;EAClC,oDAAoD;EACpD;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,kDAAkD;EAClD;AACF;;AAEA;EACE,+EAA+E;EAC/E;AACF;;AAEA;EACE,yEAAyE;EACzE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE,UAAU;IACV;EACF;;EAEA;IACE,UAAU;IACV;EACF;AACF;;AAEA;EACE;IACE,UAAU;IACV;EACF;;EAEA;IACE,UAAU;IACV;EACF;AACF;;AAEA;EACE,wEAAwE;EACxE;AACF;;AAEA;EACE,qEAAqE;EACrE;AACF;;AAEA;EACE,wEAAwE;EACxE;AACF;;AAEA;EACE,8EAA8E;EAC9E;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,mEAAmE;EACnE;AACF;;AAEA;EACE,6EAA6E;EAC7E;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN;AACF;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB;AACF;;AAEA;;EAEE,gBAAgB;EAChB;AACF;;AAEA;EACE,4BAA4B;EAC5B;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B;EACF;AACF;;AAEA;EACE,4BAA4B;EAC5B;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B;EACF;AACF;;AAEA;EACE,4BAA4B;EAC5B;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B;EACF;AACF;;AAEA;EACE,6BAA6B;EAC7B;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B;EACF;AACF;;AAEA;EACE,6BAA6B;EAC7B;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B;EACF;AACF;;AAEA;EACE,6BAA6B;EAC7B;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B;EACF;AACF;;AAEA;EACE,iBAAiB;EACjB,4DAA4D;EAC5D,UAAU;EACV;AACF;;AAEA;EACE,gCAAgC;EAChC;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;;EAEE,sBAAsB;EACtB;AACF;;AAEA;;EAEE,yBAAyB;EACzB;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE;;IAEE;EACF;AACF;;AAEA;EAGE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,SAAS;EACT,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iDAAiD;EACjD,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,4CAA4C;EAC5C,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB;AACF;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,yEAAyE;EACzE,4CAA4C;EAC5C;AACF;;AAEA;;EAEE,YAAY;EACZ,sDAAsD;EACtD,cAAc;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,4CAA4C;EAC5C,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,UAAU;EACV,sBAAsB;EACtB,kDAAkD;EAClD;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,kDAAkD;EAClD;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,UAAU;EACV,sBAAsB;EACtB,kDAAkD;EAClD;AACF;;AAEA;;;EAGE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX;AACF;;AAEA;EACE,sBAAsB;EACtB,uDAAuD;EACvD,SAAS;EACT,WAAW;EACX,yCAAyC;EACzC,uCAAuC;EACvC,kBAAkB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uDAAuD;IACvD,SAAS;IACT,WAAW;IACX,yCAAyC;IACzC,uCAAuC;IACvC,kBAAkB;IAClB;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,sEAAsE;EACtE,6BAA6B;EAC7B,uEAAuE;EACvE,4EAA4E;EAC5E;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,4BAA4B;IAC5B,sEAAsE;IACtE,6BAA6B;IAC7B,uEAAuE;IACvE,4EAA4E;IAC5E;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,wBAAwB;EACxB,SAAS;EACT,cAAc;EACd,yCAAyC;EACzC,SAAS;EACT;AACF;;AAEA;;;;;GAKG;;AAEH;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB;EACF;AACF;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,yEAAyE;EACzE,0CAA0C;EAC1C,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB;AACF;;AAEA;;;EAGE,gBAAgB;EAChB,uBAAuB;EACvB;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,eAAe;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qCAAqC;EACrC,aAAa;EACb,2BAA2B;EAC3B;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,yEAAyE;EACzE,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;EACjB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,UAAU;EACV;AACF;;AAEA;;EAEE,YAAY;EACZ;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE;;IAEE;EACF;AACF;;AAEA;EACE,sBAAsB;EACtB,OAAO;EACP,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB;AACF;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,iEAAiE;EACjE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,iDAAiD;EACjD;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,mBAAmB;EACnB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE,mBAAmB;IACnB;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX;AACF;;AAEA;;EAEE,mCAAmC;EACnC;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;;EAEE,YAAY;EACZ,OAAO;EACP,eAAe;EACf,MAAM;EACN;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB;AACF;;AAEA;;EAEE,cAAc;EACd;AACF;;AAEA;EACE;IACE,cAAc;IACd;EACF;AACF;;AAEA;EACE,0BAA0B;EAC1B;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B;EACF;AACF;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,MAAM;EACN,wBAAwB;EACxB;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,kDAAkD;EAClD,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,2CAA2C;EAC3C,OAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,4DAA4D;EAC5D,eAAe;EACf,WAAW;EACX,UAAU;EACV;AACF;;AAEA;EACE,qEAAqE;EACrE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,8BAA8B;EAC9B,sDAAsD;EACtD,WAAW;EACX,yCAAyC;EACzC,OAAO;EACP,kBAAkB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,8CAA8C;EAC9C,aAAa;EACb,YAAY;EACZ,2CAA2C;EAC3C,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,eAAe;EACf;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB;AACF;;AAEA;EACE,+CAA+C;EAC/C,iDAAiD;EACjD;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC;AACF;;AAEA;EACE,4BAA4B;EAC5B;AACF;;AAEA;EACE,6BAA6B;EAC7B;AACF;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,MAAM;EACN;AACF;;AAEA;EACE,qDAAqD;EACrD;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,sDAAsD;EACtD,kEAAkE;EAClE,yBAAyB;EAGzB;AACF;;AAEA;;EAEE,sBAAsB;EACtB;AACF;;AAEA;;EAEE,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,qDAAqD;EACrD,qEAAqE;EACrE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;EACxC,aAAa;EACb,uBAAuB;EACvB;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ;AACF;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,uEAAuE;EACvE;AACF;;AAEA;EACE,iBAAiB;EACjB,qEAAqE;EACrE;AACF;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB;AACF;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;;;EAGE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,cAAc;EACd,WAAW;EACX,WAAW;EACX;AACF;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf;AACF;;AAEA;EACE,WAAW;EACX,cAAc;EACd,SAAS;EACT,oCAAoC;EACpC;AACF;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,OAAO;EACP,oBAAoB;EACpB,MAAM;EACN;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,8CAA8C;EAC9C,4EAA4E;EAC5E,YAAY;EACZ,OAAO;EACP,UAAU;EACV,eAAe;EACf,MAAM;EACN;AACF;;AAEA;EACE,UAAU;EACV,mDAAmD;EACnD;AACF;;AAEA;EACE,6BAA6B;EAC7B;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE,2EAA2E;EAC3E,uFAAuF;EACvF,mBAAmB;EACnB,6DAA6D;EAC7D,sEAAsE;EACtE,mCAAmC;EACnC,WAAW;EACX,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EAGzB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,4FAA4F;EAC5F;AACF;;AAEA;EACE,sBAAsB;EACtB,qDAAqD;EACrD,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN;AACF;;AAEA;EACE,uBAAuB;EACvB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,uBAAuB;EACvB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,uBAAuB;EACvB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE,uEAAuE;EACvE,mFAAmF;EACnF,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB;AACF;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kDAAkD;EAClD;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,8BAA8B;EAC9B,sDAAsD;EACtD,SAAS;EACT,WAAW;EACX,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,cAAc;EACd,yEAAyE;EACzE,0CAA0C;EAC1C,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB;AACF;;AAEA;EACE,8BAA8B;EAC9B,sDAAsD;EACtD,WAAW;EACX;AACF;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,MAAM;EACN,8BAA8B;EAC9B;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ;AACF;;AAEA;EACE,+BAA+B;EAC/B;AACF;;AAEA;EACE,gCAAgC;EAChC;AACF;;AAEA;EACE,SAAS;EACT,WAAW;EACX,OAAO;EACP,+BAA+B;EAC/B;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAGE;;IAEE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;;EAGE;;IAEE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,mEAAmE;EACnE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,kBAAkB;EAClB,UAAU;EACV;AACF;;AAEA;EACE;IACE,UAAU;IACV;EACF;;EAEA;IACE,UAAU;IACV;EACF;AACF;;AAEA;EACE;IACE,UAAU;IACV;EACF;;EAEA;IACE,UAAU;IACV;EACF;AACF;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,uCAAuC;EACvC,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,iCAAiC;EACjC;AACF;;AAEA;EACE,6BAA6B;EAC7B,8CAA8C;EAC9C,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE,8BAA8B;EAC9B;AACF;;AAEA;EACE,8BAA8B;EAC9B;AACF;;AAEA;EACE,yEAAyE;EACzE,qFAAqF;EACrF,sBAAsB;EACtB,gBAAgB;EAChB,iDAAiD;EACjD,aAAa;EACb;AACF;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,qEAAqE;EACrE,mCAAmC;EACnC,gBAAgB;EAChB;AACF;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC;AACF;;AAEA;EACE,wCAAwC;EACxC,oDAAoD;EACpD;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yEAAyE;EACzE,qFAAqF;EACrF,uBAAuB;EACvB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,qEAAqE;EACrE,mCAAmC;EACnC,gBAAgB;EAChB,2DAA2D;EAC3D,eAAe;EACf;AACF;;AAEA;EACE,2BAA2B;EAC3B,oDAAoD;EACpD;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,sBAAsB;EACtB,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,UAAU;EACV;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,cAAc;EACd;AACF;;AAEA;EACE,6CAA6C;EAC7C;AACF;;AAEA;EACE;AACF;;AAEA;EACE,+CAA+C;EAC/C;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,sCAAsC;EACtC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB;AACF;;AAEA;;;EAGE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,4CAA4C;EAC5C;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,cAAc;EACd,4CAA4C;EAC5C,gBAAgB;EAChB;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,sBAAsB;EACtB,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,iEAAiE;EACjE;AACF;;AAEA;EACE,8BAA8B;EAC9B,sDAAsD;EACtD,WAAW;EACX,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN;AACF;;AAEA;EAEE;IACE;EACF;AACF;;AAEA;EAEE;IACE;EACF;AACF;;AAEA;;;;EAIE;AACF;;AAEA;EACE,sCAAsC;EACtC,wDAAwD;EACxD,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;;;EAGE,cAAc;EACd;AACF;;AAEA;;EAEE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;EAClB,uDAAuD;EACvD,sEAAsE;EACtE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN;AACF;;AAEA;EACE;AACF;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,mFAAmF;EACnF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,4DAA4D;EAC5D,eAAe;EACf,wDAAwD;EACxD,gBAAgB;EAChB,0DAA0D;EAC1D,eAAe;EACf,yBAAyB;EAGzB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;EACE,gCAAgC;EAChC;AACF;;AAEA;;EAEE,qDAAqD;EACrD;AACF;;AAEA;EACE,gFAAgF;EAChF,4FAA4F;EAC5F;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;EAClB,4DAA4D;EAC5D,sEAAsE;EACtE,mCAAmC;EACnC,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAO;EACP;AACF;;AAEA;EACE,uBAAuB;EACvB;AACF;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,WAAW;EACX,sCAAsC;EACtC,oBAAoB;EACpB,SAAO;EACP,gBAAgB;EAChB;AACF;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;;EAEE,oDAAoD;EACpD;AACF;;AAEA;EACE,SAAS;EACT,OAAO;EACP;AACF;;AAEA;EACE,uDAAuD;EACvD;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;;EAEE,YAAY;EACZ;AACF;;AAEA;EACE,0CAA0C;EAC1C,6BAA6B;EAC7B,OAAO;EACP,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,kCAAkC;EAClC,yBAAyB;EAGzB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,SAAS;EACT,OAAO;EACP,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR;AACF;;AAEA;EACE,MAAM;EACN;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb;AACF;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,qDAAqD;EACrD,iEAAiE;EACjE;AACF;;AAEA;EACE,oDAAoD;EACpD;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,mDAAmD;EACnD;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gEAAgE;EAChE,sBAAsB;EACtB,qDAAqD;EACrD,4BAA4B;EAC5B,sEAAsE;EACtE,6BAA6B;EAC7B,uEAAuE;EACvE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB;AACF;;AAEA;EACE,+BAA+B;EAC/B,yEAAyE;EACzE,gCAAgC;EAChC,0EAA0E;EAC1E,qEAAqE;EACrE,mCAAmC;EACnC;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB;AACF;;AAEA;;EAEE,iCAAiC;EACjC;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,cAAc;EACd,SAAS;EACT;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;;EAEE,cAAc;EACd;AACF;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,qDAAqD;EACrD,iEAAiE;EACjE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,mDAAmD;EACnD;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gEAAgE;EAChE,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,qEAAqE;EACrE,mCAAmC;EACnC,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,2DAA2D;EAC3D,aAAa;EACb,oBAAoB;EACpB;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,cAAc;EACd,WAAW;EACX;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE,uBAAuB;EACvB;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,mDAAmD;EACnD,kBAAkB;EAClB,4DAA4D;EAC5D;AACF;;AAEA;EACE,qEAAqE;EACrE;AACF;;AAEA;;EAEE,gBAAgB;EAChB;AACF;;AAEA;EACE,qFAAqF;EACrF,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,OAAO;EACP,oBAAoB;EACpB,kBAAkB;EAClB,MAAM;EACN;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,gEAAgE;EAChE,4BAA4B;EAC5B;AACF;;AAEA;;EAEE,kBAAkB;EAClB;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE,kBAAkB;IAClB;EACF;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,4BAA4B;EAC5B;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,iCAAiC;EACjC;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,gEAAgE;EAChE,mBAAmB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,gEAAgE;IAChE,mBAAmB;IACnB;EACF;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,kBAAkB;EAClB,gEAAgE;EAChE,mBAAmB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB;EACF;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB;EACF;;EAEA;IACE,gBAAgB;IAChB;EACF;;EAEA;IACE,mBAAmB;IACnB;EACF;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,4DAA4D;EAC5D,WAAW;EACX,sCAAsC;EACtC,cAAc;EACd;AACF;;AAEA;EACE,0BAA0B;EAC1B,8GAA8G;EAC9G,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,cAAc;EACd;AACF;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,yEAAyE;EACzE,0CAA0C;EAC1C,mBAAmB;EACnB,gEAAgE;EAChE,mBAAmB;EACnB,iEAAiE;EACjE,yBAAyB;EAGzB;AACF;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,SAAW;EACX;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;;;;EAIE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE;;IAEE;EACF;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE;;IAEE;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC;oBACkB;AACpB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;;IAEE;EACF;;EAEA;;IAEE;EACF;AACF;;AAEA;;EAEE,eAAe;EACf;AACF;;AAEA;;EAEE;;IAEE,eAAe;IACf;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB,iDAAiD;EACjD,mBAAmB;EACnB,6DAA6D;EAC7D;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iDAAiD;IACjD,mBAAmB;IACnB,6DAA6D;IAC7D;EACF;AACF;;AAEA;EACE,4BAA4B;EAC5B;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B;EACF;AACF;;AAEA;EACE,sBAAsB;EACtB,iEAAiE;EACjE,8FAA8F;EAC9F,WAAW;EACX,YAAY;EACZ,OAAO;EACP,oBAAoB;EACpB,kBAAkB;EAClB,MAAM;EACN;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,4EAA4E;IAC5E,+FAA+F;IAC/F,WAAW;IACX,YAAY;IACZ,OAAO;IACP,oBAAoB;IACpB,kBAAkB;IAClB,MAAM;IACN;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;;EAEE,mBAAmB;EACnB;AACF;;AAEA;;EAEE;;IAEE,mBAAmB;IACnB;EACF;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,cAAc;EACd;AACF;;AAEA;;EAEE,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB;AACF;;AAEA;EACE,gLAAgL;EAChL;AACF;;AAEA;EACE,8KAA8K;EAC9K;AACF;;AAEA;EACE,kLAAkL;EAClL;AACF;;AAEA;EACE,gLAAgL;EAChL;AACF;;AAEA;EACE,uKAAuK;EACvK;AACF;;AAEA;EACE,qKAAqK;EACrK;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,yBAAyB;EACzB,yDAAyD;EACzD,qEAAqE;EACrE,mCAAmC;EACnC,UAAU;EACV;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB;AACF;;AAEA;EACE,OAAO;EACP,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB;AACF;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gEAAgE;EAChE;AACF;;AAEA;EACE,SAAS;EACT,cAAc;EACd,wCAAwC;EACxC,YAAY;EACZ,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB,wDAAwD;EACxD,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB;AACF;;AAEA;EACE;IACE,oDAAoD;IACpD;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,aAAa;EACb;AACF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB;AACF;;AAEA;EACE,yBAAyB;EACzB,wDAAwD;EACxD,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;EAC7C,WAAW;EACX,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;;EAEE,uBAAuB;EACvB;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,cAAc;EACd,8BAA8B;EAC9B,yEAAyE;EACzE,SAAS;EACT;AACF;;AAEA;;EAEE,8BAA8B;EAC9B;AACF;;AAEA;;;EAGE;;IAEE,8BAA8B;IAC9B;EACF;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,sCAAsC;EACtC,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gEAAgE;EAChE,mBAAmB;EACnB,iEAAiE;EACjE,qBAAqB;EACrB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uEAAuE;EACvE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;;EAEE,cAAc;EACd;AACF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,qBAAqB;EACrB,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uEAAuE;EACvE,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;;EAEE;IACE;EACF;;EAEA;IACE,mBAAmB;IACnB;EACF;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,sCAAsC;EACtC,aAAa;EACb,yEAAyE;EACzE,0CAA0C;EAC1C,gBAAgB;EAChB,iBAAiB;EACjB,+DAA+D;EAC/D;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,yDAAyD;EACzD,iBAAiB;EACjB,6DAA6D;EAC7D;AACF;;AAEA;EACE,eAAe;EACf,yDAAyD;EACzD,iBAAiB;EACjB;AACF;;AAEA;;EAEE;IACE,eAAe;IACf,yDAAyD;IACzD,iBAAiB;IACjB;EACF;AACF;;AAEA;;EAEE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;;;;EAIE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;;EAGE,eAAe;EACf,0DAA0D;EAC1D,iBAAiB;EACjB;AACF;;AAEA;;;EAGE,eAAe;EACf,wDAAwD;EACxD,iBAAiB;EACjB;AACF;;AAEA;;;EAGE;;;IAGE,eAAe;IACf,wDAAwD;IACxD,iBAAiB;IACjB;EACF;AACF;;AAEA;EACE,4BAA4B;EAC5B,0EAA0E;EAC1E,6BAA6B;EAC7B;AACF;;AAEA;;EAEE;IACE;EACF;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB;AACF;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,uEAAuE;EACvE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,uBAAuB;EACvB;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE,2DAA2D;EAC3D,cAAc;EACd;AACF;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,uBAAuB;EACvB;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sHAAsH;EACtH,kFAAkF;EAClF;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,mFAAmF;EACnF;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,WAAW;EACX,2BAA2B;EAC3B;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yEAAyE;EACzE,4CAA4C;EAC5C,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB;AACF;;AAEA;EACE,SAAS;EACT;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,sCAAsC;EACtC,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,cAAc;EACd,iBAAiB;EACjB,+DAA+D;EAC/D,iBAAiB;EACjB,cAAc;EACd;AACF;;AAEA;EACE,yBAAyB;EAGzB;AACF;;AAEA;;EAEE,gBAAgB;EAChB;AACF;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,cAAc;EACd,kBAAkB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EAGzB;AACF;;AAEA;EACE,YAAY;EACZ,SAAS;EACT;AACF;;AAEA;EACE;AACF;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB;AACF;;AAEA;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,OAAO;EACP,kBAAkB;EAClB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mDAAmD;EACnD;AACF;;AAEA;EACE;AACF;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB;AACF;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,2BAA2B;EAC3B,sEAAsE;EACtE,iBAAiB;EACjB,4DAA4D;EAC5D,0BAA0B;EAC1B;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE,kBAAkB;EAClB;AACF;;AAEA;EACE,SAAS;EACT;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;EAClB;AACF;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,wCAAwC;EACxC,wEAAwE;EACxE,aAAa;EACb;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;IACE;EACF;AACF;;AAEA;EACE,yBAAyB;EACzB,4DAA4D;EAC5D,kBAAkB;EAClB,uDAAuD;EACvD,aAAa;EACb,SAAO;EACP,2CAA2C;EAC3C,kBAAkB;EAClB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,qCAAqC;EACrC,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB;AACF;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,SAAS;EACT,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,OAAO;EACP,SAAS;EACT,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,6BAA6B;EAC7B,qBAAqB;EACrB;AACF;;AAEA;;;;EAIE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,6BAA6B;EAC7B;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;;EAEE,YAAY;EACZ;AACF;;AAoBA;EACE,cAAc;EACd,wCAAwC;EACxC;AACF;;AAiBA;EACE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,uDAAuD;EACvD,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,8BAA8B;EAC9B,4EAA4E;EAG5E,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,yFAAyF;EACzF;AACF;;AAEA;;EAEE,SAAO;EACP,oBAAoB;EACpB;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yEAAyE;EACzE,0CAA0C;EAC1C;AACF;;AAEA;EACE,WAAW;EACX,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,iDAAiD;EACjD,WAAW;EACX,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN;AACF;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uDAAuD;EACvD,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB;AACF;;AAEA;;EAEE;IACE,gBAAgB;IAChB,mBAAmB;IACnB;EACF;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB;AACF;;AAEA;;EAEE;IACE,gBAAgB;IAChB,oBAAoB;IACpB;EACF;AACF;;AAEA;EACE,sCAAsC;EACtC;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB,qDAAqD;EACrD,oEAAoE;EACpE;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,2DAA2D;EAC3D,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,OAAO;EACP,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE,oCAAoC;EACpC;AACF;;AAEA;EACE,oCAAoC;EACpC;AACF;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,iBAAiB;EACjB;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd,4CAA4C;EAC5C;AACF;;AAEA;EACE,yBAAyB;EACzB,sDAAsD;EACtD,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,UAAU;EACV,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;IACE;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB;AACF;;AAEA;EACE,SAAS;EACT,SAAS;EACT;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,UAAU;EACV;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;EAClB,uCAAuC;EACvC,sBAAsB;EACtB,cAAc;EACd,qCAAqC;EACrC,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,4EAA4E;EAC5E;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,8CAA8C;EAC9C;AACF;;AAEA;EACE,gBAAgB;EAChB,oDAAoD;EACpD;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,qEAAqE;EACrE,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,SAAS;EACT,UAAU;EACV;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE,qCAAqC;EACrC;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB;AACF;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,eAAe;EACf,MAAM;EACN;AACF;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,mBAAmB;EACnB;AACF;;AAEA;EACE,sBAAsB;EACtB,qDAAqD;EACrD,kBAAkB;EAClB,uDAAuD;EACvD,qEAAqE;EACrE,mCAAmC;EACnC,WAAW;EACX,sCAAsC;EACtC;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,yBAAyB;EACzB,2DAA2D;EAC3D,WAAW;EACX;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,sBAAsB;EACtB,wDAAwD;EACxD,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,yBAAyB;EACzB,gEAAgE;EAChE,WAAW;EACX;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,WAAW;EACX;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,gDAAgD;EAChD,WAAW;EACX;AACF;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,WAAW;EACX;AACF;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX;AACF;;AAEA;EACE,gBAAgB;EAChB,iDAAiD;EACjD,cAAc;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ;AACF;;AAEA;EACE,yBAAyB;EACzB,qGAAqG;EACrG,WAAW;EACX;AACF;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,wCAAwC;EACxC;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,0BAA0B;EAC1B;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;EAC7C,kBAAkB;EAClB,WAAW;EACX,8CAA8C;EAC9C,aAAa;EACb;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE,SAAO;EACP;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,qBAAqB;EACrB,mBAAmB;EACnB;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf;AACF;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,yDAAyD;EACzD,kBAAkB;EAClB,uDAAuD;EACvD,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb;AACF;;AAEA;EACE,qFAAqF;EACrF,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,OAAO;EACP,oBAAoB;EACpB,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV;AACF;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB;AACF;;AAEA;;EAEE,cAAc;EACd;AACF;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV;AACF;;AAEA;;EAEE,YAAY;EACZ;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,wCAAwC;EACxC,aAAa;EACb;AACF;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;;;;EAIE,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,aAAa;EACb,iBAAiB;EACjB;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAO;EACP,YAAY;EACZ;AACF;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB;AACF;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB;AACF;;AAEA;;EAEE,cAAc;EACd;AACF;;AAEA;;EAEE,cAAc;EACd;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC;AACF;;AAEA;;EAEE,cAAc;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,qEAAqE;EACrE;AACF;;AAEA;;;EAGE,qBAAqB;EACrB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,SAAO;EACP,YAAY;EACZ;AACF;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,sCAAsC;EACtC,SAAO;EACP,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ;AACF;;AAoBA;EACE,cAAc;EACd,sCAAsC;EACtC;AACF;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,yBAAyB;EACzB,+DAA+D;EAC/D,yFAAyF;EACzF,mBAAmB;EACnB,sBAAsB;EACtB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,iFAAiF;EACjF,4FAA4F;EAC5F,0DAA0D;EAC1D,sDAAsD;EACtD;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,uDAAuD;EACvD,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE,0BAA0B;EAC1B,yDAAyD;EACzD,kBAAkB;EAClB,UAAU;EACV;AACF;;AAEA;EACE,0BAA0B;EAC1B;AACF;;AAEA;;EAEE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;;EAEE,cAAc;EACd,4CAA4C;EAC5C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,+EAA+E;EAC/E;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B;AACF;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,SAAO;EACP;AACF;;AAEA;EACE,kBAAkB;EAClB,uDAAuD;EACvD,qBAAqB;EACrB,yBAAyB;EAGzB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;;EAEE;IACE,YAAY;IACZ;EACF;;EAEA;IACE,YAAY;IACZ;EACF;;EAEA;IACE,YAAY;IACZ;EACF;AACF;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,gBAAgB;EAChB;AACF;;AAEA;;EAEE,kBAAkB;EAClB;AACF;;AAEA;;;EAGE,mBAAmB;EACnB;AACF;;AAEA;EACE,sBAAsB;EACtB,qDAAqD;EACrD,qEAAqE;EACrE;AACF;;AAEA;EACE,4EAA4E;EAC5E;AACF;;AAEA;;EAEE,cAAc;EACd;AACF;;AAEA;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX;AACF;;AAEA;;EAEE,sCAAsC;EACtC,wDAAwD;EACxD,WAAW;EACX;AACF;;AAEA;;EAEE,WAAW;EACX;AACF;;AAEA;EACE,wFAAwF;EACxF;AACF;;AAEA;EACE,kFAAkF;EAClF;AACF;;AAEA;EACE,kFAAkF;EAClF;AACF;;AAEA;EACE,SAAO;EACP;AACF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,uDAAuD;EACvD,sBAAsB;EACtB,cAAc;EACd,wCAAwC;EACxC,YAAY;EACZ,sDAAsD;EACtD,iBAAiB;EACjB,2DAA2D;EAC3D,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EAGzB,iBAAiB;EACjB;AACF;;AAEA;EACE,sCAAsC;EACtC;AACF;;AAEA;;EAEE,sCAAsC;EACtC,wDAAwD;EACxD,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,YAAY;EACZ,sDAAsD;EACtD,iBAAiB;EACjB;AACF;;AAEA;;EAEE;IACE,YAAY;IACZ,sDAAsD;IACtD,iBAAiB;IACjB;EACF;AACF;;AAEA;EACE,eAAe;EACf,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EAGE,gBAAgB;EAChB,SAAS;EACT,SAAS;EACT,OAAO;EACP,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,MAAM;EACN,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB;AACF;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;;EAEE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,wDAAwD;EACxD;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,mCAAmC;EACnC;AACF;;AAEA;;EAEE,mCAAmC;EACnC;AACF;;AAEA;;;EAGE;;IAEE,mCAAmC;IACnC;EACF;AACF;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,uDAAuD;EACvD,sBAAsB;EACtB,aAAa;EACb,yEAAyE;EACzE,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,mDAAmD;EACnD,aAAa;EACb;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;;EAEE;IACE,gBAAgB;IAChB;EACF;AACF;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV;AACF;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,wCAAwC;EACxC,aAAa;EACb,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kDAAkD;EAClD,kBAAkB;EAClB,UAAU;EACV;AACF;;AAEA;;EAEE,YAAY;EACZ,+CAA+C;EAC/C,eAAe;EACf;AACF;;AAEA;;;EAGE;;IAEE,YAAY;IACZ,+CAA+C;IAC/C,eAAe;IACf;EACF;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,2DAA2D;EAC3D,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,OAAO;EACP,oBAAoB;EACpB,kBAAkB;EAClB,MAAM;EACN,0BAA0B;EAC1B,WAAW;EACX,UAAU;EACV;AACF;;AAEA;EACE,gCAAgC;EAChC;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;;EAEE,qBAAqB;EACrB,gDAAgD;EAChD,UAAU;EACV;AACF;;AAEA;;EAEE,yBAAyB;EACzB;AACF;;AAEA;;EAEE,qBAAqB;EACrB,gDAAgD;EAChD,UAAU;EACV;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mDAAmD;EACnD;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,gCAAgC;EAChC,0DAA0D;EAC1D,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,UAAU;EACV;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf;AACF;;AAEA;EACE,8BAA8B;EAC9B,mEAAmE;EACnE,2BAA2B;EAC3B;AACF;;AAEA;EACE,+BAA+B;EAC/B,oEAAoE;EACpE,4BAA4B;EAC5B;AACF;;AAEA;EACE,2BAA2B;EAC3B,gEAAgE;EAChE,4BAA4B;EAC5B;AACF;;AAEA;EACE,8BAA8B;EAC9B,mEAAmE;EACnE,+BAA+B;EAC/B;AACF;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,yEAAyE;EACzE,eAAe;EACf;AACF;;AAEA;EACE,8BAA8B;EAC9B;AACF;;AAEA;;EAEE;IACE,8BAA8B;IAC9B;EACF;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,qGAAqG;EACrG,kBAAkB;EAClB,yBAAyB;EAGzB;AACF;;AAEA;EACE,gCAAgC;EAChC;AACF;;AAEA;;EAEE;IACE,gCAAgC;IAChC;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE,6CAA6C;EAC7C,wCAAwC;EACxC,sBAAsB;EACtB,cAAc;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,sDAAsD;EACtD,kBAAkB;EAClB,wEAAwE;EACxE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,6BAA6B;EAC7B,kGAAkG;EAClG,kBAAkB;EAClB,4BAA4B;EAC5B,iGAAiG;EACjG,WAAW;EACX;AACF;;AAEA;EACE,YAAY;EACZ,6CAA6C;EAC7C,6BAA6B;EAC7B,kGAAkG;EAClG,4BAA4B;EAC5B,iGAAiG;EACjG,WAAW;EACX;AACF;;AAEA;;EAEE;IACE,YAAY;IACZ,6CAA6C;IAC7C,6BAA6B;IAC7B,kGAAkG;IAClG,4BAA4B;IAC5B,iGAAiG;IACjG,WAAW;IACX;EACF;AACF;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,wCAAwC;EACxC;AACF;;AAEA;EACE,8BAA8B;EAC9B,kDAAkD;EAClD,6BAA6B;EAC7B,gEAAgE;EAChE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,gDAAgD;EAChD,WAAW;EACX;AACF;;AAEA;EACE,6BAA6B;EAC7B,gEAAgE;EAChE,YAAY;EACZ,gDAAgD;EAChD,WAAW;EACX;AACF;;AAEA;;EAEE;IACE,6BAA6B;IAC7B,gEAAgE;IAChE,YAAY;IACZ,gDAAgD;IAChD,WAAW;IACX;EACF;AACF;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C;AACF;;AAEA;EACE,wCAAwC;EACxC;AACF;;AAEA;;EAEE;IACE,wCAAwC;IACxC;EACF;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,gBAAgB;EAChB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EAGE,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,sCAAsC;EACtC,YAAY;EACZ,+CAA+C;EAC/C,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;;EAEE;IACE,YAAY;IACZ;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAoBA;EACE,cAAc;EACd,wCAAwC;EACxC;AACF;;AAiBA;EACE,cAAc;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,iDAAiD;EACjD,qFAAqF;EACrF,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,qBAAqB;EACrB,yEAAyE;EACzE,8DAA8D;EAC9D,eAAe;EACf,0DAA0D;EAC1D,gBAAgB;EAChB,8DAA8D;EAC9D,iBAAiB;EACjB,8DAA8D;EAC9D,gBAAgB;EAChB,uBAAuB;EACvB;AACF;;AAEA;EACE,yEAAyE;EACzE,6DAA6D;EAC7D,eAAe;EACf,yDAAyD;EACzD,gBAAgB;EAChB,6DAA6D;EAC7D,iBAAiB;EACjB;AACF;;AAEA;;EAEE;IACE,yEAAyE;IACzE,6DAA6D;IAC7D,eAAe;IACf,yDAAyD;IACzD,gBAAgB;IAChB,6DAA6D;IAC7D,iBAAiB;IACjB;EACF;AACF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,aAAa;EACb,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;IACE;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB;AACF;;AAEA;EAGE,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,sCAAsC;EACtC,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAoBA;EACE,cAAc;EACd,wCAAwC;EACxC;AACF;;AAiBA;EACE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,uBAAuB;EACvB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,+CAA+C;EAC/C;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ;AACF;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB;AACF;;AAEA;EACE,yBAAyB;EACzB,qDAAqD;EACrD;AACF;;AAEA;EACE,mBAAmB;EACnB,gDAAgD;EAChD;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,8DAA8D;EAC9D,4BAA4B;EAC5B,+DAA+D;EAC/D;AACF;;AAEA;EACE,QAAQ;EACR;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;IACE;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB,kDAAkD;EAClD,qCAAqC;EACrC,6DAA6D;EAC7D,kBAAkB;EAClB,qEAAqE;EACrE,mCAAmC;EACnC,YAAY;EACZ,+CAA+C;EAC/C,kBAAkB;EAClB,yBAAyB;EAGzB,iBAAiB;EACjB,WAAW;EACX,8CAA8C;EAC9C;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EAGE,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,sCAAsC;EACtC,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;IACE;EACF;AACF;;AAoBA;EACE,cAAc;EACd,wCAAwC;EACxC;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAiBA;EACE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd,yEAAyE;EACzE,0CAA0C;EAC1C,eAAe;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,uEAAuE;EACvE;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iDAAiD;EACjD,6DAA6D;EAC7D;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,qDAAqD;EACrD;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,cAAc;EACd,YAAY;EACZ;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,cAAc;EACd,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;;EAEE;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE,YAAY;IACZ;EACF;;EAEA;IACE,YAAY;IACZ;EACF;AACF;;AAEA;EACE,sBAAsB;EACtB,SAAO;EACP;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yEAAyE;EACzE,0CAA0C;EAC1C,2BAA2B;EAC3B,gBAAgB;EAChB,mDAAmD;EACnD,eAAe;EACf,kDAAkD;EAClD,eAAe;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,uEAAuE;EACvE;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;;EAEE,cAAc;EACd,qCAAqC;EACrC;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,cAAc;EACd,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,+CAA+C;EAC/C,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,mDAAmD;EACnD,eAAe;EACf;AACF;;AAEA;EACE,YAAY;EACZ,+CAA+C;EAC/C,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE;IACE,gBAAgB;IAChB,mDAAmD;IACnD,eAAe;IACf;EACF;;EAEA;IACE,YAAY;IACZ,+CAA+C;IAC/C,WAAW;IACX;EACF;;EAEA;IACE;EACF;;EAEA;;IAEE;EACF;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB;AACF;;AAEA;EACE,4BAA4B;EAC5B;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,sCAAsC;EACtC,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EAGzB,iBAAiB;EACjB;AACF;;AAEA;EACE,wDAAwD;EACxD,4BAA4B;EAC5B;AACF;;AAEA;EACE;AACF;;AAEA;;;EAGE;IACE;EACF;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ;AACF;;AAEA;EACE,sCAAsC;EACtC;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,yEAAyE;EACzE,0CAA0C;EAC1C;AACF;;AAEA;EAGE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,0DAA0D;EAC1D,YAAY;EACZ,OAAO;EACP,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV;AACF;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,sCAAsC;EACtC,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;;EAEE;IACE,mBAAmB;IACnB;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB,qDAAqD;EACrD,qFAAqF;EACrF,kBAAkB;EAClB,oEAAoE;EACpE,mCAAmC;EACnC,sBAAsB;EACtB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB;AACF;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,YAAY;EACZ,qEAAqE;EACrE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN;AACF;;AAEA;EACE,sBAAsB;EACtB,OAAO;EACP,sBAAsB;EACtB,kBAAkB;EAClB,MAAM;EACN,yBAAyB;EAGzB,iBAAiB;EACjB;AACF;;AAEA;EACE,UAAU;EACV;AACF;;AAEA;EACE,yBAAyB;EACzB,gDAAgD;EAChD,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC;AACF;;AAEA;;EAEE,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,SAAS;EACT,SAAS;EACT;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,SAAW;EACX,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB,yDAAyD;EACzD,kBAAkB;EAClB,uDAAuD;EACvD,sBAAsB;EACtB,yEAAyE;EACzE,0CAA0C;EAC1C,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B;AACF;;AAEA;EACE,sBAAsB;EACtB,sDAAsD;EACtD,sBAAsB;EACtB,SAAS;EACT,2GAA2G;EAC3G,8HAA8H;EAC9H,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,qBAAqB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,SAAO;EACP,SAAS;EACT,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;;EAGE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EAGE,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,sCAAsC;EACtC,eAAe;EACf,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;EAGzB;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB;AACF;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,0BAA0B;EAC1B,uDAAuD;EACvD,kBAAkB;EAClB,oEAAoE;EACpE,mCAAmC;EACnC,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb;AACF;;AAEA;EACE,6BAA6B;EAC7B,0DAA0D;EAC1D,oBAAoB;EACpB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB;AACF;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sCAAsC;EACtC,aAAa;EACb,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB;AACF;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,sCAAsC;EACtC,yEAAyE;EACzE,0CAA0C;EAC1C;AACF;;AAEA;;EAEE,0BAA0B;EAC1B,YAAY;EACZ;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE,cAAc;EACd;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;;EAEE,8BAA8B;EAC9B;AACF;;AAEA;;EAEE,+BAA+B;EAC/B;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gCAAgC;EAChC,yDAAyD;EACzD,WAAW;EACX,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,oCAAoC;EACpC;AACF;;AAEA;EACE,yBAAyB;EACzB,sDAAsD;EACtD,WAAW;EACX;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,yEAAyE;EACzE,0CAA0C;EAC1C,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,0BAA0B;EAC1B,uDAAuD;EACvD,kBAAkB;EAClB,oEAAoE;EACpE,mCAAmC;EACnC,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yEAAyE;EACzE,0CAA0C;EAC1C;AACF;;AAEA;EACE,gCAAgC;EAChC,0DAA0D;EAC1D,SAAS;EACT,WAAW;EACX,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAAkC;EAAlC,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EAGzB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;IACE;EACF;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAAkC;EAAlC,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EAGzB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;IACE;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,mBAAmB;EAEnB,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,iDAAiD;EACjD,sBAAsB;EACtB,WAAW;EACX,sCAAsC;EACtC,mEAAmE;EACnE,2FAA2F;EAC3F,oBAAoB;EACpB,kBAAkB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,aAAa;EACb,uBAAuB;EACvB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,wCAAwC;EACxC,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf;AACF;;AAEA;EACE,4BAA4B;EAC5B;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;EAClB,uDAAuD;EACvD,qEAAqE;EACrE,mCAAmC;EACnC;AACF;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,WAAW;EACX,oBAAoB;EACpB,gEAAgE;EAChE,kBAAkB;EAClB,qBAAqB;EACrB,iEAAiE;EACjE,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE,2CAA2C;EAC3C,sBAAsB;EACtB,qDAAqD;EACrD,kBAAkB;EAClB,uDAAuD;EACvD,qEAAqE;EACrE,mCAAmC;EACnC,WAAW;EACX,sCAAsC;EACtC;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,yBAAyB;EACzB,2DAA2D;EAC3D,WAAW;EACX;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,sBAAsB;EACtB,wDAAwD;EACxD,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,yBAAyB;EACzB,gEAAgE;EAChE,WAAW;EACX;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,WAAW;EACX;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE,2CAA2C;EAC3C,sBAAsB;EACtB,qDAAqD;EACrD,kBAAkB;EAClB,uDAAuD;EACvD,qEAAqE;EACrE,mCAAmC;EACnC,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,yBAAyB;EACzB,2DAA2D;EAC3D,WAAW;EACX;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,sBAAsB;EACtB,wDAAwD;EACxD,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,yBAAyB;EACzB,gEAAgE;EAChE,WAAW;EACX;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,WAAW;EACX;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE,wCAAwC;EACxC;AACF;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ;AACF;;AAEA;;EAEE,mBAAmB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC;AACF;;AAEA;;;EAGE,YAAY;EACZ,SAAS;EACT;AACF;;AAEA;;EAEE,wCAAwC;EACxC,8BAA8B;EAC9B,WAAW;EACX,sCAAsC;EACtC,mBAAmB;EACnB,wCAAwC;EACxC,yEAAyE;EACzE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB;EACF;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF","sourcesContent":[".vkui--vkBase--light,\n:root {\n  --vkui--theme_name: \"vkBase\"\n}\n\n.vkui--vkBase--dark,\n.vkui--vkBase--light,\n:root {\n  --vkui--theme_name_base: \"vkBase\";\n  --vkui--size_base_padding_horizontal--regular: 16px;\n  --vkui--size_switch_height--regular: 14px;\n  --vkui--size_switch_height--compact: 12px;\n  --vkui--size_switch_width--regular: 34px;\n  --vkui--size_switch_width--compact: 32px;\n  --vkui--size_switch_pin--regular: 20px;\n  --vkui--size_switch_pin--compact: 18px;\n  --vkui--size_panel_header_height--regular: 56px\n}\n\n.vkui--vkBase--dark,\n.vkui--vkBase--light,\n.vkui--vkCom--dark,\n.vkui--vkCom--light,\n.vkui--vkIOS--dark,\n.vkui--vkIOS--light,\n:root {\n  --vkui--gradient_black: transparent 0%, rgba(0, 0, 0, .014) 13%, rgba(0, 0, 0, .06) 27%, rgba(0, 0, 0, .316) 68%, rgba(0, 0, 0, .38) 84%, rgba(0, 0, 0, .4) 100%;\n  --vkui--gradient_white: hsla(0, 0%, 100%, 0) 0%, hsla(0, 0%, 100%, .036) 13%, hsla(0, 0%, 100%, .15) 27%, hsla(0, 0%, 100%, .79) 68%, hsla(0, 0%, 100%, .95) 84%, #fff 100%;\n  --vkui--elevation1: 0px 0px 2px rgba(0, 0, 0, .03), 0px 2px 2px rgba(0, 0, 0, .06);\n  --vkui--elevation1_invert_y: 0px 0px 2px rgba(0, 0, 0, .03), 0px -2px 2px rgba(0, 0, 0, .06);\n  --vkui--elevation2: 0px 4px 8px rgba(0, 0, 0, .04), 0px 0px 4px rgba(0, 0, 0, .06);\n  --vkui--elevation3: 0px 0px 2px rgba(0, 0, 0, .08), 0px 4px 16px rgba(0, 0, 0, .08);\n  --vkui--elevation4: 0px 0px 8px rgba(0, 0, 0, .12), 0px 16px 16px rgba(0, 0, 0, .16);\n  --vkui--font_family_fallbacks: -apple-system, system-ui, \"Helvetica Neue\", Roboto, sans-serif;\n  --vkui--font_family_accent: -apple-system, system-ui, \"Helvetica Neue\", Roboto, sans-serif;\n  --vkui--font_family_base: -apple-system, system-ui, \"Helvetica Neue\", Roboto, sans-serif;\n  --vkui--font_weight_accent1: 600;\n  --vkui--font_weight_accent2: 500;\n  --vkui--font_weight_accent3: 400;\n  --vkui--font_weight_base1: 600;\n  --vkui--font_weight_base2: 500;\n  --vkui--font_weight_base3: 400;\n  --vkui--font_title1--font_size--regular: 24px;\n  --vkui--font_title1--line_height--regular: 28px;\n  --vkui--font_title1--font_family--regular: -apple-system, system-ui, \"Helvetica Neue\", Roboto, sans-serif;\n  --vkui--font_title1--font_weight--regular: 600;\n  --vkui--font_title2--font_size--regular: 20px;\n  --vkui--font_title2--line_height--regular: 24px;\n  --vkui--font_title2--font_family--regular: -apple-system, system-ui, \"Helvetica Neue\", Roboto, sans-serif;\n  --vkui--font_title2--font_weight--regular: 600;\n  --vkui--font_title3--font_size--regular: 17px;\n  --vkui--font_title3--line_height--regular: 22px;\n  --vkui--font_title3--font_family--regular: -apple-system, system-ui, \"Helvetica Neue\", Roboto, sans-serif;\n  --vkui--font_title3--font_weight--regular: 600;\n  --vkui--font_headline1--font_size--regular: 16px;\n  --vkui--font_headline1--line_height--regular: 20px;\n  --vkui--font_headline1--font_family--regular: -apple-system, system-ui, \"Helvetica Neue\", Roboto, sans-serif;\n  --vkui--font_headline1--font_weight--regular: 500;\n  --vkui--font_headline2--font_size--regular: 15px;\n  --vkui--font_headline2--line_height--regular: 20px;\n  --vkui--font_headline2--font_family--regular: -apple-system, system-ui, \"Helvetica Neue\", Roboto, sans-serif;\n  --vkui--font_headline2--font_weight--regular: 500;\n  --vkui--font_headline2--font_size--compact: 14px;\n  --vkui--font_headline2--line_height--compact: 20px;\n  --vkui--font_text--font_size--regular: 16px;\n  --vkui--font_text--line_height--regular: 20px;\n  --vkui--font_text--font_family--regular: -apple-system, system-ui, \"Helvetica Neue\", Roboto, sans-serif;\n  --vkui--font_text--font_weight--regular: 400;\n  --vkui--font_paragraph--font_size--regular: 15px;\n  --vkui--font_paragraph--line_height--regular: 20px;\n  --vkui--font_paragraph--font_family--regular: -apple-system, system-ui, \"Helvetica Neue\", Roboto, sans-serif;\n  --vkui--font_paragraph--font_weight--regular: 400;\n  --vkui--font_subhead--font_size--regular: 14px;\n  --vkui--font_subhead--line_height--regular: 18px;\n  --vkui--font_subhead--font_family--regular: -apple-system, system-ui, \"Helvetica Neue\", Roboto, sans-serif;\n  --vkui--font_subhead--font_weight--regular: 400;\n  --vkui--font_footnote--font_size--regular: 13px;\n  --vkui--font_footnote--line_height--regular: 16px;\n  --vkui--font_footnote--font_family--regular: -apple-system, system-ui, \"Helvetica Neue\", Roboto, sans-serif;\n  --vkui--font_footnote--font_weight--regular: 400;\n  --vkui--font_footnote_caps--font_size--regular: 13px;\n  --vkui--font_footnote_caps--line_height--regular: 16px;\n  --vkui--font_footnote_caps--font_family--regular: -apple-system, system-ui, \"Helvetica Neue\", Roboto, sans-serif;\n  --vkui--font_footnote_caps--font_weight--regular: 400;\n  --vkui--font_footnote_caps--text_transform--regular: uppercase;\n  --vkui--font_caption1--font_size--regular: 12px;\n  --vkui--font_caption1--line_height--regular: 14px;\n  --vkui--font_caption1--font_family--regular: -apple-system, system-ui, \"Helvetica Neue\", Roboto, sans-serif;\n  --vkui--font_caption1--font_weight--regular: 400;\n  --vkui--font_caption1_caps--font_size--regular: 12px;\n  --vkui--font_caption1_caps--line_height--regular: 14px;\n  --vkui--font_caption1_caps--font_family--regular: -apple-system, system-ui, \"Helvetica Neue\", Roboto, sans-serif;\n  --vkui--font_caption1_caps--font_weight--regular: 600;\n  --vkui--font_caption1_caps--text_transform--regular: uppercase;\n  --vkui--font_caption2--font_size--regular: 11px;\n  --vkui--font_caption2--line_height--regular: 14px;\n  --vkui--font_caption2--font_family--regular: -apple-system, system-ui, \"Helvetica Neue\", Roboto, sans-serif;\n  --vkui--font_caption2--font_weight--regular: 400;\n  --vkui--font_caption2_caps--font_size--regular: 11px;\n  --vkui--font_caption2_caps--line_height--regular: 14px;\n  --vkui--font_caption2_caps--font_family--regular: -apple-system, system-ui, \"Helvetica Neue\", Roboto, sans-serif;\n  --vkui--font_caption2_caps--font_weight--regular: 600;\n  --vkui--font_caption2_caps--text_transform--regular: uppercase;\n  --vkui--font_caption3--font_size--regular: 9px;\n  --vkui--font_caption3--line_height--regular: 12px;\n  --vkui--font_caption3--font_family--regular: -apple-system, system-ui, \"Helvetica Neue\", Roboto, sans-serif;\n  --vkui--font_caption3--font_weight--regular: 400;\n  --vkui--font_caption3_caps--font_size--regular: 9px;\n  --vkui--font_caption3_caps--line_height--regular: 12px;\n  --vkui--font_caption3_caps--font_family--regular: -apple-system, system-ui, \"Helvetica Neue\", Roboto, sans-serif;\n  --vkui--font_caption3_caps--font_weight--regular: 600;\n  --vkui--font_caption3_caps--text_transform--regular: uppercase;\n  --vkui--size_select_icon_padding--regular: 6px;\n  --vkui--size_select_icon_padding--compact: 7px;\n  --vkui--size_popup_base_padding--regular: 32px;\n  --vkui--size_popup_base_padding--compact: 20px;\n  --vkui--size_popup_header_padding--regular: 24px;\n  --vkui--size_popup_header_padding--compact: 16px;\n  --vkui--size_label_horizontal_margin--regular: 16px;\n  --vkui--size_border_radius_rounded--regular: 48px;\n  --vkui--size_check_border_radius--regular: 4px;\n  --vkui--size_border_radius_paper--regular: 12px;\n  --vkui--size_border_radius_promo--regular: 20px;\n  --vkui--size_field_height--regular: 44px;\n  --vkui--size_field_height--compact: 36px;\n  --vkui--size_search_height--regular: 36px;\n  --vkui--size_search_height--compact: 32px;\n  --vkui--size_button_large_height--regular: 44px;\n  --vkui--size_button_large_height--compact: 36px;\n  --vkui--size_button_medium_height--regular: 36px;\n  --vkui--size_button_medium_height--compact: 32px;\n  --vkui--size_button_small_height--regular: 30px;\n  --vkui--size_button_small_height--compact: 28px;\n  --vkui--size_checkbox--regular: 16px;\n  --vkui--size_arrow--regular: 8px;\n  --vkui--size_arrow_promo--regular: 40px;\n  --vkui--size_popup_medium--regular: 680px;\n  --vkui--size_popup_large--regular: 880px;\n  --vkui--size_field_horizontal_padding--regular: 12px;\n  --vkui--size_button_padding_horizontal--regular: 12px;\n  --vkui--size_arrow_padding--regular: 12px;\n  --vkui--size_tooltip_margin--regular: 8px;\n  --vkui--size_icon_u_i--regular: 16px;\n  --vkui--size_avatar_x_s--regular: 24px;\n  --vkui--size_avatar_s--regular: 32px;\n  --vkui--size_avatar_m--regular: 48px;\n  --vkui--size_avatar_l--regular: 96px;\n  --vkui--size_avatar_x_l--regular: 128px;\n  --vkui--size_badge_x_s--regular: 12px;\n  --vkui--size_badge_s--regular: 16px;\n  --vkui--size_badge_m--regular: 24px;\n  --vkui--size_badge_l--regular: 44px;\n  --vkui--size_badge_x_l--regular: 56px;\n  --vkui--size_cardgrid_padding--regular: 8px;\n  --vkui--size_cardgrid_padding_vertical--regular: 8px;\n  --vkui--size_base_padding_vertical--regular: 12px;\n  --vkui--size_button_group_gap_space--regular: 1px;\n  --vkui--size_button_group_gap_small--regular: 8px;\n  --vkui--size_button_group_gap_medium--regular: 12px;\n  --vkui--size_option_hierarchy--regular: 32px;\n  --vkui--size_button_base_small_padding_horizontal--regular: 16px;\n  --vkui--size_button_base_medium_padding_horizontal--regular: 16px;\n  --vkui--size_button_base_large_padding_horizontal--regular: 20px;\n  --vkui--size_button_base_small_padding_horizontal_icon--regular: 12px;\n  --vkui--size_button_base_medium_padding_horizontal_icon--regular: 12px;\n  --vkui--size_button_base_large_padding_horizontal_icon--regular: 16px;\n  --vkui--size_button_tertiary_small_padding_horizontal--regular: 12px;\n  --vkui--size_button_tertiary_medium_padding_horizontal--regular: 12px;\n  --vkui--size_button_tertiary_large_padding_horizontal--regular: 16px;\n  --vkui--size_button_tertiary_small_padding_horizontal_icon--regular: 8px;\n  --vkui--size_button_tertiary_medium_padding_horizontal_icon--regular: 8px;\n  --vkui--size_button_tertiary_large_padding_horizontal_icon--regular: 12px;\n  --vkui--size_button_minimum_width--regular: 80px;\n  --vkui--size_split_col_padding_horizontal--regular: 16px;\n  --vkui--size_subnavigation_bar_gap--regular: 8px;\n  --vkui--size_subnavigation_bar_padding_vertical--regular: 12px;\n  --vkui--size_border1x--regular: 1px;\n  --vkui--spacing_size_xs: 4px;\n  --vkui--spacing_size_s: 6px;\n  --vkui--spacing_size_m: 8px;\n  --vkui--spacing_size_l: 10px;\n  --vkui--spacing_size_xl: 12px;\n  --vkui--animation_duration_l: 0.4s;\n  --vkui--animation_duration_m: 0.2s;\n  --vkui--animation_duration_s: 0.1s;\n  --vkui--animation_easing_default: cubic-bezier(0.3, 0.3, 0.5, 1);\n  --vkui--opacity_disable: 0.4;\n  --vkui--opacity_disable_accessibility: 0.64;\n  --vkui--z_index_modal: 99;\n  --vkui--z_index_popout: 100;\n  --vkui--font_headline--font_size--regular: 16px;\n  --vkui--font_headline--line_height--regular: 20px;\n  --vkui--font_headline--font_family--regular: -apple-system, system-ui, \"Helvetica Neue\", Roboto, sans-serif;\n  --vkui--font_headline--font_weight--regular: 500;\n  --vkui--color_background_accent_tint: #5a9eff;\n  --vkui--color_background_contrast_secondary_alpha--hover: hsla(0, 0%, 100%, .24);\n  --vkui--color_background_contrast_secondary_alpha--active: hsla(0, 0%, 100%, .28);\n  --vkui--color_text_link_tint: #71aaeb;\n  --vkui--color_text_link_visited: #4986cc;\n  --vkui--color_icon_contrast_secondary: #f2f3f5;\n  --vkui--color_accent_orange_fire: #f05c44;\n  --vkui--color_accent_secondary: #3f8ae0;\n  --vkui--color_overlay_primary: rgba(0, 0, 0, .4);\n  --vkui--color_overlay_primary--hover: rgba(0, 0, 0, .44);\n  --vkui--color_overlay_primary--active: rgba(0, 0, 0, .48);\n  --vkui--color_avatar_overlay: rgba(0, 0, 0, .6);\n  --vkui--color_avatar_overlay--hover: rgba(0, 0, 0, .64);\n  --vkui--color_avatar_overlay--active: rgba(0, 0, 0, .68);\n  --vkui--color_avatar_overlay_inverse_alpha: hsla(0, 0%, 100%, .85);\n  --vkui--color_avatar_overlay_inverse_alpha--hover: hsla(0, 0%, 100%, .89);\n  --vkui--color_avatar_overlay_inverse_alpha--active: hsla(0, 0%, 100%, .93);\n  --vkui--color_transparent: transparent\n}\n\n.vkui--vkBase--light,\n.vkui--vkCom--light,\n.vkui--vkIOS--light,\n:root {\n  --vkui--gradient_tint: hsla(0, 0%, 98%, 0) 0%, hsla(0, 0%, 98%, .036) 13%, hsla(0, 0%, 98%, .15) 27%, hsla(0, 0%, 98%, .79) 68%, hsla(0, 0%, 98%, .95) 84%, #f9f9f9 100%;\n  --vkui--gradient: hsla(0, 0%, 100%, 0) 0%, hsla(0, 0%, 100%, .036) 13%, hsla(0, 0%, 100%, .15) 27%, hsla(0, 0%, 100%, .79) 68%, hsla(0, 0%, 100%, .95) 84%, #fff 100%;\n  --vkui--colors_scheme: light;\n  --vkui--color_background_accent_tint--hover: #5698f7;\n  --vkui--color_background_accent_tint--active: #5393ef;\n  --vkui--color_background_content--hover: #f5f5f7;\n  --vkui--color_background_content--active: #ebecef;\n  --vkui--color_background_tertiary_alpha: rgba(0, 0, 0, .03);\n  --vkui--color_background_tertiary_alpha--hover: rgba(0, 0, 0, .07);\n  --vkui--color_background_tertiary_alpha--active: rgba(0, 0, 0, .11);\n  --vkui--color_background_contrast--hover: #f5f5f7;\n  --vkui--color_background_contrast--active: #ebecef;\n  --vkui--color_background_contrast_secondary_alpha: hsla(0, 0%, 100%, .2);\n  --vkui--color_background_contrast_themed: #fff;\n  --vkui--color_background_contrast_themed--hover: #f5f5f7;\n  --vkui--color_background_contrast_themed--active: #ebecef;\n  --vkui--color_background_modal--hover: #f5f5f7;\n  --vkui--color_background_modal--active: #ebecef;\n  --vkui--color_background_modal_inverse--hover: #2b2c2f;\n  --vkui--color_background_modal_inverse--active: #292b2f;\n  --vkui--color_background_warning: #fff2d6;\n  --vkui--color_background_warning--hover: #f5e9d0;\n  --vkui--color_background_warning--active: #ebe0ca;\n  --vkui--color_background_positive--hover: #48ac4a;\n  --vkui--color_background_positive--active: #45a64a;\n  --vkui--color_background_negative--hover: #dd4446;\n  --vkui--color_background_negative--active: #d44245;\n  --vkui--color_background_negative_tint: #faebeb;\n  --vkui--color_background_negative_tint--hover: #f0e2e4;\n  --vkui--color_background_negative_tint--active: #e6d9dd;\n  --vkui--color_background_positive_tint: #e8f9e8;\n  --vkui--color_background_positive_tint--hover: #dff0e1;\n  --vkui--color_background_positive_tint--active: #d5e6da;\n  --vkui--color_header_background--hover: #f5f5f7;\n  --vkui--color_header_background--active: #ebecef;\n  --vkui--color_text_primary: #000;\n  --vkui--color_text_primary--hover: #000102;\n  --vkui--color_text_primary--active: #000105;\n  --vkui--color_text_secondary--hover: #7c8795;\n  --vkui--color_text_secondary--active: #778292;\n  --vkui--color_text_tertiary--hover: #939ca9;\n  --vkui--color_text_tertiary--active: #8d96a4;\n  --vkui--color_text_contrast--hover: #f5f5f7;\n  --vkui--color_text_contrast--active: #ebecef;\n  --vkui--color_text_contrast_themed--hover: #f5f5f7;\n  --vkui--color_text_contrast_themed--active: #ebecef;\n  --vkui--color_text_positive--hover: #48ac4a;\n  --vkui--color_text_positive--active: #45a64a;\n  --vkui--color_text_negative--hover: #dd4446;\n  --vkui--color_text_negative--active: #d44245;\n  --vkui--color_text_link_tint--hover: #6ca4e4;\n  --vkui--color_text_link_tint--active: #689edd;\n  --vkui--color_text_link_visited--hover: #4681c6;\n  --vkui--color_text_link_visited--active: #437dc1;\n  --vkui--color_link_contrast--hover: #f5f5f7;\n  --vkui--color_link_contrast--active: #ebecef;\n  --vkui--color_icon_primary: #2c2d2e;\n  --vkui--color_icon_primary--hover: #2a2c2f;\n  --vkui--color_icon_primary--active: #282b2f;\n  --vkui--color_icon_medium_alpha: rgba(0, 0, 0, .48);\n  --vkui--color_icon_medium_alpha--hover: rgba(0, 0, 0, .52);\n  --vkui--color_icon_medium_alpha--active: rgba(0, 0, 0, .56);\n  --vkui--color_icon_secondary--hover: #939ca9;\n  --vkui--color_icon_secondary--active: #8d96a4;\n  --vkui--color_icon_secondary_alpha: rgba(0, 0, 0, .36);\n  --vkui--color_icon_secondary_alpha--hover: rgba(0, 0, 0, .4);\n  --vkui--color_icon_secondary_alpha--active: rgba(0, 0, 0, .44);\n  --vkui--color_icon_tertiary_alpha: rgba(0, 0, 0, .24);\n  --vkui--color_icon_tertiary_alpha--hover: rgba(0, 0, 0, .28);\n  --vkui--color_icon_tertiary_alpha--active: rgba(0, 0, 0, .32);\n  --vkui--color_icon_contrast--hover: #f5f5f7;\n  --vkui--color_icon_contrast--active: #ebecef;\n  --vkui--color_icon_contrast_themed--hover: #f5f5f7;\n  --vkui--color_icon_contrast_themed--active: #ebecef;\n  --vkui--color_icon_contrast_secondary--hover: #e8eaee;\n  --vkui--color_icon_contrast_secondary--active: #dfe1e6;\n  --vkui--color_icon_positive--hover: #48ac4a;\n  --vkui--color_icon_positive--active: #45a64a;\n  --vkui--color_icon_negative--hover: #dd4446;\n  --vkui--color_icon_negative--active: #d44245;\n  --vkui--color_separator_primary2x--hover: #c3c4c7;\n  --vkui--color_separator_primary2x--active: #bbbdc1;\n  --vkui--color_separator_primary3x--hover: #b6b8bc;\n  --vkui--color_separator_primary3x--active: #afb1b6;\n  --vkui--color_separator_primary_alpha: rgba(0, 0, 0, .12);\n  --vkui--color_separator_primary_alpha--hover: rgba(0, 0, 0, .16);\n  --vkui--color_separator_primary_alpha--active: rgba(0, 0, 0, .2);\n  --vkui--color_stroke_positive--hover: #48ac4a;\n  --vkui--color_stroke_positive--active: #45a64a;\n  --vkui--color_stroke_negative--hover: #dd4446;\n  --vkui--color_stroke_negative--active: #d44245;\n  --vkui--color_stroke_contrast: #fff;\n  --vkui--color_stroke_contrast--hover: #f5f5f7;\n  --vkui--color_stroke_contrast--active: #ebecef;\n  --vkui--color_image_border_alpha: rgba(0, 0, 0, .08);\n  --vkui--color_image_border_alpha--hover: rgba(0, 0, 0, .12);\n  --vkui--color_image_border_alpha--active: rgba(0, 0, 0, .16);\n  --vkui--color_field_border_alpha: rgba(0, 0, 0, .12);\n  --vkui--color_field_border_alpha--hover: rgba(0, 0, 0, .24);\n  --vkui--color_field_border_alpha--active: rgba(0, 0, 0, .36);\n  --vkui--color_accent_red--hover: #f53247;\n  --vkui--color_accent_red--active: #eb3046;\n  --vkui--color_accent_green--hover: #48ac4a;\n  --vkui--color_accent_green--active: #45a64a;\n  --vkui--color_accent_orange--hover: #f59a02;\n  --vkui--color_accent_orange--active: #eb9405;\n  --vkui--color_accent_orange_peach: #f9b54f;\n  --vkui--color_accent_orange_peach--hover: #efae4e;\n  --vkui--color_accent_orange_peach--active: #e5a84e;\n  --vkui--color_accent_orange_fire--hover: #e65944;\n  --vkui--color_accent_orange_fire--active: #dd5643;\n  --vkui--color_accent_purple--hover: #6e59df;\n  --vkui--color_accent_purple--active: #6a56d8;\n  --vkui--color_accent_violet--hover: #742dbb;\n  --vkui--color_accent_violet--active: #6f2cb6;\n  --vkui--color_accent_raspberry_pink: #e03fab;\n  --vkui--color_accent_raspberry_pink--hover: #d73da7;\n  --vkui--color_accent_raspberry_pink--active: #ce3ba2;\n  --vkui--color_accent_secondary--hover: #3c85d9;\n  --vkui--color_accent_secondary--active: #3a80d3;\n  --vkui--color_overlay_secondary: rgba(44, 45, 46, .5);\n  --vkui--color_overlay_secondary--hover: rgba(44, 45, 46, .54);\n  --vkui--color_overlay_secondary--active: rgba(44, 45, 46, .58);\n  --vkui--color_action_sheet_text: #3f8ae0;\n  --vkui--color_action_sheet_text--hover: #3c85d9;\n  --vkui--color_action_sheet_text--active: #3a80d3;\n  --vkui--color_image_placeholder: #f2f3f5;\n  --vkui--color_image_placeholder--hover: #e8eaee;\n  --vkui--color_image_placeholder--active: #dfe1e6;\n  --vkui--color_image_placeholder_alpha: rgba(0, 28, 61, .08);\n  --vkui--color_image_placeholder_alpha--hover: rgba(0, 28, 61, .12);\n  --vkui--color_image_placeholder_alpha--active: rgba(0, 28, 61, .16);\n  --vkui--color_write_bar_input_border_alpha: rgba(0, 0, 0, .08);\n  --vkui--color_write_bar_input_border_alpha--hover: rgba(0, 0, 0, .12);\n  --vkui--color_write_bar_input_border_alpha--active: rgba(0, 0, 0, .16);\n  --vkui--color_segmented_control: #fff;\n  --vkui--color_segmented_control--hover: #f5f5f7;\n  --vkui--color_segmented_control--active: #ebecef;\n  --vkui--color_tabbar_text_inactive: #99a2ad;\n  --vkui--color_tabbar_text_inactive--hover: #939ca9;\n  --vkui--color_tabbar_text_inactive--active: #8d96a4;\n  --vkui--color_transparent--hover: rgba(0, 16, 61, .04);\n  --vkui--color_transparent--active: rgba(0, 16, 61, .08)\n}\n\n.vkui--vkBase--dark,\n.vkui--vkBase--light,\n.vkui--vkIOS--dark,\n.vkui--vkIOS--light,\n:root {\n  --vkui--font_headline1--font_size--compact: 15px;\n  --vkui--font_headline1--line_height--compact: 20px;\n  --vkui--font_text--font_size--compact: 15px;\n  --vkui--font_text--line_height--compact: 20px;\n  --vkui--font_subhead--font_size--compact: 13px;\n  --vkui--font_subhead--line_height--compact: 16px;\n  --vkui--size_popup_small--regular: 430px;\n  --vkui--size_form_item_padding_vertical--regular: 12px;\n  --vkui--size_border2x--regular: 0.5px;\n  --vkui--size_border3x--regular: 0.33px;\n  --vkui--font_headline--font_size--compact: 15px;\n  --vkui--font_headline--line_height--compact: 20px;\n  --vkui--color_background_contrast_inverse: #2c2d2e;\n  --vkui--color_background_positive: #4bb34b;\n  --vkui--color_text_primary_invariably: #000;\n  --vkui--color_text_positive: #4bb34b;\n  --vkui--color_icon_primary_invariably: #2c2d2e;\n  --vkui--color_icon_positive: #4bb34b;\n  --vkui--color_stroke_positive: #4bb34b;\n  --vkui--color_accent_gray: #a3adb8;\n  --vkui--color_accent_red: #ff3347;\n  --vkui--color_accent_green: #4bb34b;\n  --vkui--color_accent_orange: #ffa000\n}\n\n.vkui--vkBase--dark,\n.vkui--vkBase--light,\n.vkui--vkCom--dark,\n.vkui--vkCom--light,\n:root {\n  --vkui--size_border_radius--regular: 8px;\n  --vkui--size_card_border_radius--regular: 8px;\n  --vkui--animation_easing_platform: cubic-bezier(0.4, 0, 0.2, 1)\n}\n\n.vkui--vkBase--light,\n.vkui--vkIOS--light,\n:root {\n  --vkui--color_background_accent: #2688eb;\n  --vkui--color_background_accent--hover: #2483e4;\n  --vkui--color_background_accent--active: #237edd;\n  --vkui--color_background_accent_themed: #2688eb;\n  --vkui--color_background_accent_themed--hover: #2483e4;\n  --vkui--color_background_accent_themed--active: #237edd;\n  --vkui--color_background_accent_alternative: #2688eb;\n  --vkui--color_background_accent_alternative--hover: #2483e4;\n  --vkui--color_background_accent_alternative--active: #237edd;\n  --vkui--color_background: #ebedf0;\n  --vkui--color_background--hover: #e2e4e9;\n  --vkui--color_background--active: #d8dbe2;\n  --vkui--color_background_content: #fff;\n  --vkui--color_background_secondary: #f5f5f5;\n  --vkui--color_background_secondary--hover: #ebecee;\n  --vkui--color_background_secondary--active: #e1e3e6;\n  --vkui--color_background_secondary_alpha: rgba(0, 0, 0, .04);\n  --vkui--color_background_secondary_alpha--hover: rgba(0, 0, 0, .08);\n  --vkui--color_background_secondary_alpha--active: rgba(0, 0, 0, .12);\n  --vkui--color_background_tertiary: #f9f9f9;\n  --vkui--color_background_tertiary--hover: #eff0f1;\n  --vkui--color_background_tertiary--active: #e5e6ea;\n  --vkui--color_background_contrast: #fff;\n  --vkui--color_background_contrast_inverse--hover: #2a2c2f;\n  --vkui--color_background_contrast_inverse--active: #282b2f;\n  --vkui--color_background_modal: #fff;\n  --vkui--color_background_modal_inverse: #2d2d2e;\n  --vkui--color_background_negative: #e64646;\n  --vkui--color_field_background: #f2f3f5;\n  --vkui--color_field_background--hover: #e8eaee;\n  --vkui--color_field_background--active: #dfe1e6;\n  --vkui--color_header_background: #fff;\n  --vkui--color_text_accent: #2688eb;\n  --vkui--color_text_accent--hover: #2483e4;\n  --vkui--color_text_accent--active: #237edd;\n  --vkui--color_text_accent_themed: #2688eb;\n  --vkui--color_text_accent_themed--hover: #2483e4;\n  --vkui--color_text_accent_themed--active: #237edd;\n  --vkui--color_text_primary_invariably--hover: #000102;\n  --vkui--color_text_primary_invariably--active: #000105;\n  --vkui--color_text_secondary: #818c99;\n  --vkui--color_text_subhead: #6d7885;\n  --vkui--color_text_subhead--hover: #697482;\n  --vkui--color_text_subhead--active: #64707f;\n  --vkui--color_text_tertiary: #99a2ad;\n  --vkui--color_text_contrast: #fff;\n  --vkui--color_text_contrast_themed: #fff;\n  --vkui--color_text_negative: #e64646;\n  --vkui--color_text_link: #2d81e0;\n  --vkui--color_text_link--hover: #2b7cd9;\n  --vkui--color_text_link--active: #2978d3;\n  --vkui--color_text_link_themed: #2d81e0;\n  --vkui--color_text_link_themed--hover: #2b7cd9;\n  --vkui--color_text_link_themed--active: #2978d3;\n  --vkui--color_text_muted: #2c2d2e;\n  --vkui--color_text_muted--hover: #2a2c2f;\n  --vkui--color_text_muted--active: #282b2f;\n  --vkui--color_link_contrast: #fff;\n  --vkui--color_icon_accent: #2688eb;\n  --vkui--color_icon_accent--hover: #2483e4;\n  --vkui--color_icon_accent--active: #237edd;\n  --vkui--color_icon_accent_themed: #2688eb;\n  --vkui--color_icon_accent_themed--hover: #2483e4;\n  --vkui--color_icon_accent_themed--active: #237edd;\n  --vkui--color_icon_primary_invariably--hover: #2a2c2f;\n  --vkui--color_icon_primary_invariably--active: #282b2f;\n  --vkui--color_icon_medium: #818c99;\n  --vkui--color_icon_medium--hover: #7c8795;\n  --vkui--color_icon_medium--active: #778292;\n  --vkui--color_icon_secondary: #99a2ad;\n  --vkui--color_icon_tertiary: #b8c1cc;\n  --vkui--color_icon_tertiary--hover: #b1bac6;\n  --vkui--color_icon_tertiary--active: #a9b3c1;\n  --vkui--color_icon_contrast: #fff;\n  --vkui--color_icon_contrast_themed: #fff;\n  --vkui--color_icon_negative: #e64646;\n  --vkui--color_stroke_accent: #2688eb;\n  --vkui--color_stroke_accent--hover: #2483e4;\n  --vkui--color_stroke_accent--active: #237edd;\n  --vkui--color_stroke_accent_themed: #2688eb;\n  --vkui--color_stroke_accent_themed--hover: #2483e4;\n  --vkui--color_stroke_accent_themed--active: #237edd;\n  --vkui--color_separator_primary: #d7d8d9;\n  --vkui--color_separator_primary--hover: #ced0d3;\n  --vkui--color_separator_primary--active: #c6c8cd;\n  --vkui--color_separator_primary2x: #cbcccd;\n  --vkui--color_separator_primary3x: #bebfc1;\n  --vkui--color_separator_secondary: #e1e3e6;\n  --vkui--color_separator_secondary--hover: #d8dbdf;\n  --vkui--color_separator_secondary--active: #cfd2d8;\n  --vkui--color_stroke_negative: #e64646;\n  --vkui--color_accent_blue: #2688eb;\n  --vkui--color_accent_blue--hover: #2483e4;\n  --vkui--color_accent_blue--active: #237edd;\n  --vkui--color_accent_gray--hover: #9ca7b3;\n  --vkui--color_accent_gray--active: #96a0ae;\n  --vkui--color_accent_purple: #735ce6;\n  --vkui--color_accent_violet: #792ec0;\n  --vkui--color_skeleton_from: #f5f5f5;\n  --vkui--color_skeleton_from--hover: #ebecee;\n  --vkui--color_skeleton_from--active: #e1e3e6;\n  --vkui--color_skeleton_to: #e1e3e6;\n  --vkui--color_skeleton_to--hover: #d8dbdf;\n  --vkui--color_skeleton_to--active: #cfd2d8;\n  --vkui--color_button_text: #2688eb;\n  --vkui--color_button_text--hover: #2483e4;\n  --vkui--color_button_text--active: #237edd;\n  --vkui--color_button_icon: #2688eb;\n  --vkui--color_button_icon--hover: #2483e4;\n  --vkui--color_button_icon--active: #237edd;\n  --vkui--color_button_stroke: #2688eb;\n  --vkui--color_button_stroke--hover: #2483e4;\n  --vkui--color_button_stroke--active: #237edd;\n  --vkui--color_write_bar_icon: #3f8ae0;\n  --vkui--color_write_bar_icon--hover: #3c85d9;\n  --vkui--color_write_bar_icon--active: #3a80d3;\n  --vkui--color_write_bar_input_background: #f2f3f5;\n  --vkui--color_write_bar_input_background--hover: #e8eaee;\n  --vkui--color_write_bar_input_background--active: #dfe1e6;\n  --vkui--color_write_bar_input_border: #e1e3e6;\n  --vkui--color_write_bar_input_border--hover: #d8dbdf;\n  --vkui--color_write_bar_input_border--active: #cfd2d8;\n  --vkui--color_track_background: #e1e3e6;\n  --vkui--color_track_background--hover: #d8dbdf;\n  --vkui--color_track_background--active: #cfd2d8;\n  --vkui--color_track_buffer: #a0bfe4;\n  --vkui--color_track_buffer--hover: #9ab8dd;\n  --vkui--color_track_buffer--active: #93b1d7;\n  --vkui--color_search_field_background: #ebedf0;\n  --vkui--color_search_field_background--hover: #e2e4e9;\n  --vkui--color_search_field_background--active: #d8dbe2;\n  --vkui--color_panel_header_icon: #2688eb;\n  --vkui--color_panel_header_icon--hover: #2483e4;\n  --vkui--color_panel_header_icon--active: #237edd\n}\n\n.vkui--vkBase--dark {\n  --vkui--theme_name: \"vkBaseDark\"\n}\n\n.vkui--vkBase--dark,\n.vkui--vkCom--dark,\n.vkui--vkIOS--dark {\n  --vkui--gradient_tint: rgba(32, 32, 33, 0) 0%, rgba(32, 32, 33, .036) 13%, rgba(32, 32, 33, .15) 27%, rgba(32, 32, 33, .79) 68%, rgba(32, 32, 33, .95) 84%, #202021 100%;\n  --vkui--gradient: rgba(25, 25, 26, 0) 0%, rgba(25, 25, 26, .014) 13%, rgba(25, 25, 26, .06) 27%, rgba(25, 25, 26, .316) 68%, rgba(25, 25, 26, .38) 84%, rgba(25, 25, 26, .4) 100%;\n  --vkui--colors_scheme: dark;\n  --vkui--color_background_accent_tint--hover: #61a2ff;\n  --vkui--color_background_accent_tint--active: #67a6ff;\n  --vkui--color_background_secondary_alpha: hsla(0, 0%, 100%, .1);\n  --vkui--color_background_secondary_alpha--hover: hsla(0, 0%, 100%, .12);\n  --vkui--color_background_secondary_alpha--active: hsla(0, 0%, 100%, .14);\n  --vkui--color_background_tertiary_alpha: hsla(0, 0%, 100%, .03);\n  --vkui--color_background_tertiary_alpha--hover: hsla(0, 0%, 100%, .07);\n  --vkui--color_background_tertiary_alpha--active: hsla(0, 0%, 100%, .11);\n  --vkui--color_background_contrast--hover: #ebedf0;\n  --vkui--color_background_contrast--active: #d7d8db;\n  --vkui--color_background_contrast_secondary_alpha: hsla(0, 0%, 100%, .2);\n  --vkui--color_background_contrast_themed: #323232;\n  --vkui--color_background_contrast_themed--hover: #3a3a3a;\n  --vkui--color_background_contrast_themed--active: #424242;\n  --vkui--color_background_modal_inverse: #fff;\n  --vkui--color_background_modal_inverse--hover: #ebedf0;\n  --vkui--color_background_modal_inverse--active: #d7d8db;\n  --vkui--color_background_warning: #857250;\n  --vkui--color_background_warning--hover: #8a7857;\n  --vkui--color_background_warning--active: #8f7d5e;\n  --vkui--color_background_positive--hover: #52b652;\n  --vkui--color_background_positive--active: #59b959;\n  --vkui--color_background_negative--hover: #ff6363;\n  --vkui--color_background_negative--active: #ff6969;\n  --vkui--color_background_negative_tint: #522e2e;\n  --vkui--color_background_negative_tint--hover: #593636;\n  --vkui--color_background_negative_tint--active: #603f3f;\n  --vkui--color_background_positive_tint: #b1d6b1;\n  --vkui--color_background_positive_tint--hover: #b4d8b4;\n  --vkui--color_background_positive_tint--active: #b7d9b7;\n  --vkui--color_text_primary--hover: #e2e4e7;\n  --vkui--color_text_primary--active: #e3e5e8;\n  --vkui--color_text_contrast--hover: #ebedf0;\n  --vkui--color_text_contrast--active: #d7d8db;\n  --vkui--color_text_positive--hover: #52b652;\n  --vkui--color_text_positive--active: #59b959;\n  --vkui--color_text_negative--hover: #ff6363;\n  --vkui--color_text_negative--active: #ff6969;\n  --vkui--color_text_link_tint--hover: #77adec;\n  --vkui--color_text_link_tint--active: #7cb1ed;\n  --vkui--color_text_link_visited--hover: #508bce;\n  --vkui--color_text_link_visited--active: #5890d0;\n  --vkui--color_link_contrast--hover: #ebedf0;\n  --vkui--color_link_contrast--active: #d7d8db;\n  --vkui--color_icon_primary: #e1e3e6;\n  --vkui--color_icon_primary--hover: #e2e4e7;\n  --vkui--color_icon_primary--active: #e3e5e8;\n  --vkui--color_icon_contrast_secondary--hover: #f3f3f5;\n  --vkui--color_icon_contrast_secondary--active: #f3f4f6;\n  --vkui--color_icon_positive--hover: #52b652;\n  --vkui--color_icon_positive--active: #59b959;\n  --vkui--color_icon_negative--hover: #ff6363;\n  --vkui--color_icon_negative--active: #ff6969;\n  --vkui--color_separator_primary: #363738;\n  --vkui--color_separator_primary--hover: #3e3f40;\n  --vkui--color_separator_primary--active: #464748;\n  --vkui--color_separator_primary2x: #444546;\n  --vkui--color_separator_primary2x--hover: #4b4c4d;\n  --vkui--color_separator_primary2x--active: #535455;\n  --vkui--color_separator_primary3x: #505253;\n  --vkui--color_separator_primary3x--hover: #57595a;\n  --vkui--color_separator_primary3x--active: #5e6061;\n  --vkui--color_separator_primary_alpha: hsla(0, 0%, 100%, .12);\n  --vkui--color_separator_primary_alpha--hover: hsla(0, 0%, 100%, .16);\n  --vkui--color_separator_primary_alpha--active: hsla(0, 0%, 100%, .2);\n  --vkui--color_stroke_positive--hover: #52b652;\n  --vkui--color_stroke_positive--active: #59b959;\n  --vkui--color_stroke_negative--hover: #ff6363;\n  --vkui--color_stroke_negative--active: #ff6969;\n  --vkui--color_stroke_contrast: #fff;\n  --vkui--color_stroke_contrast--hover: #ebedf0;\n  --vkui--color_stroke_contrast--active: #d7d8db;\n  --vkui--color_image_border_alpha: hsla(0, 0%, 100%, .08);\n  --vkui--color_image_border_alpha--hover: hsla(0, 0%, 100%, .12);\n  --vkui--color_image_border_alpha--active: hsla(0, 0%, 100%, .16);\n  --vkui--color_field_border_alpha: hsla(0, 0%, 100%, .12);\n  --vkui--color_field_border_alpha--hover: hsla(0, 0%, 100%, .16);\n  --vkui--color_field_border_alpha--active: hsla(0, 0%, 100%, .2);\n  --vkui--color_accent_red--hover: #ff3b4e;\n  --vkui--color_accent_red--active: #ff4356;\n  --vkui--color_accent_green--hover: #52b652;\n  --vkui--color_accent_green--active: #59b959;\n  --vkui--color_accent_orange--hover: #ffa40a;\n  --vkui--color_accent_orange--active: #ffa814;\n  --vkui--color_accent_orange_peach: #ffc062;\n  --vkui--color_accent_orange_peach--hover: #ffc368;\n  --vkui--color_accent_orange_peach--active: #ffc56f;\n  --vkui--color_accent_orange_fire--hover: #f1634b;\n  --vkui--color_accent_orange_fire--active: #f16953;\n  --vkui--color_accent_raspberry_pink: #f060c0;\n  --vkui--color_accent_raspberry_pink--hover: #f166c3;\n  --vkui--color_accent_raspberry_pink--active: #f16dc5;\n  --vkui--color_accent_secondary--hover: #478fe1;\n  --vkui--color_accent_secondary--active: #4e93e2;\n  --vkui--color_overlay_secondary: rgba(55, 56, 57, .5);\n  --vkui--color_overlay_secondary--hover: rgba(55, 56, 57, .54);\n  --vkui--color_overlay_secondary--active: rgba(55, 56, 57, .58);\n  --vkui--color_action_sheet_text: #71aaeb;\n  --vkui--color_action_sheet_text--hover: #77adec;\n  --vkui--color_action_sheet_text--active: #7cb1ed;\n  --vkui--color_image_placeholder: #2a2b2c;\n  --vkui--color_image_placeholder--hover: #333334;\n  --vkui--color_image_placeholder--active: #3b3c3d;\n  --vkui--color_image_placeholder_alpha: rgba(241, 247, 255, .08);\n  --vkui--color_image_placeholder_alpha--hover: rgba(241, 247, 255, .12);\n  --vkui--color_image_placeholder_alpha--active: rgba(241, 247, 255, .16);\n  --vkui--color_write_bar_input_border_alpha: hsla(0, 0%, 100%, .8);\n  --vkui--color_write_bar_input_border_alpha--hover: hsla(0, 0%, 100%, .84);\n  --vkui--color_write_bar_input_border_alpha--active: hsla(0, 0%, 100%, .88);\n  --vkui--color_panel_header_icon--hover: #77adec;\n  --vkui--color_panel_header_icon--active: #7cb1ed;\n  --vkui--color_segmented_control: #626364;\n  --vkui--color_segmented_control--hover: #68696a;\n  --vkui--color_segmented_control--active: #6f6f70;\n  --vkui--color_tabbar_text_inactive: #76787a;\n  --vkui--color_tabbar_text_inactive--hover: #7b7d7f;\n  --vkui--color_tabbar_text_inactive--active: #818385;\n  --vkui--color_transparent--hover: hsla(0, 0%, 100%, .04);\n  --vkui--color_transparent--active: hsla(0, 0%, 100%, .08)\n}\n\n.vkui--vkBase--dark,\n.vkui--vkCom--light,\n.vkui--vkIOS--light {\n  --vkui--theme_inherits_from: \"vkBase\"\n}\n\n.vkui--vkBase--dark,\n.vkui--vkIOS--dark {\n  --vkui--color_background_accent: #529ef4;\n  --vkui--color_background_accent--hover: #59a2f4;\n  --vkui--color_background_accent--active: #60a6f5;\n  --vkui--color_background_accent_themed: #fff;\n  --vkui--color_background_accent_themed--hover: #ebedf0;\n  --vkui--color_background_accent_themed--active: #d7d8db;\n  --vkui--color_background_accent_alternative: #529ef4;\n  --vkui--color_background_accent_alternative--hover: #59a2f4;\n  --vkui--color_background_accent_alternative--active: #60a6f5;\n  --vkui--color_background: #0a0a0a;\n  --vkui--color_background--hover: #141414;\n  --vkui--color_background--active: #1e1e1e;\n  --vkui--color_background_content: #0f0f0f;\n  --vkui--color_background_content--hover: #222223;\n  --vkui--color_background_content--active: #2b2b2c;\n  --vkui--color_background_secondary: #212022;\n  --vkui--color_background_secondary--hover: #2c2c2d;\n  --vkui--color_background_secondary--active: #353536;\n  --vkui--color_background_tertiary: #202021;\n  --vkui--color_background_tertiary--hover: #29292a;\n  --vkui--color_background_tertiary--active: #323233;\n  --vkui--color_background_contrast_inverse--hover: #343536;\n  --vkui--color_background_contrast_inverse--active: #3d3e3f;\n  --vkui--color_background_modal: #2c2d2e;\n  --vkui--color_background_modal--hover: #343536;\n  --vkui--color_background_modal--active: #3d3e3f;\n  --vkui--color_background_negative: #ff5c5c;\n  --vkui--color_field_background: #232324;\n  --vkui--color_field_background--hover: #2c2c2d;\n  --vkui--color_field_background--active: #353536;\n  --vkui--color_header_background: #19191a;\n  --vkui--color_header_background--hover: #222223;\n  --vkui--color_header_background--active: #2b2b2c;\n  --vkui--color_text_accent: #529ef4;\n  --vkui--color_text_accent--hover: #59a2f4;\n  --vkui--color_text_accent--active: #60a6f5;\n  --vkui--color_text_accent_themed: #fff;\n  --vkui--color_text_accent_themed--hover: #ebedf0;\n  --vkui--color_text_accent_themed--active: #d7d8db;\n  --vkui--color_text_primary: #e1e3e6;\n  --vkui--color_text_primary_invariably--hover: #0a0a0a;\n  --vkui--color_text_primary_invariably--active: #141414;\n  --vkui--color_text_secondary: #76787a;\n  --vkui--color_text_secondary--hover: #7b7d7f;\n  --vkui--color_text_secondary--active: #818385;\n  --vkui--color_text_subhead: #969a9f;\n  --vkui--color_text_subhead--hover: #9a9ea3;\n  --vkui--color_text_subhead--active: #9ea2a7;\n  --vkui--color_text_tertiary: #5d5f61;\n  --vkui--color_text_tertiary--hover: #636567;\n  --vkui--color_text_tertiary--active: #6a6c6e;\n  --vkui--color_text_contrast_themed: #000;\n  --vkui--color_text_contrast_themed--hover: #0a0a0a;\n  --vkui--color_text_contrast_themed--active: #141414;\n  --vkui--color_text_negative: #ff5c5c;\n  --vkui--color_text_link: #529ef4;\n  --vkui--color_text_link--hover: #59a2f4;\n  --vkui--color_text_link--active: #60a6f5;\n  --vkui--color_text_link_themed: #fff;\n  --vkui--color_text_link_themed--hover: #ebedf0;\n  --vkui--color_text_link_themed--active: #d7d8db;\n  --vkui--color_text_muted: #e1e3e6;\n  --vkui--color_text_muted--hover: #e2e4e7;\n  --vkui--color_text_muted--active: #e3e5e8;\n  --vkui--color_icon_accent: #529ef4;\n  --vkui--color_icon_accent--hover: #59a2f4;\n  --vkui--color_icon_accent--active: #60a6f5;\n  --vkui--color_icon_accent_themed: #fff;\n  --vkui--color_icon_accent_themed--hover: #ebedf0;\n  --vkui--color_icon_accent_themed--active: #d7d8db;\n  --vkui--color_icon_primary_invariably--hover: #343536;\n  --vkui--color_icon_primary_invariably--active: #3d3e3f;\n  --vkui--color_icon_medium: #b0b1b6;\n  --vkui--color_icon_medium--hover: #b3b4b9;\n  --vkui--color_icon_medium--active: #b6b7bc;\n  --vkui--color_icon_medium_alpha: rgba(241, 247, 255, .66);\n  --vkui--color_icon_medium_alpha--hover: rgba(241, 247, 255, .7);\n  --vkui--color_icon_medium_alpha--active: rgba(241, 247, 255, .74);\n  --vkui--color_icon_secondary: #76787a;\n  --vkui--color_icon_secondary--hover: #7b7d7f;\n  --vkui--color_icon_secondary--active: #818385;\n  --vkui--color_icon_secondary_alpha: rgba(0, 0, 0, .43);\n  --vkui--color_icon_secondary_alpha--hover: rgba(0, 0, 0, .47);\n  --vkui--color_icon_secondary_alpha--active: rgba(0, 0, 0, .51);\n  --vkui--color_icon_tertiary: #5d5f61;\n  --vkui--color_icon_tertiary--hover: #636567;\n  --vkui--color_icon_tertiary--active: #6a6c6e;\n  --vkui--color_icon_tertiary_alpha: hsla(0, 0%, 100%, .3);\n  --vkui--color_icon_tertiary_alpha--hover: hsla(0, 0%, 100%, .34);\n  --vkui--color_icon_tertiary_alpha--active: hsla(0, 0%, 100%, .38);\n  --vkui--color_icon_contrast--hover: #ebedf0;\n  --vkui--color_icon_contrast--active: #d7d8db;\n  --vkui--color_icon_contrast_themed: #000;\n  --vkui--color_icon_contrast_themed--hover: #0a0a0a;\n  --vkui--color_icon_contrast_themed--active: #141414;\n  --vkui--color_icon_negative: #ff5c5c;\n  --vkui--color_stroke_accent: #529ef4;\n  --vkui--color_stroke_accent--hover: #59a2f4;\n  --vkui--color_stroke_accent--active: #60a6f5;\n  --vkui--color_stroke_accent_themed: #fff;\n  --vkui--color_stroke_accent_themed--hover: #ebedf0;\n  --vkui--color_stroke_accent_themed--active: #d7d8db;\n  --vkui--color_separator_secondary: #141415;\n  --vkui--color_separator_secondary--hover: #1d1d1e;\n  --vkui--color_separator_secondary--active: #272728;\n  --vkui--color_stroke_negative: #ff5c5c;\n  --vkui--color_accent_blue: #71aaeb;\n  --vkui--color_accent_blue--hover: #77adec;\n  --vkui--color_accent_blue--active: #7cb1ed;\n  --vkui--color_accent_gray--hover: #a7b0bb;\n  --vkui--color_accent_gray--active: #aab4be;\n  --vkui--color_accent_purple: #9985ff;\n  --vkui--color_accent_purple--hover: #9d8aff;\n  --vkui--color_accent_purple--active: #a18fff;\n  --vkui--color_accent_violet: #a94fff;\n  --vkui--color_accent_violet--hover: #ac56ff;\n  --vkui--color_accent_violet--active: #b05dff;\n  --vkui--color_skeleton_from: #232324;\n  --vkui--color_skeleton_from--hover: #2c2c2d;\n  --vkui--color_skeleton_from--active: #353536;\n  --vkui--color_skeleton_to: #2c2d2e;\n  --vkui--color_skeleton_to--hover: #343536;\n  --vkui--color_skeleton_to--active: #3d3e3f;\n  --vkui--color_button_text: #fff;\n  --vkui--color_button_text--hover: #ebedf0;\n  --vkui--color_button_text--active: #d7d8db;\n  --vkui--color_button_icon: #fff;\n  --vkui--color_button_icon--hover: #ebedf0;\n  --vkui--color_button_icon--active: #d7d8db;\n  --vkui--color_button_stroke: #fff;\n  --vkui--color_button_stroke--hover: #ebedf0;\n  --vkui--color_button_stroke--active: #d7d8db;\n  --vkui--color_write_bar_icon: #76787a;\n  --vkui--color_write_bar_icon--hover: #7b7d7f;\n  --vkui--color_write_bar_icon--active: #818385;\n  --vkui--color_write_bar_input_background: #2c2d2e;\n  --vkui--color_write_bar_input_background--hover: #343536;\n  --vkui--color_write_bar_input_background--active: #3d3e3f;\n  --vkui--color_write_bar_input_border: #2c2d2e;\n  --vkui--color_write_bar_input_border--hover: #343536;\n  --vkui--color_write_bar_input_border--active: #3d3e3f;\n  --vkui--color_track_background: #454647;\n  --vkui--color_track_background--hover: #4c4d4e;\n  --vkui--color_track_background--active: #545556;\n  --vkui--color_track_buffer: #405772;\n  --vkui--color_track_buffer--hover: #485e78;\n  --vkui--color_track_buffer--active: #4f647d;\n  --vkui--color_search_field_background: #363738;\n  --vkui--color_search_field_background--hover: #3e3f40;\n  --vkui--color_search_field_background--active: #464748;\n  --vkui--color_panel_header_icon: #71aaeb\n}\n\n.vkui--vkBase--dark,\n.vkui--vkCom--dark,\n.vkui--vkCom--light,\n.vkui--vkIOS--dark {\n  --vkui--color_background_contrast: #fff;\n  --vkui--color_text_contrast: #fff;\n  --vkui--color_link_contrast: #fff\n}\n\n.vkui--vkBase--dark,\n.vkui--vkCom--light,\n.vkui--vkIOS--dark {\n  --vkui--color_icon_contrast: #fff\n}\n\n.vkui--vkIOS--light {\n  --vkui--theme_name: \"vkIOS\"\n}\n\n.vkui--vkIOS--dark,\n.vkui--vkIOS--light {\n  --vkui--theme_name_base: \"vkIOS\";\n  --vkui--size_border_radius--regular: 10px;\n  --vkui--size_card_border_radius--regular: 10px;\n  --vkui--size_switch_height--regular: 31px;\n  --vkui--size_switch_height--compact: 27px;\n  --vkui--size_switch_width--regular: 51px;\n  --vkui--size_switch_width--compact: 47px;\n  --vkui--size_switch_pin--regular: 27px;\n  --vkui--size_switch_pin--compact: 23px;\n  --vkui--size_panel_header_height--regular: 52px;\n  --vkui--animation_easing_platform: cubic-bezier(0.36, 0.66, 0.04, 1)\n}\n\n.vkui--vkCom--dark,\n.vkui--vkCom--light,\n.vkui--vkIOS--dark,\n.vkui--vkIOS--light {\n  --vkui--size_base_padding_horizontal--regular: 12px\n}\n\n.vkui--vkIOS--dark {\n  --vkui--theme_name: \"vkIOSDark\"\n}\n\n.vkui--vkCom--dark,\n.vkui--vkIOS--dark {\n  --vkui--theme_inherits_from: \"vkBaseDark\"\n}\n\n.vkui--vkCom--light {\n  --vkui--theme_name: \"vkCom\";\n  --vkui--color_background_accent: #447bba;\n  --vkui--color_background_accent--hover: #4177b5;\n  --vkui--color_background_accent--active: #3f72b0;\n  --vkui--color_background_accent_themed: #447bba;\n  --vkui--color_background_accent_themed--hover: #4177b5;\n  --vkui--color_background_accent_themed--active: #3f72b0;\n  --vkui--color_background_accent_alternative: #447bba;\n  --vkui--color_background_accent_alternative--hover: #4177b5;\n  --vkui--color_background_accent_alternative--active: #3f72b0;\n  --vkui--color_background: #edeef0;\n  --vkui--color_background--hover: #e4e5e9;\n  --vkui--color_background--active: #dadce2;\n  --vkui--color_background_content: #fff;\n  --vkui--color_background_secondary: #f0f2f5;\n  --vkui--color_background_secondary--hover: #e6e9ee;\n  --vkui--color_background_secondary--active: #dde0e6;\n  --vkui--color_background_secondary_alpha: rgba(235, 242, 250, .99);\n  --vkui--color_background_secondary_alpha--hover: rgba(223, 234, 246, .99);\n  --vkui--color_background_secondary_alpha--active: rgba(213, 226, 241, .99);\n  --vkui--color_background_tertiary: #fafbfc;\n  --vkui--color_background_tertiary--hover: #f0f2f4;\n  --vkui--color_background_tertiary--active: #e6e8ed;\n  --vkui--color_background_contrast_inverse--hover: #313233;\n  --vkui--color_background_contrast_inverse--active: #2f3034;\n  --vkui--color_background_modal: #fff;\n  --vkui--color_background_modal_inverse: #2d2d2e;\n  --vkui--color_background_negative: #e64646;\n  --vkui--color_field_background: #f7f8fa;\n  --vkui--color_field_background--hover: #edeff2;\n  --vkui--color_field_background--active: #e3e5eb;\n  --vkui--color_header_background: #fff;\n  --vkui--color_text_accent: #447bba;\n  --vkui--color_text_accent--hover: #4177b5;\n  --vkui--color_text_accent--active: #3f72b0;\n  --vkui--color_text_accent_themed: #3770b1;\n  --vkui--color_text_accent_themed--hover: #356cac;\n  --vkui--color_text_accent_themed--active: #3368a8;\n  --vkui--color_text_primary_invariably--hover: #313233;\n  --vkui--color_text_primary_invariably--active: #2f3034;\n  --vkui--color_text_secondary: #818c99;\n  --vkui--color_text_subhead: #626d7a;\n  --vkui--color_text_subhead--hover: #5e6978;\n  --vkui--color_text_subhead--active: #5a6675;\n  --vkui--color_text_tertiary: #99a2ad;\n  --vkui--color_text_contrast_themed: #fff;\n  --vkui--color_text_negative: #e64646;\n  --vkui--color_text_link: #2a5885;\n  --vkui--color_text_link--hover: #285582;\n  --vkui--color_text_link--active: #27527f;\n  --vkui--color_text_link_themed: #2a5885;\n  --vkui--color_text_link_themed--hover: #285582;\n  --vkui--color_text_link_themed--active: #27527f;\n  --vkui--color_text_muted: #333;\n  --vkui--color_text_muted--hover: #313233;\n  --vkui--color_text_muted--active: #2f3034;\n  --vkui--color_icon_accent: #447bba;\n  --vkui--color_icon_accent--hover: #4177b5;\n  --vkui--color_icon_accent--active: #3f72b0;\n  --vkui--color_icon_accent_themed: #3770b1;\n  --vkui--color_icon_accent_themed--hover: #356cac;\n  --vkui--color_icon_accent_themed--active: #3368a8;\n  --vkui--color_icon_primary_invariably--hover: #313233;\n  --vkui--color_icon_primary_invariably--active: #2f3034;\n  --vkui--color_icon_medium: #6f7985;\n  --vkui--color_icon_medium--hover: #6b7582;\n  --vkui--color_icon_medium--active: #66717f;\n  --vkui--color_icon_secondary: #99a2ad;\n  --vkui--color_icon_tertiary: #aeb7c2;\n  --vkui--color_icon_tertiary--hover: #a7b0bd;\n  --vkui--color_icon_tertiary--active: #a0aab7;\n  --vkui--color_icon_contrast_themed: #fff;\n  --vkui--color_icon_negative: #e64646;\n  --vkui--color_stroke_accent: #447bba;\n  --vkui--color_stroke_accent--hover: #4177b5;\n  --vkui--color_stroke_accent--active: #3f72b0;\n  --vkui--color_stroke_accent_themed: #3770b1;\n  --vkui--color_stroke_accent_themed--hover: #356cac;\n  --vkui--color_stroke_accent_themed--active: #3368a8;\n  --vkui--color_separator_primary: #dce1e6;\n  --vkui--color_separator_primary--hover: #d3d9df;\n  --vkui--color_separator_primary--active: #cad0d8;\n  --vkui--color_separator_primary2x: #cbcccd;\n  --vkui--color_separator_primary3x: #bebfc1;\n  --vkui--color_separator_secondary: #e7e8ec;\n  --vkui--color_separator_secondary--hover: #dedfe5;\n  --vkui--color_separator_secondary--active: #d5d7de;\n  --vkui--color_stroke_negative: #e64646;\n  --vkui--color_accent_blue: #5181b8;\n  --vkui--color_accent_blue--hover: #4e7cb3;\n  --vkui--color_accent_blue--active: #4b78ae;\n  --vkui--color_accent_gray--hover: #a7b0bd;\n  --vkui--color_accent_gray--active: #a0aab7;\n  --vkui--color_accent_purple: #735ce6;\n  --vkui--color_accent_violet: #792ec0;\n  --vkui--color_skeleton_from: #f0f2f5;\n  --vkui--color_skeleton_from--hover: #e6e9ee;\n  --vkui--color_skeleton_from--active: #dde0e6;\n  --vkui--color_skeleton_to: #e7e8ec;\n  --vkui--color_skeleton_to--hover: #dedfe5;\n  --vkui--color_skeleton_to--active: #d5d7de;\n  --vkui--color_button_text: #346297;\n  --vkui--color_button_text--hover: #325f93;\n  --vkui--color_button_text--active: #305b90;\n  --vkui--color_button_icon: #346297;\n  --vkui--color_button_icon--hover: #325f93;\n  --vkui--color_button_icon--active: #305b90;\n  --vkui--color_button_stroke: #346297;\n  --vkui--color_button_stroke--hover: #325f93;\n  --vkui--color_button_stroke--active: #305b90;\n  --vkui--color_write_bar_icon: #818c99;\n  --vkui--color_write_bar_icon--hover: #7c8795;\n  --vkui--color_write_bar_icon--active: #778292;\n  --vkui--color_write_bar_input_background: #fff;\n  --vkui--color_write_bar_input_background--hover: #f5f5f7;\n  --vkui--color_write_bar_input_background--active: #ebecef;\n  --vkui--color_write_bar_input_border: #d3d9de;\n  --vkui--color_write_bar_input_border--hover: #cbd1d8;\n  --vkui--color_write_bar_input_border--active: #c2c9d1;\n  --vkui--color_track_background: #d3d9de;\n  --vkui--color_track_background--hover: #cbd1d8;\n  --vkui--color_track_background--active: #c2c9d1;\n  --vkui--color_track_buffer: #447bba;\n  --vkui--color_track_buffer--hover: #4177b5;\n  --vkui--color_track_buffer--active: #3f72b0;\n  --vkui--color_search_field_background: #edeef0;\n  --vkui--color_search_field_background--hover: #e4e5e9;\n  --vkui--color_search_field_background--active: #dadce2;\n  --vkui--color_panel_header_icon: #447bba;\n  --vkui--color_panel_header_icon--hover: #4177b5;\n  --vkui--color_panel_header_icon--active: #3f72b0\n}\n\n.vkui--vkCom--dark,\n.vkui--vkCom--light {\n  --vkui--theme_name_base: \"vkCom\";\n  --vkui--font_headline1--font_size--compact: 14px;\n  --vkui--font_headline1--line_height--compact: 18px;\n  --vkui--font_text--font_size--compact: 13px;\n  --vkui--font_text--line_height--compact: 16px;\n  --vkui--font_subhead--font_size--compact: 14px;\n  --vkui--font_subhead--line_height--compact: 18px;\n  --vkui--size_popup_small--regular: 448px;\n  --vkui--size_switch_height--regular: 10px;\n  --vkui--size_switch_height--compact: 10px;\n  --vkui--size_switch_width--regular: 27px;\n  --vkui--size_switch_width--compact: 27px;\n  --vkui--size_switch_pin--regular: 16px;\n  --vkui--size_switch_pin--compact: 16px;\n  --vkui--size_panel_header_height--regular: 48px;\n  --vkui--size_form_item_padding_vertical--regular: 8px;\n  --vkui--size_border2x--regular: 1px;\n  --vkui--size_border3x--regular: 1px;\n  --vkui--font_headline--font_size--compact: 14px;\n  --vkui--font_headline--line_height--compact: 18px;\n  --vkui--color_background_contrast_inverse: #333;\n  --vkui--color_background_positive: #4bb34b;\n  --vkui--color_text_primary_invariably: #333;\n  --vkui--color_text_positive: #4bb34b;\n  --vkui--color_icon_primary_invariably: #333;\n  --vkui--color_icon_positive: #4bb34b;\n  --vkui--color_stroke_positive: #4bb34b;\n  --vkui--color_accent_gray: #aeb7c2;\n  --vkui--color_accent_red: #ff3347;\n  --vkui--color_accent_green: #4bb34b;\n  --vkui--color_accent_orange: #ffa000\n}\n\n.vkui--vkCom--dark {\n  --vkui--theme_name: \"vkComDark\";\n  --vkui--color_background_accent: #71aaeb;\n  --vkui--color_background_accent--hover: #77adec;\n  --vkui--color_background_accent--active: #7cb1ed;\n  --vkui--color_background_accent_themed: #e1e3e6;\n  --vkui--color_background_accent_themed--hover: #d8dbdf;\n  --vkui--color_background_accent_themed--active: #cfd2d8;\n  --vkui--color_background_accent_alternative: #71aaeb;\n  --vkui--color_background_accent_alternative--hover: #77adec;\n  --vkui--color_background_accent_alternative--active: #7cb1ed;\n  --vkui--color_background: #141414;\n  --vkui--color_background--hover: #1d1d1d;\n  --vkui--color_background--active: #272727;\n  --vkui--color_background_content: #222;\n  --vkui--color_background_content--hover: #2b2b2b;\n  --vkui--color_background_content--active: #343434;\n  --vkui--color_background_secondary: #333;\n  --vkui--color_background_secondary--hover: #3b3b3b;\n  --vkui--color_background_secondary--active: #434343;\n  --vkui--color_background_tertiary: #292929;\n  --vkui--color_background_tertiary--hover: #323232;\n  --vkui--color_background_tertiary--active: #3a3a3a;\n  --vkui--color_background_contrast_inverse--hover: #3b3b3b;\n  --vkui--color_background_contrast_inverse--active: #434343;\n  --vkui--color_background_modal: #292929;\n  --vkui--color_background_modal--hover: #323232;\n  --vkui--color_background_modal--active: #3a3a3a;\n  --vkui--color_background_negative: #ff5c5c;\n  --vkui--color_field_background: #292929;\n  --vkui--color_field_background--hover: #323232;\n  --vkui--color_field_background--active: #3a3a3a;\n  --vkui--color_header_background: #222;\n  --vkui--color_header_background--hover: #2b2b2b;\n  --vkui--color_header_background--active: #343434;\n  --vkui--color_text_accent: #71aaeb;\n  --vkui--color_text_accent--hover: #77adec;\n  --vkui--color_text_accent--active: #7cb1ed;\n  --vkui--color_text_accent_themed: #e1e3e6;\n  --vkui--color_text_accent_themed--hover: #e2e4e7;\n  --vkui--color_text_accent_themed--active: #e3e5e8;\n  --vkui--color_text_primary: #e1e3e6;\n  --vkui--color_text_primary_invariably--hover: #3b3b3b;\n  --vkui--color_text_primary_invariably--active: #434343;\n  --vkui--color_text_secondary: #828282;\n  --vkui--color_text_secondary--hover: #878787;\n  --vkui--color_text_secondary--active: #8c8c8c;\n  --vkui--color_text_subhead: #939393;\n  --vkui--color_text_subhead--hover: #979797;\n  --vkui--color_text_subhead--active: #9c9c9c;\n  --vkui--color_text_tertiary: #656565;\n  --vkui--color_text_tertiary--hover: #6b6b6b;\n  --vkui--color_text_tertiary--active: #717171;\n  --vkui--color_text_contrast_themed: #222;\n  --vkui--color_text_contrast_themed--hover: #2b2b2b;\n  --vkui--color_text_contrast_themed--active: #343434;\n  --vkui--color_text_negative: #ff5c5c;\n  --vkui--color_text_link: #71aaeb;\n  --vkui--color_text_link--hover: #77adec;\n  --vkui--color_text_link--active: #7cb1ed;\n  --vkui--color_text_link_themed: #939393;\n  --vkui--color_text_link_themed--hover: #979797;\n  --vkui--color_text_link_themed--active: #9c9c9c;\n  --vkui--color_text_muted: #ccc;\n  --vkui--color_text_muted--hover: #cecece;\n  --vkui--color_text_muted--active: #d0d0d0;\n  --vkui--color_icon_accent: #71aaeb;\n  --vkui--color_icon_accent--hover: #77adec;\n  --vkui--color_icon_accent--active: #7cb1ed;\n  --vkui--color_icon_accent_themed: #e1e3e6;\n  --vkui--color_icon_accent_themed--hover: #e2e4e7;\n  --vkui--color_icon_accent_themed--active: #e3e5e8;\n  --vkui--color_icon_primary_invariably--hover: #3b3b3b;\n  --vkui--color_icon_primary_invariably--active: #434343;\n  --vkui--color_icon_medium: #939393;\n  --vkui--color_icon_medium--hover: #979797;\n  --vkui--color_icon_medium--active: #9c9c9c;\n  --vkui--color_icon_medium_alpha: hsla(0, 0%, 100%, .48);\n  --vkui--color_icon_medium_alpha--hover: hsla(0, 0%, 100%, .52);\n  --vkui--color_icon_medium_alpha--active: hsla(0, 0%, 100%, .56);\n  --vkui--color_icon_secondary: #828282;\n  --vkui--color_icon_secondary--hover: #878787;\n  --vkui--color_icon_secondary--active: #8c8c8c;\n  --vkui--color_icon_secondary_alpha: hsla(0, 0%, 100%, .4);\n  --vkui--color_icon_secondary_alpha--hover: hsla(0, 0%, 100%, .44);\n  --vkui--color_icon_secondary_alpha--active: hsla(0, 0%, 100%, .48);\n  --vkui--color_icon_tertiary: #656565;\n  --vkui--color_icon_tertiary--hover: #6b6b6b;\n  --vkui--color_icon_tertiary--active: #717171;\n  --vkui--color_icon_tertiary_alpha: hsla(0, 0%, 100%, .24);\n  --vkui--color_icon_tertiary_alpha--hover: hsla(0, 0%, 100%, .28);\n  --vkui--color_icon_tertiary_alpha--active: hsla(0, 0%, 100%, .32);\n  --vkui--color_icon_contrast: #e1e3e6;\n  --vkui--color_icon_contrast--hover: #e2e4e7;\n  --vkui--color_icon_contrast--active: #e3e5e8;\n  --vkui--color_icon_contrast_themed: #222;\n  --vkui--color_icon_contrast_themed--hover: #2b2b2b;\n  --vkui--color_icon_contrast_themed--active: #343434;\n  --vkui--color_icon_negative: #ff5c5c;\n  --vkui--color_stroke_accent: #71aaeb;\n  --vkui--color_stroke_accent--hover: #77adec;\n  --vkui--color_stroke_accent--active: #7cb1ed;\n  --vkui--color_stroke_accent_themed: #e1e3e6;\n  --vkui--color_stroke_accent_themed--hover: #e2e4e7;\n  --vkui--color_stroke_accent_themed--active: #e3e5e8;\n  --vkui--color_separator_secondary: #292929;\n  --vkui--color_separator_secondary--hover: #323232;\n  --vkui--color_separator_secondary--active: #3a3a3a;\n  --vkui--color_stroke_negative: #ff5c5c;\n  --vkui--color_accent_blue: #397dcc;\n  --vkui--color_accent_blue--hover: #4182ce;\n  --vkui--color_accent_blue--active: #4987d0;\n  --vkui--color_accent_gray--hover: #b1bac4;\n  --vkui--color_accent_gray--active: #b4bdc7;\n  --vkui--color_accent_purple: #937ff5;\n  --vkui--color_accent_purple--hover: #9784f5;\n  --vkui--color_accent_purple--active: #9c89f6;\n  --vkui--color_accent_violet: #a393f5;\n  --vkui--color_accent_violet--hover: #a797f5;\n  --vkui--color_accent_violet--active: #aa9cf6;\n  --vkui--color_skeleton_from: #292929;\n  --vkui--color_skeleton_from--hover: #323232;\n  --vkui--color_skeleton_from--active: #3a3a3a;\n  --vkui--color_skeleton_to: #333;\n  --vkui--color_skeleton_to--hover: #3b3b3b;\n  --vkui--color_skeleton_to--active: #434343;\n  --vkui--color_button_text: #e1e3e6;\n  --vkui--color_button_text--hover: #e2e4e7;\n  --vkui--color_button_text--active: #e3e5e8;\n  --vkui--color_button_icon: #e1e3e6;\n  --vkui--color_button_icon--hover: #e2e4e7;\n  --vkui--color_button_icon--active: #e3e5e8;\n  --vkui--color_button_stroke: #e1e3e6;\n  --vkui--color_button_stroke--hover: #e2e4e7;\n  --vkui--color_button_stroke--active: #e3e5e8;\n  --vkui--color_write_bar_icon: #e1e3e6;\n  --vkui--color_write_bar_icon--hover: #e2e4e7;\n  --vkui--color_write_bar_icon--active: #e3e5e8;\n  --vkui--color_write_bar_input_background: #424242;\n  --vkui--color_write_bar_input_background--hover: #4a4a4a;\n  --vkui--color_write_bar_input_background--active: #515151;\n  --vkui--color_write_bar_input_border: #555;\n  --vkui--color_write_bar_input_border--hover: #5c5c5c;\n  --vkui--color_write_bar_input_border--active: #636363;\n  --vkui--color_track_background: #828282;\n  --vkui--color_track_background--hover: #878787;\n  --vkui--color_track_background--active: #8c8c8c;\n  --vkui--color_track_buffer: #fff;\n  --vkui--color_track_buffer--hover: #ebedf0;\n  --vkui--color_track_buffer--active: #d7d8db;\n  --vkui--color_search_field_background: #424242;\n  --vkui--color_search_field_background--hover: #4a4a4a;\n  --vkui--color_search_field_background--active: #515151;\n  --vkui--color_panel_header_icon: #71aaeb\n}\n\n:root {\n  --vkui_internal--tabbar_height: 48px;\n  --vkui_internal--grid_avatar_image_offset: 2px;\n  --vkui_internal--slider_thumb_size: 28px;\n  --vkui_internal--side_cell_gap: calc(var(--vkui--size_base_padding_horizontal--regular) - var(--vkui--spacing_size_s));\n  --vkui_internal--popover_safe_zone_padding: 8px;\n  --vkui_internal--white: #fff;\n  --vkui_internal--safe_area_inset_top: 0px;\n  --vkui_internal--safe_area_inset_right: 0px;\n  --vkui_internal--safe_area_inset_bottom: 0px;\n  --vkui_internal--safe_area_inset_left: 0px;\n  --vkui_internal--duration: 0.7s;\n  --vkui_internal--z_index_cell_dragging: 1;\n  --vkui_internal--z_index_tabs: 2;\n  --vkui_internal--z_index_fixed_layout: 3;\n  --vkui_internal--z_index_panel_header_context: 4;\n  --vkui_internal--z_index_panel_header_fade: 5;\n  --vkui_internal--z_index_pull_to_refresh: 9;\n  --vkui_internal--z_index_panel_header: 10;\n  --vkui_internal--z_index_split_layout_panel_header: 11;\n  --vkui_internal--z_index_tappable_state: 0;\n  --vkui_internal--z_index_tappable_element: 1;\n  --vkui_internal--z_index_banner_background: 0;\n  --vkui_internal--z_index_banner_content: 1;\n  --vkui_internal--z_index_banner_hover: 2;\n  --vkui_internal--z_index_form_field_element: 1;\n  --vkui_internal--z_index_form_field_border: 2;\n  --vkui_internal--z_index_form_field_status: 3;\n  --vkui_internal--z_index_form_field_border_hover: 4;\n  --vkui_internal--z_index_form_field_focus: 5;\n  --vkui_internal--z_index_form_field_side: 6;\n  --vkui_internal--z_index_image_base_overlay: 0;\n  --vkui_internal--z_index_image_base_border: 1;\n  --vkui_internal--z_index_image_base_badge: 2;\n  --vkui_internal--z_index_horizontal_scroll_arrow: 1\n}\n\n@supports (padding-top:constant(safe-area-inset-top)) {\n  :root {\n    --vkui_internal--safe_area_inset_top: constant(safe-area-inset-top);\n    --vkui_internal--safe_area_inset_right: constant(safe-area-inset-right);\n    --vkui_internal--safe_area_inset_bottom: constant(safe-area-inset-bottom);\n    --vkui_internal--safe_area_inset_left: constant(safe-area-inset-left)\n  }\n}\n\n@supports (padding-top:env(safe-area-inset-top)) {\n  :root {\n    --vkui_internal--safe_area_inset_top: env(safe-area-inset-top);\n    --vkui_internal--safe_area_inset_right: env(safe-area-inset-right);\n    --vkui_internal--safe_area_inset_bottom: env(safe-area-inset-bottom);\n    --vkui_internal--safe_area_inset_left: env(safe-area-inset-left)\n  }\n}\n\n@media (min-width:768px) {\n  .vkui-sizeX--compact-mq {\n    display: none !important\n  }\n}\n\n@media (max-width:767.9px) {\n  .vkui-sizeX--regular-mq {\n    display: none !important\n  }\n}\n\n@media (max-width:767.9px) and (min-height:415px),\n(pointer:coarse) and (min-height:415px),\n(pointer:none) and (min-height:415px) {\n  .vkui-sizeY--compact-mq {\n    display: none !important\n  }\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkui-sizeY--regular-mq {\n    display: none !important\n  }\n}\n\n@media (min-width:1024px) {\n  .vkui-viewWidth--tabletMinus-mq {\n    display: none !important\n  }\n}\n\n@media (max-width:1023.9px) {\n  .vkui-viewWidth--tabletPlus-mq {\n    display: none !important\n  }\n}\n\n.vkui-deviceType--desktop-forced,\n.vkui-deviceType--mobile-forced {\n  display: none !important\n}\n\n@media (min-width:768px) and (min-height:720px),\n(min-width:768px) and (pointer:fine) {\n  .vkui-deviceType--mobile-mq {\n    display: none !important\n  }\n}\n\n@media (max-width:767.9px),\n(pointer:coarse) and (max-height:719.9px),\n(pointer:none) and (max-height:719.9px) {\n  .vkui-deviceType--desktop-mq {\n    display: none !important\n  }\n}\n\n* {\n  --vkui--size_border--regular: var(--vkui--size_border1x--regular)\n}\n\n@media (-webkit-min-device-pixel-ratio:2),\n(min-resolution:2dppx) {\n  * {\n    --vkui--size_border--regular: var(--vkui--size_border2x--regular);\n    --vkui--color_separator_primary: var(--vkui--color_separator_primary2x)\n  }\n}\n\n@media (-webkit-min-device-pixel-ratio:3),\n(min-resolution:3dppx) {\n  * {\n    --vkui--size_border--regular: var(--vkui--size_border3x--regular);\n    --vkui--color_separator_primary: var(--vkui--color_separator_primary3x)\n  }\n}\n\n.vkuiAppRoot {\n  height: 100%\n}\n\n.vkuiAppRoot--pointer-has-not {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none\n}\n\n.vkuiAppRoot--pointer-has-not [contenteditable] {\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text\n}\n\n@media (pointer:coarse),\n(pointer:none) {\n  .vkuiAppRoot--pointer-none {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none\n  }\n\n  .vkuiAppRoot--pointer-none [contenteditable] {\n    -webkit-user-select: text;\n    -moz-user-select: text;\n    -ms-user-select: text;\n    user-select: text\n  }\n}\n\n.vkui__root--embedded .vkuiAppRoot {\n  overflow: auto\n}\n\n.vkuiTitle--level-1 {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_title1--font_family--regular);\n  font-size: 24px;\n  font-size: var(--vkui--font_title1--font_size--regular);\n  font-weight: 600;\n  font-weight: var(--vkui--font_title1--font_weight--regular);\n  line-height: 28px;\n  line-height: var(--vkui--font_title1--line_height--regular)\n}\n\n.vkuiTitle--level-2 {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_title2--font_family--regular);\n  font-size: 20px;\n  font-size: var(--vkui--font_title2--font_size--regular);\n  font-weight: 600;\n  font-weight: var(--vkui--font_title2--font_weight--regular);\n  line-height: 24px;\n  line-height: var(--vkui--font_title2--line_height--regular)\n}\n\n.vkuiTitle--level-3 {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_title3--font_family--regular);\n  font-size: 17px;\n  font-size: var(--vkui--font_title3--font_size--regular);\n  font-weight: 600;\n  font-weight: var(--vkui--font_title3--font_weight--regular);\n  line-height: 22px;\n  line-height: var(--vkui--font_title3--line_height--regular)\n}\n\n.vkuiTypography--normalize {\n  display: block;\n  margin: 0;\n  padding: 0\n}\n\n.vkuiTypography--weight-1.vkuiTypography--weight-1.vkuiTypography--weight-1 {\n  font-weight: 600;\n  font-weight: var(--vkui--font_weight_accent1)\n}\n\n.vkuiTypography--weight-2.vkuiTypography--weight-2.vkuiTypography--weight-2 {\n  font-weight: 500;\n  font-weight: var(--vkui--font_weight_accent2)\n}\n\n.vkuiTypography--weight-3.vkuiTypography--weight-3.vkuiTypography--weight-3 {\n  font-weight: 400;\n  font-weight: var(--vkui--font_weight_accent3)\n}\n\n.vkuiTypography b {\n  font-weight: 600;\n  font-weight: var(--vkui--font_weight_accent1)\n}\n\n.vkuiHeadline--level-1 {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_headline1--font_family--regular);\n  font-size: 16px;\n  font-size: var(--vkui--font_headline1--font_size--regular);\n  font-weight: 500;\n  font-weight: var(--vkui--font_headline1--font_weight--regular);\n  line-height: 20px;\n  line-height: var(--vkui--font_headline1--line_height--regular)\n}\n\n.vkuiHeadline--sizeY-compact.vkuiHeadline--level-1 {\n  font-size: 15px;\n  font-size: var(--vkui--font_headline1--font_size--compact);\n  line-height: 20px;\n  line-height: var(--vkui--font_headline1--line_height--compact)\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiHeadline--sizeY-none.vkuiHeadline--level-1 {\n    font-size: 15px;\n    font-size: var(--vkui--font_headline1--font_size--compact);\n    line-height: 20px;\n    line-height: var(--vkui--font_headline1--line_height--compact)\n  }\n}\n\n.vkuiHeadline--level-2 {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_headline2--font_family--regular);\n  font-size: 15px;\n  font-size: var(--vkui--font_headline2--font_size--regular);\n  font-weight: 500;\n  font-weight: var(--vkui--font_headline2--font_weight--regular);\n  line-height: 20px;\n  line-height: var(--vkui--font_headline2--line_height--regular)\n}\n\n.vkuiHeadline--sizeY-compact.vkuiHeadline--level-2 {\n  font-size: 14px;\n  font-size: var(--vkui--font_headline2--font_size--compact);\n  line-height: 20px;\n  line-height: var(--vkui--font_headline2--line_height--compact)\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiHeadline--sizeY-none.vkuiHeadline--level-2 {\n    font-size: 14px;\n    font-size: var(--vkui--font_headline2--font_size--compact);\n    line-height: 20px;\n    line-height: var(--vkui--font_headline2--line_height--compact)\n  }\n}\n\n.vkuiText {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_text--font_family--regular);\n  font-size: 16px;\n  font-size: var(--vkui--font_text--font_size--regular);\n  font-weight: 400;\n  font-weight: var(--vkui--font_text--font_weight--regular);\n  line-height: 20px;\n  line-height: var(--vkui--font_text--line_height--regular)\n}\n\n.vkuiText--sizeY-compact {\n  font-size: 15px;\n  font-size: var(--vkui--font_text--font_size--compact);\n  line-height: 20px;\n  line-height: var(--vkui--font_text--line_height--compact)\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiText--sizeY-none {\n    font-size: 15px;\n    font-size: var(--vkui--font_text--font_size--compact);\n    line-height: 20px;\n    line-height: var(--vkui--font_text--line_height--compact)\n  }\n}\n\n.vkuiParagraph {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_paragraph--font_family--regular);\n  font-size: 15px;\n  font-size: var(--vkui--font_paragraph--font_size--regular);\n  font-weight: 400;\n  font-weight: var(--vkui--font_paragraph--font_weight--regular);\n  line-height: 20px;\n  line-height: var(--vkui--font_paragraph--line_height--regular)\n}\n\n.vkuiSubhead {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_subhead--font_family--regular);\n  font-size: 14px;\n  font-size: var(--vkui--font_subhead--font_size--regular);\n  font-weight: 400;\n  font-weight: var(--vkui--font_subhead--font_weight--regular);\n  line-height: 18px;\n  line-height: var(--vkui--font_subhead--line_height--regular)\n}\n\n.vkuiSubhead--sizeY-compact {\n  font-size: 13px;\n  font-size: var(--vkui--font_subhead--font_size--compact);\n  line-height: 16px;\n  line-height: var(--vkui--font_subhead--line_height--compact)\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiSubhead--sizeY-none {\n    font-size: 13px;\n    font-size: var(--vkui--font_subhead--font_size--compact);\n    line-height: 16px;\n    line-height: var(--vkui--font_subhead--line_height--compact)\n  }\n}\n\n.vkuiFootnote {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_footnote--font_family--regular);\n  font-size: 13px;\n  font-size: var(--vkui--font_footnote--font_size--regular);\n  font-weight: 400;\n  font-weight: var(--vkui--font_footnote--font_weight--regular);\n  line-height: 16px;\n  line-height: var(--vkui--font_footnote--line_height--regular)\n}\n\n.vkuiFootnote--caps {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_footnote_caps--font_family--regular);\n  font-size: 13px;\n  font-size: var(--vkui--font_footnote_caps--font_size--regular);\n  font-weight: 400;\n  font-weight: var(--vkui--font_footnote_caps--font_weight--regular);\n  line-height: 16px;\n  line-height: var(--vkui--font_footnote_caps--line_height--regular);\n  text-transform: uppercase\n}\n\n.vkuiCaption--caps {\n  text-transform: uppercase\n}\n\n.vkuiCaption--level-1 {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_caption1--font_family--regular);\n  font-size: 12px;\n  font-size: var(--vkui--font_caption1--font_size--regular);\n  font-weight: 400;\n  font-weight: var(--vkui--font_caption1--font_weight--regular);\n  line-height: 14px;\n  line-height: var(--vkui--font_caption1--line_height--regular)\n}\n\n.vkuiCaption--level-1.vkuiCaption--caps {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_caption1_caps--font_family--regular);\n  font-size: 12px;\n  font-size: var(--vkui--font_caption1_caps--font_size--regular);\n  font-weight: 600;\n  font-weight: var(--vkui--font_caption1_caps--font_weight--regular);\n  line-height: 14px;\n  line-height: var(--vkui--font_caption1_caps--line_height--regular)\n}\n\n.vkuiCaption--level-2 {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_caption2--font_family--regular);\n  font-size: 11px;\n  font-size: var(--vkui--font_caption2--font_size--regular);\n  font-weight: 400;\n  font-weight: var(--vkui--font_caption2--font_weight--regular);\n  line-height: 14px;\n  line-height: var(--vkui--font_caption2--line_height--regular)\n}\n\n.vkuiCaption--level-2.vkuiCaption--caps {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_caption2_caps--font_family--regular);\n  font-size: 11px;\n  font-size: var(--vkui--font_caption2_caps--font_size--regular);\n  font-weight: 600;\n  font-weight: var(--vkui--font_caption2_caps--font_weight--regular);\n  line-height: 14px;\n  line-height: var(--vkui--font_caption2_caps--line_height--regular)\n}\n\n.vkuiCaption--level-3 {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_caption3--font_family--regular);\n  font-size: 9px;\n  font-size: var(--vkui--font_caption3--font_size--regular);\n  font-weight: 400;\n  font-weight: var(--vkui--font_caption3--font_weight--regular);\n  line-height: 12px;\n  line-height: var(--vkui--font_caption3--line_height--regular)\n}\n\n.vkuiCaption--level-3.vkuiCaption--caps {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_caption3_caps--font_family--regular);\n  font-size: 9px;\n  font-size: var(--vkui--font_caption3_caps--font_size--regular);\n  font-weight: 600;\n  font-weight: var(--vkui--font_caption3_caps--font_weight--regular);\n  line-height: 12px;\n  line-height: var(--vkui--font_caption3_caps--line_height--regular)\n}\n\n.vkuiTappable {\n  -webkit-tap-highlight-color: transparent;\n  border-radius: 8px;\n  border-radius: var(--vkui--size_border_radius--regular);\n  cursor: default;\n  isolation: isolate;\n  position: relative;\n  transition: background-color .15s ease-out, opacity .15s ease-out\n}\n\n.vkuiTappable>* {\n  position: relative;\n  z-index: 1;\n  z-index: var(--vkui_internal--z_index_tappable_element)\n}\n\n.vkuiTappable--hasActive,\n.vkuiTappable--hasHover {\n  cursor: pointer\n}\n\n.vkuiTappable[aria-disabled=true],\n.vkuiTappable[disabled] {\n  cursor: default\n}\n\n.vkuiTappable--focus-visible,\n.vkuiTappable:focus,\n.vkuiTappable:focus-visible {\n  outline: none\n}\n\n.vkuiTappable__stateLayer {\n  border-radius: inherit;\n  bottom: 0;\n  left: 0;\n  overflow: hidden;\n  pointer-events: none;\n  position: absolute;\n  right: 0;\n  top: 0;\n  transition: background-color .15s ease-out;\n  z-index: 0;\n  z-index: var(--vkui_internal--z_index_tappable_state)\n}\n\n.vkuiTappable--hover-background>.vkuiTappable__stateLayer {\n  background-color: rgba(0, 16, 61, .04);\n  background-color: var(--vkui--color_transparent--hover)\n}\n\n.vkuiTappable--hover-opacity {\n  opacity: .8\n}\n\n.vkuiTappable--active-background>.vkuiTappable__stateLayer {\n  background-color: rgba(0, 16, 61, .08);\n  background-color: var(--vkui--color_transparent--active)\n}\n\n.vkuiTappable--active-opacity {\n  opacity: .7\n}\n\n.vkuiTappable--ios.vkuiTappable--active-background {\n  transition: none\n}\n\n.vkuiTappable .vkuiTappable__waves {\n  border-radius: inherit;\n  bottom: 0;\n  left: 0;\n  overflow: hidden;\n  pointer-events: none;\n  position: absolute;\n  right: 0;\n  top: 0;\n  will-change: transform;\n  z-index: 0;\n  z-index: var(--vkui_internal--z_index_tappable_state)\n}\n\n.vkuiTappable .vkuiTappable__wave {\n  animation: vkuianimation-wave .3s cubic-bezier(.4, 0, .2, 1);\n  animation: vkuianimation-wave .3s var(--vkui--animation_easing_platform);\n  background: rgba(0, 16, 61, .08);\n  background: var(--vkui--color_transparent--active);\n  border-radius: 50%;\n  content: \"\";\n  height: 24px;\n  left: 0;\n  margin: -12px 0 0 -12px;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  width: 24px\n}\n\n.vkuiTappable--sizeX-compact {\n  border-radius: 0\n}\n\n@media (max-width:767.9px) {\n  .vkuiTappable--sizeX-none {\n    border-radius: 0\n  }\n}\n\n.vkuiTappable.vkuiTappable--borderRadiusInherit {\n  border-radius: inherit\n}\n\n@keyframes vkuianimation-wave {\n  0% {\n    opacity: 1;\n    transform: scale(1)\n  }\n\n  30% {\n    opacity: 1\n  }\n\n  to {\n    opacity: 0;\n    transform: scale(8)\n  }\n}\n\n.vkuiFocusVisible {\n  border-radius: inherit;\n  bottom: 0;\n  bottom: var(--vkui_internal--focus_visible_distance, 0);\n  left: 0;\n  left: var(--vkui_internal--focus_visible_distance, 0);\n  overflow: hidden;\n  pointer-events: none;\n  position: absolute;\n  right: 0;\n  right: var(--vkui_internal--focus_visible_distance, 0);\n  top: 0;\n  top: var(--vkui_internal--focus_visible_distance, 0);\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  visibility: hidden\n}\n\n.vkuiFocusVisible--visible {\n  visibility: visible\n}\n\n.vkuiFocusVisible.vkuiFocusVisible {\n  position: absolute\n}\n\n.vkuiFocusVisible {\n  --vkui_internal--focus_visible_thin: 2px\n}\n\n.vkuiFocusVisible--thin {\n  --vkui_internal--focus_visible_thin: var(--vkui--size_border--regular)\n}\n\n.vkuiFocusVisible--mode-inside,\n.vkuiFocusVisible--mode-outline {\n  border-color: #2688eb;\n  border-color: var(--vkui--color_stroke_accent);\n  border-style: solid;\n  border-width: var(--vkui_internal--focus_visible_thin);\n  box-sizing: border-box\n}\n\n.vkuiFocusVisible--mode-outline {\n  --vkui_internal--focus_visible_distance: 0\n}\n\n.vkuiFocusVisible--mode-inside {\n  --vkui_internal--focus_visible_distance: 2px\n}\n\n.vkuiFocusVisible--mode-outside {\n  --vkui_internal--focus_visible_distance: -2px;\n  box-shadow: 0 0 0 var(--vkui_internal--focus_visible_thin) #2688eb;\n  box-shadow: 0 0 0 var(--vkui_internal--focus_visible_thin) var(--vkui--color_stroke_accent)\n}\n\n@media (prefers-reduced-motion:no-preference) {\n  .vkuiFocusVisible--visible.vkuiFocusVisible--mode-inside {\n    --vkui_internal--focus_visible_distance: 4px;\n    animation: vkuianimation-focus-visible .15s ease-in-out forwards;\n    animation-delay: .01ms;\n    will-change: top, left, bottom, right\n  }\n\n  .vkuiFocusVisible--visible.vkuiFocusVisible--mode-outside {\n    --vkui_internal--focus_visible_distance: 0;\n    animation-name: vkuianimation-focus-visible-outside\n  }\n}\n\n@keyframes vkuianimation-focus-visible {\n  to {\n    bottom: 0;\n    left: 0;\n    right: 0;\n    top: 0;\n    will-change: auto\n  }\n}\n\n@keyframes vkuianimation-focus-visible-outside {\n  to {\n    bottom: -2px;\n    left: -2px;\n    right: -2px;\n    top: -2px;\n    will-change: auto\n  }\n}\n\n.vkuiFixedLayout {\n  box-sizing: border-box;\n  left: auto;\n  padding-left: 0;\n  padding-left: var(--vkui_internal--safe_area_inset_left);\n  padding-right: 0;\n  padding-right: var(--vkui_internal--safe_area_inset_right);\n  position: fixed;\n  z-index: 3;\n  z-index: var(--vkui_internal--z_index_fixed_layout)\n}\n\n.vkuiFixedLayout--filled {\n  background: #fff;\n  background: var(--vkui--color_background_content)\n}\n\n.vkuiFixedLayout--vertical-top {\n  top: 0;\n  width: 100%\n}\n\n.vkuiFixedLayout--vertical-bottom {\n  bottom: 0;\n  padding-bottom: 0;\n  padding-bottom: var(--vkui_internal--safe_area_inset_bottom);\n  width: 100%\n}\n\n.vkuiInternalEpic--hasTabbar .vkuiFixedLayout--vertical-bottom {\n  padding-bottom: calc(48px + 0px);\n  padding-bottom: calc(var(--vkui_internal--tabbar_height) + var(--vkui_internal--safe_area_inset_bottom))\n}\n\n.vkuiInternalPanelHeader~* .vkuiFixedLayout--vertical-top:not(.vkuiInternalPanelHeader__fixed),\n.vkuiInternalPanelHeader~.vkuiFixedLayout--vertical-top {\n  top: calc(56px + 0px);\n  top: calc(var(--vkui--size_panel_header_height--regular) + var(--vkui_internal--safe_area_inset_top))\n}\n\n.vkuiImageBase {\n  align-items: center;\n  background-color: #f5f5f5;\n  background-color: var(--vkui--color_background_secondary);\n  background-size: cover;\n  box-sizing: border-box;\n  color: #99a2ad;\n  color: var(--vkui_internal--icon_color, var(--vkui--color_icon_secondary));\n  display: flex;\n  flex-shrink: 0;\n  isolation: isolate;\n  justify-content: center;\n  position: relative\n}\n\n.vkuiImageBase__border {\n  border: var(--vkui--size_border--regular) solid var(--vkui--color_image_border_alpha);\n  border-radius: inherit;\n  box-sizing: border-box;\n  pointer-events: none;\n  transform-origin: left top;\n  z-index: 1;\n  z-index: var(--vkui_internal--z_index_image_base_border)\n}\n\n.vkuiImageBase__border,\n.vkuiImageBase__img {\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%\n}\n\n.vkuiImageBase__img {\n  border: 0;\n  border-radius: inherit;\n  display: block;\n  object-fit: cover;\n  visibility: hidden\n}\n\n.vkuiImageBase--loaded .vkuiImageBase__img {\n  visibility: visible\n}\n\n.vkuiImageBase__fallback {\n  left: auto;\n  position: absolute;\n  top: auto\n}\n\n.vkuiInternalPanelHeader__before .vkuiImageBase {\n  margin-left: 8px\n}\n\n.vkuiInternalPanelHeader__after .vkuiImageBase {\n  margin-right: 8px\n}\n\n.vkuiClickable__host {\n  cursor: pointer\n}\n\n.vkuiClickable__host:focus,\n.vkuiClickable__host:focus-visible {\n  outline: none\n}\n\n.vkuiImageBaseBadge {\n  border-radius: 50%;\n  bottom: 0;\n  padding: 2px;\n  position: absolute;\n  right: 0;\n  transform: translate(2px, 2px);\n  z-index: 2;\n  z-index: var(--vkui_internal--z_index_image_base_badge)\n}\n\n.vkuiImageBaseBadge--background-stroke {\n  background-color: #fff;\n  background-color: var(--vkui_internal--background, var(--vkui--color_background_content))\n}\n\n.vkuiImageBaseBadge--background-shadow:before {\n  border-radius: inherit;\n  bottom: 2px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .03), 0 2px 2px rgba(0, 0, 0, .06);\n  box-shadow: var(--vkui--elevation1);\n  content: \"\";\n  left: 2px;\n  margin: auto;\n  position: absolute;\n  right: 2px;\n  top: 2px\n}\n\n.vkuiImageBaseOverlay {\n  align-items: center;\n  border: 0;\n  border-radius: inherit;\n  box-shadow: inherit;\n  box-sizing: border-box;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  transition: opacity .3s ease-in-out;\n  width: 100%;\n  z-index: 0;\n  z-index: var(--vkui_internal--z_index_image_base_overlay)\n}\n\n.vkuiImageBaseOverlay--visible {\n  opacity: 1\n}\n\n.vkuiImageBaseOverlay--focus-visible {\n  box-shadow: inset 0 0 0 2px #2688eb;\n  box-shadow: inset 0 0 0 2px var(--vkui--color_stroke_accent);\n  opacity: 1\n}\n\n.vkuiImageBaseOverlay--theme-light {\n  background-color: hsla(0, 0%, 100%, .85);\n  background-color: var(--vkui--color_avatar_overlay_inverse_alpha);\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent)\n}\n\n.vkuiImageBaseOverlay--theme-dark {\n  background-color: rgba(0, 0, 0, .6);\n  background-color: var(--vkui--color_avatar_overlay);\n  color: #fff;\n  color: var(--vkui--color_icon_contrast)\n}\n\n.vkuiSpinner {\n  align-items: center;\n  color: #818c99;\n  color: var(--vkui--color_icon_medium);\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  width: 100%\n}\n\n.vkuiInternalPanelHeader .vkuiSpinner {\n  color: currentColor\n}\n\n.vkuiButton {\n  border: 0;\n  border-radius: 8px;\n  border-radius: var(--vkui--size_border_radius--regular);\n  box-sizing: border-box;\n  display: inline-block;\n  margin: 0;\n  max-width: 100%;\n  min-height: 28px;\n  min-height: var(--vkui--size_button_small_height--compact);\n  min-width: 80px;\n  min-width: var(--vkui--size_button_minimum_width--regular);\n  padding: 0;\n  position: relative;\n  text-decoration: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none\n}\n\n.vkuiButton--rounded {\n  border-radius: 48px;\n  border-radius: var(--vkui--size_border_radius_rounded--regular)\n}\n\n.vkuiButton--loading {\n  cursor: progress\n}\n\n.vkuiButton--singleIcon {\n  min-width: auto;\n  width: 28px;\n  width: var(--vkui--size_button_small_height--compact)\n}\n\n.vkuiButton--sizeY-regular.vkuiButton--singleIcon {\n  width: 30px;\n  width: var(--vkui--size_button_small_height--regular)\n}\n\n@media (max-width:767.9px) and (min-height:415px),\n(pointer:coarse) and (min-height:415px),\n(pointer:none) and (min-height:415px) {\n  .vkuiButton--sizeY-none.vkuiButton--singleIcon {\n    width: 30px;\n    width: var(--vkui--size_button_small_height--regular)\n  }\n}\n\n.vkuiButton--stretched {\n  display: block;\n  flex-basis: 0;\n  flex-grow: 1;\n  width: 100%\n}\n\n.vkuiButton__in {\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  min-height: inherit;\n  text-align: center;\n  width: 100%\n}\n\n.vkuiButton--align-left .vkuiButton__in {\n  justify-content: flex-start;\n  text-align: left\n}\n\n.vkuiButton--align-right .vkuiButton__in {\n  justify-content: flex-end;\n  text-align: right\n}\n\n.vkuiButton[disabled] {\n  opacity: .4;\n  opacity: var(--vkui--opacity_disable)\n}\n\n.vkuiButton--mode-outline[disabled]:not(.vkuiButton--appearance-overlay),\n.vkuiButton--mode-primary[disabled]:not(.vkuiButton--appearance-overlay):not(.vkuiButton--appearance-negative):not(.vkuiButton--appearance-positive),\n.vkuiButton--mode-secondary[disabled]:not(.vkuiButton--appearance-overlay),\n.vkuiButton--mode-tertiary[disabled]:not(.vkuiButton--appearance-overlay) {\n  opacity: .64\n}\n\n.vkuiButton__content {\n  font-weight: 500;\n  font-weight: var(--vkui--font_weight_accent2);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap\n}\n\n.vkuiButton--size-s .vkuiButton__content:first-child {\n  padding-left: 16px;\n  padding-left: var(--vkui--size_button_base_small_padding_horizontal--regular)\n}\n\n.vkuiButton--size-s .vkuiButton__after,\n.vkuiButton--size-s .vkuiButton__content:last-child {\n  padding-right: 16px;\n  padding-right: var(--vkui--size_button_base_small_padding_horizontal--regular)\n}\n\n.vkuiButton--size-m .vkuiButton__content:first-child {\n  padding-left: 16px;\n  padding-left: var(--vkui--size_button_base_medium_padding_horizontal--regular)\n}\n\n.vkuiButton--size-m .vkuiButton__after,\n.vkuiButton--size-m .vkuiButton__content:last-child {\n  padding-right: 16px;\n  padding-right: var(--vkui--size_button_base_medium_padding_horizontal--regular)\n}\n\n.vkuiButton--size-l .vkuiButton__content:first-child {\n  padding-left: 20px;\n  padding-left: var(--vkui--size_button_base_large_padding_horizontal--regular)\n}\n\n.vkuiButton--size-l .vkuiButton__after,\n.vkuiButton--size-l .vkuiButton__content:last-child {\n  padding-right: 20px;\n  padding-right: var(--vkui--size_button_base_large_padding_horizontal--regular)\n}\n\n.vkuiButton--size-s .vkuiButton__before {\n  padding-left: 12px;\n  padding-left: var(--vkui--size_button_base_small_padding_horizontal_icon--regular)\n}\n\n.vkuiButton--size-m .vkuiButton__before {\n  padding-left: 12px;\n  padding-left: var(--vkui--size_button_base_medium_padding_horizontal_icon--regular)\n}\n\n.vkuiButton--size-l .vkuiButton__before {\n  padding-left: 16px;\n  padding-left: var(--vkui--size_button_base_large_padding_horizontal_icon--regular)\n}\n\n.vkuiButton--mode-tertiary.vkuiButton--size-s .vkuiButton__content:first-child {\n  padding-left: 12px;\n  padding-left: var(--vkui--size_button_tertiary_small_padding_horizontal--regular)\n}\n\n.vkuiButton--mode-tertiary.vkuiButton--size-s .vkuiButton__after,\n.vkuiButton--mode-tertiary.vkuiButton--size-s .vkuiButton__content:last-child {\n  padding-right: 12px;\n  padding-right: var(--vkui--size_button_tertiary_small_padding_horizontal--regular)\n}\n\n.vkuiButton--mode-tertiary.vkuiButton--size-m .vkuiButton__content:first-child {\n  padding-left: 12px;\n  padding-left: var(--vkui--size_button_tertiary_medium_padding_horizontal--regular)\n}\n\n.vkuiButton--mode-tertiary.vkuiButton--size-m .vkuiButton__after,\n.vkuiButton--mode-tertiary.vkuiButton--size-m .vkuiButton__content:last-child {\n  padding-right: 12px;\n  padding-right: var(--vkui--size_button_tertiary_medium_padding_horizontal--regular)\n}\n\n.vkuiButton--mode-tertiary.vkuiButton--size-l .vkuiButton__content:first-child {\n  padding-left: 16px;\n  padding-left: var(--vkui--size_button_tertiary_large_padding_horizontal--regular)\n}\n\n.vkuiButton--mode-tertiary.vkuiButton--size-l .vkuiButton__after,\n.vkuiButton--mode-tertiary.vkuiButton--size-l .vkuiButton__content:last-child {\n  padding-right: 16px;\n  padding-right: var(--vkui--size_button_tertiary_large_padding_horizontal--regular)\n}\n\n.vkuiButton--mode-tertiary.vkuiButton--size-s .vkuiButton__before {\n  padding-left: 8px;\n  padding-left: var(--vkui--size_button_tertiary_small_padding_horizontal_icon--regular)\n}\n\n.vkuiButton--mode-tertiary.vkuiButton--size-m .vkuiButton__before {\n  padding-left: 8px;\n  padding-left: var(--vkui--size_button_tertiary_medium_padding_horizontal_icon--regular)\n}\n\n.vkuiButton--mode-tertiary.vkuiButton--size-l .vkuiButton__before {\n  padding-left: 12px;\n  padding-left: var(--vkui--size_button_tertiary_large_padding_horizontal_icon--regular)\n}\n\n.vkuiButton--mode-tertiary.vkuiButton--singleIcon .vkuiButton__after,\n.vkuiButton--mode-tertiary.vkuiButton--singleIcon .vkuiButton__before,\n.vkuiButton--singleIcon .vkuiButton__after,\n.vkuiButton--singleIcon .vkuiButton__before {\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 0;\n  padding-right: 0\n}\n\n.vkuiButton--mode-link {\n  background: none;\n  min-width: auto\n}\n\n.vkuiButton--mode-link .vkuiButton__after,\n.vkuiButton--mode-link .vkuiButton__before,\n.vkuiButton--mode-link .vkuiButton__content:first-child,\n.vkuiButton--mode-link .vkuiButton__content:last-child,\n.vkuiButton--stretched .vkuiButton__after:only-child,\n.vkuiButton--stretched .vkuiButton__before:only-child {\n  padding-left: 0;\n  padding-right: 0\n}\n\n.vkuiButton__spinner {\n  bottom: 0;\n  color: currentColor;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0\n}\n\n.vkuiButton__spinner+.vkuiButton__in {\n  visibility: hidden\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-accent {\n  background-color: #2688eb;\n  background-color: var(--vkui--color_background_accent_themed)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-accent.vkuiButton--hover {\n  background-color: #2483e4;\n  background-color: var(--vkui--color_background_accent_themed--hover)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-accent.vkuiButton--active {\n  background-color: #237edd;\n  background-color: var(--vkui--color_background_accent_themed--active)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-positive {\n  background-color: #4bb34b;\n  background-color: var(--vkui--color_background_positive)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-positive.vkuiButton--hover {\n  background-color: #48ac4a;\n  background-color: var(--vkui--color_background_positive--hover)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-positive.vkuiButton--active {\n  background-color: #45a64a;\n  background-color: var(--vkui--color_background_positive--active)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-negative {\n  background-color: #e64646;\n  background-color: var(--vkui--color_background_negative)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-negative.vkuiButton--hover {\n  background-color: #dd4446;\n  background-color: var(--vkui--color_background_negative--hover)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-negative.vkuiButton--active {\n  background-color: #d44245;\n  background-color: var(--vkui--color_background_negative--active)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-neutral {\n  background-color: #f5f5f5;\n  background-color: var(--vkui--color_background_secondary)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-neutral.vkuiButton--hover {\n  background-color: #ebecee;\n  background-color: var(--vkui--color_background_secondary--hover)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-neutral.vkuiButton--active {\n  background-color: #e1e3e6;\n  background-color: var(--vkui--color_background_secondary--active)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-accent-invariable {\n  background-color: #2688eb;\n  background-color: var(--vkui--color_background_accent)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-accent-invariable.vkuiButton--hover {\n  background-color: #2483e4;\n  background-color: var(--vkui--color_background_accent--hover)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-accent-invariable.vkuiButton--active {\n  background-color: #237edd;\n  background-color: var(--vkui--color_background_accent--active)\n}\n\n.vkuiButton--mode-secondary {\n  background-color: rgba(0, 0, 0, .04);\n  background-color: var(--vkui--color_background_secondary_alpha)\n}\n\n.vkuiButton--mode-secondary.vkuiButton--hover {\n  background-color: rgba(0, 0, 0, .08);\n  background-color: var(--vkui--color_background_secondary_alpha--hover)\n}\n\n.vkuiButton--mode-secondary.vkuiButton--active {\n  background-color: rgba(0, 0, 0, .12);\n  background-color: var(--vkui--color_background_secondary_alpha--active)\n}\n\n.vkuiButton--mode-outline,\n.vkuiButton--mode-tertiary {\n  background-color: initial;\n  background-color: var(--vkui--color_transparent)\n}\n\n.vkuiButton--mode-outline.vkuiButton--hover,\n.vkuiButton--mode-tertiary.vkuiButton--hover {\n  background-color: rgba(0, 16, 61, .04);\n  background-color: var(--vkui--color_transparent--hover)\n}\n\n.vkuiButton--mode-outline.vkuiButton--active,\n.vkuiButton--mode-tertiary.vkuiButton--active {\n  background-color: rgba(0, 16, 61, .08);\n  background-color: var(--vkui--color_transparent--active)\n}\n\n.vkuiButton.vkuiButton--appearance-accent {\n  color: #2688eb;\n  color: var(--vkui--color_text_accent_themed)\n}\n\n.vkuiButton.vkuiButton--appearance-positive {\n  color: #4bb34b;\n  color: var(--vkui--color_text_positive)\n}\n\n.vkuiButton.vkuiButton--appearance-negative {\n  color: #e64646;\n  color: var(--vkui--color_text_negative)\n}\n\n.vkuiButton.vkuiButton--appearance-neutral {\n  color: #000;\n  color: var(--vkui--color_text_primary)\n}\n\n.vkuiButton.vkuiButton--appearance-accent-invariable {\n  color: #2688eb;\n  color: var(--vkui--color_text_accent)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-accent {\n  color: #fff;\n  color: var(--vkui--color_text_contrast_themed)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-accent-invariable,\n.vkuiButton--mode-primary.vkuiButton--appearance-negative,\n.vkuiButton--mode-primary.vkuiButton--appearance-positive {\n  color: #fff;\n  color: var(--vkui--color_text_contrast)\n}\n\n.vkuiButton--mode-link.vkuiButton--hover {\n  opacity: .8\n}\n\n.vkuiButton--mode-link.vkuiButton--active {\n  opacity: .7\n}\n\n.vkuiButton--mode-outline.vkuiButton--appearance-accent,\n.vkuiButton--mode-outline.vkuiButton--appearance-accent.vkuiButton--active,\n.vkuiButton--mode-outline.vkuiButton--appearance-accent.vkuiButton--hover {\n  box-shadow: inset 0 0 0 1px #2688eb;\n  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_accent_themed)\n}\n\n.vkuiButton--mode-outline.vkuiButton--appearance-positive {\n  box-shadow: inset 0 0 0 1px #4bb34b;\n  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_positive)\n}\n\n.vkuiButton--mode-outline.vkuiButton--appearance-positive.vkuiButton--hover {\n  box-shadow: inset 0 0 0 1px #48ac4a;\n  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_positive--hover)\n}\n\n.vkuiButton--mode-outline.vkuiButton--appearance-positive.vkuiButton--active {\n  box-shadow: inset 0 0 0 1px #45a64a;\n  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_positive--active)\n}\n\n.vkuiButton--mode-outline.vkuiButton--appearance-negative {\n  box-shadow: inset 0 0 0 1px #e64646;\n  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_negative)\n}\n\n.vkuiButton--mode-outline.vkuiButton--appearance-negative.vkuiButton--hover {\n  box-shadow: inset 0 0 0 1px #dd4446;\n  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_negative--hover)\n}\n\n.vkuiButton--mode-outline.vkuiButton--appearance-negative.vkuiButton--active {\n  box-shadow: inset 0 0 0 1px #d44245;\n  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_negative--active)\n}\n\n.vkuiButton--mode-outline.vkuiButton--appearance-neutral {\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .12);\n  box-shadow: inset 0 0 0 1px var(--vkui--color_field_border_alpha)\n}\n\n.vkuiButton--mode-outline.vkuiButton--appearance-neutral.vkuiButton--hover {\n  background-color: #ebecee;\n  background-color: var(--vkui--color_background_secondary--hover);\n  box-shadow: unset\n}\n\n.vkuiButton--mode-outline.vkuiButton--appearance-neutral.vkuiButton--active {\n  background-color: #e1e3e6;\n  background-color: var(--vkui--color_background_secondary--active);\n  box-shadow: unset\n}\n\n.vkuiButton--mode-outline.vkuiButton--appearance-accent-invariable {\n  box-shadow: inset 0 0 0 1px #2688eb;\n  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_accent)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-overlay {\n  background-color: #fff;\n  background-color: var(--vkui--color_background_contrast)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-overlay.vkuiButton--hover {\n  background-color: #f5f5f7;\n  background-color: var(--vkui--color_background_contrast--hover)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-overlay.vkuiButton--active {\n  background-color: #ebecef;\n  background-color: var(--vkui--color_background_contrast--active)\n}\n\n.vkuiButton--mode-secondary.vkuiButton--appearance-overlay {\n  background-color: hsla(0, 0%, 100%, .2);\n  background-color: var(--vkui--color_background_contrast_secondary_alpha)\n}\n\n.vkuiButton--mode-outline.vkuiButton--appearance-overlay.vkuiButton--hover,\n.vkuiButton--mode-secondary.vkuiButton--appearance-overlay.vkuiButton--hover,\n.vkuiButton--mode-tertiary.vkuiButton--appearance-overlay.vkuiButton--hover {\n  background-color: hsla(0, 0%, 100%, .24);\n  background-color: var(--vkui--color_background_contrast_secondary_alpha--hover)\n}\n\n.vkuiButton--mode-outline.vkuiButton--appearance-overlay.vkuiButton--active,\n.vkuiButton--mode-secondary.vkuiButton--appearance-overlay.vkuiButton--active,\n.vkuiButton--mode-tertiary.vkuiButton--appearance-overlay.vkuiButton--active {\n  background-color: hsla(0, 0%, 100%, .28);\n  background-color: var(--vkui--color_background_contrast_secondary_alpha--active)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-overlay {\n  color: #000;\n  color: var(--vkui--color_text_primary_invariably)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-overlay.vkuiButton--hover {\n  color: #000102;\n  color: var(--vkui--color_text_primary_invariably--hover)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-overlay.vkuiButton--active {\n  color: #000105;\n  color: var(--vkui--color_text_primary_invariably--active)\n}\n\n.vkuiButton--mode-link.vkuiButton--appearance-overlay,\n.vkuiButton--mode-outline.vkuiButton--appearance-overlay,\n.vkuiButton--mode-secondary.vkuiButton--appearance-overlay,\n.vkuiButton--mode-tertiary.vkuiButton--appearance-overlay {\n  color: #fff;\n  color: var(--vkui--color_text_contrast)\n}\n\n.vkuiButton--mode-outline.vkuiButton--appearance-overlay {\n  box-shadow: inset 0 0 0 1px #fff;\n  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_contrast)\n}\n\n.vkuiButton--mode-outline.vkuiButton--appearance-overlay.vkuiButton--hover {\n  box-shadow: inset 0 0 0 1px #f5f5f7;\n  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_contrast--hover)\n}\n\n.vkuiButton--mode-outline.vkuiButton--appearance-overlay.vkuiButton--active {\n  box-shadow: inset 0 0 0 1px #ebecef;\n  box-shadow: inset 0 0 0 1px var(--vkui--color_stroke_contrast--active)\n}\n\n.vkuiButton__after:not(:first-child),\n.vkuiButton__before:not(:last-child)+.vkuiButton__content {\n  margin-left: 6px\n}\n\n.vkuiButton--size-l .vkuiButton__after:not(:first-child),\n.vkuiButton--size-l .vkuiButton__before:not(:last-child)+.vkuiButton__content {\n  margin-left: 8px\n}\n\n.vkuiButton--size-s .vkuiButton__content {\n  font-size: 13px;\n  font-size: var(--vkui--font_subhead--font_size--compact);\n  line-height: 16px;\n  line-height: var(--vkui--font_subhead--line_height--compact)\n}\n\n.vkuiButton--size-s .vkuiButton__content,\n.vkuiButton--sizeY-regular.vkuiButton--size-s .vkuiButton__content {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_subhead--font_family--regular)\n}\n\n.vkuiButton--sizeY-regular.vkuiButton--size-s .vkuiButton__content {\n  font-size: 14px;\n  font-size: var(--vkui--font_subhead--font_size--regular);\n  line-height: 18px;\n  line-height: var(--vkui--font_subhead--line_height--regular)\n}\n\n@media (max-width:767.9px) and (min-height:415px),\n(pointer:coarse) and (min-height:415px),\n(pointer:none) and (min-height:415px) {\n  .vkuiButton--sizeY-none.vkuiButton--size-s .vkuiButton__content {\n    font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n    font-family: var(--vkui--font_subhead--font_family--regular);\n    font-size: 14px;\n    font-size: var(--vkui--font_subhead--font_size--regular);\n    line-height: 18px;\n    line-height: var(--vkui--font_subhead--line_height--regular)\n  }\n}\n\n.vkuiButton--size-m .vkuiButton__content {\n  font-size: 14px;\n  font-size: var(--vkui--font_headline2--font_size--compact);\n  line-height: 20px;\n  line-height: var(--vkui--font_headline2--line_height--compact)\n}\n\n.vkuiButton--size-m .vkuiButton__content,\n.vkuiButton--sizeY-regular.vkuiButton--size-m .vkuiButton__content {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_headline2--font_family--regular)\n}\n\n.vkuiButton--sizeY-regular.vkuiButton--size-m .vkuiButton__content {\n  font-size: 15px;\n  font-size: var(--vkui--font_headline2--font_size--regular);\n  line-height: 20px;\n  line-height: var(--vkui--font_headline2--line_height--regular)\n}\n\n@media (max-width:767.9px) and (min-height:415px),\n(pointer:coarse) and (min-height:415px),\n(pointer:none) and (min-height:415px) {\n  .vkuiButton--sizeY-none.vkuiButton--size-m .vkuiButton__content {\n    font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n    font-family: var(--vkui--font_headline2--font_family--regular);\n    font-size: 15px;\n    font-size: var(--vkui--font_headline2--font_size--regular);\n    line-height: 20px;\n    line-height: var(--vkui--font_headline2--line_height--regular)\n  }\n}\n\n.vkuiButton--size-l .vkuiButton__content {\n  font-size: 15px;\n  font-size: var(--vkui--font_headline1--font_size--compact);\n  line-height: 20px;\n  line-height: var(--vkui--font_headline1--line_height--compact)\n}\n\n.vkuiButton--size-l .vkuiButton__content,\n.vkuiButton--sizeY-regular.vkuiButton--size-l .vkuiButton__content {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_headline1--font_family--regular)\n}\n\n.vkuiButton--sizeY-regular.vkuiButton--size-l .vkuiButton__content {\n  font-size: 16px;\n  font-size: var(--vkui--font_headline1--font_size--regular);\n  line-height: 20px;\n  line-height: var(--vkui--font_headline1--line_height--regular)\n}\n\n@media (max-width:767.9px) and (min-height:415px),\n(pointer:coarse) and (min-height:415px),\n(pointer:none) and (min-height:415px) {\n  .vkuiButton--sizeY-none.vkuiButton--size-l .vkuiButton__content {\n    font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n    font-family: var(--vkui--font_headline1--font_family--regular);\n    font-size: 16px;\n    font-size: var(--vkui--font_headline1--font_size--regular);\n    line-height: 20px;\n    line-height: var(--vkui--font_headline1--line_height--regular)\n  }\n}\n\n.vkuiButton--sizeY-regular.vkuiButton--size-l.vkuiButton--ios .vkuiButton__content {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_title3--font_family--regular);\n  font-size: 17px;\n  font-size: var(--vkui--font_title3--font_size--regular);\n  line-height: 22px;\n  line-height: var(--vkui--font_title3--line_height--regular)\n}\n\n@media (max-width:767.9px) and (min-height:415px),\n(pointer:coarse) and (min-height:415px),\n(pointer:none) and (min-height:415px) {\n  .vkuiButton--sizeY-none.vkuiButton--size-l.vkuiButton--ios .vkuiButton__content {\n    font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n    font-family: var(--vkui--font_title3--font_family--regular);\n    font-size: 17px;\n    font-size: var(--vkui--font_title3--font_size--regular);\n    line-height: 22px;\n    line-height: var(--vkui--font_title3--line_height--regular)\n  }\n}\n\n.vkuiButton--size-m {\n  min-height: 32px;\n  min-height: var(--vkui--size_button_medium_height--compact)\n}\n\n.vkuiButton--sizeY-regular.vkuiButton--size-m {\n  min-height: 36px;\n  min-height: var(--vkui--size_button_medium_height--regular)\n}\n\n@media (max-width:767.9px) and (min-height:415px),\n(pointer:coarse) and (min-height:415px),\n(pointer:none) and (min-height:415px) {\n  .vkuiButton--sizeY-none.vkuiButton--size-m {\n    min-height: 36px;\n    min-height: var(--vkui--size_button_medium_height--regular)\n  }\n}\n\n.vkuiButton--size-m.vkuiButton--singleIcon {\n  width: 32px;\n  width: var(--vkui--size_button_medium_height--compact)\n}\n\n.vkuiButton--sizeY-regular.vkuiButton--size-m.vkuiButton--singleIcon {\n  width: 36px;\n  width: var(--vkui--size_button_medium_height--regular)\n}\n\n@media (max-width:767.9px) and (min-height:415px),\n(pointer:coarse) and (min-height:415px),\n(pointer:none) and (min-height:415px) {\n  .vkuiButton--sizeY-none.vkuiButton--size-m.vkuiButton--singleIcon {\n    width: 36px;\n    width: var(--vkui--size_button_medium_height--regular)\n  }\n}\n\n.vkuiButton--size-l {\n  min-height: 36px;\n  min-height: var(--vkui--size_button_large_height--compact)\n}\n\n.vkuiButton--sizeY-regular.vkuiButton--size-l {\n  min-height: 44px;\n  min-height: var(--vkui--size_button_large_height--regular)\n}\n\n@media (max-width:767.9px) and (min-height:415px),\n(pointer:coarse) and (min-height:415px),\n(pointer:none) and (min-height:415px) {\n  .vkuiButton--sizeY-none.vkuiButton--size-l {\n    min-height: 44px;\n    min-height: var(--vkui--size_button_large_height--regular)\n  }\n}\n\n.vkuiButton--size-l.vkuiButton--singleIcon {\n  width: 36px;\n  width: var(--vkui--size_button_large_height--compact)\n}\n\n.vkuiButton--sizeY-regular.vkuiButton--size-l.vkuiButton--singleIcon {\n  width: 44px;\n  width: var(--vkui--size_button_large_height--regular)\n}\n\n@media (max-width:767.9px) and (min-height:415px),\n(pointer:coarse) and (min-height:415px),\n(pointer:none) and (min-height:415px) {\n  .vkuiButton--sizeY-none.vkuiButton--size-l.vkuiButton--singleIcon {\n    width: 44px;\n    width: var(--vkui--size_button_large_height--regular)\n  }\n}\n\n.vkuiButton--sizeY-regular {\n  min-height: 30px;\n  min-height: var(--vkui--size_button_small_height--regular)\n}\n\n@media (max-width:767.9px) and (min-height:415px),\n(pointer:coarse) and (min-height:415px),\n(pointer:none) and (min-height:415px) {\n  .vkuiButton--sizeY-none {\n    min-height: 30px;\n    min-height: var(--vkui--size_button_small_height--regular)\n  }\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-accent {\n  --vkui_internal--counter_inherit_background: var(--vkui--color_background_content);\n  --vkui_internal--counter_inherit_color: var(--vkui--color_text_accent_themed)\n}\n\n.vkuiButton--mode-outline.vkuiButton--appearance-accent,\n.vkuiButton--mode-secondary.vkuiButton--appearance-accent,\n.vkuiButton--mode-tertiary.vkuiButton--appearance-accent {\n  --vkui_internal--counter_inherit_background: var(--vkui--color_background_accent_themed);\n  --vkui_internal--counter_inherit_color: var(--vkui--color_text_contrast_themed)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-positive {\n  --vkui_internal--counter_inherit_background: var(--vkui--color_background_contrast);\n  --vkui_internal--counter_inherit_color: var(--vkui--color_text_positive)\n}\n\n.vkuiButton--mode-outline.vkuiButton--appearance-positive,\n.vkuiButton--mode-secondary.vkuiButton--appearance-positive,\n.vkuiButton--mode-tertiary.vkuiButton--appearance-positive {\n  --vkui_internal--counter_inherit_background: var(--vkui--color_background_positive);\n  --vkui_internal--counter_inherit_color: var(--vkui--color_text_contrast)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-negative {\n  --vkui_internal--counter_inherit_background: var(--vkui--color_background_contrast);\n  --vkui_internal--counter_inherit_color: var(--vkui--color_text_negative)\n}\n\n.vkuiButton--mode-outline.vkuiButton--appearance-negative,\n.vkuiButton--mode-secondary.vkuiButton--appearance-negative,\n.vkuiButton--mode-tertiary.vkuiButton--appearance-negative {\n  --vkui_internal--counter_inherit_background: var(--vkui--color_background_negative);\n  --vkui_internal--counter_inherit_color: var(--vkui--color_text_contrast)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-neutral {\n  --vkui_internal--counter_inherit_background: var(--vkui--color_background_contrast);\n  --vkui_internal--counter_inherit_color: var(--vkui--color_text_primary_invariably)\n}\n\n.vkuiButton--mode-outline.vkuiButton--appearance-neutral,\n.vkuiButton--mode-secondary.vkuiButton--appearance-neutral,\n.vkuiButton--mode-tertiary.vkuiButton--appearance-neutral {\n  --vkui_internal--counter_inherit_background: var(--vkui--color_background_accent);\n  --vkui_internal--counter_inherit_color: var(--vkui--color_text_contrast)\n}\n\n.vkuiButton--mode-primary.vkuiButton--appearance-overlay {\n  --vkui_internal--counter_inherit_background: var(--vkui--color_icon_primary_invariably);\n  --vkui_internal--counter_inherit_color: var(--vkui--color_text_contrast)\n}\n\n.vkuiButton--mode-outline.vkuiButton--appearance-overlay,\n.vkuiButton--mode-secondary.vkuiButton--appearance-overlay,\n.vkuiButton--mode-tertiary.vkuiButton--appearance-overlay {\n  --vkui_internal--counter_inherit_background: var(--vkui--color_background_contrast);\n  --vkui_internal--counter_inherit_color: var(--vkui--color_text_primary_invariably)\n}\n\n.vkuiVisuallyHidden {\n  clip: rect(0, 0, 0, 0) !important;\n  border: 0 !important;\n  -webkit-clip-path: inset(50%);\n  clip-path: inset(50%);\n  height: 1px !important;\n  margin: -1px !important;\n  opacity: 0;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  white-space: nowrap !important;\n  width: 1px !important\n}\n\n.vkuiIconButton {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background: none;\n  border: 0;\n  border-radius: 9999px;\n  box-shadow: none;\n  color: currentColor;\n  display: block;\n  height: 48px;\n  margin: 0;\n  padding: 0;\n  position: relative\n}\n\n.vkuiIconButton--sizeY-compact {\n  height: 44px\n}\n\n.vkuiIconButton[disabled] {\n  opacity: .64;\n  opacity: var(--vkui--opacity_disable_accessibility)\n}\n\n.vkuiIconButton--ios {\n  border-radius: 8px;\n  border-radius: var(--vkui--size_border_radius--regular)\n}\n\n.vkuiIconButton .vkuiIcon--16 {\n  padding: 16px\n}\n\n.vkuiIconButton .vkuiIcon--16.vkuiIcon--w-8 {\n  padding: 16px 14px\n}\n\n.vkuiIconButton--sizeY-compact .vkuiIcon--16,\n.vkuiIconButton--sizeY-compact .vkuiIcon--16.vkuiIcon--w-8 {\n  padding: 14px\n}\n\n.vkuiIconButton .vkuiIcon--24 {\n  padding: 12px\n}\n\n.vkuiIconButton .vkuiIcon--28,\n.vkuiIconButton--sizeY-compact .vkuiIcon--24 {\n  padding: 10px\n}\n\n.vkuiIconButton--sizeY-compact .vkuiIcon--28 {\n  padding: 8px\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiIconButton--sizeY-none {\n    height: 44px\n  }\n\n  .vkuiIconButton--sizeY-none .vkuiIcon--16,\n  .vkuiIconButton--sizeY-none .vkuiIcon--16.vkuiIcon--w-8 {\n    padding: 14px\n  }\n\n  .vkuiIconButton--sizeY-none .vkuiIcon--24 {\n    padding: 10px\n  }\n\n  .vkuiIconButton--sizeY-none .vkuiIcon--28 {\n    padding: 8px\n  }\n}\n\n.vkuiInternalFormField__after .vkuiIconButton,\n.vkuiInternalFormItem--removable .vkuiInternalRemovable__content>.vkuiIconButton,\n.vkuiInternalFormLayoutGroup--removable .vkuiInternalRemovable__content>.vkuiIconButton {\n  align-content: center;\n  align-items: center;\n  border-radius: 8px;\n  border-radius: var(--vkui--size_border_radius--regular);\n  display: flex;\n  height: 44px;\n  height: var(--vkui--size_field_height--regular);\n  justify-content: center;\n  width: 44px;\n  width: var(--vkui--size_field_height--regular)\n}\n\n.vkuiInternalFormField__after .vkuiIconButton .vkuiIcon.vkuiIcon.vkuiIcon {\n  padding: 0\n}\n\n.vkuiInternalFormField__after .vkuiIconButton--sizeY-compact {\n  height: 36px;\n  height: var(--vkui--size_field_height--compact);\n  width: 36px;\n  width: var(--vkui--size_field_height--compact)\n}\n\n.vkuiInternalFormItem--removable .vkuiInternalRemovable__content>.vkuiIconButton--sizeY-compact,\n.vkuiInternalFormLayoutGroup--removable .vkuiInternalRemovable__content>.vkuiIconButton--sizeY-compact {\n  height: 36px;\n  height: var(--vkui--size_field_height--compact)\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiInternalFormField__after .vkuiIconButton--sizeY-none {\n    width: 36px;\n    width: var(--vkui--size_field_height--compact)\n  }\n\n  .vkuiInternalFormField__after .vkuiIconButton--sizeY-none,\n  .vkuiInternalFormItem--removable .vkuiInternalRemovable__content>.vkuiIconButton--sizeY-none,\n  .vkuiInternalFormLayoutGroup--removable .vkuiInternalRemovable__content>.vkuiIconButton--sizeY-none {\n    height: 36px;\n    height: var(--vkui--size_field_height--compact)\n  }\n}\n\n.vkuiInternalSimpleCell__after .vkuiIconButton:last-child {\n  margin-right: -12px\n}\n\n.vkuiInternalSimpleCell__after .vkuiIconButton--ios:last-child {\n  margin-right: -9px\n}\n\n.vkuiInternalAlert__dismiss.vkuiIconButton {\n  height: 36px;\n  padding: 8px\n}\n\n.vkuiRoot {\n  height: 100%;\n  position: relative;\n  width: 100%\n}\n\n.vkuiRoot--transition {\n  pointer-events: auto\n}\n\n.vkuiRoot__view {\n  height: 100%;\n  position: relative;\n  width: 100%\n}\n\n.vkuiRoot--transition .vkuiRoot__view {\n  left: 0;\n  position: fixed;\n  top: 0\n}\n\n.vkuiRoot__scrollCompensation {\n  height: 100%;\n  width: 100%\n}\n\n.vkuiRoot__view--show-forward {\n  animation: vkuiroot-android-animation-show-forward .6s cubic-bezier(.4, 0, .2, 1);\n  animation: vkuiroot-android-animation-show-forward .6s var(--vkui--animation_easing_platform)\n}\n\n.vkuiRoot__view--hide-back {\n  animation: vkuiroot-android-animation-hide-back .6s cubic-bezier(.4, 0, .2, 1) forwards;\n  animation: vkuiroot-android-animation-hide-back .6s var(--vkui--animation_easing_platform) forwards\n}\n\n.vkuiRoot--ios .vkuiRoot__view--hide-forward:after,\n.vkuiRoot--ios .vkuiRoot__view--show-back:after {\n  background-color: #000;\n  content: \"\";\n  display: block;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%\n}\n\n.vkuiRoot--ios .vkuiRoot__view--show-back:after {\n  animation: vkuiroot-ios-animation-show-back .5s cubic-bezier(.32, .72, 0, 1) forwards;\n  animation: vkuiroot-ios-animation-show-back .5s var(--vkui--animation_easing_platform) forwards\n}\n\n.vkuiRoot--ios .vkuiRoot__view--hide-forward:after {\n  animation: vkuiroot-ios-animation-hide-forward .5s cubic-bezier(.32, .72, 0, 1);\n  animation: vkuiroot-ios-animation-hide-forward .5s var(--vkui--animation_easing_platform);\n}\n\n.vkuiRoot--ios .vkuiRoot__view--show-forward {\n  animation: vkuianimation-ios-next-forward .5s cubic-bezier(.32, .72, 0, 1);\n  animation: vkuianimation-ios-next-forward .5s var(--vkui--animation_easing_platform)\n}\n\n.vkuiRoot--ios .vkuiRoot__view--hide-back {\n  animation: vkuianimation-ios-prev-back .5s cubic-bezier(.32, .72, 0, 1) forwards;\n  animation: vkuianimation-ios-prev-back .5s var(--vkui--animation_easing_platform) forwards\n}\n\n@keyframes vkuiroot-ios-animation-show-back {\n  0% {\n    opacity: .9\n  }\n\n  to {\n    opacity: 0\n  }\n}\n\n@keyframes vkuiroot-ios-animation-hide-forward {\n  0% {\n    opacity: 0\n  }\n\n  to {\n    opacity: .9\n  }\n}\n\n@keyframes vkuiroot-ios-animation-hide-back {\n  0% {\n    transform: translateZ(0)\n  }\n\n  to {\n    transform: translate3d(0, 100%, 0)\n  }\n}\n\n@keyframes vkuiroot-ios-animation-show-forward {\n  0% {\n    transform: translate3d(0, 100%, 0)\n  }\n\n  to {\n    transform: translateZ(0)\n  }\n}\n\n@keyframes vkuiroot-android-animation-hide-back {\n  0% {\n    opacity: 1;\n    transform: scale(1)\n  }\n\n  to {\n    opacity: 0;\n    transform: scale(1.05)\n  }\n}\n\n@keyframes vkuiroot-android-animation-show-forward {\n  0% {\n    opacity: 0;\n    transform: scale(1.05)\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1)\n  }\n}\n\n.vkuiView {\n  word-wrap: break-word;\n  height: 100%;\n  position: relative;\n  width: 100%\n}\n\n.vkuiView--animated,\n.vkuiView--swiping-back {\n  overflow: hidden\n}\n\n.vkuiView--animated .vkuiView__header,\n.vkuiView--animated .vkuiView__panel,\n.vkuiView--swiping-back .vkuiView__header,\n.vkuiView--swiping-back .vkuiView__panel {\n  pointer-events: auto\n}\n\n.vkuiView__panel,\n.vkuiView__panels {\n  height: 100%;\n  width: 100%\n}\n\n.vkuiView__panel {\n  box-sizing: border-box;\n  isolation: isolate;\n  position: relative\n}\n\n.vkuiView__panel-in {\n  height: 100%\n}\n\n.vkuiView--animated .vkuiView__panel,\n.vkuiView--swiping-back .vkuiView__panel {\n  left: 0;\n  overflow: hidden;\n  position: fixed;\n  top: 0\n}\n\n.vkuiView__panel-overlay {\n  background-color: #000;\n  display: none;\n  height: 100%;\n  left: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 5;\n  z-index: var(--vkui_internal--z_index_panel_header_fade)\n}\n\n.vkuiView--ios .vkuiView__panel--swipe-back-prev.vkuiView__panel--swipe-back-success {\n  transform: translate3d(100%, 0, 0);\n  transition: transform .3s cubic-bezier(.4, 0, .2, 1);\n  transition: transform .3s var(--vkui--animation_easing_platform)\n}\n\n.vkuiView--ios .vkuiView__panel--swipe-back-next.vkuiView__panel--swipe-back-success,\n.vkuiView--ios .vkuiView__panel--swipe-back-prev.vkuiView__panel--swipe-back-failed {\n  transform: translateZ(0);\n  transition: transform .3s cubic-bezier(.4, 0, .2, 1);\n  transition: transform .3s var(--vkui--animation_easing_platform)\n}\n\n.vkuiView--ios .vkuiView__panel--swipe-back-next.vkuiView__panel--swipe-back-failed {\n  transform: translate3d(-50%, 0, 0);\n  transition: transform .3s cubic-bezier(.4, 0, .2, 1);\n  transition: transform .3s var(--vkui--animation_easing_platform)\n}\n\n.vkuiView--ios .vkuiView__panel--swipe-back-next .vkuiView__panel-overlay {\n  background-color: rgba(0, 0, 0, .1)\n}\n\n.vkuiView--ios .vkuiView__panel--swipe-back-next.vkuiView__panel--swipe-back-failed .vkuiView__panel-overlay,\n.vkuiView--ios .vkuiView__panel--swipe-back-next.vkuiView__panel--swipe-back-success .vkuiView__panel-overlay {\n  transition: opacity .3s cubic-bezier(.4, 0, .2, 1);\n  transition: opacity .3s var(--vkui--animation_easing_platform)\n}\n\n.vkuiView__panel--next~.vkuiView__panel--prev {\n  animation: vkuianimation-view-prev-back .3s cubic-bezier(.4, 0, .2, 1) forwards;\n  animation: vkuianimation-view-prev-back .3s var(--vkui--animation_easing_platform) forwards\n}\n\n.vkuiView__panel--prev~.vkuiView__panel--next {\n  animation: vkuianimation-view-next-forward .3s cubic-bezier(.4, 0, .2, 1);\n  animation: vkuianimation-view-next-forward .3s var(--vkui--animation_easing_platform)\n}\n\n.vkuiView--no-motion .vkuiView__panel {\n  animation: none\n}\n\n@keyframes vkuianimation-view-prev-back {\n  0% {\n    opacity: 1;\n    transform: translateY(0)\n  }\n\n  to {\n    opacity: 0;\n    transform: translateY(80px)\n  }\n}\n\n@keyframes vkuianimation-view-next-forward {\n  0% {\n    opacity: 0;\n    transform: translateY(80px)\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0)\n  }\n}\n\n.vkuiView--ios .vkuiView__panel--prev {\n  animation: vkuianimation-ios-prev-forward .6s cubic-bezier(.4, 0, .2, 1);\n  animation: vkuianimation-ios-prev-forward .6s var(--vkui--animation_easing_platform)\n}\n\n.vkuiView--ios .vkuiView__panel--next {\n  animation: vkuianimation-ios-next-back .6s cubic-bezier(.4, 0, .2, 1);\n  animation: vkuianimation-ios-next-back .6s var(--vkui--animation_easing_platform)\n}\n\n.vkuiView--ios .vkuiView__panel--prev~.vkuiView__panel--next {\n  animation: vkuianimation-ios-next-forward .6s cubic-bezier(.4, 0, .2, 1);\n  animation: vkuianimation-ios-next-forward .6s var(--vkui--animation_easing_platform)\n}\n\n.vkuiView--ios .vkuiView__panel--next~.vkuiView__panel--prev {\n  animation: vkuianimation-ios-prev-back .6s cubic-bezier(.4, 0, .2, 1) forwards;\n  animation: vkuianimation-ios-prev-back .6s var(--vkui--animation_easing_platform) forwards\n}\n\n.vkuiView--ios .vkuiView__panel--next .vkuiView__panel-overlay,\n.vkuiView--ios .vkuiView__panel--prev .vkuiView__panel-overlay {\n  display: block\n}\n\n.vkuiView--ios .vkuiView__panel--prev .vkuiView__panel-overlay {\n  animation: vkuianimation-ios-fade-in .6s cubic-bezier(.4, 0, .2, 1);\n  animation: vkuianimation-ios-fade-in .6s var(--vkui--animation_easing_platform)\n}\n\n.vkuiView--ios .vkuiView__panel--next .vkuiView__panel-overlay {\n  animation: vkuianimation-ios-fade-out .6s cubic-bezier(.4, 0, .2, 1) forwards;\n  animation: vkuianimation-ios-fade-out .6s var(--vkui--animation_easing_platform) forwards\n}\n\n.vkuiView--ios .vkuiView__panel--next~.vkuiView__panel--prev .vkuiView__panel-overlay,\n.vkuiView--ios .vkuiView__panel--prev~.vkuiView__panel--next .vkuiView__panel-overlay {\n  display: none\n}\n\n.vkuiView--ios.vkuiView--no-motion .vkuiView__panel,\n.vkuiView--ios.vkuiView--no-motion .vkuiView__panel .vkuiInternalPanel__in {\n  animation: none\n}\n\n.vkuiView--ios .vkuiView__panel--active .vkuiView__panel-overlay {\n  display: none\n}\n\n@keyframes vkuianimation-ios-next-forward {\n  0% {\n    transform: translate3d(100%, 0, 0)\n  }\n\n  to {\n    transform: translateZ(0)\n  }\n}\n\n@keyframes vkuianimation-ios-next-back {\n  0% {\n    transform: translate3d(-50%, 0, 0)\n  }\n\n  to {\n    transform: translateZ(0)\n  }\n}\n\n@keyframes vkuianimation-ios-prev-forward {\n  0% {\n    transform: translateZ(0)\n  }\n\n  to {\n    transform: translate3d(-50%, 0, 0)\n  }\n}\n\n@keyframes vkuianimation-ios-prev-back {\n  0% {\n    transform: translateZ(0)\n  }\n\n  to {\n    transform: translate3d(100%, 0, 0)\n  }\n}\n\n@keyframes vkuianimation-ios-fade-in {\n  0% {\n    opacity: 0\n  }\n\n  to {\n    opacity: .3\n  }\n}\n\n@keyframes vkuianimation-ios-fade-out {\n  0% {\n    opacity: .3\n  }\n\n  to {\n    opacity: 0\n  }\n}\n\n.vkuiPanel {\n  height: 100%;\n  position: relative;\n  width: 100%\n}\n\n.vkuiPanel:before {\n  content: \"\";\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%\n}\n\n.vkuiPanel__in {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  position: relative;\n  width: 100%\n}\n\n.vkuiPanel__centered {\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  flex: 1 0;\n  flex-direction: column;\n  justify-content: center\n}\n\n.vkuiPanel__centered .vkuiInternalPanelHeader--ios.vkuiInternalPanelHeader--vis+*,\n.vkuiPanel__centered .vkuiInternalPanelHeader--vis+* {\n  margin-top: 56px;\n  margin-top: var(--vkui--size_panel_header_height--regular)\n}\n\n.vkuiPanel--sizeX-compact .vkuiPanel__centered .vkuiInternalPanelHeader--sep+* {\n  margin-top: calc(56px + 5px);\n  margin-top: calc(var(--vkui--size_panel_header_height--regular) + 5px)\n}\n\n@media (max-width:767.9px) {\n  .vkuiPanel--sizeX-none .vkuiPanel__centered .vkuiInternalPanelHeader--sep+* {\n    margin-top: calc(56px + 5px);\n    margin-top: calc(var(--vkui--size_panel_header_height--regular) + 5px)\n  }\n}\n\n.vkuiPanel--sizeX-compact .vkuiPanel__centered .vkuiInternalPanelHeader--ios.vkuiInternalPanelHeader--sep+* {\n  margin-top: calc(56px + 5px);\n  margin-top: calc(var(--vkui--size_panel_header_height--regular) + 5px)\n}\n\n@media (max-width:767.9px) {\n  .vkuiPanel--sizeX-none .vkuiPanel__centered .vkuiInternalPanelHeader--ios.vkuiInternalPanelHeader--sep+* {\n    margin-top: calc(56px + 5px);\n    margin-top: calc(var(--vkui--size_panel_header_height--regular) + 5px)\n  }\n}\n\n.vkuiPanel--sizeX-compact .vkuiPanel__centered .vkuiInternalPanelHeader--vkcom.vkuiInternalPanelHeader--sep+* {\n  margin-top: calc(56px + 5px);\n  margin-top: calc(var(--vkui--size_panel_header_height--regular) + 5px)\n}\n\n@media (max-width:767.9px) {\n  .vkuiPanel--sizeX-none .vkuiPanel__centered .vkuiInternalPanelHeader--vkcom.vkuiInternalPanelHeader--sep+* {\n    margin-top: calc(56px + 5px);\n    margin-top: calc(var(--vkui--size_panel_header_height--regular) + 5px)\n  }\n}\n\n.vkuiPanel--sizeX-regular .vkuiPanel__centered .vkuiInternalPanelHeader--sep+* {\n  margin-top: calc(56px + 16px);\n  margin-top: calc(var(--vkui--size_panel_header_height--regular) + 16px)\n}\n\n@media (min-width:768px) {\n  .vkuiPanel--sizeX-none .vkuiPanel__centered .vkuiInternalPanelHeader--sep+* {\n    margin-top: calc(56px + 16px);\n    margin-top: calc(var(--vkui--size_panel_header_height--regular) + 16px)\n  }\n}\n\n.vkuiPanel--sizeX-regular .vkuiPanel__centered .vkuiInternalPanelHeader--ios.vkuiInternalPanelHeader--sep+* {\n  margin-top: calc(56px + 16px);\n  margin-top: calc(var(--vkui--size_panel_header_height--regular) + 16px)\n}\n\n@media (min-width:768px) {\n  .vkuiPanel--sizeX-none .vkuiPanel__centered .vkuiInternalPanelHeader--ios.vkuiInternalPanelHeader--sep+* {\n    margin-top: calc(56px + 16px);\n    margin-top: calc(var(--vkui--size_panel_header_height--regular) + 16px)\n  }\n}\n\n.vkuiPanel--sizeX-regular .vkuiPanel__centered .vkuiInternalPanelHeader--vkcom.vkuiInternalPanelHeader--sep+* {\n  margin-top: calc(56px + 16px);\n  margin-top: calc(var(--vkui--size_panel_header_height--regular) + 16px)\n}\n\n@media (min-width:768px) {\n  .vkuiPanel--sizeX-none .vkuiPanel__centered .vkuiInternalPanelHeader--vkcom.vkuiInternalPanelHeader--sep+* {\n    margin-top: calc(56px + 16px);\n    margin-top: calc(var(--vkui--size_panel_header_height--regular) + 16px)\n  }\n}\n\n.vkuiInternalView--ios .vkuiPanel__in {\n  padding-bottom: 0;\n  padding-bottom: var(--vkui_internal--safe_area_inset_bottom);\n  padding: 0;\n  padding: 0 var(--vkui_internal--safe_area_inset_right) var(--vkui_internal--safe_area_inset_bottom) var(--vkui_internal--safe_area_inset_left)\n}\n\n.vkuiInternalEpic--hasTabbar .vkuiPanel__in {\n  padding-bottom: calc(0px + 48px);\n  padding-bottom: calc(var(--vkui_internal--safe_area_inset_bottom) + var(--vkui_internal--tabbar_height))\n}\n\n.vkuiPanel__in-before {\n  height: 1px;\n  margin-bottom: -1px\n}\n\n.vkuiPanel__in-after {\n  height: 1px;\n  margin-top: -1px\n}\n\n.vkuiPanel .vkuiPanel__in,\n.vkuiPanel:before {\n  background-color: #fff;\n  background-color: var(--vkui--color_background_content)\n}\n\n.vkuiPanel--layout-card .vkuiPanel__in,\n.vkuiPanel--layout-card:before {\n  background-color: #ebedf0;\n  background-color: var(--vkui--color_background)\n}\n\n.vkuiPanel--sizeX-regular .vkuiPanel__in,\n.vkuiPanel--sizeX-regular:before {\n  background-color: initial\n}\n\n@media (min-width:768px) {\n\n  .vkuiPanel--sizeX-none .vkuiPanel__in,\n  .vkuiPanel--sizeX-none:before {\n    background-color: initial\n  }\n}\n\n.vkuiPanelHeaderButton {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background: none;\n  border: 0;\n  box-shadow: none;\n  color: currentColor;\n  display: block;\n  margin: 0;\n  padding: 0;\n  position: relative\n}\n\n.vkuiPanelHeaderButton[disabled] {\n  opacity: .6\n}\n\n.vkuiPanelHeaderButton--primitive {\n  height: 48px;\n  line-height: 48px;\n  padding: 0 10px\n}\n\n.vkuiPanelHeaderButton--ios {\n  align-items: center;\n  display: flex;\n  font-size: 17px;\n  position: relative\n}\n\n.vkuiPanelHeaderButton--ios.vkuiPanelHeaderButton--primitive {\n  height: 44px;\n  line-height: 44px\n}\n\n.vkuiPanelHeaderButton--ios .vkuiIcon--24 {\n  padding: 10px\n}\n\n.vkuiPanelHeaderButton--ios .vkuiIcon--28 {\n  padding: 8px\n}\n\n.vkuiPanelHeaderBack--ios .vkuiIcon--w-20 {\n  padding-left: 4px\n}\n\n.vkuiPanelHeaderButton--android.vkuiPanelHeaderButton--notPrimitive {\n  border-radius: 50%\n}\n\n.vkuiPanelHeaderButton--android .vkuiIcon--24 {\n  padding: 12px\n}\n\n.vkuiPanelHeaderButton--android .vkuiIcon--28 {\n  padding: 10px\n}\n\n.vkuiPanelHeaderButton--vkcom {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiPanelHeaderButton--vkcom>:not(.vkuiInternalCounter) {\n  opacity: .7;\n  transition: opacity .3s\n}\n\n.vkuiPanelHeaderButton--vkcom.vkuiPanelHeaderButton--active>:not(.vkuiInternalCounter),\n.vkuiPanelHeaderButton--vkcom.vkuiPanelHeaderButton--hover>:not(.vkuiInternalCounter) {\n  opacity: 1\n}\n\n.vkuiPanelHeaderButton--vkcom {\n  align-items: center;\n  display: flex;\n  padding: 10px\n}\n\n.vkuiPanelHeaderButton--vkcom.vkuiPanelHeaderButton--notPrimitive {\n  border-radius: 50%\n}\n\n.vkuiPanelHeaderBack--vkcom.vkuiPanelHeaderBack--has-label {\n  padding-right: 11px\n}\n\n@media (min-width:768px) {\n  .vkuiPanelHeaderBack--ios.vkuiPanelHeaderBack--has-label:not(.vkuiPanelHeaderBack--sizeX-compact) {\n    padding-right: 8px\n  }\n}\n\n.vkuiPanelHeaderBack--sizeX-compact.vkuiPanelHeaderBack--ios .vkuiPanelHeaderButton__label {\n  display: none\n}\n\n@media (max-width:767.9px) {\n  .vkuiPanelHeaderBack--sizeX-none.vkuiPanelHeaderBack--ios .vkuiPanelHeaderButton__label {\n    display: none\n  }\n}\n\n.vkuiPanelHeader {\n  position: relative\n}\n\n.vkuiPanelHeader--vis.vkuiPanelHeader--fixed:before {\n  content: \"\";\n  display: block\n}\n\n.vkuiPanelHeader:not(.vkuiPanelHeader--vis):not(.vkuiPanelHeader--fixed) {\n  height: 0;\n  z-index: 10;\n  z-index: var(--vkui_internal--z_index_panel_header)\n}\n\n.vkuiPanelHeader__fixed {\n  z-index: 10;\n  z-index: var(--vkui_internal--z_index_panel_header)\n}\n\n.vkuiPanelHeader__in {\n  align-items: center;\n  background: #fff;\n  background: var(--vkui--color_background_content);\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n  white-space: nowrap\n}\n\n.vkuiPanelHeader--trnsp .vkuiPanelHeader__in {\n  background: transparent\n}\n\n.vkuiPanelHeader--sizeX-regular .vkuiPanelHeader--shadow .vkuiPanelHeader__in {\n  box-shadow: 0 0 4px rgba(0, 0, 0, .08)\n}\n\n@media (min-width:768px) {\n  .vkuiPanelHeader--sizeX-none .vkuiPanelHeader--shadow .vkuiPanelHeader__in {\n    box-shadow: 0 0 4px rgba(0, 0, 0, .08)\n  }\n}\n\n.vkuiPanelHeader__before {\n  box-sizing: border-box;\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent_themed);\n  display: flex;\n  flex-shrink: 0\n}\n\n.vkuiPanelHeader__content {\n  overflow: hidden\n}\n\n.vkuiPanelHeader__content>* {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis\n}\n\n.vkuiPanelHeader__content-in {\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_family_accent);\n  font-weight: 500\n}\n\n.vkuiPanelHeader:before,\n.vkuiPanelHeader__in {\n  height: 56px;\n  height: var(--vkui--size_panel_header_height--regular);\n  padding-top: 0;\n  padding-top: var(--vkui_internal--safe_area_inset_top)\n}\n\n.vkuiPanelHeader__after {\n  align-items: center;\n  box-sizing: border-box;\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent_themed);\n  display: flex;\n  justify-content: flex-end\n}\n\n.vkuiPanelHeader__after>:not(:last-child) {\n  margin-right: 4px\n}\n\n.vkuiPanelHeader--ios .vkuiPanelHeader__before {\n  flex-basis: 0;\n  flex-grow: 1;\n  flex-shrink: 0;\n  opacity: 1;\n  padding: 4px 0 4px 4px;\n  transition: opacity .3s cubic-bezier(.4, 0, .2, 1);\n  transition: opacity .3s var(--vkui--animation_easing_platform)\n}\n\n.vkuiPanelHeader--ios .vkuiPanelHeader__before .vkuiPanelHeaderButton+.vkuiPanelHeaderButton--primitive {\n  margin-left: -6px;\n  padding-left: 0\n}\n\n.vkuiPanelHeader--ios .vkuiPanelHeader__content {\n  opacity: 1;\n  text-align: center;\n  transition: opacity .3s cubic-bezier(.4, 0, .2, 1);\n  transition: opacity .3s var(--vkui--animation_easing_platform)\n}\n\n.vkuiPanelHeader--ios .vkuiPanelHeader__content-in {\n  font-size: 21px\n}\n\n.vkuiPanelHeader--ios .vkuiPanelHeader__content>* {\n  padding: 0 4px\n}\n\n.vkuiPanelHeader--ios.vkuiPanelHeader--no-before .vkuiPanelHeader__content {\n  padding-left: 8px\n}\n\n.vkuiPanelHeader--ios.vkuiPanelHeader--no-after .vkuiPanelHeader__content>* {\n  padding-right: 0\n}\n\n.vkuiPanelHeader--ios.vkuiPanelHeader--no-after .vkuiPanelHeader__content {\n  padding-right: 8px\n}\n\n.vkuiPanelHeader--ios .vkuiPanelHeader__after {\n  flex-basis: 0;\n  flex-grow: 1;\n  flex-shrink: 0;\n  opacity: 1;\n  padding: 4px 4px 4px 0;\n  transition: opacity .3s cubic-bezier(.4, 0, .2, 1);\n  transition: opacity .3s var(--vkui--animation_easing_platform)\n}\n\n.vkuiView--ios .vkuiView__panel--prev .vkuiPanelHeader__after,\n.vkuiView--ios .vkuiView__panel--prev .vkuiPanelHeader__before,\n.vkuiView--ios .vkuiView__panel--prev .vkuiPanelHeader__content {\n  opacity: 0\n}\n\n.vkuiPanelHeader--android .vkuiPanelHeader__before:not(:empty) {\n  padding: 4px 0 4px 4px\n}\n\n.vkuiPanelHeader--android .vkuiPanelHeader__content {\n  align-items: center;\n  flex-grow: 1;\n  max-width: 100%\n}\n\n.vkuiPanelHeader--android .vkuiPanelHeader__content-in {\n  font-size: 23px\n}\n\n.vkuiPanelHeader--android .vkuiPanelHeader__content>* {\n  padding: 0 12px\n}\n\n.vkuiInternalSplitCol--spaced .vkuiPanelHeader--android.vkuiPanelHeader--no-before:not(.vkuiInternalModalPageHeader__in) .vkuiPanelHeader__content,\n.vkuiInternalSplitCol--viewWidth-tabletPlus.vkuiInternalSplitCol--spaced-none.vkuiInternalSplitCol--spaced-auto .vkuiPanelHeader--android.vkuiPanelHeader--no-before:not(.vkuiInternalModalPageHeader__in) .vkuiPanelHeader__content {\n  padding-left: 0\n}\n\n@media (min-width:768px) {\n  .vkuiInternalSplitCol--viewWidth-none.vkuiInternalSplitCol--spaced-none.vkuiInternalSplitCol--spaced-auto .vkuiPanelHeader--android.vkuiPanelHeader--no-before:not(.vkuiInternalModalPageHeader__in) .vkuiPanelHeader__content {\n    padding-left: 0\n  }\n}\n\n.vkuiPanelHeader--android.vkuiPanelHeader--no-after .vkuiPanelHeader__content>*,\n.vkuiPanelHeader--vkcom.vkuiPanelHeader--no-after .vkuiPanelHeader__content>* {\n  padding-right: 0\n}\n\n.vkuiPanelHeader--android.vkuiPanelHeader--no-after .vkuiPanelHeader__content {\n  padding-right: 16px\n}\n\n.vkuiPanelHeader--android.vkuiPanelHeader--no-before .vkuiPanelHeader__content {\n  padding-left: 16px\n}\n\n.vkuiInternalSplitCol--spaced .vkuiPanelHeader--android.vkuiPanelHeader--no-after:not(.vkuiInternalModalPageHeader__in) .vkuiPanelHeader__content,\n.vkuiInternalSplitCol--viewWidth-tabletPlus.vkuiInternalSplitCol--spaced-none.vkuiInternalSplitCol--spaced-auto .vkuiPanelHeader--android.vkuiPanelHeader--no-after:not(.vkuiInternalModalPageHeader__in) .vkuiPanelHeader__content {\n  padding-right: 0\n}\n\n@media (min-width:768px) {\n  .vkuiInternalSplitCol--viewWidth-none.vkuiInternalSplitCol--spaced-none.vkuiInternalSplitCol--spaced-auto .vkuiPanelHeader--android.vkuiPanelHeader--no-after:not(.vkuiInternalModalPageHeader__in) .vkuiPanelHeader__content {\n    padding-right: 0\n  }\n}\n\n.vkuiPanelHeader--android .vkuiPanelHeader__after:not(:empty),\n.vkuiPanelHeader--vkcom .vkuiPanelHeader__after:not(:empty) {\n  padding: 4px 4px 4px 0\n}\n\n.vkuiPanelHeader--vkcom {\n  position: relative;\n  z-index: 10;\n  z-index: var(--vkui_internal--z_index_panel_header)\n}\n\n.vkuiPanelHeader--vkcom.vkuiPanelHeader--sizeX-regular:not(.vkuiInternalModalPageHeader__in):not(.vkuiPanelHeader--sep) .vkuiPanelHeader__in:after {\n  background-color: #fff;\n  background-color: var(--vkui--color_background_content);\n  bottom: 0;\n  content: \"\";\n  height: var(--vkui--size_border--regular);\n  left: var(--vkui--size_border--regular);\n  position: absolute;\n  right: var(--vkui--size_border--regular)\n}\n\n@media (min-width:768px) {\n  .vkuiPanelHeader--vkcom.vkuiPanelHeader--sizeX-none:not(.vkuiInternalModalPageHeader__in):not(.vkuiPanelHeader--sep) .vkuiPanelHeader__in:after {\n    background-color: #fff;\n    background-color: var(--vkui--color_background_content);\n    bottom: 0;\n    content: \"\";\n    height: var(--vkui--size_border--regular);\n    left: var(--vkui--size_border--regular);\n    position: absolute;\n    right: var(--vkui--size_border--regular)\n  }\n}\n\n.vkuiPanelHeader--vkcom.vkuiPanelHeader--sizeX-regular:not(.vkuiInternalModalPageHeader__in) .vkuiPanelHeader__in {\n  border-bottom: 0;\n  border-top-left-radius: 12px;\n  border-top-left-radius: var(--vkui--size_border_radius_paper--regular);\n  border-top-right-radius: 12px;\n  border-top-right-radius: var(--vkui--size_border_radius_paper--regular);\n  box-shadow: 0 0 0 var(--vkui--size_border--regular) rgba(0, 0, 0, .12) inset;\n  box-shadow: 0 0 0 var(--vkui--size_border--regular) var(--vkui--color_field_border_alpha) inset\n}\n\n@media (min-width:768px) {\n  .vkuiPanelHeader--vkcom.vkuiPanelHeader--sizeX-none:not(.vkuiInternalModalPageHeader__in) .vkuiPanelHeader__in {\n    border-bottom: 0;\n    border-top-left-radius: 12px;\n    border-top-left-radius: var(--vkui--size_border_radius_paper--regular);\n    border-top-right-radius: 12px;\n    border-top-right-radius: var(--vkui--size_border_radius_paper--regular);\n    box-shadow: 0 0 0 var(--vkui--size_border--regular) rgba(0, 0, 0, .12) inset;\n    box-shadow: 0 0 0 var(--vkui--size_border--regular) var(--vkui--color_field_border_alpha) inset\n  }\n}\n\n.vkuiPanelHeader--vkcom .vkuiPanelHeader__content {\n  text-align: center\n}\n\n.vkuiPanelHeader--vkcom .vkuiPanelHeader__before:not(:empty) {\n  padding: 0 0 0 4px\n}\n\n.vkuiPanelHeader--vkcom .vkuiPanelHeader__after,\n.vkuiPanelHeader--vkcom .vkuiPanelHeader__before {\n  flex-basis: 0;\n  flex-grow: 1;\n  flex-shrink: 0\n}\n\n.vkuiPanelHeader__separator {\n  margin-top: calc(-1 * var(--vkui--size_border--regular))\n}\n\n.vkuiPanelHeader--no-before .vkuiPanelHeader__content>* {\n  padding-left: 0\n}\n\n.vkuiInternalPanel--centered .vkuiPanelHeader {\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%\n}\n\n.vkuiSeparator {\n  color: #d7d8d9;\n  color: var(--vkui--color_separator_primary)\n}\n\n.vkuiSeparator__in {\n  background: currentColor;\n  border: 0;\n  color: inherit;\n  height: var(--vkui--size_border--regular);\n  margin: 0;\n  transform-origin: center top\n}\n\n/* .vkuiSeparator--padded .vkuiSeparator__in {\n  margin-left: 16px;\n  margin-left: var(--vkui--size_base_padding_horizontal--regular);\n  margin-right: 16px;\n  margin-right: var(--vkui--size_base_padding_horizontal--regular)\n} */\n\n.vkuiInternalModalPage--sizeX-regular .vkuiSeparator--padded {\n  padding-left: 8px;\n  padding-right: 8px\n}\n\n@media (min-width:768px) {\n  .vkuiInternalModalPage--sizeX-none .vkuiSeparator--padded {\n    padding-left: 8px;\n    padding-right: 8px\n  }\n}\n\n.vkuiSpacing {\n  box-sizing: border-box;\n  position: relative\n}\n\n.vkuiPanelHeaderContent {\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_family_base);\n  height: 100%;\n  justify-content: flex-start;\n  line-height: normal;\n  max-width: 100%\n}\n\n.vkuiPanelHeaderContent__before {\n  flex-shrink: 0;\n  margin-right: 12px\n}\n\n.vkuiPanelHeaderContent__in {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  height: 100%;\n  justify-content: center;\n  min-width: 0\n}\n\n.vkuiPanelHeaderContent__children-in,\n.vkuiPanelHeaderContent__childrenText,\n.vkuiPanelHeaderContent__status {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap\n}\n\n.vkuiPanelHeaderContent__status {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  margin-top: 1px;\n  max-width: 100%;\n  order: 1\n}\n\n.vkuiPanelHeaderContent__children {\n  align-items: center;\n  display: flex;\n  max-width: 100%\n}\n\n.vkuiPanelHeaderContent__children-in {\n  flex-grow: 0;\n  min-width: 0\n}\n\n.vkuiPanelHeaderContent__aside {\n  align-items: center;\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent);\n  display: flex;\n  justify-content: flex-start;\n  margin-left: 2px\n}\n\n.vkuiPanelHeaderContent__width {\n  width: 1000px\n}\n\n.vkuiPanelHeaderContent__in--centered {\n  align-items: center\n}\n\n.vkuiPanelHeaderContent--ios .vkuiPanelHeaderContent__children-in {\n  font-size: 21px\n}\n\n.vkuiPanelHeaderContent--android .vkuiPanelHeaderContent__children-in,\n.vkuiPanelHeaderContent--ios .vkuiPanelHeaderContent__children-in {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_family_accent);\n  font-weight: 500;\n  line-height: 56px;\n  line-height: var(--vkui--size_panel_header_height--regular)\n}\n\n.vkuiPanelHeaderContent--android .vkuiPanelHeaderContent__children-in {\n  font-size: 23px\n}\n\n.vkuiInternalPanelHeader--no-before .vkuiPanelHeaderContent--vkcom {\n  padding-left: 16px\n}\n\n.vkuiPanelHeaderContext {\n  z-index: 4;\n  z-index: var(--vkui_internal--z_index_panel_header_context)\n}\n\n.vkuiPanelHeaderContext--closing,\n.vkuiPanelHeaderContext--opened {\n  height: 100%;\n  width: 100%\n}\n\n.vkuiPanelHeaderContext--sizeX-regular.vkuiPanelHeaderContext--closing,\n.vkuiPanelHeaderContext--sizeX-regular.vkuiPanelHeaderContext--opened {\n  height: auto\n}\n\n@media (min-width:768px) {\n\n  .vkuiPanelHeaderContext--sizeX-none.vkuiPanelHeaderContext--closing,\n  .vkuiPanelHeaderContext--sizeX-none.vkuiPanelHeaderContext--opened {\n    height: auto\n  }\n}\n\n.vkuiPanelHeaderContext__in {\n  box-sizing: border-box;\n  left: 0;\n  padding: 8px;\n  pointer-events: none;\n  position: absolute;\n  width: 100%\n}\n\n.vkuiPanelHeaderContext__fade {\n  background: rgba(0, 0, 0, .4);\n  display: none;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%\n}\n\n.vkuiPanelHeaderContext--sizeX-compact .vkuiPanelHeaderContext__fade {\n  display: block\n}\n\n@media (max-width:767.9px) {\n  .vkuiPanelHeaderContext--sizeX-none .vkuiPanelHeaderContext__fade {\n    display: block\n  }\n}\n\n.vkuiPanelHeaderContext--opened .vkuiPanelHeaderContext__fade {\n  animation: vkuianimation-panelheadercontext-fade-in .2s ease\n}\n\n.vkuiPanelHeaderContext--closing .vkuiPanelHeaderContext__fade {\n  animation: vkuianimation-panelheadercontext-fade-out .2s ease\n}\n\n.vkuiPanelHeaderContext--opened .vkuiPanelHeaderContext__in {\n  animation: vkuianimation-panelheadercontext-translate-in .2s ease;\n  pointer-events: auto\n}\n\n.vkuiPanelHeaderContext--closing .vkuiPanelHeaderContext__in {\n  animation: vkuianimation-panelheadercontext-translate-out .2s ease\n}\n\n.vkuiPanelHeaderContext__content {\n  background: #fff;\n  background: var(--vkui--color_background_content);\n  overflow: hidden\n}\n\n.vkuiPanelHeaderContext--ios .vkuiPanelHeaderContext__in {\n  padding: 0\n}\n\n.vkuiPanelHeaderContext--sizeX-regular.vkuiPanelHeaderContext--ios .vkuiPanelHeaderContext__content,\n.vkuiPanelHeaderContext:not(.vkuiPanelHeaderContext--ios) .vkuiPanelHeaderContext__content {\n  border-radius: 12px;\n  padding: 8px 0\n}\n\n@media (min-width:768px) {\n  .vkuiPanelHeaderContext--sizeX-none.vkuiPanelHeaderContext--ios .vkuiPanelHeaderContext__content {\n    border-radius: 12px;\n    padding: 8px 0\n  }\n}\n\n.vkuiPanelHeaderContext--sizeX-regular .vkuiPanelHeaderContext__in {\n  padding: 12px 8px\n}\n\n.vkuiPanelHeaderContext--sizeX-regular .vkuiPanelHeaderContext__content {\n  border-radius: 12px;\n  box-shadow: 0 0 4px rgba(0, 0, 0, .08), 0 8px 8px rgba(0, 0, 0, .16)\n}\n\n@media (min-width:768px) {\n  .vkuiPanelHeaderContext--sizeX-none .vkuiPanelHeaderContext__in {\n    padding: 12px 8px\n  }\n\n  .vkuiPanelHeaderContext--sizeX-none .vkuiPanelHeaderContext__content {\n    border-radius: 12px;\n    box-shadow: 0 0 4px rgba(0, 0, 0, .08), 0 8px 8px rgba(0, 0, 0, .16)\n  }\n}\n\n@keyframes vkuianimation-panelheadercontext-translate-in {\n  0% {\n    transform: translateY(-100%)\n  }\n\n  to {\n    transform: translateY(0)\n  }\n}\n\n@keyframes vkuianimation-panelheadercontext-translate-out {\n  0% {\n    transform: translateY(0)\n  }\n\n  to {\n    transform: translateY(-100%)\n  }\n}\n\n@keyframes vkuianimation-panelheadercontext-fade-in {\n  0% {\n    opacity: 0\n  }\n\n  to {\n    opacity: 1\n  }\n}\n\n@keyframes vkuianimation-panelheadercontext-fade-out {\n  0% {\n    opacity: 1\n  }\n\n  to {\n    opacity: 0\n  }\n}\n\n.vkuiSplitLayout {\n  height: 100%;\n  position: relative;\n  width: 100%\n}\n\n.vkuiSplitLayout__inner {\n  display: flex;\n  height: 100%;\n  width: 100%\n}\n\n.vkuiSplitLayout__inner--header {\n  position: relative;\n  z-index: 11;\n  z-index: var(--vkui_internal--z_index_split_layout_panel_header)\n}\n\n.vkuiSplitLayout--ios .vkuiSplitLayout__inner--header,\n.vkuiSplitLayout__inner--header {\n  margin-top: calc(-1 * (56px + 0px));\n  margin-top: calc(-1 * (var(--vkui--size_panel_header_height--regular) + var(--vkui_internal--safe_area_inset_top)))\n}\n\n.vkuiPopoutRoot {\n  height: 100%;\n  position: relative;\n  width: 100%\n}\n\n.vkuiPopoutRoot__popout {\n  z-index: 100;\n  z-index: var(--vkui--z_index_popout)\n}\n\n.vkuiPopoutRoot__modal,\n.vkuiPopoutRoot__popout {\n  height: 100%;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100%\n}\n\n.vkuiPopoutRoot__modal {\n  z-index: 99;\n  z-index: var(--vkui--z_index_modal)\n}\n\n.vkuiPopoutRoot__modal:empty,\n.vkuiPopoutRoot__popout:empty {\n  display: none\n}\n\n.vkuiSplitCol {\n  flex-grow: 1;\n  flex-shrink: 1;\n  height: 100%;\n  position: relative;\n  width: 1px\n}\n\n.vkuiSplitCol--spaced,\n.vkuiSplitCol--viewWidth-smallTabletPlus.vkuiSplitCol--spaced-none.vkuiSplitCol--spaced-auto {\n  margin: 0 16px;\n  margin: 0 var(--vkui--size_split_col_padding_horizontal--regular)\n}\n\n@media (min-width:768px) {\n  .vkuiSplitCol--viewWidth-none.vkuiSplitCol--spaced-none.vkuiSplitCol--spaced-auto {\n    margin: 0 16px;\n    margin: 0 var(--vkui--size_split_col_padding_horizontal--regular)\n  }\n}\n\n.vkuiSplitCol--viewWidth-tabletMinus.vkuiSplitCol--stretched-on-mobile {\n  max-width: 100% !important;\n  width: 100% !important\n}\n\n@media (max-width:1023.9px) {\n  .vkuiSplitCol--viewWidth-none.vkuiSplitCol--stretched-on-mobile {\n    max-width: 100% !important;\n    width: 100% !important\n  }\n}\n\n.vkuiSplitCol--fixed {\n  flex-grow: 1;\n  flex-shrink: 1;\n  height: 100%;\n  width: 1px\n}\n\n.vkuiSplitCol__fixedInner {\n  height: inherit;\n  max-width: inherit;\n  min-width: inherit;\n  overflow: hidden;\n  position: fixed;\n  top: 0;\n  transform: translateZ(0);\n  width: inherit\n}\n\n.vkuiEpic {\n  height: 100%;\n  width: 100%\n}\n\n.vkuiTabbar {\n  background: #f9f9f9;\n  background: var(--vkui--color_background_tertiary);\n  bottom: 0;\n  box-sizing: initial;\n  display: flex;\n  height: 48px;\n  height: var(--vkui_internal--tabbar_height);\n  left: 0;\n  overflow: hidden;\n  padding-bottom: 0;\n  padding-bottom: var(--vkui_internal--safe_area_inset_bottom);\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  z-index: var(--vkui_internal--z_index_tabs)\n}\n\n.vkuiTabbar--shadow {\n  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);\n  box-shadow: var(--vkui--elevation3)\n}\n\n.vkuiTabbar--ios.vkuiTabbar--shadow {\n  box-shadow: none\n}\n\n.vkuiTabbar--ios.vkuiTabbar--shadow:before {\n  background: rgba(0, 0, 0, .12);\n  background: var(--vkui--color_separator_primary_alpha);\n  content: \"\";\n  height: var(--vkui--size_border--regular);\n  left: 0;\n  position: absolute;\n  width: 100%\n}\n\n.vkuiTabbarItem {\n  align-items: center;\n  background: transparent;\n  border: 0;\n  color: #99a2ad;\n  color: var(--vkui--color_tabbar_text_inactive);\n  display: flex;\n  height: 48px;\n  height: var(--vkui_internal--tabbar_height);\n  justify-content: center;\n  outline: none;\n  padding: 0;\n  position: relative;\n  text-decoration: none\n}\n\n.vkuiInternalTabbar .vkuiTabbarItem {\n  flex-basis: 0;\n  flex-grow: 1;\n  flex-shrink: 0;\n  max-width: 100%;\n  min-width: 0\n}\n\n.vkuiTabbarItem--selected {\n  color: #2688eb;\n  color: var(--vkui--color_text_accent_themed)\n}\n\n.vkuiTabbarItem__tappable {\n  position: absolute\n}\n\n.vkuiTabbarItem__in {\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  overflow: hidden;\n  padding: 4px 2px 2px;\n  pointer-events: none;\n  width: 100%\n}\n\n.vkuiInternalTabbar--layout-vertical .vkuiTabbarItem__in {\n  flex-direction: column\n}\n\n.vkuiInternalTabbar--layout-horizontal .vkuiTabbarItem__in {\n  flex-direction: row\n}\n\n.vkuiTabbarItem__icon {\n  color: #99a2ad;\n  color: var(--vkui--color_icon_secondary);\n  position: relative\n}\n\n.vkuiTabbarItem--selected .vkuiTabbarItem__icon {\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent_themed)\n}\n\n.vkuiTabbarItem__text {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap\n}\n\n.vkuiInternalTabbar--layout-vertical .vkuiTabbarItem__text {\n  --vkui--font_footnote--font_size--regular: 10px;\n  --vkui--font_footnote--line_height--regular: 12px;\n  margin-top: 2px\n}\n\n.vkuiInternalTabbar--layout-horizontal .vkuiTabbarItem__text {\n  margin-left: 8px\n}\n\n.vkuiTabbarItem--android .vkuiTabbarItem__tappable {\n  border-radius: 50%;\n  padding-bottom: calc(100% + 16px);\n  width: calc(100% + 16px)\n}\n\n.vkuiTabbarItem--android:first-child {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0\n}\n\n.vkuiTabbarItem--android:last-child {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0\n}\n\n.vkuiTabbarItem--ios .vkuiTabbarItem__tappable {\n  height: 100%;\n  left: 0;\n  top: 0;\n  width: 100%\n}\n\n.vkuiTabbarItem--ios .vkuiTabbarItem__in {\n  transition: transform .07s cubic-bezier(.4, 0, .2, 1);\n  transition: transform .07s var(--vkui--animation_easing_platform)\n}\n\n.vkuiTabbarItem--ios .vkuiTabbarItem__tappable--active+.vkuiTabbarItem__in {\n  transform: scale(.96)\n}\n\n.vkuiScrollArrow {\n  background-color: initial;\n  border: 0;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  transition: opacity .15s;\n  transition-timing-function: cubic-bezier(.4, 0, .2, 1);\n  transition-timing-function: var(--vkui--animation_easing_platform);\n  -webkit-user-select: auto;\n  -moz-user-select: auto;\n  -ms-user-select: auto;\n  user-select: auto\n}\n\n.vkuiScrollArrow--direction-left,\n.vkuiScrollArrow--direction-right {\n  flex-direction: column;\n  height: 100%\n}\n\n.vkuiScrollArrow--direction-down,\n.vkuiScrollArrow--direction-up {\n  flex-direction: row;\n  width: 100%\n}\n\n.vkuiScrollArrow__icon {\n  align-items: center;\n  background-color: #fff;\n  background-color: var(--vkui--color_background_modal);\n  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);\n  box-shadow: var(--vkui--elevation3);\n  color: #99a2ad;\n  color: var(--vkui--color_icon_secondary);\n  display: flex;\n  justify-content: center;\n  position: relative\n}\n\n.vkuiScrollArrow--size-m .vkuiScrollArrow__icon {\n  border-radius: 14px;\n  height: 28px;\n  width: 28px\n}\n\n.vkuiScrollArrow--size-l .vkuiScrollArrow__icon {\n  border-radius: 24px;\n  height: 40px;\n  width: 40px\n}\n\n.vkuiScrollArrow--direction-left {\n  left: 0;\n  padding-left: 16px;\n  padding-left: var(--vkui--size_base_padding_horizontal--regular, 16px)\n}\n\n.vkuiScrollArrow--direction-right {\n  padding-right: 16px;\n  padding-right: var(--vkui--size_base_padding_horizontal--regular, 16px);\n  right: 0\n}\n\n.vkuiScrollArrow--direction-up {\n  padding-top: 16px;\n  padding-top: var(--vkui--size_base_padding_horizontal--regular, 16px);\n  top: 0\n}\n\n.vkuiScrollArrow--direction-down {\n  bottom: 0;\n  padding-bottom: 16px;\n  padding-bottom: var(--vkui--size_base_padding_horizontal--regular, 16px)\n}\n\n.vkuiScrollArrow--direction-left .vkuiScrollArrow__defaultIcon {\n  transform: rotate(180deg)\n}\n\n.vkuiScrollArrow--direction-up .vkuiScrollArrow__defaultIcon {\n  transform: rotate(-90deg)\n}\n\n.vkuiScrollArrow--direction-down .vkuiScrollArrow__defaultIcon {\n  transform: rotate(90deg)\n}\n\n.vkuiHorizontalScroll {\n  isolation: isolate;\n  overflow-x: hidden;\n  position: relative\n}\n\n.vkuiHorizontalScroll__in {\n  -webkit-overflow-scrolling: touch;\n  overflow-x: auto;\n  scrollbar-width: none\n}\n\n.vkuiHorizontalScroll__in::-webkit-scrollbar {\n  display: none\n}\n\n.vkuiHorizontalScroll__in-wrapper {\n  transition: transform .2s\n}\n\n.vkuiHorizontalScroll__arrow {\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  z-index: 1;\n  z-index: var(--vkui_internal--z_index_horizontal_scroll_arrow)\n}\n\n.vkuiHorizontalScroll:hover .vkuiHorizontalScroll__arrow {\n  opacity: .64;\n  opacity: var(--vkui--opacity_disable_accessibility)\n}\n\n.vkuiHorizontalScroll .vkuiHorizontalScroll__arrow:hover,\n.vkuiHorizontalScroll--withConstArrows .vkuiHorizontalScroll__arrow,\n.vkuiHorizontalScroll--withConstArrows:hover .vkuiHorizontalScroll__arrow {\n  opacity: 1\n}\n\n.vkuiHorizontalScroll__arrowLeft:hover~.vkuiHorizontalScroll__in .vkuiHorizontalScroll__in-wrapper {\n  transform: translateX(8px)\n}\n\n.vkuiHorizontalScroll__arrowRight:hover~.vkuiHorizontalScroll__in .vkuiHorizontalScroll__in-wrapper {\n  transform: translateX(-8px)\n}\n\n.vkuiInternalTabs .vkuiHorizontalScroll {\n  min-width: 100%\n}\n\n.vkuiInternalTabs .vkuiHorizontalScroll__in-wrapper {\n  align-items: stretch;\n  display: flex\n}\n\n.vkuiInternalTabs--withGaps .vkuiHorizontalScroll__in-wrapper:after,\n.vkuiInternalTabs--withGaps .vkuiHorizontalScroll__in-wrapper:before {\n  content: \"\";\n  display: block;\n  flex-shrink: 0;\n  height: 1px;\n  width: 16px;\n  width: var(--vkui--size_base_padding_horizontal--regular)\n}\n\n.vkuiAspectRatio {\n  --vkui_internal--aspect_ratio: 1;\n  max-width: 100%;\n  position: relative\n}\n\n.vkuiAspectRatio:before {\n  content: \"\";\n  display: block;\n  height: 0;\n  padding-bottom: calc((1 / 1) * 100%);\n  padding-bottom: calc((1 / var(--vkui_internal--aspect_ratio, 1)) * 100%)\n}\n\n.vkuiAspectRatio>* {\n  left: 0;\n  position: absolute;\n  top: 0\n}\n\n.vkuiAspectRatio--mode-stretch>* {\n  height: 100%;\n  width: 100%\n}\n\n.vkuiAspectRatio--mode-stretch>img,\n.vkuiAspectRatio--mode-stretch>video {\n  object-fit: cover\n}\n\n.vkuiPopoutWrapper {\n  box-sizing: border-box;\n  height: 100%;\n  left: 0;\n  pointer-events: none;\n  top: 0;\n  width: 100%\n}\n\n.vkuiPopoutWrapper--opened {\n  pointer-events: auto\n}\n\n.vkuiPopoutWrapper--closing {\n  pointer-events: none\n}\n\n.vkuiPopoutWrapper--fixed {\n  position: fixed\n}\n\n.vkuiPopoutWrapper__overlay {\n  animation: vkuianimation-full-fade-in .2s ease;\n  animation: vkuianimation-full-fade-in var(--vkui--animation_duration_m) ease;\n  height: 100%;\n  left: 0;\n  opacity: 1;\n  position: fixed;\n  top: 0;\n  width: 100%\n}\n\n.vkuiPopoutWrapper--closing .vkuiPopoutWrapper__overlay {\n  opacity: 0;\n  transition: opacity .2s cubic-bezier(.3, .3, .5, 1);\n  transition: opacity var(--vkui--animation_duration_m) var(--vkui--animation_easing_default)\n}\n\n.vkuiPopoutWrapper--masked .vkuiPopoutWrapper__overlay {\n  background: rgba(0, 0, 0, .4);\n  background: var(--vkui--color_overlay_primary)\n}\n\n.vkuiPopoutWrapper--fixed .vkuiPopoutWrapper__overlay {\n  position: absolute\n}\n\n.vkuiPopoutWrapper__container {\n  box-sizing: border-box;\n  display: flex;\n  height: 100%;\n  position: relative;\n  width: 100%\n}\n\n.vkuiPopoutWrapper__content {\n  display: flex;\n  justify-content: center;\n  pointer-events: none;\n  position: relative;\n  width: 100%\n}\n\n.vkuiPopoutWrapper__content>* {\n  pointer-events: auto\n}\n\n.vkuiPopoutWrapper--alignY-center .vkuiPopoutWrapper__container {\n  align-items: center\n}\n\n.vkuiPopoutWrapper--alignY-bottom .vkuiPopoutWrapper__container {\n  align-items: flex-end\n}\n\n.vkuiPopoutWrapper--alignY-top .vkuiPopoutWrapper__container {\n  align-items: flex-start\n}\n\n.vkuiPopoutWrapper--alignX-center .vkuiPopoutWrapper__container {\n  justify-content: center\n}\n\n.vkuiPopoutWrapper--alignX-left .vkuiPopoutWrapper__container {\n  justify-content: flex-start\n}\n\n.vkuiPopoutWrapper--alignX-right .vkuiPopoutWrapper__container {\n  justify-content: flex-end\n}\n\n@keyframes vkuianimation-full-fade-in {\n  0% {\n    opacity: 0\n  }\n\n  to {\n    opacity: 1\n  }\n}\n\n.vkuiAlert {\n  animation: vkuianimation-android-alert-intro .2s cubic-bezier(.4, 0, .2, 1);\n  animation: vkuianimation-android-alert-intro .2s var(--vkui--animation_easing_platform);\n  border-radius: 12px;\n  border-radius: var(--vkui--size_border_radius_paper--regular);\n  box-shadow: 0 0 8px rgba(0, 0, 0, .12), 0 16px 16px rgba(0, 0, 0, .16);\n  box-shadow: var(--vkui--elevation4);\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  margin: auto 24px;\n  max-width: 416px;\n  min-width: 280px;\n  position: relative;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none\n}\n\n.vkuiAlert--desktop {\n  width: 100%\n}\n\n.vkuiAlert--closing {\n  opacity: 0;\n  transform: scale(.95);\n  transition: transform .2s cubic-bezier(.4, 0, .2, 1), opacity .2s cubic-bezier(.4, 0, .2, 1);\n  transition: transform .2s var(--vkui--animation_easing_platform), opacity .2s var(--vkui--animation_easing_platform)\n}\n\n.vkuiAlert:before {\n  background-color: #fff;\n  background-color: var(--vkui--color_background_modal);\n  border-radius: inherit;\n  content: \"\";\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%\n}\n\n.vkuiAlert__content {\n  padding: 24px 24px 16px;\n  position: relative\n}\n\n.vkuiAlert__content--withButton {\n  padding-right: 52px\n}\n\n.vkuiAlert__action {\n  background: transparent;\n  white-space: nowrap\n}\n\n.vkuiAlert__actions {\n  display: flex;\n  max-width: 100%;\n  padding: 0 12px 12px;\n  position: relative\n}\n\n.vkuiAlert__header {\n  margin-bottom: 8px\n}\n\n.vkuiAlert__text {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiAlert__header,\n.vkuiAlert__text {\n  word-break: break-word\n}\n\n.vkuiAlert__actions--direction-horizontal {\n  justify-content: flex-end\n}\n\n.vkuiAlert__actions--direction-vertical {\n  align-items: flex-end;\n  flex-direction: column\n}\n\n.vkuiAlert__actions>* {\n  margin: 4px\n}\n\n.vkuiAlert__actions--align-left {\n  align-items: flex-start;\n  justify-content: flex-start\n}\n\n.vkuiAlert__actions--align-center {\n  align-items: center;\n  justify-content: center\n}\n\n.vkuiAlert__actions--align-right {\n  align-items: flex-end;\n  justify-content: flex-end\n}\n\n.vkuiAlert--ios {\n  animation: vkuianimation-ios-alert-intro .3s cubic-bezier(.4, 0, .2, 1);\n  animation: vkuianimation-ios-alert-intro .3s var(--vkui--animation_easing_platform);\n  box-shadow: none;\n  min-width: 270px;\n  overflow: hidden;\n  width: 270px\n}\n\n.vkuiAlert--ios.vkuiAlert--closing {\n  opacity: 0;\n  transform: none;\n  transition: opacity .3s cubic-bezier(.4, 0, .2, 1);\n  transition: opacity .3s var(--vkui--animation_easing_platform)\n}\n\n.vkuiAlert--ios .vkuiAlert__content {\n  padding: 20px 16px;\n  text-align: center\n}\n\n.vkuiAlert--ios .vkuiAlert__header:not(:last-child) {\n  margin-bottom: 7px\n}\n\n.vkuiAlert--ios .vkuiAlert__text {\n  color: inherit\n}\n\n.vkuiAlert--ios .vkuiAlert__content:after {\n  background: rgba(0, 0, 0, .12);\n  background: var(--vkui--color_separator_primary_alpha);\n  bottom: 0;\n  content: \"\";\n  height: 1px;\n  left: 0;\n  position: absolute;\n  right: 0;\n  transform-origin: center bottom\n}\n\n.vkuiAlert--ios .vkuiAlert__actions {\n  padding: initial\n}\n\n.vkuiAlert--ios .vkuiAlert__actions--direction-vertical {\n  align-items: normal;\n  flex-direction: column\n}\n\n.vkuiAlert--ios .vkuiAlert__action {\n  border: 0;\n  border-radius: 0;\n  color: #2688eb;\n  color: var(--vkui--color_text_accent);\n  display: block;\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_family_base);\n  font-size: 17px;\n  height: 44px;\n  line-height: 44px;\n  margin: 0;\n  overflow: hidden;\n  padding: 0 6px;\n  position: relative;\n  text-align: center;\n  text-decoration: none;\n  text-overflow: ellipsis\n}\n\n.vkuiAlert--ios .vkuiAlert__action:after {\n  background: rgba(0, 0, 0, .12);\n  background: var(--vkui--color_separator_primary_alpha);\n  content: \"\";\n  position: absolute\n}\n\n.vkuiAlert--ios .vkuiAlert__actions--direction-horizontal .vkuiAlert__action:after {\n  height: 100%;\n  right: 0;\n  top: 0;\n  transform-origin: right center;\n  width: 1px\n}\n\n.vkuiAlert--ios .vkuiAlert__actions--direction-horizontal .vkuiAlert__action:last-child:after {\n  content: none\n}\n\n.vkuiAlert--ios .vkuiAlert__actions--direction-horizontal .vkuiAlert__action {\n  flex-basis: 0;\n  flex-grow: 1;\n  flex-shrink: 1\n}\n\n.vkuiAlert--ios .vkuiAlert__actions--direction-horizontal .vkuiAlert__action:first-child {\n  border-bottom-left-radius: 12px;\n  border-bottom-left-radius: var(--vkui--size_border_radius_paper--regular)\n}\n\n.vkuiAlert--ios .vkuiAlert__actions--direction-horizontal .vkuiAlert__action:last-child {\n  border-bottom-right-radius: 12px;\n  border-bottom-right-radius: var(--vkui--size_border_radius_paper--regular)\n}\n\n.vkuiAlert--ios .vkuiAlert__actions--direction-vertical .vkuiAlert__action:after {\n  bottom: 0;\n  height: 1px;\n  left: 0;\n  transform-origin: center bottom;\n  width: 100%\n}\n\n.vkuiAlert--ios .vkuiAlert__actions--direction-vertical .vkuiAlert__action:last-child:after {\n  content: none\n}\n\n.vkuiAlert--ios .vkuiAlert__actions--direction-vertical .vkuiAlert__action:last-child {\n  border-radius: 0 0 12px 12px\n}\n\n@media (-webkit-min-device-pixel-ratio:2),\n(min-resolution:2dppx) {\n\n  .vkuiAlert--ios .vkuiAlert__actions--direction-vertical .vkuiAlert__action:after,\n  .vkuiAlert--ios .vkuiAlert__content:after {\n    transform: scaleY(.5)\n  }\n\n  .vkuiAlert--ios .vkuiAlert__actions--direction-horizontal .vkuiAlert__action:after {\n    transform: scaleX(.5)\n  }\n}\n\n@media (-webkit-min-device-pixel-ratio:3),\n(min-resolution:3dppx) {\n\n  .vkuiAlert--ios .vkuiAlert__actions--direction-vertical .vkuiAlert__action:after,\n  .vkuiAlert--ios .vkuiAlert__content:after {\n    transform: scaleY(.33)\n  }\n\n  .vkuiAlert--ios .vkuiAlert__actions--direction-horizontal .vkuiAlert__action:after {\n    transform: scaleX(.33)\n  }\n}\n\n.vkuiAlert--ios .vkuiAlert__action--mode-cancel {\n  font-weight: 600\n}\n\n.vkuiAlert--ios .vkuiAlert__action--mode-destructive {\n  color: #e64646;\n  color: var(--vkui--color_text_negative)\n}\n\n.vkuiAlert--vkcom {\n  box-shadow: 0 0 2px rgba(0, 0, 0, .12), 0 0 96px rgba(0, 0, 0, .16);\n  width: 400px\n}\n\n.vkuiAlert--vkcom .vkuiAlert__content {\n  padding-bottom: 20px\n}\n\n.vkuiAlert--vkcom .vkuiAlert__actions {\n  padding: 0 20px 12px\n}\n\n.vkuiAlert--vkcom .vkuiAlert__button {\n  order: 2\n}\n\n.vkuiAlert--vkcom .vkuiAlert__button--mode-cancel {\n  order: 1\n}\n\n.vkuiAlert__dismiss {\n  color: #99a2ad;\n  color: var(--vkui--color_icon_secondary);\n  position: absolute;\n  right: 8px;\n  top: 8px\n}\n\n@keyframes vkuianimation-ios-alert-intro {\n  0% {\n    opacity: 0;\n    transform: scale(1.05)\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1)\n  }\n}\n\n@keyframes vkuianimation-android-alert-intro {\n  0% {\n    opacity: 0;\n    transform: scale(.95)\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1)\n  }\n}\n\n.vkuiModalDismissButton {\n  box-sizing: border-box;\n  color: #fff;\n  color: var(--vkui--color_icon_contrast);\n  height: 56px;\n  justify-content: center;\n  padding: 18px;\n  position: absolute;\n  right: -56px;\n  top: 0;\n  transition: opacity .15s ease-out;\n  width: 56px\n}\n\n.vkuiModalDismissButton:before {\n  background: rgba(0, 0, 0, .4);\n  background: var(--vkui--color_overlay_primary);\n  border-radius: 50%;\n  bottom: 14px;\n  content: \"\";\n  display: block;\n  left: 14px;\n  position: absolute;\n  right: 14px;\n  top: 14px\n}\n\n.vkuiModalDismissButton .vkuiIcon {\n  transform: translateX(0)\n}\n\n.vkuiModalDismissButton--hover.vkuiModalDismissButton:before {\n  background: rgba(0, 0, 0, .44);\n  background: var(--vkui--color_overlay_primary--hover)\n}\n\n.vkuiModalDismissButton--active.vkuiModalDismissButton:before {\n  background: rgba(0, 0, 0, .48);\n  background: var(--vkui--color_overlay_primary--active)\n}\n\n.vkuiActionSheet {\n  animation: vkuianimation-actionsheet-intro .2s cubic-bezier(.4, 0, .2, 1);\n  animation: vkuianimation-actionsheet-intro .2s var(--vkui--animation_easing_platform);\n  box-sizing: border-box;\n  max-width: 430px;\n  max-width: var(--vkui--size_popup_small--regular);\n  padding: 10px;\n  width: 100%\n}\n\n.vkuiActionSheet__content-wrapper {\n  background: #fff;\n  background: var(--vkui--color_background_modal);\n  border-radius: 12px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);\n  box-shadow: var(--vkui--elevation3);\n  overflow: hidden;\n  padding: 8px 0\n}\n\n.vkuiActionSheet__header {\n  color: #6d7885;\n  color: var(--vkui--color_text_subhead);\n  padding: 16px 20px\n}\n\n.vkuiActionSheet--closing {\n  transform: translateY(calc(100% + 20px));\n  transition: transform .2s cubic-bezier(.4, 0, .2, 1);\n  transition: transform .2s var(--vkui--animation_easing_platform)\n}\n\n.vkuiActionSheet__title+.vkuiActionSheet__text {\n  margin-top: 8px\n}\n\n.vkuiActionSheet--ios {\n  animation: vkuianimation-actionsheet-intro .3s cubic-bezier(.4, 0, .2, 1);\n  animation: vkuianimation-actionsheet-intro .3s var(--vkui--animation_easing_platform);\n  background: transparent;\n  padding: 8px\n}\n\n.vkuiActionSheet--ios .vkuiActionSheet__content-wrapper {\n  border-radius: 14px;\n  padding: 0\n}\n\n.vkuiActionSheet__close-item-wrapper--ios {\n  background: #fff;\n  background: var(--vkui--color_background_modal);\n  border-radius: 14px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);\n  box-shadow: var(--vkui--elevation3);\n  margin-bottom: 0;\n  margin-bottom: var(--vkui_internal--safe_area_inset_bottom);\n  margin-top: 8px;\n  overflow: hidden\n}\n\n.vkuiActionSheet--ios.vkuiActionSheet--closing {\n  transform: translateY(100%);\n  transition: transform .3s cubic-bezier(.4, 0, .2, 1);\n  transition: transform .3s var(--vkui--animation_easing_platform)\n}\n\n.vkuiActionSheet--ios .vkuiActionSheet__header {\n  position: relative;\n  text-align: center\n}\n\n.vkuiActionSheet--ios .vkuiActionSheet__text,\n.vkuiActionSheet--ios .vkuiActionSheet__title {\n  position: relative\n}\n\n.vkuiActionSheet--ios .vkuiActionSheet__header:before {\n  background-color: #fff;\n  background-color: var(--vkui--color_background_modal);\n  content: \"\";\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%\n}\n\n.vkuiActionSheet--sizeY-compact .vkuiActionSheet__header {\n  padding: 12px 20px\n}\n\n.vkuiActionSheet--menu {\n  animation: none;\n  height: auto;\n  max-width: 100%;\n  padding: 0;\n  width: auto\n}\n\n.vkuiActionSheet--menu.vkuiActionSheet--ios .vkuiActionSheet__content-wrapper {\n  border-radius: 14px;\n  padding: 0\n}\n\n@keyframes vkuianimation-actionsheet-intro {\n  0% {\n    transform: translateY(100%)\n  }\n\n  to {\n    transform: translateY(0)\n  }\n}\n\n.vkuiPopper {\n  z-index: 100;\n  z-index: var(--vkui--z_index_popout)\n}\n\n.vkuiPopperArrow {\n  position: absolute\n}\n\n.vkuiPopperArrow__in {\n  content: \"\";\n  display: block;\n  transform: translateY(1px)\n}\n\n.vkuiPopperArrow--placement-right {\n  transform: rotate(90deg) translate(50%, -50%);\n  transform-origin: right\n}\n\n.vkuiPopperArrow--placement-bottom {\n  transform: rotate(180deg)\n}\n\n.vkuiPopperArrow--placement-left {\n  transform: rotate(-90deg) translate(-50%, -50%);\n  transform-origin: left\n}\n\n.vkuiActionSheetItem {\n  align-items: center;\n  box-sizing: border-box;\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  display: flex;\n  min-height: 48px;\n  overflow: hidden;\n  padding: 0 20px;\n  position: relative;\n  text-decoration: none\n}\n\n.vkuiActionSheetItem__after,\n.vkuiActionSheetItem__before,\n.vkuiActionSheetItem__container {\n  position: relative\n}\n\n.vkuiActionSheetItem__after,\n.vkuiActionSheetItem__before {\n  flex-shrink: 0\n}\n\n.vkuiActionSheetItem__container {\n  flex-grow: 1;\n  max-width: 100%;\n  padding: 10px 0\n}\n\n.vkuiActionSheetItem--ellipsis {\n  overflow: hidden;\n  white-space: nowrap\n}\n\n.vkuiActionSheetItem__content {\n  align-items: baseline;\n  display: flex;\n  justify-content: space-between;\n  overflow: hidden\n}\n\n.vkuiActionSheetItem--ellipsis .vkuiActionSheetItem__content {\n  justify-content: flex-start\n}\n\n.vkuiActionSheetItem__children {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis\n}\n\n.vkuiActionSheetItem__subtitle {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  margin-top: 2px;\n  overflow: hidden;\n  text-overflow: ellipsis\n}\n\n.vkuiActionSheetItem__meta {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  flex-shrink: 0;\n  margin-left: 6px\n}\n\n.vkuiActionSheetItem__before {\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent);\n  margin-right: 16px\n}\n\n.vkuiActionSheetItem--menu .vkuiActionSheetItem__before {\n  margin-right: 12px\n}\n\n.vkuiActionSheetItem--ios .vkuiActionSheetItem__before {\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent_themed);\n  margin-right: 18px\n}\n\n.vkuiActionSheetItem--mode-destructive .vkuiActionSheetItem__container:first-child {\n  color: #e64646;\n  color: var(--vkui--color_text_negative)\n}\n\n.vkuiActionSheetItem--mode-destructive .vkuiActionSheetItem__before {\n  color: #e64646;\n  color: var(--vkui--color_icon_negative)\n}\n\n.vkuiActionSheetItem__after {\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent);\n  display: flex;\n  flex-direction: row;\n  margin-left: 16px\n}\n\n.vkuiActionSheetItem__after>:not(:last-child) {\n  margin-right: 12px\n}\n\n.vkuiActionSheetItem--ios {\n  background: #fff;\n  background: var(--vkui--color_background_modal);\n  color: #2688eb;\n  color: var(--vkui--color_text_accent_themed);\n  min-height: 56px;\n  padding: 14px 18px\n}\n\n.vkuiActionSheetItem--rich {\n  color: #000;\n  color: var(--vkui--color_text_primary)\n}\n\n.vkuiActionSheet--ios.vkuiActionSheetItem--selectable {\n  padding: 14px 16px\n}\n\n.vkuiActionSheetItem--ios.vkuiActionSheetItem--mode-destructive {\n  color: #e64646;\n  color: var(--vkui--color_text_negative)\n}\n\n.vkuiActionSheetItem--ios:before {\n  background-color: #fff;\n  background-color: var(--vkui--color_background_modal);\n  content: \"\";\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  transition: opacity .15s ease-out, background-color .15s ease-out;\n  width: 100%\n}\n\n.vkuiActionSheetItem--ios:after {\n  background: rgba(0, 0, 0, .12);\n  background: var(--vkui--color_separator_primary_alpha);\n  content: \"\";\n  height: 1px;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  transform-origin: center bottom\n}\n\n@media (-webkit-min-device-pixel-ratio:2),\n(min-resolution:2dppx) {\n  .vkuiActionSheetItem--ios:after {\n    transform: scaleY(.5)\n  }\n}\n\n@media (-webkit-min-device-pixel-ratio:3),\n(min-resolution:3dppx) {\n  .vkuiActionSheetItem--ios:after {\n    transform: scaleY(.33)\n  }\n}\n\n.vkuiActionSheet--ios .vkuiActionSheetItem--last:after,\n.vkuiActionSheet--ios .vkuiActionSheet__header:empty,\n.vkuiActionSheetItem--ios:first-child:after,\n.vkuiActionSheetItem--mode-cancel:after {\n  content: none\n}\n\n.vkuiActionSheetItem--ios.vkuiActionSheetItem--active:before {\n  background-color: rgba(0, 16, 61, .08);\n  background-color: var(--vkui--color_transparent--active);\n  opacity: 1;\n  transition: none\n}\n\n.vkuiActionSheetItem--ios .vkuiActionSheetItem__container {\n  padding: 0\n}\n\n.vkuiActionSheetItem--ios .vkuiActionSheetItem--centered {\n  justify-content: center\n}\n\n.vkuiActionSheetItem--mode-cancel {\n  min-height: 52px\n}\n\n.vkuiActionSheetItem--menu {\n  cursor: pointer;\n  width: auto\n}\n\n.vkuiActionSheetItem[disabled] .vkuiActionSheetItem__children,\n.vkuiActionSheetItem[disabled] .vkuiActionSheetItem__meta,\n.vkuiActionSheetItem[disabled] .vkuiActionSheetItem__subtitle {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiActionSheetItem[disabled] .vkuiActionSheetItem__before,\n.vkuiActionSheetItem[disabled] .vkuiActionSheetItem__marker {\n  color: #99a2ad;\n  color: var(--vkui--color_icon_secondary)\n}\n\n.vkuiActionSheetItem--sizeY-compact {\n  min-height: 32px\n}\n\n.vkuiActionSheetItem--sizeY-compact.vkuiActionSheetItem--ios {\n  min-height: 36px;\n  padding: 4px 20px 4px 18px\n}\n\n.vkuiActionSheetItem--sizeY-compact:not(.vkuiActionSheetItem--ios)+.vkuiActionSheetItem--sizeY-compact:not(.vkuiActionSheetItem--ios) {\n  margin-top: 2px\n}\n\n.vkuiActionSheetItem--sizeY-compact .vkuiActionSheetItem__container {\n  padding: 5px 0\n}\n\n.vkuiActionSheetItemRadio__input~* {\n  display: none\n}\n\n.vkuiActionSheetItemRadio__input:checked~* {\n  display: block\n}\n\n.vkuiScreenSpinner {\n  animation: vkuiscreen-spinner-intro .3s ease\n}\n\n.vkuiScreenSpinner--clickable {\n  cursor: pointer\n}\n\n.vkuiScreenSpinner__spinner {\n  opacity: 1;\n  transition: opacity .1s ease\n}\n\n.vkuiScreenSpinner__spinner--hidden {\n  opacity: 0\n}\n\n.vkuiScreenSpinner__container {\n  background: #fff;\n  background: var(--vkui--color_background_modal);\n  border-radius: 8px;\n  border-radius: var(--vkui--size_border_radius--regular);\n  box-shadow: 0 0 8px rgba(0, 0, 0, .12), 0 16px 16px rgba(0, 0, 0, .16);\n  box-shadow: var(--vkui--elevation4);\n  color: #818c99;\n  color: var(--vkui--color_icon_medium);\n  height: 88px;\n  position: relative;\n  width: 88px\n}\n\n.vkuiScreenSpinner__icon {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  width: 100%\n}\n\n.vkuiScreenSpinner__icon .vkuiIcon {\n  animation: vkuiscreen-spinner-intro .2s ease\n}\n\n.vkuiScreenSpinner__icon--state-done .vkuiIcon path {\n  stroke-dasharray: 50;\n  stroke-dashoffset: 50;\n  animation: vkuiscreen-spinner-icon-done .6s cubic-bezier(.4, 0, .2, 1) .3s forwards;\n  animation: vkuiscreen-spinner-icon-done .6s .3s var(--vkui--animation_easing_platform) forwards\n}\n\n@keyframes vkuiscreen-spinner-icon-done {\n  0% {\n    stroke-dashoffset: 50\n  }\n\n  to {\n    stroke-dashoffset: 0\n  }\n}\n\n@keyframes vkuiscreen-spinner-intro {\n  0% {\n    opacity: 0\n  }\n\n  to {\n    opacity: 1\n  }\n}\n\n.vkuiSnackbar {\n  bottom: 0;\n  left: auto;\n  padding-bottom: 0;\n  padding-bottom: var(--vkui_internal--safe_area_inset_bottom);\n  padding-left: 0;\n  padding-left: var(--vkui_internal--safe_area_inset_left);\n  padding-right: 0;\n  padding-right: var(--vkui_internal--safe_area_inset_right);\n  position: fixed;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  width: 100%;\n  z-index: 100;\n  z-index: var(--vkui--z_index_popout)\n}\n\n.vkuiInternalEpic--hasTabbar .vkuiSnackbar {\n  padding-bottom: calc(48px + 0px);\n  padding-bottom: calc(var(--vkui_internal--tabbar_height) + var(--vkui_internal--safe_area_inset_bottom))\n}\n\n.vkuiSnackbar__body,\n.vkuiSnackbar__in {\n  transition: transform .32s cubic-bezier(.4, 0, .2, 1);\n  transition: transform .32s var(--vkui--animation_easing_platform)\n}\n\n.vkuiSnackbar__in {\n  animation: vkuianimation-snackbar-intro-vertical .34s cubic-bezier(.4, 0, .2, 1);\n  animation: vkuianimation-snackbar-intro-vertical .34s var(--vkui--animation_easing_platform);\n  padding: 8px\n}\n\n.vkuiSnackbar--closing .vkuiSnackbar__in {\n  transform: translate3d(0, 140%, 0)\n}\n\n.vkuiSnackbar__body {\n  align-items: center;\n  background: #fff;\n  background: var(--vkui--color_background_modal);\n  border-radius: 8px;\n  border-radius: var(--vkui--size_card_border_radius--regular);\n  box-shadow: 0 0 8px rgba(0, 0, 0, .12), 0 16px 16px rgba(0, 0, 0, .16);\n  box-shadow: var(--vkui--elevation4);\n  box-sizing: border-box;\n  display: flex;\n  min-height: 56px;\n  padding: 12px\n}\n\n.vkuiSnackbar--mode-dark .vkuiSnackbar__body {\n  background: #2c2d2e;\n  background: var(--vkui--color_background_contrast_inverse)\n}\n\n.vkuiSnackbar__before {\n  margin-right: 12px\n}\n\n.vkuiSnackbar__after {\n  margin-left: 12px\n}\n\n.vkuiSnackbar__content {\n  align-items: center;\n  display: flex;\n  flex: 1;\n  overflow: hidden\n}\n\n.vkuiSnackbar--layout-vertical .vkuiSnackbar__content {\n  align-items: flex-start;\n  flex-direction: column\n}\n\n.vkuiSnackbar__content-text {\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  display: -webkit-box;\n  flex: 1;\n  overflow: hidden;\n  width: 100%\n}\n\n.vkuiSnackbar__content-subtitle {\n  color: #6d7885;\n  color: var(--vkui--color_text_subhead);\n  margin-top: 2px\n}\n\n.vkuiSnackbar--mode-dark .vkuiSnackbar__content-text {\n  color: #fff;\n  color: var(--vkui--color_text_contrast)\n}\n\n.vkuiSnackbar--layout-horizontal .vkuiSnackbar__action {\n  margin-left: 12px;\n  position: relative\n}\n\n.vkuiSnackbar--layout-vertical .vkuiSnackbar__action {\n  margin-top: 2px;\n  min-height: auto\n}\n\n.vkuiModalRoot .vkuiSnackbar {\n  padding-bottom: 0;\n  padding-bottom: var(--vkui_internal--safe_area_inset_bottom)\n}\n\n.vkuiSnackbar--ios .vkuiSnackbar__body,\n.vkuiSnackbar--ios .vkuiSnackbar__in {\n  transition: transform .4s cubic-bezier(.4, 0, .2, 1);\n  transition: transform .4s var(--vkui--animation_easing_platform)\n}\n\n.vkuiSnackbar--desktop {\n  bottom: 0;\n  left: 0;\n  max-width: 351px\n}\n\n.vkuiSnackbar--desktop .vkuiSnackbar__in {\n  animation-name: vkuianimation-snackbar-intro-horizontal;\n  padding: 12px\n}\n\n.vkuiSnackbar--desktop.vkuiSnackbar--closing .vkuiSnackbar__in {\n  transform: translate3d(-140%, 0, 0)\n}\n\n.vkuiSnackbar--touched .vkuiSnackbar__body {\n  transition: none\n}\n\n@keyframes vkuianimation-snackbar-intro-vertical {\n  0% {\n    transform: translate3d(0, 140%, 0)\n  }\n\n  to {\n    transform: translateZ(0)\n  }\n}\n\n@keyframes vkuianimation-snackbar-intro-horizontal {\n  0% {\n    transform: translate3d(-140%, 0, 0)\n  }\n\n  to {\n    transform: translateZ(0)\n  }\n}\n\n.vkuiModalRoot,\n.vkuiModalRoot__mask {\n  height: 100%;\n  width: 100%\n}\n\n.vkuiModalRoot__mask {\n  animation: vkuianimation-fade-in .32s ease;\n  background: rgba(0, 0, 0, .4);\n  left: 0;\n  opacity: 1;\n  position: absolute;\n  top: 0;\n  transition: opacity 167ms ease-out;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none\n}\n\n.vkuiModalRoot--touched .vkuiModalRoot__mask {\n  transition: none\n}\n\n.vkuiModalRoot--switching .vkuiModalRoot__mask {\n  pointer-events: none\n}\n\n.vkuiModalRoot__viewport {\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n  position: absolute;\n  right: 0;\n  top: 0\n}\n\n:not(.vkuiModalRoot--desktop).vkuiModalRoot .vkuiModalRoot__viewport {\n  top: 0;\n  top: var(--vkui_internal--safe_area_inset_top)\n}\n\n:not(.vkuiModalRoot--desktop).vkuiModalRoot--hasCustomPanelHeaderAfterSlot .vkuiModalRoot__viewport {\n  top: calc(0px + 56px);\n  top: calc(var(--vkui_internal--safe_area_inset_top) + var(--vkui--size_panel_header_height--regular))\n}\n\n.vkuiModalRoot__modal {\n  box-sizing: border-box;\n  height: 100%;\n  position: absolute;\n  width: 100%\n}\n\n@keyframes vkuianimation-fade-in {\n  0% {\n    opacity: 0\n  }\n\n  to {\n    opacity: 1\n  }\n}\n\n.vkuiModalPage {\n  box-sizing: border-box;\n  height: 100%;\n  overflow: hidden;\n  pointer-events: none;\n  position: absolute;\n  width: 100%\n}\n\n.vkuiModalPage--desktop {\n  align-items: center;\n  display: flex;\n  justify-content: center\n}\n\n.vkuiModalPage__in-wrap {\n  align-items: flex-end;\n  bottom: 0;\n  display: flex;\n  height: 100%;\n  left: 0;\n  margin-left: auto;\n  margin-right: auto;\n  pointer-events: auto;\n  position: absolute;\n  right: 0;\n  transform: translateY(100%);\n  transition: transform .32s cubic-bezier(.4, 0, .2, 1);\n  transition: transform .32s var(--vkui--animation_easing_platform);\n  width: 100%\n}\n\n.vkuiModalPage--ios .vkuiModalPage__in-wrap {\n  transition: transform .4s cubic-bezier(.4, 0, .2, 1);\n  transition: transform .4s var(--vkui--animation_easing_platform)\n}\n\n.vkuiModalPage--desktop .vkuiModalPage__in-wrap {\n  align-items: normal;\n  height: auto;\n  margin: 32px 56px;\n  max-height: 640px;\n  opacity: 0;\n  position: relative;\n  transform: none;\n  transition: opacity .34s cubic-bezier(.4, 0, .2, 1);\n  transition: opacity .34s var(--vkui--animation_easing_platform)\n}\n\n@media (max-height:672px) {\n  .vkuiModalPage--desktop .vkuiModalPage__in-wrap {\n    max-height: calc(100% - 32px * 2)\n  }\n}\n\n.vkuiModalPage--size-s .vkuiModalPage__in-wrap {\n  max-width: 430px;\n  max-width: var(--vkui--size_popup_small--regular)\n}\n\n.vkuiModalPage--size-m .vkuiModalPage__in-wrap {\n  max-width: 680px;\n  max-width: var(--vkui--size_popup_medium--regular)\n}\n\n.vkuiModalPage--size-l .vkuiModalPage__in-wrap {\n  max-width: 880px;\n  max-width: var(--vkui--size_popup_large--regular)\n}\n\n.vkuiModalPage__in {\n  --vkui_internal--background: var(--vkui--color_background_modal);\n  background-color: #fff;\n  background-color: var(--vkui--color_background_modal);\n  border-top-left-radius: 12px;\n  border-top-left-radius: var(--vkui--size_border_radius_paper--regular);\n  border-top-right-radius: 12px;\n  border-top-right-radius: var(--vkui--size_border_radius_paper--regular);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: visible;\n  position: relative;\n  width: 100%\n}\n\n.vkuiModalPage--desktop .vkuiModalPage__in {\n  border-bottom-left-radius: 12px;\n  border-bottom-left-radius: var(--vkui--size_border_radius_paper--regular);\n  border-bottom-right-radius: 12px;\n  border-bottom-right-radius: var(--vkui--size_border_radius_paper--regular);\n  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);\n  box-shadow: var(--vkui--elevation3);\n  height: auto\n}\n\n.vkuiModalPage__header {\n  width: 100%\n}\n\n.vkuiModalPage__content-wrap {\n  border-bottom-left-radius: inherit;\n  border-bottom-right-radius: inherit;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n  position: relative\n}\n\n.vkuiModalPage__header:empty+.vkuiModalPage__content-wrap {\n  border-radius: inherit\n}\n\n.vkuiModalPage__content {\n  box-sizing: border-box;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: hidden\n}\n\n.vkuiInternalModalRoot__modal--expandable .vkuiModalPage__content,\n.vkuiModalPage--desktop .vkuiModalPage__content {\n  -webkit-overflow-scrolling: touch;\n  overflow-y: auto\n}\n\n.vkuiInternalModalRoot__modal--expandable .vkuiModalPage__content-in,\n.vkuiModalPage--desktop .vkuiModalPage__content-in {\n  height: 100%\n}\n\n.vkuiModalPage__bottom-inset {\n  flex-shrink: 0;\n  height: 0;\n  height: var(--vkui_internal--safe_area_inset_bottom)\n}\n\n.vkuiInternalModalRoot--touched .vkuiModalPage__in-wrap {\n  transition: none\n}\n\n.vkuiInternalModalRoot--switching .vkuiModalPage__in-wrap {\n  pointer-events: none\n}\n\n.vkuiInternalModalRoot__modal--collapsed .vkuiModalPage__content,\n.vkuiInternalModalRoot__modal--dragging .vkuiModalPage__content {\n  overflow: hidden;\n  touch-action: pan-y\n}\n\n.vkuiModalPageHeader {\n  --vkui_internal--safe_area_inset_top: 0\n}\n\n.vkuiModalPageHeader--withGaps {\n  padding-left: 4px;\n  padding-right: 4px\n}\n\n.vkuiModalPageHeader--desktop.vkuiModalPageHeader--withGaps {\n  padding-left: 8px;\n  padding-right: 8px\n}\n\n.vkuiModalPageHeader .vkuiIcon--cancel_24,\n.vkuiModalPageHeader .vkuiIcon--dismiss_24 {\n  color: #99a2ad;\n  color: var(--vkui--color_icon_secondary)\n}\n\n.vkuiModalCard {\n  align-items: flex-end;\n  box-sizing: border-box;\n  display: flex;\n  height: 100%;\n  left: 0;\n  padding: 8px;\n  position: absolute;\n  top: 0;\n  width: 100%\n}\n\n.vkuiModalCard__in {\n  margin-left: auto;\n  margin-right: auto;\n  transform: translateY(calc(100% + 16px));\n  transition: transform .34s cubic-bezier(.4, 0, .2, 1);\n  transition: transform .34s var(--vkui--animation_easing_platform);\n  width: 100%\n}\n\n.vkuiModalCard--ios .vkuiModalCard__in {\n  max-width: 414px\n}\n\n.vkuiModalCard--android .vkuiModalCard__in {\n  max-width: 440px\n}\n\n.vkuiModalCard--vkcom .vkuiModalCard__in {\n  max-width: 400px\n}\n\n.vkuiModalCard--desktop {\n  align-items: center\n}\n\n.vkuiModalCard--desktop .vkuiModalCard__in {\n  opacity: 0;\n  transform: unset;\n  transition: opacity .34s cubic-bezier(.4, 0, .2, 1);\n  transition: opacity .34s var(--vkui--animation_easing_platform)\n}\n\n.vkuiInternalModalRoot--touched .vkuiModalCard__in {\n  transition: none\n}\n\n.vkuiModalCardBase__container {\n  --vkui_internal--background: var(--vkui--color_background_modal);\n  background: #fff;\n  background: var(--vkui--color_background_modal);\n  border-radius: 12px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);\n  box-shadow: var(--vkui--elevation3);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-bottom: 0;\n  margin-bottom: var(--vkui_internal--safe_area_inset_bottom);\n  padding: 16px;\n  pointer-events: auto;\n  position: relative\n}\n\n.vkuiModalCardBase__container--softwareKeyboardOpened {\n  margin-bottom: 0\n}\n\n.vkuiModalCardBase__header,\n.vkuiModalCardBase__subheader {\n  margin: 0;\n  padding: 0 8px;\n  text-align: center;\n  word-break: break-word\n}\n\n.vkuiModalCardBase__header {\n  color: #000;\n  color: var(--vkui--color_text_primary)\n}\n\n.vkuiModalCardBase__subheader {\n  color: #6d7885;\n  color: var(--vkui--color_text_subhead)\n}\n\n.vkuiModalCardBase__header+.vkuiModalCardBase__subheader {\n  margin-top: 8px\n}\n\n.vkuiModalCardBase__icon {\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent);\n  margin: 8px auto 16px\n}\n\n.vkuiModalCardBase__actions {\n  display: flex;\n  margin-top: 16px\n}\n\n.vkuiInternalUsersStack+.vkuiModalCardBase__actions {\n  margin-top: 24px\n}\n\n.vkuiModalCardBase__header+.vkuiModalCardBase__actions,\n.vkuiModalCardBase__subheader+.vkuiModalCardBase__actions {\n  margin-top: 32px\n}\n\n.vkuiModalCardBase__dismiss {\n  color: #99a2ad;\n  color: var(--vkui--color_icon_secondary);\n  height: 48px;\n  justify-content: center;\n  position: absolute;\n  right: 4px;\n  top: 4px;\n  width: 48px\n}\n\n.vkuiModalCardBase--ios .vkuiModalCardBase__header:first-child {\n  padding-left: 36px;\n  padding-right: 36px\n}\n\n.vkuiModalCardBase--ios .vkuiModalCardBase__container {\n  border-radius: 14px\n}\n\n.vkuiModalCardBase--desktop .vkuiModalCardBase__container {\n  padding: 24px\n}\n\n.vkuiBadge {\n  border-radius: 50%;\n  display: block;\n  flex-grow: 0;\n  flex-shrink: 0;\n  height: 6px;\n  width: 6px\n}\n\n.vkuiBadge--mode-new {\n  background-color: #2688eb;\n  background-color: var(--vkui--color_icon_accent)\n}\n\n.vkuiBadge--mode-prominent {\n  background-color: #ff3347;\n  background-color: var(--vkui--color_accent_red)\n}\n\n.vkuiInternalTabbarItem__label .vkuiBadge {\n  position: absolute;\n  right: -2px;\n  top: -2px\n}\n\n.vkuiButtonGroup {\n  display: inline-flex;\n  max-width: 100%\n}\n\n.vkuiButtonGroup--stretched {\n  display: flex;\n  width: 100%\n}\n\n.vkuiButtonGroup--mode-vertical {\n  flex-direction: column\n}\n\n.vkuiButtonGroup--mode-horizontal {\n  align-items: flex-start;\n  flex-direction: row\n}\n\n.vkuiButtonGroup--mode-vertical.vkuiButtonGroup--gap-space>:not(:first-child) {\n  margin-top: 1px;\n  margin-top: var(--vkui--size_button_group_gap_space--regular)\n}\n\n.vkuiButtonGroup--mode-vertical.vkuiButtonGroup--gap-s>:not(:first-child) {\n  margin-top: 8px;\n  margin-top: var(--vkui--size_button_group_gap_small--regular)\n}\n\n.vkuiButtonGroup--mode-vertical.vkuiButtonGroup--gap-m>:not(:first-child) {\n  margin-top: 12px;\n  margin-top: var(--vkui--size_button_group_gap_medium--regular)\n}\n\n.vkuiButtonGroup--mode-horizontal>:not(.vkuiButtonGroup) {\n  min-width: 0\n}\n\n.vkuiButtonGroup--mode-horizontal.vkuiButtonGroup--gap-space>:not(:last-child) {\n  margin-right: 1px;\n  margin-right: var(--vkui--size_button_group_gap_space--regular)\n}\n\n.vkuiButtonGroup--mode-horizontal.vkuiButtonGroup--gap-s>:not(:last-child) {\n  margin-right: 8px;\n  margin-right: var(--vkui--size_button_group_gap_small--regular)\n}\n\n.vkuiButtonGroup--mode-horizontal.vkuiButtonGroup--gap-m>:not(:last-child) {\n  margin-right: 12px;\n  margin-right: var(--vkui--size_button_group_gap_medium--regular)\n}\n\n.vkuiButtonGroup--mode-vertical.vkuiButtonGroup--align-left {\n  align-items: flex-start\n}\n\n.vkuiButtonGroup--mode-vertical.vkuiButtonGroup--align-center {\n  align-items: center\n}\n\n.vkuiButtonGroup--mode-vertical.vkuiButtonGroup--align-right {\n  align-items: flex-end\n}\n\n.vkuiButtonGroup--mode-horizontal.vkuiButtonGroup--align-left {\n  justify-content: flex-start\n}\n\n.vkuiButtonGroup--mode-horizontal.vkuiButtonGroup--align-center {\n  justify-content: center\n}\n\n.vkuiButtonGroup--mode-horizontal.vkuiButtonGroup--align-right {\n  justify-content: flex-end\n}\n\n.vkuiCard {\n  background: #f5f5f5;\n  background: var(--vkui--color_background_secondary);\n  border-radius: 8px;\n  border-radius: var(--vkui--size_card_border_radius--regular);\n  position: relative\n}\n\n.vkuiCard--mode-shadow {\n  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);\n  box-shadow: var(--vkui--elevation3, 0 2px 24px 0 rgba(0, 0, 0, .08), 0 0 2px 0 rgba(0, 0, 0, .08))\n}\n\n.vkuiCard--mode-outline,\n.vkuiCard--mode-shadow {\n  background: #fff;\n  background: var(--vkui--color_background_modal)\n}\n\n.vkuiCard--withBorder:after {\n  border: var(--vkui--size_border--regular) solid var(--vkui--color_image_border_alpha);\n  border-radius: inherit;\n  box-sizing: border-box;\n  content: \"\";\n  display: block;\n  height: 100%;\n  left: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  width: 100%\n}\n\n.vkuiInternalCardScroll .vkuiCard {\n  flex-shrink: 0;\n  margin-right: 8px;\n  margin-right: var(--vkui--size_cardgrid_padding--regular)\n}\n\n.vkuiInternalCardScroll .vkuiCard:last-of-type {\n  margin-right: 0\n}\n\n.vkuiInternalCardScroll--size-s .vkuiCard {\n  width: 40%\n}\n\n.vkuiInternalCardScroll--size-m .vkuiCard {\n  width: 62%\n}\n\n.vkuiInternalCardScroll--size-l .vkuiCard {\n  margin-right: 16px;\n  margin-right: var(--vkui--size_base_padding_horizontal--regular);\n  width: calc(100% - 16px * 2);\n  width: calc(100% - var(--vkui--size_base_padding_horizontal--regular) * 2)\n}\n\n.vkuiInternalGroup--mode-card .vkuiInternalCardScroll--size-l .vkuiCard,\n.vkuiInternalSplitCol--spaced .vkuiInternalCardScroll--size-l .vkuiCard {\n  margin-right: 16px;\n  width: calc(100% - 32px)\n}\n\n.vkuiInternalGroup--mode-card .vkuiInternalCardScroll--size-l .vkuiCard:last-of-type,\n.vkuiInternalSplitCol--spaced .vkuiInternalCardScroll--size-l .vkuiCard:last-of-type {\n  margin-right: 0\n}\n\n@media (min-width:768px) {\n  .vkuiInternalGroup--mode-none .vkuiInternalCardScroll--size-l .vkuiCard:last-of-type {\n    margin-right: 0\n  }\n\n  .vkuiInternalGroup--mode-none .vkuiInternalCardScroll--size-l .vkuiCard {\n    margin-right: 16px;\n    width: calc(100% - 32px)\n  }\n}\n\n.vkuiInternalCardGrid .vkuiCard {\n  margin-right: 8px;\n  margin-right: var(--vkui--size_cardgrid_padding--regular)\n}\n\n.vkuiInternalCardGrid--size-l .vkuiCard {\n  margin-right: 0;\n  width: 100%\n}\n\n.vkuiInternalCardGrid--size-l .vkuiCard:not(:first-child) {\n  margin-top: 8px;\n  margin-top: var(--vkui--size_cardgrid_padding--regular)\n}\n\n.vkuiInternalCardGrid--size-m .vkuiCard {\n  width: calc(50% - (8px / 2));\n  width: calc(50% - (var(--vkui--size_cardgrid_padding--regular) / 2))\n}\n\n.vkuiInternalCardGrid--size-m .vkuiCard:nth-child(n+3) {\n  margin-top: 8px;\n  margin-top: var(--vkui--size_cardgrid_padding--regular)\n}\n\n.vkuiInternalCardGrid--size-m .vkuiCard:nth-child(2n) {\n  margin-right: 0\n}\n\n.vkuiInternalCardGrid--size-s .vkuiCard {\n  width: calc((100% - 2 * 8px) / 3);\n  width: calc((100% - 2 * var(--vkui--size_cardgrid_padding--regular)) / 3)\n}\n\n.vkuiInternalCardGrid--size-s .vkuiCard:nth-child(n+4) {\n  margin-top: 8px;\n  margin-top: var(--vkui--size_cardgrid_padding--regular)\n}\n\n.vkuiInternalCardGrid--size-s .vkuiCard:nth-child(3n) {\n  margin-right: 0\n}\n\n.vkuiCardGrid {\n  align-items: flex-start;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start\n}\n\n.vkuiCardGrid--spaced {\n  padding: 12px 16px;\n  padding: var(--vkui--size_base_padding_vertical--regular) var(--vkui--size_base_padding_horizontal--regular)\n}\n\n.vkuiCardGrid--sizeX-compact {\n  padding-left: 16px;\n  padding-left: var(--vkui--size_base_padding_horizontal--regular);\n  padding-right: 16px;\n  padding-right: var(--vkui--size_base_padding_horizontal--regular)\n}\n\n@media (max-width:767.9px) {\n  .vkuiCardGrid--sizeX-none {\n    padding-left: 16px;\n    padding-left: var(--vkui--size_base_padding_horizontal--regular);\n    padding-right: 16px;\n    padding-right: var(--vkui--size_base_padding_horizontal--regular)\n  }\n}\n\n.vkuiCardGrid+.vkuiCardGrid {\n  margin-top: calc(8px * 2);\n  margin-top: calc(var(--vkui--size_cardgrid_padding_vertical--regular) * 2)\n}\n\n.vkuiInternalGroup--mode-card .vkuiCardGrid {\n  padding-left: 16px;\n  padding-left: var(--vkui--size_base_padding_horizontal--regular);\n  padding-right: 16px;\n  padding-right: var(--vkui--size_base_padding_horizontal--regular)\n}\n\n@media (min-width:768px) {\n  .vkuiInternalGroup--mode-none .vkuiCardGrid {\n    padding-left: 8px;\n    padding-right: 8px\n  }\n}\n\n.vkuiInternalGroup .vkuiCardGrid:first-child {\n  margin-top: 8px;\n  margin-top: var(--vkui--size_cardgrid_padding_vertical--regular)\n}\n\n.vkuiInternalGroup .vkuiCardGrid:last-child {\n  margin-bottom: 8px;\n  margin-bottom: var(--vkui--size_cardgrid_padding_vertical--regular)\n}\n\n.vkuiCardScroll__in {\n  align-items: stretch;\n  display: flex\n}\n\n.vkuiCardScroll__gap {\n  display: block;\n  flex-shrink: 0\n}\n\n.vkuiCardScroll+.vkuiCardScroll {\n  margin-top: 16px\n}\n\n.vkuiCardScroll--withSpaces .vkuiCardScroll__gap {\n  width: 16px;\n  width: var(--vkui--size_base_padding_horizontal--regular)\n}\n\n.vkuiInternalSplitCol--spaced .vkuiCardScroll--withSpaces .vkuiCardScroll {\n  margin-left: -16px;\n  margin-right: -16px\n}\n\n.vkuiInternalSplitCol--spaced .vkuiCardScroll--withSpaces .vkuiCardScroll__gap {\n  width: 16px\n}\n\n.vkuiInternalGroup--mode-card .vkuiCardScroll--withSpaces {\n  margin-left: -8px;\n  margin-right: -8px\n}\n\n.vkuiInternalGroup--mode-card .vkuiCardScroll--withSpaces:first-child {\n  padding-top: 8px;\n  padding-top: var(--vkui--size_cardgrid_padding_vertical--regular)\n}\n\n.vkuiInternalGroup--mode-card .vkuiCardScroll--withSpaces:last-child {\n  padding-bottom: 8px;\n  padding-bottom: var(--vkui--size_cardgrid_padding_vertical--regular)\n}\n\n@media (min-width:768px) {\n  .vkuiInternalGroup--mode-none .vkuiCardScroll--withSpaces {\n    margin-left: -8px;\n    margin-right: -8px\n  }\n\n  .vkuiInternalGroup--mode-none .vkuiCardScroll--withSpaces:first-child {\n    padding-top: 8px;\n    padding-top: var(--vkui--size_cardgrid_padding_vertical--regular)\n  }\n\n  .vkuiInternalGroup--mode-none .vkuiCardScroll--withSpaces:last-child {\n    padding-bottom: 8px;\n    padding-bottom: var(--vkui--size_cardgrid_padding_vertical--regular)\n  }\n}\n\n.vkuiContentCard--disabled {\n  opacity: .64;\n  opacity: var(--vkui--opacity_disable_accessibility)\n}\n\n.vkuiContentCard__body {\n  padding: 12px 16px;\n  padding: var(--vkui--size_base_padding_vertical--regular) var(--vkui--size_base_padding_horizontal--regular)\n}\n\n.vkuiContentCard__tappable {\n  border-radius: 8px;\n  border-radius: var(--vkui--size_card_border_radius--regular);\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  display: block;\n  text-decoration: none\n}\n\n.vkuiContentCard__img {\n  border-radius: 8px 8px 0 0;\n  border-radius: var(--vkui--size_card_border_radius--regular) var(--vkui--size_card_border_radius--regular) 0 0;\n  display: block;\n  object-fit: cover\n}\n\n.vkuiContentCard__text:not(:last-child) {\n  margin-bottom: 4px\n}\n\n.vkuiContentCard__caption,\n.vkuiContentCard__subtitle {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiHeader {\n  align-items: flex-start;\n  display: flex;\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_family_base);\n  padding: 0 0 0 16px;\n  padding-left: var(--vkui--size_base_padding_horizontal--regular);\n  padding-right: 16px;\n  padding-right: var(--vkui--size_base_padding_horizontal--regular);\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text\n}\n\n.vkuiHeader__main {\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  flex: 1 0 0;\n  min-width: 0\n}\n\n.vkuiHeader__content {\n  align-items: center;\n  display: flex\n}\n\n.vkuiHeader__content-in,\n.vkuiHeader__subtitle {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap\n}\n\n.vkuiHeader__content--multiline {\n  white-space: normal;\n  word-break: break-word\n}\n\n.vkuiHeader__subtitle {\n  display: block\n}\n\n.vkuiHeader--mode-secondary:not(.vkuiHeader--pi):not(.vkuiHeader--with-subtitle) .vkuiHeader__main,\n.vkuiHeader--mode-tertiary .vkuiHeader__main,\n.vkuiHeader__indicator,\n.vkuiHeader__subtitle {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiHeader__indicator {\n  flex-shrink: 0;\n  margin-left: 6px\n}\n\n.vkuiHeader--mode-primary .vkuiHeader__indicator {\n  color: #6d7885;\n  color: var(--vkui--color_text_subhead)\n}\n\n.vkuiHeader:not(.vkuiHeader--pi) .vkuiHeader__indicator {\n  align-self: center\n}\n\n.vkuiHeader--mode-secondary .vkuiHeader__indicator {\n  margin-left: 8px\n}\n\n.vkuiHeader__aside {\n  display: flex;\n  white-space: nowrap\n}\n\n.vkuiHeader__aside.vkuiHeader__aside>* {\n  margin-bottom: 7px;\n  margin-left: 12px;\n  margin-top: 13px\n}\n\n.vkuiHeader__aside>.vkuiIcon {\n  color: #99a2ad;\n  color: var(--vkui--color_icon_secondary);\n  position: relative\n}\n\n.vkuiHeader__aside>.vkuiIcon--24 {\n  margin-bottom: 5px;\n  margin-top: 11px\n}\n\n.vkuiHeader__aside>.vkuiIcon--16 {\n  margin-bottom: 9px;\n  margin-top: 15px\n}\n\n.vkuiHeader--mode-primary {\n  padding-bottom: 1px;\n  padding-top: 3px\n}\n\n.vkuiHeader__content {\n  margin-top: 12px\n}\n\n.vkuiHeader__content:last-child {\n  margin-bottom: 8px\n}\n\n.vkuiHeader--mode-tertiary .vkuiHeader__content {\n  margin-top: 15px\n}\n\n.vkuiHeader--mode-tertiary .vkuiHeader__content:last-child {\n  margin-bottom: 9px\n}\n\n.vkuiHeader__subtitle {\n  margin-bottom: 7px\n}\n\n.vkuiHeader--mode-primary .vkuiHeader__subtitle {\n  margin-bottom: 6px\n}\n\n.vkuiHeader--large .vkuiHeader__content {\n  margin-bottom: 6px;\n  margin-top: 10px\n}\n\n.vkuiInternalGroup--mode-plain:not(:first-of-type)>.vkuiHeader:first-child,\n.vkuiInternalGroup--mode-plain:not(:first-of-type)>.vkuiInternalTappable:first-child>.vkuiHeader {\n  margin-top: -16px\n}\n\n@media (max-width:767.9px) {\n\n  .vkuiInternalGroup--sizeX-none.vkuiInternalGroup--mode-none:not(:first-of-type)>.vkuiHeader:first-child,\n  .vkuiInternalGroup--sizeX-none.vkuiInternalGroup--mode-none:not(:first-of-type)>.vkuiInternalTappable:first-child>.vkuiHeader {\n    margin-top: -16px\n  }\n}\n\n.vkuiInternalGroup--mode-card>.vkuiHeader:not(.vkuiHeader--mode-tertiary):first-child,\n.vkuiInternalGroup--mode-card>.vkuiInternalTappable:first-child>.vkuiHeader:not(.vkuiHeader--mode-tertiary) {\n  margin-top: -4px\n}\n\n@media (min-width:768px) {\n\n  .vkuiInternalGroup--sizeX-none.vkuiInternalGroup--mode-none>.vkuiHeader:not(.vkuiHeader--mode-tertiary):first-child,\n  .vkuiInternalGroup--sizeX-none.vkuiInternalGroup--mode-none>.vkuiInternalTappable:first-child>.vkuiHeader:not(.vkuiHeader--mode-tertiary) {\n    margin-top: -4px\n  }\n}\n\n.vkuiHeader__aside {\n  --vkui_internal--link-color: var(--vkui--color_text_accent)\n}\n\n.vkuiGroup {\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  /* padding-bottom: 8px;\n  padding-top: 8px */\n}\n\n.vkuiGroup__header:empty {\n  display: none\n}\n\n.vkuiGroup--mode-plain:not(:first-of-type)>.vkuiGroup__header {\n  margin-top: -8px\n}\n\n@media (max-width:767.9px) {\n  .vkuiGroup--sizeX-none.vkuiGroup--mode-none:not(:first-of-type)>.vkuiGroup__header {\n    margin-top: -8px\n  }\n}\n\n.vkuiGroup--mode-card>.vkuiGroup__header {\n  margin-top: -4px\n}\n\n@media (min-width:768px) {\n  .vkuiGroup--sizeX-none.vkuiGroup--mode-none>.vkuiGroup__header {\n    margin-top: -4px\n  }\n}\n\n.vkuiGroup__separator--separator,\n.vkuiGroup__separator--spacing {\n  display: none\n}\n\n.vkuiGroup--mode-plain+*+.vkuiGroup__separator--separator {\n  display: block\n}\n\n@media (max-width:767.9px) {\n  .vkuiGroup--sizeX-none.vkuiGroup--mode-none+*+.vkuiGroup__separator--separator {\n    display: block\n  }\n}\n\n.vkuiGroup--mode-card+.vkuiGroup__separator--spacing {\n  display: block\n}\n\n@media (min-width:768px) {\n  .vkuiGroup--sizeX-none.vkuiGroup--mode-none+.vkuiGroup__separator--spacing {\n    display: block\n  }\n}\n\n.vkuiGroup:last-of-type~.vkuiGroup__separator {\n  display: none\n}\n\n.vkuiGroup--mode-card:last-of-type+.vkuiGroup__separator--spacing,\n.vkuiGroup:last-of-type~.vkuiGroup__separator--force {\n  display: block\n}\n\n@media (min-width:768px) {\n  .vkuiGroup--sizeX-none.vkuiGroup--mode-none:last-of-type+.vkuiGroup__separator--spacing {\n    display: block\n  }\n}\n\n.vkuiGroup--mode-card.vkuiGroup--padding-s {\n  padding: 4px\n}\n\n.vkuiGroup--mode-card.vkuiGroup--padding-m {\n  padding: 8px\n}\n\n@media (min-width:768px) {\n\n  .vkuiGroup--sizeX-none.vkuiGroup--inside-modal.vkuiGroup--padding-s,\n  .vkuiGroup--sizeX-none.vkuiGroup--mode-none.vkuiGroup--padding-s {\n    padding: 4px\n  }\n\n  .vkuiGroup--sizeX-none.vkuiGroup--inside-modal.vkuiGroup--padding-m,\n  .vkuiGroup--sizeX-none.vkuiGroup--mode-none.vkuiGroup--padding-m {\n    padding: 8px\n  }\n}\n\n.vkuiGroup--sizeX-compact,\n.vkuiGroup--sizeX-compact.vkuiGroup--mode-card {\n  padding-left: 0;\n  padding-right: 0\n}\n\n@media (max-width:767.9px) {\n\n  .vkuiGroup--sizeX-none,\n  .vkuiGroup--sizeX-none.vkuiGroup--mode-card {\n    padding-left: 0;\n    padding-right: 0\n  }\n}\n\n.vkuiGroup--mode-card {\n  background: #fff;\n  background: var(--vkui--color_background_content);\n  border-radius: 12px;\n  border-radius: var(--vkui--size_border_radius_paper--regular);\n  position: relative\n}\n\n@media (min-width:768px) {\n  .vkuiGroup--sizeX-none.vkuiGroup--mode-none {\n    background: #fff;\n    background: var(--vkui--color_background_content);\n    border-radius: 12px;\n    border-radius: var(--vkui--size_border_radius_paper--regular);\n    position: relative\n  }\n}\n\n.vkuiGroup--sizeX-compact.vkuiGroup--mode-card:first-of-type {\n  border-radius: 0 0 12px 12px;\n  border-radius: 0 0 var(--vkui--size_border_radius_paper--regular) var(--vkui--size_border_radius_paper--regular)\n}\n\n@media (max-width:767.9px) {\n  .vkuiGroup--sizeX-none.vkuiGroup--mode-card:first-of-type {\n    border-radius: 0 0 12px 12px;\n    border-radius: 0 0 var(--vkui--size_border_radius_paper--regular) var(--vkui--size_border_radius_paper--regular)\n  }\n}\n\n.vkuiGroup--mode-card:before {\n  border-radius: inherit;\n  box-shadow: inset 0 0 0 var(--vkui--size_border--regular) #d7d8d9;\n  box-shadow: inset 0 0 0 var(--vkui--size_border--regular) var(--vkui--color_separator_primary);\n  content: \"\";\n  height: 100%;\n  left: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  width: 100%\n}\n\n@media (min-width:768px) {\n  .vkuiGroup--sizeX-none.vkuiGroup--mode-none:before {\n    border-radius: inherit;\n    box-shadow: inset 0 0 0 var(--vkui--size_border--regular) rgba(0, 0, 0, .12);\n    box-shadow: inset 0 0 0 var(--vkui--size_border--regular) var(--vkui--color_field_border_alpha);\n    content: \"\";\n    height: 100%;\n    left: 0;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    width: 100%\n  }\n}\n\n.vkuiGroup--sizeX-compact.vkuiGroup--mode-card:before {\n  box-shadow: none\n}\n\n@media (max-width:767.9px) {\n  .vkuiGroup--sizeX-none.vkuiGroup--mode-card:before {\n    box-shadow: none\n  }\n}\n\n.vkuiGroup--mode-plain+.vkuiGroup__separator,\n.vkuiGroup--mode-plain+.vkuiGroup__separator+.vkuiGroup__separator {\n  padding-bottom: 8px;\n  padding-top: 8px\n}\n\n@media (max-width:767.9px) {\n\n  .vkuiGroup--sizeX-none.vkuiGroup--mode-none+.vkuiGroup__separator,\n  .vkuiGroup--sizeX-none.vkuiGroup--mode-none+.vkuiGroup__separator+.vkuiGroup__separator {\n    padding-bottom: 8px;\n    padding-top: 8px\n  }\n}\n\n.vkuiGroup__description {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  display: block;\n  padding: 4px 16px 16px\n}\n\n.vkuiGroup .vkuiGroup,\n.vkuiGroup .vkuiGroup+.vkuiGroup__separator {\n  padding-left: 0;\n  padding-right: 0\n}\n\n.vkuiGroup .vkuiGroup:first-of-type {\n  padding-top: 0\n}\n\n.vkuiGroup .vkuiGroup:last-of-type {\n  padding-bottom: 0\n}\n\n.vkuiGroup--ios .vkuiGroup__description {\n  padding: 4px 12px 16px\n}\n\n.vkuiInternalPanelHeader--vkcom+* .vkuiGroup:first-of-type,\n.vkuiInternalPanelHeader--vkcom~.vkuiGroup:first-of-type {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  position: relative;\n  top: -1px\n}\n\n.vkuiGradient--mode-tint.vkuiGradient--to-top {\n  background: linear-gradient(180deg, hsla(0, 0%, 98%, 0) 0, hsla(0, 0%, 98%, .036) 13%, hsla(0, 0%, 98%, .15) 27%, hsla(0, 0%, 98%, .79) 68%, hsla(0, 0%, 98%, .95) 84%, #f9f9f9);\n  background: linear-gradient(to bottom, var(--vkui--gradient_tint))\n}\n\n.vkuiGradient--mode-tint.vkuiGradient--to-bottom {\n  background: linear-gradient(0deg, hsla(0, 0%, 98%, 0) 0, hsla(0, 0%, 98%, .036) 13%, hsla(0, 0%, 98%, .15) 27%, hsla(0, 0%, 98%, .79) 68%, hsla(0, 0%, 98%, .95) 84%, #f9f9f9);\n  background: linear-gradient(to top, var(--vkui--gradient_tint))\n}\n\n.vkuiGradient--mode-white.vkuiGradient--to-top {\n  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0) 0, hsla(0, 0%, 100%, .036) 13%, hsla(0, 0%, 100%, .15) 27%, hsla(0, 0%, 100%, .79) 68%, hsla(0, 0%, 100%, .95) 84%, #fff);\n  background: linear-gradient(to bottom, var(--vkui--gradient_white))\n}\n\n.vkuiGradient--mode-white.vkuiGradient--to-bottom {\n  background: linear-gradient(0deg, hsla(0, 0%, 100%, 0) 0, hsla(0, 0%, 100%, .036) 13%, hsla(0, 0%, 100%, .15) 27%, hsla(0, 0%, 100%, .79) 68%, hsla(0, 0%, 100%, .95) 84%, #fff);\n  background: linear-gradient(to top, var(--vkui--gradient_white))\n}\n\n.vkuiGradient--mode-black.vkuiGradient--to-top {\n  background: linear-gradient(180deg, transparent 0, rgba(0, 0, 0, .014) 13%, rgba(0, 0, 0, .06) 27%, rgba(0, 0, 0, .316) 68%, rgba(0, 0, 0, .38) 84%, rgba(0, 0, 0, .4));\n  background: linear-gradient(to bottom, var(--vkui--gradient_black))\n}\n\n.vkuiGradient--mode-black.vkuiGradient--to-bottom {\n  background: linear-gradient(0deg, transparent 0, rgba(0, 0, 0, .014) 13%, rgba(0, 0, 0, .06) 27%, rgba(0, 0, 0, .316) 68%, rgba(0, 0, 0, .38) 84%, rgba(0, 0, 0, .4));\n  background: linear-gradient(to top, var(--vkui--gradient_black))\n}\n\n.vkuiList {\n  isolation: isolate\n}\n\n.vkuiCell {\n  position: relative\n}\n\n.vkuiInternalList--dragging .vkuiCell:not(.vkuiCell--dragging) {\n  pointer-events: none;\n  transition: transform .3s ease\n}\n\n.vkuiCell--dragging {\n  background-color: #f5f5f5;\n  background-color: var(--vkui--color_background_secondary);\n  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);\n  box-shadow: var(--vkui--elevation3);\n  z-index: 1;\n  z-index: var(--vkui_internal--z_index_cell_dragging)\n}\n\n.vkuiCell--selectable.vkuiCell--disabled {\n  opacity: .64;\n  opacity: var(--vkui--opacity_disable_accessibility)\n}\n\n.vkuiCell__checkbox,\n.vkuiCell__dragger {\n  flex-shrink: 0;\n  margin-right: 16px;\n  position: relative\n}\n\n.vkuiCell__content {\n  max-width: 100%;\n  min-width: 0\n}\n\n.vkuiCell--removable .vkuiCell__content {\n  flex-grow: 1;\n  padding-right: 44px\n}\n\n.vkuiCell--removable .vkuiInternalRemovable__content {\n  padding-left: 0\n}\n\n.vkuiCell--removable .vkuiInternalRemovable__action {\n  padding-left: 0;\n  position: absolute;\n  right: 0\n}\n\n.vkuiCell--ios .vkuiCell__dragger {\n  margin-left: 12px;\n  margin-right: 0\n}\n\n.vkuiCell--ios .vkuiCell__checkbox {\n  margin-right: 12px\n}\n\n.vkuiCell--ios.vkuiCell--removable .vkuiCell__content {\n  padding-left: 48px;\n  padding-right: 16px;\n  padding-right: var(--vkui--size_base_padding_horizontal--regular)\n}\n\n.vkuiCell--ios.vkuiCell--removable .vkuiInternalRemovable__action {\n  left: 0;\n  right: auto;\n  z-index: 1\n}\n\n.vkuiCell--ios.vkuiCell--removable .vkuiInternalRemovable__content {\n  padding-right: 0\n}\n\n.vkuiInternalFormItem>.vkuiCell {\n  margin: 0 calc(-1 * 16px);\n  margin: 0 calc(-1 * var(--vkui--size_base_padding_horizontal--regular))\n}\n\n.vkuiCellDragger {\n  color: #99a2ad;\n  color: var(--vkui--color_icon_secondary);\n  cursor: ns-resize\n}\n\n.vkuiCellCheckbox {\n  display: flex;\n  justify-content: center;\n  width: 24px\n}\n\n.vkuiCellCheckbox__icon {\n  color: #b8c1cc;\n  color: var(--vkui--color_icon_tertiary);\n  display: none\n}\n\n.vkuiCellCheckbox__icon--on {\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent)\n}\n\n.vkuiCellCheckbox__input:checked~.vkuiCellCheckbox__icon--on,\n.vkuiCellCheckbox__input:not(:checked)~.vkuiCellCheckbox__icon--off {\n  display: block\n}\n\n.vkuiRemovable__content {\n  align-items: center;\n  display: flex;\n  padding-left: 16px;\n  padding-left: var(--vkui--size_base_padding_horizontal--regular);\n  position: relative\n}\n\n.vkuiRemovable__action {\n  border: 0;\n  color: #99a2ad;\n  color: var(--vkui--color_icon_secondary);\n  flex-grow: 0;\n  flex-shrink: 0;\n  position: relative\n}\n\n.vkuiRemovable--align-start .vkuiRemovable__action {\n  align-self: flex-start\n}\n\n.vkuiRemovable--ios {\n  overflow: hidden\n}\n\n.vkuiRemovable__remove {\n  background-color: #e64646;\n  background-color: var(--vkui--color_background_negative);\n  border: 0;\n  border-radius: 0;\n  color: #fff;\n  color: var(--vkui_internal--white);\n  font-size: 15px;\n  height: 100%;\n  left: 100%;\n  line-height: 45px;\n  padding: 0 10px;\n  position: absolute;\n  top: 0\n}\n\n.vkuiRemovable__remove-in {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  width: 100%\n}\n\n@media (prefers-reduced-motion:no-preference) {\n  .vkuiRemovable--ios .vkuiRemovable__content {\n    transition: transform .6s cubic-bezier(.4, 0, .2, 1);\n    transition: transform .6s var(--vkui--animation_easing_platform)\n  }\n}\n\n.vkuiRemovable__toggle {\n  background: none;\n  display: block;\n  height: 44px;\n  margin: 0 2px;\n  width: 44px\n}\n\n.vkuiRemovable__toggle-in {\n  align-content: center;\n  align-items: center;\n  border: 0;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  position: relative;\n  width: 100%\n}\n\n.vkuiRemovable__toggle-in:after {\n  background-color: #e64646;\n  background-color: var(--vkui--color_background_negative);\n  border-radius: 50%;\n  content: \"\";\n  height: 22px;\n  width: 22px\n}\n\n.vkuiRemovable__toggle-in:before {\n  background-color: #fff;\n  background-color: var(--vkui_internal--white);\n  content: \"\";\n  display: block;\n  height: 2px;\n  position: absolute;\n  width: 12px\n}\n\n.vkuiRemovable--ios .vkuiRemovable__content {\n  padding-left: 0;\n  padding-right: 16px;\n  padding-right: var(--vkui--size_base_padding_horizontal--regular)\n}\n\n.vkuiRemovable--indent .vkuiRemovable__action {\n  pointer-events: none;\n  visibility: hidden\n}\n\n.vkuiInternalFormItem--removable .vkuiRemovable__content,\n.vkuiInternalFormLayoutGroup--removable .vkuiRemovable__content {\n  align-items: flex-start;\n  flex-wrap: wrap\n}\n\n.vkuiRemovable__offset {\n  display: none\n}\n\n.vkuiInternalFormItem--withTop .vkuiInternalFormItem__removable~.vkuiRemovable__offset,\n.vkuiInternalFormLayoutGroup--removable .vkuiInternalFormItem--withTop~.vkuiRemovable__offset {\n  display: block;\n  height: calc(2px + 18px + 8px);\n  height: calc(2px + var(--vkui--font_subhead--line_height--regular) + 8px);\n  order: -1;\n  width: 100%\n}\n\n.vkuiInternalFormItem--sizeY-compact.vkuiInternalFormItem--withTop .vkuiInternalFormItem__removable~.vkuiRemovable__offset,\n.vkuiInternalFormLayoutGroup--sizeY-compact.vkuiInternalFormLayoutGroup--removable .vkuiInternalFormItem--withTop~.vkuiRemovable__offset {\n  height: calc(2px + 16px + 6px);\n  height: calc(2px + var(--vkui--font_subhead--line_height--compact) + 6px)\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n\n  .vkuiInternalFormItem--sizeY-none.vkuiInternalFormItem--withTop .vkuiInternalFormItem__removable~.vkuiRemovable__offset,\n  .vkuiInternalFormLayoutGroup--sizeY-none.vkuiInternalFormLayoutGroup--removable .vkuiInternalFormItem--withTop~.vkuiRemovable__offset {\n    height: calc(2px + 16px + 6px);\n    height: calc(2px + var(--vkui--font_subhead--line_height--compact) + 6px)\n  }\n}\n\n.vkuiSimpleCell {\n  align-items: center;\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  display: flex;\n  min-height: 48px;\n  padding-left: 16px;\n  padding-left: var(--vkui--size_base_padding_horizontal--regular);\n  padding-right: 16px;\n  padding-right: var(--vkui--size_base_padding_horizontal--regular);\n  text-decoration: none;\n  white-space: nowrap\n}\n\n.vkuiSimpleCell--mult {\n  white-space: normal\n}\n\n.vkuiSimpleCell--mult .vkuiSimpleCell__children {\n  text-overflow: clip\n}\n\n.vkuiSimpleCell__before {\n  align-items: center;\n  color: #2688eb;\n  color: var(--vkui_internal--icon_color, var(--vkui--color_icon_accent));\n  display: flex;\n  padding-bottom: 6px;\n  padding-right: 12px;\n  padding-top: 6px\n}\n\n.vkuiSimpleCell__before>.vkuiIcon {\n  padding-right: 4px\n}\n\n.vkuiSimpleCell__before:empty {\n  display: none\n}\n\n.vkuiSimpleCell__middle {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: center;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  padding-bottom: 10px;\n  padding-top: 10px\n}\n\n.vkuiSimpleCell__middle>:not(:first-child) {\n  margin-top: 2px\n}\n\n.vkuiSimpleCell__subhead {\n  color: #6d7885;\n  color: var(--vkui--color_text_subhead)\n}\n\n.vkuiSimpleCell__text {\n  overflow: hidden;\n  text-overflow: ellipsis\n}\n\n.vkuiSimpleCell__extraSubtitle,\n.vkuiSimpleCell__subtitle {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiSimpleCell .vkuiSimpleCell__content {\n  align-content: flex-start;\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  max-width: 100%\n}\n\n.vkuiSimpleCell:not(.vkuiSimpleCell--mult) .vkuiSimpleCell__content {\n  justify-content: flex-start\n}\n\n.vkuiSimpleCell__children {\n  color: inherit;\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis\n}\n\n.vkuiSimpleCell--mult .vkuiSimpleCell__children,\n.vkuiSimpleCell--mult .vkuiSimpleCell__subtitle {\n  flex: 1 1 auto\n}\n\n.vkuiSimpleCell__badge {\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent);\n  display: inline-block;\n  flex-grow: 0;\n  flex-shrink: 0\n}\n\n.vkuiSimpleCell__content>:not(:last-child) {\n  margin-right: 4px\n}\n\n.vkuiSimpleCell__indicator {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  min-width: 0;\n  overflow: hidden;\n  padding-left: 12px;\n  text-overflow: ellipsis;\n  white-space: nowrap\n}\n\n.vkuiSimpleCell__after {\n  align-items: center;\n  color: #2688eb;\n  color: var(--vkui_internal--icon_color, var(--vkui--color_icon_accent));\n  display: flex;\n  flex-shrink: 0\n}\n\n.vkuiSimpleCell__after>.vkuiIcon {\n  padding-left: 8px\n}\n\n.vkuiSimpleCell__after>.vkuiIcon:last-child {\n  padding-right: 2px\n}\n\n.vkuiSimpleCell__chevronIcon {\n  color: #b8c1cc;\n  color: var(--vkui--color_icon_tertiary);\n  padding-left: 12px\n}\n\n.vkuiSimpleCell--sizeY-compact {\n  min-height: 44px\n}\n\n.vkuiSimpleCell--sizeY-compact .vkuiSimpleCell__before {\n  padding-bottom: 4px;\n  padding-top: 4px\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiSimpleCell--sizeY-none {\n    min-height: 44px\n  }\n\n  .vkuiSimpleCell--sizeY-none .vkuiSimpleCell__before {\n    padding-bottom: 4px;\n    padding-top: 4px\n  }\n}\n\n.vkuiInternalFormItem>.vkuiSimpleCell {\n  margin: 0 calc(-1 * 16px);\n  margin: 0 calc(-1 * var(--vkui--size_base_padding_horizontal--regular))\n}\n\n.vkuiRichCell {\n  box-sizing: border-box;\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  display: flex;\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_family_base);\n  min-height: 64px;\n  padding: 8px 16px;\n  padding: 8px var(--vkui--size_base_padding_horizontal--regular);\n  text-decoration: none\n}\n\n.vkuiRichCell--sizeY-compact {\n  min-height: 60px\n}\n\n.vkuiRichCell__before {\n  margin-right: 12px\n}\n\n.vkuiRichCell__in {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: center;\n  max-width: 100%;\n  min-width: 0\n}\n\n.vkuiRichCell__content {\n  display: flex;\n  word-break: break-word\n}\n\n.vkuiRichCell__content-before {\n  flex-grow: 1;\n  min-width: 0\n}\n\n.vkuiRichCell__content-after {\n  align-items: flex-end;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  padding-left: 12px\n}\n\n.vkuiRichCell__after-children {\n  font-weight: 500;\n  font-weight: var(--vkui--font_weight_accent2)\n}\n\n.vkuiRichCell__after-caption {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  font-size: 13px;\n  font-size: var(--vkui--font_footnote--font_size--regular);\n  line-height: 16px;\n  line-height: var(--vkui--font_footnote--line_height--regular);\n  margin-top: 2px\n}\n\n.vkuiRichCell--sizeY-compact .vkuiRichCell__after-caption {\n  font-size: 12px;\n  font-size: var(--vkui--font_caption1--font_size--regular);\n  line-height: 14px;\n  line-height: var(--vkui--font_caption1--line_height--regular)\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiRichCell--sizeY-none .vkuiRichCell__after-caption {\n    font-size: 12px;\n    font-size: var(--vkui--font_caption1--font_size--regular);\n    line-height: 14px;\n    line-height: var(--vkui--font_caption1--line_height--regular)\n  }\n}\n\n.vkuiRichCell__caption,\n.vkuiRichCell__subhead {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiRichCell__caption {\n  margin-top: 1px\n}\n\n.vkuiRichCell__children {\n  font-weight: 500;\n  font-weight: var(--vkui--font_weight_accent2)\n}\n\n.vkuiRichCell--text-ellipsis .vkuiRichCell__caption,\n.vkuiRichCell--text-ellipsis .vkuiRichCell__children,\n.vkuiRichCell--text-ellipsis .vkuiRichCell__subhead,\n.vkuiRichCell--text-ellipsis .vkuiRichCell__text {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap\n}\n\n.vkuiRichCell__bottom {\n  margin-top: 5px\n}\n\n.vkuiRichCell__actions {\n  margin-top: 8px\n}\n\n.vkuiRichCell__after-children,\n.vkuiRichCell__children,\n.vkuiRichCell__text {\n  font-size: 15px;\n  font-size: var(--vkui--font_paragraph--font_size--regular);\n  line-height: 20px;\n  line-height: var(--vkui--font_paragraph--line_height--regular)\n}\n\n.vkuiRichCell--sizeY-compact .vkuiRichCell__after-children,\n.vkuiRichCell--sizeY-compact .vkuiRichCell__children,\n.vkuiRichCell--sizeY-compact .vkuiRichCell__text {\n  font-size: 14px;\n  font-size: var(--vkui--font_subhead--font_size--regular);\n  line-height: 18px;\n  line-height: var(--vkui--font_subhead--line_height--regular)\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n\n  .vkuiRichCell--sizeY-none .vkuiRichCell__after-children,\n  .vkuiRichCell--sizeY-none .vkuiRichCell__children,\n  .vkuiRichCell--sizeY-none .vkuiRichCell__text {\n    font-size: 14px;\n    font-size: var(--vkui--font_subhead--font_size--regular);\n    line-height: 18px;\n    line-height: var(--vkui--font_subhead--line_height--regular)\n  }\n}\n\n.vkuiInternalFormItem .vkuiRichCell {\n  margin-left: calc(-1 * 16px);\n  margin-left: calc(-1 * var(--vkui--size_base_padding_horizontal--regular));\n  margin-right: calc(-1 * 16px);\n  margin-right: calc(-1 * var(--vkui--size_base_padding_horizontal--regular))\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiRichCell--sizeY-none {\n    min-height: 60px\n  }\n}\n\n.vkuiRichCellIcon {\n  align-items: center;\n  box-sizing: border-box;\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent_themed);\n  display: flex;\n  flex-direction: row;\n  height: 40px;\n  justify-content: flex-end;\n  padding: 6px 0 6px 12px;\n  width: 48px\n}\n\n.vkuiCellButton {\n  background: transparent;\n  border: 0;\n  box-sizing: border-box;\n  cursor: pointer;\n  margin: 0;\n  padding-bottom: 0;\n  padding-top: 0;\n  text-align: left;\n  text-decoration: none;\n  width: 100%\n}\n\n.vkuiInternalFormItem .vkuiCellButton {\n  box-sizing: initial;\n  margin: 0 calc(-1 * 16px);\n  margin: 0 calc(-1 * var(--vkui--size_base_padding_horizontal--regular));\n  width: 100%\n}\n\n.vkuiCellButton[disabled] {\n  opacity: .4\n}\n\n.vkuiCellButton--centered {\n  justify-content: center;\n  text-align: center\n}\n\n.vkuiCellButton--centered>* {\n  flex-grow: 0;\n  max-width: none\n}\n\n.vkuiCellButton--centered .vkuiIcon {\n  padding-right: 8px\n}\n\n.vkuiCellButton {\n  --vkui_internal--icon_color: var(--vkui--color_icon_accent);\n  color: #2688eb;\n  color: var(--vkui--color_text_accent)\n}\n\n.vkuiCellButton--mode-danger {\n  --vkui_internal--icon_color: var(--vkui--color_text_negative);\n  color: #e64646;\n  color: var(--vkui--color_text_negative)\n}\n\n.vkuiHorizontalCell {\n  display: flex\n}\n\n.vkuiHorizontalCell__image {\n  display: flex;\n  justify-content: center\n}\n\n.vkuiHorizontalCell__body {\n  font-family: inherit;\n  text-decoration: none\n}\n\n.vkuiHorizontalCell .vkuiHorizontalCell__body {\n  border-radius: 8px;\n  border-radius: var(--vkui--size_border_radius--regular)\n}\n\n.vkuiHorizontalCell__content {\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  text-overflow: ellipsis;\n  word-break: break-all\n}\n\n.vkuiHorizontalCell__subtitle {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiHorizontalCell__content .vkuiHorizontalCell__subtitle {\n  margin-top: 2px\n}\n\n.vkuiHorizontalCell--size-s {\n  --vkui_internal--side_cell_gap: calc(var(--vkui--size_base_padding_horizontal--regular) - var(--vkui--spacing_size_m));\n  --vkui_internal--side_cell_width: calc(72px + var(--vkui_internal--side_cell_gap));\n  max-width: 72px\n}\n\n.vkuiHorizontalCell__image {\n  padding: 4px 6px;\n  padding: 4px var(--vkui--spacing_size_s)\n}\n\n.vkuiHorizontalCell__content {\n  padding: 2px 6px 8px;\n  text-align: left\n}\n\n.vkuiHorizontalCell--size-s .vkuiHorizontalCell__image {\n  padding: 4px 8px;\n  padding: 4px var(--vkui--spacing_size_m)\n}\n\n.vkuiHorizontalCell--size-s .vkuiHorizontalCell__content {\n  padding: 2px 4px 8px;\n  text-align: center\n}\n\n.vkuiHorizontalCell--size-m {\n  --vkui_internal--side_cell_width: calc(100px + var(--vkui_internal--side_cell_gap));\n  width: 100px\n}\n\n.vkuiHorizontalCell--size-l {\n  width: auto\n}\n\n.vkuiHorizontalCell:first-child:before,\n.vkuiHorizontalCell:last-child:after {\n  content: \"\";\n  min-width: calc(16px - 6px);\n  min-width: var(--vkui_internal--side_cell_gap)\n}\n\n.vkuiHorizontalCell--size-s:first-child,\n.vkuiHorizontalCell--size-s:last-child {\n  max-width: var(--vkui_internal--side_cell_width)\n}\n\n.vkuiHorizontalCell--size-m:first-child,\n.vkuiHorizontalCell--size-m:last-child {\n  width: var(--vkui_internal--side_cell_width)\n}\n\n.vkuiAvatar {\n  border-radius: 50%\n}\n\n.vkuiAvatar--has-gradient {\n  color: #fff;\n  color: var(--vkui--color_text_contrast)\n}\n\n.vkuiAvatar--gradient-red {\n  background-color: #e52e40;\n  background-image: linear-gradient(135deg, #ff7583, #e52e40)\n}\n\n.vkuiAvatar--gradient-pink {\n  background-color: #e62e6b;\n  background-image: linear-gradient(135deg, #ff8880, #e62e6b)\n}\n\n.vkuiAvatar--gradient-orange {\n  background-color: #e66b2e;\n  background-image: linear-gradient(135deg, #ffbf80, #e66b2e)\n}\n\n.vkuiAvatar--gradient-yellow {\n  background-color: #e7a902;\n  background-image: linear-gradient(135deg, #ffd54f, #e7a902)\n}\n\n.vkuiAvatar--gradient-green {\n  background-color: #6cd97e;\n  background-image: linear-gradient(135deg, #6cd97e, #12b212)\n}\n\n.vkuiAvatar--gradient-l-blue {\n  background-color: #2bb4d6;\n  background-image: linear-gradient(135deg, #7df1fa, #2bb4d6)\n}\n\n.vkuiAvatar--gradient-blue {\n  background-color: #3f8ae0;\n  background-image: linear-gradient(135deg, #6cf, #3f8ae0)\n}\n\n.vkuiAvatar--gradient-violet {\n  background-color: #8f3fe0;\n  background-image: linear-gradient(135deg, #d3a6ff, #8f3fe0)\n}\n\n.vkuiAvatar__initials {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_family_accent);\n  font-weight: 600;\n  line-height: 1;\n  text-align: center;\n  text-transform: uppercase\n}\n\n.vkuiAvatarBadge {\n  bottom: 0;\n  right: 0\n}\n\n.vkuiAvatarBadge--shifted {\n  bottom: -2px;\n  right: -2px\n}\n\n.vkuiAvatarBadge--preset-online,\n.vkuiAvatarBadge--preset-onlineMobile {\n  bottom: 14%;\n  color: #4bb34b;\n  color: var(--vkui--color_accent_green);\n  right: 14%;\n  transform: translate(50%, 50%)\n}\n\n.vkuiAvatarBadge--preset-online {\n  padding: 0\n}\n\n.vkuiAvatarBadge--preset-onlineMobile {\n  border-radius: 3px\n}\n\n.vkuiFooter {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  display: block;\n  margin: 24px 16px;\n  margin: 24px var(--vkui--size_base_padding_horizontal--regular);\n  padding-bottom: 0;\n  padding-top: 0;\n  text-align: center\n}\n\n.vkuiInfoRow {\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text\n}\n\n.vkuiInfoRow,\n.vkuiInfoRow__header {\n  overflow: hidden;\n  text-overflow: ellipsis\n}\n\n.vkuiInfoRow__header {\n  color: #6d7885;\n  color: var(--vkui--color_text_subhead);\n  display: block;\n  margin-bottom: 2px;\n  white-space: nowrap\n}\n\n.vkuiBaseGallery {\n  overflow: hidden;\n  position: relative;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none\n}\n\n.vkuiBaseGallery__viewport {\n  height: 100%;\n  margin: 0;\n  position: relative\n}\n\n.vkuiBaseGallery--align-center .vkuiBaseGallery__viewport {\n  margin: 0 auto\n}\n\n.vkuiBaseGallery__layer {\n  align-items: stretch;\n  display: flex;\n  height: 100%;\n  min-height: 100px;\n  width: 100%\n}\n\n.vkuiBaseGallery--draggable .vkuiBaseGallery__layer {\n  cursor: -webkit-grab;\n  cursor: grab\n}\n\n.vkuiBaseGallery__layer:empty {\n  min-height: 0\n}\n\n.vkuiBaseGallery__slide {\n  flex: 0 0 auto;\n  max-width: 100%;\n  overflow: hidden;\n  width: 100%\n}\n\n.vkuiBaseGallery--custom-width .vkuiBaseGallery__slide {\n  width: auto\n}\n\n.vkuiBaseGallery__slide>* {\n  min-height: 100%;\n  width: 100%\n}\n\n.vkuiBaseGallery__bullets {\n  align-items: center;\n  bottom: 10px;\n  display: flex;\n  height: 6px;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  width: 100%\n}\n\n.vkuiBaseGallery__bullets--dark .vkuiBaseGallery__bullet {\n  background-color: #2c2d2e;\n  background-color: var(--vkui--color_icon_primary_invariably)\n}\n\n.vkuiBaseGallery__bullets--light .vkuiBaseGallery__bullet {\n  background-color: #fff;\n  background-color: var(--vkui--color_icon_contrast)\n}\n\n.vkuiBaseGallery__bullet {\n  border-radius: 10px;\n  height: 6px;\n  margin: 0 3px;\n  opacity: .64;\n  opacity: var(--vkui--opacity_disable_accessibility);\n  width: 18px\n}\n\n.vkuiBaseGallery__bullet--active {\n  opacity: 1\n}\n\n.vkuiBaseGallery__arrow {\n  opacity: 0;\n  position: absolute;\n  top: 0\n}\n\n.vkuiBaseGallery:hover .vkuiBaseGallery__arrow {\n  opacity: .64;\n  opacity: var(--vkui--opacity_disable_accessibility)\n}\n\n.vkuiBaseGallery .vkuiBaseGallery__arrow:hover {\n  opacity: 1\n}\n\n.vkuiGridAvatar {\n  border-radius: 50%\n}\n\n.vkuiGridAvatar__in {\n  border-radius: inherit;\n  display: flex;\n  flex-flow: column wrap;\n  height: 100%;\n  overflow: hidden;\n  width: 100%\n}\n\n.vkuiGridAvatar__item {\n  background-position: 50%;\n  background-size: cover;\n  height: calc(50% - 2px / 2);\n  height: calc(50% - var(--vkui_internal--grid_avatar_image_offset) / 2);\n  margin-right: 2px;\n  margin-right: var(--vkui_internal--grid_avatar_image_offset);\n  width: calc(50% - 2px / 2);\n  width: calc(50% - var(--vkui_internal--grid_avatar_image_offset) / 2)\n}\n\n.vkuiGridAvatar__item:only-child {\n  width: 100%\n}\n\n.vkuiGridAvatar__item:first-child:not(:nth-last-child(4)),\n.vkuiGridAvatar__item:nth-child(2):last-child {\n  height: 100%\n}\n\n.vkuiGridAvatar__item:nth-last-child(4),\n.vkuiGridAvatar__item:nth-last-child(n+3)~.vkuiGridAvatar__item:nth-last-child(2) {\n  margin-bottom: 2px;\n  margin-bottom: var(--vkui_internal--grid_avatar_image_offset)\n}\n\n.vkuiGridAvatarBadge {\n  bottom: 0;\n  right: 0\n}\n\n.vkuiGridAvatarBadge--shifted {\n  bottom: -2px;\n  right: -2px\n}\n\n.vkuiImageBadge {\n  bottom: -4px;\n  position: absolute;\n  right: -4px\n}\n\n.vkuiImageBadge--shifted {\n  bottom: -3px;\n  right: -3px\n}\n\n.vkuiProgress {\n  background: #e1e3e6;\n  background: var(--vkui--color_track_background);\n  border-radius: 1px;\n  height: 2px\n}\n\n.vkuiProgress__in {\n  border-radius: inherit;\n  height: 100%;\n  transition: width .2s ease\n}\n\n.vkuiProgress--appearance-accent .vkuiProgress__in {\n  background: #2688eb;\n  background: var(--vkui--color_stroke_accent)\n}\n\n.vkuiProgress--appearance-positive .vkuiProgress__in {\n  background: #4bb34b;\n  background: var(--vkui--color_stroke_positive)\n}\n\n.vkuiProgress--appearance-negative .vkuiProgress__in {\n  background: #e64646;\n  background: var(--vkui--color_stroke_negative)\n}\n\n.vkuiSearch {\n  -webkit-tap-highlight-color: transparent;\n  --vkui_internal--search_height: var(--vkui--size_search_height--regular);\n  display: flex;\n  overflow: hidden\n}\n\n.vkuiSearch--withPadding {\n  padding: 8px 16px;\n  padding: 8px var(--vkui--size_base_padding_horizontal--regular)\n}\n\n.vkuiSearch--sizeY-compact {\n  --vkui_internal--search_height: var(--vkui--size_search_height--compact)\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiSearch--sizeY-none {\n    --vkui_internal--search_height: var(--vkui--size_search_height--compact)\n  }\n}\n\n.vkuiSearch__field {\n  background-color: #ebedf0;\n  background-color: var(--vkui--color_search_field_background);\n  border-radius: 8px;\n  border-radius: var(--vkui--size_border_radius--regular);\n  display: flex;\n  flex: 2;\n  height: var(--vkui_internal--search_height);\n  position: relative;\n  width: 10000px\n}\n\n.vkuiSearch__field:hover {\n  background-color: #e2e4e9;\n  background-color: var(--vkui--color_search_field_background--hover)\n}\n\n.vkuiSearch__field:active {\n  background-color: #d8dbe2;\n  background-color: var(--vkui--color_search_field_background--active)\n}\n\n.vkuiSearch__control {\n  align-items: center;\n  border-radius: inherit;\n  color: #818c99;\n  color: var(--vkui--color_icon_medium);\n  display: flex;\n  height: 100%;\n  justify-content: flex-start;\n  padding-left: 12px;\n  width: calc(100% - 1px)\n}\n\n.vkuiSearch__input {\n  -webkit-appearance: none;\n  background-color: initial;\n  border: 0;\n  border-radius: inherit;\n  bottom: 0;\n  box-sizing: border-box;\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  flex-grow: 1;\n  height: 100%;\n  left: 0;\n  margin: 0;\n  max-width: 100%;\n  min-width: 0;\n  padding: 0 0 0 36px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: -webkit-fill-available;\n  width: -moz-available;\n  width: stretch\n}\n\n.vkuiSearch__input::-webkit-search-cancel-button,\n.vkuiSearch__input::-webkit-search-decoration,\n.vkuiSearch__input::-webkit-search-results-button,\n.vkuiSearch__input::-webkit-search-results-decoration {\n  display: none\n}\n\n.vkuiSearch__input:focus {\n  outline: none\n}\n\n.vkuiSearch--has-after .vkuiSearch__input {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0\n}\n\n.vkuiSearch--has-icon .vkuiSearch__input,\n.vkuiSearch--has-value .vkuiSearch__input {\n  margin-right: calc(var(--vkui_internal--search_height) + 4px)\n}\n\n.vkuiSearch--has-icon.vkuiSearch--has-value .vkuiSearch__input {\n  margin-right: calc((var(--vkui_internal--search_height) + 4px) * 2)\n}\n\n.vkuiSearch--disabled {\n  cursor: default;\n  pointer-events: none\n}\n\n.vkuiSearch--disabled,\n.vkuiSearch__input:disabled {\n  opacity: .64;\n  opacity: var(--vkui--opacity_disable_accessibility)\n}\n\n.vkuiSearch__input::-webkit-input-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  opacity: 1\n}\n\n.vkuiSearch__input::-moz-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  opacity: 1\n}\n\n.vkuiSearch__input::-ms-input-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  opacity: 1\n}\n\n.vkuiSearch__input::placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  opacity: 1\n}\n\n.vkuiSearch__input:disabled::-webkit-input-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiSearch__input:disabled::-moz-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiSearch__input:disabled::-ms-input-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiSearch__input:disabled::placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiSearch__icons {\n  color: #99a2ad;\n  color: var(--vkui--color_icon_secondary)\n}\n\n.vkuiSearch__icon,\n.vkuiSearch__icons {\n  align-items: center;\n  display: flex;\n  justify-content: center\n}\n\n.vkuiSearch__icon {\n  border-radius: 8px;\n  border-radius: var(--vkui--size_border_radius--regular);\n  height: 100%;\n  width: calc(var(--vkui_internal--search_height) + 4px)\n}\n\n.vkuiSearch__icon .vkuiIcon {\n  padding: 0\n}\n\n.vkuiSearch__after {\n  flex: 0;\n  margin-left: 4px;\n  margin-right: calc(4px - 16px);\n  margin-right: calc(4px - var(--vkui--size_base_padding_horizontal--regular));\n  max-width: -webkit-min-content;\n  max-width: -moz-min-content;\n  max-width: min-content;\n  min-width: auto;\n  overflow: hidden;\n  pointer-events: none;\n  transform: translate(50%);\n  transform-origin: left;\n  transition: flex .3s cubic-bezier(.4, 0, .2, 1), transform .3s cubic-bezier(.4, 0, .2, 1);\n  transition: flex .3s var(--vkui--animation_easing_platform), transform .3s var(--vkui--animation_easing_platform)\n}\n\n.vkuiSearch--focused .vkuiSearch__after,\n.vkuiSearch--has-value .vkuiSearch__after {\n  flex: 1;\n  pointer-events: auto;\n  transform: translate(0)\n}\n\n.vkuiSearch__afterText {\n  display: block;\n  overflow: hidden;\n  text-overflow: clip;\n  white-space: nowrap\n}\n\n.vkuiGroup--mode-plain .vkuiSearch {\n  padding-top: 4px\n}\n\n.vkuiTabs__in {\n  align-items: stretch;\n  display: flex\n}\n\n.vkuiTabs--withGaps {\n  justify-content: flex-start\n}\n\n.vkuiInternalPanelHeader .vkuiTabs {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_family_base);\n  overflow: hidden\n}\n\n.vkuiInternalPanelHeader .vkuiTabs:after {\n  content: \"\";\n  display: block;\n  width: 1000px\n}\n\n.vkuiInternalGroup--mode-plain>.vkuiTabs--mode-default:first-child {\n  margin-top: -8px\n}\n\n.vkuiInternalGroup--mode-card>.vkuiTabs--mode-default:first-child {\n  margin-top: -4px\n}\n\n.vkuiInternalFixedLayout--ios.vkuiInternalFixedLayout--vertical-bottom .vkuiTabs:after {\n  background: #fff;\n  background: var(--vkui--color_background_content);\n  content: \"\";\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%\n}\n\n.vkuiInternalFixedLayout--ios.vkuiInternalFixedLayout--vertical-bottom .vkuiSeparator,\n.vkuiInternalFixedLayout--ios.vkuiInternalFixedLayout--vertical-bottom .vkuiTabs__in {\n  position: relative;\n  z-index: 2;\n  z-index: var(--vkui_internal--z_index_tabs)\n}\n\n.vkuiTabsItem {\n  align-items: center;\n  border-radius: 8px;\n  border-radius: var(--vkui--size_border_radius--regular);\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  max-width: 100%;\n  min-height: 32px;\n  min-width: 0;\n  padding: 4px 8px;\n  transition: background-color .15s ease-out\n}\n\n.vkuiTabsItem--withGaps {\n  margin-bottom: 8px;\n  margin-top: 8px\n}\n\n.vkuiTabsItem--withGaps:not(:first-of-type) {\n  margin-left: 6px\n}\n\n.vkuiTabsItem--sizeY-compact {\n  min-height: 28px;\n  padding-bottom: 2px;\n  padding-top: 2px\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiTabsItem--sizeY-none {\n    min-height: 28px;\n    padding-bottom: 2px;\n    padding-top: 2px\n  }\n}\n\n.vkuiTabsItem[disabled] {\n  opacity: .64;\n  opacity: var(--vkui--opacity_disable_accessibility)\n}\n\n.vkuiTabsItem--mode-default {\n  flex-basis: 0;\n  flex-grow: 1;\n  flex-shrink: 0;\n  min-height: 48px;\n  padding: 12px 16px;\n  position: relative\n}\n\n.vkuiTabsItem--sizeY-compact.vkuiTabsItem--mode-default {\n  min-height: 44px;\n  padding-bottom: 10px;\n  padding-top: 10px\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiTabsItem--sizeY-none.vkuiTabsItem--mode-default {\n    min-height: 44px;\n    padding-bottom: 10px;\n    padding-top: 10px\n  }\n}\n\n.vkuiTabsItem--hover.vkuiTabsItem--mode-default {\n  background-color: rgba(0, 16, 61, .04);\n  background-color: var(--vkui--color_transparent--hover)\n}\n\n.vkuiTabsItem--mode-accent {\n  transition: background-color .15s ease-out, box-shadow .15s ease-out\n}\n\n.vkuiTabsItem--selected.vkuiTabsItem--mode-accent {\n  background-color: #fff;\n  background-color: var(--vkui--color_background_modal);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, .04), 0 0 4px rgba(0, 0, 0, .06);\n  box-shadow: var(--vkui--elevation2)\n}\n\n.vkuiTabsItem--hover.vkuiTabsItem--mode-accent {\n  background-color: #f5f5f5;\n  background-color: var(--vkui--color_background_secondary)\n}\n\n.vkuiTabsItem--mode-accent:before {\n  border: var(--vkui--size_border--regular) solid transparent;\n  border-radius: inherit;\n  bottom: 0;\n  content: \"\";\n  left: 0;\n  pointer-events: none;\n  position: absolute;\n  right: 0;\n  top: 0\n}\n\n.vkuiTabsItem--selected.vkuiTabsItem--mode-accent:before {\n  border-color: #d7d8d9;\n  border-color: var(--vkui--color_separator_primary)\n}\n\n.vkuiTabsItem--selected.vkuiTabsItem--mode-secondary {\n  background-color: rgba(0, 0, 0, .04);\n  background-color: var(--vkui--color_background_secondary_alpha)\n}\n\n.vkuiTabsItem--hover.vkuiTabsItem--mode-secondary {\n  background-color: rgba(0, 0, 0, .08);\n  background-color: var(--vkui--color_background_secondary_alpha--hover)\n}\n\n.vkuiTabsItem__before {\n  color: #818c99;\n  color: var(--vkui--color_icon_medium);\n  margin-right: 6px;\n  transition: color .15s ease-out\n}\n\n.vkuiTabsItem--selected .vkuiTabsItem__before {\n  color: #2c2d2e;\n  color: var(--vkui--color_icon_primary)\n}\n\n.vkuiTabsItem--selected.vkuiTabsItem--mode-accent .vkuiTabsItem__before {\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent_themed)\n}\n\n.vkuiTabsItem--selected.vkuiTabsItem--mode-secondary .vkuiTabsItem__before {\n  opacity: .72\n}\n\n.vkuiTabsItem__label {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: color .15s ease-out;\n  white-space: nowrap\n}\n\n.vkuiTabsItem--selected .vkuiTabsItem__label {\n  color: #000;\n  color: var(--vkui--color_text_primary)\n}\n\n.vkuiTabsItem--selected.vkuiTabsItem--mode-accent .vkuiTabsItem__label {\n  color: #2688eb;\n  color: var(--vkui--color_text_accent_themed)\n}\n\n.vkuiTabsItem--selected.vkuiTabsItem--mode-secondary .vkuiTabsItem__label {\n  opacity: .72\n}\n\n.vkuiTabsItem__status {\n  margin-left: 6px\n}\n\n.vkuiTabsItem__status--count {\n  color: #99a2ad;\n  color: var(--vkui--color_text_tertiary)\n}\n\n.vkuiTabsItem__after {\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent_themed);\n  margin-left: 6px\n}\n\n.vkuiTabsItem__underline {\n  background-color: #2688eb;\n  background-color: var(--vkui--color_background_accent);\n  border-radius: 2px;\n  bottom: 5px;\n  height: 2px;\n  left: 16px;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  right: 16px;\n  transition: opacity .15s ease-out\n}\n\n.vkuiTabsItem--sizeY-compact .vkuiTabsItem__underline {\n  bottom: 3px\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiTabsItem--sizeY-none .vkuiTabsItem__underline {\n    bottom: 3px\n  }\n}\n\n.vkuiTabsItem__underline[data-selected=true] {\n  opacity: 1\n}\n\n.vkuiInternalTabs--vkcom .vkuiTabsItem {\n  flex-grow: 0;\n  min-width: auto;\n  padding-left: 10px;\n  padding-right: 10px\n}\n\n.vkuiInternalTabs--vkcom .vkuiTabsItem__underline {\n  bottom: 0;\n  left: 2px;\n  right: 2px\n}\n\n.vkuiInternalHorizontalScroll .vkuiTabsItem {\n  flex-basis: auto;\n  flex-grow: 1;\n  flex-shrink: 0;\n  min-width: 64px\n}\n\n.vkuiPullToRefresh {\n  flex-grow: 1\n}\n\n.vkuiPullToRefresh--refreshing {\n  pointer-events: none;\n  touch-action: none\n}\n\n.vkuiPullToRefresh__controls {\n  pointer-events: none;\n  width: 100%\n}\n\n.vkuiPullToRefresh:not(.vkuiPullToRefresh--ios) .vkuiPullToRefresh__controls {\n  z-index: 9;\n  z-index: var(--vkui_internal--z_index_pull_to_refresh)\n}\n\n.vkuiPullToRefresh__spinner {\n  align-items: center;\n  background: #fff;\n  background: var(--vkui--color_background_modal);\n  border-radius: 50%;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, .2);\n  box-sizing: border-box;\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent);\n  display: flex;\n  height: 40px;\n  justify-content: center;\n  margin: auto;\n  opacity: 0;\n  transition: transform .3s cubic-bezier(.1, 0, .25, 1), opacity .22s ease-out;\n  width: 40px\n}\n\n.vkuiPullToRefresh--ios .vkuiPullToRefresh__spinner {\n  background: none;\n  border-radius: 0;\n  box-shadow: none;\n  color: #818c99;\n  color: var(--vkui--color_icon_medium)\n}\n\n.vkuiPullToRefresh--watching .vkuiPullToRefresh__spinner {\n  transition: opacity .22s ease-out\n}\n\n.vkuiPullToRefresh__spinner-self {\n  stroke: currentColor\n}\n\n.vkuiPullToRefresh--ios.vkuiPullToRefresh--refreshing .vkuiPullToRefresh__spinner-self {\n  animation: vkuipull-to-refresh-to-refreshing .38s ease-out\n}\n\n.vkuiPullToRefresh__spinner-path {\n  transform: rotate(-90deg);\n  transform-origin: center center;\n  transition: stroke-dashoffset 167ms ease-out\n}\n\n.vkuiPullToRefresh--refreshing .vkuiPullToRefresh__spinner-path,\n.vkuiPullToRefresh--watching .vkuiPullToRefresh__spinner-path {\n  transition: none\n}\n\n.vkuiPullToRefresh__spinner--on .vkuiPullToRefresh__spinner-path {\n  animation: vkuiptr-rotator .7s linear infinite;\n  animation: vkuiptr-rotator var(--vkui_internal--duration) linear infinite\n}\n\n.vkuiPullToRefresh__content {\n  overflow: hidden;\n  transition: transform .4s cubic-bezier(.4, 0, .2, 1);\n  transition: transform .4s var(--vkui--animation_easing_platform)\n}\n\n.vkuiPullToRefresh--watching .vkuiPullToRefresh__content {\n  transition: none\n}\n\n@keyframes vkuipull-to-refresh-to-refreshing {\n  0% {\n    transform: scale(1)\n  }\n\n  30% {\n    transform: scale(.6)\n  }\n\n  90% {\n    transform: scale(1.1)\n  }\n\n  to {\n    transform: scale(1)\n  }\n}\n\n@keyframes vkuiptr-rotator {\n  0% {\n    transform: rotate(0deg)\n  }\n\n  to {\n    transform: rotate(1turn)\n  }\n}\n\n.vkuiLink {\n  background: none;\n  border: 0;\n  border-radius: 0;\n  color: #2d81e0;\n  color: var(--vkui_internal--link-color, var(--vkui--color_text_link));\n  cursor: pointer;\n  display: inline;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  margin: 0;\n  padding: 0;\n  text-decoration: none\n}\n\n@media (hover:hover) and (pointer:fine) {\n  .vkuiLink:hover {\n    text-decoration: underline\n  }\n}\n\n.vkuiLink--focus-visible {\n  outline: 2px solid #2688eb !important;\n  outline: 2px solid var(--vkui--color_stroke_accent) !important\n}\n\n.vkuiLink--has-visited:visited {\n  color: #4986cc;\n  color: var(--vkui--color_text_link_visited)\n}\n\n.vkuiLink .vkuiIcon {\n  display: inline-block;\n  margin-left: 4px;\n  vertical-align: middle\n}\n\n.vkuiTooltip__overlay {\n  height: 100%;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100%\n}\n\n.vkuiTooltipBase {\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  white-space: normal;\n  width: 100%\n}\n\n.vkuiTooltipBase__content {\n  background-color: #fff;\n  background-color: var(--vkui--color_background_modal);\n  border-radius: 8px;\n  border-radius: var(--vkui--size_border_radius--regular);\n  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);\n  box-shadow: var(--vkui--elevation3);\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  padding: 9px 12px 10px\n}\n\n.vkuiTooltipBase__arrow {\n  color: #fff;\n  color: var(--vkui--color_background_modal)\n}\n\n.vkuiTooltipBase--appearance-accent .vkuiTooltipBase__content {\n  background-color: #5a9eff;\n  background-color: var(--vkui--color_background_accent_tint);\n  color: #fff;\n  color: var(--vkui--color_text_contrast)\n}\n\n.vkuiTooltipBase--appearance-accent .vkuiTooltipBase__arrow {\n  color: #5a9eff;\n  color: var(--vkui--color_background_accent_tint)\n}\n\n.vkuiTooltipBase--appearance-white .vkuiTooltipBase__content {\n  background-color: #fff;\n  background-color: var(--vkui--color_background_contrast);\n  color: #000;\n  color: var(--vkui--color_text_primary_invariably)\n}\n\n.vkuiTooltipBase--appearance-white .vkuiTooltipBase__arrow {\n  color: #fff;\n  color: var(--vkui--color_background_contrast)\n}\n\n.vkuiTooltipBase--appearance-black .vkuiTooltipBase__content {\n  background-color: #2c2d2e;\n  background-color: var(--vkui--color_background_contrast_inverse);\n  color: #fff;\n  color: var(--vkui--color_text_contrast)\n}\n\n.vkuiTooltipBase--appearance-black .vkuiTooltipBase__arrow {\n  color: #2c2d2e;\n  color: var(--vkui--color_background_contrast_inverse)\n}\n\n.vkuiTooltipBase--appearance-inversion .vkuiTooltipBase__content {\n  background-color: #2d2d2e;\n  background-color: var(--vkui--color_background_modal_inverse);\n  color: #fff;\n  color: var(--vkui--color_text_contrast_themed)\n}\n\n.vkuiTooltipBase--appearance-inversion .vkuiTooltipBase__arrow {\n  color: #2d2d2e;\n  color: var(--vkui--color_background_modal_inverse)\n}\n\n.vkuiCounter {\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  padding-left: 5px;\n  padding-right: 5px;\n  text-align: center\n}\n\n.vkuiCounter--mode-primary {\n  background: #2688eb;\n  background: var(--vkui--color_background_accent);\n  color: #fff;\n  color: var(--vkui--color_text_contrast)\n}\n\n.vkuiCounter--mode-secondary {\n  background: #99a2ad;\n  background: var(--vkui--color_icon_secondary);\n  color: #fff;\n  color: var(--vkui--color_text_contrast_themed)\n}\n\n.vkuiCounter--mode-prominent {\n  background: #ff3347;\n  background: var(--vkui--color_accent_red);\n  color: #fff;\n  color: var(--vkui--color_text_contrast)\n}\n\n.vkuiCounter--mode-contrast {\n  background: #fff;\n  background: var(--vkui--color_background_content);\n  color: #2688eb;\n  color: var(--vkui--color_text_accent_themed)\n}\n\n.vkuiCounter--size-m {\n  border-radius: 12px;\n  height: 24px;\n  min-width: 24px\n}\n\n.vkuiCounter--size-s {\n  border-radius: 9px;\n  height: 18px;\n  min-width: 18px\n}\n\n.vkuiCounter--mode-inherit {\n  background-color: #99a2ad;\n  background-color: var(--vkui_internal--counter_inherit_background, var(--vkui--color_icon_secondary));\n  color: #fff;\n  color: var(--vkui_internal--counter_inherit_color, var(--vkui--color_text_contrast_themed))\n}\n\n.vkuiInternalPanelHeaderButton .vkuiCounter {\n  padding: 0;\n  position: absolute;\n  right: 2px;\n  top: 8px\n}\n\n.vkuiInternalTabbarItem__label .vkuiCounter {\n  position: absolute;\n  right: -9px;\n  top: -2px\n}\n\n.vkuiUsersStack {\n  align-items: center;\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  display: flex\n}\n\n.vkuiUsersStack--direction-row-reverse {\n  flex-direction: row-reverse\n}\n\n.vkuiUsersStack--direction-column {\n  flex-direction: column;\n  justify-content: center\n}\n\n.vkuiUsersStack__photos {\n  display: flex\n}\n\n.vkuiUsersStack__fill {\n  fill: rgba(0, 28, 61, .08);\n  fill: var(--vkui--color_image_placeholder_alpha)\n}\n\n.vkuiUsersStack__photo--others {\n  align-items: center;\n  background: #99a2ad;\n  background: var(--vkui--color_icon_secondary);\n  border-radius: 50%;\n  color: #fff;\n  color: var(--vkui--color_text_contrast_themed);\n  display: flex;\n  justify-content: center\n}\n\n.vkuiUsersStack--size-s .vkuiUsersStack__photo {\n  height: 16px;\n  width: 16px\n}\n\n.vkuiUsersStack--size-m .vkuiUsersStack__photo {\n  height: 24px;\n  width: 24px\n}\n\n.vkuiUsersStack--size-l .vkuiUsersStack__photo {\n  height: 32px;\n  width: 32px\n}\n\n.vkuiUsersStack__photo+.vkuiUsersStack__photo {\n  margin-left: -2px\n}\n\n.vkuiUsersStack__text {\n  flex: 1;\n  min-width: 0\n}\n\n.vkuiUsersStack--direction-column .vkuiUsersStack__text {\n  margin-top: 8px;\n  text-align: center\n}\n\n.vkuiUsersStack--direction-row .vkuiUsersStack__text {\n  margin-left: 8px\n}\n\n.vkuiUsersStack--direction-row-reverse .vkuiUsersStack__text {\n  margin-right: 8px\n}\n\n.vkuiInternalModalCardBase .vkuiUsersStack {\n  margin-top: 20px\n}\n\n.vkuiPlaceholder {\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center\n}\n\n.vkuiPlaceholder--withPadding {\n  padding: 48px 32px\n}\n\n.vkuiPlaceholder--stretched {\n  flex: 1 0;\n  height: 100%;\n  padding-bottom: inherit;\n  padding-top: inherit\n}\n\n.vkuiPlaceholder__icon {\n  color: #99a2ad;\n  color: var(--vkui--color_icon_secondary);\n  display: inline-block;\n  margin-bottom: 12px;\n  vertical-align: top\n}\n\n.vkuiPlaceholder__header {\n  color: #000;\n  color: var(--vkui--color_text_primary)\n}\n\n.vkuiPlaceholder__text {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiPlaceholder__header+.vkuiPlaceholder__text {\n  margin-top: 8px\n}\n\n.vkuiPlaceholder__action:not(:first-child) {\n  margin-top: 16px\n}\n\n.vkuiBanner {\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  isolation: isolate\n}\n\n.vkuiBanner--withPadding {\n  margin: 12px 0;\n  padding: 0 16px;\n  padding: 0 var(--vkui--size_base_padding_horizontal--regular)\n}\n\n.vkuiBanner__in {\n  align-items: stretch;\n  background-color: #f5f5f5;\n  background-color: var(--vkui--color_background_secondary);\n  border-radius: 8px;\n  border-radius: var(--vkui--size_border_radius--regular);\n  display: flex;\n  flex-flow: row nowrap;\n  overflow: hidden;\n  padding: 12px;\n  position: relative\n}\n\n.vkuiBanner__in:before {\n  border: var(--vkui--size_border--regular) solid var(--vkui--color_image_border_alpha);\n  border-radius: inherit;\n  box-sizing: border-box;\n  content: \"\";\n  display: block;\n  height: 100%;\n  left: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n  z-index: var(--vkui_internal--z_index_banner_content)\n}\n\n.vkuiBanner__before {\n  margin-right: 12px\n}\n\n.vkuiBanner__before,\n.vkuiBanner__content {\n  position: relative;\n  z-index: 1;\n  z-index: var(--vkui_internal--z_index_banner_content)\n}\n\n.vkuiBanner__content {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0\n}\n\n.vkuiBanner__subheader,\n.vkuiBanner__text {\n  color: #6d7885;\n  color: var(--vkui--color_text_subhead)\n}\n\n.vkuiBanner__bg {\n  left: 0;\n  position: absolute;\n  top: 0;\n  z-index: 0;\n  z-index: var(--vkui_internal--z_index_banner_background)\n}\n\n.vkuiBanner__bg,\n.vkuiBanner__bg>* {\n  height: 100%;\n  width: 100%\n}\n\n.vkuiBanner__aside {\n  justify-content: flex-end;\n  width: 28px\n}\n\n.vkuiBanner__aside,\n.vkuiBanner__dismiss {\n  align-content: center;\n  align-items: center;\n  color: #99a2ad;\n  color: var(--vkui--color_icon_secondary);\n  display: flex;\n  flex-flow: row nowrap\n}\n\n.vkuiBanner__dismiss {\n  justify-content: center;\n  position: absolute;\n  right: 2px;\n  top: 2px;\n  z-index: 2;\n  z-index: var(--vkui_internal--z_index_banner_hover)\n}\n\n.vkuiBanner__actions {\n  margin-top: 12px\n}\n\n.vkuiBanner__subheader:not(:first-child),\n.vkuiBanner__text:not(:first-child) {\n  margin-top: 2px\n}\n\n.vkuiBanner--mode-image .vkuiBanner__in {\n  background-color: #f5f5f5;\n  background-color: var(--vkui--color_background_secondary)\n}\n\n.vkuiBanner--inverted,\n.vkuiBanner--inverted .vkuiBanner__dismiss,\n.vkuiBanner--inverted .vkuiBanner__expand,\n.vkuiBanner--inverted .vkuiBanner__subheader {\n  color: #fff;\n  color: var(--vkui--color_text_contrast)\n}\n\n.vkuiBanner--inverted .vkuiBanner__subheader {\n  opacity: .72\n}\n\n.vkuiBanner--size-m .vkuiBanner__in {\n  padding: 16px\n}\n\n.vkuiBanner--size-m .vkuiBanner__subheader:not(:first-child),\n.vkuiBanner--size-m .vkuiBanner__text:not(:first-child) {\n  margin-top: 4px\n}\n\n.vkuiBanner--ios .vkuiBanner__dismiss,\n.vkuiBanner--ios.vkuiBanner--mode-image .vkuiBanner__dismiss {\n  color: #99a2ad;\n  color: var(--vkui--color_icon_secondary)\n}\n\n.vkuiInternalFormStatus .vkuiBanner__in:before {\n  border: 0\n}\n\n.vkuiInternalFormStatus--mode-error .vkuiBanner__in {\n  background-color: #faebeb;\n  background-color: var(--vkui--color_background_negative_tint)\n}\n\n.vkuiInternalFormStatus--mode-error .vkuiBanner__subheader {\n  color: #e64646;\n  color: var(--vkui--color_background_negative)\n}\n\n.vkuiMiniInfoCell {\n  color: #6d7885;\n  color: var(--vkui--color_text_subhead);\n  display: flex;\n  padding: 6px 16px;\n  padding: 6px var(--vkui--size_base_padding_horizontal--regular)\n}\n\n.vkuiMiniInfoCell--mode-accent {\n  color: #000;\n  color: var(--vkui--color_text_primary)\n}\n\n.vkuiMiniInfoCell__before {\n  color: #99a2ad;\n  color: var(--vkui--color_icon_secondary);\n  margin-right: 12px\n}\n\n.vkuiMiniInfoCell__middle {\n  align-items: center;\n  display: flex;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden\n}\n\n.vkuiMiniInfoCell__content {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-break: break-word\n}\n\n.vkuiMiniInfoCell--textWrap-short .vkuiMiniInfoCell__content {\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  max-height: 60px;\n  white-space: normal\n}\n\n.vkuiMiniInfoCell--textWrap-full .vkuiMiniInfoCell__content {\n  overflow: inherit;\n  white-space: normal\n}\n\n.vkuiMiniInfoCell--textWrap-nowrap .vkuiMiniInfoCell__content {\n  flex: 0 1 auto\n}\n\n.vkuiMiniInfoCell__after {\n  margin-bottom: -2px;\n  margin-left: 12px;\n  margin-top: -2px\n}\n\n.vkuiMiniInfoCell--mode-add,\n.vkuiMiniInfoCell--mode-more {\n  color: #2d81e0;\n  color: var(--vkui--color_text_link_themed)\n}\n\n.vkuiMiniInfoCell--mode-add .vkuiMiniInfoCell__before,\n.vkuiMiniInfoCell--mode-more .vkuiMiniInfoCell__before {\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent_themed)\n}\n\n.vkuiMiniInfoCell--mode-more {\n  padding-bottom: 10px;\n  padding-top: 10px\n}\n\n.vkuiMiniInfoCell__middle .vkuiIcon {\n  color: #2688eb;\n  color: var(--vkui--color_text_accent);\n  margin-left: 4px\n}\n\n.vkuiMiniInfoCell--mode-add .vkuiMiniInfoCell__middle .vkuiIcon,\n.vkuiMiniInfoCell--mode-more .vkuiMiniInfoCell__middle .vkuiIcon {\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent_themed)\n}\n\n.vkuiWriteBar {\n  background: #fff;\n  background: var(--vkui--color_background_modal)\n}\n\n.vkuiWriteBar--shadow {\n  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);\n  box-shadow: var(--vkui--elevation3)\n}\n\n.vkuiWriteBar__after,\n.vkuiWriteBar__before,\n.vkuiWriteBar__form {\n  align-items: flex-end;\n  display: flex\n}\n\n.vkuiWriteBar__form {\n  min-height: 52px\n}\n\n.vkuiWriteBar__formIn {\n  display: flex;\n  flex: 1;\n  min-width: 0;\n  position: relative\n}\n\n.vkuiWriteBar__textarea {\n  -webkit-appearance: none;\n  background: transparent;\n  border: 0;\n  box-sizing: border-box;\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  flex: 1;\n  margin: 0;\n  max-height: 120px;\n  min-width: 0;\n  resize: none;\n  width: 100%\n}\n\n.vkuiWriteBar__textarea::-webkit-input-placeholder {\n  color: #6d7885;\n  color: var(--vkui--color_text_subhead);\n  opacity: 1\n}\n\n.vkuiWriteBar__textarea::-moz-placeholder {\n  color: #6d7885;\n  color: var(--vkui--color_text_subhead);\n  opacity: 1\n}\n\n.vkuiWriteBar__textarea::-ms-input-placeholder {\n  color: #6d7885;\n  color: var(--vkui--color_text_subhead);\n  opacity: 1\n}\n\n.vkuiWriteBar__textarea::placeholder {\n  color: #6d7885;\n  color: var(--vkui--color_text_subhead);\n  opacity: 1\n}\n\n.vkuiWriteBar__textarea:focus {\n  outline: none\n}\n\n.vkuiWriteBar__inlineAfter {\n  align-items: flex-end;\n  display: flex\n}\n\n.vkuiWriteBar__before {\n  padding-left: 4px\n}\n\n.vkuiWriteBar__after {\n  padding-right: 4px\n}\n\n.vkuiWriteBar__textarea {\n  height: 52px;\n  padding: 16px 12px\n}\n\n.vkuiWriteBar--ios {\n  background: #fff;\n  background: var(--vkui--color_background_content)\n}\n\n.vkuiWriteBar--ios .vkuiWriteBar__after,\n.vkuiWriteBar--ios .vkuiWriteBar__before {\n  padding: 0 4px\n}\n\n.vkuiWriteBar--ios .vkuiWriteBar__formIn {\n  background-color: #f2f3f5;\n  background-color: var(--vkui--color_write_bar_input_background);\n  border: var(--vkui--size_border--regular) solid var(--vkui--color_write_bar_input_border);\n  border-radius: 18px;\n  box-sizing: border-box;\n  margin: 8px 0\n}\n\n.vkuiWriteBar--ios .vkuiWriteBar__formIn:first-child {\n  margin-left: 12px\n}\n\n.vkuiWriteBar--ios .vkuiWriteBar__inlineAfter {\n  --vkui_internal--writebar-right-gap: calc(-1 * var(--vkui--size_border--regular));\n  --vkui_internal--writebar-vertical-gap: calc(var(--vkui_internal--writebar-right-gap) - 8px);\n  margin-bottom: var(--vkui_internal--writebar-vertical-gap);\n  margin-right: var(--vkui_internal--writebar-right-gap);\n  margin-top: var(--vkui_internal--writebar-vertical-gap)\n}\n\n.vkuiWriteBar--ios .vkuiWriteBar__textarea {\n  height: 36px;\n  padding: 6px 0 6px 12px\n}\n\n.vkuiWriteBarIcon {\n  background: none;\n  border: 0;\n  border-radius: 8px;\n  border-radius: var(--vkui--size_border_radius--regular);\n  color: #99a2ad;\n  color: var(--vkui--color_icon_secondary);\n  cursor: pointer;\n  height: 52px;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  width: 44px\n}\n\n.vkuiWriteBarIcon__in {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  width: 100%\n}\n\n.vkuiWriteBarIcon:disabled {\n  opacity: .4;\n  pointer-events: none\n}\n\n.vkuiWriteBarIcon__active {\n  opacity: .6\n}\n\n.vkuiWriteBarIcon__counter {\n  box-shadow: 0 0 0 2px #fff;\n  box-shadow: 0 0 0 2px var(--vkui--color_background_modal);\n  position: absolute;\n  right: 2px;\n  top: 6px\n}\n\n.vkuiWriteBarIcon--ios .vkuiWriteBarIcon__counter {\n  box-shadow: 0 0 0 2px #fff;\n  box-shadow: 0 0 0 2px var(--vkui--color_background_content)\n}\n\n.vkuiWriteBarIcon.vkuiWriteBarIcon--mode-done,\n.vkuiWriteBarIcon.vkuiWriteBarIcon--mode-send {\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent)\n}\n\n.vkuiWriteBarIcon--ios {\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent_themed)\n}\n\n.vkuiWriteBarIcon--ios.vkuiWriteBarIcon--mode-done,\n.vkuiWriteBarIcon--ios.vkuiWriteBarIcon--mode-send {\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent_themed);\n  margin-right: -4px;\n  padding-left: 0;\n  padding-right: 0;\n  width: 48px\n}\n\n.vkuiWriteBarIcon--ios.vkuiWriteBarIcon--mode-done:only-child,\n.vkuiWriteBarIcon--ios.vkuiWriteBarIcon--mode-send:only-child {\n  margin-left: -4px\n}\n\n.vkuiWriteBarIcon {\n  --vkui_internal--counter_inherit_color: var(--vkui--color_text_contrast_themed);\n  --vkui_internal--counter_inherit_background: var(--vkui--color_background_positive)\n}\n\n.vkuiSubnavigationBar__in {\n  margin: -8px 0\n}\n\n.vkuiSubnavigationBar__scrollIn {\n  display: flex;\n  margin: 0;\n  padding: calc(12px + 8px) 0;\n  padding: calc(var(--vkui--size_subnavigation_bar_padding_vertical--regular) + 8px) 0\n}\n\n.vkuiSubnavigationBar__scrollIn:after,\n.vkuiSubnavigationBar__scrollIn:before {\n  content: \"\";\n  min-width: 16px;\n  min-width: var(--vkui--size_base_padding_horizontal--regular)\n}\n\n.vkuiSubnavigationBar__item {\n  display: flex;\n  list-style-type: none\n}\n\n.vkuiSubnavigationBar__item+.vkuiSubnavigationBar__item {\n  margin-left: 8px;\n  margin-left: var(--vkui--size_subnavigation_bar_gap--regular)\n}\n\n.vkuiInternalSubnavigationBar--mode-fixed .vkuiSubnavigationBar__item {\n  flex: 1;\n  min-width: 0\n}\n\n.vkuiSubnavigationButton {\n  border-radius: 8px;\n  border-radius: var(--vkui--size_border_radius--regular);\n  display: inline-block;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none\n}\n\n.vkuiSubnavigationButton__in {\n  align-items: center;\n  display: flex;\n  justify-content: center\n}\n\n.vkuiSubnavigationButton--size-s .vkuiSubnavigationButton__in {\n  height: 30px;\n  height: var(--vkui--size_button_small_height--regular)\n}\n\n.vkuiSubnavigationButton--size-m .vkuiSubnavigationButton__in {\n  height: 36px;\n  height: var(--vkui--size_button_medium_height--regular)\n}\n\n.vkuiSubnavigationButton--size-l .vkuiSubnavigationButton__in {\n  height: 44px;\n  height: var(--vkui--size_button_large_height--regular)\n}\n\n.vkuiSubnavigationButton--sizeY-compact.vkuiSubnavigationButton--size-s .vkuiSubnavigationButton__in {\n  height: 28px;\n  height: var(--vkui--size_button_small_height--compact)\n}\n\n.vkuiSubnavigationButton--sizeY-compact.vkuiSubnavigationButton--size-m .vkuiSubnavigationButton__in {\n  height: 32px;\n  height: var(--vkui--size_button_medium_height--compact)\n}\n\n.vkuiSubnavigationButton--sizeY-compact.vkuiSubnavigationButton--size-l .vkuiSubnavigationButton__in {\n  height: 36px;\n  height: var(--vkui--size_button_large_height--compact)\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiSubnavigationButton--sizeY-none.vkuiSubnavigationButton--size-s .vkuiSubnavigationButton__in {\n    height: 28px;\n    height: var(--vkui--size_button_small_height--compact)\n  }\n\n  .vkuiSubnavigationButton--sizeY-none.vkuiSubnavigationButton--size-m .vkuiSubnavigationButton__in {\n    height: 32px;\n    height: var(--vkui--size_button_medium_height--compact)\n  }\n\n  .vkuiSubnavigationButton--sizeY-none.vkuiSubnavigationButton--size-l .vkuiSubnavigationButton__in {\n    height: 36px;\n    height: var(--vkui--size_button_large_height--compact)\n  }\n}\n\n.vkuiSubnavigationButton__before {\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent);\n  margin-right: 8px\n}\n\n.vkuiSubnavigationButton__label {\n  flex-grow: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap\n}\n\n.vkuiSubnavigationButton__after {\n  margin-left: 8px\n}\n\n.vkuiSubnavigationButton__expandableIcon {\n  color: #99a2ad;\n  color: var(--vkui--color_icon_secondary);\n  margin-left: 8px;\n  margin-top: 1px\n}\n\n.vkuiSubnavigationButton__before:first-child,\n.vkuiSubnavigationButton__label:first-child {\n  padding-left: 12px;\n  padding-left: var(--vkui--size_button_base_small_padding_horizontal_icon--regular)\n}\n\n.vkuiSubnavigationButton__after:last-child,\n.vkuiSubnavigationButton__expandableIcon,\n.vkuiSubnavigationButton__label:last-child {\n  padding-right: 12px;\n  padding-right: var(--vkui--size_button_base_small_padding_horizontal_icon--regular)\n}\n\n.vkuiSubnavigationButton--mode-primary {\n  background-color: #fff;\n  background-color: var(--vkui--color_background_modal);\n  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);\n  box-shadow: var(--vkui--elevation3)\n}\n\n.vkuiSubnavigationButton--mode-outline {\n  box-shadow: inset 0 0 0 var(--vkui--size_border--regular) rgba(0, 0, 0, .12);\n  box-shadow: inset 0 0 0 var(--vkui--size_border--regular) var(--vkui--color_field_border_alpha)\n}\n\n.vkuiSubnavigationButton--appearance-neutral .vkuiSubnavigationButton__before,\n.vkuiSubnavigationButton--appearance-neutral .vkuiSubnavigationButton__expandableIcon {\n  color: #2c2d2e;\n  color: var(--vkui--color_icon_primary)\n}\n\n.vkuiSubnavigationButton--selected {\n  background-color: #2688eb;\n  background-color: var(--vkui--color_background_accent_themed);\n  border: 0;\n  box-shadow: none;\n  color: #fff;\n  color: var(--vkui--color_text_contrast_themed)\n}\n\n.vkuiSubnavigationButton--selected.vkuiSubnavigationButton--appearance-neutral,\n.vkuiSubnavigationButton--selected.vkuiSubnavigationButton--mode-tertiary {\n  background-color: rgba(0, 16, 61, .08);\n  background-color: var(--vkui--color_transparent--active);\n  color: #000;\n  color: var(--vkui--color_text_primary)\n}\n\n.vkuiSubnavigationButton--selected.vkuiSubnavigationButton--appearance-accent:not(.vkuiSubnavigationButton--mode-tertiary) .vkuiSubnavigationButton__before,\n.vkuiSubnavigationButton--selected.vkuiSubnavigationButton--appearance-accent:not(.vkuiSubnavigationButton--mode-tertiary) .vkuiSubnavigationButton__expandableIcon {\n  color: #fff;\n  color: var(--vkui--color_icon_contrast_themed)\n}\n\n.vkuiSubnavigationButton {\n  --vkui_internal--counter_inherit_background: var(--vkui--color_background_accent_themed);\n  --vkui_internal--counter_inherit_color: var(--vkui--color_text_contrast_themed)\n}\n\n.vkuiSubnavigationButton--selected.vkuiSubnavigationButton--appearance-accent:not(.vkuiSubnavigationButton--mode-tertiary) {\n  --vkui_internal--counter_inherit_background: var(--vkui--color_background_content);\n  --vkui_internal--counter_inherit_color: var(--vkui--color_text_accent_themed)\n}\n\n.vkuiSubnavigationButton--selected.vkuiSubnavigationButton--appearance-neutral {\n  --vkui_internal--counter_inherit_background: var(--vkui--color_background_content);\n  --vkui_internal--counter_inherit_color: var(--vkui--color_text_primary)\n}\n\n.vkuiInternalSubnavigationBar--mode-fixed .vkuiSubnavigationButton {\n  flex: 1;\n  min-width: 0\n}\n\n.vkuiPagination__list {\n  display: flex;\n  list-style-type: none;\n  margin: 0;\n  padding: 0\n}\n\n.vkuiPagination__prevButtonContainer {\n  margin-right: 8px\n}\n\n.vkuiPagination__nextButtonContainer {\n  margin-left: 8px\n}\n\n.vkuiPaginationPage {\n  border-radius: 8px;\n  border-radius: var(--vkui--size_border_radius--regular);\n  box-sizing: border-box;\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  height: 44px;\n  height: var(--vkui--size_button_large_height--regular);\n  line-height: 44px;\n  line-height: var(--vkui--size_button_large_height--regular);\n  min-width: 40px;\n  padding-left: 8px;\n  padding-right: 8px;\n  text-align: center;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  width: 100%\n}\n\n.vkuiPaginationPage--state-hover {\n  background-color: rgba(0, 16, 61, .04);\n  background-color: var(--vkui--color_transparent--hover)\n}\n\n.vkuiPaginationPage--current,\n.vkuiPaginationPage--state-active {\n  background-color: rgba(0, 16, 61, .08);\n  background-color: var(--vkui--color_transparent--active);\n  color: #000;\n  color: var(--vkui--color_text_primary)\n}\n\n.vkuiPaginationPage--disabled {\n  opacity: .4;\n  opacity: var(--vkui--opacity_disable)\n}\n\n.vkuiPaginationPage--sizeY-compact {\n  height: 36px;\n  height: var(--vkui--size_button_large_height--compact);\n  line-height: 36px;\n  line-height: var(--vkui--size_button_large_height--compact)\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiPaginationPage--sizeY-none {\n    height: 36px;\n    height: var(--vkui--size_button_large_height--compact);\n    line-height: 36px;\n    line-height: var(--vkui--size_button_large_height--compact)\n  }\n}\n\n.vkuiPaginationPage--type-ellipsis {\n  min-width: 16px;\n  padding-left: 0;\n  padding-right: 0\n}\n\n.vkuiAccordionSummary::-webkit-details-marker {\n  display: none\n}\n\n.vkuiAccordionSummary__icon {\n  color: #99a2ad;\n  color: var(--vkui--color_icon_secondary)\n}\n\n.vkuiAccordion:not([open])>summary .vkuiAccordionSummary__icon--collapse,\n.vkuiAccordion[open]>summary .vkuiAccordionSummary__icon--expand {\n  display: none\n}\n\n.vkuiFormLayout {\n  position: relative\n}\n\n.vkuiFormLayout__submit {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border: 0;\n  height: 0;\n  left: 0;\n  padding: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  visibility: hidden;\n  width: 0\n}\n\n.vkuiFormItem {\n  display: block\n}\n\n.vkuiFormItem--withPadding {\n  padding: 12px 16px;\n  padding: var(--vkui--size_form_item_padding_vertical--regular) var(--vkui--size_base_padding_horizontal--regular)\n}\n\n.vkuiFormItem--removable {\n  padding-left: 0;\n  padding-right: 0\n}\n\n.vkuiFormItem__removable {\n  flex-basis: 0;\n  flex-grow: 1;\n  flex-shrink: 0;\n  max-width: 100%;\n  min-width: 1px;\n  overflow: hidden;\n  padding: 0\n}\n\n.vkuiFormItem__top {\n  color: #6d7885;\n  color: var(--vkui--color_text_subhead);\n  overflow: hidden;\n  padding-bottom: 8px;\n  padding-top: 2px;\n  text-overflow: ellipsis;\n  white-space: nowrap\n}\n\n.vkuiFormItem__bottom {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  padding-top: 8px\n}\n\n.vkuiFormItem--status-error .vkuiFormItem__bottom {\n  color: #e64646;\n  color: var(--vkui--color_text_negative)\n}\n\n.vkuiFormItem--status-valid .vkuiFormItem__bottom,\n.vkuiFormItem--verified .vkuiFormItem__bottom {\n  color: #4bb34b;\n  color: var(--vkui--color_text_positive)\n}\n\n.vkuiFormItem--sizeY-compact .vkuiFormItem__top {\n  padding-bottom: 6px\n}\n\n.vkuiFormItem--sizeY-compact .vkuiFormItem__bottom {\n  padding-top: 6px\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiFormItem--sizeY-none .vkuiFormItem__top {\n    padding-bottom: 6px\n  }\n\n  .vkuiFormItem--sizeY-none .vkuiFormItem__bottom {\n    padding-top: 6px\n  }\n}\n\n.vkuiInternalFormLayoutGroup--mode-horizontal .vkuiFormItem {\n  flex-basis: 0;\n  flex-grow: 1;\n  flex-shrink: 0;\n  max-width: 100%;\n  min-width: 1px;\n  padding: 0\n}\n\n.vkuiInternalFormLayoutGroup--mode-horizontal:not(.vkuiInternalFormLayoutGroup--segmented) .vkuiFormItem+.vkuiFormItem {\n  margin-left: 24px\n}\n\n.vkuiInternalFormLayoutGroup--mode-horizontal.vkuiInternalFormLayoutGroup--segmented .vkuiFormItem+.vkuiFormItem {\n  margin-left: calc(-1 * var(--vkui--size_border--regular))\n}\n\n.vkuiInternalFormLayoutGroup--mode-vertical.vkuiInternalFormLayoutGroup--segmented .vkuiFormItem+.vkuiFormItem {\n  margin-top: calc(-1 * var(--vkui--size_border--regular));\n  padding-top: 0\n}\n\n.vkuiInternalFormLayoutGroup--mode-vertical.vkuiInternalFormLayoutGroup--segmented .vkuiFormItem:not(:last-of-type) {\n  padding-bottom: 0\n}\n\n.vkuiFormItem--withTop .vkuiFormItem__removable,\n.vkuiInternalFormLayoutGroup--mode-horizontal .vkuiFormItem--withTop {\n  margin-top: calc(-2px - 18px - 8px);\n  margin-top: calc(-2px - var(--vkui--font_subhead--line_height--regular) - 8px)\n}\n\n.vkuiFormItem--sizeY-compact.vkuiFormItem--withTop .vkuiFormItem__removable,\n.vkuiInternalFormLayoutGroup--mode-horizontal .vkuiFormItem--sizeY-compact.vkuiFormItem--withTop {\n  margin-top: calc(-2px - 16px - 6px);\n  margin-top: calc(-2px - var(--vkui--font_subhead--line_height--compact) - 6px)\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n\n  .vkuiFormItem--sizeY-none.vkuiFormItem--withTop .vkuiFormItem__removable,\n  .vkuiInternalFormLayoutGroup--mode-horizontal .vkuiFormItem--sizeY-none.vkuiFormItem--withTop {\n    margin-top: calc(-2px - 16px - 6px);\n    margin-top: calc(-2px - var(--vkui--font_subhead--line_height--compact) - 6px)\n  }\n}\n\n.vkuiFormField {\n  -webkit-tap-highlight-color: transparent;\n  align-items: center;\n  border-radius: 8px;\n  border-radius: var(--vkui--size_border_radius--regular);\n  box-sizing: border-box;\n  display: flex;\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_family_base);\n  isolation: isolate;\n  min-height: 44px;\n  min-height: var(--vkui--size_field_height--regular);\n  outline: none;\n  position: relative\n}\n\n.vkuiFormField--sizeY-compact {\n  min-height: 36px;\n  min-height: var(--vkui--size_field_height--compact)\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiFormField--sizeY-none {\n    min-height: 36px;\n    min-height: var(--vkui--size_field_height--compact)\n  }\n}\n\n.vkuiFormField>* {\n  border-radius: inherit;\n  z-index: 1;\n  z-index: var(--vkui_internal--z_index_form_field_element)\n}\n\n.vkuiFormField__after,\n.vkuiFormField__before {\n  align-content: center;\n  align-items: center;\n  color: #99a2ad;\n  color: var(--vkui--color_icon_secondary);\n  display: flex;\n  flex-shrink: 0;\n  height: 100%;\n  justify-content: center;\n  min-width: 44px;\n  min-width: var(--vkui--size_field_height--regular);\n  position: relative;\n  z-index: 6;\n  z-index: var(--vkui_internal--z_index_form_field_side)\n}\n\n.vkuiFormField--sizeY-compact .vkuiFormField__after,\n.vkuiFormField--sizeY-compact .vkuiFormField__before {\n  height: 36px;\n  height: var(--vkui--size_field_height--compact);\n  min-width: 36px;\n  min-width: var(--vkui--size_field_height--compact)\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n\n  .vkuiFormField--sizeY-none .vkuiFormField__after,\n  .vkuiFormField--sizeY-none .vkuiFormField__before {\n    height: 36px;\n    height: var(--vkui--size_field_height--compact);\n    min-width: 36px;\n    min-width: var(--vkui--size_field_height--compact)\n  }\n}\n\n.vkuiFormField__before {\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent)\n}\n\n.vkuiFormField__after {\n  color: #99a2ad;\n  color: var(--vkui--color_icon_secondary)\n}\n\n.vkuiFormField__border {\n  border: var(--vkui--size_border--regular) solid transparent;\n  border-radius: inherit;\n  box-sizing: border-box;\n  height: 100%;\n  left: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  transform-origin: left top;\n  width: 100%;\n  z-index: 2;\n  z-index: var(--vkui_internal--z_index_form_field_border)\n}\n\n.vkuiFormField--mode-default .vkuiFormField__border {\n  border-color: rgba(0, 0, 0, .12);\n  border-color: var(--vkui--color_field_border_alpha)\n}\n\n.vkuiFormField--mode-default {\n  background-color: #f2f3f5;\n  background-color: var(--vkui--color_field_background)\n}\n\n.vkuiFormField--status-error .vkuiFormField__border,\n.vkuiInternalFormItem--status-error .vkuiFormField__border {\n  border-color: #e64646;\n  border-color: var(--vkui--color_stroke_negative);\n  z-index: 3;\n  z-index: var(--vkui_internal--z_index_form_field_status)\n}\n\n.vkuiFormField--status-error,\n.vkuiInternalFormItem--status-error .vkuiFormField {\n  background-color: #faebeb;\n  background-color: var(--vkui--color_background_negative_tint)\n}\n\n.vkuiFormField--status-valid .vkuiFormField__border,\n.vkuiInternalFormItem--status-valid .vkuiFormField__border {\n  border-color: #4bb34b;\n  border-color: var(--vkui--color_stroke_positive);\n  z-index: 3;\n  z-index: var(--vkui_internal--z_index_form_field_status)\n}\n\n.vkuiFormField--disabled {\n  cursor: default;\n  opacity: .64;\n  opacity: var(--vkui--opacity_disable_accessibility);\n  pointer-events: none\n}\n\n.vkuiFormField--hover {\n  background-color: #f2f3f5;\n  background-color: var(--vkui--color_field_background)\n}\n\n.vkuiFormField--mode-default.vkuiFormField--hover .vkuiFormField__border {\n  border-color: rgba(0, 0, 0, .24);\n  border-color: var(--vkui--color_field_border_alpha--hover);\n  z-index: 4;\n  z-index: var(--vkui_internal--z_index_form_field_border_hover)\n}\n\n.vkuiFormField :focus {\n  outline: none\n}\n\n.vkuiInternalModalCardBase__header+.vkuiFormField,\n.vkuiInternalModalCardBase__subheader+.vkuiFormField {\n  margin-top: 16px\n}\n\n.vkuiInternalNativeSelect .vkuiFormField__after {\n  pointer-events: none\n}\n\n.vkuiInternalCalendarHeader__picker .vkuiFormField__after {\n  min-width: 12px;\n  padding-right: 8px\n}\n\n.vkuiInternalChipsInput .vkuiFormField__after {\n  z-index: 6;\n  z-index: var(--vkui_internal--z_index_form_field_side)\n}\n\n.vkuiInternalFormLayoutGroup--segmented .vkuiFormField {\n  border-radius: 0;\n  isolation: auto;\n  z-index: auto\n}\n\n.vkuiInternalFormLayoutGroup--segmented.vkuiInternalFormLayoutGroup--mode-horizontal .vkuiInternalFormItem:first-of-type .vkuiFormField {\n  border-bottom-left-radius: 8px;\n  border-bottom-left-radius: var(--vkui--size_border_radius--regular);\n  border-top-left-radius: 8px;\n  border-top-left-radius: var(--vkui--size_border_radius--regular)\n}\n\n.vkuiInternalFormLayoutGroup--segmented.vkuiInternalFormLayoutGroup--mode-horizontal .vkuiInternalFormItem:last-of-type .vkuiFormField {\n  border-bottom-right-radius: 8px;\n  border-bottom-right-radius: var(--vkui--size_border_radius--regular);\n  border-top-right-radius: 8px;\n  border-top-right-radius: var(--vkui--size_border_radius--regular)\n}\n\n.vkuiInternalFormLayoutGroup--segmented.vkuiInternalFormLayoutGroup--mode-vertical .vkuiInternalFormItem:first-of-type .vkuiFormField {\n  border-top-left-radius: 8px;\n  border-top-left-radius: var(--vkui--size_border_radius--regular);\n  border-top-right-radius: 8px;\n  border-top-right-radius: var(--vkui--size_border_radius--regular)\n}\n\n.vkuiInternalFormLayoutGroup--segmented.vkuiInternalFormLayoutGroup--mode-vertical .vkuiInternalFormItem:last-of-type .vkuiFormField {\n  border-bottom-left-radius: 8px;\n  border-bottom-left-radius: var(--vkui--size_border_radius--regular);\n  border-bottom-right-radius: 8px;\n  border-bottom-right-radius: var(--vkui--size_border_radius--regular)\n}\n\n.vkuiFormLayoutGroup--mode-horizontal {\n  align-items: flex-start;\n  display: flex;\n  flex-wrap: wrap;\n  padding: 12px 16px;\n  padding: var(--vkui--size_form_item_padding_vertical--regular) var(--vkui--size_base_padding_horizontal--regular)\n}\n\n.vkuiFormLayoutGroup__removable {\n  flex-grow: 1;\n  max-width: 100%;\n  min-width: 0\n}\n\n.vkuiFormLayoutGroup__offset {\n  display: none\n}\n\n.vkuiFormLayoutGroup--mode-horizontal .vkuiInternalFormItem--withTop~.vkuiFormLayoutGroup__offset {\n  display: block;\n  height: calc(2px + 18px + 8px);\n  height: calc(2px + var(--vkui--font_subhead--line_height--regular) + 8px);\n  min-width: 100%;\n  order: -1\n}\n\n.vkuiFormLayoutGroup--sizeY-compact.vkuiFormLayoutGroup--mode-horizontal .vkuiInternalFormItem--withTop~.vkuiFormLayoutGroup__offset {\n  height: calc(2px + 16px + 6px);\n  height: calc(2px + var(--vkui--font_subhead--line_height--compact) + 6px)\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiFormLayoutGroup--sizeY-none.vkuiFormLayoutGroup--mode-horizontal .vkuiInternalFormItem--withTop~.vkuiFormLayoutGroup__offset {\n    height: calc(2px + 16px + 6px);\n    height: calc(2px + var(--vkui--font_subhead--line_height--compact) + 6px)\n  }\n}\n\n.vkuiFormLayoutGroup--removable {\n  padding-left: 0;\n  padding-right: 0\n}\n\n.vkuiFormLayoutGroup--segmented {\n  position: relative\n}\n\n.vkuiFormStatus--mode-error {\n  color: #e64646;\n  color: var(--vkui--color_background_negative)\n}\n\n.vkuiSwitch {\n  cursor: pointer;\n  display: block;\n  padding: calc((20px - 14px) / 2);\n  padding: calc((var(--vkui--size_switch_pin--regular) - var(--vkui--size_switch_height--regular)) / 2);\n  position: relative;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none\n}\n\n.vkuiSwitch--sizeY-compact {\n  padding: calc((18px - 12px) / 2);\n  padding: calc((var(--vkui--size_switch_pin--compact) - var(--vkui--size_switch_height--compact)) / 2)\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiSwitch--sizeY-none {\n    padding: calc((18px - 12px) / 2);\n    padding: calc((var(--vkui--size_switch_pin--compact) - var(--vkui--size_switch_height--compact)) / 2)\n  }\n}\n\n.vkuiSwitch--disabled {\n  cursor: default\n}\n\n.vkuiSwitch__pseudo {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-tap-highlight-color: transparent;\n  box-sizing: border-box;\n  display: block;\n  position: relative\n}\n\n.vkuiSwitch__pseudo:before {\n  background: #f2f3f5;\n  background: var(--vkui--color_icon_contrast_secondary);\n  border-radius: 50%;\n  box-shadow: 0 0 2px 0 rgba(0, 0, 0, .12), 0 2px 2px 0 rgba(0, 0, 0, .24);\n  box-sizing: border-box;\n  content: \"\";\n  height: 20px;\n  height: var(--vkui--size_switch_pin--regular);\n  left: calc((14px - 20px) / 2);\n  left: calc((var(--vkui--size_switch_height--regular) - var(--vkui--size_switch_pin--regular)) / 2);\n  position: absolute;\n  top: calc((14px - 20px) / 2);\n  top: calc((var(--vkui--size_switch_height--regular) - var(--vkui--size_switch_pin--regular)) / 2);\n  width: 20px;\n  width: var(--vkui--size_switch_pin--regular)\n}\n\n.vkuiSwitch--sizeY-compact .vkuiSwitch__pseudo:before {\n  height: 18px;\n  height: var(--vkui--size_switch_pin--compact);\n  left: calc((12px - 18px) / 2);\n  left: calc((var(--vkui--size_switch_height--compact) - var(--vkui--size_switch_pin--compact)) / 2);\n  top: calc((12px - 18px) / 2);\n  top: calc((var(--vkui--size_switch_height--compact) - var(--vkui--size_switch_pin--compact)) / 2);\n  width: 18px;\n  width: var(--vkui--size_switch_pin--compact)\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiSwitch--sizeY-none .vkuiSwitch__pseudo:before {\n    height: 18px;\n    height: var(--vkui--size_switch_pin--compact);\n    left: calc((12px - 18px) / 2);\n    left: calc((var(--vkui--size_switch_height--compact) - var(--vkui--size_switch_pin--compact)) / 2);\n    top: calc((12px - 18px) / 2);\n    top: calc((var(--vkui--size_switch_height--compact) - var(--vkui--size_switch_pin--compact)) / 2);\n    width: 18px;\n    width: var(--vkui--size_switch_pin--compact)\n  }\n}\n\n.vkuiSwitch__self:checked+.vkuiSwitch__pseudo:before {\n  background: #2688eb;\n  background: var(--vkui--color_icon_accent);\n  transform: translateX(calc(34px - 14px));\n  transform: translateX(calc(var(--vkui--size_switch_width--regular) - var(--vkui--size_switch_height--regular)))\n}\n\n.vkuiSwitch__pseudo:after {\n  background: rgba(0, 0, 0, .24);\n  background: var(--vkui--color_icon_tertiary_alpha);\n  border-radius: calc(34px / 2);\n  border-radius: calc(var(--vkui--size_switch_width--regular) / 2);\n  content: \"\";\n  display: block;\n  height: 14px;\n  height: var(--vkui--size_switch_height--regular);\n  width: 34px;\n  width: var(--vkui--size_switch_width--regular)\n}\n\n.vkuiSwitch--sizeY-compact .vkuiSwitch__pseudo:after {\n  border-radius: calc(32px / 2);\n  border-radius: calc(var(--vkui--size_switch_width--compact) / 2);\n  height: 12px;\n  height: var(--vkui--size_switch_height--compact);\n  width: 32px;\n  width: var(--vkui--size_switch_width--compact)\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiSwitch--sizeY-none .vkuiSwitch__pseudo:after {\n    border-radius: calc(32px / 2);\n    border-radius: calc(var(--vkui--size_switch_width--compact) / 2);\n    height: 12px;\n    height: var(--vkui--size_switch_height--compact);\n    width: 32px;\n    width: var(--vkui--size_switch_width--compact)\n  }\n}\n\n.vkuiSwitch__self:checked+.vkuiSwitch__pseudo:after {\n  background: #2688eb;\n  background: var(--vkui--color_icon_accent);\n  opacity: .48\n}\n\n.vkuiSwitch--sizeY-compact .vkuiSwitch__self:checked+.vkuiSwitch__pseudo:before {\n  transform: translateX(calc(32px - 12px));\n  transform: translateX(calc(var(--vkui--size_switch_width--compact) - var(--vkui--size_switch_height--compact)))\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiSwitch--sizeY-none .vkuiSwitch__self:checked+.vkuiSwitch__pseudo:before {\n    transform: translateX(calc(32px - 12px));\n    transform: translateX(calc(var(--vkui--size_switch_width--compact) - var(--vkui--size_switch_height--compact)))\n  }\n}\n\n.vkuiSwitch__self[disabled]+.vkuiSwitch__pseudo {\n  opacity: .4;\n  opacity: var(--vkui--opacity_disable)\n}\n\n.vkuiSwitch--ios .vkuiSwitch__pseudo:before {\n  box-shadow: 0 3px 8px rgba(0, 0, 0, .15), 0 3px 1px rgba(0, 0, 0, .06), inset 0 0 0 .5px rgba(0, 0, 0, .04)\n}\n\n.vkuiSwitch--ios .vkuiSwitch__pseudo:before,\n.vkuiSwitch--ios .vkuiSwitch__self:checked+.vkuiSwitch__pseudo:before {\n  background: #fff;\n  background: var(--vkui_internal--white)\n}\n\n.vkuiSwitch--ios .vkuiSwitch__pseudo:after {\n  background: #e1e3e6;\n  background: var(--vkui--color_track_background)\n}\n\n.vkuiSwitch--ios .vkuiSwitch__self:checked+.vkuiSwitch__pseudo:after {\n  opacity: 1\n}\n\n@media (prefers-reduced-motion:no-preference) {\n  .vkuiSwitch__pseudo:after {\n    transition: background-color .1s ease\n  }\n\n  .vkuiSwitch__pseudo:before {\n    transition: transform .1s ease\n  }\n\n  .vkuiSwitch--ios .vkuiSwitch__pseudo:after {\n    transition: background-color .2s ease\n  }\n\n  .vkuiSwitch--ios .vkuiSwitch__pseudo:before {\n    transition: transform .2s cubic-bezier(.36, -.24, .26, 1.32)\n  }\n}\n\n.vkuiInternalSimpleCell__after>.vkuiSwitch {\n  margin-left: 12px\n}\n\n.vkuiInput {\n  font-size: 16px;\n  line-height: 20px;\n  position: relative\n}\n\n.vkuiInput--align-center .vkuiInput__el {\n  text-align: center\n}\n\n.vkuiInput--align-right .vkuiInput__el {\n  text-align: right\n}\n\n.vkuiInput__el {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background: transparent;\n  border: 0;\n  border-radius: inherit;\n  box-shadow: none;\n  box-sizing: border-box;\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  height: 44px;\n  height: var(--vkui--size_field_height--regular);\n  margin: 0;\n  padding: 0 12px;\n  position: relative;\n  width: 100%;\n  z-index: 1;\n  z-index: var(--vkui_internal--z_index_form_field_element)\n}\n\n.vkuiInput__el::-webkit-inner-spin-button,\n.vkuiInput__el::-webkit-outer-spin-button {\n  -webkit-appearance: none\n}\n\n.vkuiInput__el[type=number] {\n  -moz-appearance: textfield\n}\n\n.vkuiInput--sizeY-compact .vkuiInput__el {\n  height: 36px;\n  height: var(--vkui--size_field_height--compact)\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiInput--sizeY-none .vkuiInput__el {\n    height: 36px;\n    height: var(--vkui--size_field_height--compact)\n  }\n}\n\n.vkuiInput--hasBefore .vkuiInput__el {\n  padding-left: 0\n}\n\n.vkuiInput--hasAfter .vkuiInput__el {\n  padding-right: 0\n}\n\n.vkuiInput__el:disabled {\n  opacity: .64;\n  opacity: var(--vkui--opacity_disable_accessibility)\n}\n\n.vkuiInput__el::-webkit-input-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  opacity: 1\n}\n\n.vkuiInput__el::-moz-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  opacity: 1\n}\n\n.vkuiInput__el::-ms-input-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  opacity: 1\n}\n\n.vkuiInput__el::placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  opacity: 1\n}\n\n.vkuiInput__el:disabled::-webkit-input-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiInput__el:disabled::-moz-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiInput__el:disabled::-ms-input-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiInput__el:disabled::placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiChip {\n  background: #fff;\n  background: var(--vkui--color_background_content);\n  border: var(--vkui--size_border--regular) solid var(--vkui--color_image_border_alpha);\n  border-radius: 6px;\n  box-sizing: border-box;\n  display: inline-block;\n  height: 32px\n}\n\n.vkuiChip__in {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  padding: 0 8px;\n  position: relative\n}\n\n.vkuiChip--removable .vkuiChip__in {\n  padding-right: 0\n}\n\n.vkuiChip__content {\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  display: inline-block;\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_paragraph--font_family--regular);\n  font-size: 15px;\n  font-size: var(--vkui--font_paragraph--font_size--regular);\n  font-weight: 400;\n  font-weight: var(--vkui--font_paragraph--font_weight--regular);\n  line-height: 20px;\n  line-height: var(--vkui--font_paragraph--line_height--regular);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap\n}\n\n.vkuiChip--sizeY-compact .vkuiChip__content {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_footnote--font_family--regular);\n  font-size: 13px;\n  font-size: var(--vkui--font_footnote--font_size--regular);\n  font-weight: 400;\n  font-weight: var(--vkui--font_footnote--font_weight--regular);\n  line-height: 16px;\n  line-height: var(--vkui--font_footnote--line_height--regular)\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiChip--sizeY-none .vkuiChip__content {\n    font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n    font-family: var(--vkui--font_footnote--font_family--regular);\n    font-size: 13px;\n    font-size: var(--vkui--font_footnote--font_size--regular);\n    font-weight: 400;\n    font-weight: var(--vkui--font_footnote--font_weight--regular);\n    line-height: 16px;\n    line-height: var(--vkui--font_footnote--line_height--regular)\n  }\n}\n\n.vkuiChip__remove {\n  align-content: center;\n  align-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 2px;\n  box-sizing: border-box;\n  color: #99a2ad;\n  color: var(--vkui--color_icon_secondary);\n  cursor: pointer;\n  display: flex;\n  flex-grow: 0;\n  flex-shrink: 0;\n  height: 28px;\n  justify-content: center;\n  margin: -1px;\n  padding: 6px;\n  position: relative;\n  transform: translateX(-1px);\n  width: 28px\n}\n\n.vkuiChip__before {\n  margin-right: 6px\n}\n\n.vkuiChip__after {\n  margin-left: 6px\n}\n\n.vkuiChip--sizeY-compact {\n  height: 28px\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiChip--sizeY-none {\n    height: 28px\n  }\n}\n\n.vkuiChipsInput {\n  max-width: 100%\n}\n\n.vkuiChipsInputBase {\n  display: flex;\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-wrap: wrap;\n  max-width: 100%;\n  overflow: hidden;\n  padding: 3px;\n  position: relative;\n  z-index: 1;\n  z-index: var(--vkui_internal--z_index_form_field_element)\n}\n\n.vkuiChipsInputBase__chip {\n  margin: 2px;\n  max-width: calc(100% - 4px)\n}\n\n.vkuiChipsInputBase__label {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  margin: 2px 2px 2px 10px\n}\n\n.vkuiChipsInputBase__el {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background: transparent;\n  border: 0;\n  box-shadow: none;\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  margin-bottom: 2px;\n  padding: 0;\n  position: relative;\n  width: 100%\n}\n\n.vkuiChipsInputBase__el:focus {\n  min-width: 64px\n}\n\n.vkuiChipsInputBase__el::-ms-clear {\n  display: none\n}\n\n.vkuiChipsInputBase__el:disabled {\n  opacity: .64;\n  opacity: var(--vkui--opacity_disable_accessibility)\n}\n\n.vkuiChipsInputBase__el::-webkit-input-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  opacity: 1\n}\n\n.vkuiChipsInputBase__el::-moz-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  opacity: 1\n}\n\n.vkuiChipsInputBase__el::-ms-input-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  opacity: 1\n}\n\n.vkuiChipsInputBase__el::placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  opacity: 1\n}\n\n.vkuiChipsInputBase__el:disabled::-webkit-input-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiChipsInputBase__el:disabled::-moz-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiChipsInputBase__el:disabled::-ms-input-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiChipsInputBase__el:disabled::placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiChipsInputBase__el[readonly] {\n  cursor: default\n}\n\n.vkuiChipsInputBase--hasPlaceholder .vkuiChipsInputBase__label {\n  margin-left: 9px;\n  margin-right: 0\n}\n\n.vkuiChipsInputBase--hasPlaceholder .vkuiChipsInputBase__el {\n  text-overflow: ellipsis;\n  white-space: nowrap\n}\n\n.vkuiChipsInputBase--sizeY-compact {\n  padding: 1px\n}\n\n.vkuiSlider {\n  cursor: pointer;\n  height: 28px;\n  height: var(--vkui_internal--slider_thumb_size);\n  position: relative\n}\n\n.vkuiSlider--disabled {\n  cursor: not-allowed;\n  opacity: .64;\n  opacity: var(--vkui--opacity_disable_accessibility)\n}\n\n.vkuiSlider__track,\n.vkuiSlider__track-fill {\n  border-radius: 1px;\n  height: 2px;\n  left: 0;\n  position: absolute;\n  top: 50%\n}\n\n.vkuiSlider__track {\n  background-color: #e1e3e6;\n  background-color: var(--vkui--color_track_background);\n  width: 100%\n}\n\n.vkuiSlider__track-fill {\n  background: #2688eb;\n  background: var(--vkui--color_background_accent);\n  width: auto\n}\n\n.vkuiSlider__thumbs {\n  height: 100%;\n  isolation: isolate;\n  margin-left: calc(28px / 2);\n  margin-left: calc(var(--vkui_internal--slider_thumb_size) / 2);\n  margin-right: calc(28px / 2);\n  margin-right: calc(var(--vkui_internal--slider_thumb_size) / 2);\n  position: relative\n}\n\n.vkuiSlider__thumb {\n  top: 50%;\n  transform: translate(-50%, -50%)\n}\n\n.vkuiSlider--sizeY-compact {\n  --vkui_internal--slider_thumb_size: 24px\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiSlider--sizeY-none {\n    --vkui_internal--slider_thumb_size: 24px\n  }\n}\n\n.vkuiSliderThumb {\n  background: #fff;\n  background: var(--vkui--color_background_contrast);\n  border: .5px solid rgba(0, 0, 0, .12);\n  border: .5px solid var(--vkui--color_separator_primary_alpha);\n  border-radius: 50%;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);\n  box-shadow: var(--vkui--elevation3);\n  height: 28px;\n  height: var(--vkui_internal--slider_thumb_size);\n  position: absolute;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  width: 28px;\n  width: var(--vkui_internal--slider_thumb_size);\n  z-index: 1\n}\n\n.vkuiSliderThumb--focused {\n  z-index: 2\n}\n\n.vkuiSliderThumb__nativeInput {\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  direction: ltr;\n  height: 100%;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 100%\n}\n\n.vkuiTextarea {\n  position: relative\n}\n\n.vkuiTextarea__el {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background: transparent;\n  border: 0;\n  box-sizing: border-box;\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  display: block;\n  margin: 0;\n  max-height: 204px;\n  padding: 12px;\n  position: relative;\n  resize: none;\n  width: 100%;\n  z-index: 1;\n  z-index: var(--vkui_internal--z_index_form_field_element)\n}\n\n.vkuiTextarea__el[cols] {\n  width: auto\n}\n\n.vkuiTextarea--sizeY-compact .vkuiTextarea__el {\n  max-height: 196px\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiTextarea--sizeY-none .vkuiTextarea__el {\n    max-height: 196px\n  }\n}\n\n.vkuiTextarea__el::-webkit-input-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  opacity: 1\n}\n\n.vkuiTextarea__el::-moz-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  opacity: 1\n}\n\n.vkuiTextarea__el::-ms-input-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  opacity: 1\n}\n\n.vkuiTextarea__el::placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  opacity: 1\n}\n\n.vkuiTextarea__el:disabled {\n  opacity: .64;\n  opacity: var(--vkui--opacity_disable_accessibility)\n}\n\n.vkuiTextarea__el:disabled::-webkit-input-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiTextarea__el:disabled::-moz-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiTextarea__el:disabled::-ms-input-placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiTextarea__el:disabled::placeholder {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiRadio {\n  display: block;\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_family_base);\n  padding: 0 16px;\n  padding: 0 var(--vkui--size_base_padding_horizontal--regular)\n}\n\n.vkuiInternalFormItem .vkuiRadio {\n  box-sizing: initial;\n  margin: 0 calc(-1 * 16px);\n  margin: 0 calc(-1 * var(--vkui--size_base_padding_horizontal--regular));\n  width: 100%\n}\n\n.vkuiRadio__container {\n  align-items: center;\n  display: flex;\n  justify-content: flex-start\n}\n\n.vkuiRadio__input:disabled~.vkuiRadio__container {\n  opacity: .64;\n  opacity: var(--vkui--opacity_disable_accessibility)\n}\n\n.vkuiRadio__icon {\n  color: #b8c1cc;\n  color: var(--vkui--color_icon_tertiary);\n  flex-shrink: 0;\n  height: 22px;\n  margin-right: 14px;\n  transition: color .15s cubic-bezier(.4, 0, .2, 1);\n  transition: color .15s var(--vkui--animation_easing_platform);\n  width: 22px\n}\n\n.vkuiRadio__input:checked~.vkuiRadio__container .vkuiRadio__icon {\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent)\n}\n\n.vkuiRadio__icon .vkuiRadio__pin {\n  transform: scale(0);\n  transform-origin: 12px 12px;\n  transition: transform .15s cubic-bezier(.4, 0, .2, 1);\n  transition: transform .15s var(--vkui--animation_easing_platform)\n}\n\n.vkuiRadio__input:checked~.vkuiRadio__container .vkuiRadio__icon .vkuiRadio__pin {\n  transform: none\n}\n\n.vkuiRadio__content {\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  display: block;\n  flex-grow: 1;\n  max-width: 100%\n}\n\n.vkuiRadio__description {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  display: block;\n  margin-bottom: 12px;\n  margin-top: 2px\n}\n\n.vkuiRadio__title {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-top: 12px\n}\n\n.vkuiRadio__title:last-child {\n  margin-bottom: 12px\n}\n\n.vkuiRadio__titleAfter {\n  color: #b8c1cc;\n  color: var(--vkui--color_icon_tertiary);\n  margin-left: 4px\n}\n\n.vkuiRadio--sizeY-compact .vkuiRadio__title {\n  margin-top: 8px\n}\n\n.vkuiRadio--sizeY-compact .vkuiRadio__title:last-child {\n  margin-bottom: 8px\n}\n\n.vkuiRadio--sizeY-compact .vkuiRadio__description {\n  margin-bottom: 7px\n}\n\n.vkuiRadio--sizeY-compact .vkuiRadio__icon {\n  height: 18px;\n  width: 18px\n}\n\n.vkuiRadio--sizeY-compact .vkuiRadio__icon:after {\n  height: 12px;\n  width: 12px\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiRadio--sizeY-none .vkuiRadio__title {\n    margin-top: 8px\n  }\n\n  .vkuiRadio--sizeY-none .vkuiRadio__title:last-child {\n    margin-bottom: 8px\n  }\n\n  .vkuiRadio--sizeY-none .vkuiRadio__description {\n    margin-bottom: 7px\n  }\n\n  .vkuiRadio--sizeY-none .vkuiRadio__icon {\n    height: 18px;\n    width: 18px\n  }\n\n  .vkuiRadio--sizeY-none .vkuiRadio__icon:after {\n    height: 12px;\n    width: 12px\n  }\n}\n\n.vkuiInternalRadioGroup .vkuiRadio {\n  box-sizing: border-box;\n  flex: 1;\n  margin: 0\n}\n\n.vkuiRadioGroup--mode-horizontal {\n  display: flex\n}\n\n.vkuiInternalFormItem .vkuiRadioGroup {\n  box-sizing: initial;\n  margin: 0 calc(-1 * 16px);\n  margin: 0 calc(-1 * var(--vkui--size_base_padding_horizontal--regular))\n}\n\n.vkuiCheckbox {\n  align-items: center;\n  display: flex;\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_family_base);\n  justify-content: flex-start;\n  min-height: 44px;\n  min-height: var(--vkui--size_field_height--regular);\n  min-width: 44px;\n  min-width: var(--vkui--size_field_height--regular);\n  padding: 0 16px;\n  padding: 0 var(--vkui--size_base_padding_horizontal--regular)\n}\n\n.vkuiInternalFormItem .vkuiCheckbox {\n  box-sizing: initial;\n  margin: 0 calc(-1 * 16px);\n  margin: 0 calc(-1 * var(--vkui--size_base_padding_horizontal--regular));\n  width: 100%\n}\n\n.vkuiCheckbox__icon {\n  flex-shrink: 0;\n  margin-right: 12px\n}\n\n.vkuiCheckbox__icon--indeterminate,\n.vkuiCheckbox__icon--on {\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent);\n  display: none\n}\n\n.vkuiCheckbox__icon--off {\n  color: #b8c1cc;\n  color: var(--vkui--color_icon_tertiary)\n}\n\n.vkuiCheckbox__content {\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  flex-grow: 1;\n  min-width: 0;\n  word-break: break-word\n}\n\n.vkuiCheckbox__description {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  display: block;\n  margin-bottom: 12px;\n  margin-top: 2px\n}\n\n.vkuiCheckbox__title {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-top: 12px\n}\n\n.vkuiCheckbox__title:last-child {\n  margin-bottom: 12px\n}\n\n.vkuiCheckbox__titleBefore {\n  min-width: 0\n}\n\n.vkuiCheckbox__titleAfter {\n  color: #b8c1cc;\n  color: var(--vkui--color_icon_tertiary);\n  flex-shrink: 0;\n  margin-left: 4px\n}\n\n.vkuiCheckbox__input:checked~.vkuiCheckbox__icon--on {\n  display: flex\n}\n\n.vkuiCheckbox__input:checked~.vkuiCheckbox__icon--off,\n.vkuiCheckbox__input:indeterminate~.vkuiCheckbox__icon--indeterminate {\n  display: none\n}\n\n.vkuiCheckbox__input:indeterminate~.vkuiCheckbox__icon--indeterminate {\n  display: flex\n}\n\n.vkuiCheckbox__input:indeterminate~.vkuiCheckbox__icon--off,\n.vkuiCheckbox__input:indeterminate~.vkuiCheckbox__icon--on {\n  display: none\n}\n\n.vkuiCheckbox__input[disabled]~* {\n  opacity: .64;\n  opacity: var(--vkui--opacity_disable_accessibility)\n}\n\n.vkuiCheckbox--simple {\n  align-items: center;\n  border-radius: 50%;\n  display: flex;\n  height: 44px;\n  height: var(--vkui--size_field_height--regular);\n  justify-content: center;\n  padding: 0;\n  width: 44px;\n  width: var(--vkui--size_field_height--regular)\n}\n\n.vkuiCheckbox--simple .vkuiCheckbox__content {\n  display: none\n}\n\n.vkuiCheckbox--simple .vkuiCheckbox__icon {\n  margin: 0\n}\n\n.vkuiCheckbox--sizeY-compact {\n  min-height: 36px;\n  min-height: var(--vkui--size_field_height--compact);\n  min-width: 36px;\n  min-width: var(--vkui--size_field_height--compact)\n}\n\n.vkuiCheckbox--sizeY-compact.vkuiCheckbox--simple {\n  height: 36px;\n  height: var(--vkui--size_field_height--compact);\n  width: 36px;\n  width: var(--vkui--size_field_height--compact)\n}\n\n.vkuiCheckbox--sizeY-compact .vkuiCheckbox__title {\n  margin-top: 8px\n}\n\n.vkuiCheckbox--sizeY-compact .vkuiCheckbox__description,\n.vkuiCheckbox--sizeY-compact .vkuiCheckbox__title:last-child {\n  margin-bottom: 8px\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiCheckbox--sizeY-none {\n    min-height: 36px;\n    min-height: var(--vkui--size_field_height--compact);\n    min-width: 36px;\n    min-width: var(--vkui--size_field_height--compact)\n  }\n\n  .vkuiCheckbox--sizeY-none.vkuiCheckbox--simple {\n    height: 36px;\n    height: var(--vkui--size_field_height--compact);\n    width: 36px;\n    width: var(--vkui--size_field_height--compact)\n  }\n\n  .vkuiCheckbox--sizeY-none .vkuiCheckbox__title {\n    margin-top: 8px\n  }\n\n  .vkuiCheckbox--sizeY-none .vkuiCheckbox__description,\n  .vkuiCheckbox--sizeY-none .vkuiCheckbox__title:last-child {\n    margin-bottom: 8px\n  }\n}\n\n.vkuiCustomSelect {\n  cursor: pointer;\n  display: block;\n  position: relative;\n  width: 100%\n}\n\n.vkuiCustomSelect--pop-down {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0\n}\n\n.vkuiCustomSelect--pop-up {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0\n}\n\n.vkuiCustomSelect__control {\n  display: none\n}\n\n.vkuiCustomSelect__empty {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  padding: 12px 0;\n  text-align: center\n}\n\n.vkuiCustomSelect__fetching {\n  align-items: center;\n  display: flex;\n  justify-content: center\n}\n\n.vkuiCustomSelect__dropdown-icon {\n  margin-right: 10px\n}\n\n.vkuiCustomSelect--clear-icon {\n  margin-right: -6px\n}\n\n.vkuiCustomSelect--sizeY-compact .vkuiCustomSelect__dropdown-icon {\n  margin-right: 8px\n}\n\n.vkuiCustomSelect--sizeY-compact .vkuiCustomSelect--clear-icon {\n  margin-right: -2px\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiCustomSelect--sizeY-none .vkuiCustomSelect__dropdown-icon {\n    margin-right: 8px\n  }\n\n  .vkuiCustomSelect--sizeY-none .vkuiCustomSelect--clear-icon {\n    margin-right: -2px\n  }\n}\n\n.vkuiCustomSelectOption {\n  align-items: center;\n  box-sizing: border-box;\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  cursor: pointer;\n  display: flex;\n  padding: 8px 12px;\n  position: relative;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  width: 100%\n}\n\n.vkuiCustomSelectOption--hierarchy {\n  --vkui_internal--custom_select_option_hierarchy_level: 0;\n  padding-left: calc(0 * 32px);\n  padding-left: calc(var(--vkui_internal--custom_select_option_hierarchy_level) * var(--vkui--size_option_hierarchy--regular))\n}\n\n.vkuiCustomSelectOption--sizeY-regular {\n  min-height: 44px\n}\n\n@media (max-width:767.9px) and (min-height:415px),\n(pointer:coarse) and (min-height:415px),\n(pointer:none) and (min-height:415px) {\n  .vkuiCustomSelectOption--sizeY-none {\n    min-height: 44px\n  }\n}\n\n.vkuiCustomSelectOption--disabled {\n  cursor: default;\n  opacity: .64;\n  opacity: var(--vkui--opacity_disable_accessibility)\n}\n\n.vkuiCustomSelectOption--hover {\n  background-color: rgba(0, 16, 61, .04);\n  background-color: var(--vkui--color_transparent--hover)\n}\n\n.vkuiCustomSelectOption__before {\n  flex-shrink: 0;\n  margin-right: 7px\n}\n\n.vkuiCustomSelectOption__main {\n  flex-grow: 1;\n  max-width: 100%;\n  min-width: 0\n}\n\n.vkuiCustomSelectOption__children {\n  min-width: 0\n}\n\n.vkuiCustomSelectOption__after {\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  margin-left: 8px\n}\n\n.vkuiCustomSelectOption__description {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiCustomSelectOption__selectedIcon {\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent)\n}\n\n.vkuiCustomSelectOption__selectedIcon:not(:first-child) {\n  margin-left: 8px\n}\n\n.vkuiSelect {\n  box-sizing: border-box;\n  cursor: pointer;\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_family_base);\n  position: relative\n}\n\n.vkuiSelect__el {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border: 0;\n  display: block;\n  font-family: inherit;\n  font-size: 15px;\n  font-size: var(--vkui--font_paragraph--font_size--regular);\n  height: 100%;\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 6;\n  z-index: var(--vkui_internal--z_index_form_field_side)\n}\n\n.vkuiSelect__container {\n  box-sizing: border-box;\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  flex-grow: 1;\n  flex-shrink: 1;\n  overflow: hidden;\n  padding-left: 12px;\n  padding-right: 0;\n  position: relative;\n  z-index: 1;\n  z-index: var(--vkui_internal--z_index_form_field_element)\n}\n\n.vkuiSelect--hasBefore .vkuiSelect__container {\n  padding-left: 0\n}\n\n.vkuiSelect--multiline .vkuiSelect__container {\n  padding-bottom: 12px;\n  padding-top: 12px\n}\n\n.vkuiSelect--sizeY-compact.vkuiSelect--multiline .vkuiSelect__container {\n  padding-bottom: 8px;\n  padding-top: 8px\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiSelect--sizeY-none.vkuiSelect--multiline .vkuiSelect__container {\n    padding-bottom: 8px;\n    padding-top: 8px\n  }\n}\n\n.vkuiSelect__title {\n  display: block\n}\n\n.vkuiSelect:not(.vkuiSelect--multiline) .vkuiSelect__title {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap\n}\n\n.vkuiSelect--empty .vkuiSelect__title {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiSelect--align-right .vkuiSelect__title {\n  text-align: right\n}\n\n.vkuiSelect--align-center .vkuiSelect__title {\n  text-align: center\n}\n\n.vkuiInternalCalendarHeader__picker .vkuiSelect__container {\n  padding-right: 4px\n}\n\n.vkuiCustomSelectDropdown {\n  background-color: #fff;\n  background-color: var(--vkui--color_background_modal);\n  border: var(--vkui--size_border--regular) solid var(--vkui--color_field_border_alpha);\n  border-radius: 8px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .03), 0 2px 2px rgba(0, 0, 0, .06);\n  box-shadow: var(--vkui--elevation1);\n  box-sizing: border-box;\n  overflow: hidden\n}\n\n.vkuiCustomSelectDropdown--wide {\n  width: 100%\n}\n\n.vkuiCustomSelectDropdown--bottom {\n  border-top: 0;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0\n}\n\n.vkuiCustomSelectDropdown--top {\n  border-bottom: 0;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  bottom: 100%;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .03), 0 -2px 2px rgba(0, 0, 0, .06);\n  box-shadow: var(--vkui--elevation1_invert_y)\n}\n\n.vkuiCustomSelectDropdown__fetching {\n  padding: 12px 0\n}\n\n.vkuiCustomSelectDropdown__in {\n  max-height: 160px\n}\n\n.vkuiInternalCalendarHeader__pickers .vkuiCustomSelectDropdown__in {\n  max-height: 184px\n}\n\n.vkuiCustomScrollView {\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n  width: 100%\n}\n\n.vkuiCustomScrollView__box {\n  height: 100%;\n  max-height: inherit;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  padding-right: 100px;\n  position: relative;\n  scrollbar-width: none;\n  width: 100%\n}\n\n.vkuiCustomScrollView__box::-webkit-scrollbar {\n  display: none\n}\n\n.vkuiCustomScrollView__barY:active+.vkuiCustomScrollView__box {\n  pointer-events: none\n}\n\n.vkuiCustomScrollView__barY {\n  height: 100%;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 10px\n}\n\n.vkuiCustomScrollView__trackerY {\n  box-sizing: border-box;\n  left: 0;\n  padding: 4px 4px 4px 0;\n  position: absolute;\n  top: 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  width: 10px\n}\n\n.vkuiCustomScrollView__trackerY--hidden {\n  opacity: 0;\n  transition: opacity .2s\n}\n\n.vkuiCustomScrollView__trackerY:before {\n  background-color: #818c99;\n  background-color: var(--vkui--color_icon_medium);\n  border-radius: 12px;\n  content: \"\";\n  display: block;\n  height: 100%;\n  opacity: .48;\n  transition: transform .2s, opacity .2s;\n  width: 100%\n}\n\n.vkuiCustomScrollView__trackerY:active:before,\n.vkuiCustomScrollView__trackerY:hover:before {\n  opacity: .8;\n  transform: scaleX(1.3333)\n}\n\n.vkuiInternalCustomSelectDropdown .vkuiCustomScrollView__box {\n  padding-right: 8px\n}\n\n.vkuiInternalCustomSelectDropdown--wide .vkuiCustomScrollView__box {\n  padding-right: 0\n}\n\n.vkuiDatePicker {\n  border: 0;\n  margin: 0;\n  padding: 0\n}\n\n.vkuiDatePicker__container {\n  display: flex;\n  flex-direction: row;\n  width: 100%\n}\n\n.vkuiDatePicker__day {\n  min-width: 72px\n}\n\n.vkuiDatePicker__month {\n  display: flex;\n  flex: 1 0 0;\n  min-width: 0;\n  padding: 0 8px\n}\n\n.vkuiDatePicker__year {\n  min-width: 92px\n}\n\n.vkuiDatePicker__monthSelect {\n  width: 100%\n}\n\n.vkuiSegmentedControl {\n  background-color: #f5f5f5;\n  background-color: var(--vkui--color_background_secondary);\n  border-radius: 8px;\n  border-radius: var(--vkui--size_border_radius--regular);\n  box-sizing: border-box;\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_family_base);\n  height: 30px;\n  padding: 2px\n}\n\n.vkuiSegmentedControl--size-l {\n  height: 36px\n}\n\n.vkuiSegmentedControl__in {\n  border-radius: inherit;\n  display: flex;\n  height: 100%;\n  position: relative;\n  transition: all .1s ease-out;\n  width: 100%\n}\n\n.vkuiSegmentedControl__slider {\n  background-color: #fff;\n  background-color: var(--vkui--color_segmented_control);\n  border-radius: inherit;\n  bottom: 0;\n  box-shadow: inset 0 0 0 .5px rgba(0, 0, 0, .08), 0 3px 8px rgba(0, 0, 0, .12), 0 3px 1px rgba(0, 0, 0, .04);\n  box-shadow: inset 0 0 0 .5px var(--vkui--color_image_border_alpha), 0 3px 8px rgba(0, 0, 0, .12), 0 3px 1px rgba(0, 0, 0, .04);\n  left: 0;\n  position: absolute;\n  top: 0;\n  transform-origin: 0 0;\n  transition: transform .15s\n}\n\n.vkuiSegmentedControl__option {\n  display: block;\n  flex: 1;\n  margin: 0;\n  padding: 0;\n  position: relative\n}\n\n.vkuiSegmentedControl--sizeY-regular {\n  height: 36px\n}\n\n.vkuiSegmentedControl--sizeY-regular.vkuiSegmentedControl--size-l {\n  height: 44px\n}\n\n@media (max-width:767.9px) and (min-height:415px),\n(pointer:coarse) and (min-height:415px),\n(pointer:none) and (min-height:415px) {\n  .vkuiSegmentedControl--sizeY-none {\n    height: 36px\n  }\n\n  .vkuiSegmentedControl--sizeY-none.vkuiSegmentedControl--size-l {\n    height: 44px\n  }\n}\n\n.vkuiSegmentedControlOption {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background: transparent;\n  border: 0;\n  border-radius: inherit;\n  box-sizing: border-box;\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  cursor: pointer;\n  height: 100%;\n  transition: color .1s ease-out;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none\n}\n\n.vkuiSegmentedControlOption .vkuiIcon {\n  color: #2c2d2e;\n  color: var(--vkui--color_icon_primary)\n}\n\n.vkuiSegmentedControlOption:not(.vkuiSegmentedControlOption--checked):hover {\n  opacity: .5\n}\n\n.vkuiSegmentedControlOption__content {\n  align-content: center;\n  align-items: center;\n  border-radius: inherit;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  width: 100%\n}\n\n.vkuiCalendar {\n  background: #fff;\n  background: var(--vkui--color_background_modal);\n  border: .5px solid #d7d8d9;\n  border: .5px solid var(--vkui--color_separator_primary);\n  border-radius: 8px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .03), 0 2px 2px rgba(0, 0, 0, .06);\n  box-shadow: var(--vkui--elevation1);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  padding: 12px;\n  width: 305px\n}\n\n.vkuiCalendar__time {\n  border-top: 1px solid #d7d8d9;\n  border-top: 1px solid var(--vkui--color_separator_primary);\n  margin: 12px -12px 0;\n  padding: 12px 12px 0\n}\n\n.vkuiCalendar__header {\n  margin-bottom: 4px\n}\n\n.vkuiCalendar--size-s {\n  padding: 8px;\n  width: 220px\n}\n\n.vkuiCalendar--size-s .vkuiCalendar__header {\n  margin-bottom: 0\n}\n\n.vkuiCalendarHeader {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  min-height: 36px;\n  position: relative\n}\n\n.vkuiCalendarHeader__pickers {\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  display: flex;\n  position: absolute\n}\n\n.vkuiCalendarHeader__picker+.vkuiCalendarHeader__picker {\n  margin-left: 4px\n}\n\n.vkuiCalendarHeader__nav-icon {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  padding: 3px;\n  position: absolute\n}\n\n.vkuiCalendarHeader__nav-icon--accent {\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent)\n}\n\n.vkuiCalendarHeader__nav-icon-next {\n  right: 0\n}\n\n.vkuiCalendarHeader__nav-icon-prev {\n  left: 0\n}\n\n.vkuiCalendarHeader__month {\n  text-transform: capitalize\n}\n\n.vkuiCalendarDays {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: space-around\n}\n\n.vkuiCalendarDays__row {\n  display: flex;\n  flex-grow: 1;\n  justify-content: center\n}\n\n.vkuiCalendarDays__row:not(:last-child) {\n  margin-bottom: 4px\n}\n\n.vkuiCalendarDays__row--size-s:not(:last-child) {\n  margin-bottom: 0\n}\n\n.vkuiCalendarDays__weekday {\n  align-items: center;\n  color: #6d7885;\n  color: var(--vkui--color_text_subhead);\n  display: flex;\n  flex-basis: calc(100% / 7);\n  flex-grow: 0;\n  height: 32px;\n  justify-content: center;\n  text-transform: capitalize\n}\n\n.vkuiCalendarDay {\n  border-radius: 0;\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_family_base);\n  font-size: 14px\n}\n\n.vkuiCalendarDay,\n.vkuiCalendarDay__hidden {\n  flex-basis: calc(100% / 7);\n  flex-grow: 0;\n  height: 36px\n}\n\n.vkuiCalendarDay--size-s,\n.vkuiCalendarDay__hidden--size-s {\n  height: 34px\n}\n\n.vkuiCalendarDay--disabled,\n.vkuiCalendarDay--not-same-month {\n  color: #99a2ad;\n  color: var(--vkui--color_text_tertiary)\n}\n\n.vkuiCalendarDay--selected {\n  background-color: #f5f5f5;\n  background-color: var(--vkui--color_background_secondary)\n}\n\n.vkuiCalendarDay--selection-start.vkuiCalendarDay--selected,\n.vkuiCalendarDay__hinted--selection-start {\n  border-bottom-left-radius: 8px;\n  border-top-left-radius: 8px\n}\n\n.vkuiCalendarDay--selection-end.vkuiCalendarDay--selected,\n.vkuiCalendarDay__hinted--selection-end {\n  border-bottom-right-radius: 8px;\n  border-top-right-radius: 8px\n}\n\n.vkuiCalendarDay__day-number {\n  text-align: center\n}\n\n.vkuiCalendarDay--today {\n  font-weight: 600\n}\n\n.vkuiCalendarDay--today .vkuiCalendarDay__day-number:after {\n  border-bottom: 2px solid #2688eb;\n  border-bottom: 2px solid var(--vkui--color_stroke_accent);\n  content: \"\";\n  display: block;\n  left: 50%;\n  position: relative;\n  transform: translateX(-50%);\n  width: 16px\n}\n\n.vkuiCalendarDay--today .vkuiCalendarDay__inner--active .vkuiCalendarDay__day-number:after {\n  border-bottom-color: #fff;\n  border-bottom-color: var(--vkui--color_stroke_contrast)\n}\n\n.vkuiCalendarDay__hinted,\n.vkuiCalendarDay__inner {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  width: 100%\n}\n\n.vkuiCalendarDay__inner {\n  border-radius: 8px\n}\n\n.vkuiCalendarDay--hover :not(.vkuiCalendarDay__hinted--active) .vkuiCalendarDay__inner,\n.vkuiCalendarDay__hinted--active {\n  background-color: rgba(0, 0, 0, .08);\n  background-color: var(--vkui--color_background_secondary_alpha--hover)\n}\n\n.vkuiCalendarDay__inner--active {\n  background-color: #2688eb;\n  background-color: var(--vkui--color_background_accent);\n  color: #fff;\n  color: var(--vkui--color_text_contrast)\n}\n\n.vkuiCalendarTime {\n  align-items: center;\n  display: flex\n}\n\n.vkuiCalendarTime__picker {\n  width: 77px\n}\n\n.vkuiCalendarTime__divider {\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_family_base);\n  margin-left: 6px;\n  margin-right: 6px\n}\n\n.vkuiCalendarTime__button {\n  margin-left: auto\n}\n\n.vkuiCalendarRange {\n  background: #fff;\n  background: var(--vkui--color_background_modal);\n  border: .5px solid #d7d8d9;\n  border: .5px solid var(--vkui--color_separator_primary);\n  border-radius: 8px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .03), 0 2px 2px rgba(0, 0, 0, .06);\n  box-shadow: var(--vkui--elevation1);\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  padding: 12px;\n  width: 610px\n}\n\n.vkuiCalendarRange__inner {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1\n}\n\n.vkuiCalendarRange__inner:not(:last-child) {\n  margin-right: 24px\n}\n\n.vkuiCalendarRange__header {\n  margin-bottom: 4px\n}\n\n.vkuiInputLike__mask {\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_family_base);\n  position: relative\n}\n\n.vkuiInputLike__mask:after {\n  border-bottom: 1px solid #818c99;\n  border-bottom: 1px solid var(--vkui--color_text_secondary);\n  bottom: 0;\n  content: \"\";\n  height: 1px;\n  left: 0;\n  position: absolute;\n  width: calc(100% - .1em)\n}\n\n.vkuiInputLike__mask:last-child {\n  margin-right: 1px\n}\n\n.vkuiInputLike__divider,\n.vkuiInputLike__last_character {\n  letter-spacing: 1px !important\n}\n\n.vkuiInputLike__divider {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary)\n}\n\n.vkuiInputLike--full+.vkuiInputLike__divider {\n  color: #000;\n  color: var(--vkui--color_text_primary)\n}\n\n.vkuiDateInput__input {\n  cursor: text;\n  flex-grow: 1;\n  font-variant-numeric: tabular-nums;\n  margin-left: 10px;\n  margin-right: 14px;\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n  white-space: nowrap;\n  z-index: 1;\n  z-index: var(--vkui_internal--z_index_form_field_element)\n}\n\n.vkuiDateInput__input--time-divider {\n  letter-spacing: 6px !important\n}\n\n.vkuiDateInput--sizeY-compact .vkuiDateInput__input {\n  margin-right: 22px\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiDateInput--sizeY-none .vkuiDateInput__input {\n    margin-right: 22px\n  }\n}\n\n.vkuiDateRangeInput__input {\n  cursor: text;\n  flex-grow: 1;\n  font-variant-numeric: tabular-nums;\n  margin-left: 10px;\n  margin-right: 14px;\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n  white-space: nowrap;\n  z-index: 1;\n  z-index: var(--vkui_internal--z_index_form_field_element)\n}\n\n.vkuiDateRangeInput--sizeY-compact .vkuiDateRangeInput__input {\n  margin-right: 22px\n}\n\n@media (max-height:414.9px),\n(pointer:fine) and (min-width:768px) {\n  .vkuiDateRangeInput--sizeY-none .vkuiDateRangeInput__input {\n    margin-right: 22px\n  }\n}\n\n.vkuiDiv {\n  padding: 12px 16px;\n  padding: var(--vkui--size_base_padding_vertical--regular) var(--vkui--size_base_padding_horizontal--regular)\n}\n\n.vkuiVisuallyHiddenInput {\n  clip: rect(0 0 0 0);\n  -webkit-clip-path: inset(50%);\n  clip-path: inset(50%);\n  height: 1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap\n}\n\n.vkuiPromoBanner {\n  background: #fff;\n  background: var(--vkui--color_background_content);\n  box-sizing: border-box;\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  outline: var(--vkui--size_border--regular) solid rgba(0, 0, 0, .12);\n  outline: var(--vkui--size_border--regular) solid var(--vkui--color_separator_primary_alpha);\n  padding-bottom: 10px;\n  position: relative;\n  width: 100%\n}\n\n.vkuiPromoBanner__head {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  display: flex;\n  padding: 14px 16px 10px;\n  padding: 14px var(--vkui--size_base_padding_horizontal--regular) 10px\n}\n\n.vkuiPromoBanner__age {\n  margin-left: 6px\n}\n\n.vkuiPromoBanner__close {\n  align-items: center;\n  color: #99a2ad;\n  color: var(--vkui--color_icon_secondary);\n  display: flex;\n  height: 48px;\n  justify-content: center;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 48px\n}\n\n.vkuiPromoBanner__close:active {\n  opacity: .7\n}\n\n.vkuiPromoBanner__pixels {\n  display: none\n}\n\n.vkuiChipsSelect {\n  position: relative\n}\n\n.vkuiChipsSelect__dropdown {\n  cursor: pointer\n}\n\n.vkuiChipsSelect__icon {\n  pointer-events: none\n}\n\n.vkuiChipsSelect__empty {\n  color: #818c99;\n  color: var(--vkui--color_text_secondary);\n  padding: 12px 0;\n  text-align: center\n}\n\n.vkuiChipsSelect--pop-down {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0\n}\n\n.vkuiChipsSelect--pop-up {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0\n}\n\n.vkuiPopover {\n  animation: vkuipopover-fade-in .2s ease;\n  background: #fff;\n  background: var(--vkui--color_background_modal);\n  border-radius: 8px;\n  border-radius: var(--vkui--size_border_radius--regular);\n  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);\n  box-shadow: var(--vkui--elevation3);\n  position: relative\n}\n\n.vkuiPopover:before {\n  bottom: calc(-1 * 8px);\n  bottom: calc(-1 * var(--vkui_internal--popover_safe_zone_padding));\n  content: \"\";\n  left: calc(-1 * 8px);\n  left: calc(-1 * var(--vkui_internal--popover_safe_zone_padding));\n  position: absolute;\n  right: calc(-1 * 8px);\n  right: calc(-1 * var(--vkui_internal--popover_safe_zone_padding));\n  top: calc(-1 * 8px);\n  top: calc(-1 * var(--vkui_internal--popover_safe_zone_padding))\n}\n\n.vkuiPopover__in {\n  position: relative\n}\n\n@keyframes vkuipopover-fade-in {\n  0% {\n    opacity: 0\n  }\n\n  to {\n    opacity: 1\n  }\n}\n\n.vkuiTextTooltip {\n  animation: vkuitexttooltip-fade-in .2s ease;\n  background-color: #fff;\n  background-color: var(--vkui--color_background_modal);\n  border-radius: 8px;\n  border-radius: var(--vkui--size_border_radius--regular);\n  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);\n  box-shadow: var(--vkui--elevation3);\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  padding: 8px 12px 9px\n}\n\n.vkuiTextTooltip__arrow {\n  color: #fff;\n  color: var(--vkui--color_background_modal)\n}\n\n.vkuiTextTooltip--appearance-accent {\n  background-color: #5a9eff;\n  background-color: var(--vkui--color_background_accent_tint);\n  color: #fff;\n  color: var(--vkui--color_text_contrast)\n}\n\n.vkuiTextTooltip--appearance-accent .vkuiTextTooltip__arrow {\n  color: #5a9eff;\n  color: var(--vkui--color_background_accent_tint)\n}\n\n.vkuiTextTooltip--appearance-white {\n  background-color: #fff;\n  background-color: var(--vkui--color_background_contrast);\n  color: #000;\n  color: var(--vkui--color_text_primary_invariably)\n}\n\n.vkuiTextTooltip--appearance-white .vkuiTextTooltip__arrow {\n  color: #fff;\n  color: var(--vkui--color_background_contrast)\n}\n\n.vkuiTextTooltip--appearance-black {\n  background-color: #2c2d2e;\n  background-color: var(--vkui--color_background_contrast_inverse);\n  color: #fff;\n  color: var(--vkui--color_text_contrast)\n}\n\n.vkuiTextTooltip--appearance-black .vkuiTextTooltip__arrow {\n  color: #2c2d2e;\n  color: var(--vkui--color_background_contrast_inverse)\n}\n\n.vkuiTextTooltip--appearance-inversion {\n  background-color: #2d2d2e;\n  background-color: var(--vkui--color_background_modal_inverse);\n  color: #fff;\n  color: var(--vkui--color_text_contrast_themed)\n}\n\n.vkuiTextTooltip--appearance-inversion .vkuiTextTooltip__arrow {\n  color: #2d2d2e;\n  color: var(--vkui--color_background_modal_inverse)\n}\n\n@keyframes vkuitexttooltip-fade-in {\n  0% {\n    opacity: 0\n  }\n\n  to {\n    opacity: 1\n  }\n}\n\n.vkuiRichTooltip {\n  animation: vkuirichtooltip-fade-in .2s ease;\n  background-color: #fff;\n  background-color: var(--vkui--color_background_modal);\n  border-radius: 8px;\n  border-radius: var(--vkui--size_border_radius--regular);\n  box-shadow: 0 0 2px rgba(0, 0, 0, .08), 0 4px 16px rgba(0, 0, 0, .08);\n  box-shadow: var(--vkui--elevation3);\n  color: #000;\n  color: var(--vkui--color_text_primary)\n}\n\n.vkuiRichTooltip__arrow {\n  color: #fff;\n  color: var(--vkui--color_background_modal)\n}\n\n.vkuiRichTooltip--appearance-accent {\n  background-color: #5a9eff;\n  background-color: var(--vkui--color_background_accent_tint);\n  color: #fff;\n  color: var(--vkui--color_text_contrast)\n}\n\n.vkuiRichTooltip--appearance-accent .vkuiRichTooltip__arrow {\n  color: #5a9eff;\n  color: var(--vkui--color_background_accent_tint)\n}\n\n.vkuiRichTooltip--appearance-white {\n  background-color: #fff;\n  background-color: var(--vkui--color_background_contrast);\n  color: #000;\n  color: var(--vkui--color_text_primary_invariably)\n}\n\n.vkuiRichTooltip--appearance-white .vkuiRichTooltip__arrow {\n  color: #fff;\n  color: var(--vkui--color_background_contrast)\n}\n\n.vkuiRichTooltip--appearance-black {\n  background-color: #2c2d2e;\n  background-color: var(--vkui--color_background_contrast_inverse);\n  color: #fff;\n  color: var(--vkui--color_text_contrast)\n}\n\n.vkuiRichTooltip--appearance-black .vkuiRichTooltip__arrow {\n  color: #2c2d2e;\n  color: var(--vkui--color_background_contrast_inverse)\n}\n\n.vkuiRichTooltip--appearance-inversion {\n  background-color: #2d2d2e;\n  background-color: var(--vkui--color_background_modal_inverse);\n  color: #fff;\n  color: var(--vkui--color_text_contrast_themed)\n}\n\n.vkuiRichTooltip--appearance-inversion .vkuiRichTooltip__arrow {\n  color: #2d2d2e;\n  color: var(--vkui--color_background_modal_inverse)\n}\n\n@keyframes vkuirichtooltip-fade-in {\n  0% {\n    opacity: 0\n  }\n\n  to {\n    opacity: 1\n  }\n}\n\n.vkuiHorizontalCellShowMore {\n  display: flex\n}\n\n.vkuiHorizontalCellShowMore--compensate-last-cell-indent {\n  margin-left: calc(-1 * calc(16px - 6px));\n  margin-left: calc(-1 * var(--vkui_internal--side_cell_gap))\n}\n\n.vkuiHorizontalCellShowMore:last-child:after {\n  content: \"\";\n  min-width: calc(16px - 6px);\n  min-width: var(--vkui_internal--side_cell_gap)\n}\n\n.vkuiHorizontalCellShowMore__body {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 4px 6px;\n  padding: 4px var(--vkui--spacing_size_s)\n}\n\n.vkuiHorizontalCellShowMore--size-s .vkuiHorizontalCellShowMore__body {\n  min-width: 64px;\n  padding: 4px;\n  padding: var(--vkui--spacing_size_xs)\n}\n\n.vkuiHorizontalCellShowMore--size-l .vkuiHorizontalCellShowMore__body,\n.vkuiHorizontalCellShowMore--size-m .vkuiHorizontalCellShowMore__body {\n  margin-bottom: auto;\n  width: 128px\n}\n\n.vkuiHorizontalCellShowMore .vkuiHorizontalCellShowMore__body {\n  border-radius: 8px;\n  border-radius: var(--vkui--size_border_radius--regular)\n}\n\n.vkuiHorizontalCellShowMore__icon {\n  color: #2688eb;\n  color: var(--vkui--color_icon_accent)\n}\n\n.vkuiHorizontalCellShowMore__text {\n  color: #2688eb;\n  color: var(--vkui--color_text_accent);\n  padding-top: 8px\n}\n\n.vkui,\n.vkui>body,\n.vkui__root {\n  height: 100%;\n  margin: 0;\n  padding: 0\n}\n\n.vkui,\n.vkui>body {\n  -webkit-tap-highlight-color: transparent;\n  -webkit-text-size-adjust: 100%;\n  color: #000;\n  color: var(--vkui--color_text_primary);\n  color-scheme: light;\n  color-scheme: var(--vkui--colors_scheme);\n  font-family: -apple-system, system-ui, Helvetica Neue, Roboto, sans-serif;\n  font-family: var(--vkui--font_family_base)\n}\n\n.vkui__root--embedded {\n  overflow-x: hidden\n}\n\n.vkui--sizeX-regular {\n  background: #ebedf0;\n  background: var(--vkui--color_background)\n}\n\n@media (min-width:768px) {\n  .vkui--sizeX-none {\n    background: #ebedf0;\n    background: var(--vkui--color_background)\n  }\n}\n\n.vkui--layout-card {\n  background: #ebedf0;\n  background: var(--vkui--color_background)\n}\n\n.vkui--layout-plain {\n  background: #fff;\n  background: var(--vkui--color_background_content)\n}\n\n.vkui--disable-overscroll-behavior {\n  overscroll-behavior-y: none\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
